
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

      var $parcel$global = globalThis;
    
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire1e52"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire1e52"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("8Za8R", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $68abe334decb61e8$export$2e2bcd8739ae039);
parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");
var $TusQn = parcelRequire("TusQn");

var $73mM4 = parcelRequire("73mM4");

var $1kaYI = parcelRequire("1kaYI");

var $gYKPF = parcelRequire("gYKPF");

var $gGcib = parcelRequire("gGcib");
var $68abe334decb61e8$export$2e2bcd8739ae039 = {
    __name: 'make-request',
    setup (__props, { expose: expose }) {
        expose();
        const router = (0, $73mM4.useRouter)();
        const textAreaElement = (0, $01W3b.ref)(null);
        const requestValue = (0, $01W3b.ref)(null);
        const numberOfCharactersLeft = (0, $01W3b.computed)(()=>{
            return requestValue.value ? 100 - requestValue.value.length : 100;
        });
        const onRequestSubmit = async (event)=>{
            event.preventDefault();
            // if ( ! isAuthenticated() ) return router.push( { name: 'login' } );
            try {
                const data = JSON.stringify({
                    title: requestValue.value
                });
                const options = {
                    method: 'POST',
                    body: data,
                    headers: {
                        'Authorization': `Bearer ${(0, $gGcib.getToken)('token')}`,
                        'Content-Type': 'application/json'
                    }
                };
                let response = await fetch(`${"https://scrapbook-concierge-requests-api-cr45w.ondigitalocean.app"}/requests/${(0, $gYKPF.state).user.id}`, options);
                let result = await response.json();
                if (response.ok) {
                    (0, $gYKPF.pushAlert)('success', result.message);
                    // currentModalComponent.callbackFunction();
                    (0, $gYKPF.state).requests.push(result.request);
                    (0, $gYKPF.closeModal)();
                } else if (response.status === 401) {
                    (0, $gYKPF.pushAlert)('failure', 'You\'re not logged in.');
                    logUserOut();
                    router.push({
                        name: 'login'
                    });
                } else (0, $gYKPF.pushAlert)('failure', result.message);
            } catch (error) {
                console.warn(error);
                (0, $gYKPF.pushAlert)('failure', 'An Error occurred while making a request. Try again later.');
            }
        };
        (0, $TusQn.onMounted)(()=>textAreaElement.value.focus());
        const __returned__ = {
            router: router,
            textAreaElement: textAreaElement,
            requestValue: requestValue,
            numberOfCharactersLeft: numberOfCharactersLeft,
            onRequestSubmit: onRequestSubmit,
            ref: $01W3b.ref,
            computed: $01W3b.computed,
            onMounted: $TusQn.onMounted,
            useRouter: $73mM4.useRouter,
            XMarkIcon: $1kaYI.default,
            state: $gYKPF.state,
            closeModal: $gYKPF.closeModal,
            isAuthenticated: $gYKPF.isAuthenticated,
            currentModalComponent: $gYKPF.currentModalComponent,
            pushAlert: $gYKPF.pushAlert,
            getToken: $gGcib.getToken
        };
        Object.defineProperty(__returned__, '__isScriptSetup', {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
};

});
parcelRegister("ecd4d", function(module, exports) {
$parcel$export(module.exports, "shallowRef", () => (parcelRequire("01W3b")).shallowRef);
$parcel$export(module.exports, "unref", () => (parcelRequire("01W3b")).unref);
$parcel$export(module.exports, "toDisplayString", () => (parcelRequire("8POXm")).toDisplayString);

var $TusQn = parcelRequire("TusQn");
var $eeJ70 = parcelRequire("eeJ70");parcelRequire("01W3b");parcelRequire("8POXm");
function $a55c527d369bf9c1$var$initDev() {
    (0, $TusQn.initCustomFormatter)();
}
const $a55c527d369bf9c1$export$ef7acd7185315e22 = ()=>{};
$parcel$exportWildcard(module.exports, $TusQn);
$parcel$exportWildcard(module.exports, $eeJ70);

});
parcelRegister("TusQn", function(module, exports) {

$parcel$export(module.exports, "warn", () => $0a6cc4ba868319ae$export$c106dd0671a0fc2d);
$parcel$export(module.exports, "callWithErrorHandling", () => $0a6cc4ba868319ae$export$b22fcaf88446e9bf);
$parcel$export(module.exports, "handleError", () => $0a6cc4ba868319ae$export$d3da1ecaf1206c58);
$parcel$export(module.exports, "callWithAsyncErrorHandling", () => $0a6cc4ba868319ae$export$dae85862a8d94378);
$parcel$export(module.exports, "nextTick", () => $0a6cc4ba868319ae$export$bdd553fddd433dcb);
$parcel$export(module.exports, "queuePostFlushCb", () => $0a6cc4ba868319ae$export$59536a0199721cab);
$parcel$export(module.exports, "devtools", () => $0a6cc4ba868319ae$export$6922d3b3a607469e);
$parcel$export(module.exports, "setDevtoolsHook", () => $0a6cc4ba868319ae$export$b0c258b32c26c785);
$parcel$export(module.exports, "Fragment", () => $0a6cc4ba868319ae$export$ffb0004e005737fa);
$parcel$export(module.exports, "Text", () => $0a6cc4ba868319ae$export$5f1af8db9871e1d6);
$parcel$export(module.exports, "Comment", () => $0a6cc4ba868319ae$export$4d299b491347818a);
$parcel$export(module.exports, "Static", () => $0a6cc4ba868319ae$export$c1b9a1d3af45b7b6);
$parcel$export(module.exports, "pushScopeId", () => $0a6cc4ba868319ae$export$ac020265ca2cc4cd);
$parcel$export(module.exports, "popScopeId", () => $0a6cc4ba868319ae$export$f2dc6805dc11834e);
$parcel$export(module.exports, "withScopeId", () => $0a6cc4ba868319ae$export$15ba313e13f3dd04);
$parcel$export(module.exports, "withCtx", () => $0a6cc4ba868319ae$export$694b237e827a3d23);
$parcel$export(module.exports, "setBlockTracking", () => $0a6cc4ba868319ae$export$c20bee82f26f1e27);
$parcel$export(module.exports, "createVNode", () => $0a6cc4ba868319ae$export$bf5c4cf060303d58);
$parcel$export(module.exports, "cloneVNode", () => $0a6cc4ba868319ae$export$ee4f9e12c0a92a1a);
$parcel$export(module.exports, "isVNode", () => $0a6cc4ba868319ae$export$3868d13f8734ae81);
$parcel$export(module.exports, "Suspense", () => $0a6cc4ba868319ae$export$74bf444e3cd11ea5);
$parcel$export(module.exports, "openBlock", () => $0a6cc4ba868319ae$export$e7eaa45e502fe5cc);
$parcel$export(module.exports, "provide", () => $0a6cc4ba868319ae$export$abe1e183e22e10ad);
$parcel$export(module.exports, "inject", () => $0a6cc4ba868319ae$export$a976684a0efeb93f);
$parcel$export(module.exports, "watchEffect", () => $0a6cc4ba868319ae$export$ede35fc0e5500309);
$parcel$export(module.exports, "watchPostEffect", () => $0a6cc4ba868319ae$export$b7f27ea67102d543);
$parcel$export(module.exports, "watchSyncEffect", () => $0a6cc4ba868319ae$export$2035654f31b0e555);
$parcel$export(module.exports, "watch", () => $0a6cc4ba868319ae$export$3db5d71bdb2d5499);
$parcel$export(module.exports, "useTransitionState", () => $0a6cc4ba868319ae$export$d2a0a1bc267c90f6);
$parcel$export(module.exports, "onMounted", () => $0a6cc4ba868319ae$export$6d1641039221b5cb);
$parcel$export(module.exports, "onBeforeUnmount", () => $0a6cc4ba868319ae$export$40c420df62d2614);
$parcel$export(module.exports, "getCurrentInstance", () => $0a6cc4ba868319ae$export$f13e630aa3915748);
$parcel$export(module.exports, "getTransitionRawChildren", () => $0a6cc4ba868319ae$export$a67f9b1229c7c97a);
$parcel$export(module.exports, "resolveTransitionHooks", () => $0a6cc4ba868319ae$export$76ac1779589cd824);
$parcel$export(module.exports, "setTransitionHooks", () => $0a6cc4ba868319ae$export$7770a22486565649);
$parcel$export(module.exports, "BaseTransition", () => $0a6cc4ba868319ae$export$abd95b5f5e8a8837);
$parcel$export(module.exports, "defineComponent", () => $0a6cc4ba868319ae$export$afa64b67e5a01c3b);
$parcel$export(module.exports, "defineAsyncComponent", () => $0a6cc4ba868319ae$export$d75d499b4c16cf21);
$parcel$export(module.exports, "onUpdated", () => $0a6cc4ba868319ae$export$5876c47052fb88b1);
$parcel$export(module.exports, "KeepAlive", () => $0a6cc4ba868319ae$export$70eb8a58709972df);
$parcel$export(module.exports, "onActivated", () => $0a6cc4ba868319ae$export$ba52d824b95a2154);
$parcel$export(module.exports, "onDeactivated", () => $0a6cc4ba868319ae$export$bf1440eeaf5fa709);
$parcel$export(module.exports, "onUnmounted", () => $0a6cc4ba868319ae$export$13348a43ccacfe58);
$parcel$export(module.exports, "onBeforeMount", () => $0a6cc4ba868319ae$export$23b7aeb0d671f804);
$parcel$export(module.exports, "onBeforeUpdate", () => $0a6cc4ba868319ae$export$ab91988a13872e4c);
$parcel$export(module.exports, "onServerPrefetch", () => $0a6cc4ba868319ae$export$ebf0c601f267bceb);
$parcel$export(module.exports, "onRenderTriggered", () => $0a6cc4ba868319ae$export$898295a813d662eb);
$parcel$export(module.exports, "onRenderTracked", () => $0a6cc4ba868319ae$export$2b41f4235363e921);
$parcel$export(module.exports, "onErrorCaptured", () => $0a6cc4ba868319ae$export$6a3a15856e50ad19);
$parcel$export(module.exports, "withDirectives", () => $0a6cc4ba868319ae$export$49729353e7c1e6c5);
$parcel$export(module.exports, "resolveComponent", () => $0a6cc4ba868319ae$export$681d65eec9d1d1e8);
$parcel$export(module.exports, "resolveDynamicComponent", () => $0a6cc4ba868319ae$export$b44c564a05ca975);
$parcel$export(module.exports, "resolveDirective", () => $0a6cc4ba868319ae$export$a1989e995cd481be);
$parcel$export(module.exports, "renderList", () => $0a6cc4ba868319ae$export$4bf387f59bfc6d67);
$parcel$export(module.exports, "createSlots", () => $0a6cc4ba868319ae$export$85738f8fcd0a5430);
$parcel$export(module.exports, "renderSlot", () => $0a6cc4ba868319ae$export$4abee4c34694ada1);
$parcel$export(module.exports, "createBlock", () => $0a6cc4ba868319ae$export$9f2dfe8048dfb22b);
$parcel$export(module.exports, "toHandlers", () => $0a6cc4ba868319ae$export$2fb94ff667a6a1a);
$parcel$export(module.exports, "computed", () => $0a6cc4ba868319ae$export$2983e091f1a1e8e2);
$parcel$export(module.exports, "version", () => $0a6cc4ba868319ae$export$83d89fbfd8236492);
$parcel$export(module.exports, "createTextVNode", () => $0a6cc4ba868319ae$export$22f9b5ffd89dac9);
$parcel$export(module.exports, "createRenderer", () => $0a6cc4ba868319ae$export$53ae2f996c64e9a);
$parcel$export(module.exports, "createHydrationRenderer", () => $0a6cc4ba868319ae$export$200524cf0d997ff0);
$parcel$export(module.exports, "Teleport", () => $0a6cc4ba868319ae$export$76d55a0304a371f4);
$parcel$export(module.exports, "createElementBlock", () => $0a6cc4ba868319ae$export$167055419fc69ec1);
$parcel$export(module.exports, "createElementVNode", () => $0a6cc4ba868319ae$export$42098e0eaa15c48e);
$parcel$export(module.exports, "transformVNodeArgs", () => $0a6cc4ba868319ae$export$83beccd3afeeb809);
$parcel$export(module.exports, "guardReactiveProps", () => $0a6cc4ba868319ae$export$1f1be0e0e384d7d2);
$parcel$export(module.exports, "mergeProps", () => $0a6cc4ba868319ae$export$9d1611c77c2fe928);
$parcel$export(module.exports, "createStaticVNode", () => $0a6cc4ba868319ae$export$33a9f6dd2840e6bb);
$parcel$export(module.exports, "createCommentVNode", () => $0a6cc4ba868319ae$export$49553837c7236d3c);
$parcel$export(module.exports, "registerRuntimeCompiler", () => $0a6cc4ba868319ae$export$667bb5a67822b941);
$parcel$export(module.exports, "isRuntimeOnly", () => $0a6cc4ba868319ae$export$c93a9c496c5211fa);
$parcel$export(module.exports, "defineProps", () => $0a6cc4ba868319ae$export$80b33eababae110e);
$parcel$export(module.exports, "defineEmits", () => $0a6cc4ba868319ae$export$51ecece22fc17ddc);
$parcel$export(module.exports, "defineExpose", () => $0a6cc4ba868319ae$export$da25b65ca24b518a);
$parcel$export(module.exports, "withDefaults", () => $0a6cc4ba868319ae$export$4df9c0969a9e0160);
$parcel$export(module.exports, "useSlots", () => $0a6cc4ba868319ae$export$9203a8e84125433c);
$parcel$export(module.exports, "useAttrs", () => $0a6cc4ba868319ae$export$75e29435042cd2ea);
$parcel$export(module.exports, "mergeDefaults", () => $0a6cc4ba868319ae$export$ec60f47d4a8a2e7f);
$parcel$export(module.exports, "createPropsRestProxy", () => $0a6cc4ba868319ae$export$7c343e855c563faa);
$parcel$export(module.exports, "withAsyncContext", () => $0a6cc4ba868319ae$export$d6d6f7369f1fb104);
$parcel$export(module.exports, "h", () => $0a6cc4ba868319ae$export$dda1d9f60106f0e9);
$parcel$export(module.exports, "ssrContextKey", () => $0a6cc4ba868319ae$export$f2549a27e18acf2d);
$parcel$export(module.exports, "useSSRContext", () => $0a6cc4ba868319ae$export$6b1c54dc4befcda);
$parcel$export(module.exports, "initCustomFormatter", () => $0a6cc4ba868319ae$export$aed4979be6a60047);
$parcel$export(module.exports, "withMemo", () => $0a6cc4ba868319ae$export$2a6d714a4d738ae);
$parcel$export(module.exports, "isMemoSame", () => $0a6cc4ba868319ae$export$bf525184d622787c);
$parcel$export(module.exports, "ssrUtils", () => $0a6cc4ba868319ae$export$a9679033567b336d);
$parcel$export(module.exports, "resolveFilter", () => $0a6cc4ba868319ae$export$83cf26e06ea620e1);
$parcel$export(module.exports, "compatUtils", () => $0a6cc4ba868319ae$export$dc678eddf276286e);
$parcel$export(module.exports, "EffectScope", () => (parcelRequire("01W3b")).EffectScope);
$parcel$export(module.exports, "ReactiveEffect", () => (parcelRequire("01W3b")).ReactiveEffect);
$parcel$export(module.exports, "customRef", () => (parcelRequire("01W3b")).customRef);
$parcel$export(module.exports, "effect", () => (parcelRequire("01W3b")).effect);
$parcel$export(module.exports, "effectScope", () => (parcelRequire("01W3b")).effectScope);
$parcel$export(module.exports, "getCurrentScope", () => (parcelRequire("01W3b")).getCurrentScope);
$parcel$export(module.exports, "isProxy", () => (parcelRequire("01W3b")).isProxy);
$parcel$export(module.exports, "isReactive", () => (parcelRequire("01W3b")).isReactive);
$parcel$export(module.exports, "isReadonly", () => (parcelRequire("01W3b")).isReadonly);
$parcel$export(module.exports, "isRef", () => (parcelRequire("01W3b")).isRef);
$parcel$export(module.exports, "isShallow", () => (parcelRequire("01W3b")).isShallow);
$parcel$export(module.exports, "markRaw", () => (parcelRequire("01W3b")).markRaw);
$parcel$export(module.exports, "onScopeDispose", () => (parcelRequire("01W3b")).onScopeDispose);
$parcel$export(module.exports, "proxyRefs", () => (parcelRequire("01W3b")).proxyRefs);
$parcel$export(module.exports, "reactive", () => (parcelRequire("01W3b")).reactive);
$parcel$export(module.exports, "readonly", () => (parcelRequire("01W3b")).readonly);
$parcel$export(module.exports, "ref", () => (parcelRequire("01W3b")).ref);
$parcel$export(module.exports, "shallowReactive", () => (parcelRequire("01W3b")).shallowReactive);
$parcel$export(module.exports, "shallowReadonly", () => (parcelRequire("01W3b")).shallowReadonly);
$parcel$export(module.exports, "shallowRef", () => (parcelRequire("01W3b")).shallowRef);
$parcel$export(module.exports, "stop", () => (parcelRequire("01W3b")).stop);
$parcel$export(module.exports, "toRaw", () => (parcelRequire("01W3b")).toRaw);
$parcel$export(module.exports, "toRef", () => (parcelRequire("01W3b")).toRef);
$parcel$export(module.exports, "toRefs", () => (parcelRequire("01W3b")).toRefs);
$parcel$export(module.exports, "triggerRef", () => (parcelRequire("01W3b")).triggerRef);
$parcel$export(module.exports, "unref", () => (parcelRequire("01W3b")).unref);
$parcel$export(module.exports, "camelize", () => (parcelRequire("8POXm")).camelize);
$parcel$export(module.exports, "capitalize", () => (parcelRequire("8POXm")).capitalize);
$parcel$export(module.exports, "normalizeClass", () => (parcelRequire("8POXm")).normalizeClass);
$parcel$export(module.exports, "normalizeProps", () => (parcelRequire("8POXm")).normalizeProps);
$parcel$export(module.exports, "normalizeStyle", () => (parcelRequire("8POXm")).normalizeStyle);
$parcel$export(module.exports, "toDisplayString", () => (parcelRequire("8POXm")).toDisplayString);
$parcel$export(module.exports, "toHandlerKey", () => (parcelRequire("8POXm")).toHandlerKey);

var $01W3b = parcelRequire("01W3b");

var $8POXm = parcelRequire("8POXm");
const $0a6cc4ba868319ae$var$stack = [];
function $0a6cc4ba868319ae$var$pushWarningContext(vnode) {
    $0a6cc4ba868319ae$var$stack.push(vnode);
}
function $0a6cc4ba868319ae$var$popWarningContext() {
    $0a6cc4ba868319ae$var$stack.pop();
}
function $0a6cc4ba868319ae$export$c106dd0671a0fc2d(msg, ...args) {
    // avoid props formatting or warn handler tracking deps that might be mutated
    // during patch, leading to infinite recursion.
    (0, $01W3b.pauseTracking)();
    const instance = $0a6cc4ba868319ae$var$stack.length ? $0a6cc4ba868319ae$var$stack[$0a6cc4ba868319ae$var$stack.length - 1].component : null;
    const appWarnHandler = instance && instance.appContext.config.warnHandler;
    const trace = $0a6cc4ba868319ae$var$getComponentTrace();
    if (appWarnHandler) $0a6cc4ba868319ae$export$b22fcaf88446e9bf(appWarnHandler, instance, 11 /* ErrorCodes.APP_WARN_HANDLER */ , [
        msg + args.join(''),
        instance && instance.proxy,
        trace.map(({ vnode: vnode })=>`at <${$0a6cc4ba868319ae$var$formatComponentName(instance, vnode.type)}>`).join('\n'),
        trace
    ]);
    else {
        const warnArgs = [
            `[Vue warn]: ${msg}`,
            ...args
        ];
        /* istanbul ignore if */ if (trace.length && // avoid spamming console during tests
        true) warnArgs.push(`\n`, ...$0a6cc4ba868319ae$var$formatTrace(trace));
        console.warn(...warnArgs);
    }
    (0, $01W3b.resetTracking)();
}
function $0a6cc4ba868319ae$var$getComponentTrace() {
    let currentVNode = $0a6cc4ba868319ae$var$stack[$0a6cc4ba868319ae$var$stack.length - 1];
    if (!currentVNode) return [];
    // we can't just use the stack because it will be incomplete during updates
    // that did not start from the root. Re-construct the parent chain using
    // instance parent pointers.
    const normalizedStack = [];
    while(currentVNode){
        const last = normalizedStack[0];
        if (last && last.vnode === currentVNode) last.recurseCount++;
        else normalizedStack.push({
            vnode: currentVNode,
            recurseCount: 0
        });
        const parentInstance = currentVNode.component && currentVNode.component.parent;
        currentVNode = parentInstance && parentInstance.vnode;
    }
    return normalizedStack;
}
/* istanbul ignore next */ function $0a6cc4ba868319ae$var$formatTrace(trace) {
    const logs = [];
    trace.forEach((entry, i)=>{
        logs.push(...i === 0 ? [] : [
            `\n`
        ], ...$0a6cc4ba868319ae$var$formatTraceEntry(entry));
    });
    return logs;
}
function $0a6cc4ba868319ae$var$formatTraceEntry({ vnode: vnode, recurseCount: recurseCount }) {
    const postfix = recurseCount > 0 ? `... (${recurseCount} recursive calls)` : ``;
    const isRoot = vnode.component ? vnode.component.parent == null : false;
    const open = ` at <${$0a6cc4ba868319ae$var$formatComponentName(vnode.component, vnode.type, isRoot)}`;
    const close = `>` + postfix;
    return vnode.props ? [
        open,
        ...$0a6cc4ba868319ae$var$formatProps(vnode.props),
        close
    ] : [
        open + close
    ];
}
/* istanbul ignore next */ function $0a6cc4ba868319ae$var$formatProps(props) {
    const res = [];
    const keys = Object.keys(props);
    keys.slice(0, 3).forEach((key)=>{
        res.push(...$0a6cc4ba868319ae$var$formatProp(key, props[key]));
    });
    if (keys.length > 3) res.push(` ...`);
    return res;
}
/* istanbul ignore next */ function $0a6cc4ba868319ae$var$formatProp(key, value, raw) {
    if ((0, $8POXm.isString)(value)) {
        value = JSON.stringify(value);
        return raw ? value : [
            `${key}=${value}`
        ];
    } else if (typeof value === 'number' || typeof value === 'boolean' || value == null) return raw ? value : [
        `${key}=${value}`
    ];
    else if ((0, $01W3b.isRef)(value)) {
        value = $0a6cc4ba868319ae$var$formatProp(key, (0, $01W3b.toRaw)(value.value), true);
        return raw ? value : [
            `${key}=Ref<`,
            value,
            `>`
        ];
    } else if ((0, $8POXm.isFunction)(value)) return [
        `${key}=fn${value.name ? `<${value.name}>` : ``}`
    ];
    else {
        value = (0, $01W3b.toRaw)(value);
        return raw ? value : [
            `${key}=`,
            value
        ];
    }
}
const $0a6cc4ba868319ae$var$ErrorTypeStrings = {
    ["sp" /* LifecycleHooks.SERVER_PREFETCH */ ]: 'serverPrefetch hook',
    ["bc" /* LifecycleHooks.BEFORE_CREATE */ ]: 'beforeCreate hook',
    ["c" /* LifecycleHooks.CREATED */ ]: 'created hook',
    ["bm" /* LifecycleHooks.BEFORE_MOUNT */ ]: 'beforeMount hook',
    ["m" /* LifecycleHooks.MOUNTED */ ]: 'mounted hook',
    ["bu" /* LifecycleHooks.BEFORE_UPDATE */ ]: 'beforeUpdate hook',
    ["u" /* LifecycleHooks.UPDATED */ ]: 'updated',
    ["bum" /* LifecycleHooks.BEFORE_UNMOUNT */ ]: 'beforeUnmount hook',
    ["um" /* LifecycleHooks.UNMOUNTED */ ]: 'unmounted hook',
    ["a" /* LifecycleHooks.ACTIVATED */ ]: 'activated hook',
    ["da" /* LifecycleHooks.DEACTIVATED */ ]: 'deactivated hook',
    ["ec" /* LifecycleHooks.ERROR_CAPTURED */ ]: 'errorCaptured hook',
    ["rtc" /* LifecycleHooks.RENDER_TRACKED */ ]: 'renderTracked hook',
    ["rtg" /* LifecycleHooks.RENDER_TRIGGERED */ ]: 'renderTriggered hook',
    [0 /* ErrorCodes.SETUP_FUNCTION */ ]: 'setup function',
    [1 /* ErrorCodes.RENDER_FUNCTION */ ]: 'render function',
    [2 /* ErrorCodes.WATCH_GETTER */ ]: 'watcher getter',
    [3 /* ErrorCodes.WATCH_CALLBACK */ ]: 'watcher callback',
    [4 /* ErrorCodes.WATCH_CLEANUP */ ]: 'watcher cleanup function',
    [5 /* ErrorCodes.NATIVE_EVENT_HANDLER */ ]: 'native event handler',
    [6 /* ErrorCodes.COMPONENT_EVENT_HANDLER */ ]: 'component event handler',
    [7 /* ErrorCodes.VNODE_HOOK */ ]: 'vnode hook',
    [8 /* ErrorCodes.DIRECTIVE_HOOK */ ]: 'directive hook',
    [9 /* ErrorCodes.TRANSITION_HOOK */ ]: 'transition hook',
    [10 /* ErrorCodes.APP_ERROR_HANDLER */ ]: 'app errorHandler',
    [11 /* ErrorCodes.APP_WARN_HANDLER */ ]: 'app warnHandler',
    [12 /* ErrorCodes.FUNCTION_REF */ ]: 'ref function',
    [13 /* ErrorCodes.ASYNC_COMPONENT_LOADER */ ]: 'async component loader',
    [14 /* ErrorCodes.SCHEDULER */ ]: "scheduler flush. This is likely a Vue internals bug. Please open an issue at https://new-issue.vuejs.org/?repo=vuejs/core"
};
function $0a6cc4ba868319ae$export$b22fcaf88446e9bf(fn, instance, type, args) {
    let res;
    try {
        res = args ? fn(...args) : fn();
    } catch (err) {
        $0a6cc4ba868319ae$export$d3da1ecaf1206c58(err, instance, type);
    }
    return res;
}
function $0a6cc4ba868319ae$export$dae85862a8d94378(fn, instance, type, args) {
    if ((0, $8POXm.isFunction)(fn)) {
        const res = $0a6cc4ba868319ae$export$b22fcaf88446e9bf(fn, instance, type, args);
        if (res && (0, $8POXm.isPromise)(res)) res.catch((err)=>{
            $0a6cc4ba868319ae$export$d3da1ecaf1206c58(err, instance, type);
        });
        return res;
    }
    const values = [];
    for(let i = 0; i < fn.length; i++)values.push($0a6cc4ba868319ae$export$dae85862a8d94378(fn[i], instance, type, args));
    return values;
}
function $0a6cc4ba868319ae$export$d3da1ecaf1206c58(err, instance, type, throwInDev = true) {
    const contextVNode = instance ? instance.vnode : null;
    if (instance) {
        let cur = instance.parent;
        // the exposed instance is the render proxy to keep it consistent with 2.x
        const exposedInstance = instance.proxy;
        // in production the hook receives only the error code
        const errorInfo = type;
        while(cur){
            const errorCapturedHooks = cur.ec;
            if (errorCapturedHooks) for(let i = 0; i < errorCapturedHooks.length; i++){
                if (errorCapturedHooks[i](err, exposedInstance, errorInfo) === false) return;
            }
            cur = cur.parent;
        }
        // app-level handling
        const appErrorHandler = instance.appContext.config.errorHandler;
        if (appErrorHandler) {
            $0a6cc4ba868319ae$export$b22fcaf88446e9bf(appErrorHandler, null, 10 /* ErrorCodes.APP_ERROR_HANDLER */ , [
                err,
                exposedInstance,
                errorInfo
            ]);
            return;
        }
    }
    $0a6cc4ba868319ae$var$logError(err, type, contextVNode, throwInDev);
}
function $0a6cc4ba868319ae$var$logError(err, type, contextVNode, throwInDev = true) {
    // recover in prod to reduce the impact on end-user
    console.error(err);
}
let $0a6cc4ba868319ae$var$isFlushing = false;
let $0a6cc4ba868319ae$var$isFlushPending = false;
const $0a6cc4ba868319ae$var$queue = [];
let $0a6cc4ba868319ae$var$flushIndex = 0;
const $0a6cc4ba868319ae$var$pendingPostFlushCbs = [];
let $0a6cc4ba868319ae$var$activePostFlushCbs = null;
let $0a6cc4ba868319ae$var$postFlushIndex = 0;
const $0a6cc4ba868319ae$var$resolvedPromise = /*#__PURE__*/ Promise.resolve();
let $0a6cc4ba868319ae$var$currentFlushPromise = null;
const $0a6cc4ba868319ae$var$RECURSION_LIMIT = 100;
function $0a6cc4ba868319ae$export$bdd553fddd433dcb(fn) {
    const p = $0a6cc4ba868319ae$var$currentFlushPromise || $0a6cc4ba868319ae$var$resolvedPromise;
    return fn ? p.then(this ? fn.bind(this) : fn) : p;
}
// #2768
// Use binary-search to find a suitable position in the queue,
// so that the queue maintains the increasing order of job's id,
// which can prevent the job from being skipped and also can avoid repeated patching.
function $0a6cc4ba868319ae$var$findInsertionIndex(id) {
    // the start index should be `flushIndex + 1`
    let start = $0a6cc4ba868319ae$var$flushIndex + 1;
    let end = $0a6cc4ba868319ae$var$queue.length;
    while(start < end){
        const middle = start + end >>> 1;
        const middleJobId = $0a6cc4ba868319ae$var$getId($0a6cc4ba868319ae$var$queue[middle]);
        middleJobId < id ? start = middle + 1 : end = middle;
    }
    return start;
}
function $0a6cc4ba868319ae$var$queueJob(job) {
    // the dedupe search uses the startIndex argument of Array.includes()
    // by default the search index includes the current job that is being run
    // so it cannot recursively trigger itself again.
    // if the job is a watch() callback, the search will start with a +1 index to
    // allow it recursively trigger itself - it is the user's responsibility to
    // ensure it doesn't end up in an infinite loop.
    if (!$0a6cc4ba868319ae$var$queue.length || !$0a6cc4ba868319ae$var$queue.includes(job, $0a6cc4ba868319ae$var$isFlushing && job.allowRecurse ? $0a6cc4ba868319ae$var$flushIndex + 1 : $0a6cc4ba868319ae$var$flushIndex)) {
        if (job.id == null) $0a6cc4ba868319ae$var$queue.push(job);
        else $0a6cc4ba868319ae$var$queue.splice($0a6cc4ba868319ae$var$findInsertionIndex(job.id), 0, job);
        $0a6cc4ba868319ae$var$queueFlush();
    }
}
function $0a6cc4ba868319ae$var$queueFlush() {
    if (!$0a6cc4ba868319ae$var$isFlushing && !$0a6cc4ba868319ae$var$isFlushPending) {
        $0a6cc4ba868319ae$var$isFlushPending = true;
        $0a6cc4ba868319ae$var$currentFlushPromise = $0a6cc4ba868319ae$var$resolvedPromise.then($0a6cc4ba868319ae$var$flushJobs);
    }
}
function $0a6cc4ba868319ae$var$invalidateJob(job) {
    const i = $0a6cc4ba868319ae$var$queue.indexOf(job);
    if (i > $0a6cc4ba868319ae$var$flushIndex) $0a6cc4ba868319ae$var$queue.splice(i, 1);
}
function $0a6cc4ba868319ae$export$59536a0199721cab(cb) {
    if (!(0, $8POXm.isArray)(cb)) {
        if (!$0a6cc4ba868319ae$var$activePostFlushCbs || !$0a6cc4ba868319ae$var$activePostFlushCbs.includes(cb, cb.allowRecurse ? $0a6cc4ba868319ae$var$postFlushIndex + 1 : $0a6cc4ba868319ae$var$postFlushIndex)) $0a6cc4ba868319ae$var$pendingPostFlushCbs.push(cb);
    } else // if cb is an array, it is a component lifecycle hook which can only be
    // triggered by a job, which is already deduped in the main queue, so
    // we can skip duplicate check here to improve perf
    $0a6cc4ba868319ae$var$pendingPostFlushCbs.push(...cb);
    $0a6cc4ba868319ae$var$queueFlush();
}
function $0a6cc4ba868319ae$var$flushPreFlushCbs(seen, // if currently flushing, skip the current job itself
i = $0a6cc4ba868319ae$var$isFlushing ? $0a6cc4ba868319ae$var$flushIndex + 1 : 0) {
    for(; i < $0a6cc4ba868319ae$var$queue.length; i++){
        const cb = $0a6cc4ba868319ae$var$queue[i];
        if (cb && cb.pre) {
            $0a6cc4ba868319ae$var$queue.splice(i, 1);
            i--;
            cb();
        }
    }
}
function $0a6cc4ba868319ae$var$flushPostFlushCbs(seen) {
    if ($0a6cc4ba868319ae$var$pendingPostFlushCbs.length) {
        const deduped = [
            ...new Set($0a6cc4ba868319ae$var$pendingPostFlushCbs)
        ];
        $0a6cc4ba868319ae$var$pendingPostFlushCbs.length = 0;
        // #1947 already has active queue, nested flushPostFlushCbs call
        if ($0a6cc4ba868319ae$var$activePostFlushCbs) {
            $0a6cc4ba868319ae$var$activePostFlushCbs.push(...deduped);
            return;
        }
        $0a6cc4ba868319ae$var$activePostFlushCbs = deduped;
        $0a6cc4ba868319ae$var$activePostFlushCbs.sort((a, b)=>$0a6cc4ba868319ae$var$getId(a) - $0a6cc4ba868319ae$var$getId(b));
        for($0a6cc4ba868319ae$var$postFlushIndex = 0; $0a6cc4ba868319ae$var$postFlushIndex < $0a6cc4ba868319ae$var$activePostFlushCbs.length; $0a6cc4ba868319ae$var$postFlushIndex++)$0a6cc4ba868319ae$var$activePostFlushCbs[$0a6cc4ba868319ae$var$postFlushIndex]();
        $0a6cc4ba868319ae$var$activePostFlushCbs = null;
        $0a6cc4ba868319ae$var$postFlushIndex = 0;
    }
}
const $0a6cc4ba868319ae$var$getId = (job)=>job.id == null ? Infinity : job.id;
const $0a6cc4ba868319ae$var$comparator = (a, b)=>{
    const diff = $0a6cc4ba868319ae$var$getId(a) - $0a6cc4ba868319ae$var$getId(b);
    if (diff === 0) {
        if (a.pre && !b.pre) return -1;
        if (b.pre && !a.pre) return 1;
    }
    return diff;
};
function $0a6cc4ba868319ae$var$flushJobs(seen) {
    $0a6cc4ba868319ae$var$isFlushPending = false;
    $0a6cc4ba868319ae$var$isFlushing = true;
    // Sort queue before flush.
    // This ensures that:
    // 1. Components are updated from parent to child. (because parent is always
    //    created before the child so its render effect will have smaller
    //    priority number)
    // 2. If a component is unmounted during a parent component's update,
    //    its update can be skipped.
    $0a6cc4ba868319ae$var$queue.sort($0a6cc4ba868319ae$var$comparator);
    // conditional usage of checkRecursiveUpdate must be determined out of
    // try ... catch block since Rollup by default de-optimizes treeshaking
    // inside try-catch. This can leave all warning code unshaked. Although
    // they would get eventually shaken by a minifier like terser, some minifiers
    // would fail to do that (e.g. https://github.com/evanw/esbuild/issues/1610)
    const check = (0, $8POXm.NOOP);
    try {
        for($0a6cc4ba868319ae$var$flushIndex = 0; $0a6cc4ba868319ae$var$flushIndex < $0a6cc4ba868319ae$var$queue.length; $0a6cc4ba868319ae$var$flushIndex++){
            const job = $0a6cc4ba868319ae$var$queue[$0a6cc4ba868319ae$var$flushIndex];
            if (job && job.active !== false) // console.log(`running:`, job.id)
            $0a6cc4ba868319ae$export$b22fcaf88446e9bf(job, null, 14 /* ErrorCodes.SCHEDULER */ );
        }
    } finally{
        $0a6cc4ba868319ae$var$flushIndex = 0;
        $0a6cc4ba868319ae$var$queue.length = 0;
        $0a6cc4ba868319ae$var$flushPostFlushCbs(seen);
        $0a6cc4ba868319ae$var$isFlushing = false;
        $0a6cc4ba868319ae$var$currentFlushPromise = null;
        // some postFlushCb queued jobs!
        // keep flushing until it drains.
        if ($0a6cc4ba868319ae$var$queue.length || $0a6cc4ba868319ae$var$pendingPostFlushCbs.length) $0a6cc4ba868319ae$var$flushJobs(seen);
    }
}
function $0a6cc4ba868319ae$var$checkRecursiveUpdates(seen, fn) {
    if (!seen.has(fn)) seen.set(fn, 1);
    else {
        const count = seen.get(fn);
        if (count > $0a6cc4ba868319ae$var$RECURSION_LIMIT) {
            const instance = fn.ownerInstance;
            const componentName = instance && $0a6cc4ba868319ae$var$getComponentName(instance.type);
            $0a6cc4ba868319ae$export$c106dd0671a0fc2d(`Maximum recursive updates exceeded${componentName ? ` in component <${componentName}>` : ``}. ` + `This means you have a reactive effect that is mutating its own ` + `dependencies and thus recursively triggering itself. Possible sources ` + `include component template, render function, updated hook or ` + `watcher source function.`);
            return true;
        } else seen.set(fn, count + 1);
    }
}
/* eslint-disable no-restricted-globals */ let $0a6cc4ba868319ae$var$isHmrUpdating = false;
const $0a6cc4ba868319ae$var$hmrDirtyComponents = new Set();
const $0a6cc4ba868319ae$var$map = new Map();
function $0a6cc4ba868319ae$var$registerHMR(instance) {
    const id = instance.type.__hmrId;
    let record = $0a6cc4ba868319ae$var$map.get(id);
    if (!record) {
        $0a6cc4ba868319ae$var$createRecord(id, instance.type);
        record = $0a6cc4ba868319ae$var$map.get(id);
    }
    record.instances.add(instance);
}
function $0a6cc4ba868319ae$var$unregisterHMR(instance) {
    $0a6cc4ba868319ae$var$map.get(instance.type.__hmrId).instances.delete(instance);
}
function $0a6cc4ba868319ae$var$createRecord(id, initialDef) {
    if ($0a6cc4ba868319ae$var$map.has(id)) return false;
    $0a6cc4ba868319ae$var$map.set(id, {
        initialDef: $0a6cc4ba868319ae$var$normalizeClassComponent(initialDef),
        instances: new Set()
    });
    return true;
}
function $0a6cc4ba868319ae$var$normalizeClassComponent(component) {
    return $0a6cc4ba868319ae$var$isClassComponent(component) ? component.__vccOpts : component;
}
function $0a6cc4ba868319ae$var$rerender(id, newRender) {
    const record = $0a6cc4ba868319ae$var$map.get(id);
    if (!record) return;
    // update initial record (for not-yet-rendered component)
    record.initialDef.render = newRender;
    [
        ...record.instances
    ].forEach((instance)=>{
        if (newRender) {
            instance.render = newRender;
            $0a6cc4ba868319ae$var$normalizeClassComponent(instance.type).render = newRender;
        }
        instance.renderCache = [];
        // this flag forces child components with slot content to update
        $0a6cc4ba868319ae$var$isHmrUpdating = true;
        instance.update();
        $0a6cc4ba868319ae$var$isHmrUpdating = false;
    });
}
function $0a6cc4ba868319ae$var$reload(id, newComp) {
    const record = $0a6cc4ba868319ae$var$map.get(id);
    if (!record) return;
    newComp = $0a6cc4ba868319ae$var$normalizeClassComponent(newComp);
    // update initial def (for not-yet-rendered components)
    $0a6cc4ba868319ae$var$updateComponentDef(record.initialDef, newComp);
    // create a snapshot which avoids the set being mutated during updates
    const instances = [
        ...record.instances
    ];
    for (const instance of instances){
        const oldComp = $0a6cc4ba868319ae$var$normalizeClassComponent(instance.type);
        if (!$0a6cc4ba868319ae$var$hmrDirtyComponents.has(oldComp)) {
            // 1. Update existing comp definition to match new one
            if (oldComp !== record.initialDef) $0a6cc4ba868319ae$var$updateComponentDef(oldComp, newComp);
            // 2. mark definition dirty. This forces the renderer to replace the
            // component on patch.
            $0a6cc4ba868319ae$var$hmrDirtyComponents.add(oldComp);
        }
        // 3. invalidate options resolution cache
        instance.appContext.optionsCache.delete(instance.type);
        // 4. actually update
        if (instance.ceReload) {
            // custom element
            $0a6cc4ba868319ae$var$hmrDirtyComponents.add(oldComp);
            instance.ceReload(newComp.styles);
            $0a6cc4ba868319ae$var$hmrDirtyComponents.delete(oldComp);
        } else if (instance.parent) {
            // 4. Force the parent instance to re-render. This will cause all updated
            // components to be unmounted and re-mounted. Queue the update so that we
            // don't end up forcing the same parent to re-render multiple times.
            $0a6cc4ba868319ae$var$queueJob(instance.parent.update);
            // instance is the inner component of an async custom element
            // invoke to reset styles
            if (instance.parent.type.__asyncLoader && instance.parent.ceReload) instance.parent.ceReload(newComp.styles);
        } else if (instance.appContext.reload) // root instance mounted via createApp() has a reload method
        instance.appContext.reload();
        else if (typeof window !== 'undefined') // root instance inside tree created via raw render(). Force reload.
        window.location.reload();
        else console.warn('[HMR] Root or manually mounted instance modified. Full reload required.');
    }
    // 5. make sure to cleanup dirty hmr components after update
    $0a6cc4ba868319ae$export$59536a0199721cab(()=>{
        for (const instance of instances)$0a6cc4ba868319ae$var$hmrDirtyComponents.delete($0a6cc4ba868319ae$var$normalizeClassComponent(instance.type));
    });
}
function $0a6cc4ba868319ae$var$updateComponentDef(oldComp, newComp) {
    (0, $8POXm.extend)(oldComp, newComp);
    for(const key in oldComp)if (key !== '__file' && !(key in newComp)) delete oldComp[key];
}
function $0a6cc4ba868319ae$var$tryWrap(fn) {
    return (id, arg)=>{
        try {
            return fn(id, arg);
        } catch (e) {
            console.error(e);
            console.warn(`[HMR] Something went wrong during Vue component hot-reload. ` + `Full reload required.`);
        }
    };
}
let $0a6cc4ba868319ae$export$6922d3b3a607469e;
let $0a6cc4ba868319ae$var$buffer = [];
let $0a6cc4ba868319ae$var$devtoolsNotInstalled = false;
function $0a6cc4ba868319ae$var$emit(event, ...args) {
    if ($0a6cc4ba868319ae$export$6922d3b3a607469e) $0a6cc4ba868319ae$export$6922d3b3a607469e.emit(event, ...args);
    else if (!$0a6cc4ba868319ae$var$devtoolsNotInstalled) $0a6cc4ba868319ae$var$buffer.push({
        event: event,
        args: args
    });
}
function $0a6cc4ba868319ae$export$b0c258b32c26c785(hook, target) {
    var _a, _b;
    $0a6cc4ba868319ae$export$6922d3b3a607469e = hook;
    if ($0a6cc4ba868319ae$export$6922d3b3a607469e) {
        $0a6cc4ba868319ae$export$6922d3b3a607469e.enabled = true;
        $0a6cc4ba868319ae$var$buffer.forEach(({ event: event, args: args })=>$0a6cc4ba868319ae$export$6922d3b3a607469e.emit(event, ...args));
        $0a6cc4ba868319ae$var$buffer = [];
    } else if (// handle late devtools injection - only do this if we are in an actual
    // browser environment to avoid the timer handle stalling test runner exit
    // (#4815)
    typeof window !== 'undefined' && // some envs mock window but not fully
    window.HTMLElement && // also exclude jsdom
    !((_b = (_a = window.navigator) === null || _a === void 0 ? void 0 : _a.userAgent) === null || _b === void 0 ? void 0 : _b.includes('jsdom'))) {
        const replay = target.__VUE_DEVTOOLS_HOOK_REPLAY__ = target.__VUE_DEVTOOLS_HOOK_REPLAY__ || [];
        replay.push((newHook)=>{
            $0a6cc4ba868319ae$export$b0c258b32c26c785(newHook, target);
        });
        // clear buffer after 3s - the user probably doesn't have devtools installed
        // at all, and keeping the buffer will cause memory leaks (#4738)
        setTimeout(()=>{
            if (!$0a6cc4ba868319ae$export$6922d3b3a607469e) {
                target.__VUE_DEVTOOLS_HOOK_REPLAY__ = null;
                $0a6cc4ba868319ae$var$devtoolsNotInstalled = true;
                $0a6cc4ba868319ae$var$buffer = [];
            }
        }, 3000);
    } else {
        // non-browser env, assume not installed
        $0a6cc4ba868319ae$var$devtoolsNotInstalled = true;
        $0a6cc4ba868319ae$var$buffer = [];
    }
}
function $0a6cc4ba868319ae$var$devtoolsInitApp(app, version) {
    $0a6cc4ba868319ae$var$emit("app:init" /* DevtoolsHooks.APP_INIT */ , app, version, {
        Fragment: $0a6cc4ba868319ae$export$ffb0004e005737fa,
        Text: $0a6cc4ba868319ae$export$5f1af8db9871e1d6,
        Comment: $0a6cc4ba868319ae$export$4d299b491347818a,
        Static: $0a6cc4ba868319ae$export$c1b9a1d3af45b7b6
    });
}
function $0a6cc4ba868319ae$var$devtoolsUnmountApp(app) {
    $0a6cc4ba868319ae$var$emit("app:unmount" /* DevtoolsHooks.APP_UNMOUNT */ , app);
}
const $0a6cc4ba868319ae$var$devtoolsComponentAdded = /*#__PURE__*/ $0a6cc4ba868319ae$var$createDevtoolsComponentHook("component:added" /* DevtoolsHooks.COMPONENT_ADDED */ );
const $0a6cc4ba868319ae$var$devtoolsComponentUpdated = /*#__PURE__*/ $0a6cc4ba868319ae$var$createDevtoolsComponentHook("component:updated" /* DevtoolsHooks.COMPONENT_UPDATED */ );
const $0a6cc4ba868319ae$var$devtoolsComponentRemoved = /*#__PURE__*/ $0a6cc4ba868319ae$var$createDevtoolsComponentHook("component:removed" /* DevtoolsHooks.COMPONENT_REMOVED */ );
function $0a6cc4ba868319ae$var$createDevtoolsComponentHook(hook) {
    return (component)=>{
        $0a6cc4ba868319ae$var$emit(hook, component.appContext.app, component.uid, component.parent ? component.parent.uid : undefined, component);
    };
}
const $0a6cc4ba868319ae$var$devtoolsPerfStart = /*#__PURE__*/ $0a6cc4ba868319ae$var$createDevtoolsPerformanceHook("perf:start" /* DevtoolsHooks.PERFORMANCE_START */ );
const $0a6cc4ba868319ae$var$devtoolsPerfEnd = /*#__PURE__*/ $0a6cc4ba868319ae$var$createDevtoolsPerformanceHook("perf:end" /* DevtoolsHooks.PERFORMANCE_END */ );
function $0a6cc4ba868319ae$var$createDevtoolsPerformanceHook(hook) {
    return (component, type, time)=>{
        $0a6cc4ba868319ae$var$emit(hook, component.appContext.app, component.uid, component, type, time);
    };
}
function $0a6cc4ba868319ae$var$devtoolsComponentEmit(component, event, params) {
    $0a6cc4ba868319ae$var$emit("component:emit" /* DevtoolsHooks.COMPONENT_EMIT */ , component.appContext.app, component, event, params);
}
function $0a6cc4ba868319ae$var$emit$1(instance, event, ...rawArgs) {
    if (instance.isUnmounted) return;
    const props = instance.vnode.props || (0, $8POXm.EMPTY_OBJ);
    let args = rawArgs;
    const isModelListener = event.startsWith('update:');
    // for v-model update:xxx events, apply modifiers on args
    const modelArg = isModelListener && event.slice(7);
    if (modelArg && modelArg in props) {
        const modifiersKey = `${modelArg === 'modelValue' ? 'model' : modelArg}Modifiers`;
        const { number: number, trim: trim } = props[modifiersKey] || (0, $8POXm.EMPTY_OBJ);
        if (trim) args = rawArgs.map((a)=>a.trim());
        if (number) args = rawArgs.map((0, $8POXm.toNumber));
    }
    if (__VUE_PROD_DEVTOOLS__) $0a6cc4ba868319ae$var$devtoolsComponentEmit(instance, event, args);
    let handlerName;
    let handler = props[handlerName = (0, $8POXm.toHandlerKey)(event)] || // also try camelCase event handler (#2249)
    props[handlerName = (0, $8POXm.toHandlerKey)((0, $8POXm.camelize)(event))];
    // for v-model update:xxx events, also trigger kebab-case equivalent
    // for props passed via kebab-case
    if (!handler && isModelListener) handler = props[handlerName = (0, $8POXm.toHandlerKey)((0, $8POXm.hyphenate)(event))];
    if (handler) $0a6cc4ba868319ae$export$dae85862a8d94378(handler, instance, 6 /* ErrorCodes.COMPONENT_EVENT_HANDLER */ , args);
    const onceHandler = props[handlerName + `Once`];
    if (onceHandler) {
        if (!instance.emitted) instance.emitted = {};
        else if (instance.emitted[handlerName]) return;
        instance.emitted[handlerName] = true;
        $0a6cc4ba868319ae$export$dae85862a8d94378(onceHandler, instance, 6 /* ErrorCodes.COMPONENT_EVENT_HANDLER */ , args);
    }
}
function $0a6cc4ba868319ae$var$normalizeEmitsOptions(comp, appContext, asMixin = false) {
    const cache = appContext.emitsCache;
    const cached = cache.get(comp);
    if (cached !== undefined) return cached;
    const raw = comp.emits;
    let normalized = {};
    // apply mixin/extends props
    let hasExtends = false;
    if (__VUE_OPTIONS_API__ && !(0, $8POXm.isFunction)(comp)) {
        const extendEmits = (raw)=>{
            const normalizedFromExtend = $0a6cc4ba868319ae$var$normalizeEmitsOptions(raw, appContext, true);
            if (normalizedFromExtend) {
                hasExtends = true;
                (0, $8POXm.extend)(normalized, normalizedFromExtend);
            }
        };
        if (!asMixin && appContext.mixins.length) appContext.mixins.forEach(extendEmits);
        if (comp.extends) extendEmits(comp.extends);
        if (comp.mixins) comp.mixins.forEach(extendEmits);
    }
    if (!raw && !hasExtends) {
        if ((0, $8POXm.isObject)(comp)) cache.set(comp, null);
        return null;
    }
    if ((0, $8POXm.isArray)(raw)) raw.forEach((key)=>normalized[key] = null);
    else (0, $8POXm.extend)(normalized, raw);
    if ((0, $8POXm.isObject)(comp)) cache.set(comp, normalized);
    return normalized;
}
// Check if an incoming prop key is a declared emit event listener.
// e.g. With `emits: { click: null }`, props named `onClick` and `onclick` are
// both considered matched listeners.
function $0a6cc4ba868319ae$var$isEmitListener(options, key) {
    if (!options || !(0, $8POXm.isOn)(key)) return false;
    key = key.slice(2).replace(/Once$/, '');
    return (0, $8POXm.hasOwn)(options, key[0].toLowerCase() + key.slice(1)) || (0, $8POXm.hasOwn)(options, (0, $8POXm.hyphenate)(key)) || (0, $8POXm.hasOwn)(options, key);
}
/**
 * mark the current rendering instance for asset resolution (e.g.
 * resolveComponent, resolveDirective) during render
 */ let $0a6cc4ba868319ae$var$currentRenderingInstance = null;
let $0a6cc4ba868319ae$var$currentScopeId = null;
/**
 * Note: rendering calls maybe nested. The function returns the parent rendering
 * instance if present, which should be restored after the render is done:
 *
 * ```js
 * const prev = setCurrentRenderingInstance(i)
 * // ...render
 * setCurrentRenderingInstance(prev)
 * ```
 */ function $0a6cc4ba868319ae$var$setCurrentRenderingInstance(instance) {
    const prev = $0a6cc4ba868319ae$var$currentRenderingInstance;
    $0a6cc4ba868319ae$var$currentRenderingInstance = instance;
    $0a6cc4ba868319ae$var$currentScopeId = instance && instance.type.__scopeId || null;
    return prev;
}
/**
 * Set scope id when creating hoisted vnodes.
 * @private compiler helper
 */ function $0a6cc4ba868319ae$export$ac020265ca2cc4cd(id) {
    $0a6cc4ba868319ae$var$currentScopeId = id;
}
/**
 * Technically we no longer need this after 3.0.8 but we need to keep the same
 * API for backwards compat w/ code generated by compilers.
 * @private
 */ function $0a6cc4ba868319ae$export$f2dc6805dc11834e() {
    $0a6cc4ba868319ae$var$currentScopeId = null;
}
/**
 * Only for backwards compat
 * @private
 */ const $0a6cc4ba868319ae$export$15ba313e13f3dd04 = (_id)=>$0a6cc4ba868319ae$export$694b237e827a3d23;
/**
 * Wrap a slot function to memoize current rendering instance
 * @private compiler helper
 */ function $0a6cc4ba868319ae$export$694b237e827a3d23(fn, ctx = $0a6cc4ba868319ae$var$currentRenderingInstance, isNonScopedSlot // false only
) {
    if (!ctx) return fn;
    // already normalized
    if (fn._n) return fn;
    const renderFnWithContext = (...args)=>{
        // If a user calls a compiled slot inside a template expression (#1745), it
        // can mess up block tracking, so by default we disable block tracking and
        // force bail out when invoking a compiled slot (indicated by the ._d flag).
        // This isn't necessary if rendering a compiled `<slot>`, so we flip the
        // ._d flag off when invoking the wrapped fn inside `renderSlot`.
        if (renderFnWithContext._d) $0a6cc4ba868319ae$export$c20bee82f26f1e27(-1);
        const prevInstance = $0a6cc4ba868319ae$var$setCurrentRenderingInstance(ctx);
        const res = fn(...args);
        $0a6cc4ba868319ae$var$setCurrentRenderingInstance(prevInstance);
        if (renderFnWithContext._d) $0a6cc4ba868319ae$export$c20bee82f26f1e27(1);
        if (__VUE_PROD_DEVTOOLS__) $0a6cc4ba868319ae$var$devtoolsComponentUpdated(ctx);
        return res;
    };
    // mark normalized to avoid duplicated wrapping
    renderFnWithContext._n = true;
    // mark this as compiled by default
    // this is used in vnode.ts -> normalizeChildren() to set the slot
    // rendering flag.
    renderFnWithContext._c = true;
    // disable block tracking by default
    renderFnWithContext._d = true;
    return renderFnWithContext;
}
/**
 * dev only flag to track whether $attrs was used during render.
 * If $attrs was used during render then the warning for failed attrs
 * fallthrough can be suppressed.
 */ let $0a6cc4ba868319ae$var$accessedAttrs = false;
function $0a6cc4ba868319ae$var$markAttrsAccessed() {
    $0a6cc4ba868319ae$var$accessedAttrs = true;
}
function $0a6cc4ba868319ae$var$renderComponentRoot(instance) {
    const { type: Component, vnode: vnode, proxy: proxy, withProxy: withProxy, props: props, propsOptions: [propsOptions], slots: slots, attrs: attrs, emit: emit, render: render, renderCache: renderCache, data: data, setupState: setupState, ctx: ctx, inheritAttrs: inheritAttrs } = instance;
    let result;
    let fallthroughAttrs;
    const prev = $0a6cc4ba868319ae$var$setCurrentRenderingInstance(instance);
    try {
        if (vnode.shapeFlag & 4 /* ShapeFlags.STATEFUL_COMPONENT */ ) {
            // withProxy is a proxy with a different `has` trap only for
            // runtime-compiled render functions using `with` block.
            const proxyToUse = withProxy || proxy;
            result = $0a6cc4ba868319ae$var$normalizeVNode(render.call(proxyToUse, proxyToUse, renderCache, props, setupState, data, ctx));
            fallthroughAttrs = attrs;
        } else {
            // functional
            const render = Component;
            result = $0a6cc4ba868319ae$var$normalizeVNode(render.length > 1 ? render(props, {
                attrs: attrs,
                slots: slots,
                emit: emit
            }) : render(props, null));
            fallthroughAttrs = Component.props ? attrs : $0a6cc4ba868319ae$var$getFunctionalFallthrough(attrs);
        }
    } catch (err) {
        $0a6cc4ba868319ae$var$blockStack.length = 0;
        $0a6cc4ba868319ae$export$d3da1ecaf1206c58(err, instance, 1 /* ErrorCodes.RENDER_FUNCTION */ );
        result = $0a6cc4ba868319ae$export$bf5c4cf060303d58($0a6cc4ba868319ae$export$4d299b491347818a);
    }
    // attr merging
    // in dev mode, comments are preserved, and it's possible for a template
    // to have comments along side the root element which makes it a fragment
    let root = result;
    let setRoot = undefined;
    if (fallthroughAttrs && inheritAttrs !== false) {
        const keys = Object.keys(fallthroughAttrs);
        const { shapeFlag: shapeFlag } = root;
        if (keys.length) {
            if (shapeFlag & 7 /* ShapeFlags.COMPONENT */ ) {
                if (propsOptions && keys.some((0, $8POXm.isModelListener))) // If a v-model listener (onUpdate:xxx) has a corresponding declared
                // prop, it indicates this component expects to handle v-model and
                // it should not fallthrough.
                // related: #1543, #1643, #1989
                fallthroughAttrs = $0a6cc4ba868319ae$var$filterModelListeners(fallthroughAttrs, propsOptions);
                root = $0a6cc4ba868319ae$export$ee4f9e12c0a92a1a(root, fallthroughAttrs);
            }
        }
    }
    // inherit directives
    if (vnode.dirs) {
        // clone before mutating since the root may be a hoisted vnode
        root = $0a6cc4ba868319ae$export$ee4f9e12c0a92a1a(root);
        root.dirs = root.dirs ? root.dirs.concat(vnode.dirs) : vnode.dirs;
    }
    // inherit transition data
    if (vnode.transition) root.transition = vnode.transition;
    result = root;
    $0a6cc4ba868319ae$var$setCurrentRenderingInstance(prev);
    return result;
}
/**
 * dev only
 * In dev mode, template root level comments are rendered, which turns the
 * template into a fragment root, but we need to locate the single element
 * root for attrs and scope id processing.
 */ const $0a6cc4ba868319ae$var$getChildRoot = (vnode)=>{
    const rawChildren = vnode.children;
    const dynamicChildren = vnode.dynamicChildren;
    const childRoot = $0a6cc4ba868319ae$var$filterSingleRoot(rawChildren);
    if (!childRoot) return [
        vnode,
        undefined
    ];
    const index = rawChildren.indexOf(childRoot);
    const dynamicIndex = dynamicChildren ? dynamicChildren.indexOf(childRoot) : -1;
    const setRoot = (updatedRoot)=>{
        rawChildren[index] = updatedRoot;
        if (dynamicChildren) {
            if (dynamicIndex > -1) dynamicChildren[dynamicIndex] = updatedRoot;
            else if (updatedRoot.patchFlag > 0) vnode.dynamicChildren = [
                ...dynamicChildren,
                updatedRoot
            ];
        }
    };
    return [
        $0a6cc4ba868319ae$var$normalizeVNode(childRoot),
        setRoot
    ];
};
function $0a6cc4ba868319ae$var$filterSingleRoot(children) {
    let singleRoot;
    for(let i = 0; i < children.length; i++){
        const child = children[i];
        if ($0a6cc4ba868319ae$export$3868d13f8734ae81(child)) // ignore user comment
        {
            if (child.type !== $0a6cc4ba868319ae$export$4d299b491347818a || child.children === 'v-if') {
                if (singleRoot) // has more than 1 non-comment child, return now
                return;
                else singleRoot = child;
            }
        } else return;
    }
    return singleRoot;
}
const $0a6cc4ba868319ae$var$getFunctionalFallthrough = (attrs)=>{
    let res;
    for(const key in attrs)if (key === 'class' || key === 'style' || (0, $8POXm.isOn)(key)) (res || (res = {}))[key] = attrs[key];
    return res;
};
const $0a6cc4ba868319ae$var$filterModelListeners = (attrs, props)=>{
    const res = {};
    for(const key in attrs)if (!(0, $8POXm.isModelListener)(key) || !(key.slice(9) in props)) res[key] = attrs[key];
    return res;
};
const $0a6cc4ba868319ae$var$isElementRoot = (vnode)=>{
    return vnode.shapeFlag & 7 /* ShapeFlags.ELEMENT */  || vnode.type === $0a6cc4ba868319ae$export$4d299b491347818a // potential v-if branch switch
    ;
};
function $0a6cc4ba868319ae$var$shouldUpdateComponent(prevVNode, nextVNode, optimized) {
    const { props: prevProps, children: prevChildren, component: component } = prevVNode;
    const { props: nextProps, children: nextChildren, patchFlag: patchFlag } = nextVNode;
    const emits = component.emitsOptions;
    // force child update for runtime directive or transition on component vnode.
    if (nextVNode.dirs || nextVNode.transition) return true;
    if (optimized && patchFlag >= 0) {
        if (patchFlag & 1024 /* PatchFlags.DYNAMIC_SLOTS */ ) // slot content that references values that might have changed,
        // e.g. in a v-for
        return true;
        if (patchFlag & 16 /* PatchFlags.FULL_PROPS */ ) {
            if (!prevProps) return !!nextProps;
            // presence of this flag indicates props are always non-null
            return $0a6cc4ba868319ae$var$hasPropsChanged(prevProps, nextProps, emits);
        } else if (patchFlag & 8 /* PatchFlags.PROPS */ ) {
            const dynamicProps = nextVNode.dynamicProps;
            for(let i = 0; i < dynamicProps.length; i++){
                const key = dynamicProps[i];
                if (nextProps[key] !== prevProps[key] && !$0a6cc4ba868319ae$var$isEmitListener(emits, key)) return true;
            }
        }
    } else {
        // this path is only taken by manually written render functions
        // so presence of any children leads to a forced update
        if (prevChildren || nextChildren) {
            if (!nextChildren || !nextChildren.$stable) return true;
        }
        if (prevProps === nextProps) return false;
        if (!prevProps) return !!nextProps;
        if (!nextProps) return true;
        return $0a6cc4ba868319ae$var$hasPropsChanged(prevProps, nextProps, emits);
    }
    return false;
}
function $0a6cc4ba868319ae$var$hasPropsChanged(prevProps, nextProps, emitsOptions) {
    const nextKeys = Object.keys(nextProps);
    if (nextKeys.length !== Object.keys(prevProps).length) return true;
    for(let i = 0; i < nextKeys.length; i++){
        const key = nextKeys[i];
        if (nextProps[key] !== prevProps[key] && !$0a6cc4ba868319ae$var$isEmitListener(emitsOptions, key)) return true;
    }
    return false;
}
function $0a6cc4ba868319ae$var$updateHOCHostEl({ vnode: vnode, parent: parent }, el // HostNode
) {
    while(parent && parent.subTree === vnode){
        (vnode = parent.vnode).el = el;
        parent = parent.parent;
    }
}
const $0a6cc4ba868319ae$var$isSuspense = (type)=>type.__isSuspense;
// Suspense exposes a component-like API, and is treated like a component
// in the compiler, but internally it's a special built-in type that hooks
// directly into the renderer.
const $0a6cc4ba868319ae$var$SuspenseImpl = {
    name: 'Suspense',
    // In order to make Suspense tree-shakable, we need to avoid importing it
    // directly in the renderer. The renderer checks for the __isSuspense flag
    // on a vnode's type and calls the `process` method, passing in renderer
    // internals.
    __isSuspense: true,
    process (n1, n2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized, // platform-specific impl passed from renderer
    rendererInternals) {
        if (n1 == null) $0a6cc4ba868319ae$var$mountSuspense(n2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized, rendererInternals);
        else $0a6cc4ba868319ae$var$patchSuspense(n1, n2, container, anchor, parentComponent, isSVG, slotScopeIds, optimized, rendererInternals);
    },
    hydrate: $0a6cc4ba868319ae$var$hydrateSuspense,
    create: $0a6cc4ba868319ae$var$createSuspenseBoundary,
    normalize: $0a6cc4ba868319ae$var$normalizeSuspenseChildren
};
// Force-casted public typing for h and TSX props inference
const $0a6cc4ba868319ae$export$74bf444e3cd11ea5 = $0a6cc4ba868319ae$var$SuspenseImpl;
function $0a6cc4ba868319ae$var$triggerEvent(vnode, name) {
    const eventListener = vnode.props && vnode.props[name];
    if ((0, $8POXm.isFunction)(eventListener)) eventListener();
}
function $0a6cc4ba868319ae$var$mountSuspense(vnode, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized, rendererInternals) {
    const { p: patch, o: { createElement: createElement } } = rendererInternals;
    const hiddenContainer = createElement('div');
    const suspense = vnode.suspense = $0a6cc4ba868319ae$var$createSuspenseBoundary(vnode, parentSuspense, parentComponent, container, hiddenContainer, anchor, isSVG, slotScopeIds, optimized, rendererInternals);
    // start mounting the content subtree in an off-dom container
    patch(null, suspense.pendingBranch = vnode.ssContent, hiddenContainer, null, parentComponent, suspense, isSVG, slotScopeIds);
    // now check if we have encountered any async deps
    if (suspense.deps > 0) {
        // has async
        // invoke @fallback event
        $0a6cc4ba868319ae$var$triggerEvent(vnode, 'onPending');
        $0a6cc4ba868319ae$var$triggerEvent(vnode, 'onFallback');
        // mount the fallback tree
        patch(null, vnode.ssFallback, container, anchor, parentComponent, null, isSVG, slotScopeIds);
        $0a6cc4ba868319ae$var$setActiveBranch(suspense, vnode.ssFallback);
    } else // Suspense has no async deps. Just resolve.
    suspense.resolve();
}
function $0a6cc4ba868319ae$var$patchSuspense(n1, n2, container, anchor, parentComponent, isSVG, slotScopeIds, optimized, { p: patch, um: unmount, o: { createElement: createElement } }) {
    const suspense = n2.suspense = n1.suspense;
    suspense.vnode = n2;
    n2.el = n1.el;
    const newBranch = n2.ssContent;
    const newFallback = n2.ssFallback;
    const { activeBranch: activeBranch, pendingBranch: pendingBranch, isInFallback: isInFallback, isHydrating: isHydrating } = suspense;
    if (pendingBranch) {
        suspense.pendingBranch = newBranch;
        if ($0a6cc4ba868319ae$var$isSameVNodeType(newBranch, pendingBranch)) {
            // same root type but content may have changed.
            patch(pendingBranch, newBranch, suspense.hiddenContainer, null, parentComponent, suspense, isSVG, slotScopeIds, optimized);
            if (suspense.deps <= 0) suspense.resolve();
            else if (isInFallback) {
                patch(activeBranch, newFallback, container, anchor, parentComponent, null, isSVG, slotScopeIds, optimized);
                $0a6cc4ba868319ae$var$setActiveBranch(suspense, newFallback);
            }
        } else {
            // toggled before pending tree is resolved
            suspense.pendingId++;
            if (isHydrating) {
                // if toggled before hydration is finished, the current DOM tree is
                // no longer valid. set it as the active branch so it will be unmounted
                // when resolved
                suspense.isHydrating = false;
                suspense.activeBranch = pendingBranch;
            } else unmount(pendingBranch, parentComponent, suspense);
            // increment pending ID. this is used to invalidate async callbacks
            // reset suspense state
            suspense.deps = 0;
            // discard effects from pending branch
            suspense.effects.length = 0;
            // discard previous container
            suspense.hiddenContainer = createElement('div');
            if (isInFallback) {
                // already in fallback state
                patch(null, newBranch, suspense.hiddenContainer, null, parentComponent, suspense, isSVG, slotScopeIds, optimized);
                if (suspense.deps <= 0) suspense.resolve();
                else {
                    patch(activeBranch, newFallback, container, anchor, parentComponent, null, isSVG, slotScopeIds, optimized);
                    $0a6cc4ba868319ae$var$setActiveBranch(suspense, newFallback);
                }
            } else if (activeBranch && $0a6cc4ba868319ae$var$isSameVNodeType(newBranch, activeBranch)) {
                // toggled "back" to current active branch
                patch(activeBranch, newBranch, container, anchor, parentComponent, suspense, isSVG, slotScopeIds, optimized);
                // force resolve
                suspense.resolve(true);
            } else {
                // switched to a 3rd branch
                patch(null, newBranch, suspense.hiddenContainer, null, parentComponent, suspense, isSVG, slotScopeIds, optimized);
                if (suspense.deps <= 0) suspense.resolve();
            }
        }
    } else if (activeBranch && $0a6cc4ba868319ae$var$isSameVNodeType(newBranch, activeBranch)) {
        // root did not change, just normal patch
        patch(activeBranch, newBranch, container, anchor, parentComponent, suspense, isSVG, slotScopeIds, optimized);
        $0a6cc4ba868319ae$var$setActiveBranch(suspense, newBranch);
    } else {
        // root node toggled
        // invoke @pending event
        $0a6cc4ba868319ae$var$triggerEvent(n2, 'onPending');
        // mount pending branch in off-dom container
        suspense.pendingBranch = newBranch;
        suspense.pendingId++;
        patch(null, newBranch, suspense.hiddenContainer, null, parentComponent, suspense, isSVG, slotScopeIds, optimized);
        if (suspense.deps <= 0) // incoming branch has no async deps, resolve now.
        suspense.resolve();
        else {
            const { timeout: timeout, pendingId: pendingId } = suspense;
            if (timeout > 0) setTimeout(()=>{
                if (suspense.pendingId === pendingId) suspense.fallback(newFallback);
            }, timeout);
            else if (timeout === 0) suspense.fallback(newFallback);
        }
    }
}
let $0a6cc4ba868319ae$var$hasWarned = false;
function $0a6cc4ba868319ae$var$createSuspenseBoundary(vnode, parent, parentComponent, container, hiddenContainer, anchor, isSVG, slotScopeIds, optimized, rendererInternals, isHydrating = false) {
    const { p: patch, m: move, um: unmount, n: next, o: { parentNode: parentNode, remove: remove } } = rendererInternals;
    const timeout = (0, $8POXm.toNumber)(vnode.props && vnode.props.timeout);
    const suspense = {
        vnode: vnode,
        parent: parent,
        parentComponent: parentComponent,
        isSVG: isSVG,
        container: container,
        hiddenContainer: hiddenContainer,
        anchor: anchor,
        deps: 0,
        pendingId: 0,
        timeout: typeof timeout === 'number' ? timeout : -1,
        activeBranch: null,
        pendingBranch: null,
        isInFallback: true,
        isHydrating: isHydrating,
        isUnmounted: false,
        effects: [],
        resolve (resume = false) {
            const { vnode: vnode, activeBranch: activeBranch, pendingBranch: pendingBranch, pendingId: pendingId, effects: effects, parentComponent: parentComponent, container: container } = suspense;
            if (suspense.isHydrating) suspense.isHydrating = false;
            else if (!resume) {
                const delayEnter = activeBranch && pendingBranch.transition && pendingBranch.transition.mode === 'out-in';
                if (delayEnter) activeBranch.transition.afterLeave = ()=>{
                    if (pendingId === suspense.pendingId) move(pendingBranch, container, anchor, 0 /* MoveType.ENTER */ );
                };
                // this is initial anchor on mount
                let { anchor: anchor } = suspense;
                // unmount current active tree
                if (activeBranch) {
                    // if the fallback tree was mounted, it may have been moved
                    // as part of a parent suspense. get the latest anchor for insertion
                    anchor = next(activeBranch);
                    unmount(activeBranch, parentComponent, suspense, true);
                }
                if (!delayEnter) // move content from off-dom container to actual container
                move(pendingBranch, container, anchor, 0 /* MoveType.ENTER */ );
            }
            $0a6cc4ba868319ae$var$setActiveBranch(suspense, pendingBranch);
            suspense.pendingBranch = null;
            suspense.isInFallback = false;
            // flush buffered effects
            // check if there is a pending parent suspense
            let parent = suspense.parent;
            let hasUnresolvedAncestor = false;
            while(parent){
                if (parent.pendingBranch) {
                    // found a pending parent suspense, merge buffered post jobs
                    // into that parent
                    parent.effects.push(...effects);
                    hasUnresolvedAncestor = true;
                    break;
                }
                parent = parent.parent;
            }
            // no pending parent suspense, flush all jobs
            if (!hasUnresolvedAncestor) $0a6cc4ba868319ae$export$59536a0199721cab(effects);
            suspense.effects = [];
            // invoke @resolve event
            $0a6cc4ba868319ae$var$triggerEvent(vnode, 'onResolve');
        },
        fallback (fallbackVNode) {
            if (!suspense.pendingBranch) return;
            const { vnode: vnode, activeBranch: activeBranch, parentComponent: parentComponent, container: container, isSVG: isSVG } = suspense;
            // invoke @fallback event
            $0a6cc4ba868319ae$var$triggerEvent(vnode, 'onFallback');
            const anchor = next(activeBranch);
            const mountFallback = ()=>{
                if (!suspense.isInFallback) return;
                // mount the fallback tree
                patch(null, fallbackVNode, container, anchor, parentComponent, null, isSVG, slotScopeIds, optimized);
                $0a6cc4ba868319ae$var$setActiveBranch(suspense, fallbackVNode);
            };
            const delayEnter = fallbackVNode.transition && fallbackVNode.transition.mode === 'out-in';
            if (delayEnter) activeBranch.transition.afterLeave = mountFallback;
            suspense.isInFallback = true;
            // unmount current active branch
            unmount(activeBranch, parentComponent, null, true // shouldRemove
            );
            if (!delayEnter) mountFallback();
        },
        move (container, anchor, type) {
            suspense.activeBranch && move(suspense.activeBranch, container, anchor, type);
            suspense.container = container;
        },
        next () {
            return suspense.activeBranch && next(suspense.activeBranch);
        },
        registerDep (instance, setupRenderEffect) {
            const isInPendingSuspense = !!suspense.pendingBranch;
            if (isInPendingSuspense) suspense.deps++;
            const hydratedEl = instance.vnode.el;
            instance.asyncDep.catch((err)=>{
                $0a6cc4ba868319ae$export$d3da1ecaf1206c58(err, instance, 0 /* ErrorCodes.SETUP_FUNCTION */ );
            }).then((asyncSetupResult)=>{
                // retry when the setup() promise resolves.
                // component may have been unmounted before resolve.
                if (instance.isUnmounted || suspense.isUnmounted || suspense.pendingId !== instance.suspenseId) return;
                // retry from this component
                instance.asyncResolved = true;
                const { vnode: vnode } = instance;
                $0a6cc4ba868319ae$var$handleSetupResult(instance, asyncSetupResult, false);
                if (hydratedEl) // vnode may have been replaced if an update happened before the
                // async dep is resolved.
                vnode.el = hydratedEl;
                const placeholder = !hydratedEl && instance.subTree.el;
                setupRenderEffect(instance, vnode, // component may have been moved before resolve.
                // if this is not a hydration, instance.subTree will be the comment
                // placeholder.
                parentNode(hydratedEl || instance.subTree.el), // anchor will not be used if this is hydration, so only need to
                // consider the comment placeholder case.
                hydratedEl ? null : next(instance.subTree), suspense, isSVG, optimized);
                if (placeholder) remove(placeholder);
                $0a6cc4ba868319ae$var$updateHOCHostEl(instance, vnode.el);
                // only decrease deps count if suspense is not already resolved
                if (isInPendingSuspense && --suspense.deps === 0) suspense.resolve();
            });
        },
        unmount (parentSuspense, doRemove) {
            suspense.isUnmounted = true;
            if (suspense.activeBranch) unmount(suspense.activeBranch, parentComponent, parentSuspense, doRemove);
            if (suspense.pendingBranch) unmount(suspense.pendingBranch, parentComponent, parentSuspense, doRemove);
        }
    };
    return suspense;
}
function $0a6cc4ba868319ae$var$hydrateSuspense(node, vnode, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized, rendererInternals, hydrateNode) {
    /* eslint-disable no-restricted-globals */ const suspense = vnode.suspense = $0a6cc4ba868319ae$var$createSuspenseBoundary(vnode, parentSuspense, parentComponent, node.parentNode, document.createElement('div'), null, isSVG, slotScopeIds, optimized, rendererInternals, true);
    // there are two possible scenarios for server-rendered suspense:
    // - success: ssr content should be fully resolved
    // - failure: ssr content should be the fallback branch.
    // however, on the client we don't really know if it has failed or not
    // attempt to hydrate the DOM assuming it has succeeded, but we still
    // need to construct a suspense boundary first
    const result = hydrateNode(node, suspense.pendingBranch = vnode.ssContent, parentComponent, suspense, slotScopeIds, optimized);
    if (suspense.deps === 0) suspense.resolve();
    return result;
/* eslint-enable no-restricted-globals */ }
function $0a6cc4ba868319ae$var$normalizeSuspenseChildren(vnode) {
    const { shapeFlag: shapeFlag, children: children } = vnode;
    const isSlotChildren = shapeFlag & 32 /* ShapeFlags.SLOTS_CHILDREN */ ;
    vnode.ssContent = $0a6cc4ba868319ae$var$normalizeSuspenseSlot(isSlotChildren ? children.default : children);
    vnode.ssFallback = isSlotChildren ? $0a6cc4ba868319ae$var$normalizeSuspenseSlot(children.fallback) : $0a6cc4ba868319ae$export$bf5c4cf060303d58($0a6cc4ba868319ae$export$4d299b491347818a);
}
function $0a6cc4ba868319ae$var$normalizeSuspenseSlot(s) {
    let block;
    if ((0, $8POXm.isFunction)(s)) {
        const trackBlock = $0a6cc4ba868319ae$var$isBlockTreeEnabled && s._c;
        if (trackBlock) {
            // disableTracking: false
            // allow block tracking for compiled slots
            // (see ./componentRenderContext.ts)
            s._d = false;
            $0a6cc4ba868319ae$export$e7eaa45e502fe5cc();
        }
        s = s();
        if (trackBlock) {
            s._d = true;
            block = $0a6cc4ba868319ae$var$currentBlock;
            $0a6cc4ba868319ae$var$closeBlock();
        }
    }
    if ((0, $8POXm.isArray)(s)) {
        const singleChild = $0a6cc4ba868319ae$var$filterSingleRoot(s);
        s = singleChild;
    }
    s = $0a6cc4ba868319ae$var$normalizeVNode(s);
    if (block && !s.dynamicChildren) s.dynamicChildren = block.filter((c)=>c !== s);
    return s;
}
function $0a6cc4ba868319ae$var$queueEffectWithSuspense(fn, suspense) {
    if (suspense && suspense.pendingBranch) {
        if ((0, $8POXm.isArray)(fn)) suspense.effects.push(...fn);
        else suspense.effects.push(fn);
    } else $0a6cc4ba868319ae$export$59536a0199721cab(fn);
}
function $0a6cc4ba868319ae$var$setActiveBranch(suspense, branch) {
    suspense.activeBranch = branch;
    const { vnode: vnode, parentComponent: parentComponent } = suspense;
    const el = vnode.el = branch.el;
    // in case suspense is the root node of a component,
    // recursively update the HOC el
    if (parentComponent && parentComponent.subTree === vnode) {
        parentComponent.vnode.el = el;
        $0a6cc4ba868319ae$var$updateHOCHostEl(parentComponent, el);
    }
}
function $0a6cc4ba868319ae$export$abe1e183e22e10ad(key, value) {
    if (!$0a6cc4ba868319ae$var$currentInstance) ;
    else {
        let provides = $0a6cc4ba868319ae$var$currentInstance.provides;
        // by default an instance inherits its parent's provides object
        // but when it needs to provide values of its own, it creates its
        // own provides object using parent provides object as prototype.
        // this way in `inject` we can simply look up injections from direct
        // parent and let the prototype chain do the work.
        const parentProvides = $0a6cc4ba868319ae$var$currentInstance.parent && $0a6cc4ba868319ae$var$currentInstance.parent.provides;
        if (parentProvides === provides) provides = $0a6cc4ba868319ae$var$currentInstance.provides = Object.create(parentProvides);
        // TS doesn't allow symbol as index type
        provides[key] = value;
    }
}
function $0a6cc4ba868319ae$export$a976684a0efeb93f(key, defaultValue, treatDefaultAsFactory = false) {
    // fallback to `currentRenderingInstance` so that this can be called in
    // a functional component
    const instance = $0a6cc4ba868319ae$var$currentInstance || $0a6cc4ba868319ae$var$currentRenderingInstance;
    if (instance) {
        // #2400
        // to support `app.use` plugins,
        // fallback to appContext's `provides` if the instance is at root
        const provides = instance.parent == null ? instance.vnode.appContext && instance.vnode.appContext.provides : instance.parent.provides;
        if (provides && key in provides) // TS doesn't allow symbol as index type
        return provides[key];
        else if (arguments.length > 1) return treatDefaultAsFactory && (0, $8POXm.isFunction)(defaultValue) ? defaultValue.call(instance.proxy) : defaultValue;
    }
}
// Simple effect.
function $0a6cc4ba868319ae$export$ede35fc0e5500309(effect, options) {
    return $0a6cc4ba868319ae$var$doWatch(effect, null, options);
}
function $0a6cc4ba868319ae$export$b7f27ea67102d543(effect, options) {
    return $0a6cc4ba868319ae$var$doWatch(effect, null, {
        flush: 'post'
    });
}
function $0a6cc4ba868319ae$export$2035654f31b0e555(effect, options) {
    return $0a6cc4ba868319ae$var$doWatch(effect, null, {
        flush: 'sync'
    });
}
// initial value for watchers to trigger on undefined initial values
const $0a6cc4ba868319ae$var$INITIAL_WATCHER_VALUE = {};
// implementation
function $0a6cc4ba868319ae$export$3db5d71bdb2d5499(source, cb, options) {
    return $0a6cc4ba868319ae$var$doWatch(source, cb, options);
}
function $0a6cc4ba868319ae$var$doWatch(source, cb, { immediate: immediate, deep: deep, flush: flush, onTrack: onTrack, onTrigger: onTrigger } = (0, $8POXm.EMPTY_OBJ)) {
    const warnInvalidSource = (s)=>{
        $0a6cc4ba868319ae$export$c106dd0671a0fc2d(`Invalid watch source: `, s, `A watch source can only be a getter/effect function, a ref, ` + `a reactive object, or an array of these types.`);
    };
    const instance = $0a6cc4ba868319ae$var$currentInstance;
    let getter;
    let forceTrigger = false;
    let isMultiSource = false;
    if ((0, $01W3b.isRef)(source)) {
        getter = ()=>source.value;
        forceTrigger = (0, $01W3b.isShallow)(source);
    } else if ((0, $01W3b.isReactive)(source)) {
        getter = ()=>source;
        deep = true;
    } else if ((0, $8POXm.isArray)(source)) {
        isMultiSource = true;
        forceTrigger = source.some((s)=>(0, $01W3b.isReactive)(s) || (0, $01W3b.isShallow)(s));
        getter = ()=>source.map((s)=>{
                if ((0, $01W3b.isRef)(s)) return s.value;
                else if ((0, $01W3b.isReactive)(s)) return $0a6cc4ba868319ae$var$traverse(s);
                else if ((0, $8POXm.isFunction)(s)) return $0a6cc4ba868319ae$export$b22fcaf88446e9bf(s, instance, 2 /* ErrorCodes.WATCH_GETTER */ );
            });
    } else if ((0, $8POXm.isFunction)(source)) {
        if (cb) // getter with cb
        getter = ()=>$0a6cc4ba868319ae$export$b22fcaf88446e9bf(source, instance, 2 /* ErrorCodes.WATCH_GETTER */ );
        else // no cb -> simple effect
        getter = ()=>{
            if (instance && instance.isUnmounted) return;
            if (cleanup) cleanup();
            return $0a6cc4ba868319ae$export$dae85862a8d94378(source, instance, 3 /* ErrorCodes.WATCH_CALLBACK */ , [
                onCleanup
            ]);
        };
    } else getter = (0, $8POXm.NOOP);
    if (cb && deep) {
        const baseGetter = getter;
        getter = ()=>$0a6cc4ba868319ae$var$traverse(baseGetter());
    }
    let cleanup;
    let onCleanup = (fn)=>{
        cleanup = effect.onStop = ()=>{
            $0a6cc4ba868319ae$export$b22fcaf88446e9bf(fn, instance, 4 /* ErrorCodes.WATCH_CLEANUP */ );
        };
    };
    // in SSR there is no need to setup an actual effect, and it should be noop
    // unless it's eager
    if ($0a6cc4ba868319ae$var$isInSSRComponentSetup) {
        // we will also not call the invalidate callback (+ runner is not set up)
        onCleanup = (0, $8POXm.NOOP);
        if (!cb) getter();
        else if (immediate) $0a6cc4ba868319ae$export$dae85862a8d94378(cb, instance, 3 /* ErrorCodes.WATCH_CALLBACK */ , [
            getter(),
            isMultiSource ? [] : undefined,
            onCleanup
        ]);
        return 0, $8POXm.NOOP;
    }
    let oldValue = isMultiSource ? [] : $0a6cc4ba868319ae$var$INITIAL_WATCHER_VALUE;
    const job = ()=>{
        if (!effect.active) return;
        if (cb) {
            // watch(source, cb)
            const newValue = effect.run();
            if (deep || forceTrigger || (isMultiSource ? newValue.some((v1, i)=>(0, $8POXm.hasChanged)(v1, oldValue[i])) : (0, $8POXm.hasChanged)(newValue, oldValue)) || false) {
                // cleanup before running cb again
                if (cleanup) cleanup();
                $0a6cc4ba868319ae$export$dae85862a8d94378(cb, instance, 3 /* ErrorCodes.WATCH_CALLBACK */ , [
                    newValue,
                    // pass undefined as the old value when it's changed for the first time
                    oldValue === $0a6cc4ba868319ae$var$INITIAL_WATCHER_VALUE ? undefined : oldValue,
                    onCleanup
                ]);
                oldValue = newValue;
            }
        } else // watchEffect
        effect.run();
    };
    // important: mark the job as a watcher callback so that scheduler knows
    // it is allowed to self-trigger (#1727)
    job.allowRecurse = !!cb;
    let scheduler;
    if (flush === 'sync') scheduler = job; // the scheduler function gets called directly
    else if (flush === 'post') scheduler = ()=>$0a6cc4ba868319ae$var$queuePostRenderEffect(job, instance && instance.suspense);
    else {
        // default: 'pre'
        job.pre = true;
        if (instance) job.id = instance.uid;
        scheduler = ()=>$0a6cc4ba868319ae$var$queueJob(job);
    }
    const effect = new (0, $01W3b.ReactiveEffect)(getter, scheduler);
    // initial run
    if (cb) {
        if (immediate) job();
        else oldValue = effect.run();
    } else if (flush === 'post') $0a6cc4ba868319ae$var$queuePostRenderEffect(effect.run.bind(effect), instance && instance.suspense);
    else effect.run();
    return ()=>{
        effect.stop();
        if (instance && instance.scope) (0, $8POXm.remove)(instance.scope.effects, effect);
    };
}
// this.$watch
function $0a6cc4ba868319ae$var$instanceWatch(source, value, options) {
    const publicThis = this.proxy;
    const getter = (0, $8POXm.isString)(source) ? source.includes('.') ? $0a6cc4ba868319ae$var$createPathGetter(publicThis, source) : ()=>publicThis[source] : source.bind(publicThis, publicThis);
    let cb;
    if ((0, $8POXm.isFunction)(value)) cb = value;
    else {
        cb = value.handler;
        options = value;
    }
    const cur = $0a6cc4ba868319ae$var$currentInstance;
    $0a6cc4ba868319ae$var$setCurrentInstance(this);
    const res = $0a6cc4ba868319ae$var$doWatch(getter, cb.bind(publicThis), options);
    if (cur) $0a6cc4ba868319ae$var$setCurrentInstance(cur);
    else $0a6cc4ba868319ae$var$unsetCurrentInstance();
    return res;
}
function $0a6cc4ba868319ae$var$createPathGetter(ctx, path) {
    const segments = path.split('.');
    return ()=>{
        let cur = ctx;
        for(let i = 0; i < segments.length && cur; i++)cur = cur[segments[i]];
        return cur;
    };
}
function $0a6cc4ba868319ae$var$traverse(value, seen) {
    if (!(0, $8POXm.isObject)(value) || value["__v_skip" /* ReactiveFlags.SKIP */ ]) return value;
    seen = seen || new Set();
    if (seen.has(value)) return value;
    seen.add(value);
    if ((0, $01W3b.isRef)(value)) $0a6cc4ba868319ae$var$traverse(value.value, seen);
    else if ((0, $8POXm.isArray)(value)) for(let i = 0; i < value.length; i++)$0a6cc4ba868319ae$var$traverse(value[i], seen);
    else if ((0, $8POXm.isSet)(value) || (0, $8POXm.isMap)(value)) value.forEach((v1)=>{
        $0a6cc4ba868319ae$var$traverse(v1, seen);
    });
    else if ((0, $8POXm.isPlainObject)(value)) for(const key in value)$0a6cc4ba868319ae$var$traverse(value[key], seen);
    return value;
}
function $0a6cc4ba868319ae$export$d2a0a1bc267c90f6() {
    const state = {
        isMounted: false,
        isLeaving: false,
        isUnmounting: false,
        leavingVNodes: new Map()
    };
    $0a6cc4ba868319ae$export$6d1641039221b5cb(()=>{
        state.isMounted = true;
    });
    $0a6cc4ba868319ae$export$40c420df62d2614(()=>{
        state.isUnmounting = true;
    });
    return state;
}
const $0a6cc4ba868319ae$var$TransitionHookValidator = [
    Function,
    Array
];
const $0a6cc4ba868319ae$var$BaseTransitionImpl = {
    name: `BaseTransition`,
    props: {
        mode: String,
        appear: Boolean,
        persisted: Boolean,
        // enter
        onBeforeEnter: $0a6cc4ba868319ae$var$TransitionHookValidator,
        onEnter: $0a6cc4ba868319ae$var$TransitionHookValidator,
        onAfterEnter: $0a6cc4ba868319ae$var$TransitionHookValidator,
        onEnterCancelled: $0a6cc4ba868319ae$var$TransitionHookValidator,
        // leave
        onBeforeLeave: $0a6cc4ba868319ae$var$TransitionHookValidator,
        onLeave: $0a6cc4ba868319ae$var$TransitionHookValidator,
        onAfterLeave: $0a6cc4ba868319ae$var$TransitionHookValidator,
        onLeaveCancelled: $0a6cc4ba868319ae$var$TransitionHookValidator,
        // appear
        onBeforeAppear: $0a6cc4ba868319ae$var$TransitionHookValidator,
        onAppear: $0a6cc4ba868319ae$var$TransitionHookValidator,
        onAfterAppear: $0a6cc4ba868319ae$var$TransitionHookValidator,
        onAppearCancelled: $0a6cc4ba868319ae$var$TransitionHookValidator
    },
    setup (props, { slots: slots }) {
        const instance = $0a6cc4ba868319ae$export$f13e630aa3915748();
        const state = $0a6cc4ba868319ae$export$d2a0a1bc267c90f6();
        let prevTransitionKey;
        return ()=>{
            const children = slots.default && $0a6cc4ba868319ae$export$a67f9b1229c7c97a(slots.default(), true);
            if (!children || !children.length) return;
            let child = children[0];
            if (children.length > 1) {
                let hasFound = false;
                // locate first non-comment child
                for (const c of children)if (c.type !== $0a6cc4ba868319ae$export$4d299b491347818a) {
                    child = c;
                    hasFound = true;
                    break;
                }
            }
            // there's no need to track reactivity for these props so use the raw
            // props for a bit better perf
            const rawProps = (0, $01W3b.toRaw)(props);
            const { mode: mode } = rawProps;
            if (state.isLeaving) return $0a6cc4ba868319ae$var$emptyPlaceholder(child);
            // in the case of <transition><keep-alive/></transition>, we need to
            // compare the type of the kept-alive children.
            const innerChild = $0a6cc4ba868319ae$var$getKeepAliveChild(child);
            if (!innerChild) return $0a6cc4ba868319ae$var$emptyPlaceholder(child);
            const enterHooks = $0a6cc4ba868319ae$export$76ac1779589cd824(innerChild, rawProps, state, instance);
            $0a6cc4ba868319ae$export$7770a22486565649(innerChild, enterHooks);
            const oldChild = instance.subTree;
            const oldInnerChild = oldChild && $0a6cc4ba868319ae$var$getKeepAliveChild(oldChild);
            let transitionKeyChanged = false;
            const { getTransitionKey: getTransitionKey } = innerChild.type;
            if (getTransitionKey) {
                const key = getTransitionKey();
                if (prevTransitionKey === undefined) prevTransitionKey = key;
                else if (key !== prevTransitionKey) {
                    prevTransitionKey = key;
                    transitionKeyChanged = true;
                }
            }
            // handle mode
            if (oldInnerChild && oldInnerChild.type !== $0a6cc4ba868319ae$export$4d299b491347818a && (!$0a6cc4ba868319ae$var$isSameVNodeType(innerChild, oldInnerChild) || transitionKeyChanged)) {
                const leavingHooks = $0a6cc4ba868319ae$export$76ac1779589cd824(oldInnerChild, rawProps, state, instance);
                // update old tree's hooks in case of dynamic transition
                $0a6cc4ba868319ae$export$7770a22486565649(oldInnerChild, leavingHooks);
                // switching between different views
                if (mode === 'out-in') {
                    state.isLeaving = true;
                    // return placeholder node and queue update when leave finishes
                    leavingHooks.afterLeave = ()=>{
                        state.isLeaving = false;
                        instance.update();
                    };
                    return $0a6cc4ba868319ae$var$emptyPlaceholder(child);
                } else if (mode === 'in-out' && innerChild.type !== $0a6cc4ba868319ae$export$4d299b491347818a) leavingHooks.delayLeave = (el, earlyRemove, delayedLeave)=>{
                    const leavingVNodesCache = $0a6cc4ba868319ae$var$getLeavingNodesForType(state, oldInnerChild);
                    leavingVNodesCache[String(oldInnerChild.key)] = oldInnerChild;
                    // early removal callback
                    el._leaveCb = ()=>{
                        earlyRemove();
                        el._leaveCb = undefined;
                        delete enterHooks.delayedLeave;
                    };
                    enterHooks.delayedLeave = delayedLeave;
                };
            }
            return child;
        };
    }
};
// export the public type for h/tsx inference
// also to avoid inline import() in generated d.ts files
const $0a6cc4ba868319ae$export$abd95b5f5e8a8837 = $0a6cc4ba868319ae$var$BaseTransitionImpl;
function $0a6cc4ba868319ae$var$getLeavingNodesForType(state, vnode) {
    const { leavingVNodes: leavingVNodes } = state;
    let leavingVNodesCache = leavingVNodes.get(vnode.type);
    if (!leavingVNodesCache) {
        leavingVNodesCache = Object.create(null);
        leavingVNodes.set(vnode.type, leavingVNodesCache);
    }
    return leavingVNodesCache;
}
// The transition hooks are attached to the vnode as vnode.transition
// and will be called at appropriate timing in the renderer.
function $0a6cc4ba868319ae$export$76ac1779589cd824(vnode, props, state, instance) {
    const { appear: appear, mode: mode, persisted: persisted = false, onBeforeEnter: onBeforeEnter, onEnter: onEnter, onAfterEnter: onAfterEnter, onEnterCancelled: onEnterCancelled, onBeforeLeave: onBeforeLeave, onLeave: onLeave, onAfterLeave: onAfterLeave, onLeaveCancelled: onLeaveCancelled, onBeforeAppear: onBeforeAppear, onAppear: onAppear, onAfterAppear: onAfterAppear, onAppearCancelled: onAppearCancelled } = props;
    const key = String(vnode.key);
    const leavingVNodesCache = $0a6cc4ba868319ae$var$getLeavingNodesForType(state, vnode);
    const callHook = (hook, args)=>{
        hook && $0a6cc4ba868319ae$export$dae85862a8d94378(hook, instance, 9 /* ErrorCodes.TRANSITION_HOOK */ , args);
    };
    const callAsyncHook = (hook, args)=>{
        const done = args[1];
        callHook(hook, args);
        if ((0, $8POXm.isArray)(hook)) {
            if (hook.every((hook)=>hook.length <= 1)) done();
        } else if (hook.length <= 1) done();
    };
    const hooks = {
        mode: mode,
        persisted: persisted,
        beforeEnter (el) {
            let hook = onBeforeEnter;
            if (!state.isMounted) {
                if (appear) hook = onBeforeAppear || onBeforeEnter;
                else return;
            }
            // for same element (v-show)
            if (el._leaveCb) el._leaveCb(true);
            // for toggled element with same key (v-if)
            const leavingVNode = leavingVNodesCache[key];
            if (leavingVNode && $0a6cc4ba868319ae$var$isSameVNodeType(vnode, leavingVNode) && leavingVNode.el._leaveCb) // force early removal (not cancelled)
            leavingVNode.el._leaveCb();
            callHook(hook, [
                el
            ]);
        },
        enter (el) {
            let hook = onEnter;
            let afterHook = onAfterEnter;
            let cancelHook = onEnterCancelled;
            if (!state.isMounted) {
                if (appear) {
                    hook = onAppear || onEnter;
                    afterHook = onAfterAppear || onAfterEnter;
                    cancelHook = onAppearCancelled || onEnterCancelled;
                } else return;
            }
            let called = false;
            const done = el._enterCb = (cancelled)=>{
                if (called) return;
                called = true;
                if (cancelled) callHook(cancelHook, [
                    el
                ]);
                else callHook(afterHook, [
                    el
                ]);
                if (hooks.delayedLeave) hooks.delayedLeave();
                el._enterCb = undefined;
            };
            if (hook) callAsyncHook(hook, [
                el,
                done
            ]);
            else done();
        },
        leave (el, remove) {
            const key = String(vnode.key);
            if (el._enterCb) el._enterCb(true);
            if (state.isUnmounting) return remove();
            callHook(onBeforeLeave, [
                el
            ]);
            let called = false;
            const done = el._leaveCb = (cancelled)=>{
                if (called) return;
                called = true;
                remove();
                if (cancelled) callHook(onLeaveCancelled, [
                    el
                ]);
                else callHook(onAfterLeave, [
                    el
                ]);
                el._leaveCb = undefined;
                if (leavingVNodesCache[key] === vnode) delete leavingVNodesCache[key];
            };
            leavingVNodesCache[key] = vnode;
            if (onLeave) callAsyncHook(onLeave, [
                el,
                done
            ]);
            else done();
        },
        clone (vnode) {
            return $0a6cc4ba868319ae$export$76ac1779589cd824(vnode, props, state, instance);
        }
    };
    return hooks;
}
// the placeholder really only handles one special case: KeepAlive
// in the case of a KeepAlive in a leave phase we need to return a KeepAlive
// placeholder with empty content to avoid the KeepAlive instance from being
// unmounted.
function $0a6cc4ba868319ae$var$emptyPlaceholder(vnode) {
    if ($0a6cc4ba868319ae$var$isKeepAlive(vnode)) {
        vnode = $0a6cc4ba868319ae$export$ee4f9e12c0a92a1a(vnode);
        vnode.children = null;
        return vnode;
    }
}
function $0a6cc4ba868319ae$var$getKeepAliveChild(vnode) {
    return $0a6cc4ba868319ae$var$isKeepAlive(vnode) ? vnode.children ? vnode.children[0] : undefined : vnode;
}
function $0a6cc4ba868319ae$export$7770a22486565649(vnode, hooks) {
    if (vnode.shapeFlag & 6 /* ShapeFlags.COMPONENT */  && vnode.component) $0a6cc4ba868319ae$export$7770a22486565649(vnode.component.subTree, hooks);
    else if (vnode.shapeFlag & 128 /* ShapeFlags.SUSPENSE */ ) {
        vnode.ssContent.transition = hooks.clone(vnode.ssContent);
        vnode.ssFallback.transition = hooks.clone(vnode.ssFallback);
    } else vnode.transition = hooks;
}
function $0a6cc4ba868319ae$export$a67f9b1229c7c97a(children, keepComment = false, parentKey) {
    let ret = [];
    let keyedFragmentCount = 0;
    for(let i = 0; i < children.length; i++){
        let child = children[i];
        // #5360 inherit parent key in case of <template v-for>
        const key = parentKey == null ? child.key : String(parentKey) + String(child.key != null ? child.key : i);
        // handle fragment children case, e.g. v-for
        if (child.type === $0a6cc4ba868319ae$export$ffb0004e005737fa) {
            if (child.patchFlag & 128 /* PatchFlags.KEYED_FRAGMENT */ ) keyedFragmentCount++;
            ret = ret.concat($0a6cc4ba868319ae$export$a67f9b1229c7c97a(child.children, keepComment, key));
        } else if (keepComment || child.type !== $0a6cc4ba868319ae$export$4d299b491347818a) ret.push(key != null ? $0a6cc4ba868319ae$export$ee4f9e12c0a92a1a(child, {
            key: key
        }) : child);
    }
    // #1126 if a transition children list contains multiple sub fragments, these
    // fragments will be merged into a flat children array. Since each v-for
    // fragment may contain different static bindings inside, we need to de-op
    // these children to force full diffs to ensure correct behavior.
    if (keyedFragmentCount > 1) for(let i = 0; i < ret.length; i++)ret[i].patchFlag = -2 /* PatchFlags.BAIL */ ;
    return ret;
}
// implementation, close to no-op
function $0a6cc4ba868319ae$export$afa64b67e5a01c3b(options) {
    return (0, $8POXm.isFunction)(options) ? {
        setup: options,
        name: options.name
    } : options;
}
const $0a6cc4ba868319ae$var$isAsyncWrapper = (i)=>!!i.type.__asyncLoader;
function $0a6cc4ba868319ae$export$d75d499b4c16cf21(source) {
    if ((0, $8POXm.isFunction)(source)) source = {
        loader: source
    };
    const { loader: loader, loadingComponent: loadingComponent, errorComponent: errorComponent, delay: delay = 200, timeout: timeout, suspensible: suspensible = true, onError: userOnError } = source;
    let pendingRequest = null;
    let resolvedComp;
    let retries = 0;
    const retry = ()=>{
        retries++;
        pendingRequest = null;
        return load();
    };
    const load = ()=>{
        let thisRequest;
        return pendingRequest || (thisRequest = pendingRequest = loader().catch((err)=>{
            err = err instanceof Error ? err : new Error(String(err));
            if (userOnError) return new Promise((resolve, reject)=>{
                const userRetry = ()=>resolve(retry());
                const userFail = ()=>reject(err);
                userOnError(err, userRetry, userFail, retries + 1);
            });
            else throw err;
        }).then((comp)=>{
            if (thisRequest !== pendingRequest && pendingRequest) return pendingRequest;
            // interop module default
            if (comp && (comp.__esModule || comp[Symbol.toStringTag] === 'Module')) comp = comp.default;
            resolvedComp = comp;
            return comp;
        }));
    };
    return $0a6cc4ba868319ae$export$afa64b67e5a01c3b({
        name: 'AsyncComponentWrapper',
        __asyncLoader: load,
        get __asyncResolved () {
            return resolvedComp;
        },
        setup () {
            const instance = $0a6cc4ba868319ae$var$currentInstance;
            // already resolved
            if (resolvedComp) return ()=>$0a6cc4ba868319ae$var$createInnerComp(resolvedComp, instance);
            const onError = (err)=>{
                pendingRequest = null;
                $0a6cc4ba868319ae$export$d3da1ecaf1206c58(err, instance, 13 /* ErrorCodes.ASYNC_COMPONENT_LOADER */ , !errorComponent /* do not throw in dev if user provided error component */ );
            };
            // suspense-controlled or SSR.
            if (suspensible && instance.suspense || $0a6cc4ba868319ae$var$isInSSRComponentSetup) return load().then((comp)=>{
                return ()=>$0a6cc4ba868319ae$var$createInnerComp(comp, instance);
            }).catch((err)=>{
                onError(err);
                return ()=>errorComponent ? $0a6cc4ba868319ae$export$bf5c4cf060303d58(errorComponent, {
                        error: err
                    }) : null;
            });
            const loaded = (0, $01W3b.ref)(false);
            const error = (0, $01W3b.ref)();
            const delayed = (0, $01W3b.ref)(!!delay);
            if (delay) setTimeout(()=>{
                delayed.value = false;
            }, delay);
            if (timeout != null) setTimeout(()=>{
                if (!loaded.value && !error.value) {
                    const err = new Error(`Async component timed out after ${timeout}ms.`);
                    onError(err);
                    error.value = err;
                }
            }, timeout);
            load().then(()=>{
                loaded.value = true;
                if (instance.parent && $0a6cc4ba868319ae$var$isKeepAlive(instance.parent.vnode)) // parent is keep-alive, force update so the loaded component's
                // name is taken into account
                $0a6cc4ba868319ae$var$queueJob(instance.parent.update);
            }).catch((err)=>{
                onError(err);
                error.value = err;
            });
            return ()=>{
                if (loaded.value && resolvedComp) return $0a6cc4ba868319ae$var$createInnerComp(resolvedComp, instance);
                else if (error.value && errorComponent) return $0a6cc4ba868319ae$export$bf5c4cf060303d58(errorComponent, {
                    error: error.value
                });
                else if (loadingComponent && !delayed.value) return $0a6cc4ba868319ae$export$bf5c4cf060303d58(loadingComponent);
            };
        }
    });
}
function $0a6cc4ba868319ae$var$createInnerComp(comp, { vnode: { ref: ref, props: props, children: children, shapeFlag: shapeFlag }, parent: parent }) {
    const vnode = $0a6cc4ba868319ae$export$bf5c4cf060303d58(comp, props, children);
    // ensure inner component inherits the async wrapper's ref owner
    vnode.ref = ref;
    return vnode;
}
const $0a6cc4ba868319ae$var$isKeepAlive = (vnode)=>vnode.type.__isKeepAlive;
const $0a6cc4ba868319ae$var$KeepAliveImpl = {
    name: `KeepAlive`,
    // Marker for special handling inside the renderer. We are not using a ===
    // check directly on KeepAlive in the renderer, because importing it directly
    // would prevent it from being tree-shaken.
    __isKeepAlive: true,
    props: {
        include: [
            String,
            RegExp,
            Array
        ],
        exclude: [
            String,
            RegExp,
            Array
        ],
        max: [
            String,
            Number
        ]
    },
    setup (props, { slots: slots }) {
        const instance = $0a6cc4ba868319ae$export$f13e630aa3915748();
        // KeepAlive communicates with the instantiated renderer via the
        // ctx where the renderer passes in its internals,
        // and the KeepAlive instance exposes activate/deactivate implementations.
        // The whole point of this is to avoid importing KeepAlive directly in the
        // renderer to facilitate tree-shaking.
        const sharedContext = instance.ctx;
        // if the internal renderer is not registered, it indicates that this is server-side rendering,
        // for KeepAlive, we just need to render its children
        if (!sharedContext.renderer) return ()=>{
            const children = slots.default && slots.default();
            return children && children.length === 1 ? children[0] : children;
        };
        const cache = new Map();
        const keys = new Set();
        let current = null;
        if (__VUE_PROD_DEVTOOLS__) instance.__v_cache = cache;
        const parentSuspense = instance.suspense;
        const { renderer: { p: patch, m: move, um: _unmount, o: { createElement: createElement } } } = sharedContext;
        const storageContainer = createElement('div');
        sharedContext.activate = (vnode, container, anchor, isSVG, optimized)=>{
            const instance = vnode.component;
            move(vnode, container, anchor, 0 /* MoveType.ENTER */ , parentSuspense);
            // in case props have changed
            patch(instance.vnode, vnode, container, anchor, instance, parentSuspense, isSVG, vnode.slotScopeIds, optimized);
            $0a6cc4ba868319ae$var$queuePostRenderEffect(()=>{
                instance.isDeactivated = false;
                if (instance.a) (0, $8POXm.invokeArrayFns)(instance.a);
                const vnodeHook = vnode.props && vnode.props.onVnodeMounted;
                if (vnodeHook) $0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHook, instance.parent, vnode);
            }, parentSuspense);
            if (__VUE_PROD_DEVTOOLS__) // Update components tree
            $0a6cc4ba868319ae$var$devtoolsComponentAdded(instance);
        };
        sharedContext.deactivate = (vnode)=>{
            const instance = vnode.component;
            move(vnode, storageContainer, null, 1 /* MoveType.LEAVE */ , parentSuspense);
            $0a6cc4ba868319ae$var$queuePostRenderEffect(()=>{
                if (instance.da) (0, $8POXm.invokeArrayFns)(instance.da);
                const vnodeHook = vnode.props && vnode.props.onVnodeUnmounted;
                if (vnodeHook) $0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHook, instance.parent, vnode);
                instance.isDeactivated = true;
            }, parentSuspense);
            if (__VUE_PROD_DEVTOOLS__) // Update components tree
            $0a6cc4ba868319ae$var$devtoolsComponentAdded(instance);
        };
        function unmount(vnode) {
            // reset the shapeFlag so it can be properly unmounted
            $0a6cc4ba868319ae$var$resetShapeFlag(vnode);
            _unmount(vnode, instance, parentSuspense, true);
        }
        function pruneCache(filter) {
            cache.forEach((vnode, key)=>{
                const name = $0a6cc4ba868319ae$var$getComponentName(vnode.type);
                if (name && (!filter || !filter(name))) pruneCacheEntry(key);
            });
        }
        function pruneCacheEntry(key) {
            const cached = cache.get(key);
            if (!current || cached.type !== current.type) unmount(cached);
            else if (current) // current active instance should no longer be kept-alive.
            // we can't unmount it now but it might be later, so reset its flag now.
            $0a6cc4ba868319ae$var$resetShapeFlag(current);
            cache.delete(key);
            keys.delete(key);
        }
        // prune cache on include/exclude prop change
        $0a6cc4ba868319ae$export$3db5d71bdb2d5499(()=>[
                props.include,
                props.exclude
            ], ([include, exclude])=>{
            include && pruneCache((name)=>$0a6cc4ba868319ae$var$matches(include, name));
            exclude && pruneCache((name)=>!$0a6cc4ba868319ae$var$matches(exclude, name));
        }, // prune post-render after `current` has been updated
        {
            flush: 'post',
            deep: true
        });
        // cache sub tree after render
        let pendingCacheKey = null;
        const cacheSubtree = ()=>{
            // fix #1621, the pendingCacheKey could be 0
            if (pendingCacheKey != null) cache.set(pendingCacheKey, $0a6cc4ba868319ae$var$getInnerChild(instance.subTree));
        };
        $0a6cc4ba868319ae$export$6d1641039221b5cb(cacheSubtree);
        $0a6cc4ba868319ae$export$5876c47052fb88b1(cacheSubtree);
        $0a6cc4ba868319ae$export$40c420df62d2614(()=>{
            cache.forEach((cached)=>{
                const { subTree: subTree, suspense: suspense } = instance;
                const vnode = $0a6cc4ba868319ae$var$getInnerChild(subTree);
                if (cached.type === vnode.type) {
                    // current instance will be unmounted as part of keep-alive's unmount
                    $0a6cc4ba868319ae$var$resetShapeFlag(vnode);
                    // but invoke its deactivated hook here
                    const da = vnode.component.da;
                    da && $0a6cc4ba868319ae$var$queuePostRenderEffect(da, suspense);
                    return;
                }
                unmount(cached);
            });
        });
        return ()=>{
            pendingCacheKey = null;
            if (!slots.default) return null;
            const children = slots.default();
            const rawVNode = children[0];
            if (children.length > 1) {
                current = null;
                return children;
            } else if (!$0a6cc4ba868319ae$export$3868d13f8734ae81(rawVNode) || !(rawVNode.shapeFlag & 4 /* ShapeFlags.STATEFUL_COMPONENT */ ) && !(rawVNode.shapeFlag & 128 /* ShapeFlags.SUSPENSE */ )) {
                current = null;
                return rawVNode;
            }
            let vnode = $0a6cc4ba868319ae$var$getInnerChild(rawVNode);
            const comp = vnode.type;
            // for async components, name check should be based in its loaded
            // inner component if available
            const name = $0a6cc4ba868319ae$var$getComponentName($0a6cc4ba868319ae$var$isAsyncWrapper(vnode) ? vnode.type.__asyncResolved || {} : comp);
            const { include: include, exclude: exclude, max: max } = props;
            if (include && (!name || !$0a6cc4ba868319ae$var$matches(include, name)) || exclude && name && $0a6cc4ba868319ae$var$matches(exclude, name)) {
                current = vnode;
                return rawVNode;
            }
            const key = vnode.key == null ? comp : vnode.key;
            const cachedVNode = cache.get(key);
            // clone vnode if it's reused because we are going to mutate it
            if (vnode.el) {
                vnode = $0a6cc4ba868319ae$export$ee4f9e12c0a92a1a(vnode);
                if (rawVNode.shapeFlag & 128 /* ShapeFlags.SUSPENSE */ ) rawVNode.ssContent = vnode;
            }
            // #1513 it's possible for the returned vnode to be cloned due to attr
            // fallthrough or scopeId, so the vnode here may not be the final vnode
            // that is mounted. Instead of caching it directly, we store the pending
            // key and cache `instance.subTree` (the normalized vnode) in
            // beforeMount/beforeUpdate hooks.
            pendingCacheKey = key;
            if (cachedVNode) {
                // copy over mounted state
                vnode.el = cachedVNode.el;
                vnode.component = cachedVNode.component;
                if (vnode.transition) // recursively update transition hooks on subTree
                $0a6cc4ba868319ae$export$7770a22486565649(vnode, vnode.transition);
                // avoid vnode being mounted as fresh
                vnode.shapeFlag |= 512 /* ShapeFlags.COMPONENT_KEPT_ALIVE */ ;
                // make this key the freshest
                keys.delete(key);
                keys.add(key);
            } else {
                keys.add(key);
                // prune oldest entry
                if (max && keys.size > parseInt(max, 10)) pruneCacheEntry(keys.values().next().value);
            }
            // avoid vnode being unmounted
            vnode.shapeFlag |= 256 /* ShapeFlags.COMPONENT_SHOULD_KEEP_ALIVE */ ;
            current = vnode;
            return $0a6cc4ba868319ae$var$isSuspense(rawVNode.type) ? rawVNode : vnode;
        };
    }
};
// export the public type for h/tsx inference
// also to avoid inline import() in generated d.ts files
const $0a6cc4ba868319ae$export$70eb8a58709972df = $0a6cc4ba868319ae$var$KeepAliveImpl;
function $0a6cc4ba868319ae$var$matches(pattern, name) {
    if ((0, $8POXm.isArray)(pattern)) return pattern.some((p)=>$0a6cc4ba868319ae$var$matches(p, name));
    else if ((0, $8POXm.isString)(pattern)) return pattern.split(',').includes(name);
    else if (pattern.test) return pattern.test(name);
    /* istanbul ignore next */ return false;
}
function $0a6cc4ba868319ae$export$ba52d824b95a2154(hook, target) {
    $0a6cc4ba868319ae$var$registerKeepAliveHook(hook, "a" /* LifecycleHooks.ACTIVATED */ , target);
}
function $0a6cc4ba868319ae$export$bf1440eeaf5fa709(hook, target) {
    $0a6cc4ba868319ae$var$registerKeepAliveHook(hook, "da" /* LifecycleHooks.DEACTIVATED */ , target);
}
function $0a6cc4ba868319ae$var$registerKeepAliveHook(hook, type, target = $0a6cc4ba868319ae$var$currentInstance) {
    // cache the deactivate branch check wrapper for injected hooks so the same
    // hook can be properly deduped by the scheduler. "__wdc" stands for "with
    // deactivation check".
    const wrappedHook = hook.__wdc || (hook.__wdc = ()=>{
        // only fire the hook if the target instance is NOT in a deactivated branch.
        let current = target;
        while(current){
            if (current.isDeactivated) return;
            current = current.parent;
        }
        return hook();
    });
    $0a6cc4ba868319ae$var$injectHook(type, wrappedHook, target);
    // In addition to registering it on the target instance, we walk up the parent
    // chain and register it on all ancestor instances that are keep-alive roots.
    // This avoids the need to walk the entire component tree when invoking these
    // hooks, and more importantly, avoids the need to track child components in
    // arrays.
    if (target) {
        let current = target.parent;
        while(current && current.parent){
            if ($0a6cc4ba868319ae$var$isKeepAlive(current.parent.vnode)) $0a6cc4ba868319ae$var$injectToKeepAliveRoot(wrappedHook, type, target, current);
            current = current.parent;
        }
    }
}
function $0a6cc4ba868319ae$var$injectToKeepAliveRoot(hook, type, target, keepAliveRoot) {
    // injectHook wraps the original for error handling, so make sure to remove
    // the wrapped version.
    const injected = $0a6cc4ba868319ae$var$injectHook(type, hook, keepAliveRoot, true);
    $0a6cc4ba868319ae$export$13348a43ccacfe58(()=>{
        (0, $8POXm.remove)(keepAliveRoot[type], injected);
    }, target);
}
function $0a6cc4ba868319ae$var$resetShapeFlag(vnode) {
    let shapeFlag = vnode.shapeFlag;
    if (shapeFlag & 256 /* ShapeFlags.COMPONENT_SHOULD_KEEP_ALIVE */ ) shapeFlag -= 256 /* ShapeFlags.COMPONENT_SHOULD_KEEP_ALIVE */ ;
    if (shapeFlag & 512 /* ShapeFlags.COMPONENT_KEPT_ALIVE */ ) shapeFlag -= 512 /* ShapeFlags.COMPONENT_KEPT_ALIVE */ ;
    vnode.shapeFlag = shapeFlag;
}
function $0a6cc4ba868319ae$var$getInnerChild(vnode) {
    return vnode.shapeFlag & 128 /* ShapeFlags.SUSPENSE */  ? vnode.ssContent : vnode;
}
function $0a6cc4ba868319ae$var$injectHook(type, hook, target = $0a6cc4ba868319ae$var$currentInstance, prepend = false) {
    if (target) {
        const hooks = target[type] || (target[type] = []);
        // cache the error handling wrapper for injected hooks so the same hook
        // can be properly deduped by the scheduler. "__weh" stands for "with error
        // handling".
        const wrappedHook = hook.__weh || (hook.__weh = (...args)=>{
            if (target.isUnmounted) return;
            // disable tracking inside all lifecycle hooks
            // since they can potentially be called inside effects.
            (0, $01W3b.pauseTracking)();
            // Set currentInstance during hook invocation.
            // This assumes the hook does not synchronously trigger other hooks, which
            // can only be false when the user does something really funky.
            $0a6cc4ba868319ae$var$setCurrentInstance(target);
            const res = $0a6cc4ba868319ae$export$dae85862a8d94378(hook, target, type, args);
            $0a6cc4ba868319ae$var$unsetCurrentInstance();
            (0, $01W3b.resetTracking)();
            return res;
        });
        if (prepend) hooks.unshift(wrappedHook);
        else hooks.push(wrappedHook);
        return wrappedHook;
    }
}
const $0a6cc4ba868319ae$var$createHook = (lifecycle)=>(hook, target = $0a6cc4ba868319ae$var$currentInstance)=>// post-create lifecycle registrations are noops during SSR (except for serverPrefetch)
        (!$0a6cc4ba868319ae$var$isInSSRComponentSetup || lifecycle === "sp" /* LifecycleHooks.SERVER_PREFETCH */ ) && $0a6cc4ba868319ae$var$injectHook(lifecycle, hook, target);
const $0a6cc4ba868319ae$export$23b7aeb0d671f804 = $0a6cc4ba868319ae$var$createHook("bm" /* LifecycleHooks.BEFORE_MOUNT */ );
const $0a6cc4ba868319ae$export$6d1641039221b5cb = $0a6cc4ba868319ae$var$createHook("m" /* LifecycleHooks.MOUNTED */ );
const $0a6cc4ba868319ae$export$ab91988a13872e4c = $0a6cc4ba868319ae$var$createHook("bu" /* LifecycleHooks.BEFORE_UPDATE */ );
const $0a6cc4ba868319ae$export$5876c47052fb88b1 = $0a6cc4ba868319ae$var$createHook("u" /* LifecycleHooks.UPDATED */ );
const $0a6cc4ba868319ae$export$40c420df62d2614 = $0a6cc4ba868319ae$var$createHook("bum" /* LifecycleHooks.BEFORE_UNMOUNT */ );
const $0a6cc4ba868319ae$export$13348a43ccacfe58 = $0a6cc4ba868319ae$var$createHook("um" /* LifecycleHooks.UNMOUNTED */ );
const $0a6cc4ba868319ae$export$ebf0c601f267bceb = $0a6cc4ba868319ae$var$createHook("sp" /* LifecycleHooks.SERVER_PREFETCH */ );
const $0a6cc4ba868319ae$export$898295a813d662eb = $0a6cc4ba868319ae$var$createHook("rtg" /* LifecycleHooks.RENDER_TRIGGERED */ );
const $0a6cc4ba868319ae$export$2b41f4235363e921 = $0a6cc4ba868319ae$var$createHook("rtc" /* LifecycleHooks.RENDER_TRACKED */ );
function $0a6cc4ba868319ae$export$6a3a15856e50ad19(hook, target = $0a6cc4ba868319ae$var$currentInstance) {
    $0a6cc4ba868319ae$var$injectHook("ec" /* LifecycleHooks.ERROR_CAPTURED */ , hook, target);
}
/**
Runtime helper for applying directives to a vnode. Example usage:

const comp = resolveComponent('comp')
const foo = resolveDirective('foo')
const bar = resolveDirective('bar')

return withDirectives(h(comp), [
  [foo, this.x],
  [bar, this.y]
])
*/ function $0a6cc4ba868319ae$var$validateDirectiveName(name) {
    if ((0, $8POXm.isBuiltInDirective)(name)) $0a6cc4ba868319ae$export$c106dd0671a0fc2d('Do not use built-in directive ids as custom directive id: ' + name);
}
/**
 * Adds directives to a VNode.
 */ function $0a6cc4ba868319ae$export$49729353e7c1e6c5(vnode, directives) {
    const internalInstance = $0a6cc4ba868319ae$var$currentRenderingInstance;
    if (internalInstance === null) return vnode;
    const instance = $0a6cc4ba868319ae$var$getExposeProxy(internalInstance) || internalInstance.proxy;
    const bindings = vnode.dirs || (vnode.dirs = []);
    for(let i = 0; i < directives.length; i++){
        let [dir, value, arg, modifiers = (0, $8POXm.EMPTY_OBJ)] = directives[i];
        if ((0, $8POXm.isFunction)(dir)) dir = {
            mounted: dir,
            updated: dir
        };
        if (dir.deep) $0a6cc4ba868319ae$var$traverse(value);
        bindings.push({
            dir: dir,
            instance: instance,
            value: value,
            oldValue: void 0,
            arg: arg,
            modifiers: modifiers
        });
    }
    return vnode;
}
function $0a6cc4ba868319ae$var$invokeDirectiveHook(vnode, prevVNode, instance, name) {
    const bindings = vnode.dirs;
    const oldBindings = prevVNode && prevVNode.dirs;
    for(let i = 0; i < bindings.length; i++){
        const binding = bindings[i];
        if (oldBindings) binding.oldValue = oldBindings[i].value;
        let hook = binding.dir[name];
        if (hook) {
            // disable tracking inside all lifecycle hooks
            // since they can potentially be called inside effects.
            (0, $01W3b.pauseTracking)();
            $0a6cc4ba868319ae$export$dae85862a8d94378(hook, instance, 8 /* ErrorCodes.DIRECTIVE_HOOK */ , [
                vnode.el,
                binding,
                vnode,
                prevVNode
            ]);
            (0, $01W3b.resetTracking)();
        }
    }
}
const $0a6cc4ba868319ae$var$COMPONENTS = 'components';
const $0a6cc4ba868319ae$var$DIRECTIVES = 'directives';
/**
 * @private
 */ function $0a6cc4ba868319ae$export$681d65eec9d1d1e8(name, maybeSelfReference) {
    return $0a6cc4ba868319ae$var$resolveAsset($0a6cc4ba868319ae$var$COMPONENTS, name, true, maybeSelfReference) || name;
}
const $0a6cc4ba868319ae$var$NULL_DYNAMIC_COMPONENT = Symbol();
/**
 * @private
 */ function $0a6cc4ba868319ae$export$b44c564a05ca975(component) {
    if ((0, $8POXm.isString)(component)) return $0a6cc4ba868319ae$var$resolveAsset($0a6cc4ba868319ae$var$COMPONENTS, component, false) || component;
    else // invalid types will fallthrough to createVNode and raise warning
    return component || $0a6cc4ba868319ae$var$NULL_DYNAMIC_COMPONENT;
}
/**
 * @private
 */ function $0a6cc4ba868319ae$export$a1989e995cd481be(name) {
    return $0a6cc4ba868319ae$var$resolveAsset($0a6cc4ba868319ae$var$DIRECTIVES, name);
}
// implementation
function $0a6cc4ba868319ae$var$resolveAsset(type, name, warnMissing = true, maybeSelfReference = false) {
    const instance = $0a6cc4ba868319ae$var$currentRenderingInstance || $0a6cc4ba868319ae$var$currentInstance;
    if (instance) {
        const Component = instance.type;
        // explicit self name has highest priority
        if (type === $0a6cc4ba868319ae$var$COMPONENTS) {
            const selfName = $0a6cc4ba868319ae$var$getComponentName(Component, false);
            if (selfName && (selfName === name || selfName === (0, $8POXm.camelize)(name) || selfName === (0, $8POXm.capitalize)((0, $8POXm.camelize)(name)))) return Component;
        }
        const res = // local registration
        // check instance[type] first which is resolved for options API
        $0a6cc4ba868319ae$var$resolve(instance[type] || Component[type], name) || // global registration
        $0a6cc4ba868319ae$var$resolve(instance.appContext[type], name);
        if (!res && maybeSelfReference) // fallback to implicit self-reference
        return Component;
        return res;
    }
}
function $0a6cc4ba868319ae$var$resolve(registry, name) {
    return registry && (registry[name] || registry[(0, $8POXm.camelize)(name)] || registry[(0, $8POXm.capitalize)((0, $8POXm.camelize)(name))]);
}
/**
 * Actual implementation
 */ function $0a6cc4ba868319ae$export$4bf387f59bfc6d67(source, renderItem, cache, index) {
    let ret;
    const cached = cache && cache[index];
    if ((0, $8POXm.isArray)(source) || (0, $8POXm.isString)(source)) {
        ret = new Array(source.length);
        for(let i = 0, l = source.length; i < l; i++)ret[i] = renderItem(source[i], i, undefined, cached && cached[i]);
    } else if (typeof source === 'number') {
        ret = new Array(source);
        for(let i = 0; i < source; i++)ret[i] = renderItem(i + 1, i, undefined, cached && cached[i]);
    } else if ((0, $8POXm.isObject)(source)) {
        if (source[Symbol.iterator]) ret = Array.from(source, (item, i)=>renderItem(item, i, undefined, cached && cached[i]));
        else {
            const keys = Object.keys(source);
            ret = new Array(keys.length);
            for(let i = 0, l = keys.length; i < l; i++){
                const key = keys[i];
                ret[i] = renderItem(source[key], key, i, cached && cached[i]);
            }
        }
    } else ret = [];
    if (cache) cache[index] = ret;
    return ret;
}
/**
 * Compiler runtime helper for creating dynamic slots object
 * @private
 */ function $0a6cc4ba868319ae$export$85738f8fcd0a5430(slots, dynamicSlots) {
    for(let i = 0; i < dynamicSlots.length; i++){
        const slot = dynamicSlots[i];
        // array of dynamic slot generated by <template v-for="..." #[...]>
        if ((0, $8POXm.isArray)(slot)) for(let j = 0; j < slot.length; j++)slots[slot[j].name] = slot[j].fn;
        else if (slot) // conditional single slot generated by <template v-if="..." #foo>
        slots[slot.name] = slot.key ? (...args)=>{
            const res = slot.fn(...args);
            res.key = slot.key;
            return res;
        } : slot.fn;
    }
    return slots;
}
/**
 * Compiler runtime helper for rendering `<slot/>`
 * @private
 */ function $0a6cc4ba868319ae$export$4abee4c34694ada1(slots, name, props = {}, // this is not a user-facing function, so the fallback is always generated by
// the compiler and guaranteed to be a function returning an array
fallback, noSlotted) {
    if ($0a6cc4ba868319ae$var$currentRenderingInstance.isCE || $0a6cc4ba868319ae$var$currentRenderingInstance.parent && $0a6cc4ba868319ae$var$isAsyncWrapper($0a6cc4ba868319ae$var$currentRenderingInstance.parent) && $0a6cc4ba868319ae$var$currentRenderingInstance.parent.isCE) return $0a6cc4ba868319ae$export$bf5c4cf060303d58('slot', name === 'default' ? null : {
        name: name
    }, fallback && fallback());
    let slot = slots[name];
    // a compiled slot disables block tracking by default to avoid manual
    // invocation interfering with template-based block tracking, but in
    // `renderSlot` we can be sure that it's template-based so we can force
    // enable it.
    if (slot && slot._c) slot._d = false;
    $0a6cc4ba868319ae$export$e7eaa45e502fe5cc();
    const validSlotContent = slot && $0a6cc4ba868319ae$var$ensureValidVNode(slot(props));
    const rendered = $0a6cc4ba868319ae$export$9f2dfe8048dfb22b($0a6cc4ba868319ae$export$ffb0004e005737fa, {
        key: props.key || // slot content array of a dynamic conditional slot may have a branch
        // key attached in the `createSlots` helper, respect that
        validSlotContent && validSlotContent.key || `_${name}`
    }, validSlotContent || (fallback ? fallback() : []), validSlotContent && slots._ === 1 /* SlotFlags.STABLE */  ? 64 /* PatchFlags.STABLE_FRAGMENT */  : -2 /* PatchFlags.BAIL */ );
    if (!noSlotted && rendered.scopeId) rendered.slotScopeIds = [
        rendered.scopeId + '-s'
    ];
    if (slot && slot._c) slot._d = true;
    return rendered;
}
function $0a6cc4ba868319ae$var$ensureValidVNode(vnodes) {
    return vnodes.some((child)=>{
        if (!$0a6cc4ba868319ae$export$3868d13f8734ae81(child)) return true;
        if (child.type === $0a6cc4ba868319ae$export$4d299b491347818a) return false;
        if (child.type === $0a6cc4ba868319ae$export$ffb0004e005737fa && !$0a6cc4ba868319ae$var$ensureValidVNode(child.children)) return false;
        return true;
    }) ? vnodes : null;
}
/**
 * For prefixing keys in v-on="obj" with "on"
 * @private
 */ function $0a6cc4ba868319ae$export$2fb94ff667a6a1a(obj, preserveCaseIfNecessary) {
    const ret = {};
    for(const key in obj)ret[preserveCaseIfNecessary && /[A-Z]/.test(key) ? `on:${key}` : (0, $8POXm.toHandlerKey)(key)] = obj[key];
    return ret;
}
/**
 * #2437 In Vue 3, functional components do not have a public instance proxy but
 * they exist in the internal parent chain. For code that relies on traversing
 * public $parent chains, skip functional ones and go to the parent instead.
 */ const $0a6cc4ba868319ae$var$getPublicInstance = (i)=>{
    if (!i) return null;
    if ($0a6cc4ba868319ae$var$isStatefulComponent(i)) return $0a6cc4ba868319ae$var$getExposeProxy(i) || i.proxy;
    return $0a6cc4ba868319ae$var$getPublicInstance(i.parent);
};
const $0a6cc4ba868319ae$var$publicPropertiesMap = // Move PURE marker to new line to workaround compiler discarding it
// due to type annotation
/*#__PURE__*/ (0, $8POXm.extend)(Object.create(null), {
    $: (i)=>i,
    $el: (i)=>i.vnode.el,
    $data: (i)=>i.data,
    $props: (i)=>(0, i.props),
    $attrs: (i)=>(0, i.attrs),
    $slots: (i)=>(0, i.slots),
    $refs: (i)=>(0, i.refs),
    $parent: (i)=>$0a6cc4ba868319ae$var$getPublicInstance(i.parent),
    $root: (i)=>$0a6cc4ba868319ae$var$getPublicInstance(i.root),
    $emit: (i)=>i.emit,
    $options: (i)=>__VUE_OPTIONS_API__ ? $0a6cc4ba868319ae$var$resolveMergedOptions(i) : i.type,
    $forceUpdate: (i)=>i.f || (i.f = ()=>$0a6cc4ba868319ae$var$queueJob(i.update)),
    $nextTick: (i)=>i.n || (i.n = $0a6cc4ba868319ae$export$bdd553fddd433dcb.bind(i.proxy)),
    $watch: (i)=>__VUE_OPTIONS_API__ ? $0a6cc4ba868319ae$var$instanceWatch.bind(i) : (0, $8POXm.NOOP)
});
const $0a6cc4ba868319ae$var$isReservedPrefix = (key)=>key === '_' || key === '$';
const $0a6cc4ba868319ae$var$PublicInstanceProxyHandlers = {
    get ({ _: instance }, key) {
        const { ctx: ctx, setupState: setupState, data: data, props: props, accessCache: accessCache, type: type, appContext: appContext } = instance;
        // data / props / ctx
        // This getter gets called for every property access on the render context
        // during render and is a major hotspot. The most expensive part of this
        // is the multiple hasOwn() calls. It's much faster to do a simple property
        // access on a plain object, so we use an accessCache object (with null
        // prototype) to memoize what access type a key corresponds to.
        let normalizedProps;
        if (key[0] !== '$') {
            const n = accessCache[key];
            if (n !== undefined) switch(n){
                case 1 /* AccessTypes.SETUP */ :
                    return setupState[key];
                case 2 /* AccessTypes.DATA */ :
                    return data[key];
                case 4 /* AccessTypes.CONTEXT */ :
                    return ctx[key];
                case 3 /* AccessTypes.PROPS */ :
                    return props[key];
            }
            else if (setupState !== (0, $8POXm.EMPTY_OBJ) && (0, $8POXm.hasOwn)(setupState, key)) {
                accessCache[key] = 1 /* AccessTypes.SETUP */ ;
                return setupState[key];
            } else if (data !== (0, $8POXm.EMPTY_OBJ) && (0, $8POXm.hasOwn)(data, key)) {
                accessCache[key] = 2 /* AccessTypes.DATA */ ;
                return data[key];
            } else if (// only cache other properties when instance has declared (thus stable)
            // props
            (normalizedProps = instance.propsOptions[0]) && (0, $8POXm.hasOwn)(normalizedProps, key)) {
                accessCache[key] = 3 /* AccessTypes.PROPS */ ;
                return props[key];
            } else if (ctx !== (0, $8POXm.EMPTY_OBJ) && (0, $8POXm.hasOwn)(ctx, key)) {
                accessCache[key] = 4 /* AccessTypes.CONTEXT */ ;
                return ctx[key];
            } else if (!__VUE_OPTIONS_API__ || $0a6cc4ba868319ae$var$shouldCacheAccess) accessCache[key] = 0 /* AccessTypes.OTHER */ ;
        }
        const publicGetter = $0a6cc4ba868319ae$var$publicPropertiesMap[key];
        let cssModule, globalProperties;
        // public $xxx properties
        if (publicGetter) {
            if (key === '$attrs') (0, $01W3b.track)(instance, "get" /* TrackOpTypes.GET */ , key);
            return publicGetter(instance);
        } else if (// css module (injected by vue-loader)
        (cssModule = type.__cssModules) && (cssModule = cssModule[key])) return cssModule;
        else if (ctx !== (0, $8POXm.EMPTY_OBJ) && (0, $8POXm.hasOwn)(ctx, key)) {
            // user may set custom properties to `this` that start with `$`
            accessCache[key] = 4 /* AccessTypes.CONTEXT */ ;
            return ctx[key];
        } else if (// global properties
        globalProperties = appContext.config.globalProperties, (0, $8POXm.hasOwn)(globalProperties, key)) return globalProperties[key];
    },
    set ({ _: instance }, key, value) {
        const { data: data, setupState: setupState, ctx: ctx } = instance;
        if (setupState !== (0, $8POXm.EMPTY_OBJ) && (0, $8POXm.hasOwn)(setupState, key)) {
            setupState[key] = value;
            return true;
        } else if (data !== (0, $8POXm.EMPTY_OBJ) && (0, $8POXm.hasOwn)(data, key)) {
            data[key] = value;
            return true;
        } else if ((0, $8POXm.hasOwn)(instance.props, key)) return false;
        if (key[0] === '$' && key.slice(1) in instance) return false;
        else ctx[key] = value;
        return true;
    },
    has ({ _: { data: data, setupState: setupState, accessCache: accessCache, ctx: ctx, appContext: appContext, propsOptions: propsOptions } }, key) {
        let normalizedProps;
        return !!accessCache[key] || data !== (0, $8POXm.EMPTY_OBJ) && (0, $8POXm.hasOwn)(data, key) || setupState !== (0, $8POXm.EMPTY_OBJ) && (0, $8POXm.hasOwn)(setupState, key) || (normalizedProps = propsOptions[0]) && (0, $8POXm.hasOwn)(normalizedProps, key) || (0, $8POXm.hasOwn)(ctx, key) || (0, $8POXm.hasOwn)($0a6cc4ba868319ae$var$publicPropertiesMap, key) || (0, $8POXm.hasOwn)(appContext.config.globalProperties, key);
    },
    defineProperty (target, key, descriptor) {
        if (descriptor.get != null) // invalidate key cache of a getter based property #5417
        target._.accessCache[key] = 0;
        else if ((0, $8POXm.hasOwn)(descriptor, 'value')) this.set(target, key, descriptor.value, null);
        return Reflect.defineProperty(target, key, descriptor);
    }
};
var $0a6cc4ba868319ae$var$target;
const $0a6cc4ba868319ae$var$RuntimeCompiledPublicInstanceProxyHandlers = /*#__PURE__*/ (0, $8POXm.extend)({}, $0a6cc4ba868319ae$var$PublicInstanceProxyHandlers, {
    get (target, key) {
        // fast path for unscopables when using `with` block
        if (key === Symbol.unscopables) return;
        return $0a6cc4ba868319ae$var$PublicInstanceProxyHandlers.get(target, key, target);
    },
    has (_, key) {
        const has = key[0] !== '_' && !(0, $8POXm.isGloballyWhitelisted)(key);
        return has;
    }
});
// dev only
// In dev mode, the proxy target exposes the same properties as seen on `this`
// for easier console inspection. In prod mode it will be an empty object so
// these properties definitions can be skipped.
function $0a6cc4ba868319ae$var$createDevRenderContext(instance) {
    const target = {};
    // expose internal instance for proxy handlers
    Object.defineProperty(target, `_`, {
        configurable: true,
        enumerable: false,
        get: ()=>instance
    });
    // expose public properties
    Object.keys($0a6cc4ba868319ae$var$publicPropertiesMap).forEach((key)=>{
        Object.defineProperty(target, key, {
            configurable: true,
            enumerable: false,
            get: ()=>$0a6cc4ba868319ae$var$publicPropertiesMap[key](instance),
            // intercepted by the proxy so no need for implementation,
            // but needed to prevent set errors
            set: (0, $8POXm.NOOP)
        });
    });
    return target;
}
// dev only
function $0a6cc4ba868319ae$var$exposePropsOnRenderContext(instance) {
    const { ctx: ctx, propsOptions: [propsOptions] } = instance;
    if (propsOptions) Object.keys(propsOptions).forEach((key)=>{
        Object.defineProperty(ctx, key, {
            enumerable: true,
            configurable: true,
            get: ()=>instance.props[key],
            set: (0, $8POXm.NOOP)
        });
    });
}
// dev only
function $0a6cc4ba868319ae$var$exposeSetupStateOnRenderContext(instance) {
    const { ctx: ctx, setupState: setupState } = instance;
    Object.keys((0, $01W3b.toRaw)(setupState)).forEach((key)=>{
        if (!setupState.__isScriptSetup) {
            if ($0a6cc4ba868319ae$var$isReservedPrefix(key[0])) {
                $0a6cc4ba868319ae$export$c106dd0671a0fc2d(`setup() return property ${JSON.stringify(key)} should not start with "$" or "_" ` + `which are reserved prefixes for Vue internals.`);
                return;
            }
            Object.defineProperty(ctx, key, {
                enumerable: true,
                configurable: true,
                get: ()=>setupState[key],
                set: (0, $8POXm.NOOP)
            });
        }
    });
}
function $0a6cc4ba868319ae$var$createDuplicateChecker() {
    const cache = Object.create(null);
    return (type, key)=>{
        if (cache[key]) $0a6cc4ba868319ae$export$c106dd0671a0fc2d(`${type} property "${key}" is already defined in ${cache[key]}.`);
        else cache[key] = type;
    };
}
let $0a6cc4ba868319ae$var$shouldCacheAccess = true;
function $0a6cc4ba868319ae$var$applyOptions(instance) {
    const options = $0a6cc4ba868319ae$var$resolveMergedOptions(instance);
    const publicThis = instance.proxy;
    const ctx = instance.ctx;
    // do not cache property access on public proxy during state initialization
    $0a6cc4ba868319ae$var$shouldCacheAccess = false;
    // call beforeCreate first before accessing other options since
    // the hook may mutate resolved options (#2791)
    if (options.beforeCreate) $0a6cc4ba868319ae$var$callHook(options.beforeCreate, instance, "bc" /* LifecycleHooks.BEFORE_CREATE */ );
    const { // state
    data: dataOptions, computed: computedOptions, methods: methods, watch: watchOptions, provide: provideOptions, inject: injectOptions, created: // lifecycle
    created, beforeMount: beforeMount, mounted: mounted, beforeUpdate: beforeUpdate, updated: updated, activated: activated, deactivated: deactivated, beforeDestroy: beforeDestroy, beforeUnmount: beforeUnmount, destroyed: destroyed, unmounted: unmounted, render: render, renderTracked: renderTracked, renderTriggered: renderTriggered, errorCaptured: errorCaptured, serverPrefetch: serverPrefetch, expose: // public API
    expose, inheritAttrs: inheritAttrs, components: // assets
    components, directives: directives, filters: filters } = options;
    const checkDuplicateProperties = null;
    // options initialization order (to be consistent with Vue 2):
    // - props (already done outside of this function)
    // - inject
    // - methods
    // - data (deferred since it relies on `this` access)
    // - computed
    // - watch (deferred since it relies on `this` access)
    if (injectOptions) $0a6cc4ba868319ae$var$resolveInjections(injectOptions, ctx, checkDuplicateProperties, instance.appContext.config.unwrapInjectedRef);
    if (methods) for(const key in methods){
        const methodHandler = methods[key];
        if ((0, $8POXm.isFunction)(methodHandler)) ctx[key] = methodHandler.bind(publicThis);
    }
    if (dataOptions) {
        const data = dataOptions.call(publicThis, publicThis);
        if (!(0, $8POXm.isObject)(data)) ;
        else instance.data = (0, $01W3b.reactive)(data);
    }
    // state initialization complete at this point - start caching access
    $0a6cc4ba868319ae$var$shouldCacheAccess = true;
    if (computedOptions) for(const key in computedOptions){
        const opt = computedOptions[key];
        const get = (0, $8POXm.isFunction)(opt) ? opt.bind(publicThis, publicThis) : (0, $8POXm.isFunction)(opt.get) ? opt.get.bind(publicThis, publicThis) : (0, $8POXm.NOOP);
        const set = !(0, $8POXm.isFunction)(opt) && (0, $8POXm.isFunction)(opt.set) ? opt.set.bind(publicThis) : (0, $8POXm.NOOP);
        const c = $0a6cc4ba868319ae$export$2983e091f1a1e8e2({
            get: get,
            set: set
        });
        Object.defineProperty(ctx, key, {
            enumerable: true,
            configurable: true,
            get: ()=>c.value,
            set: (v1)=>c.value = v1
        });
    }
    if (watchOptions) for(const key in watchOptions)$0a6cc4ba868319ae$var$createWatcher(watchOptions[key], ctx, publicThis, key);
    if (provideOptions) {
        const provides = (0, $8POXm.isFunction)(provideOptions) ? provideOptions.call(publicThis) : provideOptions;
        Reflect.ownKeys(provides).forEach((key)=>{
            $0a6cc4ba868319ae$export$abe1e183e22e10ad(key, provides[key]);
        });
    }
    if (created) $0a6cc4ba868319ae$var$callHook(created, instance, "c" /* LifecycleHooks.CREATED */ );
    function registerLifecycleHook(register, hook) {
        if ((0, $8POXm.isArray)(hook)) hook.forEach((_hook)=>register(_hook.bind(publicThis)));
        else if (hook) register(hook.bind(publicThis));
    }
    registerLifecycleHook($0a6cc4ba868319ae$export$23b7aeb0d671f804, beforeMount);
    registerLifecycleHook($0a6cc4ba868319ae$export$6d1641039221b5cb, mounted);
    registerLifecycleHook($0a6cc4ba868319ae$export$ab91988a13872e4c, beforeUpdate);
    registerLifecycleHook($0a6cc4ba868319ae$export$5876c47052fb88b1, updated);
    registerLifecycleHook($0a6cc4ba868319ae$export$ba52d824b95a2154, activated);
    registerLifecycleHook($0a6cc4ba868319ae$export$bf1440eeaf5fa709, deactivated);
    registerLifecycleHook($0a6cc4ba868319ae$export$6a3a15856e50ad19, errorCaptured);
    registerLifecycleHook($0a6cc4ba868319ae$export$2b41f4235363e921, renderTracked);
    registerLifecycleHook($0a6cc4ba868319ae$export$898295a813d662eb, renderTriggered);
    registerLifecycleHook($0a6cc4ba868319ae$export$40c420df62d2614, beforeUnmount);
    registerLifecycleHook($0a6cc4ba868319ae$export$13348a43ccacfe58, unmounted);
    registerLifecycleHook($0a6cc4ba868319ae$export$ebf0c601f267bceb, serverPrefetch);
    if ((0, $8POXm.isArray)(expose)) {
        if (expose.length) {
            const exposed = instance.exposed || (instance.exposed = {});
            expose.forEach((key)=>{
                Object.defineProperty(exposed, key, {
                    get: ()=>publicThis[key],
                    set: (val)=>publicThis[key] = val
                });
            });
        } else if (!instance.exposed) instance.exposed = {};
    }
    // options that are handled when creating the instance but also need to be
    // applied from mixins
    if (render && instance.render === (0, $8POXm.NOOP)) instance.render = render;
    if (inheritAttrs != null) instance.inheritAttrs = inheritAttrs;
    // asset options.
    if (components) instance.components = components;
    if (directives) instance.directives = directives;
}
function $0a6cc4ba868319ae$var$resolveInjections(injectOptions, ctx, checkDuplicateProperties = (0, $8POXm.NOOP), unwrapRef = false) {
    if ((0, $8POXm.isArray)(injectOptions)) injectOptions = $0a6cc4ba868319ae$var$normalizeInject(injectOptions);
    for(const key in injectOptions){
        const opt = injectOptions[key];
        let injected;
        if ((0, $8POXm.isObject)(opt)) {
            if ('default' in opt) injected = $0a6cc4ba868319ae$export$a976684a0efeb93f(opt.from || key, opt.default, true);
            else injected = $0a6cc4ba868319ae$export$a976684a0efeb93f(opt.from || key);
        } else injected = $0a6cc4ba868319ae$export$a976684a0efeb93f(opt);
        if ((0, $01W3b.isRef)(injected)) {
            // TODO remove the check in 3.3
            if (unwrapRef) Object.defineProperty(ctx, key, {
                enumerable: true,
                configurable: true,
                get: ()=>injected.value,
                set: (v1)=>injected.value = v1
            });
            else ctx[key] = injected;
        } else ctx[key] = injected;
    }
}
function $0a6cc4ba868319ae$var$callHook(hook, instance, type) {
    $0a6cc4ba868319ae$export$dae85862a8d94378((0, $8POXm.isArray)(hook) ? hook.map((h)=>h.bind(instance.proxy)) : hook.bind(instance.proxy), instance, type);
}
function $0a6cc4ba868319ae$var$createWatcher(raw, ctx, publicThis, key) {
    const getter = key.includes('.') ? $0a6cc4ba868319ae$var$createPathGetter(publicThis, key) : ()=>publicThis[key];
    if ((0, $8POXm.isString)(raw)) {
        const handler = ctx[raw];
        if ((0, $8POXm.isFunction)(handler)) $0a6cc4ba868319ae$export$3db5d71bdb2d5499(getter, handler);
    } else if ((0, $8POXm.isFunction)(raw)) $0a6cc4ba868319ae$export$3db5d71bdb2d5499(getter, raw.bind(publicThis));
    else if ((0, $8POXm.isObject)(raw)) {
        if ((0, $8POXm.isArray)(raw)) raw.forEach((r)=>$0a6cc4ba868319ae$var$createWatcher(r, ctx, publicThis, key));
        else {
            const handler = (0, $8POXm.isFunction)(raw.handler) ? raw.handler.bind(publicThis) : ctx[raw.handler];
            if ((0, $8POXm.isFunction)(handler)) $0a6cc4ba868319ae$export$3db5d71bdb2d5499(getter, handler, raw);
        }
    } else ;
}
/**
 * Resolve merged options and cache it on the component.
 * This is done only once per-component since the merging does not involve
 * instances.
 */ function $0a6cc4ba868319ae$var$resolveMergedOptions(instance) {
    const base = instance.type;
    const { mixins: mixins, extends: extendsOptions } = base;
    const { mixins: globalMixins, optionsCache: cache, config: { optionMergeStrategies: optionMergeStrategies } } = instance.appContext;
    const cached = cache.get(base);
    let resolved;
    if (cached) resolved = cached;
    else if (!globalMixins.length && !mixins && !extendsOptions) resolved = base;
    else {
        resolved = {};
        if (globalMixins.length) globalMixins.forEach((m)=>$0a6cc4ba868319ae$var$mergeOptions(resolved, m, optionMergeStrategies, true));
        $0a6cc4ba868319ae$var$mergeOptions(resolved, base, optionMergeStrategies);
    }
    if ((0, $8POXm.isObject)(base)) cache.set(base, resolved);
    return resolved;
}
function $0a6cc4ba868319ae$var$mergeOptions(to, from, strats, asMixin = false) {
    const { mixins: mixins, extends: extendsOptions } = from;
    if (extendsOptions) $0a6cc4ba868319ae$var$mergeOptions(to, extendsOptions, strats, true);
    if (mixins) mixins.forEach((m)=>$0a6cc4ba868319ae$var$mergeOptions(to, m, strats, true));
    for(const key in from){
        if (asMixin && key === 'expose') ;
        else {
            const strat = $0a6cc4ba868319ae$var$internalOptionMergeStrats[key] || strats && strats[key];
            to[key] = strat ? strat(to[key], from[key]) : from[key];
        }
    }
    return to;
}
const $0a6cc4ba868319ae$var$internalOptionMergeStrats = {
    data: $0a6cc4ba868319ae$var$mergeDataFn,
    props: $0a6cc4ba868319ae$var$mergeObjectOptions,
    emits: $0a6cc4ba868319ae$var$mergeObjectOptions,
    // objects
    methods: $0a6cc4ba868319ae$var$mergeObjectOptions,
    computed: $0a6cc4ba868319ae$var$mergeObjectOptions,
    // lifecycle
    beforeCreate: $0a6cc4ba868319ae$var$mergeAsArray,
    created: $0a6cc4ba868319ae$var$mergeAsArray,
    beforeMount: $0a6cc4ba868319ae$var$mergeAsArray,
    mounted: $0a6cc4ba868319ae$var$mergeAsArray,
    beforeUpdate: $0a6cc4ba868319ae$var$mergeAsArray,
    updated: $0a6cc4ba868319ae$var$mergeAsArray,
    beforeDestroy: $0a6cc4ba868319ae$var$mergeAsArray,
    beforeUnmount: $0a6cc4ba868319ae$var$mergeAsArray,
    destroyed: $0a6cc4ba868319ae$var$mergeAsArray,
    unmounted: $0a6cc4ba868319ae$var$mergeAsArray,
    activated: $0a6cc4ba868319ae$var$mergeAsArray,
    deactivated: $0a6cc4ba868319ae$var$mergeAsArray,
    errorCaptured: $0a6cc4ba868319ae$var$mergeAsArray,
    serverPrefetch: $0a6cc4ba868319ae$var$mergeAsArray,
    // assets
    components: $0a6cc4ba868319ae$var$mergeObjectOptions,
    directives: $0a6cc4ba868319ae$var$mergeObjectOptions,
    // watch
    watch: $0a6cc4ba868319ae$var$mergeWatchOptions,
    // provide / inject
    provide: $0a6cc4ba868319ae$var$mergeDataFn,
    inject: $0a6cc4ba868319ae$var$mergeInject
};
function $0a6cc4ba868319ae$var$mergeDataFn(to, from) {
    if (!from) return to;
    if (!to) return from;
    return function mergedDataFn() {
        return (0, $8POXm.extend)((0, $8POXm.isFunction)(to) ? to.call(this, this) : to, (0, $8POXm.isFunction)(from) ? from.call(this, this) : from);
    };
}
function $0a6cc4ba868319ae$var$mergeInject(to, from) {
    return $0a6cc4ba868319ae$var$mergeObjectOptions($0a6cc4ba868319ae$var$normalizeInject(to), $0a6cc4ba868319ae$var$normalizeInject(from));
}
function $0a6cc4ba868319ae$var$normalizeInject(raw) {
    if ((0, $8POXm.isArray)(raw)) {
        const res = {};
        for(let i = 0; i < raw.length; i++)res[raw[i]] = raw[i];
        return res;
    }
    return raw;
}
function $0a6cc4ba868319ae$var$mergeAsArray(to, from) {
    return to ? [
        ...new Set([].concat(to, from))
    ] : from;
}
function $0a6cc4ba868319ae$var$mergeObjectOptions(to, from) {
    return to ? (0, $8POXm.extend)((0, $8POXm.extend)(Object.create(null), to), from) : from;
}
function $0a6cc4ba868319ae$var$mergeWatchOptions(to, from) {
    if (!to) return from;
    if (!from) return to;
    const merged = (0, $8POXm.extend)(Object.create(null), to);
    for(const key in from)merged[key] = $0a6cc4ba868319ae$var$mergeAsArray(to[key], from[key]);
    return merged;
}
function $0a6cc4ba868319ae$var$initProps(instance, rawProps, isStateful, isSSR = false) {
    const props = {};
    const attrs = {};
    (0, $8POXm.def)(attrs, $0a6cc4ba868319ae$var$InternalObjectKey, 1);
    instance.propsDefaults = Object.create(null);
    $0a6cc4ba868319ae$var$setFullProps(instance, rawProps, props, attrs);
    // ensure all declared prop keys are present
    for(const key in instance.propsOptions[0])if (!(key in props)) props[key] = undefined;
    if (isStateful) // stateful
    instance.props = isSSR ? props : (0, $01W3b.shallowReactive)(props);
    else if (!instance.type.props) // functional w/ optional props, props === attrs
    instance.props = attrs;
    else // functional w/ declared props
    instance.props = props;
    instance.attrs = attrs;
}
function $0a6cc4ba868319ae$var$isInHmrContext(instance) {
    while(instance){
        if (instance.type.__hmrId) return true;
        instance = instance.parent;
    }
}
function $0a6cc4ba868319ae$var$updateProps(instance, rawProps, rawPrevProps, optimized) {
    const { props: props, attrs: attrs, vnode: { patchFlag: patchFlag } } = instance;
    const rawCurrentProps = (0, $01W3b.toRaw)(props);
    const [options] = instance.propsOptions;
    let hasAttrsChanged = false;
    if (// always force full diff in dev
    // - #1942 if hmr is enabled with sfc component
    // - vite#872 non-sfc component used by sfc component
    (optimized || patchFlag > 0) && !(patchFlag & 16 /* PatchFlags.FULL_PROPS */ )) {
        if (patchFlag & 8 /* PatchFlags.PROPS */ ) {
            // Compiler-generated props & no keys change, just set the updated
            // the props.
            const propsToUpdate = instance.vnode.dynamicProps;
            for(let i = 0; i < propsToUpdate.length; i++){
                let key = propsToUpdate[i];
                // skip if the prop key is a declared emit event listener
                if ($0a6cc4ba868319ae$var$isEmitListener(instance.emitsOptions, key)) continue;
                // PROPS flag guarantees rawProps to be non-null
                const value = rawProps[key];
                if (options) {
                    // attr / props separation was done on init and will be consistent
                    // in this code path, so just check if attrs have it.
                    if ((0, $8POXm.hasOwn)(attrs, key)) {
                        if (value !== attrs[key]) {
                            attrs[key] = value;
                            hasAttrsChanged = true;
                        }
                    } else {
                        const camelizedKey = (0, $8POXm.camelize)(key);
                        props[camelizedKey] = $0a6cc4ba868319ae$var$resolvePropValue(options, rawCurrentProps, camelizedKey, value, instance, false);
                    }
                } else if (value !== attrs[key]) {
                    attrs[key] = value;
                    hasAttrsChanged = true;
                }
            }
        }
    } else {
        // full props update.
        if ($0a6cc4ba868319ae$var$setFullProps(instance, rawProps, props, attrs)) hasAttrsChanged = true;
        // in case of dynamic props, check if we need to delete keys from
        // the props object
        let kebabKey;
        for(const key in rawCurrentProps)if (!rawProps || // for camelCase
        !(0, $8POXm.hasOwn)(rawProps, key) && // it's possible the original props was passed in as kebab-case
        // and converted to camelCase (#955)
        ((kebabKey = (0, $8POXm.hyphenate)(key)) === key || !(0, $8POXm.hasOwn)(rawProps, kebabKey))) {
            if (options) {
                if (rawPrevProps && // for camelCase
                (rawPrevProps[key] !== undefined || // for kebab-case
                rawPrevProps[kebabKey] !== undefined)) props[key] = $0a6cc4ba868319ae$var$resolvePropValue(options, rawCurrentProps, key, undefined, instance, true);
            } else delete props[key];
        }
        // in the case of functional component w/o props declaration, props and
        // attrs point to the same object so it should already have been updated.
        if (attrs !== rawCurrentProps) {
            for(const key in attrs)if (!rawProps || !(0, $8POXm.hasOwn)(rawProps, key) && true) {
                delete attrs[key];
                hasAttrsChanged = true;
            }
        }
    }
    // trigger updates for $attrs in case it's used in component slots
    if (hasAttrsChanged) (0, $01W3b.trigger)(instance, "set" /* TriggerOpTypes.SET */ , '$attrs');
}
function $0a6cc4ba868319ae$var$setFullProps(instance, rawProps, props, attrs) {
    const [options, needCastKeys] = instance.propsOptions;
    let hasAttrsChanged = false;
    let rawCastValues;
    if (rawProps) for(let key in rawProps){
        // key, ref are reserved and never passed down
        if ((0, $8POXm.isReservedProp)(key)) continue;
        const value = rawProps[key];
        // prop option names are camelized during normalization, so to support
        // kebab -> camel conversion here we need to camelize the key.
        let camelKey;
        if (options && (0, $8POXm.hasOwn)(options, camelKey = (0, $8POXm.camelize)(key))) {
            if (!needCastKeys || !needCastKeys.includes(camelKey)) props[camelKey] = value;
            else (rawCastValues || (rawCastValues = {}))[camelKey] = value;
        } else if (!$0a6cc4ba868319ae$var$isEmitListener(instance.emitsOptions, key)) {
            if (!(key in attrs) || value !== attrs[key]) {
                attrs[key] = value;
                hasAttrsChanged = true;
            }
        }
    }
    if (needCastKeys) {
        const rawCurrentProps = (0, $01W3b.toRaw)(props);
        const castValues = rawCastValues || (0, $8POXm.EMPTY_OBJ);
        for(let i = 0; i < needCastKeys.length; i++){
            const key = needCastKeys[i];
            props[key] = $0a6cc4ba868319ae$var$resolvePropValue(options, rawCurrentProps, key, castValues[key], instance, !(0, $8POXm.hasOwn)(castValues, key));
        }
    }
    return hasAttrsChanged;
}
function $0a6cc4ba868319ae$var$resolvePropValue(options, props, key, value, instance, isAbsent) {
    const opt = options[key];
    if (opt != null) {
        const hasDefault = (0, $8POXm.hasOwn)(opt, 'default');
        // default values
        if (hasDefault && value === undefined) {
            const defaultValue = opt.default;
            if (opt.type !== Function && (0, $8POXm.isFunction)(defaultValue)) {
                const { propsDefaults: propsDefaults } = instance;
                if (key in propsDefaults) value = propsDefaults[key];
                else {
                    $0a6cc4ba868319ae$var$setCurrentInstance(instance);
                    value = propsDefaults[key] = defaultValue.call(null, props);
                    $0a6cc4ba868319ae$var$unsetCurrentInstance();
                }
            } else value = defaultValue;
        }
        // boolean casting
        if (opt[0 /* BooleanFlags.shouldCast */ ]) {
            if (isAbsent && !hasDefault) value = false;
            else if (opt[1 /* BooleanFlags.shouldCastTrue */ ] && (value === '' || value === (0, $8POXm.hyphenate)(key))) value = true;
        }
    }
    return value;
}
function $0a6cc4ba868319ae$var$normalizePropsOptions(comp, appContext, asMixin = false) {
    const cache = appContext.propsCache;
    const cached = cache.get(comp);
    if (cached) return cached;
    const raw = comp.props;
    const normalized = {};
    const needCastKeys = [];
    // apply mixin/extends props
    let hasExtends = false;
    if (__VUE_OPTIONS_API__ && !(0, $8POXm.isFunction)(comp)) {
        const extendProps = (raw)=>{
            hasExtends = true;
            const [props, keys] = $0a6cc4ba868319ae$var$normalizePropsOptions(raw, appContext, true);
            (0, $8POXm.extend)(normalized, props);
            if (keys) needCastKeys.push(...keys);
        };
        if (!asMixin && appContext.mixins.length) appContext.mixins.forEach(extendProps);
        if (comp.extends) extendProps(comp.extends);
        if (comp.mixins) comp.mixins.forEach(extendProps);
    }
    if (!raw && !hasExtends) {
        if ((0, $8POXm.isObject)(comp)) cache.set(comp, (0, $8POXm.EMPTY_ARR));
        return 0, $8POXm.EMPTY_ARR;
    }
    if ((0, $8POXm.isArray)(raw)) for(let i = 0; i < raw.length; i++){
        const normalizedKey = (0, $8POXm.camelize)(raw[i]);
        if ($0a6cc4ba868319ae$var$validatePropName(normalizedKey)) normalized[normalizedKey] = (0, $8POXm.EMPTY_OBJ);
    }
    else if (raw) for(const key in raw){
        const normalizedKey = (0, $8POXm.camelize)(key);
        if ($0a6cc4ba868319ae$var$validatePropName(normalizedKey)) {
            const opt = raw[key];
            const prop = normalized[normalizedKey] = (0, $8POXm.isArray)(opt) || (0, $8POXm.isFunction)(opt) ? {
                type: opt
            } : opt;
            if (prop) {
                const booleanIndex = $0a6cc4ba868319ae$var$getTypeIndex(Boolean, prop.type);
                const stringIndex = $0a6cc4ba868319ae$var$getTypeIndex(String, prop.type);
                prop[0 /* BooleanFlags.shouldCast */ ] = booleanIndex > -1;
                prop[1 /* BooleanFlags.shouldCastTrue */ ] = stringIndex < 0 || booleanIndex < stringIndex;
                // if the prop needs boolean casting or default value
                if (booleanIndex > -1 || (0, $8POXm.hasOwn)(prop, 'default')) needCastKeys.push(normalizedKey);
            }
        }
    }
    const res = [
        normalized,
        needCastKeys
    ];
    if ((0, $8POXm.isObject)(comp)) cache.set(comp, res);
    return res;
}
function $0a6cc4ba868319ae$var$validatePropName(key) {
    if (key[0] !== '$') return true;
    return false;
}
// use function string name to check type constructors
// so that it works across vms / iframes.
function $0a6cc4ba868319ae$var$getType(ctor) {
    const match = ctor && ctor.toString().match(/^\s*function (\w+)/);
    return match ? match[1] : ctor === null ? 'null' : '';
}
function $0a6cc4ba868319ae$var$isSameType(a, b) {
    return $0a6cc4ba868319ae$var$getType(a) === $0a6cc4ba868319ae$var$getType(b);
}
function $0a6cc4ba868319ae$var$getTypeIndex(type, expectedTypes) {
    if ((0, $8POXm.isArray)(expectedTypes)) return expectedTypes.findIndex((t)=>$0a6cc4ba868319ae$var$isSameType(t, type));
    else if ((0, $8POXm.isFunction)(expectedTypes)) return $0a6cc4ba868319ae$var$isSameType(expectedTypes, type) ? 0 : -1;
    return -1;
}
/**
 * dev only
 */ function $0a6cc4ba868319ae$var$validateProps(rawProps, props, instance) {
    const resolvedValues = (0, $01W3b.toRaw)(props);
    const options = instance.propsOptions[0];
    for(const key in options){
        let opt = options[key];
        if (opt == null) continue;
        $0a6cc4ba868319ae$var$validateProp(key, resolvedValues[key], opt, !(0, $8POXm.hasOwn)(rawProps, key) && !(0, $8POXm.hasOwn)(rawProps, (0, $8POXm.hyphenate)(key)));
    }
}
/**
 * dev only
 */ function $0a6cc4ba868319ae$var$validateProp(name, value, prop, isAbsent) {
    const { type: type, required: required, validator: validator } = prop;
    // required!
    if (required && isAbsent) {
        $0a6cc4ba868319ae$export$c106dd0671a0fc2d('Missing required prop: "' + name + '"');
        return;
    }
    // missing but optional
    if (value == null && !prop.required) return;
    // type check
    if (type != null && type !== true) {
        let isValid = false;
        const types = (0, $8POXm.isArray)(type) ? type : [
            type
        ];
        const expectedTypes = [];
        // value is valid as long as one of the specified types match
        for(let i = 0; i < types.length && !isValid; i++){
            const { valid: valid, expectedType: expectedType } = $0a6cc4ba868319ae$var$assertType(value, types[i]);
            expectedTypes.push(expectedType || '');
            isValid = valid;
        }
        if (!isValid) {
            $0a6cc4ba868319ae$export$c106dd0671a0fc2d($0a6cc4ba868319ae$var$getInvalidTypeMessage(name, value, expectedTypes));
            return;
        }
    }
    // custom validator
    if (validator && !validator(value)) $0a6cc4ba868319ae$export$c106dd0671a0fc2d('Invalid prop: custom validator check failed for prop "' + name + '".');
}
const $0a6cc4ba868319ae$var$isSimpleType = /*#__PURE__*/ (0, $8POXm.makeMap)('String,Number,Boolean,Function,Symbol,BigInt');
/**
 * dev only
 */ function $0a6cc4ba868319ae$var$assertType(value, type) {
    let valid;
    const expectedType = $0a6cc4ba868319ae$var$getType(type);
    if ($0a6cc4ba868319ae$var$isSimpleType(expectedType)) {
        const t = typeof value;
        valid = t === expectedType.toLowerCase();
        // for primitive wrapper objects
        if (!valid && t === 'object') valid = value instanceof type;
    } else if (expectedType === 'Object') valid = (0, $8POXm.isObject)(value);
    else if (expectedType === 'Array') valid = (0, $8POXm.isArray)(value);
    else if (expectedType === 'null') valid = value === null;
    else valid = value instanceof type;
    return {
        valid: valid,
        expectedType: expectedType
    };
}
/**
 * dev only
 */ function $0a6cc4ba868319ae$var$getInvalidTypeMessage(name, value, expectedTypes) {
    let message = `Invalid prop: type check failed for prop "${name}".` + ` Expected ${expectedTypes.map((0, $8POXm.capitalize)).join(' | ')}`;
    const expectedType = expectedTypes[0];
    const receivedType = (0, $8POXm.toRawType)(value);
    const expectedValue = $0a6cc4ba868319ae$var$styleValue(value, expectedType);
    const receivedValue = $0a6cc4ba868319ae$var$styleValue(value, receivedType);
    // check if we need to specify expected value
    if (expectedTypes.length === 1 && $0a6cc4ba868319ae$var$isExplicable(expectedType) && !$0a6cc4ba868319ae$var$isBoolean(expectedType, receivedType)) message += ` with value ${expectedValue}`;
    message += `, got ${receivedType} `;
    // check if we need to specify received value
    if ($0a6cc4ba868319ae$var$isExplicable(receivedType)) message += `with value ${receivedValue}.`;
    return message;
}
/**
 * dev only
 */ function $0a6cc4ba868319ae$var$styleValue(value, type) {
    if (type === 'String') return `"${value}"`;
    else if (type === 'Number') return `${Number(value)}`;
    else return `${value}`;
}
/**
 * dev only
 */ function $0a6cc4ba868319ae$var$isExplicable(type) {
    const explicitTypes = [
        'string',
        'number',
        'boolean'
    ];
    return explicitTypes.some((elem)=>type.toLowerCase() === elem);
}
/**
 * dev only
 */ function $0a6cc4ba868319ae$var$isBoolean(...args) {
    return args.some((elem)=>elem.toLowerCase() === 'boolean');
}
const $0a6cc4ba868319ae$var$isInternalKey = (key)=>key[0] === '_' || key === '$stable';
const $0a6cc4ba868319ae$var$normalizeSlotValue = (value)=>(0, $8POXm.isArray)(value) ? value.map($0a6cc4ba868319ae$var$normalizeVNode) : [
        $0a6cc4ba868319ae$var$normalizeVNode(value)
    ];
const $0a6cc4ba868319ae$var$normalizeSlot = (key, rawSlot, ctx)=>{
    if (rawSlot._n) // already normalized - #5353
    return rawSlot;
    const normalized = $0a6cc4ba868319ae$export$694b237e827a3d23((...args)=>{
        return $0a6cc4ba868319ae$var$normalizeSlotValue(rawSlot(...args));
    }, ctx);
    normalized._c = false;
    return normalized;
};
const $0a6cc4ba868319ae$var$normalizeObjectSlots = (rawSlots, slots, instance)=>{
    const ctx = rawSlots._ctx;
    for(const key in rawSlots){
        if ($0a6cc4ba868319ae$var$isInternalKey(key)) continue;
        const value = rawSlots[key];
        if ((0, $8POXm.isFunction)(value)) slots[key] = $0a6cc4ba868319ae$var$normalizeSlot(key, value, ctx);
        else if (value != null) {
            const normalized = $0a6cc4ba868319ae$var$normalizeSlotValue(value);
            slots[key] = ()=>normalized;
        }
    }
};
const $0a6cc4ba868319ae$var$normalizeVNodeSlots = (instance, children)=>{
    const normalized = $0a6cc4ba868319ae$var$normalizeSlotValue(children);
    instance.slots.default = ()=>normalized;
};
const $0a6cc4ba868319ae$var$initSlots = (instance, children)=>{
    if (instance.vnode.shapeFlag & 32 /* ShapeFlags.SLOTS_CHILDREN */ ) {
        const type = children._;
        if (type) {
            // users can get the shallow readonly version of the slots object through `this.$slots`,
            // we should avoid the proxy object polluting the slots of the internal instance
            instance.slots = (0, $01W3b.toRaw)(children);
            // make compiler marker non-enumerable
            (0, $8POXm.def)(children, '_', type);
        } else $0a6cc4ba868319ae$var$normalizeObjectSlots(children, instance.slots = {});
    } else {
        instance.slots = {};
        if (children) $0a6cc4ba868319ae$var$normalizeVNodeSlots(instance, children);
    }
    (0, $8POXm.def)(instance.slots, $0a6cc4ba868319ae$var$InternalObjectKey, 1);
};
const $0a6cc4ba868319ae$var$updateSlots = (instance, children, optimized)=>{
    const { vnode: vnode, slots: slots } = instance;
    let needDeletionCheck = true;
    let deletionComparisonTarget = (0, $8POXm.EMPTY_OBJ);
    if (vnode.shapeFlag & 32 /* ShapeFlags.SLOTS_CHILDREN */ ) {
        const type = children._;
        if (type) {
            if (optimized && type === 1 /* SlotFlags.STABLE */ ) // compiled AND stable.
            // no need to update, and skip stale slots removal.
            needDeletionCheck = false;
            else {
                // compiled but dynamic (v-if/v-for on slots) - update slots, but skip
                // normalization.
                (0, $8POXm.extend)(slots, children);
                // #2893
                // when rendering the optimized slots by manually written render function,
                // we need to delete the `slots._` flag if necessary to make subsequent updates reliable,
                // i.e. let the `renderSlot` create the bailed Fragment
                if (!optimized && type === 1 /* SlotFlags.STABLE */ ) delete slots._;
            }
        } else {
            needDeletionCheck = !children.$stable;
            $0a6cc4ba868319ae$var$normalizeObjectSlots(children, slots);
        }
        deletionComparisonTarget = children;
    } else if (children) {
        // non slot object children (direct value) passed to a component
        $0a6cc4ba868319ae$var$normalizeVNodeSlots(instance, children);
        deletionComparisonTarget = {
            default: 1
        };
    }
    // delete stale slots
    if (needDeletionCheck) {
        for(const key in slots)if (!$0a6cc4ba868319ae$var$isInternalKey(key) && !(key in deletionComparisonTarget)) delete slots[key];
    }
};
function $0a6cc4ba868319ae$var$createAppContext() {
    return {
        app: null,
        config: {
            isNativeTag: (0, $8POXm.NO),
            performance: false,
            globalProperties: {},
            optionMergeStrategies: {},
            errorHandler: undefined,
            warnHandler: undefined,
            compilerOptions: {}
        },
        mixins: [],
        components: {},
        directives: {},
        provides: Object.create(null),
        optionsCache: new WeakMap(),
        propsCache: new WeakMap(),
        emitsCache: new WeakMap()
    };
}
let $0a6cc4ba868319ae$var$uid = 0;
function $0a6cc4ba868319ae$var$createAppAPI(render, hydrate) {
    return function createApp(rootComponent, rootProps = null) {
        if (!(0, $8POXm.isFunction)(rootComponent)) rootComponent = Object.assign({}, rootComponent);
        if (rootProps != null && !(0, $8POXm.isObject)(rootProps)) rootProps = null;
        const context = $0a6cc4ba868319ae$var$createAppContext();
        const installedPlugins = new Set();
        let isMounted = false;
        const app = context.app = {
            _uid: $0a6cc4ba868319ae$var$uid++,
            _component: rootComponent,
            _props: rootProps,
            _container: null,
            _context: context,
            _instance: null,
            version: $0a6cc4ba868319ae$export$83d89fbfd8236492,
            get config () {
                return context.config;
            },
            set config (v){},
            use (plugin, ...options) {
                if (installedPlugins.has(plugin)) ;
                else if (plugin && (0, $8POXm.isFunction)(plugin.install)) {
                    installedPlugins.add(plugin);
                    plugin.install(app, ...options);
                } else if ((0, $8POXm.isFunction)(plugin)) {
                    installedPlugins.add(plugin);
                    plugin(app, ...options);
                }
                return app;
            },
            mixin (mixin) {
                if (__VUE_OPTIONS_API__) {
                    if (!context.mixins.includes(mixin)) context.mixins.push(mixin);
                }
                return app;
            },
            component (name, component) {
                if (!component) return context.components[name];
                context.components[name] = component;
                return app;
            },
            directive (name, directive) {
                if (!directive) return context.directives[name];
                context.directives[name] = directive;
                return app;
            },
            mount (rootContainer, isHydrate, isSVG) {
                if (!isMounted) {
                    const vnode = $0a6cc4ba868319ae$export$bf5c4cf060303d58(rootComponent, rootProps);
                    // store app context on the root VNode.
                    // this will be set on the root instance on initial mount.
                    vnode.appContext = context;
                    if (isHydrate && hydrate) hydrate(vnode, rootContainer);
                    else render(vnode, rootContainer, isSVG);
                    isMounted = true;
                    app._container = rootContainer;
                    rootContainer.__vue_app__ = app;
                    if (__VUE_PROD_DEVTOOLS__) {
                        app._instance = vnode.component;
                        $0a6cc4ba868319ae$var$devtoolsInitApp(app, $0a6cc4ba868319ae$export$83d89fbfd8236492);
                    }
                    return $0a6cc4ba868319ae$var$getExposeProxy(vnode.component) || vnode.component.proxy;
                }
            },
            unmount () {
                if (isMounted) {
                    render(null, app._container);
                    if (__VUE_PROD_DEVTOOLS__) {
                        app._instance = null;
                        $0a6cc4ba868319ae$var$devtoolsUnmountApp(app);
                    }
                    delete app._container.__vue_app__;
                }
            },
            provide (key, value) {
                context.provides[key] = value;
                return app;
            }
        };
        return app;
    };
}
/**
 * Function for handling a template ref
 */ function $0a6cc4ba868319ae$var$setRef(rawRef, oldRawRef, parentSuspense, vnode, isUnmount = false) {
    if ((0, $8POXm.isArray)(rawRef)) {
        rawRef.forEach((r, i)=>$0a6cc4ba868319ae$var$setRef(r, oldRawRef && ((0, $8POXm.isArray)(oldRawRef) ? oldRawRef[i] : oldRawRef), parentSuspense, vnode, isUnmount));
        return;
    }
    if ($0a6cc4ba868319ae$var$isAsyncWrapper(vnode) && !isUnmount) // when mounting async components, nothing needs to be done,
    // because the template ref is forwarded to inner component
    return;
    const refValue = vnode.shapeFlag & 4 /* ShapeFlags.STATEFUL_COMPONENT */  ? $0a6cc4ba868319ae$var$getExposeProxy(vnode.component) || vnode.component.proxy : vnode.el;
    const value = isUnmount ? null : refValue;
    const { i: owner, r: ref } = rawRef;
    const oldRef = oldRawRef && oldRawRef.r;
    const refs = owner.refs === (0, $8POXm.EMPTY_OBJ) ? owner.refs = {} : owner.refs;
    const setupState = owner.setupState;
    // dynamic ref changed. unset old ref
    if (oldRef != null && oldRef !== ref) {
        if ((0, $8POXm.isString)(oldRef)) {
            refs[oldRef] = null;
            if ((0, $8POXm.hasOwn)(setupState, oldRef)) setupState[oldRef] = null;
        } else if ((0, $01W3b.isRef)(oldRef)) oldRef.value = null;
    }
    if ((0, $8POXm.isFunction)(ref)) $0a6cc4ba868319ae$export$b22fcaf88446e9bf(ref, owner, 12 /* ErrorCodes.FUNCTION_REF */ , [
        value,
        refs
    ]);
    else {
        const _isString = (0, $8POXm.isString)(ref);
        const _isRef = (0, $01W3b.isRef)(ref);
        if (_isString || _isRef) {
            const doSet = ()=>{
                if (rawRef.f) {
                    const existing = _isString ? refs[ref] : ref.value;
                    if (isUnmount) (0, $8POXm.isArray)(existing) && (0, $8POXm.remove)(existing, refValue);
                    else {
                        if (!(0, $8POXm.isArray)(existing)) {
                            if (_isString) {
                                refs[ref] = [
                                    refValue
                                ];
                                if ((0, $8POXm.hasOwn)(setupState, ref)) setupState[ref] = refs[ref];
                            } else {
                                ref.value = [
                                    refValue
                                ];
                                if (rawRef.k) refs[rawRef.k] = ref.value;
                            }
                        } else if (!existing.includes(refValue)) existing.push(refValue);
                    }
                } else if (_isString) {
                    refs[ref] = value;
                    if ((0, $8POXm.hasOwn)(setupState, ref)) setupState[ref] = value;
                } else if (_isRef) {
                    ref.value = value;
                    if (rawRef.k) refs[rawRef.k] = value;
                }
            };
            if (value) {
                doSet.id = -1;
                $0a6cc4ba868319ae$var$queuePostRenderEffect(doSet, parentSuspense);
            } else doSet();
        }
    }
}
let $0a6cc4ba868319ae$var$hasMismatch = false;
const $0a6cc4ba868319ae$var$isSVGContainer = (container)=>/svg/.test(container.namespaceURI) && container.tagName !== 'foreignObject';
const $0a6cc4ba868319ae$var$isComment = (node)=>node.nodeType === 8 /* DOMNodeTypes.COMMENT */ ;
// Note: hydration is DOM-specific
// But we have to place it in core due to tight coupling with core - splitting
// it out creates a ton of unnecessary complexity.
// Hydration also depends on some renderer internal logic which needs to be
// passed in via arguments.
function $0a6cc4ba868319ae$var$createHydrationFunctions(rendererInternals) {
    const { mt: mountComponent, p: patch, o: { patchProp: patchProp, createText: createText, nextSibling: nextSibling, parentNode: parentNode, remove: remove, insert: insert, createComment: createComment } } = rendererInternals;
    const hydrate = (vnode, container)=>{
        if (!container.hasChildNodes()) {
            patch(null, vnode, container);
            $0a6cc4ba868319ae$var$flushPostFlushCbs();
            container._vnode = vnode;
            return;
        }
        $0a6cc4ba868319ae$var$hasMismatch = false;
        hydrateNode(container.firstChild, vnode, null, null, null);
        $0a6cc4ba868319ae$var$flushPostFlushCbs();
        container._vnode = vnode;
        if ($0a6cc4ba868319ae$var$hasMismatch && true) // this error should show up in production
        console.error(`Hydration completed but contains mismatches.`);
    };
    const hydrateNode = (node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized = false)=>{
        const isFragmentStart = $0a6cc4ba868319ae$var$isComment(node) && node.data === '[';
        const onMismatch = ()=>handleMismatch(node, vnode, parentComponent, parentSuspense, slotScopeIds, isFragmentStart);
        const { type: type, ref: ref, shapeFlag: shapeFlag, patchFlag: patchFlag } = vnode;
        const domType = node.nodeType;
        vnode.el = node;
        if (patchFlag === -2 /* PatchFlags.BAIL */ ) {
            optimized = false;
            vnode.dynamicChildren = null;
        }
        let nextNode = null;
        switch(type){
            case $0a6cc4ba868319ae$export$5f1af8db9871e1d6:
                if (domType !== 3 /* DOMNodeTypes.TEXT */ ) {
                    // #5728 empty text node inside a slot can cause hydration failure
                    // because the server rendered HTML won't contain a text node
                    if (vnode.children === '') {
                        insert(vnode.el = createText(''), parentNode(node), node);
                        nextNode = node;
                    } else nextNode = onMismatch();
                } else {
                    if (node.data !== vnode.children) {
                        $0a6cc4ba868319ae$var$hasMismatch = true;
                        node.data = vnode.children;
                    }
                    nextNode = nextSibling(node);
                }
                break;
            case $0a6cc4ba868319ae$export$4d299b491347818a:
                if (domType !== 8 /* DOMNodeTypes.COMMENT */  || isFragmentStart) nextNode = onMismatch();
                else nextNode = nextSibling(node);
                break;
            case $0a6cc4ba868319ae$export$c1b9a1d3af45b7b6:
                if (domType !== 1 /* DOMNodeTypes.ELEMENT */  && domType !== 3 /* DOMNodeTypes.TEXT */ ) nextNode = onMismatch();
                else {
                    // determine anchor, adopt content
                    nextNode = node;
                    // if the static vnode has its content stripped during build,
                    // adopt it from the server-rendered HTML.
                    const needToAdoptContent = !vnode.children.length;
                    for(let i = 0; i < vnode.staticCount; i++){
                        if (needToAdoptContent) vnode.children += nextNode.nodeType === 1 /* DOMNodeTypes.ELEMENT */  ? nextNode.outerHTML : nextNode.data;
                        if (i === vnode.staticCount - 1) vnode.anchor = nextNode;
                        nextNode = nextSibling(nextNode);
                    }
                    return nextNode;
                }
                break;
            case $0a6cc4ba868319ae$export$ffb0004e005737fa:
                if (!isFragmentStart) nextNode = onMismatch();
                else nextNode = hydrateFragment(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized);
                break;
            default:
                if (shapeFlag & 1 /* ShapeFlags.ELEMENT */ ) {
                    if (domType !== 1 /* DOMNodeTypes.ELEMENT */  || vnode.type.toLowerCase() !== node.tagName.toLowerCase()) nextNode = onMismatch();
                    else nextNode = hydrateElement(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized);
                } else if (shapeFlag & 6 /* ShapeFlags.COMPONENT */ ) {
                    // when setting up the render effect, if the initial vnode already
                    // has .el set, the component will perform hydration instead of mount
                    // on its sub-tree.
                    vnode.slotScopeIds = slotScopeIds;
                    const container = parentNode(node);
                    mountComponent(vnode, container, null, parentComponent, parentSuspense, $0a6cc4ba868319ae$var$isSVGContainer(container), optimized);
                    // component may be async, so in the case of fragments we cannot rely
                    // on component's rendered output to determine the end of the fragment
                    // instead, we do a lookahead to find the end anchor node.
                    nextNode = isFragmentStart ? locateClosingAsyncAnchor(node) : nextSibling(node);
                    // #4293 teleport as component root
                    if (nextNode && $0a6cc4ba868319ae$var$isComment(nextNode) && nextNode.data === 'teleport end') nextNode = nextSibling(nextNode);
                    // #3787
                    // if component is async, it may get moved / unmounted before its
                    // inner component is loaded, so we need to give it a placeholder
                    // vnode that matches its adopted DOM.
                    if ($0a6cc4ba868319ae$var$isAsyncWrapper(vnode)) {
                        let subTree;
                        if (isFragmentStart) {
                            subTree = $0a6cc4ba868319ae$export$bf5c4cf060303d58($0a6cc4ba868319ae$export$ffb0004e005737fa);
                            subTree.anchor = nextNode ? nextNode.previousSibling : container.lastChild;
                        } else subTree = node.nodeType === 3 ? $0a6cc4ba868319ae$export$22f9b5ffd89dac9('') : $0a6cc4ba868319ae$export$bf5c4cf060303d58('div');
                        subTree.el = node;
                        vnode.component.subTree = subTree;
                    }
                } else if (shapeFlag & 64 /* ShapeFlags.TELEPORT */ ) {
                    if (domType !== 8 /* DOMNodeTypes.COMMENT */ ) nextNode = onMismatch();
                    else nextNode = vnode.type.hydrate(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized, rendererInternals, hydrateChildren);
                } else if (shapeFlag & 128 /* ShapeFlags.SUSPENSE */ ) nextNode = vnode.type.hydrate(node, vnode, parentComponent, parentSuspense, $0a6cc4ba868319ae$var$isSVGContainer(parentNode(node)), slotScopeIds, optimized, rendererInternals, hydrateNode);
        }
        if (ref != null) $0a6cc4ba868319ae$var$setRef(ref, null, parentSuspense, vnode);
        return nextNode;
    };
    const hydrateElement = (el, vnode, parentComponent, parentSuspense, slotScopeIds, optimized)=>{
        optimized = optimized || !!vnode.dynamicChildren;
        const { type: type, props: props, patchFlag: patchFlag, shapeFlag: shapeFlag, dirs: dirs } = vnode;
        // #4006 for form elements with non-string v-model value bindings
        // e.g. <option :value="obj">, <input type="checkbox" :true-value="1">
        const forcePatchValue = type === 'input' && dirs || type === 'option';
        // skip props & children if this is hoisted static nodes
        // #5405 in dev, always hydrate children for HMR
        if (forcePatchValue || patchFlag !== -1 /* PatchFlags.HOISTED */ ) {
            if (dirs) $0a6cc4ba868319ae$var$invokeDirectiveHook(vnode, null, parentComponent, 'created');
            // props
            if (props) {
                if (forcePatchValue || !optimized || patchFlag & 48 /* PatchFlags.HYDRATE_EVENTS */ ) {
                    for(const key in props)if (forcePatchValue && key.endsWith('value') || (0, $8POXm.isOn)(key) && !(0, $8POXm.isReservedProp)(key)) patchProp(el, key, null, props[key], false, undefined, parentComponent);
                } else if (props.onClick) // Fast path for click listeners (which is most often) to avoid
                // iterating through props.
                patchProp(el, 'onClick', null, props.onClick, false, undefined, parentComponent);
            }
            // vnode / directive hooks
            let vnodeHooks;
            if (vnodeHooks = props && props.onVnodeBeforeMount) $0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHooks, parentComponent, vnode);
            if (dirs) $0a6cc4ba868319ae$var$invokeDirectiveHook(vnode, null, parentComponent, 'beforeMount');
            if ((vnodeHooks = props && props.onVnodeMounted) || dirs) $0a6cc4ba868319ae$var$queueEffectWithSuspense(()=>{
                vnodeHooks && $0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHooks, parentComponent, vnode);
                dirs && $0a6cc4ba868319ae$var$invokeDirectiveHook(vnode, null, parentComponent, 'mounted');
            }, parentSuspense);
            // children
            if (shapeFlag & 16 /* ShapeFlags.ARRAY_CHILDREN */  && // skip if element has innerHTML / textContent
            !(props && (props.innerHTML || props.textContent))) {
                let next = hydrateChildren(el.firstChild, vnode, el, parentComponent, parentSuspense, slotScopeIds, optimized);
                let hasWarned = false;
                while(next){
                    $0a6cc4ba868319ae$var$hasMismatch = true;
                    // The SSRed DOM contains more nodes than it should. Remove them.
                    const cur = next;
                    next = next.nextSibling;
                    remove(cur);
                }
            } else if (shapeFlag & 8 /* ShapeFlags.TEXT_CHILDREN */ ) {
                if (el.textContent !== vnode.children) {
                    $0a6cc4ba868319ae$var$hasMismatch = true;
                    el.textContent = vnode.children;
                }
            }
        }
        return el.nextSibling;
    };
    const hydrateChildren = (node, parentVNode, container, parentComponent, parentSuspense, slotScopeIds, optimized)=>{
        optimized = optimized || !!parentVNode.dynamicChildren;
        const children = parentVNode.children;
        const l = children.length;
        let hasWarned = false;
        for(let i = 0; i < l; i++){
            const vnode = optimized ? children[i] : children[i] = $0a6cc4ba868319ae$var$normalizeVNode(children[i]);
            if (node) node = hydrateNode(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized);
            else if (vnode.type === $0a6cc4ba868319ae$export$5f1af8db9871e1d6 && !vnode.children) continue;
            else {
                $0a6cc4ba868319ae$var$hasMismatch = true;
                // the SSRed DOM didn't contain enough nodes. Mount the missing ones.
                patch(null, vnode, container, null, parentComponent, parentSuspense, $0a6cc4ba868319ae$var$isSVGContainer(container), slotScopeIds);
            }
        }
        return node;
    };
    const hydrateFragment = (node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized)=>{
        const { slotScopeIds: fragmentSlotScopeIds } = vnode;
        if (fragmentSlotScopeIds) slotScopeIds = slotScopeIds ? slotScopeIds.concat(fragmentSlotScopeIds) : fragmentSlotScopeIds;
        const container = parentNode(node);
        const next = hydrateChildren(nextSibling(node), vnode, container, parentComponent, parentSuspense, slotScopeIds, optimized);
        if (next && $0a6cc4ba868319ae$var$isComment(next) && next.data === ']') return nextSibling(vnode.anchor = next);
        else {
            // fragment didn't hydrate successfully, since we didn't get a end anchor
            // back. This should have led to node/children mismatch warnings.
            $0a6cc4ba868319ae$var$hasMismatch = true;
            // since the anchor is missing, we need to create one and insert it
            insert(vnode.anchor = createComment(`]`), container, next);
            return next;
        }
    };
    const handleMismatch = (node, vnode, parentComponent, parentSuspense, slotScopeIds, isFragment)=>{
        $0a6cc4ba868319ae$var$hasMismatch = true;
        vnode.el = null;
        if (isFragment) {
            // remove excessive fragment nodes
            const end = locateClosingAsyncAnchor(node);
            while(true){
                const next = nextSibling(node);
                if (next && next !== end) remove(next);
                else break;
            }
        }
        const next = nextSibling(node);
        const container = parentNode(node);
        remove(node);
        patch(null, vnode, container, next, parentComponent, parentSuspense, $0a6cc4ba868319ae$var$isSVGContainer(container), slotScopeIds);
        return next;
    };
    const locateClosingAsyncAnchor = (node)=>{
        let match = 0;
        while(node){
            node = nextSibling(node);
            if (node && $0a6cc4ba868319ae$var$isComment(node)) {
                if (node.data === '[') match++;
                if (node.data === ']') {
                    if (match === 0) return nextSibling(node);
                    else match--;
                }
            }
        }
        return node;
    };
    return [
        hydrate,
        hydrateNode
    ];
}
/* eslint-disable no-restricted-globals */ let $0a6cc4ba868319ae$var$supported;
let $0a6cc4ba868319ae$var$perf;
function $0a6cc4ba868319ae$var$startMeasure(instance, type) {
    if (instance.appContext.config.performance && $0a6cc4ba868319ae$var$isSupported()) $0a6cc4ba868319ae$var$perf.mark(`vue-${type}-${instance.uid}`);
    if (__VUE_PROD_DEVTOOLS__) $0a6cc4ba868319ae$var$devtoolsPerfStart(instance, type, $0a6cc4ba868319ae$var$isSupported() ? $0a6cc4ba868319ae$var$perf.now() : Date.now());
}
function $0a6cc4ba868319ae$var$endMeasure(instance, type) {
    if (instance.appContext.config.performance && $0a6cc4ba868319ae$var$isSupported()) {
        const startTag = `vue-${type}-${instance.uid}`;
        const endTag = startTag + `:end`;
        $0a6cc4ba868319ae$var$perf.mark(endTag);
        $0a6cc4ba868319ae$var$perf.measure(`<${$0a6cc4ba868319ae$var$formatComponentName(instance, instance.type)}> ${type}`, startTag, endTag);
        $0a6cc4ba868319ae$var$perf.clearMarks(startTag);
        $0a6cc4ba868319ae$var$perf.clearMarks(endTag);
    }
    if (__VUE_PROD_DEVTOOLS__) $0a6cc4ba868319ae$var$devtoolsPerfEnd(instance, type, $0a6cc4ba868319ae$var$isSupported() ? $0a6cc4ba868319ae$var$perf.now() : Date.now());
}
function $0a6cc4ba868319ae$var$isSupported() {
    if ($0a6cc4ba868319ae$var$supported !== undefined) return $0a6cc4ba868319ae$var$supported;
    if (typeof window !== 'undefined' && window.performance) {
        $0a6cc4ba868319ae$var$supported = true;
        $0a6cc4ba868319ae$var$perf = window.performance;
    } else $0a6cc4ba868319ae$var$supported = false;
    return $0a6cc4ba868319ae$var$supported;
}
/**
 * This is only called in esm-bundler builds.
 * It is called when a renderer is created, in `baseCreateRenderer` so that
 * importing runtime-core is side-effects free.
 *
 * istanbul-ignore-next
 */ function $0a6cc4ba868319ae$var$initFeatureFlags() {
    const needWarn = [];
    if (typeof __VUE_OPTIONS_API__ !== 'boolean') (0, $8POXm.getGlobalThis)().__VUE_OPTIONS_API__ = true;
    if (typeof __VUE_PROD_DEVTOOLS__ !== 'boolean') (0, $8POXm.getGlobalThis)().__VUE_PROD_DEVTOOLS__ = false;
}
const $0a6cc4ba868319ae$var$queuePostRenderEffect = $0a6cc4ba868319ae$var$queueEffectWithSuspense;
/**
 * The createRenderer function accepts two generic arguments:
 * HostNode and HostElement, corresponding to Node and Element types in the
 * host environment. For example, for runtime-dom, HostNode would be the DOM
 * `Node` interface and HostElement would be the DOM `Element` interface.
 *
 * Custom renderers can pass in the platform specific types like this:
 *
 * ``` js
 * const { render, createApp } = createRenderer<Node, Element>({
 *   patchProp,
 *   ...nodeOps
 * })
 * ```
 */ function $0a6cc4ba868319ae$export$53ae2f996c64e9a(options) {
    return $0a6cc4ba868319ae$var$baseCreateRenderer(options);
}
// Separate API for creating hydration-enabled renderer.
// Hydration logic is only used when calling this function, making it
// tree-shakable.
function $0a6cc4ba868319ae$export$200524cf0d997ff0(options) {
    return $0a6cc4ba868319ae$var$baseCreateRenderer(options, $0a6cc4ba868319ae$var$createHydrationFunctions);
}
// implementation
function $0a6cc4ba868319ae$var$baseCreateRenderer(options, createHydrationFns) {
    $0a6cc4ba868319ae$var$initFeatureFlags();
    const target = (0, $8POXm.getGlobalThis)();
    target.__VUE__ = true;
    if (__VUE_PROD_DEVTOOLS__) $0a6cc4ba868319ae$export$b0c258b32c26c785(target.__VUE_DEVTOOLS_GLOBAL_HOOK__, target);
    const { insert: hostInsert, remove: hostRemove, patchProp: hostPatchProp, createElement: hostCreateElement, createText: hostCreateText, createComment: hostCreateComment, setText: hostSetText, setElementText: hostSetElementText, parentNode: hostParentNode, nextSibling: hostNextSibling, setScopeId: hostSetScopeId = (0, $8POXm.NOOP), cloneNode: hostCloneNode, insertStaticContent: hostInsertStaticContent } = options;
    // Note: functions inside this closure should use `const xxx = () => {}`
    // style in order to prevent being inlined by minifiers.
    const patch = (n1, n2, container, anchor = null, parentComponent = null, parentSuspense = null, isSVG = false, slotScopeIds = null, optimized = !!n2.dynamicChildren)=>{
        if (n1 === n2) return;
        // patching & not same type, unmount old tree
        if (n1 && !$0a6cc4ba868319ae$var$isSameVNodeType(n1, n2)) {
            anchor = getNextHostNode(n1);
            unmount(n1, parentComponent, parentSuspense, true);
            n1 = null;
        }
        if (n2.patchFlag === -2 /* PatchFlags.BAIL */ ) {
            optimized = false;
            n2.dynamicChildren = null;
        }
        const { type: type, ref: ref, shapeFlag: shapeFlag } = n2;
        switch(type){
            case $0a6cc4ba868319ae$export$5f1af8db9871e1d6:
                processText(n1, n2, container, anchor);
                break;
            case $0a6cc4ba868319ae$export$4d299b491347818a:
                processCommentNode(n1, n2, container, anchor);
                break;
            case $0a6cc4ba868319ae$export$c1b9a1d3af45b7b6:
                if (n1 == null) mountStaticNode(n2, container, anchor, isSVG);
                break;
            case $0a6cc4ba868319ae$export$ffb0004e005737fa:
                processFragment(n1, n2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
                break;
            default:
                if (shapeFlag & 1 /* ShapeFlags.ELEMENT */ ) processElement(n1, n2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
                else if (shapeFlag & 6 /* ShapeFlags.COMPONENT */ ) processComponent(n1, n2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
                else if (shapeFlag & 64 /* ShapeFlags.TELEPORT */ ) type.process(n1, n2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized, internals);
                else if (shapeFlag & 128 /* ShapeFlags.SUSPENSE */ ) type.process(n1, n2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized, internals);
        }
        // set ref
        if (ref != null && parentComponent) $0a6cc4ba868319ae$var$setRef(ref, n1 && n1.ref, parentSuspense, n2 || n1, !n2);
    };
    const processText = (n1, n2, container, anchor)=>{
        if (n1 == null) hostInsert(n2.el = hostCreateText(n2.children), container, anchor);
        else {
            const el = n2.el = n1.el;
            if (n2.children !== n1.children) hostSetText(el, n2.children);
        }
    };
    const processCommentNode = (n1, n2, container, anchor)=>{
        if (n1 == null) hostInsert(n2.el = hostCreateComment(n2.children || ''), container, anchor);
        else // there's no support for dynamic comments
        n2.el = n1.el;
    };
    const mountStaticNode = (n2, container, anchor, isSVG)=>{
        [n2.el, n2.anchor] = hostInsertStaticContent(n2.children, container, anchor, isSVG, n2.el, n2.anchor);
    };
    /**
     * Dev / HMR only
     */ const patchStaticNode = (n1, n2, container, isSVG)=>{
        // static nodes are only patched during dev for HMR
        if (n2.children !== n1.children) {
            const anchor = hostNextSibling(n1.anchor);
            // remove existing
            removeStaticNode(n1);
            [n2.el, n2.anchor] = hostInsertStaticContent(n2.children, container, anchor, isSVG);
        } else {
            n2.el = n1.el;
            n2.anchor = n1.anchor;
        }
    };
    const moveStaticNode = ({ el: el, anchor: anchor }, container, nextSibling)=>{
        let next;
        while(el && el !== anchor){
            next = hostNextSibling(el);
            hostInsert(el, container, nextSibling);
            el = next;
        }
        hostInsert(anchor, container, nextSibling);
    };
    const removeStaticNode = ({ el: el, anchor: anchor })=>{
        let next;
        while(el && el !== anchor){
            next = hostNextSibling(el);
            hostRemove(el);
            el = next;
        }
        hostRemove(anchor);
    };
    const processElement = (n1, n2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized)=>{
        isSVG = isSVG || n2.type === 'svg';
        if (n1 == null) mountElement(n2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
        else patchElement(n1, n2, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
    };
    const mountElement = (vnode, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized)=>{
        let el;
        let vnodeHook;
        const { type: type, props: props, shapeFlag: shapeFlag, transition: transition, patchFlag: patchFlag, dirs: dirs } = vnode;
        if (vnode.el && hostCloneNode !== undefined && patchFlag === -1 /* PatchFlags.HOISTED */ ) // If a vnode has non-null el, it means it's being reused.
        // Only static vnodes can be reused, so its mounted DOM nodes should be
        // exactly the same, and we can simply do a clone here.
        // only do this in production since cloned trees cannot be HMR updated.
        el = vnode.el = hostCloneNode(vnode.el);
        else {
            el = vnode.el = hostCreateElement(vnode.type, isSVG, props && props.is, props);
            // mount children first, since some props may rely on child content
            // being already rendered, e.g. `<select value>`
            if (shapeFlag & 8 /* ShapeFlags.TEXT_CHILDREN */ ) hostSetElementText(el, vnode.children);
            else if (shapeFlag & 16 /* ShapeFlags.ARRAY_CHILDREN */ ) mountChildren(vnode.children, el, null, parentComponent, parentSuspense, isSVG && type !== 'foreignObject', slotScopeIds, optimized);
            if (dirs) $0a6cc4ba868319ae$var$invokeDirectiveHook(vnode, null, parentComponent, 'created');
            // props
            if (props) {
                for(const key in props)if (key !== 'value' && !(0, $8POXm.isReservedProp)(key)) hostPatchProp(el, key, null, props[key], isSVG, vnode.children, parentComponent, parentSuspense, unmountChildren);
                /**
                 * Special case for setting value on DOM elements:
                 * - it can be order-sensitive (e.g. should be set *after* min/max, #2325, #4024)
                 * - it needs to be forced (#1471)
                 * #2353 proposes adding another renderer option to configure this, but
                 * the properties affects are so finite it is worth special casing it
                 * here to reduce the complexity. (Special casing it also should not
                 * affect non-DOM renderers)
                 */ if ('value' in props) hostPatchProp(el, 'value', null, props.value);
                if (vnodeHook = props.onVnodeBeforeMount) $0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHook, parentComponent, vnode);
            }
            // scopeId
            setScopeId(el, vnode, vnode.scopeId, slotScopeIds, parentComponent);
        }
        if (__VUE_PROD_DEVTOOLS__) {
            Object.defineProperty(el, '__vnode', {
                value: vnode,
                enumerable: false
            });
            Object.defineProperty(el, '__vueParentComponent', {
                value: parentComponent,
                enumerable: false
            });
        }
        if (dirs) $0a6cc4ba868319ae$var$invokeDirectiveHook(vnode, null, parentComponent, 'beforeMount');
        // #1583 For inside suspense + suspense not resolved case, enter hook should call when suspense resolved
        // #1689 For inside suspense + suspense resolved case, just call it
        const needCallTransitionHooks = (!parentSuspense || parentSuspense && !parentSuspense.pendingBranch) && transition && !transition.persisted;
        if (needCallTransitionHooks) transition.beforeEnter(el);
        hostInsert(el, container, anchor);
        if ((vnodeHook = props && props.onVnodeMounted) || needCallTransitionHooks || dirs) $0a6cc4ba868319ae$var$queuePostRenderEffect(()=>{
            vnodeHook && $0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHook, parentComponent, vnode);
            needCallTransitionHooks && transition.enter(el);
            dirs && $0a6cc4ba868319ae$var$invokeDirectiveHook(vnode, null, parentComponent, 'mounted');
        }, parentSuspense);
    };
    const setScopeId = (el, vnode, scopeId, slotScopeIds, parentComponent)=>{
        if (scopeId) hostSetScopeId(el, scopeId);
        if (slotScopeIds) for(let i = 0; i < slotScopeIds.length; i++)hostSetScopeId(el, slotScopeIds[i]);
        if (parentComponent) {
            let subTree = parentComponent.subTree;
            if (vnode === subTree) {
                const parentVNode = parentComponent.vnode;
                setScopeId(el, parentVNode, parentVNode.scopeId, parentVNode.slotScopeIds, parentComponent.parent);
            }
        }
    };
    const mountChildren = (children, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized, start = 0)=>{
        for(let i = start; i < children.length; i++){
            const child = children[i] = optimized ? $0a6cc4ba868319ae$var$cloneIfMounted(children[i]) : $0a6cc4ba868319ae$var$normalizeVNode(children[i]);
            patch(null, child, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
        }
    };
    const patchElement = (n1, n2, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized)=>{
        const el = n2.el = n1.el;
        let { patchFlag: patchFlag, dynamicChildren: dynamicChildren, dirs: dirs } = n2;
        // #1426 take the old vnode's patch flag into account since user may clone a
        // compiler-generated vnode, which de-opts to FULL_PROPS
        patchFlag |= n1.patchFlag & 16 /* PatchFlags.FULL_PROPS */ ;
        const oldProps = n1.props || (0, $8POXm.EMPTY_OBJ);
        const newProps = n2.props || (0, $8POXm.EMPTY_OBJ);
        let vnodeHook;
        // disable recurse in beforeUpdate hooks
        parentComponent && $0a6cc4ba868319ae$var$toggleRecurse(parentComponent, false);
        if (vnodeHook = newProps.onVnodeBeforeUpdate) $0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHook, parentComponent, n2, n1);
        if (dirs) $0a6cc4ba868319ae$var$invokeDirectiveHook(n2, n1, parentComponent, 'beforeUpdate');
        parentComponent && $0a6cc4ba868319ae$var$toggleRecurse(parentComponent, true);
        const areChildrenSVG = isSVG && n2.type !== 'foreignObject';
        if (dynamicChildren) patchBlockChildren(n1.dynamicChildren, dynamicChildren, el, parentComponent, parentSuspense, areChildrenSVG, slotScopeIds);
        else if (!optimized) // full diff
        patchChildren(n1, n2, el, null, parentComponent, parentSuspense, areChildrenSVG, slotScopeIds, false);
        if (patchFlag > 0) {
            // the presence of a patchFlag means this element's render code was
            // generated by the compiler and can take the fast path.
            // in this path old node and new node are guaranteed to have the same shape
            // (i.e. at the exact same position in the source template)
            if (patchFlag & 16 /* PatchFlags.FULL_PROPS */ ) // element props contain dynamic keys, full diff needed
            patchProps(el, n2, oldProps, newProps, parentComponent, parentSuspense, isSVG);
            else {
                // class
                // this flag is matched when the element has dynamic class bindings.
                if (patchFlag & 2 /* PatchFlags.CLASS */ ) {
                    if (oldProps.class !== newProps.class) hostPatchProp(el, 'class', null, newProps.class, isSVG);
                }
                // style
                // this flag is matched when the element has dynamic style bindings
                if (patchFlag & 4 /* PatchFlags.STYLE */ ) hostPatchProp(el, 'style', oldProps.style, newProps.style, isSVG);
                // props
                // This flag is matched when the element has dynamic prop/attr bindings
                // other than class and style. The keys of dynamic prop/attrs are saved for
                // faster iteration.
                // Note dynamic keys like :[foo]="bar" will cause this optimization to
                // bail out and go through a full diff because we need to unset the old key
                if (patchFlag & 8 /* PatchFlags.PROPS */ ) {
                    // if the flag is present then dynamicProps must be non-null
                    const propsToUpdate = n2.dynamicProps;
                    for(let i = 0; i < propsToUpdate.length; i++){
                        const key = propsToUpdate[i];
                        const prev = oldProps[key];
                        const next = newProps[key];
                        // #1471 force patch value
                        if (next !== prev || key === 'value') hostPatchProp(el, key, prev, next, isSVG, n1.children, parentComponent, parentSuspense, unmountChildren);
                    }
                }
            }
            // text
            // This flag is matched when the element has only dynamic text children.
            if (patchFlag & 1 /* PatchFlags.TEXT */ ) {
                if (n1.children !== n2.children) hostSetElementText(el, n2.children);
            }
        } else if (!optimized && dynamicChildren == null) // unoptimized, full diff
        patchProps(el, n2, oldProps, newProps, parentComponent, parentSuspense, isSVG);
        if ((vnodeHook = newProps.onVnodeUpdated) || dirs) $0a6cc4ba868319ae$var$queuePostRenderEffect(()=>{
            vnodeHook && $0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHook, parentComponent, n2, n1);
            dirs && $0a6cc4ba868319ae$var$invokeDirectiveHook(n2, n1, parentComponent, 'updated');
        }, parentSuspense);
    };
    // The fast path for blocks.
    const patchBlockChildren = (oldChildren, newChildren, fallbackContainer, parentComponent, parentSuspense, isSVG, slotScopeIds)=>{
        for(let i = 0; i < newChildren.length; i++){
            const oldVNode = oldChildren[i];
            const newVNode = newChildren[i];
            // Determine the container (parent element) for the patch.
            const container = // oldVNode may be an errored async setup() component inside Suspense
            // which will not have a mounted element
            oldVNode.el && // - In the case of a Fragment, we need to provide the actual parent
            // of the Fragment itself so it can move its children.
            (oldVNode.type === $0a6cc4ba868319ae$export$ffb0004e005737fa || // - In the case of different nodes, there is going to be a replacement
            // which also requires the correct parent container
            !$0a6cc4ba868319ae$var$isSameVNodeType(oldVNode, newVNode) || // - In the case of a component, it could contain anything.
            oldVNode.shapeFlag & 70 /* ShapeFlags.TELEPORT */ ) ? hostParentNode(oldVNode.el) : // just pass the block element here to avoid a DOM parentNode call.
            fallbackContainer;
            patch(oldVNode, newVNode, container, null, parentComponent, parentSuspense, isSVG, slotScopeIds, true);
        }
    };
    const patchProps = (el, vnode, oldProps, newProps, parentComponent, parentSuspense, isSVG)=>{
        if (oldProps !== newProps) {
            for(const key in newProps){
                // empty string is not valid prop
                if ((0, $8POXm.isReservedProp)(key)) continue;
                const next = newProps[key];
                const prev = oldProps[key];
                // defer patching value
                if (next !== prev && key !== 'value') hostPatchProp(el, key, prev, next, isSVG, vnode.children, parentComponent, parentSuspense, unmountChildren);
            }
            if (oldProps !== (0, $8POXm.EMPTY_OBJ)) {
                for(const key in oldProps)if (!(0, $8POXm.isReservedProp)(key) && !(key in newProps)) hostPatchProp(el, key, oldProps[key], null, isSVG, vnode.children, parentComponent, parentSuspense, unmountChildren);
            }
            if ('value' in newProps) hostPatchProp(el, 'value', oldProps.value, newProps.value);
        }
    };
    const processFragment = (n1, n2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized)=>{
        const fragmentStartAnchor = n2.el = n1 ? n1.el : hostCreateText('');
        const fragmentEndAnchor = n2.anchor = n1 ? n1.anchor : hostCreateText('');
        let { patchFlag: patchFlag, dynamicChildren: dynamicChildren, slotScopeIds: fragmentSlotScopeIds } = n2;
        // check if this is a slot fragment with :slotted scope ids
        if (fragmentSlotScopeIds) slotScopeIds = slotScopeIds ? slotScopeIds.concat(fragmentSlotScopeIds) : fragmentSlotScopeIds;
        if (n1 == null) {
            hostInsert(fragmentStartAnchor, container, anchor);
            hostInsert(fragmentEndAnchor, container, anchor);
            // a fragment can only have array children
            // since they are either generated by the compiler, or implicitly created
            // from arrays.
            mountChildren(n2.children, container, fragmentEndAnchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
        } else if (patchFlag > 0 && patchFlag & 64 /* PatchFlags.STABLE_FRAGMENT */  && dynamicChildren && // #2715 the previous fragment could've been a BAILed one as a result
        // of renderSlot() with no valid children
        n1.dynamicChildren) {
            // a stable fragment (template root or <template v-for>) doesn't need to
            // patch children order, but it may contain dynamicChildren.
            patchBlockChildren(n1.dynamicChildren, dynamicChildren, container, parentComponent, parentSuspense, isSVG, slotScopeIds);
            if (// #2080 if the stable fragment has a key, it's a <template v-for> that may
            //  get moved around. Make sure all root level vnodes inherit el.
            // #2134 or if it's a component root, it may also get moved around
            // as the component is being moved.
            n2.key != null || parentComponent && n2 === parentComponent.subTree) $0a6cc4ba868319ae$var$traverseStaticChildren(n1, n2, true);
        } else // keyed / unkeyed, or manual fragments.
        // for keyed & unkeyed, since they are compiler generated from v-for,
        // each child is guaranteed to be a block so the fragment will never
        // have dynamicChildren.
        patchChildren(n1, n2, container, fragmentEndAnchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
    };
    const processComponent = (n1, n2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized)=>{
        n2.slotScopeIds = slotScopeIds;
        if (n1 == null) {
            if (n2.shapeFlag & 512 /* ShapeFlags.COMPONENT_KEPT_ALIVE */ ) parentComponent.ctx.activate(n2, container, anchor, isSVG, optimized);
            else mountComponent(n2, container, anchor, parentComponent, parentSuspense, isSVG, optimized);
        } else updateComponent(n1, n2, optimized);
    };
    const mountComponent = (initialVNode, container, anchor, parentComponent, parentSuspense, isSVG, optimized)=>{
        const instance = initialVNode.component = $0a6cc4ba868319ae$var$createComponentInstance(initialVNode, parentComponent, parentSuspense);
        // inject renderer internals for keepAlive
        if ($0a6cc4ba868319ae$var$isKeepAlive(initialVNode)) instance.ctx.renderer = internals;
        $0a6cc4ba868319ae$var$setupComponent(instance);
        // setup() is async. This component relies on async logic to be resolved
        // before proceeding
        if (instance.asyncDep) {
            parentSuspense && parentSuspense.registerDep(instance, setupRenderEffect);
            // Give it a placeholder if this is not hydration
            // TODO handle self-defined fallback
            if (!initialVNode.el) {
                const placeholder = instance.subTree = $0a6cc4ba868319ae$export$bf5c4cf060303d58($0a6cc4ba868319ae$export$4d299b491347818a);
                processCommentNode(null, placeholder, container, anchor);
            }
            return;
        }
        setupRenderEffect(instance, initialVNode, container, anchor, parentSuspense, isSVG, optimized);
    };
    const updateComponent = (n1, n2, optimized)=>{
        const instance = n2.component = n1.component;
        if ($0a6cc4ba868319ae$var$shouldUpdateComponent(n1, n2, optimized)) {
            if (instance.asyncDep && !instance.asyncResolved) {
                updateComponentPreRender(instance, n2, optimized);
                return;
            } else {
                // normal update
                instance.next = n2;
                // in case the child component is also queued, remove it to avoid
                // double updating the same child component in the same flush.
                $0a6cc4ba868319ae$var$invalidateJob(instance.update);
                // instance.update is the reactive effect.
                instance.update();
            }
        } else {
            // no update needed. just copy over properties
            n2.el = n1.el;
            instance.vnode = n2;
        }
    };
    const setupRenderEffect = (instance, initialVNode, container, anchor, parentSuspense, isSVG, optimized)=>{
        const componentUpdateFn = ()=>{
            if (!instance.isMounted) {
                let vnodeHook;
                const { el: el, props: props } = initialVNode;
                const { bm: bm, m: m, parent: parent } = instance;
                const isAsyncWrapperVNode = $0a6cc4ba868319ae$var$isAsyncWrapper(initialVNode);
                $0a6cc4ba868319ae$var$toggleRecurse(instance, false);
                // beforeMount hook
                if (bm) (0, $8POXm.invokeArrayFns)(bm);
                // onVnodeBeforeMount
                if (!isAsyncWrapperVNode && (vnodeHook = props && props.onVnodeBeforeMount)) $0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHook, parent, initialVNode);
                $0a6cc4ba868319ae$var$toggleRecurse(instance, true);
                if (el && hydrateNode) {
                    // vnode has adopted host node - perform hydration instead of mount.
                    const hydrateSubTree = ()=>{
                        instance.subTree = $0a6cc4ba868319ae$var$renderComponentRoot(instance);
                        hydrateNode(el, instance.subTree, instance, parentSuspense, null);
                    };
                    if (isAsyncWrapperVNode) initialVNode.type.__asyncLoader().then(// note: we are moving the render call into an async callback,
                    // which means it won't track dependencies - but it's ok because
                    // a server-rendered async wrapper is already in resolved state
                    // and it will never need to change.
                    ()=>!instance.isUnmounted && hydrateSubTree());
                    else hydrateSubTree();
                } else {
                    const subTree = instance.subTree = $0a6cc4ba868319ae$var$renderComponentRoot(instance);
                    patch(null, subTree, container, anchor, instance, parentSuspense, isSVG);
                    initialVNode.el = subTree.el;
                }
                // mounted hook
                if (m) $0a6cc4ba868319ae$var$queuePostRenderEffect(m, parentSuspense);
                // onVnodeMounted
                if (!isAsyncWrapperVNode && (vnodeHook = props && props.onVnodeMounted)) {
                    const scopedInitialVNode = initialVNode;
                    $0a6cc4ba868319ae$var$queuePostRenderEffect(()=>$0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHook, parent, scopedInitialVNode), parentSuspense);
                }
                // activated hook for keep-alive roots.
                // #1742 activated hook must be accessed after first render
                // since the hook may be injected by a child keep-alive
                if (initialVNode.shapeFlag & 256 /* ShapeFlags.COMPONENT_SHOULD_KEEP_ALIVE */  || parent && $0a6cc4ba868319ae$var$isAsyncWrapper(parent.vnode) && parent.vnode.shapeFlag & 256 /* ShapeFlags.COMPONENT_SHOULD_KEEP_ALIVE */ ) instance.a && $0a6cc4ba868319ae$var$queuePostRenderEffect(instance.a, parentSuspense);
                instance.isMounted = true;
                if (__VUE_PROD_DEVTOOLS__) $0a6cc4ba868319ae$var$devtoolsComponentAdded(instance);
                // #2458: deference mount-only object parameters to prevent memleaks
                initialVNode = container = anchor = null;
            } else {
                // updateComponent
                // This is triggered by mutation of component's own state (next: null)
                // OR parent calling processComponent (next: VNode)
                let { next: next, bu: bu, u: u, parent: parent, vnode: vnode } = instance;
                let originNext = next;
                let vnodeHook;
                // Disallow component effect recursion during pre-lifecycle hooks.
                $0a6cc4ba868319ae$var$toggleRecurse(instance, false);
                if (next) {
                    next.el = vnode.el;
                    updateComponentPreRender(instance, next, optimized);
                } else next = vnode;
                // beforeUpdate hook
                if (bu) (0, $8POXm.invokeArrayFns)(bu);
                // onVnodeBeforeUpdate
                if (vnodeHook = next.props && next.props.onVnodeBeforeUpdate) $0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHook, parent, next, vnode);
                $0a6cc4ba868319ae$var$toggleRecurse(instance, true);
                const nextTree = $0a6cc4ba868319ae$var$renderComponentRoot(instance);
                const prevTree = instance.subTree;
                instance.subTree = nextTree;
                patch(prevTree, nextTree, // parent may have changed if it's in a teleport
                hostParentNode(prevTree.el), // anchor may have changed if it's in a fragment
                getNextHostNode(prevTree), instance, parentSuspense, isSVG);
                next.el = nextTree.el;
                if (originNext === null) // self-triggered update. In case of HOC, update parent component
                // vnode el. HOC is indicated by parent instance's subTree pointing
                // to child component's vnode
                $0a6cc4ba868319ae$var$updateHOCHostEl(instance, nextTree.el);
                // updated hook
                if (u) $0a6cc4ba868319ae$var$queuePostRenderEffect(u, parentSuspense);
                // onVnodeUpdated
                if (vnodeHook = next.props && next.props.onVnodeUpdated) $0a6cc4ba868319ae$var$queuePostRenderEffect(()=>$0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHook, parent, next, vnode), parentSuspense);
                if (__VUE_PROD_DEVTOOLS__) $0a6cc4ba868319ae$var$devtoolsComponentUpdated(instance);
            }
        };
        // create reactive effect for rendering
        const effect = instance.effect = new (0, $01W3b.ReactiveEffect)(componentUpdateFn, ()=>$0a6cc4ba868319ae$var$queueJob(update), instance.scope // track it in component's effect scope
        );
        const update = instance.update = ()=>effect.run();
        update.id = instance.uid;
        // allowRecurse
        // #1801, #2043 component render effects should allow recursive updates
        $0a6cc4ba868319ae$var$toggleRecurse(instance, true);
        var e, e1;
        update();
    };
    const updateComponentPreRender = (instance, nextVNode, optimized)=>{
        nextVNode.component = instance;
        const prevProps = instance.vnode.props;
        instance.vnode = nextVNode;
        instance.next = null;
        $0a6cc4ba868319ae$var$updateProps(instance, nextVNode.props, prevProps, optimized);
        $0a6cc4ba868319ae$var$updateSlots(instance, nextVNode.children, optimized);
        (0, $01W3b.pauseTracking)();
        // props update may have triggered pre-flush watchers.
        // flush them before the render update.
        $0a6cc4ba868319ae$var$flushPreFlushCbs();
        (0, $01W3b.resetTracking)();
    };
    const patchChildren = (n1, n2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized = false)=>{
        const c1 = n1 && n1.children;
        const prevShapeFlag = n1 ? n1.shapeFlag : 0;
        const c2 = n2.children;
        const { patchFlag: patchFlag, shapeFlag: shapeFlag } = n2;
        // fast path
        if (patchFlag > 0) {
            if (patchFlag & 128 /* PatchFlags.KEYED_FRAGMENT */ ) {
                // this could be either fully-keyed or mixed (some keyed some not)
                // presence of patchFlag means children are guaranteed to be arrays
                patchKeyedChildren(c1, c2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
                return;
            } else if (patchFlag & 256 /* PatchFlags.UNKEYED_FRAGMENT */ ) {
                // unkeyed
                patchUnkeyedChildren(c1, c2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
                return;
            }
        }
        // children has 3 possibilities: text, array or no children.
        if (shapeFlag & 8 /* ShapeFlags.TEXT_CHILDREN */ ) {
            // text children fast path
            if (prevShapeFlag & 16 /* ShapeFlags.ARRAY_CHILDREN */ ) unmountChildren(c1, parentComponent, parentSuspense);
            if (c2 !== c1) hostSetElementText(container, c2);
        } else if (prevShapeFlag & 16 /* ShapeFlags.ARRAY_CHILDREN */ ) {
            // prev children was array
            if (shapeFlag & 16 /* ShapeFlags.ARRAY_CHILDREN */ ) // two arrays, cannot assume anything, do full diff
            patchKeyedChildren(c1, c2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
            else // no new children, just unmount old
            unmountChildren(c1, parentComponent, parentSuspense, true);
        } else {
            // prev children was text OR null
            // new children is array OR null
            if (prevShapeFlag & 8 /* ShapeFlags.TEXT_CHILDREN */ ) hostSetElementText(container, '');
            // mount new if array
            if (shapeFlag & 16 /* ShapeFlags.ARRAY_CHILDREN */ ) mountChildren(c2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
        }
    };
    const patchUnkeyedChildren = (c1, c2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized)=>{
        c1 = c1 || (0, $8POXm.EMPTY_ARR);
        c2 = c2 || (0, $8POXm.EMPTY_ARR);
        const oldLength = c1.length;
        const newLength = c2.length;
        const commonLength = Math.min(oldLength, newLength);
        let i;
        for(i = 0; i < commonLength; i++){
            const nextChild = c2[i] = optimized ? $0a6cc4ba868319ae$var$cloneIfMounted(c2[i]) : $0a6cc4ba868319ae$var$normalizeVNode(c2[i]);
            patch(c1[i], nextChild, container, null, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
        }
        if (oldLength > newLength) // remove old
        unmountChildren(c1, parentComponent, parentSuspense, true, false, commonLength);
        else // mount new
        mountChildren(c2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized, commonLength);
    };
    // can be all-keyed or mixed
    const patchKeyedChildren = (c1, c2, container, parentAnchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized)=>{
        let i = 0;
        const l2 = c2.length;
        let e1 = c1.length - 1; // prev ending index
        let e2 = l2 - 1; // next ending index
        // 1. sync from start
        // (a b) c
        // (a b) d e
        while(i <= e1 && i <= e2){
            const n1 = c1[i];
            const n2 = c2[i] = optimized ? $0a6cc4ba868319ae$var$cloneIfMounted(c2[i]) : $0a6cc4ba868319ae$var$normalizeVNode(c2[i]);
            if ($0a6cc4ba868319ae$var$isSameVNodeType(n1, n2)) patch(n1, n2, container, null, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
            else break;
            i++;
        }
        // 2. sync from end
        // a (b c)
        // d e (b c)
        while(i <= e1 && i <= e2){
            const n1 = c1[e1];
            const n2 = c2[e2] = optimized ? $0a6cc4ba868319ae$var$cloneIfMounted(c2[e2]) : $0a6cc4ba868319ae$var$normalizeVNode(c2[e2]);
            if ($0a6cc4ba868319ae$var$isSameVNodeType(n1, n2)) patch(n1, n2, container, null, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
            else break;
            e1--;
            e2--;
        }
        // 3. common sequence + mount
        // (a b)
        // (a b) c
        // i = 2, e1 = 1, e2 = 2
        // (a b)
        // c (a b)
        // i = 0, e1 = -1, e2 = 0
        if (i > e1) {
            if (i <= e2) {
                const nextPos = e2 + 1;
                const anchor = nextPos < l2 ? c2[nextPos].el : parentAnchor;
                while(i <= e2){
                    patch(null, c2[i] = optimized ? $0a6cc4ba868319ae$var$cloneIfMounted(c2[i]) : $0a6cc4ba868319ae$var$normalizeVNode(c2[i]), container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
                    i++;
                }
            }
        } else if (i > e2) while(i <= e1){
            unmount(c1[i], parentComponent, parentSuspense, true);
            i++;
        }
        else {
            const s1 = i; // prev starting index
            const s2 = i; // next starting index
            // 5.1 build key:index map for newChildren
            const keyToNewIndexMap = new Map();
            for(i = s2; i <= e2; i++){
                const nextChild = c2[i] = optimized ? $0a6cc4ba868319ae$var$cloneIfMounted(c2[i]) : $0a6cc4ba868319ae$var$normalizeVNode(c2[i]);
                if (nextChild.key != null) keyToNewIndexMap.set(nextChild.key, i);
            }
            // 5.2 loop through old children left to be patched and try to patch
            // matching nodes & remove nodes that are no longer present
            let j;
            let patched = 0;
            const toBePatched = e2 - s2 + 1;
            let moved = false;
            // used to track whether any node has moved
            let maxNewIndexSoFar = 0;
            // works as Map<newIndex, oldIndex>
            // Note that oldIndex is offset by +1
            // and oldIndex = 0 is a special value indicating the new node has
            // no corresponding old node.
            // used for determining longest stable subsequence
            const newIndexToOldIndexMap = new Array(toBePatched);
            for(i = 0; i < toBePatched; i++)newIndexToOldIndexMap[i] = 0;
            for(i = s1; i <= e1; i++){
                const prevChild = c1[i];
                if (patched >= toBePatched) {
                    // all new children have been patched so this can only be a removal
                    unmount(prevChild, parentComponent, parentSuspense, true);
                    continue;
                }
                let newIndex;
                if (prevChild.key != null) newIndex = keyToNewIndexMap.get(prevChild.key);
                else {
                    // key-less node, try to locate a key-less node of the same type
                    for(j = s2; j <= e2; j++)if (newIndexToOldIndexMap[j - s2] === 0 && $0a6cc4ba868319ae$var$isSameVNodeType(prevChild, c2[j])) {
                        newIndex = j;
                        break;
                    }
                }
                if (newIndex === undefined) unmount(prevChild, parentComponent, parentSuspense, true);
                else {
                    newIndexToOldIndexMap[newIndex - s2] = i + 1;
                    if (newIndex >= maxNewIndexSoFar) maxNewIndexSoFar = newIndex;
                    else moved = true;
                    patch(prevChild, c2[newIndex], container, null, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
                    patched++;
                }
            }
            // 5.3 move and mount
            // generate longest stable subsequence only when nodes have moved
            const increasingNewIndexSequence = moved ? $0a6cc4ba868319ae$var$getSequence(newIndexToOldIndexMap) : (0, $8POXm.EMPTY_ARR);
            j = increasingNewIndexSequence.length - 1;
            // looping backwards so that we can use last patched node as anchor
            for(i = toBePatched - 1; i >= 0; i--){
                const nextIndex = s2 + i;
                const nextChild = c2[nextIndex];
                const anchor = nextIndex + 1 < l2 ? c2[nextIndex + 1].el : parentAnchor;
                if (newIndexToOldIndexMap[i] === 0) // mount new
                patch(null, nextChild, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
                else if (moved) {
                    // move if:
                    // There is no stable subsequence (e.g. a reverse)
                    // OR current node is not among the stable sequence
                    if (j < 0 || i !== increasingNewIndexSequence[j]) move(nextChild, container, anchor, 2 /* MoveType.REORDER */ );
                    else j--;
                }
            }
        }
    };
    const move = (vnode, container, anchor, moveType, parentSuspense = null)=>{
        const { el: el, type: type, transition: transition, children: children, shapeFlag: shapeFlag } = vnode;
        if (shapeFlag & 6 /* ShapeFlags.COMPONENT */ ) {
            move(vnode.component.subTree, container, anchor, moveType);
            return;
        }
        if (shapeFlag & 128 /* ShapeFlags.SUSPENSE */ ) {
            vnode.suspense.move(container, anchor, moveType);
            return;
        }
        if (shapeFlag & 64 /* ShapeFlags.TELEPORT */ ) {
            type.move(vnode, container, anchor, internals);
            return;
        }
        if (type === $0a6cc4ba868319ae$export$ffb0004e005737fa) {
            hostInsert(el, container, anchor);
            for(let i = 0; i < children.length; i++)move(children[i], container, anchor, moveType);
            hostInsert(vnode.anchor, container, anchor);
            return;
        }
        if (type === $0a6cc4ba868319ae$export$c1b9a1d3af45b7b6) {
            moveStaticNode(vnode, container, anchor);
            return;
        }
        // single nodes
        const needTransition = moveType !== 2 /* MoveType.REORDER */  && shapeFlag & 1 /* ShapeFlags.ELEMENT */  && transition;
        if (needTransition) {
            if (moveType === 0 /* MoveType.ENTER */ ) {
                transition.beforeEnter(el);
                hostInsert(el, container, anchor);
                $0a6cc4ba868319ae$var$queuePostRenderEffect(()=>transition.enter(el), parentSuspense);
            } else {
                const { leave: leave, delayLeave: delayLeave, afterLeave: afterLeave } = transition;
                const remove = ()=>hostInsert(el, container, anchor);
                const performLeave = ()=>{
                    leave(el, ()=>{
                        remove();
                        afterLeave && afterLeave();
                    });
                };
                if (delayLeave) delayLeave(el, remove, performLeave);
                else performLeave();
            }
        } else hostInsert(el, container, anchor);
    };
    const unmount = (vnode, parentComponent, parentSuspense, doRemove = false, optimized = false)=>{
        const { type: type, props: props, ref: ref, children: children, dynamicChildren: dynamicChildren, shapeFlag: shapeFlag, patchFlag: patchFlag, dirs: dirs } = vnode;
        // unset ref
        if (ref != null) $0a6cc4ba868319ae$var$setRef(ref, null, parentSuspense, vnode, true);
        if (shapeFlag & 256 /* ShapeFlags.COMPONENT_SHOULD_KEEP_ALIVE */ ) {
            parentComponent.ctx.deactivate(vnode);
            return;
        }
        const shouldInvokeDirs = shapeFlag & 1 /* ShapeFlags.ELEMENT */  && dirs;
        const shouldInvokeVnodeHook = !$0a6cc4ba868319ae$var$isAsyncWrapper(vnode);
        let vnodeHook;
        if (shouldInvokeVnodeHook && (vnodeHook = props && props.onVnodeBeforeUnmount)) $0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHook, parentComponent, vnode);
        if (shapeFlag & 6 /* ShapeFlags.COMPONENT */ ) unmountComponent(vnode.component, parentSuspense, doRemove);
        else {
            if (shapeFlag & 128 /* ShapeFlags.SUSPENSE */ ) {
                vnode.suspense.unmount(parentSuspense, doRemove);
                return;
            }
            if (shouldInvokeDirs) $0a6cc4ba868319ae$var$invokeDirectiveHook(vnode, null, parentComponent, 'beforeUnmount');
            if (shapeFlag & 64 /* ShapeFlags.TELEPORT */ ) vnode.type.remove(vnode, parentComponent, parentSuspense, optimized, internals, doRemove);
            else if (dynamicChildren && // #1153: fast path should not be taken for non-stable (v-for) fragments
            (type !== $0a6cc4ba868319ae$export$ffb0004e005737fa || patchFlag > 0 && patchFlag & 64 /* PatchFlags.STABLE_FRAGMENT */ )) // fast path for block nodes: only need to unmount dynamic children.
            unmountChildren(dynamicChildren, parentComponent, parentSuspense, false, true);
            else if (type === $0a6cc4ba868319ae$export$ffb0004e005737fa && patchFlag & 384 /* PatchFlags.UNKEYED_FRAGMENT */  || !optimized && shapeFlag & 16 /* ShapeFlags.ARRAY_CHILDREN */ ) unmountChildren(children, parentComponent, parentSuspense);
            if (doRemove) remove(vnode);
        }
        if (shouldInvokeVnodeHook && (vnodeHook = props && props.onVnodeUnmounted) || shouldInvokeDirs) $0a6cc4ba868319ae$var$queuePostRenderEffect(()=>{
            vnodeHook && $0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHook, parentComponent, vnode);
            shouldInvokeDirs && $0a6cc4ba868319ae$var$invokeDirectiveHook(vnode, null, parentComponent, 'unmounted');
        }, parentSuspense);
    };
    const remove = (vnode)=>{
        const { type: type, el: el, anchor: anchor, transition: transition } = vnode;
        if (type === $0a6cc4ba868319ae$export$ffb0004e005737fa) {
            var child;
            removeFragment(el, anchor);
            return;
        }
        if (type === $0a6cc4ba868319ae$export$c1b9a1d3af45b7b6) {
            removeStaticNode(vnode);
            return;
        }
        const performRemove = ()=>{
            hostRemove(el);
            if (transition && !transition.persisted && transition.afterLeave) transition.afterLeave();
        };
        if (vnode.shapeFlag & 1 /* ShapeFlags.ELEMENT */  && transition && !transition.persisted) {
            const { leave: leave, delayLeave: delayLeave } = transition;
            const performLeave = ()=>leave(el, performRemove);
            if (delayLeave) delayLeave(vnode.el, performRemove, performLeave);
            else performLeave();
        } else performRemove();
    };
    const removeFragment = (cur, end)=>{
        // For fragments, directly remove all contained DOM nodes.
        // (fragment child nodes cannot have transition)
        let next;
        while(cur !== end){
            next = hostNextSibling(cur);
            hostRemove(cur);
            cur = next;
        }
        hostRemove(end);
    };
    const unmountComponent = (instance, parentSuspense, doRemove)=>{
        const { bum: bum, scope: scope, update: update, subTree: subTree, um: um } = instance;
        // beforeUnmount hook
        if (bum) (0, $8POXm.invokeArrayFns)(bum);
        // stop effects in component scope
        scope.stop();
        // update may be null if a component is unmounted before its async
        // setup has resolved.
        if (update) {
            // so that scheduler will no longer invoke it
            update.active = false;
            unmount(subTree, instance, parentSuspense, doRemove);
        }
        // unmounted hook
        if (um) $0a6cc4ba868319ae$var$queuePostRenderEffect(um, parentSuspense);
        $0a6cc4ba868319ae$var$queuePostRenderEffect(()=>{
            instance.isUnmounted = true;
        }, parentSuspense);
        // A component with async dep inside a pending suspense is unmounted before
        // its async dep resolves. This should remove the dep from the suspense, and
        // cause the suspense to resolve immediately if that was the last dep.
        if (parentSuspense && parentSuspense.pendingBranch && !parentSuspense.isUnmounted && instance.asyncDep && !instance.asyncResolved && instance.suspenseId === parentSuspense.pendingId) {
            parentSuspense.deps--;
            if (parentSuspense.deps === 0) parentSuspense.resolve();
        }
        if (__VUE_PROD_DEVTOOLS__) $0a6cc4ba868319ae$var$devtoolsComponentRemoved(instance);
    };
    const unmountChildren = (children, parentComponent, parentSuspense, doRemove = false, optimized = false, start = 0)=>{
        for(let i = start; i < children.length; i++)unmount(children[i], parentComponent, parentSuspense, doRemove, optimized);
    };
    const getNextHostNode = (vnode)=>{
        if (vnode.shapeFlag & 6 /* ShapeFlags.COMPONENT */ ) return getNextHostNode(vnode.component.subTree);
        if (vnode.shapeFlag & 128 /* ShapeFlags.SUSPENSE */ ) return vnode.suspense.next();
        return hostNextSibling(vnode.anchor || vnode.el);
    };
    const render = (vnode, container, isSVG)=>{
        if (vnode == null) {
            if (container._vnode) unmount(container._vnode, null, null, true);
        } else patch(container._vnode || null, vnode, container, null, null, null, isSVG);
        $0a6cc4ba868319ae$var$flushPreFlushCbs();
        $0a6cc4ba868319ae$var$flushPostFlushCbs();
        container._vnode = vnode;
    };
    const internals = {
        p: patch,
        um: unmount,
        m: move,
        r: remove,
        mt: mountComponent,
        mc: mountChildren,
        pc: patchChildren,
        pbc: patchBlockChildren,
        n: getNextHostNode,
        o: options
    };
    let hydrate;
    let hydrateNode;
    if (createHydrationFns) [hydrate, hydrateNode] = createHydrationFns(internals);
    return {
        render: render,
        hydrate: hydrate,
        createApp: $0a6cc4ba868319ae$var$createAppAPI(render, hydrate)
    };
}
function $0a6cc4ba868319ae$var$toggleRecurse({ effect: effect, update: update }, allowed) {
    effect.allowRecurse = update.allowRecurse = allowed;
}
/**
 * #1156
 * When a component is HMR-enabled, we need to make sure that all static nodes
 * inside a block also inherit the DOM element from the previous tree so that
 * HMR updates (which are full updates) can retrieve the element for patching.
 *
 * #2080
 * Inside keyed `template` fragment static children, if a fragment is moved,
 * the children will always be moved. Therefore, in order to ensure correct move
 * position, el should be inherited from previous nodes.
 */ function $0a6cc4ba868319ae$var$traverseStaticChildren(n1, n2, shallow = false) {
    const ch1 = n1.children;
    const ch2 = n2.children;
    if ((0, $8POXm.isArray)(ch1) && (0, $8POXm.isArray)(ch2)) for(let i = 0; i < ch1.length; i++){
        // this is only called in the optimized path so array children are
        // guaranteed to be vnodes
        const c1 = ch1[i];
        let c2 = ch2[i];
        if (c2.shapeFlag & 1 /* ShapeFlags.ELEMENT */  && !c2.dynamicChildren) {
            if (c2.patchFlag <= 0 || c2.patchFlag === 32 /* PatchFlags.HYDRATE_EVENTS */ ) {
                c2 = ch2[i] = $0a6cc4ba868319ae$var$cloneIfMounted(ch2[i]);
                c2.el = c1.el;
            }
            if (!shallow) $0a6cc4ba868319ae$var$traverseStaticChildren(c1, c2);
        }
    }
}
// https://en.wikipedia.org/wiki/Longest_increasing_subsequence
function $0a6cc4ba868319ae$var$getSequence(arr) {
    const p = arr.slice();
    const result = [
        0
    ];
    let i, j, u, v1, c;
    const len = arr.length;
    for(i = 0; i < len; i++){
        const arrI = arr[i];
        if (arrI !== 0) {
            j = result[result.length - 1];
            if (arr[j] < arrI) {
                p[i] = j;
                result.push(i);
                continue;
            }
            u = 0;
            v1 = result.length - 1;
            while(u < v1){
                c = u + v1 >> 1;
                if (arr[result[c]] < arrI) u = c + 1;
                else v1 = c;
            }
            if (arrI < arr[result[u]]) {
                if (u > 0) p[i] = result[u - 1];
                result[u] = i;
            }
        }
    }
    u = result.length;
    v1 = result[u - 1];
    while(u-- > 0){
        result[u] = v1;
        v1 = p[v1];
    }
    return result;
}
const $0a6cc4ba868319ae$var$isTeleport = (type)=>type.__isTeleport;
const $0a6cc4ba868319ae$var$isTeleportDisabled = (props)=>props && (props.disabled || props.disabled === '');
const $0a6cc4ba868319ae$var$isTargetSVG = (target)=>typeof SVGElement !== 'undefined' && target instanceof SVGElement;
const $0a6cc4ba868319ae$var$resolveTarget = (props, select)=>{
    const targetSelector = props && props.to;
    if ((0, $8POXm.isString)(targetSelector)) {
        if (!select) return null;
        else {
            const target = select(targetSelector);
            target;
            return target;
        }
    } else return targetSelector;
};
const $0a6cc4ba868319ae$var$TeleportImpl = {
    __isTeleport: true,
    process (n1, n2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized, internals) {
        const { mc: mountChildren, pc: patchChildren, pbc: patchBlockChildren, o: { insert: insert, querySelector: querySelector, createText: createText, createComment: createComment } } = internals;
        const disabled = $0a6cc4ba868319ae$var$isTeleportDisabled(n2.props);
        let { shapeFlag: shapeFlag, children: children, dynamicChildren: dynamicChildren } = n2;
        if (n1 == null) {
            // insert anchors in the main view
            const placeholder = n2.el = createText('');
            const mainAnchor = n2.anchor = createText('');
            insert(placeholder, container, anchor);
            insert(mainAnchor, container, anchor);
            const target = n2.target = $0a6cc4ba868319ae$var$resolveTarget(n2.props, querySelector);
            const targetAnchor = n2.targetAnchor = createText('');
            if (target) {
                insert(targetAnchor, target);
                // #2652 we could be teleporting from a non-SVG tree into an SVG tree
                isSVG = isSVG || $0a6cc4ba868319ae$var$isTargetSVG(target);
            }
            const mount = (container, anchor)=>{
                // Teleport *always* has Array children. This is enforced in both the
                // compiler and vnode children normalization.
                if (shapeFlag & 16 /* ShapeFlags.ARRAY_CHILDREN */ ) mountChildren(children, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
            };
            if (disabled) mount(container, mainAnchor);
            else if (target) mount(target, targetAnchor);
        } else {
            // update content
            n2.el = n1.el;
            const mainAnchor = n2.anchor = n1.anchor;
            const target = n2.target = n1.target;
            const targetAnchor = n2.targetAnchor = n1.targetAnchor;
            const wasDisabled = $0a6cc4ba868319ae$var$isTeleportDisabled(n1.props);
            const currentContainer = wasDisabled ? container : target;
            const currentAnchor = wasDisabled ? mainAnchor : targetAnchor;
            isSVG = isSVG || $0a6cc4ba868319ae$var$isTargetSVG(target);
            if (dynamicChildren) {
                // fast path when the teleport happens to be a block root
                patchBlockChildren(n1.dynamicChildren, dynamicChildren, currentContainer, parentComponent, parentSuspense, isSVG, slotScopeIds);
                // even in block tree mode we need to make sure all root-level nodes
                // in the teleport inherit previous DOM references so that they can
                // be moved in future patches.
                $0a6cc4ba868319ae$var$traverseStaticChildren(n1, n2, true);
            } else if (!optimized) patchChildren(n1, n2, currentContainer, currentAnchor, parentComponent, parentSuspense, isSVG, slotScopeIds, false);
            if (disabled) {
                if (!wasDisabled) // enabled -> disabled
                // move into main container
                $0a6cc4ba868319ae$var$moveTeleport(n2, container, mainAnchor, internals, 1 /* TeleportMoveTypes.TOGGLE */ );
            } else {
                // target changed
                if ((n2.props && n2.props.to) !== (n1.props && n1.props.to)) {
                    const nextTarget = n2.target = $0a6cc4ba868319ae$var$resolveTarget(n2.props, querySelector);
                    if (nextTarget) $0a6cc4ba868319ae$var$moveTeleport(n2, nextTarget, null, internals, 0 /* TeleportMoveTypes.TARGET_CHANGE */ );
                } else if (wasDisabled) // disabled -> enabled
                // move into teleport target
                $0a6cc4ba868319ae$var$moveTeleport(n2, target, targetAnchor, internals, 1 /* TeleportMoveTypes.TOGGLE */ );
            }
        }
    },
    remove (vnode, parentComponent, parentSuspense, optimized, { um: unmount, o: { remove: hostRemove } }, doRemove) {
        const { shapeFlag: shapeFlag, children: children, anchor: anchor, targetAnchor: targetAnchor, target: target, props: props } = vnode;
        if (target) hostRemove(targetAnchor);
        // an unmounted teleport should always remove its children if not disabled
        if (doRemove || !$0a6cc4ba868319ae$var$isTeleportDisabled(props)) {
            hostRemove(anchor);
            if (shapeFlag & 16 /* ShapeFlags.ARRAY_CHILDREN */ ) for(let i = 0; i < children.length; i++){
                const child = children[i];
                unmount(child, parentComponent, parentSuspense, true, !!child.dynamicChildren);
            }
        }
    },
    move: $0a6cc4ba868319ae$var$moveTeleport,
    hydrate: $0a6cc4ba868319ae$var$hydrateTeleport
};
function $0a6cc4ba868319ae$var$moveTeleport(vnode, container, parentAnchor, { o: { insert: insert }, m: move }, moveType = 2 /* TeleportMoveTypes.REORDER */ ) {
    // move target anchor if this is a target change.
    if (moveType === 0 /* TeleportMoveTypes.TARGET_CHANGE */ ) insert(vnode.targetAnchor, container, parentAnchor);
    const { el: el, anchor: anchor, shapeFlag: shapeFlag, children: children, props: props } = vnode;
    const isReorder = moveType === 2 /* TeleportMoveTypes.REORDER */ ;
    // move main view anchor if this is a re-order.
    if (isReorder) insert(el, container, parentAnchor);
    // if this is a re-order and teleport is enabled (content is in target)
    // do not move children. So the opposite is: only move children if this
    // is not a reorder, or the teleport is disabled
    if (!isReorder || $0a6cc4ba868319ae$var$isTeleportDisabled(props)) {
        // Teleport has either Array children or no children.
        if (shapeFlag & 16 /* ShapeFlags.ARRAY_CHILDREN */ ) for(let i = 0; i < children.length; i++)move(children[i], container, parentAnchor, 2 /* MoveType.REORDER */ );
    }
    // move main view anchor if this is a re-order.
    if (isReorder) insert(anchor, container, parentAnchor);
}
function $0a6cc4ba868319ae$var$hydrateTeleport(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized, { o: { nextSibling: nextSibling, parentNode: parentNode, querySelector: querySelector } }, hydrateChildren) {
    const target = vnode.target = $0a6cc4ba868319ae$var$resolveTarget(vnode.props, querySelector);
    if (target) {
        // if multiple teleports rendered to the same target element, we need to
        // pick up from where the last teleport finished instead of the first node
        const targetNode = target._lpa || target.firstChild;
        if (vnode.shapeFlag & 16 /* ShapeFlags.ARRAY_CHILDREN */ ) {
            if ($0a6cc4ba868319ae$var$isTeleportDisabled(vnode.props)) {
                vnode.anchor = hydrateChildren(nextSibling(node), vnode, parentNode(node), parentComponent, parentSuspense, slotScopeIds, optimized);
                vnode.targetAnchor = targetNode;
            } else {
                vnode.anchor = nextSibling(node);
                // lookahead until we find the target anchor
                // we cannot rely on return value of hydrateChildren() because there
                // could be nested teleports
                let targetAnchor = targetNode;
                while(targetAnchor){
                    targetAnchor = nextSibling(targetAnchor);
                    if (targetAnchor && targetAnchor.nodeType === 8 && targetAnchor.data === 'teleport anchor') {
                        vnode.targetAnchor = targetAnchor;
                        target._lpa = vnode.targetAnchor && nextSibling(vnode.targetAnchor);
                        break;
                    }
                }
                hydrateChildren(targetNode, vnode, target, parentComponent, parentSuspense, slotScopeIds, optimized);
            }
        }
    }
    return vnode.anchor && nextSibling(vnode.anchor);
}
// Force-casted public typing for h and TSX props inference
const $0a6cc4ba868319ae$export$76d55a0304a371f4 = $0a6cc4ba868319ae$var$TeleportImpl;
const $0a6cc4ba868319ae$export$ffb0004e005737fa = Symbol(undefined);
const $0a6cc4ba868319ae$export$5f1af8db9871e1d6 = Symbol(undefined);
const $0a6cc4ba868319ae$export$4d299b491347818a = Symbol(undefined);
const $0a6cc4ba868319ae$export$c1b9a1d3af45b7b6 = Symbol(undefined);
// Since v-if and v-for are the two possible ways node structure can dynamically
// change, once we consider v-if branches and each v-for fragment a block, we
// can divide a template into nested blocks, and within each block the node
// structure would be stable. This allows us to skip most children diffing
// and only worry about the dynamic nodes (indicated by patch flags).
const $0a6cc4ba868319ae$var$blockStack = [];
let $0a6cc4ba868319ae$var$currentBlock = null;
/**
 * Open a block.
 * This must be called before `createBlock`. It cannot be part of `createBlock`
 * because the children of the block are evaluated before `createBlock` itself
 * is called. The generated code typically looks like this:
 *
 * ```js
 * function render() {
 *   return (openBlock(),createBlock('div', null, [...]))
 * }
 * ```
 * disableTracking is true when creating a v-for fragment block, since a v-for
 * fragment always diffs its children.
 *
 * @private
 */ function $0a6cc4ba868319ae$export$e7eaa45e502fe5cc(disableTracking = false) {
    $0a6cc4ba868319ae$var$blockStack.push($0a6cc4ba868319ae$var$currentBlock = disableTracking ? null : []);
}
function $0a6cc4ba868319ae$var$closeBlock() {
    $0a6cc4ba868319ae$var$blockStack.pop();
    $0a6cc4ba868319ae$var$currentBlock = $0a6cc4ba868319ae$var$blockStack[$0a6cc4ba868319ae$var$blockStack.length - 1] || null;
}
// Whether we should be tracking dynamic child nodes inside a block.
// Only tracks when this value is > 0
// We are not using a simple boolean because this value may need to be
// incremented/decremented by nested usage of v-once (see below)
let $0a6cc4ba868319ae$var$isBlockTreeEnabled = 1;
/**
 * Block tracking sometimes needs to be disabled, for example during the
 * creation of a tree that needs to be cached by v-once. The compiler generates
 * code like this:
 *
 * ``` js
 * _cache[1] || (
 *   setBlockTracking(-1),
 *   _cache[1] = createVNode(...),
 *   setBlockTracking(1),
 *   _cache[1]
 * )
 * ```
 *
 * @private
 */ function $0a6cc4ba868319ae$export$c20bee82f26f1e27(value) {
    $0a6cc4ba868319ae$var$isBlockTreeEnabled += value;
}
function $0a6cc4ba868319ae$var$setupBlock(vnode) {
    // save current block children on the block vnode
    vnode.dynamicChildren = $0a6cc4ba868319ae$var$isBlockTreeEnabled > 0 ? $0a6cc4ba868319ae$var$currentBlock || (0, $8POXm.EMPTY_ARR) : null;
    // close block
    $0a6cc4ba868319ae$var$closeBlock();
    // a block is always going to be patched, so track it as a child of its
    // parent block
    if ($0a6cc4ba868319ae$var$isBlockTreeEnabled > 0 && $0a6cc4ba868319ae$var$currentBlock) $0a6cc4ba868319ae$var$currentBlock.push(vnode);
    return vnode;
}
/**
 * @private
 */ function $0a6cc4ba868319ae$export$167055419fc69ec1(type, props, children, patchFlag, dynamicProps, shapeFlag) {
    return $0a6cc4ba868319ae$var$setupBlock($0a6cc4ba868319ae$export$42098e0eaa15c48e(type, props, children, patchFlag, dynamicProps, shapeFlag, true));
}
/**
 * Create a block root vnode. Takes the same exact arguments as `createVNode`.
 * A block root keeps track of dynamic nodes within the block in the
 * `dynamicChildren` array.
 *
 * @private
 */ function $0a6cc4ba868319ae$export$9f2dfe8048dfb22b(type, props, children, patchFlag, dynamicProps) {
    return $0a6cc4ba868319ae$var$setupBlock($0a6cc4ba868319ae$export$bf5c4cf060303d58(type, props, children, patchFlag, dynamicProps, true));
}
function $0a6cc4ba868319ae$export$3868d13f8734ae81(value) {
    return value ? value.__v_isVNode === true : false;
}
function $0a6cc4ba868319ae$var$isSameVNodeType(n1, n2) {
    return n1.type === n2.type && n1.key === n2.key;
}
let $0a6cc4ba868319ae$var$vnodeArgsTransformer;
/**
 * Internal API for registering an arguments transform for createVNode
 * used for creating stubs in the test-utils
 * It is *internal* but needs to be exposed for test-utils to pick up proper
 * typings
 */ function $0a6cc4ba868319ae$export$83beccd3afeeb809(transformer) {
    $0a6cc4ba868319ae$var$vnodeArgsTransformer = transformer;
}
const $0a6cc4ba868319ae$var$createVNodeWithArgsTransform = (...args)=>{
    return $0a6cc4ba868319ae$var$_createVNode(...$0a6cc4ba868319ae$var$vnodeArgsTransformer ? $0a6cc4ba868319ae$var$vnodeArgsTransformer(args, $0a6cc4ba868319ae$var$currentRenderingInstance) : args);
};
const $0a6cc4ba868319ae$var$InternalObjectKey = `__vInternal`;
const $0a6cc4ba868319ae$var$normalizeKey = ({ key: key })=>key != null ? key : null;
const $0a6cc4ba868319ae$var$normalizeRef = ({ ref: ref, ref_key: ref_key, ref_for: ref_for })=>{
    return ref != null ? (0, $8POXm.isString)(ref) || (0, $01W3b.isRef)(ref) || (0, $8POXm.isFunction)(ref) ? {
        i: $0a6cc4ba868319ae$var$currentRenderingInstance,
        r: ref,
        k: ref_key,
        f: !!ref_for
    } : ref : null;
};
function $0a6cc4ba868319ae$export$42098e0eaa15c48e(type, props = null, children = null, patchFlag = 0, dynamicProps = null, shapeFlag = type === $0a6cc4ba868319ae$export$ffb0004e005737fa ? 0 : 1 /* ShapeFlags.ELEMENT */ , isBlockNode = false, needFullChildrenNormalization = false) {
    const vnode = {
        __v_isVNode: true,
        __v_skip: true,
        type: type,
        props: props,
        key: props && $0a6cc4ba868319ae$var$normalizeKey(props),
        ref: props && $0a6cc4ba868319ae$var$normalizeRef(props),
        scopeId: $0a6cc4ba868319ae$var$currentScopeId,
        slotScopeIds: null,
        children: children,
        component: null,
        suspense: null,
        ssContent: null,
        ssFallback: null,
        dirs: null,
        transition: null,
        el: null,
        anchor: null,
        target: null,
        targetAnchor: null,
        staticCount: 0,
        shapeFlag: shapeFlag,
        patchFlag: patchFlag,
        dynamicProps: dynamicProps,
        dynamicChildren: null,
        appContext: null
    };
    if (needFullChildrenNormalization) {
        $0a6cc4ba868319ae$var$normalizeChildren(vnode, children);
        // normalize suspense children
        if (shapeFlag & 128 /* ShapeFlags.SUSPENSE */ ) type.normalize(vnode);
    } else if (children) // compiled element vnode - if children is passed, only possible types are
    // string or Array.
    vnode.shapeFlag |= (0, $8POXm.isString)(children) ? 8 /* ShapeFlags.TEXT_CHILDREN */  : 16 /* ShapeFlags.ARRAY_CHILDREN */ ;
    // track vnode for block tree
    if ($0a6cc4ba868319ae$var$isBlockTreeEnabled > 0 && // avoid a block node from tracking itself
    !isBlockNode && // has current parent block
    $0a6cc4ba868319ae$var$currentBlock && // presence of a patch flag indicates this node needs patching on updates.
    // component nodes also should always be patched, because even if the
    // component doesn't need to update, it needs to persist the instance on to
    // the next vnode so that it can be properly unmounted later.
    (vnode.patchFlag > 0 || shapeFlag & 6 /* ShapeFlags.COMPONENT */ ) && // the EVENTS flag is only for hydration and if it is the only flag, the
    // vnode should not be considered dynamic due to handler caching.
    vnode.patchFlag !== 32 /* PatchFlags.HYDRATE_EVENTS */ ) $0a6cc4ba868319ae$var$currentBlock.push(vnode);
    return vnode;
}
const $0a6cc4ba868319ae$export$bf5c4cf060303d58 = $0a6cc4ba868319ae$var$_createVNode;
function $0a6cc4ba868319ae$var$_createVNode(type, props = null, children = null, patchFlag = 0, dynamicProps = null, isBlockNode = false) {
    if (!type || type === $0a6cc4ba868319ae$var$NULL_DYNAMIC_COMPONENT) type = $0a6cc4ba868319ae$export$4d299b491347818a;
    if ($0a6cc4ba868319ae$export$3868d13f8734ae81(type)) {
        // createVNode receiving an existing vnode. This happens in cases like
        // <component :is="vnode"/>
        // #2078 make sure to merge refs during the clone instead of overwriting it
        const cloned = $0a6cc4ba868319ae$export$ee4f9e12c0a92a1a(type, props, true);
        if (children) $0a6cc4ba868319ae$var$normalizeChildren(cloned, children);
        if ($0a6cc4ba868319ae$var$isBlockTreeEnabled > 0 && !isBlockNode && $0a6cc4ba868319ae$var$currentBlock) {
            if (cloned.shapeFlag & 6 /* ShapeFlags.COMPONENT */ ) $0a6cc4ba868319ae$var$currentBlock[$0a6cc4ba868319ae$var$currentBlock.indexOf(type)] = cloned;
            else $0a6cc4ba868319ae$var$currentBlock.push(cloned);
        }
        cloned.patchFlag |= -2 /* PatchFlags.BAIL */ ;
        return cloned;
    }
    // class component normalization.
    if ($0a6cc4ba868319ae$var$isClassComponent(type)) type = type.__vccOpts;
    // class & style normalization.
    if (props) {
        // for reactive or proxy objects, we need to clone it to enable mutation.
        props = $0a6cc4ba868319ae$export$1f1be0e0e384d7d2(props);
        let { class: klass, style: style } = props;
        if (klass && !(0, $8POXm.isString)(klass)) props.class = (0, $8POXm.normalizeClass)(klass);
        if ((0, $8POXm.isObject)(style)) {
            // reactive state objects need to be cloned since they are likely to be
            // mutated
            if ((0, $01W3b.isProxy)(style) && !(0, $8POXm.isArray)(style)) style = (0, $8POXm.extend)({}, style);
            props.style = (0, $8POXm.normalizeStyle)(style);
        }
    }
    // encode the vnode type information into a bitmap
    const shapeFlag = (0, $8POXm.isString)(type) ? 1 /* ShapeFlags.ELEMENT */  : $0a6cc4ba868319ae$var$isSuspense(type) ? 128 /* ShapeFlags.SUSPENSE */  : $0a6cc4ba868319ae$var$isTeleport(type) ? 64 /* ShapeFlags.TELEPORT */  : (0, $8POXm.isObject)(type) ? 4 /* ShapeFlags.STATEFUL_COMPONENT */  : (0, $8POXm.isFunction)(type) ? 2 /* ShapeFlags.FUNCTIONAL_COMPONENT */  : 0;
    return $0a6cc4ba868319ae$export$42098e0eaa15c48e(type, props, children, patchFlag, dynamicProps, shapeFlag, isBlockNode, true);
}
function $0a6cc4ba868319ae$export$1f1be0e0e384d7d2(props) {
    if (!props) return null;
    return (0, $01W3b.isProxy)(props) || $0a6cc4ba868319ae$var$InternalObjectKey in props ? (0, $8POXm.extend)({}, props) : props;
}
function $0a6cc4ba868319ae$export$ee4f9e12c0a92a1a(vnode, extraProps, mergeRef = false) {
    // This is intentionally NOT using spread or extend to avoid the runtime
    // key enumeration cost.
    const { props: props, ref: ref, patchFlag: patchFlag, children: children } = vnode;
    const mergedProps = extraProps ? $0a6cc4ba868319ae$export$9d1611c77c2fe928(props || {}, extraProps) : props;
    const cloned = {
        __v_isVNode: true,
        __v_skip: true,
        type: vnode.type,
        props: mergedProps,
        key: mergedProps && $0a6cc4ba868319ae$var$normalizeKey(mergedProps),
        ref: extraProps && extraProps.ref ? // if the vnode itself already has a ref, cloneVNode will need to merge
        // the refs so the single vnode can be set on multiple refs
        mergeRef && ref ? (0, $8POXm.isArray)(ref) ? ref.concat($0a6cc4ba868319ae$var$normalizeRef(extraProps)) : [
            ref,
            $0a6cc4ba868319ae$var$normalizeRef(extraProps)
        ] : $0a6cc4ba868319ae$var$normalizeRef(extraProps) : ref,
        scopeId: vnode.scopeId,
        slotScopeIds: vnode.slotScopeIds,
        children: children,
        target: vnode.target,
        targetAnchor: vnode.targetAnchor,
        staticCount: vnode.staticCount,
        shapeFlag: vnode.shapeFlag,
        // if the vnode is cloned with extra props, we can no longer assume its
        // existing patch flag to be reliable and need to add the FULL_PROPS flag.
        // note: preserve flag for fragments since they use the flag for children
        // fast paths only.
        patchFlag: extraProps && vnode.type !== $0a6cc4ba868319ae$export$ffb0004e005737fa ? patchFlag === -1 // hoisted node
         ? 16 /* PatchFlags.FULL_PROPS */  : patchFlag | 16 /* PatchFlags.FULL_PROPS */  : patchFlag,
        dynamicProps: vnode.dynamicProps,
        dynamicChildren: vnode.dynamicChildren,
        appContext: vnode.appContext,
        dirs: vnode.dirs,
        transition: vnode.transition,
        // These should technically only be non-null on mounted VNodes. However,
        // they *should* be copied for kept-alive vnodes. So we just always copy
        // them since them being non-null during a mount doesn't affect the logic as
        // they will simply be overwritten.
        component: vnode.component,
        suspense: vnode.suspense,
        ssContent: vnode.ssContent && $0a6cc4ba868319ae$export$ee4f9e12c0a92a1a(vnode.ssContent),
        ssFallback: vnode.ssFallback && $0a6cc4ba868319ae$export$ee4f9e12c0a92a1a(vnode.ssFallback),
        el: vnode.el,
        anchor: vnode.anchor
    };
    return cloned;
}
/**
 * Dev only, for HMR of hoisted vnodes reused in v-for
 * https://github.com/vitejs/vite/issues/2022
 */ function $0a6cc4ba868319ae$var$deepCloneVNode(vnode) {
    const cloned = $0a6cc4ba868319ae$export$ee4f9e12c0a92a1a(vnode);
    if ((0, $8POXm.isArray)(vnode.children)) cloned.children = vnode.children.map($0a6cc4ba868319ae$var$deepCloneVNode);
    return cloned;
}
/**
 * @private
 */ function $0a6cc4ba868319ae$export$22f9b5ffd89dac9(text = ' ', flag = 0) {
    return $0a6cc4ba868319ae$export$bf5c4cf060303d58($0a6cc4ba868319ae$export$5f1af8db9871e1d6, null, text, flag);
}
/**
 * @private
 */ function $0a6cc4ba868319ae$export$33a9f6dd2840e6bb(content, numberOfNodes) {
    // A static vnode can contain multiple stringified elements, and the number
    // of elements is necessary for hydration.
    const vnode = $0a6cc4ba868319ae$export$bf5c4cf060303d58($0a6cc4ba868319ae$export$c1b9a1d3af45b7b6, null, content);
    vnode.staticCount = numberOfNodes;
    return vnode;
}
/**
 * @private
 */ function $0a6cc4ba868319ae$export$49553837c7236d3c(text = '', // when used as the v-else branch, the comment node must be created as a
// block to ensure correct updates.
asBlock = false) {
    return asBlock ? ($0a6cc4ba868319ae$export$e7eaa45e502fe5cc(), $0a6cc4ba868319ae$export$9f2dfe8048dfb22b($0a6cc4ba868319ae$export$4d299b491347818a, null, text)) : $0a6cc4ba868319ae$export$bf5c4cf060303d58($0a6cc4ba868319ae$export$4d299b491347818a, null, text);
}
function $0a6cc4ba868319ae$var$normalizeVNode(child) {
    if (child == null || typeof child === 'boolean') // empty placeholder
    return $0a6cc4ba868319ae$export$bf5c4cf060303d58($0a6cc4ba868319ae$export$4d299b491347818a);
    else if ((0, $8POXm.isArray)(child)) // fragment
    return $0a6cc4ba868319ae$export$bf5c4cf060303d58($0a6cc4ba868319ae$export$ffb0004e005737fa, null, // #3666, avoid reference pollution when reusing vnode
    child.slice());
    else if (typeof child === 'object') // already vnode, this should be the most common since compiled templates
    // always produce all-vnode children arrays
    return $0a6cc4ba868319ae$var$cloneIfMounted(child);
    else // strings and numbers
    return $0a6cc4ba868319ae$export$bf5c4cf060303d58($0a6cc4ba868319ae$export$5f1af8db9871e1d6, null, String(child));
}
// optimized normalization for template-compiled render fns
function $0a6cc4ba868319ae$var$cloneIfMounted(child) {
    return child.el === null || child.memo ? child : $0a6cc4ba868319ae$export$ee4f9e12c0a92a1a(child);
}
function $0a6cc4ba868319ae$var$normalizeChildren(vnode, children) {
    let type = 0;
    const { shapeFlag: shapeFlag } = vnode;
    if (children == null) children = null;
    else if ((0, $8POXm.isArray)(children)) type = 16 /* ShapeFlags.ARRAY_CHILDREN */ ;
    else if (typeof children === 'object') {
        if (shapeFlag & 65 /* ShapeFlags.TELEPORT */ ) {
            // Normalize slot to plain children for plain element and Teleport
            const slot = children.default;
            if (slot) {
                // _c marker is added by withCtx() indicating this is a compiled slot
                slot._c && (slot._d = false);
                $0a6cc4ba868319ae$var$normalizeChildren(vnode, slot());
                slot._c && (slot._d = true);
            }
            return;
        } else {
            type = 32 /* ShapeFlags.SLOTS_CHILDREN */ ;
            const slotFlag = children._;
            if (!slotFlag && !($0a6cc4ba868319ae$var$InternalObjectKey in children)) children._ctx = $0a6cc4ba868319ae$var$currentRenderingInstance;
            else if (slotFlag === 3 /* SlotFlags.FORWARDED */  && $0a6cc4ba868319ae$var$currentRenderingInstance) {
                // a child component receives forwarded slots from the parent.
                // its slot type is determined by its parent's slot type.
                if ($0a6cc4ba868319ae$var$currentRenderingInstance.slots._ === 1 /* SlotFlags.STABLE */ ) children._ = 1 /* SlotFlags.STABLE */ ;
                else {
                    children._ = 2 /* SlotFlags.DYNAMIC */ ;
                    vnode.patchFlag |= 1024 /* PatchFlags.DYNAMIC_SLOTS */ ;
                }
            }
        }
    } else if ((0, $8POXm.isFunction)(children)) {
        children = {
            default: children,
            _ctx: $0a6cc4ba868319ae$var$currentRenderingInstance
        };
        type = 32 /* ShapeFlags.SLOTS_CHILDREN */ ;
    } else {
        children = String(children);
        // force teleport children to array so it can be moved around
        if (shapeFlag & 64 /* ShapeFlags.TELEPORT */ ) {
            type = 16 /* ShapeFlags.ARRAY_CHILDREN */ ;
            children = [
                $0a6cc4ba868319ae$export$22f9b5ffd89dac9(children)
            ];
        } else type = 8 /* ShapeFlags.TEXT_CHILDREN */ ;
    }
    vnode.children = children;
    vnode.shapeFlag |= type;
}
function $0a6cc4ba868319ae$export$9d1611c77c2fe928(...args) {
    const ret = {};
    for(let i = 0; i < args.length; i++){
        const toMerge = args[i];
        for(const key in toMerge){
            if (key === 'class') {
                if (ret.class !== toMerge.class) ret.class = (0, $8POXm.normalizeClass)([
                    ret.class,
                    toMerge.class
                ]);
            } else if (key === 'style') ret.style = (0, $8POXm.normalizeStyle)([
                ret.style,
                toMerge.style
            ]);
            else if ((0, $8POXm.isOn)(key)) {
                const existing = ret[key];
                const incoming = toMerge[key];
                if (incoming && existing !== incoming && !((0, $8POXm.isArray)(existing) && existing.includes(incoming))) ret[key] = existing ? [].concat(existing, incoming) : incoming;
            } else if (key !== '') ret[key] = toMerge[key];
        }
    }
    return ret;
}
function $0a6cc4ba868319ae$var$invokeVNodeHook(hook, instance, vnode, prevVNode = null) {
    $0a6cc4ba868319ae$export$dae85862a8d94378(hook, instance, 7 /* ErrorCodes.VNODE_HOOK */ , [
        vnode,
        prevVNode
    ]);
}
const $0a6cc4ba868319ae$var$emptyAppContext = $0a6cc4ba868319ae$var$createAppContext();
let $0a6cc4ba868319ae$var$uid$1 = 0;
function $0a6cc4ba868319ae$var$createComponentInstance(vnode, parent, suspense) {
    const type = vnode.type;
    // inherit parent app context - or - if root, adopt from root vnode
    const appContext = (parent ? parent.appContext : vnode.appContext) || $0a6cc4ba868319ae$var$emptyAppContext;
    const instance = {
        uid: $0a6cc4ba868319ae$var$uid$1++,
        vnode: vnode,
        type: type,
        parent: parent,
        appContext: appContext,
        root: null,
        next: null,
        subTree: null,
        effect: null,
        update: null,
        scope: new (0, $01W3b.EffectScope)(true),
        render: null,
        proxy: null,
        exposed: null,
        exposeProxy: null,
        withProxy: null,
        provides: parent ? parent.provides : Object.create(appContext.provides),
        accessCache: null,
        renderCache: [],
        // local resolved assets
        components: null,
        directives: null,
        // resolved props and emits options
        propsOptions: $0a6cc4ba868319ae$var$normalizePropsOptions(type, appContext),
        emitsOptions: $0a6cc4ba868319ae$var$normalizeEmitsOptions(type, appContext),
        // emit
        emit: null,
        emitted: null,
        // props default value
        propsDefaults: (0, $8POXm.EMPTY_OBJ),
        // inheritAttrs
        inheritAttrs: type.inheritAttrs,
        // state
        ctx: (0, $8POXm.EMPTY_OBJ),
        data: (0, $8POXm.EMPTY_OBJ),
        props: (0, $8POXm.EMPTY_OBJ),
        attrs: (0, $8POXm.EMPTY_OBJ),
        slots: (0, $8POXm.EMPTY_OBJ),
        refs: (0, $8POXm.EMPTY_OBJ),
        setupState: (0, $8POXm.EMPTY_OBJ),
        setupContext: null,
        suspense: // suspense related
        suspense,
        suspenseId: suspense ? suspense.pendingId : 0,
        asyncDep: null,
        asyncResolved: false,
        // lifecycle hooks
        // not using enums here because it results in computed properties
        isMounted: false,
        isUnmounted: false,
        isDeactivated: false,
        bc: null,
        c: null,
        bm: null,
        m: null,
        bu: null,
        u: null,
        um: null,
        bum: null,
        da: null,
        a: null,
        rtg: null,
        rtc: null,
        ec: null,
        sp: null
    };
    instance.ctx = {
        _: instance
    };
    instance.root = parent ? parent.root : instance;
    instance.emit = $0a6cc4ba868319ae$var$emit$1.bind(null, instance);
    // apply custom element special handling
    if (vnode.ce) vnode.ce(instance);
    return instance;
}
let $0a6cc4ba868319ae$var$currentInstance = null;
const $0a6cc4ba868319ae$export$f13e630aa3915748 = ()=>$0a6cc4ba868319ae$var$currentInstance || $0a6cc4ba868319ae$var$currentRenderingInstance;
const $0a6cc4ba868319ae$var$setCurrentInstance = (instance)=>{
    $0a6cc4ba868319ae$var$currentInstance = instance;
    instance.scope.on();
};
const $0a6cc4ba868319ae$var$unsetCurrentInstance = ()=>{
    $0a6cc4ba868319ae$var$currentInstance && $0a6cc4ba868319ae$var$currentInstance.scope.off();
    $0a6cc4ba868319ae$var$currentInstance = null;
};
const $0a6cc4ba868319ae$var$isBuiltInTag = /*#__PURE__*/ (0, $8POXm.makeMap)('slot,component');
function $0a6cc4ba868319ae$var$validateComponentName(name, config) {
    const appIsNativeTag = config.isNativeTag || (0, $8POXm.NO);
    if ($0a6cc4ba868319ae$var$isBuiltInTag(name) || appIsNativeTag(name)) $0a6cc4ba868319ae$export$c106dd0671a0fc2d('Do not use built-in or reserved HTML elements as component id: ' + name);
}
function $0a6cc4ba868319ae$var$isStatefulComponent(instance) {
    return instance.vnode.shapeFlag & 4 /* ShapeFlags.STATEFUL_COMPONENT */ ;
}
let $0a6cc4ba868319ae$var$isInSSRComponentSetup = false;
function $0a6cc4ba868319ae$var$setupComponent(instance, isSSR = false) {
    $0a6cc4ba868319ae$var$isInSSRComponentSetup = isSSR;
    const { props: props, children: children } = instance.vnode;
    const isStateful = $0a6cc4ba868319ae$var$isStatefulComponent(instance);
    $0a6cc4ba868319ae$var$initProps(instance, props, isStateful, isSSR);
    $0a6cc4ba868319ae$var$initSlots(instance, children);
    const setupResult = isStateful ? $0a6cc4ba868319ae$var$setupStatefulComponent(instance, isSSR) : undefined;
    $0a6cc4ba868319ae$var$isInSSRComponentSetup = false;
    return setupResult;
}
function $0a6cc4ba868319ae$var$setupStatefulComponent(instance, isSSR) {
    var _a;
    const Component = instance.type;
    // 0. create render proxy property access cache
    instance.accessCache = Object.create(null);
    // 1. create public instance / render proxy
    // also mark it raw so it's never observed
    instance.proxy = (0, $01W3b.markRaw)(new Proxy(instance.ctx, $0a6cc4ba868319ae$var$PublicInstanceProxyHandlers));
    // 2. call setup()
    const { setup: setup } = Component;
    if (setup) {
        const setupContext = instance.setupContext = setup.length > 1 ? $0a6cc4ba868319ae$var$createSetupContext(instance) : null;
        $0a6cc4ba868319ae$var$setCurrentInstance(instance);
        (0, $01W3b.pauseTracking)();
        const setupResult = $0a6cc4ba868319ae$export$b22fcaf88446e9bf(setup, instance, 0 /* ErrorCodes.SETUP_FUNCTION */ , [
            (0, instance.props),
            setupContext
        ]);
        (0, $01W3b.resetTracking)();
        $0a6cc4ba868319ae$var$unsetCurrentInstance();
        if ((0, $8POXm.isPromise)(setupResult)) {
            setupResult.then($0a6cc4ba868319ae$var$unsetCurrentInstance, $0a6cc4ba868319ae$var$unsetCurrentInstance);
            if (isSSR) // return the promise so server-renderer can wait on it
            return setupResult.then((resolvedResult)=>{
                $0a6cc4ba868319ae$var$handleSetupResult(instance, resolvedResult, isSSR);
            }).catch((e)=>{
                $0a6cc4ba868319ae$export$d3da1ecaf1206c58(e, instance, 0 /* ErrorCodes.SETUP_FUNCTION */ );
            });
            else // async setup returned Promise.
            // bail here and wait for re-entry.
            instance.asyncDep = setupResult;
        } else $0a6cc4ba868319ae$var$handleSetupResult(instance, setupResult, isSSR);
    } else $0a6cc4ba868319ae$var$finishComponentSetup(instance, isSSR);
}
function $0a6cc4ba868319ae$var$handleSetupResult(instance, setupResult, isSSR) {
    if ((0, $8POXm.isFunction)(setupResult)) {
        // setup returned an inline render function
        if (instance.type.__ssrInlineRender) // when the function's name is `ssrRender` (compiled by SFC inline mode),
        // set it as ssrRender instead.
        instance.ssrRender = setupResult;
        else instance.render = setupResult;
    } else if ((0, $8POXm.isObject)(setupResult)) {
        // setup returned bindings.
        // assuming a render function compiled from template is present.
        if (__VUE_PROD_DEVTOOLS__) instance.devtoolsRawSetupState = setupResult;
        instance.setupState = (0, $01W3b.proxyRefs)(setupResult);
    }
    $0a6cc4ba868319ae$var$finishComponentSetup(instance, isSSR);
}
let $0a6cc4ba868319ae$var$compile;
let $0a6cc4ba868319ae$var$installWithProxy;
/**
 * For runtime-dom to register the compiler.
 * Note the exported method uses any to avoid d.ts relying on the compiler types.
 */ function $0a6cc4ba868319ae$export$667bb5a67822b941(_compile) {
    $0a6cc4ba868319ae$var$compile = _compile;
    $0a6cc4ba868319ae$var$installWithProxy = (i)=>{
        if (i.render._rc) i.withProxy = new Proxy(i.ctx, $0a6cc4ba868319ae$var$RuntimeCompiledPublicInstanceProxyHandlers);
    };
}
// dev only
const $0a6cc4ba868319ae$export$c93a9c496c5211fa = ()=>!$0a6cc4ba868319ae$var$compile;
function $0a6cc4ba868319ae$var$finishComponentSetup(instance, isSSR, skipOptions) {
    const Component = instance.type;
    // template / render function normalization
    // could be already set when returned from setup()
    if (!instance.render) {
        // only do on-the-fly compile if not in SSR - SSR on-the-fly compilation
        // is done by server-renderer
        if (!isSSR && $0a6cc4ba868319ae$var$compile && !Component.render) {
            const template = Component.template || $0a6cc4ba868319ae$var$resolveMergedOptions(instance).template;
            if (template) {
                const { isCustomElement: isCustomElement, compilerOptions: compilerOptions } = instance.appContext.config;
                const { delimiters: delimiters, compilerOptions: componentCompilerOptions } = Component;
                const finalCompilerOptions = (0, $8POXm.extend)((0, $8POXm.extend)({
                    isCustomElement: isCustomElement,
                    delimiters: delimiters
                }, compilerOptions), componentCompilerOptions);
                Component.render = $0a6cc4ba868319ae$var$compile(template, finalCompilerOptions);
            }
        }
        instance.render = Component.render || (0, $8POXm.NOOP);
        // for runtime-compiled render functions using `with` blocks, the render
        // proxy used needs a different `has` handler which is more performant and
        // also only allows a whitelist of globals to fallthrough.
        if ($0a6cc4ba868319ae$var$installWithProxy) $0a6cc4ba868319ae$var$installWithProxy(instance);
    }
    // support for 2.x options
    if (__VUE_OPTIONS_API__ && true) {
        $0a6cc4ba868319ae$var$setCurrentInstance(instance);
        (0, $01W3b.pauseTracking)();
        $0a6cc4ba868319ae$var$applyOptions(instance);
        (0, $01W3b.resetTracking)();
        $0a6cc4ba868319ae$var$unsetCurrentInstance();
    }
}
function $0a6cc4ba868319ae$var$createAttrsProxy(instance) {
    return new Proxy(instance.attrs, {
        get (target, key) {
            (0, $01W3b.track)(instance, "get" /* TrackOpTypes.GET */ , '$attrs');
            return target[key];
        }
    });
}
function $0a6cc4ba868319ae$var$createSetupContext(instance) {
    const expose = (exposed)=>{
        instance.exposed = exposed || {};
    };
    let attrs;
    var event, args;
    return {
        get attrs () {
            return attrs || (attrs = $0a6cc4ba868319ae$var$createAttrsProxy(instance));
        },
        slots: instance.slots,
        emit: instance.emit,
        expose: expose
    };
}
function $0a6cc4ba868319ae$var$getExposeProxy(instance) {
    if (instance.exposed) return instance.exposeProxy || (instance.exposeProxy = new Proxy((0, $01W3b.proxyRefs)((0, $01W3b.markRaw)(instance.exposed)), {
        get (target, key) {
            if (key in target) return target[key];
            else if (key in $0a6cc4ba868319ae$var$publicPropertiesMap) return $0a6cc4ba868319ae$var$publicPropertiesMap[key](instance);
        }
    }));
}
const $0a6cc4ba868319ae$var$classifyRE = /(?:^|[-_])(\w)/g;
const $0a6cc4ba868319ae$var$classify = (str)=>str.replace($0a6cc4ba868319ae$var$classifyRE, (c)=>c.toUpperCase()).replace(/[-_]/g, '');
function $0a6cc4ba868319ae$var$getComponentName(Component, includeInferred = true) {
    return (0, $8POXm.isFunction)(Component) ? Component.displayName || Component.name : Component.name || includeInferred && Component.__name;
}
/* istanbul ignore next */ function $0a6cc4ba868319ae$var$formatComponentName(instance, Component, isRoot = false) {
    let name = $0a6cc4ba868319ae$var$getComponentName(Component);
    if (!name && Component.__file) {
        const match = Component.__file.match(/([^/\\]+)\.\w+$/);
        if (match) name = match[1];
    }
    if (!name && instance && instance.parent) {
        // try to infer the name based on reverse resolution
        const inferFromRegistry = (registry)=>{
            for(const key in registry){
                if (registry[key] === Component) return key;
            }
        };
        name = inferFromRegistry(instance.components || instance.parent.type.components) || inferFromRegistry(instance.appContext.components);
    }
    return name ? $0a6cc4ba868319ae$var$classify(name) : isRoot ? `App` : `Anonymous`;
}
function $0a6cc4ba868319ae$var$isClassComponent(value) {
    return (0, $8POXm.isFunction)(value) && '__vccOpts' in value;
}
const $0a6cc4ba868319ae$export$2983e091f1a1e8e2 = (getterOrOptions, debugOptions)=>{
    // @ts-ignore
    return (0, $01W3b.computed)(getterOrOptions, debugOptions, $0a6cc4ba868319ae$var$isInSSRComponentSetup);
};
// dev only
const $0a6cc4ba868319ae$var$warnRuntimeUsage = (method)=>$0a6cc4ba868319ae$export$c106dd0671a0fc2d(`${method}() is a compiler-hint helper that is only usable inside ` + `<script setup> of a single file component. Its arguments should be ` + `compiled away and passing it at runtime has no effect.`);
// implementation
function $0a6cc4ba868319ae$export$80b33eababae110e() {
    return null;
}
// implementation
function $0a6cc4ba868319ae$export$51ecece22fc17ddc() {
    return null;
}
/**
 * Vue `<script setup>` compiler macro for declaring a component's exposed
 * instance properties when it is accessed by a parent component via template
 * refs.
 *
 * `<script setup>` components are closed by default - i.e. variables inside
 * the `<script setup>` scope is not exposed to parent unless explicitly exposed
 * via `defineExpose`.
 *
 * This is only usable inside `<script setup>`, is compiled away in the
 * output and should **not** be actually called at runtime.
 */ function $0a6cc4ba868319ae$export$da25b65ca24b518a(exposed) {}
/**
 * Vue `<script setup>` compiler macro for providing props default values when
 * using type-based `defineProps` declaration.
 *
 * Example usage:
 * ```ts
 * withDefaults(defineProps<{
 *   size?: number
 *   labels?: string[]
 * }>(), {
 *   size: 3,
 *   labels: () => ['default label']
 * })
 * ```
 *
 * This is only usable inside `<script setup>`, is compiled away in the output
 * and should **not** be actually called at runtime.
 */ function $0a6cc4ba868319ae$export$4df9c0969a9e0160(props, defaults) {
    return null;
}
function $0a6cc4ba868319ae$export$9203a8e84125433c() {
    return $0a6cc4ba868319ae$var$getContext().slots;
}
function $0a6cc4ba868319ae$export$75e29435042cd2ea() {
    return $0a6cc4ba868319ae$var$getContext().attrs;
}
function $0a6cc4ba868319ae$var$getContext() {
    const i = $0a6cc4ba868319ae$export$f13e630aa3915748();
    return i.setupContext || (i.setupContext = $0a6cc4ba868319ae$var$createSetupContext(i));
}
/**
 * Runtime helper for merging default declarations. Imported by compiled code
 * only.
 * @internal
 */ function $0a6cc4ba868319ae$export$ec60f47d4a8a2e7f(raw, defaults) {
    const props = (0, $8POXm.isArray)(raw) ? raw.reduce((normalized, p)=>(normalized[p] = {}, normalized), {}) : raw;
    for(const key in defaults){
        const opt = props[key];
        if (opt) {
            if ((0, $8POXm.isArray)(opt) || (0, $8POXm.isFunction)(opt)) props[key] = {
                type: opt,
                default: defaults[key]
            };
            else opt.default = defaults[key];
        } else if (opt === null) props[key] = {
            default: defaults[key]
        };
    }
    return props;
}
/**
 * Used to create a proxy for the rest element when destructuring props with
 * defineProps().
 * @internal
 */ function $0a6cc4ba868319ae$export$7c343e855c563faa(props, excludedKeys) {
    const ret = {};
    for(const key in props)if (!excludedKeys.includes(key)) Object.defineProperty(ret, key, {
        enumerable: true,
        get: ()=>props[key]
    });
    return ret;
}
/**
 * `<script setup>` helper for persisting the current instance context over
 * async/await flows.
 *
 * `@vue/compiler-sfc` converts the following:
 *
 * ```ts
 * const x = await foo()
 * ```
 *
 * into:
 *
 * ```ts
 * let __temp, __restore
 * const x = (([__temp, __restore] = withAsyncContext(() => foo())),__temp=await __temp,__restore(),__temp)
 * ```
 * @internal
 */ function $0a6cc4ba868319ae$export$d6d6f7369f1fb104(getAwaitable) {
    const ctx = $0a6cc4ba868319ae$export$f13e630aa3915748();
    let awaitable = getAwaitable();
    $0a6cc4ba868319ae$var$unsetCurrentInstance();
    if ((0, $8POXm.isPromise)(awaitable)) awaitable = awaitable.catch((e)=>{
        $0a6cc4ba868319ae$var$setCurrentInstance(ctx);
        throw e;
    });
    return [
        awaitable,
        ()=>$0a6cc4ba868319ae$var$setCurrentInstance(ctx)
    ];
}
// Actual implementation
function $0a6cc4ba868319ae$export$dda1d9f60106f0e9(type, propsOrChildren, children) {
    const l = arguments.length;
    if (l === 2) {
        if ((0, $8POXm.isObject)(propsOrChildren) && !(0, $8POXm.isArray)(propsOrChildren)) {
            // single vnode without props
            if ($0a6cc4ba868319ae$export$3868d13f8734ae81(propsOrChildren)) return $0a6cc4ba868319ae$export$bf5c4cf060303d58(type, null, [
                propsOrChildren
            ]);
            // props without children
            return $0a6cc4ba868319ae$export$bf5c4cf060303d58(type, propsOrChildren);
        } else // omit props
        return $0a6cc4ba868319ae$export$bf5c4cf060303d58(type, null, propsOrChildren);
    } else {
        if (l > 3) children = Array.prototype.slice.call(arguments, 2);
        else if (l === 3 && $0a6cc4ba868319ae$export$3868d13f8734ae81(children)) children = [
            children
        ];
        return $0a6cc4ba868319ae$export$bf5c4cf060303d58(type, propsOrChildren, children);
    }
}
const $0a6cc4ba868319ae$export$f2549a27e18acf2d = Symbol(``);
const $0a6cc4ba868319ae$export$6b1c54dc4befcda = ()=>{
    {
        const ctx = $0a6cc4ba868319ae$export$a976684a0efeb93f($0a6cc4ba868319ae$export$f2549a27e18acf2d);
        if (!ctx) $0a6cc4ba868319ae$export$c106dd0671a0fc2d(`Server rendering context not provided. Make sure to only call ` + `useSSRContext() conditionally in the server build.`);
        return ctx;
    }
};
function $0a6cc4ba868319ae$var$isShallow(value) {
    return !!(value && value["__v_isShallow" /* ReactiveFlags.IS_SHALLOW */ ]);
}
function $0a6cc4ba868319ae$export$aed4979be6a60047() {
    return;
    function formatInstance(instance) {
        const blocks = [];
        if (instance.type.props && instance.props) blocks.push(createInstanceBlock('props', (0, $01W3b.toRaw)(instance.props)));
        if (instance.setupState !== (0, $8POXm.EMPTY_OBJ)) blocks.push(createInstanceBlock('setup', instance.setupState));
        if (instance.data !== (0, $8POXm.EMPTY_OBJ)) blocks.push(createInstanceBlock('data', (0, $01W3b.toRaw)(instance.data)));
        const computed = extractKeys(instance, 'computed');
        if (computed) blocks.push(createInstanceBlock('computed', computed));
        const injected = extractKeys(instance, 'inject');
        if (injected) blocks.push(createInstanceBlock('injected', injected));
        blocks.push([
            'div',
            {},
            [
                'span',
                {
                    style: keywordStyle.style + ';opacity:0.66'
                },
                '$ (internal): '
            ],
            [
                'object',
                {
                    object: instance
                }
            ]
        ]);
        return blocks;
    }
    function createInstanceBlock(type, target) {
        target = (0, $8POXm.extend)({}, target);
        if (!Object.keys(target).length) return [
            'span',
            {}
        ];
        return [
            'div',
            {
                style: 'line-height:1.25em;margin-bottom:0.6em'
            },
            [
                'div',
                {
                    style: 'color:#476582'
                },
                type
            ],
            [
                'div',
                {
                    style: 'padding-left:1.25em'
                },
                ...Object.keys(target).map((key)=>{
                    return [
                        'div',
                        {},
                        [
                            'span',
                            keywordStyle,
                            key + ': '
                        ],
                        formatValue(target[key], false)
                    ];
                })
            ]
        ];
    }
    function formatValue(v1, asRaw = true) {
        if (typeof v1 === 'number') return [
            'span',
            numberStyle,
            v1
        ];
        else if (typeof v1 === 'string') return [
            'span',
            stringStyle,
            JSON.stringify(v1)
        ];
        else if (typeof v1 === 'boolean') return [
            'span',
            keywordStyle,
            v1
        ];
        else if ((0, $8POXm.isObject)(v1)) return [
            'object',
            {
                object: asRaw ? (0, $01W3b.toRaw)(v1) : v1
            }
        ];
        else return [
            'span',
            stringStyle,
            String(v1)
        ];
    }
    function extractKeys(instance, type) {
        const Comp = instance.type;
        if ((0, $8POXm.isFunction)(Comp)) return;
        const extracted = {};
        for(const key in instance.ctx)if (isKeyOfType(Comp, key, type)) extracted[key] = instance.ctx[key];
        return extracted;
    }
    function isKeyOfType(Comp, key, type) {
        const opts = Comp[type];
        if ((0, $8POXm.isArray)(opts) && opts.includes(key) || (0, $8POXm.isObject)(opts) && key in opts) return true;
        if (Comp.extends && isKeyOfType(Comp.extends, key, type)) return true;
        if (Comp.mixins && Comp.mixins.some((m)=>isKeyOfType(m, key, type))) return true;
    }
    function genRefFlag(v1) {
        if ($0a6cc4ba868319ae$var$isShallow(v1)) return `ShallowRef`;
        if (v1.effect) return `ComputedRef`;
        return `Ref`;
    }
}
function $0a6cc4ba868319ae$export$2a6d714a4d738ae(memo, render, cache, index) {
    const cached = cache[index];
    if (cached && $0a6cc4ba868319ae$export$bf525184d622787c(cached, memo)) return cached;
    const ret = render();
    // shallow clone
    ret.memo = memo.slice();
    return cache[index] = ret;
}
function $0a6cc4ba868319ae$export$bf525184d622787c(cached, memo) {
    const prev = cached.memo;
    if (prev.length != memo.length) return false;
    for(let i = 0; i < prev.length; i++){
        if ((0, $8POXm.hasChanged)(prev[i], memo[i])) return false;
    }
    // make sure to let parent block track it when returning cached
    if ($0a6cc4ba868319ae$var$isBlockTreeEnabled > 0 && $0a6cc4ba868319ae$var$currentBlock) $0a6cc4ba868319ae$var$currentBlock.push(cached);
    return true;
}
// Core API ------------------------------------------------------------------
const $0a6cc4ba868319ae$export$83d89fbfd8236492 = "3.2.39";
const $0a6cc4ba868319ae$var$_ssrUtils = {
    createComponentInstance: $0a6cc4ba868319ae$var$createComponentInstance,
    setupComponent: $0a6cc4ba868319ae$var$setupComponent,
    renderComponentRoot: $0a6cc4ba868319ae$var$renderComponentRoot,
    setCurrentRenderingInstance: $0a6cc4ba868319ae$var$setCurrentRenderingInstance,
    isVNode: $0a6cc4ba868319ae$export$3868d13f8734ae81,
    normalizeVNode: $0a6cc4ba868319ae$var$normalizeVNode
};
/**
 * SSR utils for \@vue/server-renderer. Only exposed in ssr-possible builds.
 * @internal
 */ const $0a6cc4ba868319ae$export$a9679033567b336d = $0a6cc4ba868319ae$var$_ssrUtils;
/**
 * @internal only exposed in compat builds
 */ const $0a6cc4ba868319ae$export$83cf26e06ea620e1 = null;
/**
 * @internal only exposed in compat builds.
 */ const $0a6cc4ba868319ae$export$dc678eddf276286e = null;

});
parcelRegister("01W3b", function(module, exports) {

$parcel$export(module.exports, "EffectScope", () => $005d1fb7704e278c$export$1168ed9dbc71ddbd);
$parcel$export(module.exports, "effectScope", () => $005d1fb7704e278c$export$7056603ea81600be);
$parcel$export(module.exports, "getCurrentScope", () => $005d1fb7704e278c$export$c7be4b0125a10cba);
$parcel$export(module.exports, "onScopeDispose", () => $005d1fb7704e278c$export$a780418acd4762da);
$parcel$export(module.exports, "ReactiveEffect", () => $005d1fb7704e278c$export$28352bb4dd362521);
$parcel$export(module.exports, "effect", () => $005d1fb7704e278c$export$dc573d8a6576cdb3);
$parcel$export(module.exports, "stop", () => $005d1fb7704e278c$export$fa6813432f753b0d);
$parcel$export(module.exports, "pauseTracking", () => $005d1fb7704e278c$export$938a971395fef855);
$parcel$export(module.exports, "resetTracking", () => $005d1fb7704e278c$export$c39176b1babaa8b8);
$parcel$export(module.exports, "track", () => $005d1fb7704e278c$export$6b2a7d5132615086);
$parcel$export(module.exports, "trigger", () => $005d1fb7704e278c$export$e614dc9140f7ae71);
$parcel$export(module.exports, "toRaw", () => $005d1fb7704e278c$export$ab18938b9fc5f28e);
$parcel$export(module.exports, "isRef", () => $005d1fb7704e278c$export$4f9f5282de18fc69);
$parcel$export(module.exports, "readonly", () => $005d1fb7704e278c$export$6ec456bd5b7b3c51);
$parcel$export(module.exports, "reactive", () => $005d1fb7704e278c$export$90a44edba14e47be);
$parcel$export(module.exports, "isReadonly", () => $005d1fb7704e278c$export$92d09b48637741e7);
$parcel$export(module.exports, "isShallow", () => $005d1fb7704e278c$export$7f3fe6025abfa26e);
$parcel$export(module.exports, "shallowReactive", () => $005d1fb7704e278c$export$8d81cefd22d22260);
$parcel$export(module.exports, "shallowReadonly", () => $005d1fb7704e278c$export$7c4b5f2b50f09f6b);
$parcel$export(module.exports, "isReactive", () => $005d1fb7704e278c$export$352205f445242f02);
$parcel$export(module.exports, "isProxy", () => $005d1fb7704e278c$export$5f3ca29d057519b3);
$parcel$export(module.exports, "markRaw", () => $005d1fb7704e278c$export$995ab8b13ad7a9d0);
$parcel$export(module.exports, "ref", () => $005d1fb7704e278c$export$eff4d24c3ff7876e);
$parcel$export(module.exports, "shallowRef", () => $005d1fb7704e278c$export$9b7bc5fe3b17c8b3);
$parcel$export(module.exports, "triggerRef", () => $005d1fb7704e278c$export$f402f86588575ccc);
$parcel$export(module.exports, "unref", () => $005d1fb7704e278c$export$a239a76781616204);
$parcel$export(module.exports, "proxyRefs", () => $005d1fb7704e278c$export$f353fd1b97db3fa0);
$parcel$export(module.exports, "customRef", () => $005d1fb7704e278c$export$a20c2dd6199824cb);
$parcel$export(module.exports, "toRefs", () => $005d1fb7704e278c$export$2e9533675e5e70e0);
$parcel$export(module.exports, "toRef", () => $005d1fb7704e278c$export$1f60508e4f47b4b7);
$parcel$export(module.exports, "computed", () => $005d1fb7704e278c$export$2983e091f1a1e8e2);

var $8POXm = parcelRequire("8POXm");
function $005d1fb7704e278c$var$warn(msg, ...args) {
    console.warn(`[Vue warn] ${msg}`, ...args);
}
let $005d1fb7704e278c$var$activeEffectScope;
class $005d1fb7704e278c$export$1168ed9dbc71ddbd {
    constructor(detached = false){
        /**
         * @internal
         */ this.active = true;
        /**
         * @internal
         */ this.effects = [];
        /**
         * @internal
         */ this.cleanups = [];
        if (!detached && $005d1fb7704e278c$var$activeEffectScope) {
            this.parent = $005d1fb7704e278c$var$activeEffectScope;
            this.index = ($005d1fb7704e278c$var$activeEffectScope.scopes || ($005d1fb7704e278c$var$activeEffectScope.scopes = [])).push(this) - 1;
        }
    }
    run(fn) {
        if (this.active) {
            const currentEffectScope = $005d1fb7704e278c$var$activeEffectScope;
            try {
                $005d1fb7704e278c$var$activeEffectScope = this;
                return fn();
            } finally{
                $005d1fb7704e278c$var$activeEffectScope = currentEffectScope;
            }
        }
    }
    /**
     * This should only be called on non-detached scopes
     * @internal
     */ on() {
        $005d1fb7704e278c$var$activeEffectScope = this;
    }
    /**
     * This should only be called on non-detached scopes
     * @internal
     */ off() {
        $005d1fb7704e278c$var$activeEffectScope = this.parent;
    }
    stop(fromParent) {
        if (this.active) {
            let i, l;
            for(i = 0, l = this.effects.length; i < l; i++)this.effects[i].stop();
            for(i = 0, l = this.cleanups.length; i < l; i++)this.cleanups[i]();
            if (this.scopes) for(i = 0, l = this.scopes.length; i < l; i++)this.scopes[i].stop(true);
            // nested scope, dereference from parent to avoid memory leaks
            if (this.parent && !fromParent) {
                // optimized O(1) removal
                const last = this.parent.scopes.pop();
                if (last && last !== this) {
                    this.parent.scopes[this.index] = last;
                    last.index = this.index;
                }
            }
            this.active = false;
        }
    }
}
function $005d1fb7704e278c$export$7056603ea81600be(detached) {
    return new $005d1fb7704e278c$export$1168ed9dbc71ddbd(detached);
}
function $005d1fb7704e278c$var$recordEffectScope(effect, scope = $005d1fb7704e278c$var$activeEffectScope) {
    if (scope && scope.active) scope.effects.push(effect);
}
function $005d1fb7704e278c$export$c7be4b0125a10cba() {
    return $005d1fb7704e278c$var$activeEffectScope;
}
function $005d1fb7704e278c$export$a780418acd4762da(fn) {
    if ($005d1fb7704e278c$var$activeEffectScope) $005d1fb7704e278c$var$activeEffectScope.cleanups.push(fn);
}
const $005d1fb7704e278c$var$createDep = (effects)=>{
    const dep = new Set(effects);
    dep.w = 0;
    dep.n = 0;
    return dep;
};
const $005d1fb7704e278c$var$wasTracked = (dep)=>(dep.w & $005d1fb7704e278c$var$trackOpBit) > 0;
const $005d1fb7704e278c$var$newTracked = (dep)=>(dep.n & $005d1fb7704e278c$var$trackOpBit) > 0;
const $005d1fb7704e278c$var$initDepMarkers = ({ deps: deps })=>{
    if (deps.length) for(let i = 0; i < deps.length; i++)deps[i].w |= $005d1fb7704e278c$var$trackOpBit; // set was tracked
};
const $005d1fb7704e278c$var$finalizeDepMarkers = (effect)=>{
    const { deps: deps } = effect;
    if (deps.length) {
        let ptr = 0;
        for(let i = 0; i < deps.length; i++){
            const dep = deps[i];
            if ($005d1fb7704e278c$var$wasTracked(dep) && !$005d1fb7704e278c$var$newTracked(dep)) dep.delete(effect);
            else deps[ptr++] = dep;
            // clear bits
            dep.w &= ~$005d1fb7704e278c$var$trackOpBit;
            dep.n &= ~$005d1fb7704e278c$var$trackOpBit;
        }
        deps.length = ptr;
    }
};
const $005d1fb7704e278c$var$targetMap = new WeakMap();
// The number of effects currently being tracked recursively.
let $005d1fb7704e278c$var$effectTrackDepth = 0;
let $005d1fb7704e278c$var$trackOpBit = 1;
/**
 * The bitwise track markers support at most 30 levels of recursion.
 * This value is chosen to enable modern JS engines to use a SMI on all platforms.
 * When recursion depth is greater, fall back to using a full cleanup.
 */ const $005d1fb7704e278c$var$maxMarkerBits = 30;
let $005d1fb7704e278c$var$activeEffect;
const $005d1fb7704e278c$export$3c41b1a4e06acc14 = Symbol('');
const $005d1fb7704e278c$var$MAP_KEY_ITERATE_KEY = Symbol('');
class $005d1fb7704e278c$export$28352bb4dd362521 {
    constructor(fn, scheduler = null, scope){
        this.fn = fn;
        this.scheduler = scheduler;
        this.active = true;
        this.deps = [];
        this.parent = undefined;
        $005d1fb7704e278c$var$recordEffectScope(this, scope);
    }
    run() {
        if (!this.active) return this.fn();
        let parent = $005d1fb7704e278c$var$activeEffect;
        let lastShouldTrack = $005d1fb7704e278c$var$shouldTrack;
        while(parent){
            if (parent === this) return;
            parent = parent.parent;
        }
        try {
            this.parent = $005d1fb7704e278c$var$activeEffect;
            $005d1fb7704e278c$var$activeEffect = this;
            $005d1fb7704e278c$var$shouldTrack = true;
            $005d1fb7704e278c$var$trackOpBit = 1 << ++$005d1fb7704e278c$var$effectTrackDepth;
            if ($005d1fb7704e278c$var$effectTrackDepth <= $005d1fb7704e278c$var$maxMarkerBits) $005d1fb7704e278c$var$initDepMarkers(this);
            else $005d1fb7704e278c$var$cleanupEffect(this);
            return this.fn();
        } finally{
            if ($005d1fb7704e278c$var$effectTrackDepth <= $005d1fb7704e278c$var$maxMarkerBits) $005d1fb7704e278c$var$finalizeDepMarkers(this);
            $005d1fb7704e278c$var$trackOpBit = 1 << --$005d1fb7704e278c$var$effectTrackDepth;
            $005d1fb7704e278c$var$activeEffect = this.parent;
            $005d1fb7704e278c$var$shouldTrack = lastShouldTrack;
            this.parent = undefined;
            if (this.deferStop) this.stop();
        }
    }
    stop() {
        // stopped while running itself - defer the cleanup
        if ($005d1fb7704e278c$var$activeEffect === this) this.deferStop = true;
        else if (this.active) {
            $005d1fb7704e278c$var$cleanupEffect(this);
            if (this.onStop) this.onStop();
            this.active = false;
        }
    }
}
function $005d1fb7704e278c$var$cleanupEffect(effect) {
    const { deps: deps } = effect;
    if (deps.length) {
        for(let i = 0; i < deps.length; i++)deps[i].delete(effect);
        deps.length = 0;
    }
}
function $005d1fb7704e278c$export$dc573d8a6576cdb3(fn, options) {
    if (fn.effect) fn = fn.effect.fn;
    const _effect = new $005d1fb7704e278c$export$28352bb4dd362521(fn);
    if (options) {
        (0, $8POXm.extend)(_effect, options);
        if (options.scope) $005d1fb7704e278c$var$recordEffectScope(_effect, options.scope);
    }
    if (!options || !options.lazy) _effect.run();
    const runner = _effect.run.bind(_effect);
    runner.effect = _effect;
    return runner;
}
function $005d1fb7704e278c$export$fa6813432f753b0d(runner) {
    runner.effect.stop();
}
let $005d1fb7704e278c$var$shouldTrack = true;
const $005d1fb7704e278c$var$trackStack = [];
function $005d1fb7704e278c$export$938a971395fef855() {
    $005d1fb7704e278c$var$trackStack.push($005d1fb7704e278c$var$shouldTrack);
    $005d1fb7704e278c$var$shouldTrack = false;
}
function $005d1fb7704e278c$export$1f8ffc6fd33b1d16() {
    $005d1fb7704e278c$var$trackStack.push($005d1fb7704e278c$var$shouldTrack);
    $005d1fb7704e278c$var$shouldTrack = true;
}
function $005d1fb7704e278c$export$c39176b1babaa8b8() {
    const last = $005d1fb7704e278c$var$trackStack.pop();
    $005d1fb7704e278c$var$shouldTrack = last === undefined ? true : last;
}
function $005d1fb7704e278c$export$6b2a7d5132615086(target, type, key) {
    if ($005d1fb7704e278c$var$shouldTrack && $005d1fb7704e278c$var$activeEffect) {
        let depsMap = $005d1fb7704e278c$var$targetMap.get(target);
        if (!depsMap) $005d1fb7704e278c$var$targetMap.set(target, depsMap = new Map());
        let dep = depsMap.get(key);
        if (!dep) depsMap.set(key, dep = $005d1fb7704e278c$var$createDep());
        const eventInfo = undefined;
        $005d1fb7704e278c$var$trackEffects(dep, eventInfo);
    }
}
function $005d1fb7704e278c$var$trackEffects(dep, debuggerEventExtraInfo) {
    let shouldTrack = false;
    if ($005d1fb7704e278c$var$effectTrackDepth <= $005d1fb7704e278c$var$maxMarkerBits) {
        if (!$005d1fb7704e278c$var$newTracked(dep)) {
            dep.n |= $005d1fb7704e278c$var$trackOpBit; // set newly tracked
            shouldTrack = !$005d1fb7704e278c$var$wasTracked(dep);
        }
    } else // Full cleanup mode.
    shouldTrack = !dep.has($005d1fb7704e278c$var$activeEffect);
    if (shouldTrack) {
        dep.add($005d1fb7704e278c$var$activeEffect);
        $005d1fb7704e278c$var$activeEffect.deps.push(dep);
    }
}
function $005d1fb7704e278c$export$e614dc9140f7ae71(target, type, key, newValue, oldValue, oldTarget) {
    const depsMap = $005d1fb7704e278c$var$targetMap.get(target);
    if (!depsMap) // never been tracked
    return;
    let deps = [];
    if (type === "clear" /* TriggerOpTypes.CLEAR */ ) // collection being cleared
    // trigger all effects for target
    deps = [
        ...depsMap.values()
    ];
    else if (key === 'length' && (0, $8POXm.isArray)(target)) depsMap.forEach((dep, key)=>{
        if (key === 'length' || key >= newValue) deps.push(dep);
    });
    else {
        // schedule runs for SET | ADD | DELETE
        if (key !== void 0) deps.push(depsMap.get(key));
        // also run for iteration key on ADD | DELETE | Map.SET
        switch(type){
            case "add" /* TriggerOpTypes.ADD */ :
                if (!(0, $8POXm.isArray)(target)) {
                    deps.push(depsMap.get($005d1fb7704e278c$export$3c41b1a4e06acc14));
                    if ((0, $8POXm.isMap)(target)) deps.push(depsMap.get($005d1fb7704e278c$var$MAP_KEY_ITERATE_KEY));
                } else if ((0, $8POXm.isIntegerKey)(key)) // new index added to array -> length changes
                deps.push(depsMap.get('length'));
                break;
            case "delete" /* TriggerOpTypes.DELETE */ :
                if (!(0, $8POXm.isArray)(target)) {
                    deps.push(depsMap.get($005d1fb7704e278c$export$3c41b1a4e06acc14));
                    if ((0, $8POXm.isMap)(target)) deps.push(depsMap.get($005d1fb7704e278c$var$MAP_KEY_ITERATE_KEY));
                }
                break;
            case "set" /* TriggerOpTypes.SET */ :
                if ((0, $8POXm.isMap)(target)) deps.push(depsMap.get($005d1fb7704e278c$export$3c41b1a4e06acc14));
                break;
        }
    }
    const eventInfo = undefined;
    if (deps.length === 1) {
        if (deps[0]) $005d1fb7704e278c$var$triggerEffects(deps[0]);
    } else {
        const effects = [];
        for (const dep of deps)if (dep) effects.push(...dep);
        $005d1fb7704e278c$var$triggerEffects($005d1fb7704e278c$var$createDep(effects));
    }
}
function $005d1fb7704e278c$var$triggerEffects(dep, debuggerEventExtraInfo) {
    // spread into array for stabilization
    const effects = (0, $8POXm.isArray)(dep) ? dep : [
        ...dep
    ];
    for (const effect of effects)if (effect.computed) $005d1fb7704e278c$var$triggerEffect(effect, debuggerEventExtraInfo);
    for (const effect of effects)if (!effect.computed) $005d1fb7704e278c$var$triggerEffect(effect, debuggerEventExtraInfo);
}
function $005d1fb7704e278c$var$triggerEffect(effect, debuggerEventExtraInfo) {
    if (effect !== $005d1fb7704e278c$var$activeEffect || effect.allowRecurse) {
        if (effect.scheduler) effect.scheduler();
        else effect.run();
    }
}
const $005d1fb7704e278c$var$isNonTrackableKeys = /*#__PURE__*/ (0, $8POXm.makeMap)(`__proto__,__v_isRef,__isVue`);
const $005d1fb7704e278c$var$builtInSymbols = new Set(/*#__PURE__*/ Object.getOwnPropertyNames(Symbol)// ios10.x Object.getOwnPropertyNames(Symbol) can enumerate 'arguments' and 'caller'
// but accessing them on Symbol leads to TypeError because Symbol is a strict mode
// function
.filter((key)=>key !== 'arguments' && key !== 'caller').map((key)=>Symbol[key]).filter((0, $8POXm.isSymbol)));
const $005d1fb7704e278c$var$get = /*#__PURE__*/ $005d1fb7704e278c$var$createGetter();
const $005d1fb7704e278c$var$shallowGet = /*#__PURE__*/ $005d1fb7704e278c$var$createGetter(false, true);
const $005d1fb7704e278c$var$readonlyGet = /*#__PURE__*/ $005d1fb7704e278c$var$createGetter(true);
const $005d1fb7704e278c$var$shallowReadonlyGet = /*#__PURE__*/ $005d1fb7704e278c$var$createGetter(true, true);
const $005d1fb7704e278c$var$arrayInstrumentations = /*#__PURE__*/ $005d1fb7704e278c$var$createArrayInstrumentations();
function $005d1fb7704e278c$var$createArrayInstrumentations() {
    const instrumentations = {};
    [
        'includes',
        'indexOf',
        'lastIndexOf'
    ].forEach((key)=>{
        instrumentations[key] = function(...args) {
            const arr = $005d1fb7704e278c$export$ab18938b9fc5f28e(this);
            for(let i = 0, l = this.length; i < l; i++)$005d1fb7704e278c$export$6b2a7d5132615086(arr, "get" /* TrackOpTypes.GET */ , i + '');
            // we run the method using the original args first (which may be reactive)
            const res = arr[key](...args);
            if (res === -1 || res === false) // if that didn't work, run it again using raw values.
            return arr[key](...args.map($005d1fb7704e278c$export$ab18938b9fc5f28e));
            else return res;
        };
    });
    [
        'push',
        'pop',
        'shift',
        'unshift',
        'splice'
    ].forEach((key)=>{
        instrumentations[key] = function(...args) {
            $005d1fb7704e278c$export$938a971395fef855();
            const res = $005d1fb7704e278c$export$ab18938b9fc5f28e(this)[key].apply(this, args);
            $005d1fb7704e278c$export$c39176b1babaa8b8();
            return res;
        };
    });
    return instrumentations;
}
function $005d1fb7704e278c$var$createGetter(isReadonly = false, shallow = false) {
    return function get(target, key, receiver) {
        if (key === "__v_isReactive" /* ReactiveFlags.IS_REACTIVE */ ) return !isReadonly;
        else if (key === "__v_isReadonly" /* ReactiveFlags.IS_READONLY */ ) return isReadonly;
        else if (key === "__v_isShallow" /* ReactiveFlags.IS_SHALLOW */ ) return shallow;
        else if (key === "__v_raw" /* ReactiveFlags.RAW */  && receiver === (isReadonly ? shallow ? $005d1fb7704e278c$var$shallowReadonlyMap : $005d1fb7704e278c$var$readonlyMap : shallow ? $005d1fb7704e278c$var$shallowReactiveMap : $005d1fb7704e278c$var$reactiveMap).get(target)) return target;
        const targetIsArray = (0, $8POXm.isArray)(target);
        if (!isReadonly && targetIsArray && (0, $8POXm.hasOwn)($005d1fb7704e278c$var$arrayInstrumentations, key)) return Reflect.get($005d1fb7704e278c$var$arrayInstrumentations, key, receiver);
        const res = Reflect.get(target, key, receiver);
        if ((0, $8POXm.isSymbol)(key) ? $005d1fb7704e278c$var$builtInSymbols.has(key) : $005d1fb7704e278c$var$isNonTrackableKeys(key)) return res;
        if (!isReadonly) $005d1fb7704e278c$export$6b2a7d5132615086(target, "get" /* TrackOpTypes.GET */ , key);
        if (shallow) return res;
        if ($005d1fb7704e278c$export$4f9f5282de18fc69(res)) // ref unwrapping - skip unwrap for Array + integer key.
        return targetIsArray && (0, $8POXm.isIntegerKey)(key) ? res : res.value;
        if ((0, $8POXm.isObject)(res)) // Convert returned value into a proxy as well. we do the isObject check
        // here to avoid invalid value warning. Also need to lazy access readonly
        // and reactive here to avoid circular dependency.
        return isReadonly ? $005d1fb7704e278c$export$6ec456bd5b7b3c51(res) : $005d1fb7704e278c$export$90a44edba14e47be(res);
        return res;
    };
}
const $005d1fb7704e278c$var$set = /*#__PURE__*/ $005d1fb7704e278c$var$createSetter();
const $005d1fb7704e278c$var$shallowSet = /*#__PURE__*/ $005d1fb7704e278c$var$createSetter(true);
function $005d1fb7704e278c$var$createSetter(shallow = false) {
    return function set(target, key, value, receiver) {
        let oldValue = target[key];
        if ($005d1fb7704e278c$export$92d09b48637741e7(oldValue) && $005d1fb7704e278c$export$4f9f5282de18fc69(oldValue) && !$005d1fb7704e278c$export$4f9f5282de18fc69(value)) return false;
        if (!shallow) {
            if (!$005d1fb7704e278c$export$7f3fe6025abfa26e(value) && !$005d1fb7704e278c$export$92d09b48637741e7(value)) {
                oldValue = $005d1fb7704e278c$export$ab18938b9fc5f28e(oldValue);
                value = $005d1fb7704e278c$export$ab18938b9fc5f28e(value);
            }
            if (!(0, $8POXm.isArray)(target) && $005d1fb7704e278c$export$4f9f5282de18fc69(oldValue) && !$005d1fb7704e278c$export$4f9f5282de18fc69(value)) {
                oldValue.value = value;
                return true;
            }
        }
        const hadKey = (0, $8POXm.isArray)(target) && (0, $8POXm.isIntegerKey)(key) ? Number(key) < target.length : (0, $8POXm.hasOwn)(target, key);
        const result = Reflect.set(target, key, value, receiver);
        // don't trigger if target is something up in the prototype chain of original
        if (target === $005d1fb7704e278c$export$ab18938b9fc5f28e(receiver)) {
            if (!hadKey) $005d1fb7704e278c$export$e614dc9140f7ae71(target, "add" /* TriggerOpTypes.ADD */ , key, value);
            else if ((0, $8POXm.hasChanged)(value, oldValue)) $005d1fb7704e278c$export$e614dc9140f7ae71(target, "set" /* TriggerOpTypes.SET */ , key, value, oldValue);
        }
        return result;
    };
}
function $005d1fb7704e278c$var$deleteProperty(target, key) {
    const hadKey = (0, $8POXm.hasOwn)(target, key);
    const oldValue = target[key];
    const result = Reflect.deleteProperty(target, key);
    if (result && hadKey) $005d1fb7704e278c$export$e614dc9140f7ae71(target, "delete" /* TriggerOpTypes.DELETE */ , key, undefined, oldValue);
    return result;
}
function $005d1fb7704e278c$var$has(target, key) {
    const result = Reflect.has(target, key);
    if (!(0, $8POXm.isSymbol)(key) || !$005d1fb7704e278c$var$builtInSymbols.has(key)) $005d1fb7704e278c$export$6b2a7d5132615086(target, "has" /* TrackOpTypes.HAS */ , key);
    return result;
}
function $005d1fb7704e278c$var$ownKeys(target) {
    $005d1fb7704e278c$export$6b2a7d5132615086(target, "iterate" /* TrackOpTypes.ITERATE */ , (0, $8POXm.isArray)(target) ? 'length' : $005d1fb7704e278c$export$3c41b1a4e06acc14);
    return Reflect.ownKeys(target);
}
const $005d1fb7704e278c$var$mutableHandlers = {
    get: $005d1fb7704e278c$var$get,
    set: $005d1fb7704e278c$var$set,
    deleteProperty: $005d1fb7704e278c$var$deleteProperty,
    has: $005d1fb7704e278c$var$has,
    ownKeys: $005d1fb7704e278c$var$ownKeys
};
const $005d1fb7704e278c$var$readonlyHandlers = {
    get: $005d1fb7704e278c$var$readonlyGet,
    set (target, key) {
        return true;
    },
    deleteProperty (target, key) {
        return true;
    }
};
const $005d1fb7704e278c$var$shallowReactiveHandlers = /*#__PURE__*/ (0, $8POXm.extend)({}, $005d1fb7704e278c$var$mutableHandlers, {
    get: $005d1fb7704e278c$var$shallowGet,
    set: $005d1fb7704e278c$var$shallowSet
});
// Props handlers are special in the sense that it should not unwrap top-level
// refs (in order to allow refs to be explicitly passed down), but should
// retain the reactivity of the normal readonly object.
const $005d1fb7704e278c$var$shallowReadonlyHandlers = /*#__PURE__*/ (0, $8POXm.extend)({}, $005d1fb7704e278c$var$readonlyHandlers, {
    get: $005d1fb7704e278c$var$shallowReadonlyGet
});
const $005d1fb7704e278c$var$toShallow = (value)=>value;
const $005d1fb7704e278c$var$getProto = (v)=>Reflect.getPrototypeOf(v);
function $005d1fb7704e278c$var$get$1(target, key, isReadonly = false, isShallow = false) {
    // #1772: readonly(reactive(Map)) should return readonly + reactive version
    // of the value
    target = target["__v_raw" /* ReactiveFlags.RAW */ ];
    const rawTarget = $005d1fb7704e278c$export$ab18938b9fc5f28e(target);
    const rawKey = $005d1fb7704e278c$export$ab18938b9fc5f28e(key);
    if (!isReadonly) {
        if (key !== rawKey) $005d1fb7704e278c$export$6b2a7d5132615086(rawTarget, "get" /* TrackOpTypes.GET */ , key);
        $005d1fb7704e278c$export$6b2a7d5132615086(rawTarget, "get" /* TrackOpTypes.GET */ , rawKey);
    }
    const { has: has } = $005d1fb7704e278c$var$getProto(rawTarget);
    const wrap = isShallow ? $005d1fb7704e278c$var$toShallow : isReadonly ? $005d1fb7704e278c$var$toReadonly : $005d1fb7704e278c$var$toReactive;
    if (has.call(rawTarget, key)) return wrap(target.get(key));
    else if (has.call(rawTarget, rawKey)) return wrap(target.get(rawKey));
    else if (target !== rawTarget) // #3602 readonly(reactive(Map))
    // ensure that the nested reactive `Map` can do tracking for itself
    target.get(key);
}
function $005d1fb7704e278c$var$has$1(key, isReadonly = false) {
    const target = this["__v_raw" /* ReactiveFlags.RAW */ ];
    const rawTarget = $005d1fb7704e278c$export$ab18938b9fc5f28e(target);
    const rawKey = $005d1fb7704e278c$export$ab18938b9fc5f28e(key);
    if (!isReadonly) {
        if (key !== rawKey) $005d1fb7704e278c$export$6b2a7d5132615086(rawTarget, "has" /* TrackOpTypes.HAS */ , key);
        $005d1fb7704e278c$export$6b2a7d5132615086(rawTarget, "has" /* TrackOpTypes.HAS */ , rawKey);
    }
    return key === rawKey ? target.has(key) : target.has(key) || target.has(rawKey);
}
function $005d1fb7704e278c$var$size(target, isReadonly = false) {
    target = target["__v_raw" /* ReactiveFlags.RAW */ ];
    !isReadonly && $005d1fb7704e278c$export$6b2a7d5132615086($005d1fb7704e278c$export$ab18938b9fc5f28e(target), "iterate" /* TrackOpTypes.ITERATE */ , $005d1fb7704e278c$export$3c41b1a4e06acc14);
    return Reflect.get(target, 'size', target);
}
function $005d1fb7704e278c$var$add(value) {
    value = $005d1fb7704e278c$export$ab18938b9fc5f28e(value);
    const target = $005d1fb7704e278c$export$ab18938b9fc5f28e(this);
    const proto = $005d1fb7704e278c$var$getProto(target);
    const hadKey = proto.has.call(target, value);
    if (!hadKey) {
        target.add(value);
        $005d1fb7704e278c$export$e614dc9140f7ae71(target, "add" /* TriggerOpTypes.ADD */ , value, value);
    }
    return this;
}
function $005d1fb7704e278c$var$set$1(key, value) {
    value = $005d1fb7704e278c$export$ab18938b9fc5f28e(value);
    const target = $005d1fb7704e278c$export$ab18938b9fc5f28e(this);
    const { has: has, get: get } = $005d1fb7704e278c$var$getProto(target);
    let hadKey = has.call(target, key);
    if (!hadKey) {
        key = $005d1fb7704e278c$export$ab18938b9fc5f28e(key);
        hadKey = has.call(target, key);
    }
    const oldValue = get.call(target, key);
    target.set(key, value);
    if (!hadKey) $005d1fb7704e278c$export$e614dc9140f7ae71(target, "add" /* TriggerOpTypes.ADD */ , key, value);
    else if ((0, $8POXm.hasChanged)(value, oldValue)) $005d1fb7704e278c$export$e614dc9140f7ae71(target, "set" /* TriggerOpTypes.SET */ , key, value, oldValue);
    return this;
}
function $005d1fb7704e278c$var$deleteEntry(key) {
    const target = $005d1fb7704e278c$export$ab18938b9fc5f28e(this);
    const { has: has, get: get } = $005d1fb7704e278c$var$getProto(target);
    let hadKey = has.call(target, key);
    if (!hadKey) {
        key = $005d1fb7704e278c$export$ab18938b9fc5f28e(key);
        hadKey = has.call(target, key);
    }
    const oldValue = get ? get.call(target, key) : undefined;
    // forward the operation before queueing reactions
    const result = target.delete(key);
    if (hadKey) $005d1fb7704e278c$export$e614dc9140f7ae71(target, "delete" /* TriggerOpTypes.DELETE */ , key, undefined, oldValue);
    return result;
}
function $005d1fb7704e278c$var$clear() {
    const target = $005d1fb7704e278c$export$ab18938b9fc5f28e(this);
    const hadItems = target.size !== 0;
    const oldTarget = undefined;
    // forward the operation before queueing reactions
    const result = target.clear();
    if (hadItems) $005d1fb7704e278c$export$e614dc9140f7ae71(target, "clear" /* TriggerOpTypes.CLEAR */ , undefined, undefined, oldTarget);
    return result;
}
function $005d1fb7704e278c$var$createForEach(isReadonly, isShallow) {
    return function forEach(callback, thisArg) {
        const observed = this;
        const target = observed["__v_raw" /* ReactiveFlags.RAW */ ];
        const rawTarget = $005d1fb7704e278c$export$ab18938b9fc5f28e(target);
        const wrap = isShallow ? $005d1fb7704e278c$var$toShallow : isReadonly ? $005d1fb7704e278c$var$toReadonly : $005d1fb7704e278c$var$toReactive;
        !isReadonly && $005d1fb7704e278c$export$6b2a7d5132615086(rawTarget, "iterate" /* TrackOpTypes.ITERATE */ , $005d1fb7704e278c$export$3c41b1a4e06acc14);
        return target.forEach((value, key)=>{
            // important: make sure the callback is
            // 1. invoked with the reactive map as `this` and 3rd arg
            // 2. the value received should be a corresponding reactive/readonly.
            return callback.call(thisArg, wrap(value), wrap(key), observed);
        });
    };
}
function $005d1fb7704e278c$var$createIterableMethod(method, isReadonly, isShallow) {
    return function(...args) {
        const target = this["__v_raw" /* ReactiveFlags.RAW */ ];
        const rawTarget = $005d1fb7704e278c$export$ab18938b9fc5f28e(target);
        const targetIsMap = (0, $8POXm.isMap)(rawTarget);
        const isPair = method === 'entries' || method === Symbol.iterator && targetIsMap;
        const isKeyOnly = method === 'keys' && targetIsMap;
        const innerIterator = target[method](...args);
        const wrap = isShallow ? $005d1fb7704e278c$var$toShallow : isReadonly ? $005d1fb7704e278c$var$toReadonly : $005d1fb7704e278c$var$toReactive;
        !isReadonly && $005d1fb7704e278c$export$6b2a7d5132615086(rawTarget, "iterate" /* TrackOpTypes.ITERATE */ , isKeyOnly ? $005d1fb7704e278c$var$MAP_KEY_ITERATE_KEY : $005d1fb7704e278c$export$3c41b1a4e06acc14);
        // return a wrapped iterator which returns observed versions of the
        // values emitted from the real iterator
        return {
            // iterator protocol
            next () {
                const { value: value, done: done } = innerIterator.next();
                return done ? {
                    value: value,
                    done: done
                } : {
                    value: isPair ? [
                        wrap(value[0]),
                        wrap(value[1])
                    ] : wrap(value),
                    done: done
                };
            },
            // iterable protocol
            [Symbol.iterator] () {
                return this;
            }
        };
    };
}
function $005d1fb7704e278c$var$createReadonlyMethod(type) {
    return function(...args) {
        return type === "delete" /* TriggerOpTypes.DELETE */  ? false : this;
    };
}
function $005d1fb7704e278c$var$createInstrumentations() {
    const mutableInstrumentations = {
        get (key) {
            return $005d1fb7704e278c$var$get$1(this, key);
        },
        get size () {
            return $005d1fb7704e278c$var$size(this);
        },
        has: $005d1fb7704e278c$var$has$1,
        add: $005d1fb7704e278c$var$add,
        set: $005d1fb7704e278c$var$set$1,
        delete: $005d1fb7704e278c$var$deleteEntry,
        clear: $005d1fb7704e278c$var$clear,
        forEach: $005d1fb7704e278c$var$createForEach(false, false)
    };
    const shallowInstrumentations = {
        get (key) {
            return $005d1fb7704e278c$var$get$1(this, key, false, true);
        },
        get size () {
            return $005d1fb7704e278c$var$size(this);
        },
        has: $005d1fb7704e278c$var$has$1,
        add: $005d1fb7704e278c$var$add,
        set: $005d1fb7704e278c$var$set$1,
        delete: $005d1fb7704e278c$var$deleteEntry,
        clear: $005d1fb7704e278c$var$clear,
        forEach: $005d1fb7704e278c$var$createForEach(false, true)
    };
    const readonlyInstrumentations = {
        get (key) {
            return $005d1fb7704e278c$var$get$1(this, key, true);
        },
        get size () {
            return $005d1fb7704e278c$var$size(this, true);
        },
        has (key) {
            return $005d1fb7704e278c$var$has$1.call(this, key, true);
        },
        add: $005d1fb7704e278c$var$createReadonlyMethod("add" /* TriggerOpTypes.ADD */ ),
        set: $005d1fb7704e278c$var$createReadonlyMethod("set" /* TriggerOpTypes.SET */ ),
        delete: $005d1fb7704e278c$var$createReadonlyMethod("delete" /* TriggerOpTypes.DELETE */ ),
        clear: $005d1fb7704e278c$var$createReadonlyMethod("clear" /* TriggerOpTypes.CLEAR */ ),
        forEach: $005d1fb7704e278c$var$createForEach(true, false)
    };
    const shallowReadonlyInstrumentations = {
        get (key) {
            return $005d1fb7704e278c$var$get$1(this, key, true, true);
        },
        get size () {
            return $005d1fb7704e278c$var$size(this, true);
        },
        has (key) {
            return $005d1fb7704e278c$var$has$1.call(this, key, true);
        },
        add: $005d1fb7704e278c$var$createReadonlyMethod("add" /* TriggerOpTypes.ADD */ ),
        set: $005d1fb7704e278c$var$createReadonlyMethod("set" /* TriggerOpTypes.SET */ ),
        delete: $005d1fb7704e278c$var$createReadonlyMethod("delete" /* TriggerOpTypes.DELETE */ ),
        clear: $005d1fb7704e278c$var$createReadonlyMethod("clear" /* TriggerOpTypes.CLEAR */ ),
        forEach: $005d1fb7704e278c$var$createForEach(true, true)
    };
    const iteratorMethods = [
        'keys',
        'values',
        'entries',
        Symbol.iterator
    ];
    iteratorMethods.forEach((method)=>{
        mutableInstrumentations[method] = $005d1fb7704e278c$var$createIterableMethod(method, false, false);
        readonlyInstrumentations[method] = $005d1fb7704e278c$var$createIterableMethod(method, true, false);
        shallowInstrumentations[method] = $005d1fb7704e278c$var$createIterableMethod(method, false, true);
        shallowReadonlyInstrumentations[method] = $005d1fb7704e278c$var$createIterableMethod(method, true, true);
    });
    return [
        mutableInstrumentations,
        readonlyInstrumentations,
        shallowInstrumentations,
        shallowReadonlyInstrumentations
    ];
}
const [$005d1fb7704e278c$var$mutableInstrumentations, $005d1fb7704e278c$var$readonlyInstrumentations, $005d1fb7704e278c$var$shallowInstrumentations, $005d1fb7704e278c$var$shallowReadonlyInstrumentations] = /* #__PURE__*/ $005d1fb7704e278c$var$createInstrumentations();
function $005d1fb7704e278c$var$createInstrumentationGetter(isReadonly, shallow) {
    const instrumentations = shallow ? isReadonly ? $005d1fb7704e278c$var$shallowReadonlyInstrumentations : $005d1fb7704e278c$var$shallowInstrumentations : isReadonly ? $005d1fb7704e278c$var$readonlyInstrumentations : $005d1fb7704e278c$var$mutableInstrumentations;
    return (target, key, receiver)=>{
        if (key === "__v_isReactive" /* ReactiveFlags.IS_REACTIVE */ ) return !isReadonly;
        else if (key === "__v_isReadonly" /* ReactiveFlags.IS_READONLY */ ) return isReadonly;
        else if (key === "__v_raw" /* ReactiveFlags.RAW */ ) return target;
        return Reflect.get((0, $8POXm.hasOwn)(instrumentations, key) && key in target ? instrumentations : target, key, receiver);
    };
}
const $005d1fb7704e278c$var$mutableCollectionHandlers = {
    get: /*#__PURE__*/ $005d1fb7704e278c$var$createInstrumentationGetter(false, false)
};
const $005d1fb7704e278c$var$shallowCollectionHandlers = {
    get: /*#__PURE__*/ $005d1fb7704e278c$var$createInstrumentationGetter(false, true)
};
const $005d1fb7704e278c$var$readonlyCollectionHandlers = {
    get: /*#__PURE__*/ $005d1fb7704e278c$var$createInstrumentationGetter(true, false)
};
const $005d1fb7704e278c$var$shallowReadonlyCollectionHandlers = {
    get: /*#__PURE__*/ $005d1fb7704e278c$var$createInstrumentationGetter(true, true)
};
function $005d1fb7704e278c$var$checkIdentityKeys(target, has, key) {
    const rawKey = $005d1fb7704e278c$export$ab18938b9fc5f28e(key);
    if (rawKey !== key && has.call(target, rawKey)) {
        const type = (0, $8POXm.toRawType)(target);
        console.warn(`Reactive ${type} contains both the raw and reactive ` + `versions of the same object${type === `Map` ? ` as keys` : ``}, ` + `which can lead to inconsistencies. ` + `Avoid differentiating between the raw and reactive versions ` + `of an object and only use the reactive version if possible.`);
    }
}
const $005d1fb7704e278c$var$reactiveMap = new WeakMap();
const $005d1fb7704e278c$var$shallowReactiveMap = new WeakMap();
const $005d1fb7704e278c$var$readonlyMap = new WeakMap();
const $005d1fb7704e278c$var$shallowReadonlyMap = new WeakMap();
function $005d1fb7704e278c$var$targetTypeMap(rawType) {
    switch(rawType){
        case 'Object':
        case 'Array':
            return 1 /* TargetType.COMMON */ ;
        case 'Map':
        case 'Set':
        case 'WeakMap':
        case 'WeakSet':
            return 2 /* TargetType.COLLECTION */ ;
        default:
            return 0 /* TargetType.INVALID */ ;
    }
}
function $005d1fb7704e278c$var$getTargetType(value) {
    return value["__v_skip" /* ReactiveFlags.SKIP */ ] || !Object.isExtensible(value) ? 0 /* TargetType.INVALID */  : $005d1fb7704e278c$var$targetTypeMap((0, $8POXm.toRawType)(value));
}
function $005d1fb7704e278c$export$90a44edba14e47be(target) {
    // if trying to observe a readonly proxy, return the readonly version.
    if ($005d1fb7704e278c$export$92d09b48637741e7(target)) return target;
    return $005d1fb7704e278c$var$createReactiveObject(target, false, $005d1fb7704e278c$var$mutableHandlers, $005d1fb7704e278c$var$mutableCollectionHandlers, $005d1fb7704e278c$var$reactiveMap);
}
/**
 * Return a shallowly-reactive copy of the original object, where only the root
 * level properties are reactive. It also does not auto-unwrap refs (even at the
 * root level).
 */ function $005d1fb7704e278c$export$8d81cefd22d22260(target) {
    return $005d1fb7704e278c$var$createReactiveObject(target, false, $005d1fb7704e278c$var$shallowReactiveHandlers, $005d1fb7704e278c$var$shallowCollectionHandlers, $005d1fb7704e278c$var$shallowReactiveMap);
}
/**
 * Creates a readonly copy of the original object. Note the returned copy is not
 * made reactive, but `readonly` can be called on an already reactive object.
 */ function $005d1fb7704e278c$export$6ec456bd5b7b3c51(target) {
    return $005d1fb7704e278c$var$createReactiveObject(target, true, $005d1fb7704e278c$var$readonlyHandlers, $005d1fb7704e278c$var$readonlyCollectionHandlers, $005d1fb7704e278c$var$readonlyMap);
}
/**
 * Returns a reactive-copy of the original object, where only the root level
 * properties are readonly, and does NOT unwrap refs nor recursively convert
 * returned properties.
 * This is used for creating the props proxy object for stateful components.
 */ function $005d1fb7704e278c$export$7c4b5f2b50f09f6b(target) {
    return $005d1fb7704e278c$var$createReactiveObject(target, true, $005d1fb7704e278c$var$shallowReadonlyHandlers, $005d1fb7704e278c$var$shallowReadonlyCollectionHandlers, $005d1fb7704e278c$var$shallowReadonlyMap);
}
function $005d1fb7704e278c$var$createReactiveObject(target, isReadonly, baseHandlers, collectionHandlers, proxyMap) {
    if (!(0, $8POXm.isObject)(target)) return target;
    // target is already a Proxy, return it.
    // exception: calling readonly() on a reactive object
    if (target["__v_raw" /* ReactiveFlags.RAW */ ] && !(isReadonly && target["__v_isReactive" /* ReactiveFlags.IS_REACTIVE */ ])) return target;
    // target already has corresponding Proxy
    const existingProxy = proxyMap.get(target);
    if (existingProxy) return existingProxy;
    // only specific value types can be observed.
    const targetType = $005d1fb7704e278c$var$getTargetType(target);
    if (targetType === 0 /* TargetType.INVALID */ ) return target;
    const proxy = new Proxy(target, targetType === 2 /* TargetType.COLLECTION */  ? collectionHandlers : baseHandlers);
    proxyMap.set(target, proxy);
    return proxy;
}
function $005d1fb7704e278c$export$352205f445242f02(value) {
    if ($005d1fb7704e278c$export$92d09b48637741e7(value)) return $005d1fb7704e278c$export$352205f445242f02(value["__v_raw" /* ReactiveFlags.RAW */ ]);
    return !!(value && value["__v_isReactive" /* ReactiveFlags.IS_REACTIVE */ ]);
}
function $005d1fb7704e278c$export$92d09b48637741e7(value) {
    return !!(value && value["__v_isReadonly" /* ReactiveFlags.IS_READONLY */ ]);
}
function $005d1fb7704e278c$export$7f3fe6025abfa26e(value) {
    return !!(value && value["__v_isShallow" /* ReactiveFlags.IS_SHALLOW */ ]);
}
function $005d1fb7704e278c$export$5f3ca29d057519b3(value) {
    return $005d1fb7704e278c$export$352205f445242f02(value) || $005d1fb7704e278c$export$92d09b48637741e7(value);
}
function $005d1fb7704e278c$export$ab18938b9fc5f28e(observed) {
    const raw = observed && observed["__v_raw" /* ReactiveFlags.RAW */ ];
    return raw ? $005d1fb7704e278c$export$ab18938b9fc5f28e(raw) : observed;
}
function $005d1fb7704e278c$export$995ab8b13ad7a9d0(value) {
    (0, $8POXm.def)(value, "__v_skip" /* ReactiveFlags.SKIP */ , true);
    return value;
}
const $005d1fb7704e278c$var$toReactive = (value)=>(0, $8POXm.isObject)(value) ? $005d1fb7704e278c$export$90a44edba14e47be(value) : value;
const $005d1fb7704e278c$var$toReadonly = (value)=>(0, $8POXm.isObject)(value) ? $005d1fb7704e278c$export$6ec456bd5b7b3c51(value) : value;
function $005d1fb7704e278c$var$trackRefValue(ref) {
    if ($005d1fb7704e278c$var$shouldTrack && $005d1fb7704e278c$var$activeEffect) {
        ref = $005d1fb7704e278c$export$ab18938b9fc5f28e(ref);
        $005d1fb7704e278c$var$trackEffects(ref.dep || (ref.dep = $005d1fb7704e278c$var$createDep()));
    }
}
function $005d1fb7704e278c$var$triggerRefValue(ref, newVal) {
    ref = $005d1fb7704e278c$export$ab18938b9fc5f28e(ref);
    if (ref.dep) $005d1fb7704e278c$var$triggerEffects(ref.dep);
}
function $005d1fb7704e278c$export$4f9f5282de18fc69(r) {
    return !!(r && r.__v_isRef === true);
}
function $005d1fb7704e278c$export$eff4d24c3ff7876e(value) {
    return $005d1fb7704e278c$var$createRef(value, false);
}
function $005d1fb7704e278c$export$9b7bc5fe3b17c8b3(value) {
    return $005d1fb7704e278c$var$createRef(value, true);
}
function $005d1fb7704e278c$var$createRef(rawValue, shallow) {
    if ($005d1fb7704e278c$export$4f9f5282de18fc69(rawValue)) return rawValue;
    return new $005d1fb7704e278c$var$RefImpl(rawValue, shallow);
}
class $005d1fb7704e278c$var$RefImpl {
    constructor(value, __v_isShallow){
        this.__v_isShallow = __v_isShallow;
        this.dep = undefined;
        this.__v_isRef = true;
        this._rawValue = __v_isShallow ? value : $005d1fb7704e278c$export$ab18938b9fc5f28e(value);
        this._value = __v_isShallow ? value : $005d1fb7704e278c$var$toReactive(value);
    }
    get value() {
        $005d1fb7704e278c$var$trackRefValue(this);
        return this._value;
    }
    set value(newVal) {
        const useDirectValue = this.__v_isShallow || $005d1fb7704e278c$export$7f3fe6025abfa26e(newVal) || $005d1fb7704e278c$export$92d09b48637741e7(newVal);
        newVal = useDirectValue ? newVal : $005d1fb7704e278c$export$ab18938b9fc5f28e(newVal);
        if ((0, $8POXm.hasChanged)(newVal, this._rawValue)) {
            this._rawValue = newVal;
            this._value = useDirectValue ? newVal : $005d1fb7704e278c$var$toReactive(newVal);
            $005d1fb7704e278c$var$triggerRefValue(this, newVal);
        }
    }
}
function $005d1fb7704e278c$export$f402f86588575ccc(ref) {
    $005d1fb7704e278c$var$triggerRefValue(ref, void 0);
}
function $005d1fb7704e278c$export$a239a76781616204(ref) {
    return $005d1fb7704e278c$export$4f9f5282de18fc69(ref) ? ref.value : ref;
}
const $005d1fb7704e278c$var$shallowUnwrapHandlers = {
    get: (target, key, receiver)=>$005d1fb7704e278c$export$a239a76781616204(Reflect.get(target, key, receiver)),
    set: (target, key, value, receiver)=>{
        const oldValue = target[key];
        if ($005d1fb7704e278c$export$4f9f5282de18fc69(oldValue) && !$005d1fb7704e278c$export$4f9f5282de18fc69(value)) {
            oldValue.value = value;
            return true;
        } else return Reflect.set(target, key, value, receiver);
    }
};
function $005d1fb7704e278c$export$f353fd1b97db3fa0(objectWithRefs) {
    return $005d1fb7704e278c$export$352205f445242f02(objectWithRefs) ? objectWithRefs : new Proxy(objectWithRefs, $005d1fb7704e278c$var$shallowUnwrapHandlers);
}
class $005d1fb7704e278c$var$CustomRefImpl {
    constructor(factory){
        this.dep = undefined;
        this.__v_isRef = true;
        const { get: get, set: set } = factory(()=>$005d1fb7704e278c$var$trackRefValue(this), ()=>$005d1fb7704e278c$var$triggerRefValue(this));
        this._get = get;
        this._set = set;
    }
    get value() {
        return this._get();
    }
    set value(newVal) {
        this._set(newVal);
    }
}
function $005d1fb7704e278c$export$a20c2dd6199824cb(factory) {
    return new $005d1fb7704e278c$var$CustomRefImpl(factory);
}
function $005d1fb7704e278c$export$2e9533675e5e70e0(object) {
    const ret = (0, $8POXm.isArray)(object) ? new Array(object.length) : {};
    for(const key in object)ret[key] = $005d1fb7704e278c$export$1f60508e4f47b4b7(object, key);
    return ret;
}
class $005d1fb7704e278c$var$ObjectRefImpl {
    constructor(_object, _key, _defaultValue){
        this._object = _object;
        this._key = _key;
        this._defaultValue = _defaultValue;
        this.__v_isRef = true;
    }
    get value() {
        const val = this._object[this._key];
        return val === undefined ? this._defaultValue : val;
    }
    set value(newVal) {
        this._object[this._key] = newVal;
    }
}
function $005d1fb7704e278c$export$1f60508e4f47b4b7(object, key, defaultValue) {
    const val = object[key];
    return $005d1fb7704e278c$export$4f9f5282de18fc69(val) ? val : new $005d1fb7704e278c$var$ObjectRefImpl(object, key, defaultValue);
}
var $005d1fb7704e278c$var$_a;
class $005d1fb7704e278c$var$ComputedRefImpl {
    constructor(getter, _setter, isReadonly, isSSR){
        this._setter = _setter;
        this.dep = undefined;
        this.__v_isRef = true;
        this[$005d1fb7704e278c$var$_a] = false;
        this._dirty = true;
        this.effect = new $005d1fb7704e278c$export$28352bb4dd362521(getter, ()=>{
            if (!this._dirty) {
                this._dirty = true;
                $005d1fb7704e278c$var$triggerRefValue(this);
            }
        });
        this.effect.computed = this;
        this.effect.active = this._cacheable = !isSSR;
        this["__v_isReadonly" /* ReactiveFlags.IS_READONLY */ ] = isReadonly;
    }
    get value() {
        // the computed ref may get wrapped by other proxies e.g. readonly() #3376
        const self = $005d1fb7704e278c$export$ab18938b9fc5f28e(this);
        $005d1fb7704e278c$var$trackRefValue(self);
        if (self._dirty || !self._cacheable) {
            self._dirty = false;
            self._value = self.effect.run();
        }
        return self._value;
    }
    set value(newValue) {
        this._setter(newValue);
    }
}
$005d1fb7704e278c$var$_a = "__v_isReadonly" /* ReactiveFlags.IS_READONLY */ ;
function $005d1fb7704e278c$export$2983e091f1a1e8e2(getterOrOptions, debugOptions, isSSR = false) {
    let getter;
    let setter;
    const onlyGetter = (0, $8POXm.isFunction)(getterOrOptions);
    if (onlyGetter) {
        getter = getterOrOptions;
        setter = (0, $8POXm.NOOP);
    } else {
        getter = getterOrOptions.get;
        setter = getterOrOptions.set;
    }
    const cRef = new $005d1fb7704e278c$var$ComputedRefImpl(getter, setter, onlyGetter || !setter, isSSR);
    return cRef;
}
var $005d1fb7704e278c$var$_a$1;
const $005d1fb7704e278c$var$tick = /*#__PURE__*/ Promise.resolve();
const $005d1fb7704e278c$var$queue = [];
let $005d1fb7704e278c$var$queued = false;
const $005d1fb7704e278c$var$scheduler = (fn)=>{
    $005d1fb7704e278c$var$queue.push(fn);
    if (!$005d1fb7704e278c$var$queued) {
        $005d1fb7704e278c$var$queued = true;
        $005d1fb7704e278c$var$tick.then($005d1fb7704e278c$var$flush);
    }
};
const $005d1fb7704e278c$var$flush = ()=>{
    for(let i = 0; i < $005d1fb7704e278c$var$queue.length; i++)$005d1fb7704e278c$var$queue[i]();
    $005d1fb7704e278c$var$queue.length = 0;
    $005d1fb7704e278c$var$queued = false;
};
class $005d1fb7704e278c$var$DeferredComputedRefImpl {
    constructor(getter){
        this.dep = undefined;
        this._dirty = true;
        this.__v_isRef = true;
        this[$005d1fb7704e278c$var$_a$1] = true;
        let compareTarget;
        let hasCompareTarget = false;
        let scheduled = false;
        this.effect = new $005d1fb7704e278c$export$28352bb4dd362521(getter, (computedTrigger)=>{
            if (this.dep) {
                if (computedTrigger) {
                    compareTarget = this._value;
                    hasCompareTarget = true;
                } else if (!scheduled) {
                    const valueToCompare = hasCompareTarget ? compareTarget : this._value;
                    scheduled = true;
                    hasCompareTarget = false;
                    $005d1fb7704e278c$var$scheduler(()=>{
                        if (this.effect.active && this._get() !== valueToCompare) $005d1fb7704e278c$var$triggerRefValue(this);
                        scheduled = false;
                    });
                }
                // chained upstream computeds are notified synchronously to ensure
                // value invalidation in case of sync access; normal effects are
                // deferred to be triggered in scheduler.
                for (const e of this.dep)if (e.computed instanceof $005d1fb7704e278c$var$DeferredComputedRefImpl) e.scheduler(true);
            }
            this._dirty = true;
        });
        this.effect.computed = this;
    }
    _get() {
        if (this._dirty) {
            this._dirty = false;
            return this._value = this.effect.run();
        }
        return this._value;
    }
    get value() {
        $005d1fb7704e278c$var$trackRefValue(this);
        // the computed ref may get wrapped by other proxies e.g. readonly() #3376
        return $005d1fb7704e278c$export$ab18938b9fc5f28e(this)._get();
    }
}
$005d1fb7704e278c$var$_a$1 = "__v_isReadonly" /* ReactiveFlags.IS_READONLY */ ;
function $005d1fb7704e278c$export$483264c4ec4c46ce(getter) {
    return new $005d1fb7704e278c$var$DeferredComputedRefImpl(getter);
}

});
parcelRegister("8POXm", function(module, exports) {

$parcel$export(module.exports, "makeMap", () => $66ea9d0aaa418c4d$export$b41394a5437791c8);
$parcel$export(module.exports, "PatchFlagNames", () => $66ea9d0aaa418c4d$export$def7dc2c2e95a08a);
$parcel$export(module.exports, "isGloballyWhitelisted", () => $66ea9d0aaa418c4d$export$d6571a1911e4f27e);
$parcel$export(module.exports, "isSpecialBooleanAttr", () => $66ea9d0aaa418c4d$export$d186f5eb2e810715);
$parcel$export(module.exports, "includeBooleanAttr", () => $66ea9d0aaa418c4d$export$e3f3cdb1390d56ce);
$parcel$export(module.exports, "normalizeStyle", () => $66ea9d0aaa418c4d$export$8756898546458274);
$parcel$export(module.exports, "isArray", () => $66ea9d0aaa418c4d$export$43bee75e5e14138e);
$parcel$export(module.exports, "isString", () => $66ea9d0aaa418c4d$export$844ec244b1367d54);
$parcel$export(module.exports, "parseStringStyle", () => $66ea9d0aaa418c4d$export$76a205ce979d066a);
$parcel$export(module.exports, "isObject", () => $66ea9d0aaa418c4d$export$a6cdc56e425d0d0a);
$parcel$export(module.exports, "hyphenate", () => $66ea9d0aaa418c4d$export$6e6a0a3676c4b8bb);
$parcel$export(module.exports, "normalizeClass", () => $66ea9d0aaa418c4d$export$4f7022d2d68e2c5a);
$parcel$export(module.exports, "normalizeProps", () => $66ea9d0aaa418c4d$export$601abcd8103db5e4);
$parcel$export(module.exports, "isHTMLTag", () => $66ea9d0aaa418c4d$export$1ccf854a0984f890);
$parcel$export(module.exports, "isSVGTag", () => $66ea9d0aaa418c4d$export$6328ce7565ea1049);
$parcel$export(module.exports, "isVoidTag", () => $66ea9d0aaa418c4d$export$e5f2d3d97d9367a4);
$parcel$export(module.exports, "looseEqual", () => $66ea9d0aaa418c4d$export$ae8015769846262c);
$parcel$export(module.exports, "isSymbol", () => $66ea9d0aaa418c4d$export$a244864fd9645c7f);
$parcel$export(module.exports, "looseIndexOf", () => $66ea9d0aaa418c4d$export$42912a80cedb8bd4);
$parcel$export(module.exports, "toDisplayString", () => $66ea9d0aaa418c4d$export$b5b1545233b45293);
$parcel$export(module.exports, "isFunction", () => $66ea9d0aaa418c4d$export$f6e2535fb5126e54);
$parcel$export(module.exports, "isMap", () => $66ea9d0aaa418c4d$export$5c90113a285f2241);
$parcel$export(module.exports, "isSet", () => $66ea9d0aaa418c4d$export$6750766a7c7ec627);
$parcel$export(module.exports, "isPlainObject", () => $66ea9d0aaa418c4d$export$53b83ca8eaab0383);
$parcel$export(module.exports, "EMPTY_OBJ", () => $66ea9d0aaa418c4d$export$cf583d23ab39677c);
$parcel$export(module.exports, "EMPTY_ARR", () => $66ea9d0aaa418c4d$export$6bd8558f433f1cc1);
$parcel$export(module.exports, "NOOP", () => $66ea9d0aaa418c4d$export$5702a91a6f42969f);
$parcel$export(module.exports, "NO", () => $66ea9d0aaa418c4d$export$c01351c0af048e39);
$parcel$export(module.exports, "isOn", () => $66ea9d0aaa418c4d$export$1a2d97de39ecbb75);
$parcel$export(module.exports, "isModelListener", () => $66ea9d0aaa418c4d$export$793aa5469768d691);
$parcel$export(module.exports, "extend", () => $66ea9d0aaa418c4d$export$8b58be045bf06082);
$parcel$export(module.exports, "remove", () => $66ea9d0aaa418c4d$export$cd7f480d6b8286c3);
$parcel$export(module.exports, "hasOwn", () => $66ea9d0aaa418c4d$export$b5a638e9b3fff9f3);
$parcel$export(module.exports, "isPromise", () => $66ea9d0aaa418c4d$export$4369c812aac99591);
$parcel$export(module.exports, "toRawType", () => $66ea9d0aaa418c4d$export$5ad0a3c360b8fbb5);
$parcel$export(module.exports, "isIntegerKey", () => $66ea9d0aaa418c4d$export$e2a2b93446ec9fe);
$parcel$export(module.exports, "isReservedProp", () => $66ea9d0aaa418c4d$export$bf7d3c0236f0aa85);
$parcel$export(module.exports, "isBuiltInDirective", () => $66ea9d0aaa418c4d$export$a9c1fdb3030c2a6b);
$parcel$export(module.exports, "camelize", () => $66ea9d0aaa418c4d$export$161d051f5dd25de7);
$parcel$export(module.exports, "capitalize", () => $66ea9d0aaa418c4d$export$9a00dee1beb8f576);
$parcel$export(module.exports, "toHandlerKey", () => $66ea9d0aaa418c4d$export$8c022799eeaaefcd);
$parcel$export(module.exports, "hasChanged", () => $66ea9d0aaa418c4d$export$f619eb8b89076d23);
$parcel$export(module.exports, "invokeArrayFns", () => $66ea9d0aaa418c4d$export$39951422d618a9d3);
$parcel$export(module.exports, "def", () => $66ea9d0aaa418c4d$export$8afb76124cf08683);
$parcel$export(module.exports, "toNumber", () => $66ea9d0aaa418c4d$export$a0a81dc3380ce7d3);
$parcel$export(module.exports, "getGlobalThis", () => $66ea9d0aaa418c4d$export$ff5f2eeb11fc7e14);
/**
 * Make a map and return a function for checking if a key
 * is in that map.
 * IMPORTANT: all calls of this function must be prefixed with
 * \/\*#\_\_PURE\_\_\*\/
 * So that rollup can tree-shake them if necessary.
 */ function $66ea9d0aaa418c4d$export$b41394a5437791c8(str, expectsLowerCase) {
    const map = Object.create(null);
    const list = str.split(',');
    for(let i = 0; i < list.length; i++)map[list[i]] = true;
    return expectsLowerCase ? (val)=>!!map[val.toLowerCase()] : (val)=>!!map[val];
}
/**
 * dev only flag -> name mapping
 */ const $66ea9d0aaa418c4d$export$def7dc2c2e95a08a = {
    [1 /* PatchFlags.TEXT */ ]: `TEXT`,
    [2 /* PatchFlags.CLASS */ ]: `CLASS`,
    [4 /* PatchFlags.STYLE */ ]: `STYLE`,
    [8 /* PatchFlags.PROPS */ ]: `PROPS`,
    [16 /* PatchFlags.FULL_PROPS */ ]: `FULL_PROPS`,
    [32 /* PatchFlags.HYDRATE_EVENTS */ ]: `HYDRATE_EVENTS`,
    [64 /* PatchFlags.STABLE_FRAGMENT */ ]: `STABLE_FRAGMENT`,
    [128 /* PatchFlags.KEYED_FRAGMENT */ ]: `KEYED_FRAGMENT`,
    [256 /* PatchFlags.UNKEYED_FRAGMENT */ ]: `UNKEYED_FRAGMENT`,
    [512 /* PatchFlags.NEED_PATCH */ ]: `NEED_PATCH`,
    [1024 /* PatchFlags.DYNAMIC_SLOTS */ ]: `DYNAMIC_SLOTS`,
    [2048 /* PatchFlags.DEV_ROOT_FRAGMENT */ ]: `DEV_ROOT_FRAGMENT`,
    [-1 /* PatchFlags.HOISTED */ ]: `HOISTED`,
    [-2 /* PatchFlags.BAIL */ ]: `BAIL`
};
/**
 * Dev only
 */ const $66ea9d0aaa418c4d$export$624972196ed3745f = {
    [1 /* SlotFlags.STABLE */ ]: 'STABLE',
    [2 /* SlotFlags.DYNAMIC */ ]: 'DYNAMIC',
    [3 /* SlotFlags.FORWARDED */ ]: 'FORWARDED'
};
const $66ea9d0aaa418c4d$var$GLOBALS_WHITE_LISTED = "Infinity,undefined,NaN,isFinite,isNaN,parseFloat,parseInt,decodeURI,decodeURIComponent,encodeURI,encodeURIComponent,Math,Number,Date,Array,Object,Boolean,String,RegExp,Map,Set,JSON,Intl,BigInt";
const $66ea9d0aaa418c4d$export$d6571a1911e4f27e = /*#__PURE__*/ $66ea9d0aaa418c4d$export$b41394a5437791c8($66ea9d0aaa418c4d$var$GLOBALS_WHITE_LISTED);
const $66ea9d0aaa418c4d$var$range = 2;
function $66ea9d0aaa418c4d$export$f9c0d8b6684a279b(source, start = 0, end = source.length) {
    // Split the content into individual lines but capture the newline sequence
    // that separated each line. This is important because the actual sequence is
    // needed to properly take into account the full line length for offset
    // comparison
    let lines = source.split(/(\r?\n)/);
    // Separate the lines and newline sequences into separate arrays for easier referencing
    const newlineSequences = lines.filter((_, idx)=>idx % 2 === 1);
    lines = lines.filter((_, idx)=>idx % 2 === 0);
    let count = 0;
    const res = [];
    for(let i = 0; i < lines.length; i++){
        count += lines[i].length + (newlineSequences[i] && newlineSequences[i].length || 0);
        if (count >= start) {
            for(let j = i - $66ea9d0aaa418c4d$var$range; j <= i + $66ea9d0aaa418c4d$var$range || end > count; j++){
                if (j < 0 || j >= lines.length) continue;
                const line = j + 1;
                res.push(`${line}${' '.repeat(Math.max(3 - String(line).length, 0))}|  ${lines[j]}`);
                const lineLength = lines[j].length;
                const newLineSeqLength = newlineSequences[j] && newlineSequences[j].length || 0;
                if (j === i) {
                    // push underline
                    const pad = start - (count - (lineLength + newLineSeqLength));
                    const length = Math.max(1, end > count ? lineLength - pad : end - start);
                    res.push(`   |  ` + ' '.repeat(pad) + '^'.repeat(length));
                } else if (j > i) {
                    if (end > count) {
                        const length = Math.max(Math.min(end - count, lineLength), 1);
                        res.push(`   |  ` + '^'.repeat(length));
                    }
                    count += lineLength + newLineSeqLength;
                }
            }
            break;
        }
    }
    return res.join('\n');
}
/**
 * On the client we only need to offer special cases for boolean attributes that
 * have different names from their corresponding dom properties:
 * - itemscope -> N/A
 * - allowfullscreen -> allowFullscreen
 * - formnovalidate -> formNoValidate
 * - ismap -> isMap
 * - nomodule -> noModule
 * - novalidate -> noValidate
 * - readonly -> readOnly
 */ const $66ea9d0aaa418c4d$var$specialBooleanAttrs = `itemscope,allowfullscreen,formnovalidate,ismap,nomodule,novalidate,readonly`;
const $66ea9d0aaa418c4d$export$d186f5eb2e810715 = /*#__PURE__*/ $66ea9d0aaa418c4d$export$b41394a5437791c8($66ea9d0aaa418c4d$var$specialBooleanAttrs);
/**
 * The full list is needed during SSR to produce the correct initial markup.
 */ const $66ea9d0aaa418c4d$export$f763ba3b84e9cd8c = /*#__PURE__*/ $66ea9d0aaa418c4d$export$b41394a5437791c8($66ea9d0aaa418c4d$var$specialBooleanAttrs + `,async,autofocus,autoplay,controls,default,defer,disabled,hidden,` + `loop,open,required,reversed,scoped,seamless,` + `checked,muted,multiple,selected`);
/**
 * Boolean attributes should be included if the value is truthy or ''.
 * e.g. `<select multiple>` compiles to `{ multiple: '' }`
 */ function $66ea9d0aaa418c4d$export$e3f3cdb1390d56ce(value) {
    return !!value || value === '';
}
const $66ea9d0aaa418c4d$var$unsafeAttrCharRE = /[>/="'\u0009\u000a\u000c\u0020]/;
const $66ea9d0aaa418c4d$var$attrValidationCache = {};
function $66ea9d0aaa418c4d$export$d55ef77660f30d12(name) {
    if ($66ea9d0aaa418c4d$var$attrValidationCache.hasOwnProperty(name)) return $66ea9d0aaa418c4d$var$attrValidationCache[name];
    const isUnsafe = $66ea9d0aaa418c4d$var$unsafeAttrCharRE.test(name);
    if (isUnsafe) console.error(`unsafe attribute name: ${name}`);
    return $66ea9d0aaa418c4d$var$attrValidationCache[name] = !isUnsafe;
}
const $66ea9d0aaa418c4d$export$b66fd0cae8dec3c8 = {
    acceptCharset: 'accept-charset',
    className: 'class',
    htmlFor: 'for',
    httpEquiv: 'http-equiv'
};
/**
 * CSS properties that accept plain numbers
 */ const $66ea9d0aaa418c4d$export$84da53524c6b1314 = /*#__PURE__*/ $66ea9d0aaa418c4d$export$b41394a5437791c8(`animation-iteration-count,border-image-outset,border-image-slice,` + `border-image-width,box-flex,box-flex-group,box-ordinal-group,column-count,` + `columns,flex,flex-grow,flex-positive,flex-shrink,flex-negative,flex-order,` + `grid-row,grid-row-end,grid-row-span,grid-row-start,grid-column,` + `grid-column-end,grid-column-span,grid-column-start,font-weight,line-clamp,` + `line-height,opacity,order,orphans,tab-size,widows,z-index,zoom,` + // SVG
`fill-opacity,flood-opacity,stop-opacity,stroke-dasharray,stroke-dashoffset,` + `stroke-miterlimit,stroke-opacity,stroke-width`);
/**
 * Known attributes, this is used for stringification of runtime static nodes
 * so that we don't stringify bindings that cannot be set from HTML.
 * Don't also forget to allow `data-*` and `aria-*`!
 * Generated from https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes
 */ const $66ea9d0aaa418c4d$export$f7e7a1cc7da8d5e9 = /*#__PURE__*/ $66ea9d0aaa418c4d$export$b41394a5437791c8(`accept,accept-charset,accesskey,action,align,allow,alt,async,` + `autocapitalize,autocomplete,autofocus,autoplay,background,bgcolor,` + `border,buffered,capture,challenge,charset,checked,cite,class,code,` + `codebase,color,cols,colspan,content,contenteditable,contextmenu,controls,` + `coords,crossorigin,csp,data,datetime,decoding,default,defer,dir,dirname,` + `disabled,download,draggable,dropzone,enctype,enterkeyhint,for,form,` + `formaction,formenctype,formmethod,formnovalidate,formtarget,headers,` + `height,hidden,high,href,hreflang,http-equiv,icon,id,importance,integrity,` + `ismap,itemprop,keytype,kind,label,lang,language,loading,list,loop,low,` + `manifest,max,maxlength,minlength,media,min,multiple,muted,name,novalidate,` + `open,optimum,pattern,ping,placeholder,poster,preload,radiogroup,readonly,` + `referrerpolicy,rel,required,reversed,rows,rowspan,sandbox,scope,scoped,` + `selected,shape,size,sizes,slot,span,spellcheck,src,srcdoc,srclang,srcset,` + `start,step,style,summary,tabindex,target,title,translate,type,usemap,` + `value,width,wrap`);
/**
 * Generated from https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute
 */ const $66ea9d0aaa418c4d$export$80da416f43933831 = /*#__PURE__*/ $66ea9d0aaa418c4d$export$b41394a5437791c8(`xmlns,accent-height,accumulate,additive,alignment-baseline,alphabetic,amplitude,` + `arabic-form,ascent,attributeName,attributeType,azimuth,baseFrequency,` + `baseline-shift,baseProfile,bbox,begin,bias,by,calcMode,cap-height,class,` + `clip,clipPathUnits,clip-path,clip-rule,color,color-interpolation,` + `color-interpolation-filters,color-profile,color-rendering,` + `contentScriptType,contentStyleType,crossorigin,cursor,cx,cy,d,decelerate,` + `descent,diffuseConstant,direction,display,divisor,dominant-baseline,dur,dx,` + `dy,edgeMode,elevation,enable-background,end,exponent,fill,fill-opacity,` + `fill-rule,filter,filterRes,filterUnits,flood-color,flood-opacity,` + `font-family,font-size,font-size-adjust,font-stretch,font-style,` + `font-variant,font-weight,format,from,fr,fx,fy,g1,g2,glyph-name,` + `glyph-orientation-horizontal,glyph-orientation-vertical,glyphRef,` + `gradientTransform,gradientUnits,hanging,height,href,hreflang,horiz-adv-x,` + `horiz-origin-x,id,ideographic,image-rendering,in,in2,intercept,k,k1,k2,k3,` + `k4,kernelMatrix,kernelUnitLength,kerning,keyPoints,keySplines,keyTimes,` + `lang,lengthAdjust,letter-spacing,lighting-color,limitingConeAngle,local,` + `marker-end,marker-mid,marker-start,markerHeight,markerUnits,markerWidth,` + `mask,maskContentUnits,maskUnits,mathematical,max,media,method,min,mode,` + `name,numOctaves,offset,opacity,operator,order,orient,orientation,origin,` + `overflow,overline-position,overline-thickness,panose-1,paint-order,path,` + `pathLength,patternContentUnits,patternTransform,patternUnits,ping,` + `pointer-events,points,pointsAtX,pointsAtY,pointsAtZ,preserveAlpha,` + `preserveAspectRatio,primitiveUnits,r,radius,referrerPolicy,refX,refY,rel,` + `rendering-intent,repeatCount,repeatDur,requiredExtensions,requiredFeatures,` + `restart,result,rotate,rx,ry,scale,seed,shape-rendering,slope,spacing,` + `specularConstant,specularExponent,speed,spreadMethod,startOffset,` + `stdDeviation,stemh,stemv,stitchTiles,stop-color,stop-opacity,` + `strikethrough-position,strikethrough-thickness,string,stroke,` + `stroke-dasharray,stroke-dashoffset,stroke-linecap,stroke-linejoin,` + `stroke-miterlimit,stroke-opacity,stroke-width,style,surfaceScale,` + `systemLanguage,tabindex,tableValues,target,targetX,targetY,text-anchor,` + `text-decoration,text-rendering,textLength,to,transform,transform-origin,` + `type,u1,u2,underline-position,underline-thickness,unicode,unicode-bidi,` + `unicode-range,units-per-em,v-alphabetic,v-hanging,v-ideographic,` + `v-mathematical,values,vector-effect,version,vert-adv-y,vert-origin-x,` + `vert-origin-y,viewBox,viewTarget,visibility,width,widths,word-spacing,` + `writing-mode,x,x-height,x1,x2,xChannelSelector,xlink:actuate,xlink:arcrole,` + `xlink:href,xlink:role,xlink:show,xlink:title,xlink:type,xml:base,xml:lang,` + `xml:space,y,y1,y2,yChannelSelector,z,zoomAndPan`);
function $66ea9d0aaa418c4d$export$8756898546458274(value) {
    if ($66ea9d0aaa418c4d$export$43bee75e5e14138e(value)) {
        const res = {};
        for(let i = 0; i < value.length; i++){
            const item = value[i];
            const normalized = $66ea9d0aaa418c4d$export$844ec244b1367d54(item) ? $66ea9d0aaa418c4d$export$76a205ce979d066a(item) : $66ea9d0aaa418c4d$export$8756898546458274(item);
            if (normalized) for(const key in normalized)res[key] = normalized[key];
        }
        return res;
    } else if ($66ea9d0aaa418c4d$export$844ec244b1367d54(value)) return value;
    else if ($66ea9d0aaa418c4d$export$a6cdc56e425d0d0a(value)) return value;
}
const $66ea9d0aaa418c4d$var$listDelimiterRE = /;(?![^(]*\))/g;
const $66ea9d0aaa418c4d$var$propertyDelimiterRE = /:(.+)/;
function $66ea9d0aaa418c4d$export$76a205ce979d066a(cssText) {
    const ret = {};
    cssText.split($66ea9d0aaa418c4d$var$listDelimiterRE).forEach((item)=>{
        if (item) {
            const tmp = item.split($66ea9d0aaa418c4d$var$propertyDelimiterRE);
            tmp.length > 1 && (ret[tmp[0].trim()] = tmp[1].trim());
        }
    });
    return ret;
}
function $66ea9d0aaa418c4d$export$9466a5a0ee6f1479(styles) {
    let ret = '';
    if (!styles || $66ea9d0aaa418c4d$export$844ec244b1367d54(styles)) return ret;
    for(const key in styles){
        const value = styles[key];
        const normalizedKey = key.startsWith(`--`) ? key : $66ea9d0aaa418c4d$export$6e6a0a3676c4b8bb(key);
        if ($66ea9d0aaa418c4d$export$844ec244b1367d54(value) || typeof value === 'number' && $66ea9d0aaa418c4d$export$84da53524c6b1314(normalizedKey)) // only render valid values
        ret += `${normalizedKey}:${value};`;
    }
    return ret;
}
function $66ea9d0aaa418c4d$export$4f7022d2d68e2c5a(value) {
    let res = '';
    if ($66ea9d0aaa418c4d$export$844ec244b1367d54(value)) res = value;
    else if ($66ea9d0aaa418c4d$export$43bee75e5e14138e(value)) for(let i = 0; i < value.length; i++){
        const normalized = $66ea9d0aaa418c4d$export$4f7022d2d68e2c5a(value[i]);
        if (normalized) res += normalized + ' ';
    }
    else if ($66ea9d0aaa418c4d$export$a6cdc56e425d0d0a(value)) {
        for(const name in value)if (value[name]) res += name + ' ';
    }
    return res.trim();
}
function $66ea9d0aaa418c4d$export$601abcd8103db5e4(props) {
    if (!props) return null;
    let { class: klass, style: style } = props;
    if (klass && !$66ea9d0aaa418c4d$export$844ec244b1367d54(klass)) props.class = $66ea9d0aaa418c4d$export$4f7022d2d68e2c5a(klass);
    if (style) props.style = $66ea9d0aaa418c4d$export$8756898546458274(style);
    return props;
}
// These tag configs are shared between compiler-dom and runtime-dom, so they
// https://developer.mozilla.org/en-US/docs/Web/HTML/Element
const $66ea9d0aaa418c4d$var$HTML_TAGS = "html,body,base,head,link,meta,style,title,address,article,aside,footer,header,h1,h2,h3,h4,h5,h6,nav,section,div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,ruby,s,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,embed,object,param,source,canvas,script,noscript,del,ins,caption,col,colgroup,table,thead,tbody,td,th,tr,button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,output,progress,select,textarea,details,dialog,menu,summary,template,blockquote,iframe,tfoot";
// https://developer.mozilla.org/en-US/docs/Web/SVG/Element
const $66ea9d0aaa418c4d$var$SVG_TAGS = "svg,animate,animateMotion,animateTransform,circle,clipPath,color-profile,defs,desc,discard,ellipse,feBlend,feColorMatrix,feComponentTransfer,feComposite,feConvolveMatrix,feDiffuseLighting,feDisplacementMap,feDistanceLight,feDropShadow,feFlood,feFuncA,feFuncB,feFuncG,feFuncR,feGaussianBlur,feImage,feMerge,feMergeNode,feMorphology,feOffset,fePointLight,feSpecularLighting,feSpotLight,feTile,feTurbulence,filter,foreignObject,g,hatch,hatchpath,image,line,linearGradient,marker,mask,mesh,meshgradient,meshpatch,meshrow,metadata,mpath,path,pattern,polygon,polyline,radialGradient,rect,set,solidcolor,stop,switch,symbol,text,textPath,title,tspan,unknown,use,view";
const $66ea9d0aaa418c4d$var$VOID_TAGS = 'area,base,br,col,embed,hr,img,input,link,meta,param,source,track,wbr';
/**
 * Compiler only.
 * Do NOT use in runtime code paths unless behind `(process.env.NODE_ENV !== 'production')` flag.
 */ const $66ea9d0aaa418c4d$export$1ccf854a0984f890 = /*#__PURE__*/ $66ea9d0aaa418c4d$export$b41394a5437791c8($66ea9d0aaa418c4d$var$HTML_TAGS);
/**
 * Compiler only.
 * Do NOT use in runtime code paths unless behind `(process.env.NODE_ENV !== 'production')` flag.
 */ const $66ea9d0aaa418c4d$export$6328ce7565ea1049 = /*#__PURE__*/ $66ea9d0aaa418c4d$export$b41394a5437791c8($66ea9d0aaa418c4d$var$SVG_TAGS);
/**
 * Compiler only.
 * Do NOT use in runtime code paths unless behind `(process.env.NODE_ENV !== 'production')` flag.
 */ const $66ea9d0aaa418c4d$export$e5f2d3d97d9367a4 = /*#__PURE__*/ $66ea9d0aaa418c4d$export$b41394a5437791c8($66ea9d0aaa418c4d$var$VOID_TAGS);
const $66ea9d0aaa418c4d$var$escapeRE = /["'&<>]/;
function $66ea9d0aaa418c4d$export$4cf11838cdc2a8a8(string) {
    const str = '' + string;
    const match = $66ea9d0aaa418c4d$var$escapeRE.exec(str);
    if (!match) return str;
    let html = '';
    let escaped;
    let index;
    let lastIndex = 0;
    for(index = match.index; index < str.length; index++){
        switch(str.charCodeAt(index)){
            case 34:
                escaped = '&quot;';
                break;
            case 38:
                escaped = '&amp;';
                break;
            case 39:
                escaped = '&#39;';
                break;
            case 60:
                escaped = '&lt;';
                break;
            case 62:
                escaped = '&gt;';
                break;
            default:
                continue;
        }
        if (lastIndex !== index) html += str.slice(lastIndex, index);
        lastIndex = index + 1;
        html += escaped;
    }
    return lastIndex !== index ? html + str.slice(lastIndex, index) : html;
}
// https://www.w3.org/TR/html52/syntax.html#comments
const $66ea9d0aaa418c4d$var$commentStripRE = /^-?>|<!--|-->|--!>|<!-$/g;
function $66ea9d0aaa418c4d$export$7b105034a53bde5f(src) {
    return src.replace($66ea9d0aaa418c4d$var$commentStripRE, '');
}
function $66ea9d0aaa418c4d$var$looseCompareArrays(a, b) {
    if (a.length !== b.length) return false;
    let equal = true;
    for(let i = 0; equal && i < a.length; i++)equal = $66ea9d0aaa418c4d$export$ae8015769846262c(a[i], b[i]);
    return equal;
}
function $66ea9d0aaa418c4d$export$ae8015769846262c(a, b) {
    if (a === b) return true;
    let aValidType = $66ea9d0aaa418c4d$export$871608497c498473(a);
    let bValidType = $66ea9d0aaa418c4d$export$871608497c498473(b);
    if (aValidType || bValidType) return aValidType && bValidType ? a.getTime() === b.getTime() : false;
    aValidType = $66ea9d0aaa418c4d$export$a244864fd9645c7f(a);
    bValidType = $66ea9d0aaa418c4d$export$a244864fd9645c7f(b);
    if (aValidType || bValidType) return a === b;
    aValidType = $66ea9d0aaa418c4d$export$43bee75e5e14138e(a);
    bValidType = $66ea9d0aaa418c4d$export$43bee75e5e14138e(b);
    if (aValidType || bValidType) return aValidType && bValidType ? $66ea9d0aaa418c4d$var$looseCompareArrays(a, b) : false;
    aValidType = $66ea9d0aaa418c4d$export$a6cdc56e425d0d0a(a);
    bValidType = $66ea9d0aaa418c4d$export$a6cdc56e425d0d0a(b);
    if (aValidType || bValidType) {
        /* istanbul ignore if: this if will probably never be called */ if (!aValidType || !bValidType) return false;
        const aKeysCount = Object.keys(a).length;
        const bKeysCount = Object.keys(b).length;
        if (aKeysCount !== bKeysCount) return false;
        for(const key in a){
            const aHasKey = a.hasOwnProperty(key);
            const bHasKey = b.hasOwnProperty(key);
            if (aHasKey && !bHasKey || !aHasKey && bHasKey || !$66ea9d0aaa418c4d$export$ae8015769846262c(a[key], b[key])) return false;
        }
    }
    return String(a) === String(b);
}
function $66ea9d0aaa418c4d$export$42912a80cedb8bd4(arr, val) {
    return arr.findIndex((item)=>$66ea9d0aaa418c4d$export$ae8015769846262c(item, val));
}
/**
 * For converting {{ interpolation }} values to displayed strings.
 * @private
 */ const $66ea9d0aaa418c4d$export$b5b1545233b45293 = (val)=>{
    return $66ea9d0aaa418c4d$export$844ec244b1367d54(val) ? val : val == null ? '' : $66ea9d0aaa418c4d$export$43bee75e5e14138e(val) || $66ea9d0aaa418c4d$export$a6cdc56e425d0d0a(val) && (val.toString === $66ea9d0aaa418c4d$export$830c053460e5ddf6 || !$66ea9d0aaa418c4d$export$f6e2535fb5126e54(val.toString)) ? JSON.stringify(val, $66ea9d0aaa418c4d$var$replacer, 2) : String(val);
};
const $66ea9d0aaa418c4d$var$replacer = (_key, val)=>{
    // can't use isRef here since @vue/shared has no deps
    if (val && val.__v_isRef) return $66ea9d0aaa418c4d$var$replacer(_key, val.value);
    else if ($66ea9d0aaa418c4d$export$5c90113a285f2241(val)) return {
        [`Map(${val.size})`]: [
            ...val.entries()
        ].reduce((entries, [key, val])=>{
            entries[`${key} =>`] = val;
            return entries;
        }, {})
    };
    else if ($66ea9d0aaa418c4d$export$6750766a7c7ec627(val)) return {
        [`Set(${val.size})`]: [
            ...val.values()
        ]
    };
    else if ($66ea9d0aaa418c4d$export$a6cdc56e425d0d0a(val) && !$66ea9d0aaa418c4d$export$43bee75e5e14138e(val) && !$66ea9d0aaa418c4d$export$53b83ca8eaab0383(val)) return String(val);
    return val;
};
const $66ea9d0aaa418c4d$export$cf583d23ab39677c = {};
const $66ea9d0aaa418c4d$export$6bd8558f433f1cc1 = [];
const $66ea9d0aaa418c4d$export$5702a91a6f42969f = ()=>{};
/**
 * Always return false.
 */ const $66ea9d0aaa418c4d$export$c01351c0af048e39 = ()=>false;
const $66ea9d0aaa418c4d$var$onRE = /^on[^a-z]/;
const $66ea9d0aaa418c4d$export$1a2d97de39ecbb75 = (key)=>$66ea9d0aaa418c4d$var$onRE.test(key);
const $66ea9d0aaa418c4d$export$793aa5469768d691 = (key)=>key.startsWith('onUpdate:');
const $66ea9d0aaa418c4d$export$8b58be045bf06082 = Object.assign;
const $66ea9d0aaa418c4d$export$cd7f480d6b8286c3 = (arr, el)=>{
    const i = arr.indexOf(el);
    if (i > -1) arr.splice(i, 1);
};
const $66ea9d0aaa418c4d$var$hasOwnProperty = Object.prototype.hasOwnProperty;
const $66ea9d0aaa418c4d$export$b5a638e9b3fff9f3 = (val, key)=>$66ea9d0aaa418c4d$var$hasOwnProperty.call(val, key);
const $66ea9d0aaa418c4d$export$43bee75e5e14138e = Array.isArray;
const $66ea9d0aaa418c4d$export$5c90113a285f2241 = (val)=>$66ea9d0aaa418c4d$export$1dccc787cc36538b(val) === '[object Map]';
const $66ea9d0aaa418c4d$export$6750766a7c7ec627 = (val)=>$66ea9d0aaa418c4d$export$1dccc787cc36538b(val) === '[object Set]';
const $66ea9d0aaa418c4d$export$871608497c498473 = (val)=>$66ea9d0aaa418c4d$export$1dccc787cc36538b(val) === '[object Date]';
const $66ea9d0aaa418c4d$export$f6e2535fb5126e54 = (val)=>typeof val === 'function';
const $66ea9d0aaa418c4d$export$844ec244b1367d54 = (val)=>typeof val === 'string';
const $66ea9d0aaa418c4d$export$a244864fd9645c7f = (val)=>typeof val === 'symbol';
const $66ea9d0aaa418c4d$export$a6cdc56e425d0d0a = (val)=>val !== null && typeof val === 'object';
const $66ea9d0aaa418c4d$export$4369c812aac99591 = (val)=>{
    return $66ea9d0aaa418c4d$export$a6cdc56e425d0d0a(val) && $66ea9d0aaa418c4d$export$f6e2535fb5126e54(val.then) && $66ea9d0aaa418c4d$export$f6e2535fb5126e54(val.catch);
};
const $66ea9d0aaa418c4d$export$830c053460e5ddf6 = Object.prototype.toString;
const $66ea9d0aaa418c4d$export$1dccc787cc36538b = (value)=>$66ea9d0aaa418c4d$export$830c053460e5ddf6.call(value);
const $66ea9d0aaa418c4d$export$5ad0a3c360b8fbb5 = (value)=>{
    // extract "RawType" from strings like "[object RawType]"
    return $66ea9d0aaa418c4d$export$1dccc787cc36538b(value).slice(8, -1);
};
const $66ea9d0aaa418c4d$export$53b83ca8eaab0383 = (val)=>$66ea9d0aaa418c4d$export$1dccc787cc36538b(val) === '[object Object]';
const $66ea9d0aaa418c4d$export$e2a2b93446ec9fe = (key)=>$66ea9d0aaa418c4d$export$844ec244b1367d54(key) && key !== 'NaN' && key[0] !== '-' && '' + parseInt(key, 10) === key;
const $66ea9d0aaa418c4d$export$bf7d3c0236f0aa85 = /*#__PURE__*/ $66ea9d0aaa418c4d$export$b41394a5437791c8(// the leading comma is intentional so empty string "" is also included
",key,ref,ref_for,ref_key,onVnodeBeforeMount,onVnodeMounted,onVnodeBeforeUpdate,onVnodeUpdated,onVnodeBeforeUnmount,onVnodeUnmounted");
const $66ea9d0aaa418c4d$export$a9c1fdb3030c2a6b = /*#__PURE__*/ $66ea9d0aaa418c4d$export$b41394a5437791c8('bind,cloak,else-if,else,for,html,if,model,on,once,pre,show,slot,text,memo');
const $66ea9d0aaa418c4d$var$cacheStringFunction = (fn)=>{
    const cache = Object.create(null);
    return (str)=>{
        const hit = cache[str];
        return hit || (cache[str] = fn(str));
    };
};
const $66ea9d0aaa418c4d$var$camelizeRE = /-(\w)/g;
/**
 * @private
 */ const $66ea9d0aaa418c4d$export$161d051f5dd25de7 = $66ea9d0aaa418c4d$var$cacheStringFunction((str)=>{
    return str.replace($66ea9d0aaa418c4d$var$camelizeRE, (_, c)=>c ? c.toUpperCase() : '');
});
const $66ea9d0aaa418c4d$var$hyphenateRE = /\B([A-Z])/g;
/**
 * @private
 */ const $66ea9d0aaa418c4d$export$6e6a0a3676c4b8bb = $66ea9d0aaa418c4d$var$cacheStringFunction((str)=>str.replace($66ea9d0aaa418c4d$var$hyphenateRE, '-$1').toLowerCase());
/**
 * @private
 */ const $66ea9d0aaa418c4d$export$9a00dee1beb8f576 = $66ea9d0aaa418c4d$var$cacheStringFunction((str)=>str.charAt(0).toUpperCase() + str.slice(1));
/**
 * @private
 */ const $66ea9d0aaa418c4d$export$8c022799eeaaefcd = $66ea9d0aaa418c4d$var$cacheStringFunction((str)=>str ? `on${$66ea9d0aaa418c4d$export$9a00dee1beb8f576(str)}` : ``);
// compare whether a value has changed, accounting for NaN.
const $66ea9d0aaa418c4d$export$f619eb8b89076d23 = (value, oldValue)=>!Object.is(value, oldValue);
const $66ea9d0aaa418c4d$export$39951422d618a9d3 = (fns, arg)=>{
    for(let i = 0; i < fns.length; i++)fns[i](arg);
};
const $66ea9d0aaa418c4d$export$8afb76124cf08683 = (obj, key, value)=>{
    Object.defineProperty(obj, key, {
        configurable: true,
        enumerable: false,
        value: value
    });
};
const $66ea9d0aaa418c4d$export$a0a81dc3380ce7d3 = (val)=>{
    const n = parseFloat(val);
    return isNaN(n) ? val : n;
};
let $66ea9d0aaa418c4d$var$_globalThis;
const $66ea9d0aaa418c4d$export$ff5f2eeb11fc7e14 = ()=>{
    return $66ea9d0aaa418c4d$var$_globalThis || ($66ea9d0aaa418c4d$var$_globalThis = typeof globalThis !== 'undefined' ? globalThis : typeof self !== 'undefined' ? self : typeof window !== 'undefined' ? window : typeof $parcel$global !== 'undefined' ? $parcel$global : {});
};
const $66ea9d0aaa418c4d$var$identRE = /^[_$a-zA-Z\xA0-\uFFFF][_$a-zA-Z0-9\xA0-\uFFFF]*$/;
function $66ea9d0aaa418c4d$export$53d5e12f9a1d3cde(name) {
    return $66ea9d0aaa418c4d$var$identRE.test(name) ? `__props.${name}` : `__props[${JSON.stringify(name)}]`;
}

});



parcelRegister("eeJ70", function(module, exports) {

$parcel$export(module.exports, "defineCustomElement", () => $a5d55dc64ccb07cf$export$a00e2346eabbdbef);
$parcel$export(module.exports, "VueElement", () => $a5d55dc64ccb07cf$export$b337c1a55163dbe3);
$parcel$export(module.exports, "defineSSRCustomElement", () => $a5d55dc64ccb07cf$export$6debb2e68f212638);
$parcel$export(module.exports, "hydrate", () => $a5d55dc64ccb07cf$export$fa8d919ba61d84db);
$parcel$export(module.exports, "render", () => $a5d55dc64ccb07cf$export$b3890eb0ae9dca99);
$parcel$export(module.exports, "useCssModule", () => $a5d55dc64ccb07cf$export$9300d5b90d56e3d1);
$parcel$export(module.exports, "useCssVars", () => $a5d55dc64ccb07cf$export$ef28b76f07940108);
$parcel$export(module.exports, "Transition", () => $a5d55dc64ccb07cf$export$be58926105124dd4);
$parcel$export(module.exports, "TransitionGroup", () => $a5d55dc64ccb07cf$export$19ffa8f511f7bc2e);
$parcel$export(module.exports, "vModelText", () => $a5d55dc64ccb07cf$export$f1f88689f5728478);
$parcel$export(module.exports, "vModelCheckbox", () => $a5d55dc64ccb07cf$export$8847c2e532b35714);
$parcel$export(module.exports, "vModelRadio", () => $a5d55dc64ccb07cf$export$b4356c59b38b7aa9);
$parcel$export(module.exports, "vModelSelect", () => $a5d55dc64ccb07cf$export$87d227567b51ca39);
$parcel$export(module.exports, "vModelDynamic", () => $a5d55dc64ccb07cf$export$5ad5c0e01ff62c5);
$parcel$export(module.exports, "withModifiers", () => $a5d55dc64ccb07cf$export$26bd3b8e29e6f273);
$parcel$export(module.exports, "withKeys", () => $a5d55dc64ccb07cf$export$f691a8759658f782);
$parcel$export(module.exports, "vShow", () => $a5d55dc64ccb07cf$export$5cb4fcdc6937d7e1);
$parcel$export(module.exports, "createApp", () => $a5d55dc64ccb07cf$export$4e373c34abfa8c68);
$parcel$export(module.exports, "createSSRApp", () => $a5d55dc64ccb07cf$export$35800275c0037383);
$parcel$export(module.exports, "initDirectivesForSSR", () => $a5d55dc64ccb07cf$export$800b28255aa678d9);
parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
var $TusQn = parcelRequire("TusQn");
var $01W3b = parcelRequire("01W3b");

var $8POXm = parcelRequire("8POXm");
const $a5d55dc64ccb07cf$var$svgNS = 'http://www.w3.org/2000/svg';
const $a5d55dc64ccb07cf$var$doc = typeof document !== 'undefined' ? document : null;
const $a5d55dc64ccb07cf$var$templateContainer = $a5d55dc64ccb07cf$var$doc && /*#__PURE__*/ $a5d55dc64ccb07cf$var$doc.createElement('template');
const $a5d55dc64ccb07cf$var$nodeOps = {
    insert: (child, parent, anchor)=>{
        parent.insertBefore(child, anchor || null);
    },
    remove: (child)=>{
        const parent = child.parentNode;
        if (parent) parent.removeChild(child);
    },
    createElement: (tag, isSVG, is, props)=>{
        const el = isSVG ? $a5d55dc64ccb07cf$var$doc.createElementNS($a5d55dc64ccb07cf$var$svgNS, tag) : $a5d55dc64ccb07cf$var$doc.createElement(tag, is ? {
            is: is
        } : undefined);
        if (tag === 'select' && props && props.multiple != null) el.setAttribute('multiple', props.multiple);
        return el;
    },
    createText: (text)=>$a5d55dc64ccb07cf$var$doc.createTextNode(text),
    createComment: (text)=>$a5d55dc64ccb07cf$var$doc.createComment(text),
    setText: (node, text)=>{
        node.nodeValue = text;
    },
    setElementText: (el, text)=>{
        el.textContent = text;
    },
    parentNode: (node)=>node.parentNode,
    nextSibling: (node)=>node.nextSibling,
    querySelector: (selector)=>$a5d55dc64ccb07cf$var$doc.querySelector(selector),
    setScopeId (el, id) {
        el.setAttribute(id, '');
    },
    cloneNode (el) {
        const cloned = el.cloneNode(true);
        // #3072
        // - in `patchDOMProp`, we store the actual value in the `el._value` property.
        // - normally, elements using `:value` bindings will not be hoisted, but if
        //   the bound value is a constant, e.g. `:value="true"` - they do get
        //   hoisted.
        // - in production, hoisted nodes are cloned when subsequent inserts, but
        //   cloneNode() does not copy the custom property we attached.
        // - This may need to account for other custom DOM properties we attach to
        //   elements in addition to `_value` in the future.
        if (`_value` in el) cloned._value = el._value;
        return cloned;
    },
    // __UNSAFE__
    // Reason: innerHTML.
    // Static content here can only come from compiled templates.
    // As long as the user only uses trusted templates, this is safe.
    insertStaticContent (content, parent, anchor, isSVG, start, end) {
        // <parent> before | first ... last | anchor </parent>
        const before = anchor ? anchor.previousSibling : parent.lastChild;
        // #5308 can only take cached path if:
        // - has a single root node
        // - nextSibling info is still available
        if (start && (start === end || start.nextSibling)) // cached
        while(true){
            parent.insertBefore(start.cloneNode(true), anchor);
            if (start === end || !(start = start.nextSibling)) break;
        }
        else {
            // fresh insert
            $a5d55dc64ccb07cf$var$templateContainer.innerHTML = isSVG ? `<svg>${content}</svg>` : content;
            const template = $a5d55dc64ccb07cf$var$templateContainer.content;
            if (isSVG) {
                // remove outer svg wrapper
                const wrapper = template.firstChild;
                while(wrapper.firstChild)template.appendChild(wrapper.firstChild);
                template.removeChild(wrapper);
            }
            parent.insertBefore(template, anchor);
        }
        return [
            // first
            before ? before.nextSibling : parent.firstChild,
            // last
            anchor ? anchor.previousSibling : parent.lastChild
        ];
    }
};
// compiler should normalize class + :class bindings on the same element
// into a single binding ['staticClass', dynamic]
function $a5d55dc64ccb07cf$var$patchClass(el, value, isSVG) {
    // directly setting className should be faster than setAttribute in theory
    // if this is an element during a transition, take the temporary transition
    // classes into account.
    const transitionClasses = el._vtc;
    if (transitionClasses) value = (value ? [
        value,
        ...transitionClasses
    ] : [
        ...transitionClasses
    ]).join(' ');
    if (value == null) el.removeAttribute('class');
    else if (isSVG) el.setAttribute('class', value);
    else el.className = value;
}
function $a5d55dc64ccb07cf$var$patchStyle(el, prev, next) {
    const style = el.style;
    const isCssString = (0, $8POXm.isString)(next);
    if (next && !isCssString) {
        for(const key in next)$a5d55dc64ccb07cf$var$setStyle(style, key, next[key]);
        if (prev && !(0, $8POXm.isString)(prev)) {
            for(const key in prev)if (next[key] == null) $a5d55dc64ccb07cf$var$setStyle(style, key, '');
        }
    } else {
        const currentDisplay = style.display;
        if (isCssString) {
            if (prev !== next) style.cssText = next;
        } else if (prev) el.removeAttribute('style');
        // indicates that the `display` of the element is controlled by `v-show`,
        // so we always keep the current `display` value regardless of the `style`
        // value, thus handing over control to `v-show`.
        if ('_vod' in el) style.display = currentDisplay;
    }
}
const $a5d55dc64ccb07cf$var$importantRE = /\s*!important$/;
function $a5d55dc64ccb07cf$var$setStyle(style, name, val) {
    if ((0, $8POXm.isArray)(val)) val.forEach((v)=>$a5d55dc64ccb07cf$var$setStyle(style, name, v));
    else {
        if (val == null) val = '';
        if (name.startsWith('--')) // custom property definition
        style.setProperty(name, val);
        else {
            const prefixed = $a5d55dc64ccb07cf$var$autoPrefix(style, name);
            if ($a5d55dc64ccb07cf$var$importantRE.test(val)) // !important
            style.setProperty((0, $8POXm.hyphenate)(prefixed), val.replace($a5d55dc64ccb07cf$var$importantRE, ''), 'important');
            else style[prefixed] = val;
        }
    }
}
const $a5d55dc64ccb07cf$var$prefixes = [
    'Webkit',
    'Moz',
    'ms'
];
const $a5d55dc64ccb07cf$var$prefixCache = {};
function $a5d55dc64ccb07cf$var$autoPrefix(style, rawName) {
    const cached = $a5d55dc64ccb07cf$var$prefixCache[rawName];
    if (cached) return cached;
    let name = (0, $8POXm.camelize)(rawName);
    if (name !== 'filter' && name in style) return $a5d55dc64ccb07cf$var$prefixCache[rawName] = name;
    name = (0, $8POXm.capitalize)(name);
    for(let i = 0; i < $a5d55dc64ccb07cf$var$prefixes.length; i++){
        const prefixed = $a5d55dc64ccb07cf$var$prefixes[i] + name;
        if (prefixed in style) return $a5d55dc64ccb07cf$var$prefixCache[rawName] = prefixed;
    }
    return rawName;
}
const $a5d55dc64ccb07cf$var$xlinkNS = 'http://www.w3.org/1999/xlink';
function $a5d55dc64ccb07cf$var$patchAttr(el, key, value, isSVG, instance) {
    if (isSVG && key.startsWith('xlink:')) {
        if (value == null) el.removeAttributeNS($a5d55dc64ccb07cf$var$xlinkNS, key.slice(6, key.length));
        else el.setAttributeNS($a5d55dc64ccb07cf$var$xlinkNS, key, value);
    } else {
        // note we are only checking boolean attributes that don't have a
        // corresponding dom prop of the same name here.
        const isBoolean = (0, $8POXm.isSpecialBooleanAttr)(key);
        if (value == null || isBoolean && !(0, $8POXm.includeBooleanAttr)(value)) el.removeAttribute(key);
        else el.setAttribute(key, isBoolean ? '' : value);
    }
}
// __UNSAFE__
// functions. The user is responsible for using them with only trusted content.
function $a5d55dc64ccb07cf$var$patchDOMProp(el, key, value, // the following args are passed only due to potential innerHTML/textContent
// overriding existing VNodes, in which case the old tree must be properly
// unmounted.
prevChildren, parentComponent, parentSuspense, unmountChildren) {
    if (key === 'innerHTML' || key === 'textContent') {
        if (prevChildren) unmountChildren(prevChildren, parentComponent, parentSuspense);
        el[key] = value == null ? '' : value;
        return;
    }
    if (key === 'value' && el.tagName !== 'PROGRESS' && // custom elements may use _value internally
    !el.tagName.includes('-')) {
        // store value as _value as well since
        // non-string values will be stringified.
        el._value = value;
        const newValue = value == null ? '' : value;
        if (el.value !== newValue || // #4956: always set for OPTION elements because its value falls back to
        // textContent if no value attribute is present. And setting .value for
        // OPTION has no side effect
        el.tagName === 'OPTION') el.value = newValue;
        if (value == null) el.removeAttribute(key);
        return;
    }
    let needRemove = false;
    if (value === '' || value == null) {
        const type = typeof el[key];
        if (type === 'boolean') // e.g. <select multiple> compiles to { multiple: '' }
        value = (0, $8POXm.includeBooleanAttr)(value);
        else if (value == null && type === 'string') {
            // e.g. <div :id="null">
            value = '';
            needRemove = true;
        } else if (type === 'number') {
            // e.g. <img :width="null">
            // the value of some IDL attr must be greater than 0, e.g. input.size = 0 -> error
            value = 0;
            needRemove = true;
        }
    }
    // some properties perform value validation and throw,
    // some properties has getter, no setter, will error in 'use strict'
    // eg. <select :type="null"></select> <select :willValidate="null"></select>
    try {
        el[key] = value;
    } catch (e) {}
    needRemove && el.removeAttribute(key);
}
// Async edge case fix requires storing an event listener's attach timestamp.
const [$a5d55dc64ccb07cf$var$_getNow, $a5d55dc64ccb07cf$var$skipTimestampCheck] = /*#__PURE__*/ (()=>{
    let _getNow = Date.now;
    let skipTimestampCheck = false;
    if (typeof window !== 'undefined') {
        // Determine what event timestamp the browser is using. Annoyingly, the
        // timestamp can either be hi-res (relative to page load) or low-res
        // (relative to UNIX epoch), so in order to compare time we have to use the
        // same timestamp type when saving the flush timestamp.
        if (Date.now() > document.createEvent('Event').timeStamp) // if the low-res timestamp which is bigger than the event timestamp
        // (which is evaluated AFTER) it means the event is using a hi-res timestamp,
        // and we need to use the hi-res version for event listeners as well.
        _getNow = performance.now.bind(performance);
        // #3485: Firefox <= 53 has incorrect Event.timeStamp implementation
        // and does not fire microtasks in between event propagation, so safe to exclude.
        const ffMatch = navigator.userAgent.match(/firefox\/(\d+)/i);
        skipTimestampCheck = !!(ffMatch && Number(ffMatch[1]) <= 53);
    }
    return [
        _getNow,
        skipTimestampCheck
    ];
})();
// To avoid the overhead of repeatedly calling performance.now(), we cache
// and use the same timestamp for all event listeners attached in the same tick.
let $a5d55dc64ccb07cf$var$cachedNow = 0;
const $a5d55dc64ccb07cf$var$p = /*#__PURE__*/ Promise.resolve();
const $a5d55dc64ccb07cf$var$reset = ()=>{
    $a5d55dc64ccb07cf$var$cachedNow = 0;
};
const $a5d55dc64ccb07cf$var$getNow = ()=>$a5d55dc64ccb07cf$var$cachedNow || ($a5d55dc64ccb07cf$var$p.then($a5d55dc64ccb07cf$var$reset), $a5d55dc64ccb07cf$var$cachedNow = $a5d55dc64ccb07cf$var$_getNow());
function $a5d55dc64ccb07cf$var$addEventListener(el, event, handler, options) {
    el.addEventListener(event, handler, options);
}
function $a5d55dc64ccb07cf$var$removeEventListener(el, event, handler, options) {
    el.removeEventListener(event, handler, options);
}
function $a5d55dc64ccb07cf$var$patchEvent(el, rawName, prevValue, nextValue, instance = null) {
    // vei = vue event invokers
    const invokers = el._vei || (el._vei = {});
    const existingInvoker = invokers[rawName];
    if (nextValue && existingInvoker) // patch
    existingInvoker.value = nextValue;
    else {
        const [name, options] = $a5d55dc64ccb07cf$var$parseName(rawName);
        if (nextValue) {
            // add
            const invoker = invokers[rawName] = $a5d55dc64ccb07cf$var$createInvoker(nextValue, instance);
            $a5d55dc64ccb07cf$var$addEventListener(el, name, invoker, options);
        } else if (existingInvoker) {
            // remove
            $a5d55dc64ccb07cf$var$removeEventListener(el, name, existingInvoker, options);
            invokers[rawName] = undefined;
        }
    }
}
const $a5d55dc64ccb07cf$var$optionsModifierRE = /(?:Once|Passive|Capture)$/;
function $a5d55dc64ccb07cf$var$parseName(name) {
    let options;
    if ($a5d55dc64ccb07cf$var$optionsModifierRE.test(name)) {
        options = {};
        let m;
        while(m = name.match($a5d55dc64ccb07cf$var$optionsModifierRE)){
            name = name.slice(0, name.length - m[0].length);
            options[m[0].toLowerCase()] = true;
        }
    }
    const event = name[2] === ':' ? name.slice(3) : (0, $8POXm.hyphenate)(name.slice(2));
    return [
        event,
        options
    ];
}
function $a5d55dc64ccb07cf$var$createInvoker(initialValue, instance) {
    const invoker = (e)=>{
        // async edge case #6566: inner click event triggers patch, event handler
        // attached to outer element during patch, and triggered again. This
        // happens because browsers fire microtask ticks between event propagation.
        // the solution is simple: we save the timestamp when a handler is attached,
        // and the handler would only fire if the event passed to it was fired
        // AFTER it was attached.
        const timeStamp = e.timeStamp || $a5d55dc64ccb07cf$var$_getNow();
        if ($a5d55dc64ccb07cf$var$skipTimestampCheck || timeStamp >= invoker.attached - 1) (0, $TusQn.callWithAsyncErrorHandling)($a5d55dc64ccb07cf$var$patchStopImmediatePropagation(e, invoker.value), instance, 5 /* ErrorCodes.NATIVE_EVENT_HANDLER */ , [
            e
        ]);
    };
    invoker.value = initialValue;
    invoker.attached = $a5d55dc64ccb07cf$var$getNow();
    return invoker;
}
function $a5d55dc64ccb07cf$var$patchStopImmediatePropagation(e, value) {
    if ((0, $8POXm.isArray)(value)) {
        const originalStop = e.stopImmediatePropagation;
        e.stopImmediatePropagation = ()=>{
            originalStop.call(e);
            e._stopped = true;
        };
        return value.map((fn)=>(e)=>!e._stopped && fn && fn(e));
    } else return value;
}
const $a5d55dc64ccb07cf$var$nativeOnRE = /^on[a-z]/;
const $a5d55dc64ccb07cf$var$patchProp = (el, key, prevValue, nextValue, isSVG = false, prevChildren, parentComponent, parentSuspense, unmountChildren)=>{
    if (key === 'class') $a5d55dc64ccb07cf$var$patchClass(el, nextValue, isSVG);
    else if (key === 'style') $a5d55dc64ccb07cf$var$patchStyle(el, prevValue, nextValue);
    else if ((0, $8POXm.isOn)(key)) // ignore v-model listeners
    {
        if (!(0, $8POXm.isModelListener)(key)) $a5d55dc64ccb07cf$var$patchEvent(el, key, prevValue, nextValue, parentComponent);
    } else if (key[0] === '.' ? (key = key.slice(1), true) : key[0] === '^' ? (key = key.slice(1), false) : $a5d55dc64ccb07cf$var$shouldSetAsProp(el, key, nextValue, isSVG)) $a5d55dc64ccb07cf$var$patchDOMProp(el, key, nextValue, prevChildren, parentComponent, parentSuspense, unmountChildren);
    else {
        // special case for <input v-model type="checkbox"> with
        // :true-value & :false-value
        // store value as dom properties since non-string values will be
        // stringified.
        if (key === 'true-value') el._trueValue = nextValue;
        else if (key === 'false-value') el._falseValue = nextValue;
        $a5d55dc64ccb07cf$var$patchAttr(el, key, nextValue, isSVG);
    }
};
function $a5d55dc64ccb07cf$var$shouldSetAsProp(el, key, value, isSVG) {
    if (isSVG) {
        // most keys must be set as attribute on svg elements to work
        // ...except innerHTML & textContent
        if (key === 'innerHTML' || key === 'textContent') return true;
        // or native onclick with function values
        if (key in el && $a5d55dc64ccb07cf$var$nativeOnRE.test(key) && (0, $8POXm.isFunction)(value)) return true;
        return false;
    }
    // these are enumerated attrs, however their corresponding DOM properties
    // are actually booleans - this leads to setting it with a string "false"
    // value leading it to be coerced to `true`, so we need to always treat
    // them as attributes.
    // Note that `contentEditable` doesn't have this problem: its DOM
    // property is also enumerated string values.
    if (key === 'spellcheck' || key === 'draggable' || key === 'translate') return false;
    // #1787, #2840 form property on form elements is readonly and must be set as
    // attribute.
    if (key === 'form') return false;
    // #1526 <input list> must be set as attribute
    if (key === 'list' && el.tagName === 'INPUT') return false;
    // #2766 <textarea type> must be set as attribute
    if (key === 'type' && el.tagName === 'TEXTAREA') return false;
    // native onclick with string value, must be set as attribute
    if ($a5d55dc64ccb07cf$var$nativeOnRE.test(key) && (0, $8POXm.isString)(value)) return false;
    return key in el;
}
function $a5d55dc64ccb07cf$export$a00e2346eabbdbef(options, hydrate) {
    const Comp = (0, $TusQn.defineComponent)(options);
    class VueCustomElement extends $a5d55dc64ccb07cf$export$b337c1a55163dbe3 {
        constructor(initialProps){
            super(Comp, initialProps, hydrate);
        }
    }
    VueCustomElement.def = Comp;
    return VueCustomElement;
}
const $a5d55dc64ccb07cf$export$6debb2e68f212638 = (options)=>{
    // @ts-ignore
    return $a5d55dc64ccb07cf$export$a00e2346eabbdbef(options, $a5d55dc64ccb07cf$export$fa8d919ba61d84db);
};
const $a5d55dc64ccb07cf$var$BaseClass = typeof HTMLElement !== 'undefined' ? HTMLElement : class {
};
class $a5d55dc64ccb07cf$export$b337c1a55163dbe3 extends $a5d55dc64ccb07cf$var$BaseClass {
    constructor(_def, _props = {}, hydrate){
        super();
        this._def = _def;
        this._props = _props;
        /**
         * @internal
         */ this._instance = null;
        this._connected = false;
        this._resolved = false;
        this._numberProps = null;
        if (this.shadowRoot && hydrate) hydrate(this._createVNode(), this.shadowRoot);
        else this.attachShadow({
            mode: 'open'
        });
    }
    connectedCallback() {
        this._connected = true;
        if (!this._instance) this._resolveDef();
    }
    disconnectedCallback() {
        this._connected = false;
        (0, $TusQn.nextTick)(()=>{
            if (!this._connected) {
                $a5d55dc64ccb07cf$export$b3890eb0ae9dca99(null, this.shadowRoot);
                this._instance = null;
            }
        });
    }
    /**
     * resolve inner component definition (handle possible async component)
     */ _resolveDef() {
        if (this._resolved) return;
        this._resolved = true;
        // set initial attrs
        for(let i = 0; i < this.attributes.length; i++)this._setAttr(this.attributes[i].name);
        // watch future attr changes
        new MutationObserver((mutations)=>{
            for (const m of mutations)this._setAttr(m.attributeName);
        }).observe(this, {
            attributes: true
        });
        const resolve = (def)=>{
            const { props: props, styles: styles } = def;
            const hasOptions = !(0, $8POXm.isArray)(props);
            const rawKeys = props ? hasOptions ? Object.keys(props) : props : [];
            // cast Number-type props set before resolve
            let numberProps;
            if (hasOptions) for(const key in this._props){
                const opt = props[key];
                if (opt === Number || opt && opt.type === Number) {
                    this._props[key] = (0, $8POXm.toNumber)(this._props[key]);
                    (numberProps || (numberProps = Object.create(null)))[key] = true;
                }
            }
            this._numberProps = numberProps;
            // check if there are props set pre-upgrade or connect
            for (const key of Object.keys(this))if (key[0] !== '_') this._setProp(key, this[key], true, false);
            // defining getter/setters on prototype
            for (const key of rawKeys.map((0, $8POXm.camelize)))Object.defineProperty(this, key, {
                get () {
                    return this._getProp(key);
                },
                set (val) {
                    this._setProp(key, val);
                }
            });
            // apply CSS
            this._applyStyles(styles);
            // initial render
            this._update();
        };
        const asyncDef = this._def.__asyncLoader;
        if (asyncDef) asyncDef().then(resolve);
        else resolve(this._def);
    }
    _setAttr(key) {
        let value = this.getAttribute(key);
        if (this._numberProps && this._numberProps[key]) value = (0, $8POXm.toNumber)(value);
        this._setProp((0, $8POXm.camelize)(key), value, false);
    }
    /**
     * @internal
     */ _getProp(key) {
        return this._props[key];
    }
    /**
     * @internal
     */ _setProp(key, val, shouldReflect = true, shouldUpdate = true) {
        if (val !== this._props[key]) {
            this._props[key] = val;
            if (shouldUpdate && this._instance) this._update();
            // reflect
            if (shouldReflect) {
                if (val === true) this.setAttribute((0, $8POXm.hyphenate)(key), '');
                else if (typeof val === 'string' || typeof val === 'number') this.setAttribute((0, $8POXm.hyphenate)(key), val + '');
                else if (!val) this.removeAttribute((0, $8POXm.hyphenate)(key));
            }
        }
    }
    _update() {
        $a5d55dc64ccb07cf$export$b3890eb0ae9dca99(this._createVNode(), this.shadowRoot);
    }
    _createVNode() {
        const vnode = (0, $TusQn.createVNode)(this._def, (0, $8POXm.extend)({}, this._props));
        if (!this._instance) vnode.ce = (instance)=>{
            this._instance = instance;
            instance.isCE = true;
            var newStyles, s;
            // intercept emit
            instance.emit = (event, ...args)=>{
                this.dispatchEvent(new CustomEvent(event, {
                    detail: args
                }));
            };
            // locate nearest Vue custom element parent for provide/inject
            let parent = this;
            while(parent = parent && (parent.parentNode || parent.host))if (parent instanceof $a5d55dc64ccb07cf$export$b337c1a55163dbe3) {
                instance.parent = parent._instance;
                break;
            }
        };
        return vnode;
    }
    _applyStyles(styles) {
        if (styles) styles.forEach((css)=>{
            const s = document.createElement('style');
            s.textContent = css;
            this.shadowRoot.appendChild(s);
        });
    }
}
function $a5d55dc64ccb07cf$export$9300d5b90d56e3d1(name = '$style') {
    /* istanbul ignore else */ {
        const instance = (0, $TusQn.getCurrentInstance)();
        if (!instance) return 0, $8POXm.EMPTY_OBJ;
        const modules = instance.type.__cssModules;
        if (!modules) return 0, $8POXm.EMPTY_OBJ;
        const mod = modules[name];
        if (!mod) return 0, $8POXm.EMPTY_OBJ;
        return mod;
    }
}
/**
 * Runtime helper for SFC's CSS variable injection feature.
 * @private
 */ function $a5d55dc64ccb07cf$export$ef28b76f07940108(getter) {
    const instance = (0, $TusQn.getCurrentInstance)();
    /* istanbul ignore next */ if (!instance) return;
    const setVars = ()=>$a5d55dc64ccb07cf$var$setVarsOnVNode(instance.subTree, getter(instance.proxy));
    (0, $TusQn.watchPostEffect)(setVars);
    (0, $TusQn.onMounted)(()=>{
        const ob = new MutationObserver(setVars);
        ob.observe(instance.subTree.el.parentNode, {
            childList: true
        });
        (0, $TusQn.onUnmounted)(()=>ob.disconnect());
    });
}
function $a5d55dc64ccb07cf$var$setVarsOnVNode(vnode, vars) {
    if (vnode.shapeFlag & 128 /* ShapeFlags.SUSPENSE */ ) {
        const suspense = vnode.suspense;
        vnode = suspense.activeBranch;
        if (suspense.pendingBranch && !suspense.isHydrating) suspense.effects.push(()=>{
            $a5d55dc64ccb07cf$var$setVarsOnVNode(suspense.activeBranch, vars);
        });
    }
    // drill down HOCs until it's a non-component vnode
    while(vnode.component)vnode = vnode.component.subTree;
    if (vnode.shapeFlag & 1 /* ShapeFlags.ELEMENT */  && vnode.el) $a5d55dc64ccb07cf$var$setVarsOnNode(vnode.el, vars);
    else if (vnode.type === (0, $TusQn.Fragment)) vnode.children.forEach((c)=>$a5d55dc64ccb07cf$var$setVarsOnVNode(c, vars));
    else if (vnode.type === (0, $TusQn.Static)) {
        let { el: el, anchor: anchor } = vnode;
        while(el){
            $a5d55dc64ccb07cf$var$setVarsOnNode(el, vars);
            if (el === anchor) break;
            el = el.nextSibling;
        }
    }
}
function $a5d55dc64ccb07cf$var$setVarsOnNode(el, vars) {
    if (el.nodeType === 1) {
        const style = el.style;
        for(const key in vars)style.setProperty(`--${key}`, vars[key]);
    }
}
const $a5d55dc64ccb07cf$var$TRANSITION = 'transition';
const $a5d55dc64ccb07cf$var$ANIMATION = 'animation';
// DOM Transition is a higher-order-component based on the platform-agnostic
// base Transition component, with DOM-specific logic.
const $a5d55dc64ccb07cf$export$be58926105124dd4 = (props, { slots: slots })=>(0, $TusQn.h)((0, $TusQn.BaseTransition), $a5d55dc64ccb07cf$var$resolveTransitionProps(props), slots);
$a5d55dc64ccb07cf$export$be58926105124dd4.displayName = 'Transition';
const $a5d55dc64ccb07cf$var$DOMTransitionPropsValidators = {
    name: String,
    type: String,
    css: {
        type: Boolean,
        default: true
    },
    duration: [
        String,
        Number,
        Object
    ],
    enterFromClass: String,
    enterActiveClass: String,
    enterToClass: String,
    appearFromClass: String,
    appearActiveClass: String,
    appearToClass: String,
    leaveFromClass: String,
    leaveActiveClass: String,
    leaveToClass: String
};
const $a5d55dc64ccb07cf$var$TransitionPropsValidators = $a5d55dc64ccb07cf$export$be58926105124dd4.props = /*#__PURE__*/ (0, $8POXm.extend)({}, (0, $TusQn.BaseTransition).props, $a5d55dc64ccb07cf$var$DOMTransitionPropsValidators);
/**
 * #3227 Incoming hooks may be merged into arrays when wrapping Transition
 * with custom HOCs.
 */ const $a5d55dc64ccb07cf$var$callHook = (hook, args = [])=>{
    if ((0, $8POXm.isArray)(hook)) hook.forEach((h)=>h(...args));
    else if (hook) hook(...args);
};
/**
 * Check if a hook expects a callback (2nd arg), which means the user
 * intends to explicitly control the end of the transition.
 */ const $a5d55dc64ccb07cf$var$hasExplicitCallback = (hook)=>{
    return hook ? (0, $8POXm.isArray)(hook) ? hook.some((h)=>h.length > 1) : hook.length > 1 : false;
};
function $a5d55dc64ccb07cf$var$resolveTransitionProps(rawProps) {
    const baseProps = {};
    for(const key in rawProps)if (!(key in $a5d55dc64ccb07cf$var$DOMTransitionPropsValidators)) baseProps[key] = rawProps[key];
    if (rawProps.css === false) return baseProps;
    const { name: name = 'v', type: type, duration: duration, enterFromClass: enterFromClass = `${name}-enter-from`, enterActiveClass: enterActiveClass = `${name}-enter-active`, enterToClass: enterToClass = `${name}-enter-to`, appearFromClass: appearFromClass = enterFromClass, appearActiveClass: appearActiveClass = enterActiveClass, appearToClass: appearToClass = enterToClass, leaveFromClass: leaveFromClass = `${name}-leave-from`, leaveActiveClass: leaveActiveClass = `${name}-leave-active`, leaveToClass: leaveToClass = `${name}-leave-to` } = rawProps;
    const durations = $a5d55dc64ccb07cf$var$normalizeDuration(duration);
    const enterDuration = durations && durations[0];
    const leaveDuration = durations && durations[1];
    const { onBeforeEnter: onBeforeEnter, onEnter: onEnter, onEnterCancelled: onEnterCancelled, onLeave: onLeave, onLeaveCancelled: onLeaveCancelled, onBeforeAppear: onBeforeAppear = onBeforeEnter, onAppear: onAppear = onEnter, onAppearCancelled: onAppearCancelled = onEnterCancelled } = baseProps;
    const finishEnter = (el, isAppear, done)=>{
        $a5d55dc64ccb07cf$var$removeTransitionClass(el, isAppear ? appearToClass : enterToClass);
        $a5d55dc64ccb07cf$var$removeTransitionClass(el, isAppear ? appearActiveClass : enterActiveClass);
        done && done();
    };
    const finishLeave = (el, done)=>{
        el._isLeaving = false;
        $a5d55dc64ccb07cf$var$removeTransitionClass(el, leaveFromClass);
        $a5d55dc64ccb07cf$var$removeTransitionClass(el, leaveToClass);
        $a5d55dc64ccb07cf$var$removeTransitionClass(el, leaveActiveClass);
        done && done();
    };
    const makeEnterHook = (isAppear)=>{
        return (el, done)=>{
            const hook = isAppear ? onAppear : onEnter;
            const resolve = ()=>finishEnter(el, isAppear, done);
            $a5d55dc64ccb07cf$var$callHook(hook, [
                el,
                resolve
            ]);
            $a5d55dc64ccb07cf$var$nextFrame(()=>{
                $a5d55dc64ccb07cf$var$removeTransitionClass(el, isAppear ? appearFromClass : enterFromClass);
                $a5d55dc64ccb07cf$var$addTransitionClass(el, isAppear ? appearToClass : enterToClass);
                if (!$a5d55dc64ccb07cf$var$hasExplicitCallback(hook)) $a5d55dc64ccb07cf$var$whenTransitionEnds(el, type, enterDuration, resolve);
            });
        };
    };
    return (0, $8POXm.extend)(baseProps, {
        onBeforeEnter (el) {
            $a5d55dc64ccb07cf$var$callHook(onBeforeEnter, [
                el
            ]);
            $a5d55dc64ccb07cf$var$addTransitionClass(el, enterFromClass);
            $a5d55dc64ccb07cf$var$addTransitionClass(el, enterActiveClass);
        },
        onBeforeAppear (el) {
            $a5d55dc64ccb07cf$var$callHook(onBeforeAppear, [
                el
            ]);
            $a5d55dc64ccb07cf$var$addTransitionClass(el, appearFromClass);
            $a5d55dc64ccb07cf$var$addTransitionClass(el, appearActiveClass);
        },
        onEnter: makeEnterHook(false),
        onAppear: makeEnterHook(true),
        onLeave (el, done) {
            el._isLeaving = true;
            const resolve = ()=>finishLeave(el, done);
            $a5d55dc64ccb07cf$var$addTransitionClass(el, leaveFromClass);
            // force reflow so *-leave-from classes immediately take effect (#2593)
            $a5d55dc64ccb07cf$var$forceReflow();
            $a5d55dc64ccb07cf$var$addTransitionClass(el, leaveActiveClass);
            $a5d55dc64ccb07cf$var$nextFrame(()=>{
                if (!el._isLeaving) // cancelled
                return;
                $a5d55dc64ccb07cf$var$removeTransitionClass(el, leaveFromClass);
                $a5d55dc64ccb07cf$var$addTransitionClass(el, leaveToClass);
                if (!$a5d55dc64ccb07cf$var$hasExplicitCallback(onLeave)) $a5d55dc64ccb07cf$var$whenTransitionEnds(el, type, leaveDuration, resolve);
            });
            $a5d55dc64ccb07cf$var$callHook(onLeave, [
                el,
                resolve
            ]);
        },
        onEnterCancelled (el) {
            finishEnter(el, false);
            $a5d55dc64ccb07cf$var$callHook(onEnterCancelled, [
                el
            ]);
        },
        onAppearCancelled (el) {
            finishEnter(el, true);
            $a5d55dc64ccb07cf$var$callHook(onAppearCancelled, [
                el
            ]);
        },
        onLeaveCancelled (el) {
            finishLeave(el);
            $a5d55dc64ccb07cf$var$callHook(onLeaveCancelled, [
                el
            ]);
        }
    });
}
function $a5d55dc64ccb07cf$var$normalizeDuration(duration) {
    if (duration == null) return null;
    else if ((0, $8POXm.isObject)(duration)) return [
        $a5d55dc64ccb07cf$var$NumberOf(duration.enter),
        $a5d55dc64ccb07cf$var$NumberOf(duration.leave)
    ];
    else {
        const n = $a5d55dc64ccb07cf$var$NumberOf(duration);
        return [
            n,
            n
        ];
    }
}
function $a5d55dc64ccb07cf$var$NumberOf(val) {
    const res = (0, $8POXm.toNumber)(val);
    return res;
}
function $a5d55dc64ccb07cf$var$validateDuration(val) {
    if (typeof val !== 'number') (0, $TusQn.warn)(`<transition> explicit duration is not a valid number - ` + `got ${JSON.stringify(val)}.`);
    else if (isNaN(val)) (0, $TusQn.warn)(`<transition> explicit duration is NaN - ` + 'the duration expression might be incorrect.');
}
function $a5d55dc64ccb07cf$var$addTransitionClass(el, cls) {
    cls.split(/\s+/).forEach((c)=>c && el.classList.add(c));
    (el._vtc || (el._vtc = new Set())).add(cls);
}
function $a5d55dc64ccb07cf$var$removeTransitionClass(el, cls) {
    cls.split(/\s+/).forEach((c)=>c && el.classList.remove(c));
    const { _vtc: _vtc } = el;
    if (_vtc) {
        _vtc.delete(cls);
        if (!_vtc.size) el._vtc = undefined;
    }
}
function $a5d55dc64ccb07cf$var$nextFrame(cb) {
    requestAnimationFrame(()=>{
        requestAnimationFrame(cb);
    });
}
let $a5d55dc64ccb07cf$var$endId = 0;
function $a5d55dc64ccb07cf$var$whenTransitionEnds(el, expectedType, explicitTimeout, resolve) {
    const id = el._endId = ++$a5d55dc64ccb07cf$var$endId;
    const resolveIfNotStale = ()=>{
        if (id === el._endId) resolve();
    };
    if (explicitTimeout) return setTimeout(resolveIfNotStale, explicitTimeout);
    const { type: type, timeout: timeout, propCount: propCount } = $a5d55dc64ccb07cf$var$getTransitionInfo(el, expectedType);
    if (!type) return resolve();
    const endEvent = type + 'end';
    let ended = 0;
    const end = ()=>{
        el.removeEventListener(endEvent, onEnd);
        resolveIfNotStale();
    };
    const onEnd = (e)=>{
        if (e.target === el && ++ended >= propCount) end();
    };
    setTimeout(()=>{
        if (ended < propCount) end();
    }, timeout + 1);
    el.addEventListener(endEvent, onEnd);
}
function $a5d55dc64ccb07cf$var$getTransitionInfo(el, expectedType) {
    const styles = window.getComputedStyle(el);
    // JSDOM may return undefined for transition properties
    const getStyleProperties = (key)=>(styles[key] || '').split(', ');
    const transitionDelays = getStyleProperties($a5d55dc64ccb07cf$var$TRANSITION + 'Delay');
    const transitionDurations = getStyleProperties($a5d55dc64ccb07cf$var$TRANSITION + 'Duration');
    const transitionTimeout = $a5d55dc64ccb07cf$var$getTimeout(transitionDelays, transitionDurations);
    const animationDelays = getStyleProperties($a5d55dc64ccb07cf$var$ANIMATION + 'Delay');
    const animationDurations = getStyleProperties($a5d55dc64ccb07cf$var$ANIMATION + 'Duration');
    const animationTimeout = $a5d55dc64ccb07cf$var$getTimeout(animationDelays, animationDurations);
    let type = null;
    let timeout = 0;
    let propCount = 0;
    /* istanbul ignore if */ if (expectedType === $a5d55dc64ccb07cf$var$TRANSITION) {
        if (transitionTimeout > 0) {
            type = $a5d55dc64ccb07cf$var$TRANSITION;
            timeout = transitionTimeout;
            propCount = transitionDurations.length;
        }
    } else if (expectedType === $a5d55dc64ccb07cf$var$ANIMATION) {
        if (animationTimeout > 0) {
            type = $a5d55dc64ccb07cf$var$ANIMATION;
            timeout = animationTimeout;
            propCount = animationDurations.length;
        }
    } else {
        timeout = Math.max(transitionTimeout, animationTimeout);
        type = timeout > 0 ? transitionTimeout > animationTimeout ? $a5d55dc64ccb07cf$var$TRANSITION : $a5d55dc64ccb07cf$var$ANIMATION : null;
        propCount = type ? type === $a5d55dc64ccb07cf$var$TRANSITION ? transitionDurations.length : animationDurations.length : 0;
    }
    const hasTransform = type === $a5d55dc64ccb07cf$var$TRANSITION && /\b(transform|all)(,|$)/.test(styles[$a5d55dc64ccb07cf$var$TRANSITION + 'Property']);
    return {
        type: type,
        timeout: timeout,
        propCount: propCount,
        hasTransform: hasTransform
    };
}
function $a5d55dc64ccb07cf$var$getTimeout(delays, durations) {
    while(delays.length < durations.length)delays = delays.concat(delays);
    return Math.max(...durations.map((d, i)=>$a5d55dc64ccb07cf$var$toMs(d) + $a5d55dc64ccb07cf$var$toMs(delays[i])));
}
// Old versions of Chromium (below 61.0.3163.100) formats floating pointer
// numbers in a locale-dependent way, using a comma instead of a dot.
// If comma is not replaced with a dot, the input will be rounded down
// (i.e. acting as a floor function) causing unexpected behaviors
function $a5d55dc64ccb07cf$var$toMs(s) {
    return Number(s.slice(0, -1).replace(',', '.')) * 1000;
}
// synchronously force layout to put elements into a certain state
function $a5d55dc64ccb07cf$var$forceReflow() {
    return document.body.offsetHeight;
}
const $a5d55dc64ccb07cf$var$positionMap = new WeakMap();
const $a5d55dc64ccb07cf$var$newPositionMap = new WeakMap();
const $a5d55dc64ccb07cf$var$TransitionGroupImpl = {
    name: 'TransitionGroup',
    props: /*#__PURE__*/ (0, $8POXm.extend)({}, $a5d55dc64ccb07cf$var$TransitionPropsValidators, {
        tag: String,
        moveClass: String
    }),
    setup (props, { slots: slots }) {
        const instance = (0, $TusQn.getCurrentInstance)();
        const state = (0, $TusQn.useTransitionState)();
        let prevChildren;
        let children;
        (0, $TusQn.onUpdated)(()=>{
            // children is guaranteed to exist after initial render
            if (!prevChildren.length) return;
            const moveClass = props.moveClass || `${props.name || 'v'}-move`;
            if (!$a5d55dc64ccb07cf$var$hasCSSTransform(prevChildren[0].el, instance.vnode.el, moveClass)) return;
            // we divide the work into three loops to avoid mixing DOM reads and writes
            // in each iteration - which helps prevent layout thrashing.
            prevChildren.forEach($a5d55dc64ccb07cf$var$callPendingCbs);
            prevChildren.forEach($a5d55dc64ccb07cf$var$recordPosition);
            const movedChildren = prevChildren.filter($a5d55dc64ccb07cf$var$applyTranslation);
            // force reflow to put everything in position
            $a5d55dc64ccb07cf$var$forceReflow();
            movedChildren.forEach((c)=>{
                const el = c.el;
                const style = el.style;
                $a5d55dc64ccb07cf$var$addTransitionClass(el, moveClass);
                style.transform = style.webkitTransform = style.transitionDuration = '';
                const cb = el._moveCb = (e)=>{
                    if (e && e.target !== el) return;
                    if (!e || /transform$/.test(e.propertyName)) {
                        el.removeEventListener('transitionend', cb);
                        el._moveCb = null;
                        $a5d55dc64ccb07cf$var$removeTransitionClass(el, moveClass);
                    }
                };
                el.addEventListener('transitionend', cb);
            });
        });
        return ()=>{
            const rawProps = (0, $01W3b.toRaw)(props);
            const cssTransitionProps = $a5d55dc64ccb07cf$var$resolveTransitionProps(rawProps);
            let tag = rawProps.tag || (0, $TusQn.Fragment);
            prevChildren = children;
            children = slots.default ? (0, $TusQn.getTransitionRawChildren)(slots.default()) : [];
            for(let i = 0; i < children.length; i++){
                const child = children[i];
                if (child.key != null) (0, $TusQn.setTransitionHooks)(child, (0, $TusQn.resolveTransitionHooks)(child, cssTransitionProps, state, instance));
            }
            if (prevChildren) for(let i = 0; i < prevChildren.length; i++){
                const child = prevChildren[i];
                (0, $TusQn.setTransitionHooks)(child, (0, $TusQn.resolveTransitionHooks)(child, cssTransitionProps, state, instance));
                $a5d55dc64ccb07cf$var$positionMap.set(child, child.el.getBoundingClientRect());
            }
            return (0, $TusQn.createVNode)(tag, null, children);
        };
    }
};
const $a5d55dc64ccb07cf$export$19ffa8f511f7bc2e = $a5d55dc64ccb07cf$var$TransitionGroupImpl;
function $a5d55dc64ccb07cf$var$callPendingCbs(c) {
    const el = c.el;
    if (el._moveCb) el._moveCb();
    if (el._enterCb) el._enterCb();
}
function $a5d55dc64ccb07cf$var$recordPosition(c) {
    $a5d55dc64ccb07cf$var$newPositionMap.set(c, c.el.getBoundingClientRect());
}
function $a5d55dc64ccb07cf$var$applyTranslation(c) {
    const oldPos = $a5d55dc64ccb07cf$var$positionMap.get(c);
    const newPos = $a5d55dc64ccb07cf$var$newPositionMap.get(c);
    const dx = oldPos.left - newPos.left;
    const dy = oldPos.top - newPos.top;
    if (dx || dy) {
        const s = c.el.style;
        s.transform = s.webkitTransform = `translate(${dx}px,${dy}px)`;
        s.transitionDuration = '0s';
        return c;
    }
}
function $a5d55dc64ccb07cf$var$hasCSSTransform(el, root, moveClass) {
    // Detect whether an element with the move class applied has
    // CSS transitions. Since the element may be inside an entering
    // transition at this very moment, we make a clone of it and remove
    // all other transition classes applied to ensure only the move class
    // is applied.
    const clone = el.cloneNode();
    if (el._vtc) el._vtc.forEach((cls)=>{
        cls.split(/\s+/).forEach((c)=>c && clone.classList.remove(c));
    });
    moveClass.split(/\s+/).forEach((c)=>c && clone.classList.add(c));
    clone.style.display = 'none';
    const container = root.nodeType === 1 ? root : root.parentNode;
    container.appendChild(clone);
    const { hasTransform: hasTransform } = $a5d55dc64ccb07cf$var$getTransitionInfo(clone);
    container.removeChild(clone);
    return hasTransform;
}
const $a5d55dc64ccb07cf$var$getModelAssigner = (vnode)=>{
    const fn = vnode.props['onUpdate:modelValue'] || false;
    return (0, $8POXm.isArray)(fn) ? (value)=>(0, $8POXm.invokeArrayFns)(fn, value) : fn;
};
function $a5d55dc64ccb07cf$var$onCompositionStart(e) {
    e.target.composing = true;
}
function $a5d55dc64ccb07cf$var$onCompositionEnd(e) {
    const target = e.target;
    if (target.composing) {
        target.composing = false;
        target.dispatchEvent(new Event('input'));
    }
}
// We are exporting the v-model runtime directly as vnode hooks so that it can
// be tree-shaken in case v-model is never used.
const $a5d55dc64ccb07cf$export$f1f88689f5728478 = {
    created (el, { modifiers: { lazy: lazy, trim: trim, number: number } }, vnode) {
        el._assign = $a5d55dc64ccb07cf$var$getModelAssigner(vnode);
        const castToNumber = number || vnode.props && vnode.props.type === 'number';
        $a5d55dc64ccb07cf$var$addEventListener(el, lazy ? 'change' : 'input', (e)=>{
            if (e.target.composing) return;
            let domValue = el.value;
            if (trim) domValue = domValue.trim();
            if (castToNumber) domValue = (0, $8POXm.toNumber)(domValue);
            el._assign(domValue);
        });
        if (trim) $a5d55dc64ccb07cf$var$addEventListener(el, 'change', ()=>{
            el.value = el.value.trim();
        });
        if (!lazy) {
            $a5d55dc64ccb07cf$var$addEventListener(el, 'compositionstart', $a5d55dc64ccb07cf$var$onCompositionStart);
            $a5d55dc64ccb07cf$var$addEventListener(el, 'compositionend', $a5d55dc64ccb07cf$var$onCompositionEnd);
            // Safari < 10.2 & UIWebView doesn't fire compositionend when
            // switching focus before confirming composition choice
            // this also fixes the issue where some browsers e.g. iOS Chrome
            // fires "change" instead of "input" on autocomplete.
            $a5d55dc64ccb07cf$var$addEventListener(el, 'change', $a5d55dc64ccb07cf$var$onCompositionEnd);
        }
    },
    // set value on mounted so it's after min/max for type="range"
    mounted (el, { value: value }) {
        el.value = value == null ? '' : value;
    },
    beforeUpdate (el, { value: value, modifiers: { lazy: lazy, trim: trim, number: number } }, vnode) {
        el._assign = $a5d55dc64ccb07cf$var$getModelAssigner(vnode);
        // avoid clearing unresolved text. #2302
        if (el.composing) return;
        if (document.activeElement === el && el.type !== 'range') {
            if (lazy) return;
            if (trim && el.value.trim() === value) return;
            if ((number || el.type === 'number') && (0, $8POXm.toNumber)(el.value) === value) return;
        }
        const newValue = value == null ? '' : value;
        if (el.value !== newValue) el.value = newValue;
    }
};
const $a5d55dc64ccb07cf$export$8847c2e532b35714 = {
    // #4096 array checkboxes need to be deep traversed
    deep: true,
    created (el, _, vnode) {
        el._assign = $a5d55dc64ccb07cf$var$getModelAssigner(vnode);
        $a5d55dc64ccb07cf$var$addEventListener(el, 'change', ()=>{
            const modelValue = el._modelValue;
            const elementValue = $a5d55dc64ccb07cf$var$getValue(el);
            const checked = el.checked;
            const assign = el._assign;
            if ((0, $8POXm.isArray)(modelValue)) {
                const index = (0, $8POXm.looseIndexOf)(modelValue, elementValue);
                const found = index !== -1;
                if (checked && !found) assign(modelValue.concat(elementValue));
                else if (!checked && found) {
                    const filtered = [
                        ...modelValue
                    ];
                    filtered.splice(index, 1);
                    assign(filtered);
                }
            } else if ((0, $8POXm.isSet)(modelValue)) {
                const cloned = new Set(modelValue);
                if (checked) cloned.add(elementValue);
                else cloned.delete(elementValue);
                assign(cloned);
            } else assign($a5d55dc64ccb07cf$var$getCheckboxValue(el, checked));
        });
    },
    // set initial checked on mount to wait for true-value/false-value
    mounted: $a5d55dc64ccb07cf$var$setChecked,
    beforeUpdate (el, binding, vnode) {
        el._assign = $a5d55dc64ccb07cf$var$getModelAssigner(vnode);
        $a5d55dc64ccb07cf$var$setChecked(el, binding, vnode);
    }
};
function $a5d55dc64ccb07cf$var$setChecked(el, { value: value, oldValue: oldValue }, vnode) {
    el._modelValue = value;
    if ((0, $8POXm.isArray)(value)) el.checked = (0, $8POXm.looseIndexOf)(value, vnode.props.value) > -1;
    else if ((0, $8POXm.isSet)(value)) el.checked = value.has(vnode.props.value);
    else if (value !== oldValue) el.checked = (0, $8POXm.looseEqual)(value, $a5d55dc64ccb07cf$var$getCheckboxValue(el, true));
}
const $a5d55dc64ccb07cf$export$b4356c59b38b7aa9 = {
    created (el, { value: value }, vnode) {
        el.checked = (0, $8POXm.looseEqual)(value, vnode.props.value);
        el._assign = $a5d55dc64ccb07cf$var$getModelAssigner(vnode);
        $a5d55dc64ccb07cf$var$addEventListener(el, 'change', ()=>{
            el._assign($a5d55dc64ccb07cf$var$getValue(el));
        });
    },
    beforeUpdate (el, { value: value, oldValue: oldValue }, vnode) {
        el._assign = $a5d55dc64ccb07cf$var$getModelAssigner(vnode);
        if (value !== oldValue) el.checked = (0, $8POXm.looseEqual)(value, vnode.props.value);
    }
};
const $a5d55dc64ccb07cf$export$87d227567b51ca39 = {
    // <select multiple> value need to be deep traversed
    deep: true,
    created (el, { value: value, modifiers: { number: number } }, vnode) {
        const isSetModel = (0, $8POXm.isSet)(value);
        $a5d55dc64ccb07cf$var$addEventListener(el, 'change', ()=>{
            const selectedVal = Array.prototype.filter.call(el.options, (o)=>o.selected).map((o)=>number ? (0, $8POXm.toNumber)($a5d55dc64ccb07cf$var$getValue(o)) : $a5d55dc64ccb07cf$var$getValue(o));
            el._assign(el.multiple ? isSetModel ? new Set(selectedVal) : selectedVal : selectedVal[0]);
        });
        el._assign = $a5d55dc64ccb07cf$var$getModelAssigner(vnode);
    },
    // set value in mounted & updated because <select> relies on its children
    // <option>s.
    mounted (el, { value: value }) {
        $a5d55dc64ccb07cf$var$setSelected(el, value);
    },
    beforeUpdate (el, _binding, vnode) {
        el._assign = $a5d55dc64ccb07cf$var$getModelAssigner(vnode);
    },
    updated (el, { value: value }) {
        $a5d55dc64ccb07cf$var$setSelected(el, value);
    }
};
function $a5d55dc64ccb07cf$var$setSelected(el, value) {
    const isMultiple = el.multiple;
    if (isMultiple && !(0, $8POXm.isArray)(value) && !(0, $8POXm.isSet)(value)) return;
    for(let i = 0, l = el.options.length; i < l; i++){
        const option = el.options[i];
        const optionValue = $a5d55dc64ccb07cf$var$getValue(option);
        if (isMultiple) {
            if ((0, $8POXm.isArray)(value)) option.selected = (0, $8POXm.looseIndexOf)(value, optionValue) > -1;
            else option.selected = value.has(optionValue);
        } else if ((0, $8POXm.looseEqual)($a5d55dc64ccb07cf$var$getValue(option), value)) {
            if (el.selectedIndex !== i) el.selectedIndex = i;
            return;
        }
    }
    if (!isMultiple && el.selectedIndex !== -1) el.selectedIndex = -1;
}
// retrieve raw value set via :value bindings
function $a5d55dc64ccb07cf$var$getValue(el) {
    return '_value' in el ? el._value : el.value;
}
// retrieve raw value for true-value and false-value set via :true-value or :false-value bindings
function $a5d55dc64ccb07cf$var$getCheckboxValue(el, checked) {
    const key = checked ? '_trueValue' : '_falseValue';
    return key in el ? el[key] : checked;
}
const $a5d55dc64ccb07cf$export$5ad5c0e01ff62c5 = {
    created (el, binding, vnode) {
        $a5d55dc64ccb07cf$var$callModelHook(el, binding, vnode, null, 'created');
    },
    mounted (el, binding, vnode) {
        $a5d55dc64ccb07cf$var$callModelHook(el, binding, vnode, null, 'mounted');
    },
    beforeUpdate (el, binding, vnode, prevVNode) {
        $a5d55dc64ccb07cf$var$callModelHook(el, binding, vnode, prevVNode, 'beforeUpdate');
    },
    updated (el, binding, vnode, prevVNode) {
        $a5d55dc64ccb07cf$var$callModelHook(el, binding, vnode, prevVNode, 'updated');
    }
};
function $a5d55dc64ccb07cf$var$resolveDynamicModel(tagName, type) {
    switch(tagName){
        case 'SELECT':
            return $a5d55dc64ccb07cf$export$87d227567b51ca39;
        case 'TEXTAREA':
            return $a5d55dc64ccb07cf$export$f1f88689f5728478;
        default:
            switch(type){
                case 'checkbox':
                    return $a5d55dc64ccb07cf$export$8847c2e532b35714;
                case 'radio':
                    return $a5d55dc64ccb07cf$export$b4356c59b38b7aa9;
                default:
                    return $a5d55dc64ccb07cf$export$f1f88689f5728478;
            }
    }
}
function $a5d55dc64ccb07cf$var$callModelHook(el, binding, vnode, prevVNode, hook) {
    const modelToUse = $a5d55dc64ccb07cf$var$resolveDynamicModel(el.tagName, vnode.props && vnode.props.type);
    const fn = modelToUse[hook];
    fn && fn(el, binding, vnode, prevVNode);
}
// SSR vnode transforms, only used when user includes client-oriented render
// function in SSR
function $a5d55dc64ccb07cf$var$initVModelForSSR() {
    $a5d55dc64ccb07cf$export$f1f88689f5728478.getSSRProps = ({ value: value })=>({
            value: value
        });
    $a5d55dc64ccb07cf$export$b4356c59b38b7aa9.getSSRProps = ({ value: value }, vnode)=>{
        if (vnode.props && (0, $8POXm.looseEqual)(vnode.props.value, value)) return {
            checked: true
        };
    };
    $a5d55dc64ccb07cf$export$8847c2e532b35714.getSSRProps = ({ value: value }, vnode)=>{
        if ((0, $8POXm.isArray)(value)) {
            if (vnode.props && (0, $8POXm.looseIndexOf)(value, vnode.props.value) > -1) return {
                checked: true
            };
        } else if ((0, $8POXm.isSet)(value)) {
            if (vnode.props && value.has(vnode.props.value)) return {
                checked: true
            };
        } else if (value) return {
            checked: true
        };
    };
    $a5d55dc64ccb07cf$export$5ad5c0e01ff62c5.getSSRProps = (binding, vnode)=>{
        if (typeof vnode.type !== 'string') return;
        const modelToUse = $a5d55dc64ccb07cf$var$resolveDynamicModel(// resolveDynamicModel expects an uppercase tag name, but vnode.type is lowercase
        vnode.type.toUpperCase(), vnode.props && vnode.props.type);
        if (modelToUse.getSSRProps) return modelToUse.getSSRProps(binding, vnode);
    };
}
const $a5d55dc64ccb07cf$var$systemModifiers = [
    'ctrl',
    'shift',
    'alt',
    'meta'
];
const $a5d55dc64ccb07cf$var$modifierGuards = {
    stop: (e)=>e.stopPropagation(),
    prevent: (e)=>e.preventDefault(),
    self: (e)=>e.target !== e.currentTarget,
    ctrl: (e)=>!e.ctrlKey,
    shift: (e)=>!e.shiftKey,
    alt: (e)=>!e.altKey,
    meta: (e)=>!e.metaKey,
    left: (e)=>'button' in e && e.button !== 0,
    middle: (e)=>'button' in e && e.button !== 1,
    right: (e)=>'button' in e && e.button !== 2,
    exact: (e, modifiers)=>$a5d55dc64ccb07cf$var$systemModifiers.some((m)=>e[`${m}Key`] && !modifiers.includes(m))
};
/**
 * @private
 */ const $a5d55dc64ccb07cf$export$26bd3b8e29e6f273 = (fn, modifiers)=>{
    return (event, ...args)=>{
        for(let i = 0; i < modifiers.length; i++){
            const guard = $a5d55dc64ccb07cf$var$modifierGuards[modifiers[i]];
            if (guard && guard(event, modifiers)) return;
        }
        return fn(event, ...args);
    };
};
// Kept for 2.x compat.
// Note: IE11 compat for `spacebar` and `del` is removed for now.
const $a5d55dc64ccb07cf$var$keyNames = {
    esc: 'escape',
    space: ' ',
    up: 'arrow-up',
    left: 'arrow-left',
    right: 'arrow-right',
    down: 'arrow-down',
    delete: 'backspace'
};
/**
 * @private
 */ const $a5d55dc64ccb07cf$export$f691a8759658f782 = (fn, modifiers)=>{
    return (event)=>{
        if (!('key' in event)) return;
        const eventKey = (0, $8POXm.hyphenate)(event.key);
        if (modifiers.some((k)=>k === eventKey || $a5d55dc64ccb07cf$var$keyNames[k] === eventKey)) return fn(event);
    };
};
const $a5d55dc64ccb07cf$export$5cb4fcdc6937d7e1 = {
    beforeMount (el, { value: value }, { transition: transition }) {
        el._vod = el.style.display === 'none' ? '' : el.style.display;
        if (transition && value) transition.beforeEnter(el);
        else $a5d55dc64ccb07cf$var$setDisplay(el, value);
    },
    mounted (el, { value: value }, { transition: transition }) {
        if (transition && value) transition.enter(el);
    },
    updated (el, { value: value, oldValue: oldValue }, { transition: transition }) {
        if (!value === !oldValue) return;
        if (transition) {
            if (value) {
                transition.beforeEnter(el);
                $a5d55dc64ccb07cf$var$setDisplay(el, true);
                transition.enter(el);
            } else transition.leave(el, ()=>{
                $a5d55dc64ccb07cf$var$setDisplay(el, false);
            });
        } else $a5d55dc64ccb07cf$var$setDisplay(el, value);
    },
    beforeUnmount (el, { value: value }) {
        $a5d55dc64ccb07cf$var$setDisplay(el, value);
    }
};
function $a5d55dc64ccb07cf$var$setDisplay(el, value) {
    el.style.display = value ? el._vod : 'none';
}
// SSR vnode transforms, only used when user includes client-oriented render
// function in SSR
function $a5d55dc64ccb07cf$var$initVShowForSSR() {
    $a5d55dc64ccb07cf$export$5cb4fcdc6937d7e1.getSSRProps = ({ value: value })=>{
        if (!value) return {
            style: {
                display: 'none'
            }
        };
    };
}
const $a5d55dc64ccb07cf$var$rendererOptions = /*#__PURE__*/ (0, $8POXm.extend)({
    patchProp: $a5d55dc64ccb07cf$var$patchProp
}, $a5d55dc64ccb07cf$var$nodeOps);
// lazy create the renderer - this makes core renderer logic tree-shakable
// in case the user only imports reactivity utilities from Vue.
let $a5d55dc64ccb07cf$var$renderer;
let $a5d55dc64ccb07cf$var$enabledHydration = false;
function $a5d55dc64ccb07cf$var$ensureRenderer() {
    return $a5d55dc64ccb07cf$var$renderer || ($a5d55dc64ccb07cf$var$renderer = (0, $TusQn.createRenderer)($a5d55dc64ccb07cf$var$rendererOptions));
}
function $a5d55dc64ccb07cf$var$ensureHydrationRenderer() {
    $a5d55dc64ccb07cf$var$renderer = $a5d55dc64ccb07cf$var$enabledHydration ? $a5d55dc64ccb07cf$var$renderer : (0, $TusQn.createHydrationRenderer)($a5d55dc64ccb07cf$var$rendererOptions);
    $a5d55dc64ccb07cf$var$enabledHydration = true;
    return $a5d55dc64ccb07cf$var$renderer;
}
// use explicit type casts here to avoid import() calls in rolled-up d.ts
const $a5d55dc64ccb07cf$export$b3890eb0ae9dca99 = (...args)=>{
    $a5d55dc64ccb07cf$var$ensureRenderer().render(...args);
};
const $a5d55dc64ccb07cf$export$fa8d919ba61d84db = (...args)=>{
    $a5d55dc64ccb07cf$var$ensureHydrationRenderer().hydrate(...args);
};
const $a5d55dc64ccb07cf$export$4e373c34abfa8c68 = (...args)=>{
    const app = $a5d55dc64ccb07cf$var$ensureRenderer().createApp(...args);
    const { mount: mount } = app;
    app.mount = (containerOrSelector)=>{
        const container = $a5d55dc64ccb07cf$var$normalizeContainer(containerOrSelector);
        if (!container) return;
        const component = app._component;
        if (!(0, $8POXm.isFunction)(component) && !component.render && !component.template) // __UNSAFE__
        // Reason: potential execution of JS expressions in in-DOM template.
        // The user must make sure the in-DOM template is trusted. If it's
        // rendered by the server, the template should not contain any user data.
        component.template = container.innerHTML;
        // clear content before mounting
        container.innerHTML = '';
        const proxy = mount(container, false, container instanceof SVGElement);
        if (container instanceof Element) {
            container.removeAttribute('v-cloak');
            container.setAttribute('data-v-app', '');
        }
        return proxy;
    };
    return app;
};
const $a5d55dc64ccb07cf$export$35800275c0037383 = (...args)=>{
    const app = $a5d55dc64ccb07cf$var$ensureHydrationRenderer().createApp(...args);
    const { mount: mount } = app;
    app.mount = (containerOrSelector)=>{
        const container = $a5d55dc64ccb07cf$var$normalizeContainer(containerOrSelector);
        if (container) return mount(container, true, container instanceof SVGElement);
    };
    return app;
};
function $a5d55dc64ccb07cf$var$injectNativeTagCheck(app) {
    // Inject `isNativeTag`
    // this is used for component name validation (dev only)
    Object.defineProperty(app.config, 'isNativeTag', {
        value: (tag)=>(0, $8POXm.isHTMLTag)(tag) || (0, $8POXm.isSVGTag)(tag),
        writable: false
    });
}
// dev only
function $a5d55dc64ccb07cf$var$injectCompilerOptionsCheck(app) {
    if ((0, $TusQn.isRuntimeOnly)()) {
        const isCustomElement = app.config.isCustomElement;
        Object.defineProperty(app.config, 'isCustomElement', {
            get () {
                return isCustomElement;
            },
            set () {
                (0, $TusQn.warn)(`The \`isCustomElement\` config option is deprecated. Use ` + `\`compilerOptions.isCustomElement\` instead.`);
            }
        });
        const compilerOptions = app.config.compilerOptions;
        const msg = `The \`compilerOptions\` config option is only respected when using ` + `a build of Vue.js that includes the runtime compiler (aka "full build"). ` + `Since you are using the runtime-only build, \`compilerOptions\` ` + `must be passed to \`@vue/compiler-dom\` in the build setup instead.\n` + `- For vue-loader: pass it via vue-loader's \`compilerOptions\` loader option.\n` + `- For vue-cli: see https://cli.vuejs.org/guide/webpack.html#modifying-options-of-a-loader\n` + `- For vite: pass it via @vitejs/plugin-vue options. See https://github.com/vitejs/vite/tree/main/packages/plugin-vue#example-for-passing-options-to-vuecompiler-dom`;
        Object.defineProperty(app.config, 'compilerOptions', {
            get () {
                (0, $TusQn.warn)(msg);
                return compilerOptions;
            },
            set () {
                (0, $TusQn.warn)(msg);
            }
        });
    }
}
function $a5d55dc64ccb07cf$var$normalizeContainer(container) {
    if ((0, $8POXm.isString)(container)) {
        const res = document.querySelector(container);
        return res;
    }
    return container;
}
let $a5d55dc64ccb07cf$var$ssrDirectiveInitialized = false;
/**
 * @internal
 */ const $a5d55dc64ccb07cf$export$800b28255aa678d9 = ()=>{
    if (!$a5d55dc64ccb07cf$var$ssrDirectiveInitialized) {
        $a5d55dc64ccb07cf$var$ssrDirectiveInitialized = true;
        $a5d55dc64ccb07cf$var$initVModelForSSR();
        $a5d55dc64ccb07cf$var$initVShowForSSR();
    }
};
$parcel$exportWildcard(module.exports, $TusQn);

});


parcelRegister("73mM4", function(module, exports) {

$parcel$export(module.exports, "createWebHistory", () => $a809ac530d32f081$export$7b4942f78e7b8a49);
$parcel$export(module.exports, "RouterLink", () => $a809ac530d32f081$export$fce709ebdac448ed);
$parcel$export(module.exports, "createRouter", () => $a809ac530d32f081$export$baddd0131ee8c05b);
$parcel$export(module.exports, "useRouter", () => $a809ac530d32f081$export$9a302a45f65d0572);
$parcel$export(module.exports, "useRoute", () => $a809ac530d32f081$export$3f79f0b98112cf57);
/*!
  * vue-router v4.1.5
  * (c) 2022 Eduardo San Martin Morote
  * @license MIT
  */ parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");
var $TusQn = parcelRequire("TusQn");

var $j6G8F = parcelRequire("j6G8F");
const $a809ac530d32f081$var$isBrowser = typeof window !== 'undefined';
function $a809ac530d32f081$var$isESModule(obj) {
    return obj.__esModule || obj[Symbol.toStringTag] === 'Module';
}
const $a809ac530d32f081$var$assign = Object.assign;
function $a809ac530d32f081$var$applyToParams(fn, params) {
    const newParams = {};
    for(const key in params){
        const value = params[key];
        newParams[key] = $a809ac530d32f081$var$isArray(value) ? value.map(fn) : fn(value);
    }
    return newParams;
}
const $a809ac530d32f081$var$noop = ()=>{};
/**
 * Typesafe alternative to Array.isArray
 * https://github.com/microsoft/TypeScript/pull/48228
 */ const $a809ac530d32f081$var$isArray = Array.isArray;
function $a809ac530d32f081$var$warn(msg) {
    // avoid using ...args as it breaks in older Edge builds
    const args = Array.from(arguments).slice(1);
    console.warn.apply(console, [
        '[Vue Router warn]: ' + msg
    ].concat(args));
}
const $a809ac530d32f081$var$TRAILING_SLASH_RE = /\/$/;
const $a809ac530d32f081$var$removeTrailingSlash = (path)=>path.replace($a809ac530d32f081$var$TRAILING_SLASH_RE, '');
/**
 * Transforms a URI into a normalized history location
 *
 * @param parseQuery
 * @param location - URI to normalize
 * @param currentLocation - current absolute location. Allows resolving relative
 * paths. Must start with `/`. Defaults to `/`
 * @returns a normalized history location
 */ function $a809ac530d32f081$var$parseURL(parseQuery, location1, currentLocation = '/') {
    let path, query = {}, searchString = '', hash = '';
    // Could use URL and URLSearchParams but IE 11 doesn't support it
    // TODO: move to new URL()
    const hashPos = location1.indexOf('#');
    let searchPos = location1.indexOf('?');
    // the hash appears before the search, so it's not part of the search string
    if (hashPos < searchPos && hashPos >= 0) searchPos = -1;
    if (searchPos > -1) {
        path = location1.slice(0, searchPos);
        searchString = location1.slice(searchPos + 1, hashPos > -1 ? hashPos : location1.length);
        query = parseQuery(searchString);
    }
    if (hashPos > -1) {
        path = path || location1.slice(0, hashPos);
        // keep the # character
        hash = location1.slice(hashPos, location1.length);
    }
    // no search and no query
    path = $a809ac530d32f081$var$resolveRelativePath(path != null ? path : location1, currentLocation);
    // empty path means a relative query or hash `?foo=f`, `#thing`
    return {
        fullPath: path + (searchString && '?') + searchString + hash,
        path: path,
        query: query,
        hash: hash
    };
}
/**
 * Stringifies a URL object
 *
 * @param stringifyQuery
 * @param location
 */ function $a809ac530d32f081$var$stringifyURL(stringifyQuery, location1) {
    const query = location1.query ? stringifyQuery(location1.query) : '';
    return location1.path + (query && '?') + query + (location1.hash || '');
}
/**
 * Strips off the base from the beginning of a location.pathname in a non-case-sensitive way.
 *
 * @param pathname - location.pathname
 * @param base - base to strip off
 */ function $a809ac530d32f081$var$stripBase(pathname, base) {
    // no base or base is not found at the beginning
    if (!base || !pathname.toLowerCase().startsWith(base.toLowerCase())) return pathname;
    return pathname.slice(base.length) || '/';
}
/**
 * Checks if two RouteLocation are equal. This means that both locations are
 * pointing towards the same {@link RouteRecord} and that all `params`, `query`
 * parameters and `hash` are the same
 *
 * @param a - first {@link RouteLocation}
 * @param b - second {@link RouteLocation}
 */ function $a809ac530d32f081$var$isSameRouteLocation(stringifyQuery, a, b) {
    const aLastIndex = a.matched.length - 1;
    const bLastIndex = b.matched.length - 1;
    return aLastIndex > -1 && aLastIndex === bLastIndex && $a809ac530d32f081$var$isSameRouteRecord(a.matched[aLastIndex], b.matched[bLastIndex]) && $a809ac530d32f081$var$isSameRouteLocationParams(a.params, b.params) && stringifyQuery(a.query) === stringifyQuery(b.query) && a.hash === b.hash;
}
/**
 * Check if two `RouteRecords` are equal. Takes into account aliases: they are
 * considered equal to the `RouteRecord` they are aliasing.
 *
 * @param a - first {@link RouteRecord}
 * @param b - second {@link RouteRecord}
 */ function $a809ac530d32f081$var$isSameRouteRecord(a, b) {
    // since the original record has an undefined value for aliasOf
    // but all aliases point to the original record, this will always compare
    // the original record
    return (a.aliasOf || a) === (b.aliasOf || b);
}
function $a809ac530d32f081$var$isSameRouteLocationParams(a, b) {
    if (Object.keys(a).length !== Object.keys(b).length) return false;
    for(const key in a){
        if (!$a809ac530d32f081$var$isSameRouteLocationParamsValue(a[key], b[key])) return false;
    }
    return true;
}
function $a809ac530d32f081$var$isSameRouteLocationParamsValue(a, b) {
    return $a809ac530d32f081$var$isArray(a) ? $a809ac530d32f081$var$isEquivalentArray(a, b) : $a809ac530d32f081$var$isArray(b) ? $a809ac530d32f081$var$isEquivalentArray(b, a) : a === b;
}
/**
 * Check if two arrays are the same or if an array with one single entry is the
 * same as another primitive value. Used to check query and parameters
 *
 * @param a - array of values
 * @param b - array of values or a single value
 */ function $a809ac530d32f081$var$isEquivalentArray(a, b) {
    return $a809ac530d32f081$var$isArray(b) ? a.length === b.length && a.every((value, i)=>value === b[i]) : a.length === 1 && a[0] === b;
}
/**
 * Resolves a relative path that starts with `.`.
 *
 * @param to - path location we are resolving
 * @param from - currentLocation.path, should start with `/`
 */ function $a809ac530d32f081$var$resolveRelativePath(to, from) {
    if (to.startsWith('/')) return to;
    if (!to) return from;
    const fromSegments = from.split('/');
    const toSegments = to.split('/');
    let position = fromSegments.length - 1;
    let toPosition;
    let segment;
    for(toPosition = 0; toPosition < toSegments.length; toPosition++){
        segment = toSegments[toPosition];
        // we stay on the same position
        if (segment === '.') continue;
        // go up in the from array
        if (segment === '..') // we can't go below zero, but we still need to increment toPosition
        {
            if (position > 1) position--;
        } else break;
    }
    return fromSegments.slice(0, position).join('/') + '/' + toSegments// ensure we use at least the last element in the toSegments
    .slice(toPosition - (toPosition === toSegments.length ? 1 : 0)).join('/');
}
var $a809ac530d32f081$var$NavigationType;
(function(NavigationType) {
    NavigationType["pop"] = "pop";
    NavigationType["push"] = "push";
})($a809ac530d32f081$var$NavigationType || ($a809ac530d32f081$var$NavigationType = {}));
var $a809ac530d32f081$var$NavigationDirection;
(function(NavigationDirection) {
    NavigationDirection["back"] = "back";
    NavigationDirection["forward"] = "forward";
    NavigationDirection["unknown"] = "";
})($a809ac530d32f081$var$NavigationDirection || ($a809ac530d32f081$var$NavigationDirection = {}));
/**
 * Starting location for Histories
 */ const $a809ac530d32f081$var$START = '';
// Generic utils
/**
 * Normalizes a base by removing any trailing slash and reading the base tag if
 * present.
 *
 * @param base - base to normalize
 */ function $a809ac530d32f081$var$normalizeBase(base) {
    if (!base) {
        if ($a809ac530d32f081$var$isBrowser) {
            // respect <base> tag
            const baseEl = document.querySelector('base');
            base = baseEl && baseEl.getAttribute('href') || '/';
            // strip full URL origin
            base = base.replace(/^\w+:\/\/[^\/]+/, '');
        } else base = '/';
    }
    // ensure leading slash when it was removed by the regex above avoid leading
    // slash with hash because the file could be read from the disk like file://
    // and the leading slash would cause problems
    if (base[0] !== '/' && base[0] !== '#') base = '/' + base;
    // remove the trailing slash so all other method can just do `base + fullPath`
    // to build an href
    return $a809ac530d32f081$var$removeTrailingSlash(base);
}
// remove any character before the hash
const $a809ac530d32f081$var$BEFORE_HASH_RE = /^[^#]+#/;
function $a809ac530d32f081$var$createHref(base, location1) {
    return base.replace($a809ac530d32f081$var$BEFORE_HASH_RE, '#') + location1;
}
function $a809ac530d32f081$var$getElementPosition(el, offset) {
    const docRect = document.documentElement.getBoundingClientRect();
    const elRect = el.getBoundingClientRect();
    return {
        behavior: offset.behavior,
        left: elRect.left - docRect.left - (offset.left || 0),
        top: elRect.top - docRect.top - (offset.top || 0)
    };
}
const $a809ac530d32f081$var$computeScrollPosition = ()=>({
        left: window.pageXOffset,
        top: window.pageYOffset
    });
function $a809ac530d32f081$var$scrollToPosition(position) {
    let scrollToOptions;
    if ('el' in position) {
        const positionEl = position.el;
        const isIdSelector = typeof positionEl === 'string' && positionEl.startsWith('#');
        var err;
        const el = typeof positionEl === 'string' ? isIdSelector ? document.getElementById(positionEl.slice(1)) : document.querySelector(positionEl) : positionEl;
        if (!el) return;
        scrollToOptions = $a809ac530d32f081$var$getElementPosition(el, position);
    } else scrollToOptions = position;
    if ('scrollBehavior' in document.documentElement.style) window.scrollTo(scrollToOptions);
    else window.scrollTo(scrollToOptions.left != null ? scrollToOptions.left : window.pageXOffset, scrollToOptions.top != null ? scrollToOptions.top : window.pageYOffset);
}
function $a809ac530d32f081$var$getScrollKey(path, delta) {
    const position = history.state ? history.state.position - delta : -1;
    return position + path;
}
const $a809ac530d32f081$var$scrollPositions = new Map();
function $a809ac530d32f081$var$saveScrollPosition(key, scrollPosition) {
    $a809ac530d32f081$var$scrollPositions.set(key, scrollPosition);
}
function $a809ac530d32f081$var$getSavedScrollPosition(key) {
    const scroll = $a809ac530d32f081$var$scrollPositions.get(key);
    // consume it so it's not used again
    $a809ac530d32f081$var$scrollPositions.delete(key);
    return scroll;
}
// TODO: RFC about how to save scroll position
/**
 * ScrollBehavior instance used by the router to compute and restore the scroll
 * position when navigating.
 */ // export interface ScrollHandler<ScrollPositionEntry extends HistoryStateValue, ScrollPosition extends ScrollPositionEntry> {
//   // returns a scroll position that can be saved in history
//   compute(): ScrollPositionEntry
//   // can take an extended ScrollPositionEntry
//   scroll(position: ScrollPosition): void
// }
// export const scrollHandler: ScrollHandler<ScrollPosition> = {
//   compute: computeScroll,
//   scroll: scrollToPosition,
// }
let $a809ac530d32f081$var$createBaseLocation = ()=>location.protocol + '//' + location.host;
/**
 * Creates a normalized history location from a window.location object
 * @param location -
 */ function $a809ac530d32f081$var$createCurrentLocation(base, location1) {
    const { pathname: pathname, search: search, hash: hash } = location1;
    // allows hash bases like #, /#, #/, #!, #!/, /#!/, or even /folder#end
    const hashPos = base.indexOf('#');
    if (hashPos > -1) {
        let slicePos = hash.includes(base.slice(hashPos)) ? base.slice(hashPos).length : 1;
        let pathFromHash = hash.slice(slicePos);
        // prepend the starting slash to hash so the url starts with /#
        if (pathFromHash[0] !== '/') pathFromHash = '/' + pathFromHash;
        return $a809ac530d32f081$var$stripBase(pathFromHash, '');
    }
    const path = $a809ac530d32f081$var$stripBase(pathname, base);
    return path + search + hash;
}
function $a809ac530d32f081$var$useHistoryListeners(base, historyState, currentLocation, replace) {
    let listeners = [];
    let teardowns = [];
    // TODO: should it be a stack? a Dict. Check if the popstate listener
    // can trigger twice
    let pauseState = null;
    const popStateHandler = ({ state: state })=>{
        const to = $a809ac530d32f081$var$createCurrentLocation(base, location);
        const from = currentLocation.value;
        const fromState = historyState.value;
        let delta = 0;
        if (state) {
            currentLocation.value = to;
            historyState.value = state;
            // ignore the popstate and reset the pauseState
            if (pauseState && pauseState === from) {
                pauseState = null;
                return;
            }
            delta = fromState ? state.position - fromState.position : 0;
        } else replace(to);
        // console.log({ deltaFromCurrent })
        // Here we could also revert the navigation by calling history.go(-delta)
        // this listener will have to be adapted to not trigger again and to wait for the url
        // to be updated before triggering the listeners. Some kind of validation function would also
        // need to be passed to the listeners so the navigation can be accepted
        // call all listeners
        listeners.forEach((listener)=>{
            listener(currentLocation.value, from, {
                delta: delta,
                type: $a809ac530d32f081$var$NavigationType.pop,
                direction: delta ? delta > 0 ? $a809ac530d32f081$var$NavigationDirection.forward : $a809ac530d32f081$var$NavigationDirection.back : $a809ac530d32f081$var$NavigationDirection.unknown
            });
        });
    };
    function pauseListeners() {
        pauseState = currentLocation.value;
    }
    function listen(callback) {
        // set up the listener and prepare teardown callbacks
        listeners.push(callback);
        const teardown = ()=>{
            const index = listeners.indexOf(callback);
            if (index > -1) listeners.splice(index, 1);
        };
        teardowns.push(teardown);
        return teardown;
    }
    function beforeUnloadListener() {
        const { history: history1 } = window;
        if (!history1.state) return;
        history1.replaceState($a809ac530d32f081$var$assign({}, history1.state, {
            scroll: $a809ac530d32f081$var$computeScrollPosition()
        }), '');
    }
    function destroy() {
        for (const teardown of teardowns)teardown();
        teardowns = [];
        window.removeEventListener('popstate', popStateHandler);
        window.removeEventListener('beforeunload', beforeUnloadListener);
    }
    // set up the listeners and prepare teardown callbacks
    window.addEventListener('popstate', popStateHandler);
    window.addEventListener('beforeunload', beforeUnloadListener);
    return {
        pauseListeners: pauseListeners,
        listen: listen,
        destroy: destroy
    };
}
/**
 * Creates a state object
 */ function $a809ac530d32f081$var$buildState(back, current, forward, replaced = false, computeScroll = false) {
    return {
        back: back,
        current: current,
        forward: forward,
        replaced: replaced,
        position: window.history.length,
        scroll: computeScroll ? $a809ac530d32f081$var$computeScrollPosition() : null
    };
}
function $a809ac530d32f081$var$useHistoryStateNavigation(base) {
    const { history: history1, location: location1 } = window;
    // private variables
    const currentLocation = {
        value: $a809ac530d32f081$var$createCurrentLocation(base, location1)
    };
    const historyState = {
        value: history1.state
    };
    // build current history entry as this is a fresh navigation
    if (!historyState.value) changeLocation(currentLocation.value, {
        back: null,
        current: currentLocation.value,
        forward: null,
        // the length is off by one, we need to decrease it
        position: history1.length - 1,
        replaced: true,
        // don't add a scroll as the user may have an anchor, and we want
        // scrollBehavior to be triggered without a saved position
        scroll: null
    }, true);
    function changeLocation(to, state, replace) {
        /**
         * if a base tag is provided, and we are on a normal domain, we have to
         * respect the provided `base` attribute because pushState() will use it and
         * potentially erase anything before the `#` like at
         * https://github.com/vuejs/router/issues/685 where a base of
         * `/folder/#` but a base of `/` would erase the `/folder/` section. If
         * there is no host, the `<base>` tag makes no sense and if there isn't a
         * base tag we can just use everything after the `#`.
         */ const hashIndex = base.indexOf('#');
        const url = hashIndex > -1 ? (location1.host && document.querySelector('base') ? base : base.slice(hashIndex)) + to : $a809ac530d32f081$var$createBaseLocation() + base + to;
        try {
            // BROWSER QUIRK
            // NOTE: Safari throws a SecurityError when calling this function 100 times in 30 seconds
            history1[replace ? 'replaceState' : 'pushState'](state, '', url);
            historyState.value = state;
        } catch (err) {
            console.error(err);
            // Force the navigation, this also resets the call count
            location1[replace ? 'replace' : 'assign'](url);
        }
    }
    function replace(to, data) {
        const state = $a809ac530d32f081$var$assign({}, history1.state, $a809ac530d32f081$var$buildState(historyState.value.back, // keep back and forward entries but override current position
        to, historyState.value.forward, true), data, {
            position: historyState.value.position
        });
        changeLocation(to, state, true);
        currentLocation.value = to;
    }
    function push(to, data) {
        // Add to current entry the information of where we are going
        // as well as saving the current position
        const currentState = $a809ac530d32f081$var$assign({}, // use current history state to gracefully handle a wrong call to
        // history.replaceState
        // https://github.com/vuejs/router/issues/366
        historyState.value, history1.state, {
            forward: to,
            scroll: $a809ac530d32f081$var$computeScrollPosition()
        });
        changeLocation(currentState.current, currentState, true);
        const state = $a809ac530d32f081$var$assign({}, $a809ac530d32f081$var$buildState(currentLocation.value, to, null), {
            position: currentState.position + 1
        }, data);
        changeLocation(to, state, false);
        currentLocation.value = to;
    }
    return {
        location: currentLocation,
        state: historyState,
        push: push,
        replace: replace
    };
}
/**
 * Creates an HTML5 history. Most common history for single page applications.
 *
 * @param base -
 */ function $a809ac530d32f081$export$7b4942f78e7b8a49(base) {
    base = $a809ac530d32f081$var$normalizeBase(base);
    const historyNavigation = $a809ac530d32f081$var$useHistoryStateNavigation(base);
    const historyListeners = $a809ac530d32f081$var$useHistoryListeners(base, historyNavigation.state, historyNavigation.location, historyNavigation.replace);
    function go(delta, triggerListeners = true) {
        if (!triggerListeners) historyListeners.pauseListeners();
        history.go(delta);
    }
    const routerHistory = $a809ac530d32f081$var$assign({
        // it's overridden right after
        location: '',
        base: base,
        go: go,
        createHref: $a809ac530d32f081$var$createHref.bind(null, base)
    }, historyNavigation, historyListeners);
    Object.defineProperty(routerHistory, 'location', {
        enumerable: true,
        get: ()=>historyNavigation.location.value
    });
    Object.defineProperty(routerHistory, 'state', {
        enumerable: true,
        get: ()=>historyNavigation.state.value
    });
    return routerHistory;
}
/**
 * Creates an in-memory based history. The main purpose of this history is to handle SSR. It starts in a special location that is nowhere.
 * It's up to the user to replace that location with the starter location by either calling `router.push` or `router.replace`.
 *
 * @param base - Base applied to all urls, defaults to '/'
 * @returns a history object that can be passed to the router constructor
 */ function $a809ac530d32f081$export$2b76ad033c6e6d08(base = '') {
    let listeners = [];
    let queue = [
        $a809ac530d32f081$var$START
    ];
    let position = 0;
    base = $a809ac530d32f081$var$normalizeBase(base);
    function setLocation(location1) {
        position++;
        if (position === queue.length) // we are at the end, we can simply append a new entry
        queue.push(location1);
        else {
            // we are in the middle, we remove everything from here in the queue
            queue.splice(position);
            queue.push(location1);
        }
    }
    function triggerListeners(to, from, { direction: direction, delta: delta }) {
        const info = {
            direction: direction,
            delta: delta,
            type: $a809ac530d32f081$var$NavigationType.pop
        };
        for (const callback of listeners)callback(to, from, info);
    }
    const routerHistory = {
        // rewritten by Object.defineProperty
        location: $a809ac530d32f081$var$START,
        // TODO: should be kept in queue
        state: {},
        base: base,
        createHref: $a809ac530d32f081$var$createHref.bind(null, base),
        replace (to) {
            // remove current entry and decrement position
            queue.splice(position--, 1);
            setLocation(to);
        },
        push (to, data) {
            setLocation(to);
        },
        listen (callback) {
            listeners.push(callback);
            return ()=>{
                const index = listeners.indexOf(callback);
                if (index > -1) listeners.splice(index, 1);
            };
        },
        destroy () {
            listeners = [];
            queue = [
                $a809ac530d32f081$var$START
            ];
            position = 0;
        },
        go (delta, shouldTrigger = true) {
            const from = this.location;
            const direction = // we are considering delta === 0 going forward, but in abstract mode
            // using 0 for the delta doesn't make sense like it does in html5 where
            // it reloads the page
            delta < 0 ? $a809ac530d32f081$var$NavigationDirection.back : $a809ac530d32f081$var$NavigationDirection.forward;
            position = Math.max(0, Math.min(position + delta, queue.length - 1));
            if (shouldTrigger) triggerListeners(this.location, from, {
                direction: direction,
                delta: delta
            });
        }
    };
    Object.defineProperty(routerHistory, 'location', {
        enumerable: true,
        get: ()=>queue[position]
    });
    return routerHistory;
}
/**
 * Creates a hash history. Useful for web applications with no host (e.g. `file://`) or when configuring a server to
 * handle any URL is not possible.
 *
 * @param base - optional base to provide. Defaults to `location.pathname + location.search` If there is a `<base>` tag
 * in the `head`, its value will be ignored in favor of this parameter **but note it affects all the history.pushState()
 * calls**, meaning that if you use a `<base>` tag, it's `href` value **has to match this parameter** (ignoring anything
 * after the `#`).
 *
 * @example
 * ```js
 * // at https://example.com/folder
 * createWebHashHistory() // gives a url of `https://example.com/folder#`
 * createWebHashHistory('/folder/') // gives a url of `https://example.com/folder/#`
 * // if the `#` is provided in the base, it won't be added by `createWebHashHistory`
 * createWebHashHistory('/folder/#/app/') // gives a url of `https://example.com/folder/#/app/`
 * // you should avoid doing this because it changes the original url and breaks copying urls
 * createWebHashHistory('/other-folder/') // gives a url of `https://example.com/other-folder/#`
 *
 * // at file:///usr/etc/folder/index.html
 * // for locations with no `host`, the base is ignored
 * createWebHashHistory('/iAmIgnored') // gives a url of `file:///usr/etc/folder/index.html#`
 * ```
 */ function $a809ac530d32f081$export$542bc3a76486c94d(base) {
    // Make sure this implementation is fine in terms of encoding, specially for IE11
    // for `file://`, directly use the pathname and ignore the base
    // location.pathname contains an initial `/` even at the root: `https://example.com`
    base = location.host ? base || location.pathname + location.search : '';
    // allow the user to provide a `#` in the middle: `/base/#/app`
    if (!base.includes('#')) base += '#';
    return $a809ac530d32f081$export$7b4942f78e7b8a49(base);
}
function $a809ac530d32f081$var$isRouteLocation(route) {
    return typeof route === 'string' || route && typeof route === 'object';
}
function $a809ac530d32f081$var$isRouteName(name) {
    return typeof name === 'string' || typeof name === 'symbol';
}
/**
 * Initial route location where the router is. Can be used in navigation guards
 * to differentiate the initial navigation.
 *
 * @example
 * ```js
 * import { START_LOCATION } from 'vue-router'
 *
 * router.beforeEach((to, from) => {
 *   if (from === START_LOCATION) {
 *     // initial navigation
 *   }
 * })
 * ```
 */ const $a809ac530d32f081$export$e44be9a9779c480b = {
    path: '/',
    name: undefined,
    params: {},
    query: {},
    hash: '',
    fullPath: '/',
    matched: [],
    meta: {},
    redirectedFrom: undefined
};
const $a809ac530d32f081$var$NavigationFailureSymbol = Symbol('');
/**
 * Enumeration with all possible types for navigation failures. Can be passed to
 * {@link isNavigationFailure} to check for specific failures.
 */ var $a809ac530d32f081$export$35710516f95d6a57;
(function(NavigationFailureType) {
    /**
     * An aborted navigation is a navigation that failed because a navigation
     * guard returned `false` or called `next(false)`
     */ NavigationFailureType[NavigationFailureType["aborted"] = 4] = "aborted";
    /**
     * A cancelled navigation is a navigation that failed because a more recent
     * navigation finished started (not necessarily finished).
     */ NavigationFailureType[NavigationFailureType["cancelled"] = 8] = "cancelled";
    /**
     * A duplicated navigation is a navigation that failed because it was
     * initiated while already being at the exact same location.
     */ NavigationFailureType[NavigationFailureType["duplicated"] = 16] = "duplicated";
})($a809ac530d32f081$export$35710516f95d6a57 || ($a809ac530d32f081$export$35710516f95d6a57 = {}));
// DEV only debug messages
const $a809ac530d32f081$var$ErrorTypeMessages = {
    [1 /* ErrorTypes.MATCHER_NOT_FOUND */ ] ({ location: location1, currentLocation: currentLocation }) {
        return `No match for\n ${JSON.stringify(location1)}${currentLocation ? '\nwhile being at\n' + JSON.stringify(currentLocation) : ''}`;
    },
    [2 /* ErrorTypes.NAVIGATION_GUARD_REDIRECT */ ] ({ from: from, to: to }) {
        return `Redirected from "${from.fullPath}" to "${$a809ac530d32f081$var$stringifyRoute(to)}" via a navigation guard.`;
    },
    [4 /* ErrorTypes.NAVIGATION_ABORTED */ ] ({ from: from, to: to }) {
        return `Navigation aborted from "${from.fullPath}" to "${to.fullPath}" via a navigation guard.`;
    },
    [8 /* ErrorTypes.NAVIGATION_CANCELLED */ ] ({ from: from, to: to }) {
        return `Navigation cancelled from "${from.fullPath}" to "${to.fullPath}" with a new navigation.`;
    },
    [16 /* ErrorTypes.NAVIGATION_DUPLICATED */ ] ({ from: from, to: to }) {
        return `Avoided redundant navigation to current location: "${from.fullPath}".`;
    }
};
function $a809ac530d32f081$var$createRouterError(type, params) {
    return $a809ac530d32f081$var$assign(new Error(), {
        type: type,
        [$a809ac530d32f081$var$NavigationFailureSymbol]: true
    }, params);
}
function $a809ac530d32f081$export$873de56207a30e5a(error, type) {
    return error instanceof Error && $a809ac530d32f081$var$NavigationFailureSymbol in error && (type == null || !!(error.type & type));
}
const $a809ac530d32f081$var$propertiesToLog = [
    'params',
    'query',
    'hash'
];
function $a809ac530d32f081$var$stringifyRoute(to) {
    if (typeof to === 'string') return to;
    if ('path' in to) return to.path;
    const location1 = {};
    for (const key of $a809ac530d32f081$var$propertiesToLog)if (key in to) location1[key] = to[key];
    return JSON.stringify(location1, null, 2);
}
// default pattern for a param: non-greedy everything but /
const $a809ac530d32f081$var$BASE_PARAM_PATTERN = '[^/]+?';
const $a809ac530d32f081$var$BASE_PATH_PARSER_OPTIONS = {
    sensitive: false,
    strict: false,
    start: true,
    end: true
};
// Special Regex characters that must be escaped in static tokens
const $a809ac530d32f081$var$REGEX_CHARS_RE = /[.+*?^${}()[\]/\\]/g;
/**
 * Creates a path parser from an array of Segments (a segment is an array of Tokens)
 *
 * @param segments - array of segments returned by tokenizePath
 * @param extraOptions - optional options for the regexp
 * @returns a PathParser
 */ function $a809ac530d32f081$var$tokensToParser(segments, extraOptions) {
    const options = $a809ac530d32f081$var$assign({}, $a809ac530d32f081$var$BASE_PATH_PARSER_OPTIONS, extraOptions);
    // the amount of scores is the same as the length of segments except for the root segment "/"
    const score = [];
    // the regexp as a string
    let pattern = options.start ? '^' : '';
    // extracted keys
    const keys = [];
    for (const segment of segments){
        // the root segment needs special treatment
        const segmentScores = segment.length ? [] : [
            90 /* PathScore.Root */ 
        ];
        // allow trailing slash
        if (options.strict && !segment.length) pattern += '/';
        for(let tokenIndex = 0; tokenIndex < segment.length; tokenIndex++){
            const token = segment[tokenIndex];
            // resets the score if we are inside a sub-segment /:a-other-:b
            let subSegmentScore = 40 /* PathScore.Segment */  + (options.sensitive ? 0.25 /* PathScore.BonusCaseSensitive */  : 0);
            if (token.type === 0 /* TokenType.Static */ ) {
                // prepend the slash if we are starting a new segment
                if (!tokenIndex) pattern += '/';
                pattern += token.value.replace($a809ac530d32f081$var$REGEX_CHARS_RE, '\\$&');
                subSegmentScore += 40 /* PathScore.Static */ ;
            } else if (token.type === 1 /* TokenType.Param */ ) {
                const { value: value, repeatable: repeatable, optional: optional, regexp: regexp } = token;
                keys.push({
                    name: value,
                    repeatable: repeatable,
                    optional: optional
                });
                const re = regexp ? regexp : $a809ac530d32f081$var$BASE_PARAM_PATTERN;
                // the user provided a custom regexp /:id(\\d+)
                if (re !== $a809ac530d32f081$var$BASE_PARAM_PATTERN) {
                    subSegmentScore += 10 /* PathScore.BonusCustomRegExp */ ;
                    // make sure the regexp is valid before using it
                    try {
                        new RegExp(`(${re})`);
                    } catch (err) {
                        throw new Error(`Invalid custom RegExp for param "${value}" (${re}): ` + err.message);
                    }
                }
                // when we repeat we must take care of the repeating leading slash
                let subPattern = repeatable ? `((?:${re})(?:/(?:${re}))*)` : `(${re})`;
                // prepend the slash if we are starting a new segment
                if (!tokenIndex) subPattern = // avoid an optional / if there are more segments e.g. /:p?-static
                // or /:p?-:p2
                optional && segment.length < 2 ? `(?:/${subPattern})` : '/' + subPattern;
                if (optional) subPattern += '?';
                pattern += subPattern;
                subSegmentScore += 20 /* PathScore.Dynamic */ ;
                if (optional) subSegmentScore += -8 /* PathScore.BonusOptional */ ;
                if (repeatable) subSegmentScore += -20 /* PathScore.BonusRepeatable */ ;
                if (re === '.*') subSegmentScore += -50 /* PathScore.BonusWildcard */ ;
            }
            segmentScores.push(subSegmentScore);
        }
        // an empty array like /home/ -> [[{home}], []]
        // if (!segment.length) pattern += '/'
        score.push(segmentScores);
    }
    // only apply the strict bonus to the last score
    if (options.strict && options.end) {
        const i = score.length - 1;
        score[i][score[i].length - 1] += 0.7000000000000001 /* PathScore.BonusStrict */ ;
    }
    // TODO: dev only warn double trailing slash
    if (!options.strict) pattern += '/?';
    if (options.end) pattern += '$';
    else if (options.strict) pattern += '(?:/|$)';
    const re = new RegExp(pattern, options.sensitive ? '' : 'i');
    function parse(path) {
        const match = path.match(re);
        const params = {};
        if (!match) return null;
        for(let i = 1; i < match.length; i++){
            const value = match[i] || '';
            const key = keys[i - 1];
            params[key.name] = value && key.repeatable ? value.split('/') : value;
        }
        return params;
    }
    function stringify(params) {
        let path = '';
        // for optional parameters to allow to be empty
        let avoidDuplicatedSlash = false;
        for (const segment of segments){
            if (!avoidDuplicatedSlash || !path.endsWith('/')) path += '/';
            avoidDuplicatedSlash = false;
            for (const token of segment){
                if (token.type === 0 /* TokenType.Static */ ) path += token.value;
                else if (token.type === 1 /* TokenType.Param */ ) {
                    const { value: value, repeatable: repeatable, optional: optional } = token;
                    const param = value in params ? params[value] : '';
                    if ($a809ac530d32f081$var$isArray(param) && !repeatable) throw new Error(`Provided param "${value}" is an array but it is not repeatable (* or + modifiers)`);
                    const text = $a809ac530d32f081$var$isArray(param) ? param.join('/') : param;
                    if (!text) {
                        if (optional) // if we have more than one optional param like /:a?-static we don't need to care about the optional param
                        {
                            if (segment.length < 2) {
                                // remove the last slash as we could be at the end
                                if (path.endsWith('/')) path = path.slice(0, -1);
                                else avoidDuplicatedSlash = true;
                            }
                        } else throw new Error(`Missing required param "${value}"`);
                    }
                    path += text;
                }
            }
        }
        // avoid empty path when we have multiple optional params
        return path || '/';
    }
    return {
        re: re,
        score: score,
        keys: keys,
        parse: parse,
        stringify: stringify
    };
}
/**
 * Compares an array of numbers as used in PathParser.score and returns a
 * number. This function can be used to `sort` an array
 *
 * @param a - first array of numbers
 * @param b - second array of numbers
 * @returns 0 if both are equal, < 0 if a should be sorted first, > 0 if b
 * should be sorted first
 */ function $a809ac530d32f081$var$compareScoreArray(a, b) {
    let i = 0;
    while(i < a.length && i < b.length){
        const diff = b[i] - a[i];
        // only keep going if diff === 0
        if (diff) return diff;
        i++;
    }
    // if the last subsegment was Static, the shorter segments should be sorted first
    // otherwise sort the longest segment first
    if (a.length < b.length) return a.length === 1 && a[0] === 80 /* PathScore.Segment */  ? -1 : 1;
    else if (a.length > b.length) return b.length === 1 && b[0] === 80 /* PathScore.Segment */  ? 1 : -1;
    return 0;
}
/**
 * Compare function that can be used with `sort` to sort an array of PathParser
 *
 * @param a - first PathParser
 * @param b - second PathParser
 * @returns 0 if both are equal, < 0 if a should be sorted first, > 0 if b
 */ function $a809ac530d32f081$var$comparePathParserScore(a, b) {
    let i = 0;
    const aScore = a.score;
    const bScore = b.score;
    while(i < aScore.length && i < bScore.length){
        const comp = $a809ac530d32f081$var$compareScoreArray(aScore[i], bScore[i]);
        // do not return if both are equal
        if (comp) return comp;
        i++;
    }
    if (Math.abs(bScore.length - aScore.length) === 1) {
        if ($a809ac530d32f081$var$isLastScoreNegative(aScore)) return 1;
        if ($a809ac530d32f081$var$isLastScoreNegative(bScore)) return -1;
    }
    // if a and b share the same score entries but b has more, sort b first
    return bScore.length - aScore.length;
// this is the ternary version
// return aScore.length < bScore.length
//   ? 1
//   : aScore.length > bScore.length
//   ? -1
//   : 0
}
/**
 * This allows detecting splats at the end of a path: /home/:id(.*)*
 *
 * @param score - score to check
 * @returns true if the last entry is negative
 */ function $a809ac530d32f081$var$isLastScoreNegative(score) {
    const last = score[score.length - 1];
    return score.length > 0 && last[last.length - 1] < 0;
}
const $a809ac530d32f081$var$ROOT_TOKEN = {
    type: 0 /* TokenType.Static */ ,
    value: ''
};
const $a809ac530d32f081$var$VALID_PARAM_RE = /[a-zA-Z0-9_]/;
// After some profiling, the cache seems to be unnecessary because tokenizePath
// (the slowest part of adding a route) is very fast
// const tokenCache = new Map<string, Token[][]>()
function $a809ac530d32f081$var$tokenizePath(path) {
    if (!path) return [
        []
    ];
    if (path === '/') return [
        [
            $a809ac530d32f081$var$ROOT_TOKEN
        ]
    ];
    if (!path.startsWith('/')) throw new Error(`Invalid path "${path}"`);
    // if (tokenCache.has(path)) return tokenCache.get(path)!
    function crash(message) {
        throw new Error(`ERR (${state})/"${buffer}": ${message}`);
    }
    let state = 0 /* TokenizerState.Static */ ;
    let previousState = state;
    const tokens = [];
    // the segment will always be valid because we get into the initial state
    // with the leading /
    let segment;
    function finalizeSegment() {
        if (segment) tokens.push(segment);
        segment = [];
    }
    // index on the path
    let i = 0;
    // char at index
    let char;
    // buffer of the value read
    let buffer = '';
    // custom regexp for a param
    let customRe = '';
    function consumeBuffer() {
        if (!buffer) return;
        if (state === 0 /* TokenizerState.Static */ ) segment.push({
            type: 0 /* TokenType.Static */ ,
            value: buffer
        });
        else if (state === 1 /* TokenizerState.Param */  || state === 2 /* TokenizerState.ParamRegExp */  || state === 3 /* TokenizerState.ParamRegExpEnd */ ) {
            if (segment.length > 1 && (char === '*' || char === '+')) crash(`A repeatable param (${buffer}) must be alone in its segment. eg: '/:ids+.`);
            segment.push({
                type: 1 /* TokenType.Param */ ,
                value: buffer,
                regexp: customRe,
                repeatable: char === '*' || char === '+',
                optional: char === '*' || char === '?'
            });
        } else crash('Invalid state to consume buffer');
        buffer = '';
    }
    function addCharToBuffer() {
        buffer += char;
    }
    while(i < path.length){
        char = path[i++];
        if (char === '\\' && state !== 2 /* TokenizerState.ParamRegExp */ ) {
            previousState = state;
            state = 4 /* TokenizerState.EscapeNext */ ;
            continue;
        }
        switch(state){
            case 0 /* TokenizerState.Static */ :
                if (char === '/') {
                    if (buffer) consumeBuffer();
                    finalizeSegment();
                } else if (char === ':') {
                    consumeBuffer();
                    state = 1 /* TokenizerState.Param */ ;
                } else addCharToBuffer();
                break;
            case 4 /* TokenizerState.EscapeNext */ :
                addCharToBuffer();
                state = previousState;
                break;
            case 1 /* TokenizerState.Param */ :
                if (char === '(') state = 2 /* TokenizerState.ParamRegExp */ ;
                else if ($a809ac530d32f081$var$VALID_PARAM_RE.test(char)) addCharToBuffer();
                else {
                    consumeBuffer();
                    state = 0 /* TokenizerState.Static */ ;
                    // go back one character if we were not modifying
                    if (char !== '*' && char !== '?' && char !== '+') i--;
                }
                break;
            case 2 /* TokenizerState.ParamRegExp */ :
                // TODO: is it worth handling nested regexp? like :p(?:prefix_([^/]+)_suffix)
                // it already works by escaping the closing )
                // https://paths.esm.dev/?p=AAMeJbiAwQEcDKbAoAAkP60PG2R6QAvgNaA6AFACM2ABuQBB#
                // is this really something people need since you can also write
                // /prefix_:p()_suffix
                if (char === ')') {
                    // handle the escaped )
                    if (customRe[customRe.length - 1] == '\\') customRe = customRe.slice(0, -1) + char;
                    else state = 3 /* TokenizerState.ParamRegExpEnd */ ;
                } else customRe += char;
                break;
            case 3 /* TokenizerState.ParamRegExpEnd */ :
                // same as finalizing a param
                consumeBuffer();
                state = 0 /* TokenizerState.Static */ ;
                // go back one character if we were not modifying
                if (char !== '*' && char !== '?' && char !== '+') i--;
                customRe = '';
                break;
            default:
                crash('Unknown state');
                break;
        }
    }
    if (state === 2 /* TokenizerState.ParamRegExp */ ) crash(`Unfinished custom RegExp for param "${buffer}"`);
    consumeBuffer();
    finalizeSegment();
    // tokenCache.set(path, tokens)
    return tokens;
}
function $a809ac530d32f081$var$createRouteRecordMatcher(record, parent, options) {
    const parser = $a809ac530d32f081$var$tokensToParser($a809ac530d32f081$var$tokenizePath(record.path), options);
    const matcher = $a809ac530d32f081$var$assign(parser, {
        record: record,
        parent: parent,
        // these needs to be populated by the parent
        children: [],
        alias: []
    });
    if (parent) // both are aliases or both are not aliases
    // we don't want to mix them because the order is used when
    // passing originalRecord in Matcher.addRoute
    {
        if (!matcher.record.aliasOf === !parent.record.aliasOf) parent.children.push(matcher);
    }
    return matcher;
}
/**
 * Creates a Router Matcher.
 *
 * @internal
 * @param routes - array of initial routes
 * @param globalOptions - global route options
 */ function $a809ac530d32f081$export$36302c85fdcc95a8(routes, globalOptions) {
    // normalized ordered array of matchers
    const matchers = [];
    const matcherMap = new Map();
    globalOptions = $a809ac530d32f081$var$mergeOptions({
        strict: false,
        end: true,
        sensitive: false
    }, globalOptions);
    function getRecordMatcher(name) {
        return matcherMap.get(name);
    }
    function addRoute(record, parent, originalRecord) {
        // used later on to remove by name
        const isRootAdd = !originalRecord;
        const mainNormalizedRecord = $a809ac530d32f081$var$normalizeRouteRecord(record);
        // we might be the child of an alias
        mainNormalizedRecord.aliasOf = originalRecord && originalRecord.record;
        const options = $a809ac530d32f081$var$mergeOptions(globalOptions, record);
        // generate an array of records to correctly handle aliases
        const normalizedRecords = [
            mainNormalizedRecord
        ];
        if ('alias' in record) {
            const aliases = typeof record.alias === 'string' ? [
                record.alias
            ] : record.alias;
            for (const alias of aliases)normalizedRecords.push($a809ac530d32f081$var$assign({}, mainNormalizedRecord, {
                // this allows us to hold a copy of the `components` option
                // so that async components cache is hold on the original record
                components: originalRecord ? originalRecord.record.components : mainNormalizedRecord.components,
                path: alias,
                // we might be the child of an alias
                aliasOf: originalRecord ? originalRecord.record : mainNormalizedRecord
            }));
        }
        let matcher;
        let originalMatcher;
        for (const normalizedRecord of normalizedRecords){
            const { path: path } = normalizedRecord;
            // Build up the path for nested routes if the child isn't an absolute
            // route. Only add the / delimiter if the child path isn't empty and if the
            // parent path doesn't have a trailing slash
            if (parent && path[0] !== '/') {
                const parentPath = parent.record.path;
                const connectingSlash = parentPath[parentPath.length - 1] === '/' ? '' : '/';
                normalizedRecord.path = parent.record.path + (path && connectingSlash + path);
            }
            // create the object beforehand, so it can be passed to children
            matcher = $a809ac530d32f081$var$createRouteRecordMatcher(normalizedRecord, parent, options);
            // if we are an alias we must tell the original record that we exist,
            // so we can be removed
            if (originalRecord) originalRecord.alias.push(matcher);
            else {
                // otherwise, the first record is the original and others are aliases
                originalMatcher = originalMatcher || matcher;
                if (originalMatcher !== matcher) originalMatcher.alias.push(matcher);
                // remove the route if named and only for the top record (avoid in nested calls)
                // this works because the original record is the first one
                if (isRootAdd && record.name && !$a809ac530d32f081$var$isAliasRecord(matcher)) removeRoute(record.name);
            }
            if (mainNormalizedRecord.children) {
                const children = mainNormalizedRecord.children;
                for(let i = 0; i < children.length; i++)addRoute(children[i], matcher, originalRecord && originalRecord.children[i]);
            }
            // if there was no original record, then the first one was not an alias and all
            // other aliases (if any) need to reference this record when adding children
            originalRecord = originalRecord || matcher;
            // TODO: add normalized records for more flexibility
            // if (parent && isAliasRecord(originalRecord)) {
            //   parent.children.push(originalRecord)
            // }
            insertMatcher(matcher);
        }
        return originalMatcher ? ()=>{
            // since other matchers are aliases, they should be removed by the original matcher
            removeRoute(originalMatcher);
        } : $a809ac530d32f081$var$noop;
    }
    function removeRoute(matcherRef) {
        if ($a809ac530d32f081$var$isRouteName(matcherRef)) {
            const matcher = matcherMap.get(matcherRef);
            if (matcher) {
                matcherMap.delete(matcherRef);
                matchers.splice(matchers.indexOf(matcher), 1);
                matcher.children.forEach(removeRoute);
                matcher.alias.forEach(removeRoute);
            }
        } else {
            const index = matchers.indexOf(matcherRef);
            if (index > -1) {
                matchers.splice(index, 1);
                if (matcherRef.record.name) matcherMap.delete(matcherRef.record.name);
                matcherRef.children.forEach(removeRoute);
                matcherRef.alias.forEach(removeRoute);
            }
        }
    }
    function getRoutes() {
        return matchers;
    }
    function insertMatcher(matcher) {
        let i = 0;
        while(i < matchers.length && $a809ac530d32f081$var$comparePathParserScore(matcher, matchers[i]) >= 0 && // Adding children with empty path should still appear before the parent
        // https://github.com/vuejs/router/issues/1124
        (matcher.record.path !== matchers[i].record.path || !$a809ac530d32f081$var$isRecordChildOf(matcher, matchers[i])))i++;
        matchers.splice(i, 0, matcher);
        // only add the original record to the name map
        if (matcher.record.name && !$a809ac530d32f081$var$isAliasRecord(matcher)) matcherMap.set(matcher.record.name, matcher);
    }
    function resolve(location1, currentLocation) {
        let matcher;
        let params = {};
        let path;
        let name;
        if ('name' in location1 && location1.name) {
            matcher = matcherMap.get(location1.name);
            if (!matcher) throw $a809ac530d32f081$var$createRouterError(1 /* ErrorTypes.MATCHER_NOT_FOUND */ , {
                location: location1
            });
            name = matcher.record.name;
            params = $a809ac530d32f081$var$assign(// paramsFromLocation is a new object
            $a809ac530d32f081$var$paramsFromLocation(currentLocation.params, // only keep params that exist in the resolved location
            // TODO: only keep optional params coming from a parent record
            matcher.keys.filter((k)=>!k.optional).map((k)=>k.name)), // discard any existing params in the current location that do not exist here
            // #1497 this ensures better active/exact matching
            location1.params && $a809ac530d32f081$var$paramsFromLocation(location1.params, matcher.keys.map((k)=>k.name)));
            // throws if cannot be stringified
            path = matcher.stringify(params);
        } else if ('path' in location1) {
            // no need to resolve the path with the matcher as it was provided
            // this also allows the user to control the encoding
            path = location1.path;
            matcher = matchers.find((m)=>m.re.test(path));
            // matcher should have a value after the loop
            if (matcher) {
                // we know the matcher works because we tested the regexp
                params = matcher.parse(path);
                name = matcher.record.name;
            }
        // location is a relative path
        } else {
            // match by name or path of current route
            matcher = currentLocation.name ? matcherMap.get(currentLocation.name) : matchers.find((m)=>m.re.test(currentLocation.path));
            if (!matcher) throw $a809ac530d32f081$var$createRouterError(1 /* ErrorTypes.MATCHER_NOT_FOUND */ , {
                location: location1,
                currentLocation: currentLocation
            });
            name = matcher.record.name;
            // since we are navigating to the same location, we don't need to pick the
            // params like when `name` is provided
            params = $a809ac530d32f081$var$assign({}, currentLocation.params, location1.params);
            path = matcher.stringify(params);
        }
        const matched = [];
        let parentMatcher = matcher;
        while(parentMatcher){
            // reversed order so parents are at the beginning
            matched.unshift(parentMatcher.record);
            parentMatcher = parentMatcher.parent;
        }
        return {
            name: name,
            path: path,
            params: params,
            matched: matched,
            meta: $a809ac530d32f081$var$mergeMetaFields(matched)
        };
    }
    // add initial routes
    routes.forEach((route)=>addRoute(route));
    return {
        addRoute: addRoute,
        resolve: resolve,
        removeRoute: removeRoute,
        getRoutes: getRoutes,
        getRecordMatcher: getRecordMatcher
    };
}
function $a809ac530d32f081$var$paramsFromLocation(params, keys) {
    const newParams = {};
    for (const key of keys)if (key in params) newParams[key] = params[key];
    return newParams;
}
/**
 * Normalizes a RouteRecordRaw. Creates a copy
 *
 * @param record
 * @returns the normalized version
 */ function $a809ac530d32f081$var$normalizeRouteRecord(record) {
    return {
        path: record.path,
        redirect: record.redirect,
        name: record.name,
        meta: record.meta || {},
        aliasOf: undefined,
        beforeEnter: record.beforeEnter,
        props: $a809ac530d32f081$var$normalizeRecordProps(record),
        children: record.children || [],
        instances: {},
        leaveGuards: new Set(),
        updateGuards: new Set(),
        enterCallbacks: {},
        components: 'components' in record ? record.components || null : record.component && {
            default: record.component
        }
    };
}
/**
 * Normalize the optional `props` in a record to always be an object similar to
 * components. Also accept a boolean for components.
 * @param record
 */ function $a809ac530d32f081$var$normalizeRecordProps(record) {
    const propsObject = {};
    // props does not exist on redirect records, but we can set false directly
    const props = record.props || false;
    if ('component' in record) propsObject.default = props;
    else // NOTE: we could also allow a function to be applied to every component.
    // Would need user feedback for use cases
    for(const name in record.components)propsObject[name] = typeof props === 'boolean' ? props : props[name];
    return propsObject;
}
/**
 * Checks if a record or any of its parent is an alias
 * @param record
 */ function $a809ac530d32f081$var$isAliasRecord(record) {
    while(record){
        if (record.record.aliasOf) return true;
        record = record.parent;
    }
    return false;
}
/**
 * Merge meta fields of an array of records
 *
 * @param matched - array of matched records
 */ function $a809ac530d32f081$var$mergeMetaFields(matched) {
    return matched.reduce((meta, record)=>$a809ac530d32f081$var$assign(meta, record.meta), {});
}
function $a809ac530d32f081$var$mergeOptions(defaults, partialOptions) {
    const options = {};
    for(const key in defaults)options[key] = key in partialOptions ? partialOptions[key] : defaults[key];
    return options;
}
function $a809ac530d32f081$var$isSameParam(a, b) {
    return a.name === b.name && a.optional === b.optional && a.repeatable === b.repeatable;
}
/**
 * Check if a path and its alias have the same required params
 *
 * @param a - original record
 * @param b - alias record
 */ function $a809ac530d32f081$var$checkSameParams(a, b) {
    for (const key of a.keys){
        if (!key.optional && !b.keys.find($a809ac530d32f081$var$isSameParam.bind(null, key))) return $a809ac530d32f081$var$warn(`Alias "${b.record.path}" and the original record: "${a.record.path}" must have the exact same param named "${key.name}"`);
    }
    for (const key of b.keys){
        if (!key.optional && !a.keys.find($a809ac530d32f081$var$isSameParam.bind(null, key))) return $a809ac530d32f081$var$warn(`Alias "${b.record.path}" and the original record: "${a.record.path}" must have the exact same param named "${key.name}"`);
    }
}
/**
 * A route with a name and a child with an empty path without a name should warn when adding the route
 *
 * @param mainNormalizedRecord - RouteRecordNormalized
 * @param parent - RouteRecordMatcher
 */ function $a809ac530d32f081$var$checkChildMissingNameWithEmptyPath(mainNormalizedRecord, parent) {
    if (parent && parent.record.name && !mainNormalizedRecord.name && !mainNormalizedRecord.path) $a809ac530d32f081$var$warn(`The route named "${String(parent.record.name)}" has a child without a name and an empty path. Using that name won't render the empty path child so you probably want to move the name to the child instead. If this is intentional, add a name to the child route to remove the warning.`);
}
function $a809ac530d32f081$var$checkMissingParamsInAbsolutePath(record, parent) {
    for (const key of parent.keys){
        if (!record.keys.find($a809ac530d32f081$var$isSameParam.bind(null, key))) return $a809ac530d32f081$var$warn(`Absolute path "${record.record.path}" must have the exact same param named "${key.name}" as its parent "${parent.record.path}".`);
    }
}
function $a809ac530d32f081$var$isRecordChildOf(record, parent) {
    return parent.children.some((child)=>child === record || $a809ac530d32f081$var$isRecordChildOf(record, child));
}
/**
 * Encoding Rules ␣ = Space Path: ␣ " < > # ? { } Query: ␣ " < > # & = Hash: ␣ "
 * < > `
 *
 * On top of that, the RFC3986 (https://tools.ietf.org/html/rfc3986#section-2.2)
 * defines some extra characters to be encoded. Most browsers do not encode them
 * in encodeURI https://github.com/whatwg/url/issues/369, so it may be safer to
 * also encode `!'()*`. Leaving un-encoded only ASCII alphanumeric(`a-zA-Z0-9`)
 * plus `-._~`. This extra safety should be applied to query by patching the
 * string returned by encodeURIComponent encodeURI also encodes `[\]^`. `\`
 * should be encoded to avoid ambiguity. Browsers (IE, FF, C) transform a `\`
 * into a `/` if directly typed in. The _backtick_ (`````) should also be
 * encoded everywhere because some browsers like FF encode it when directly
 * written while others don't. Safari and IE don't encode ``"<>{}``` in hash.
 */ // const EXTRA_RESERVED_RE = /[!'()*]/g
// const encodeReservedReplacer = (c: string) => '%' + c.charCodeAt(0).toString(16)
const $a809ac530d32f081$var$HASH_RE = /#/g; // %23
const $a809ac530d32f081$var$AMPERSAND_RE = /&/g; // %26
const $a809ac530d32f081$var$SLASH_RE = /\//g; // %2F
const $a809ac530d32f081$var$EQUAL_RE = /=/g; // %3D
const $a809ac530d32f081$var$IM_RE = /\?/g; // %3F
const $a809ac530d32f081$var$PLUS_RE = /\+/g; // %2B
/**
 * NOTE: It's not clear to me if we should encode the + symbol in queries, it
 * seems to be less flexible than not doing so and I can't find out the legacy
 * systems requiring this for regular requests like text/html. In the standard,
 * the encoding of the plus character is only mentioned for
 * application/x-www-form-urlencoded
 * (https://url.spec.whatwg.org/#urlencoded-parsing) and most browsers seems lo
 * leave the plus character as is in queries. To be more flexible, we allow the
 * plus character on the query, but it can also be manually encoded by the user.
 *
 * Resources:
 * - https://url.spec.whatwg.org/#urlencoded-parsing
 * - https://stackoverflow.com/questions/1634271/url-encoding-the-space-character-or-20
 */ const $a809ac530d32f081$var$ENC_BRACKET_OPEN_RE = /%5B/g; // [
const $a809ac530d32f081$var$ENC_BRACKET_CLOSE_RE = /%5D/g; // ]
const $a809ac530d32f081$var$ENC_CARET_RE = /%5E/g; // ^
const $a809ac530d32f081$var$ENC_BACKTICK_RE = /%60/g; // `
const $a809ac530d32f081$var$ENC_CURLY_OPEN_RE = /%7B/g; // {
const $a809ac530d32f081$var$ENC_PIPE_RE = /%7C/g; // |
const $a809ac530d32f081$var$ENC_CURLY_CLOSE_RE = /%7D/g; // }
const $a809ac530d32f081$var$ENC_SPACE_RE = /%20/g; // }
/**
 * Encode characters that need to be encoded on the path, search and hash
 * sections of the URL.
 *
 * @internal
 * @param text - string to encode
 * @returns encoded string
 */ function $a809ac530d32f081$var$commonEncode(text) {
    return encodeURI('' + text).replace($a809ac530d32f081$var$ENC_PIPE_RE, '|').replace($a809ac530d32f081$var$ENC_BRACKET_OPEN_RE, '[').replace($a809ac530d32f081$var$ENC_BRACKET_CLOSE_RE, ']');
}
/**
 * Encode characters that need to be encoded on the hash section of the URL.
 *
 * @param text - string to encode
 * @returns encoded string
 */ function $a809ac530d32f081$var$encodeHash(text) {
    return $a809ac530d32f081$var$commonEncode(text).replace($a809ac530d32f081$var$ENC_CURLY_OPEN_RE, '{').replace($a809ac530d32f081$var$ENC_CURLY_CLOSE_RE, '}').replace($a809ac530d32f081$var$ENC_CARET_RE, '^');
}
/**
 * Encode characters that need to be encoded query values on the query
 * section of the URL.
 *
 * @param text - string to encode
 * @returns encoded string
 */ function $a809ac530d32f081$var$encodeQueryValue(text) {
    return $a809ac530d32f081$var$commonEncode(text)// Encode the space as +, encode the + to differentiate it from the space
    .replace($a809ac530d32f081$var$PLUS_RE, '%2B').replace($a809ac530d32f081$var$ENC_SPACE_RE, '+').replace($a809ac530d32f081$var$HASH_RE, '%23').replace($a809ac530d32f081$var$AMPERSAND_RE, '%26').replace($a809ac530d32f081$var$ENC_BACKTICK_RE, '`').replace($a809ac530d32f081$var$ENC_CURLY_OPEN_RE, '{').replace($a809ac530d32f081$var$ENC_CURLY_CLOSE_RE, '}').replace($a809ac530d32f081$var$ENC_CARET_RE, '^');
}
/**
 * Like `encodeQueryValue` but also encodes the `=` character.
 *
 * @param text - string to encode
 */ function $a809ac530d32f081$var$encodeQueryKey(text) {
    return $a809ac530d32f081$var$encodeQueryValue(text).replace($a809ac530d32f081$var$EQUAL_RE, '%3D');
}
/**
 * Encode characters that need to be encoded on the path section of the URL.
 *
 * @param text - string to encode
 * @returns encoded string
 */ function $a809ac530d32f081$var$encodePath(text) {
    return $a809ac530d32f081$var$commonEncode(text).replace($a809ac530d32f081$var$HASH_RE, '%23').replace($a809ac530d32f081$var$IM_RE, '%3F');
}
/**
 * Encode characters that need to be encoded on the path section of the URL as a
 * param. This function encodes everything {@link encodePath} does plus the
 * slash (`/`) character. If `text` is `null` or `undefined`, returns an empty
 * string instead.
 *
 * @param text - string to encode
 * @returns encoded string
 */ function $a809ac530d32f081$var$encodeParam(text) {
    return text == null ? '' : $a809ac530d32f081$var$encodePath(text).replace($a809ac530d32f081$var$SLASH_RE, '%2F');
}
/**
 * Decode text using `decodeURIComponent`. Returns the original text if it
 * fails.
 *
 * @param text - string to decode
 * @returns decoded string
 */ function $a809ac530d32f081$var$decode(text) {
    try {
        return decodeURIComponent('' + text);
    } catch (err) {}
    return '' + text;
}
/**
 * Transforms a queryString into a {@link LocationQuery} object. Accept both, a
 * version with the leading `?` and without Should work as URLSearchParams

 * @internal
 *
 * @param search - search string to parse
 * @returns a query object
 */ function $a809ac530d32f081$export$1e8473eaf75b0d10(search) {
    const query = {};
    // avoid creating an object with an empty key and empty value
    // because of split('&')
    if (search === '' || search === '?') return query;
    const hasLeadingIM = search[0] === '?';
    const searchParams = (hasLeadingIM ? search.slice(1) : search).split('&');
    for(let i = 0; i < searchParams.length; ++i){
        // pre decode the + into space
        const searchParam = searchParams[i].replace($a809ac530d32f081$var$PLUS_RE, ' ');
        // allow the = character
        const eqPos = searchParam.indexOf('=');
        const key = $a809ac530d32f081$var$decode(eqPos < 0 ? searchParam : searchParam.slice(0, eqPos));
        const value = eqPos < 0 ? null : $a809ac530d32f081$var$decode(searchParam.slice(eqPos + 1));
        if (key in query) {
            // an extra variable for ts types
            let currentValue = query[key];
            if (!$a809ac530d32f081$var$isArray(currentValue)) currentValue = query[key] = [
                currentValue
            ];
            currentValue.push(value);
        } else query[key] = value;
    }
    return query;
}
/**
 * Stringifies a {@link LocationQueryRaw} object. Like `URLSearchParams`, it
 * doesn't prepend a `?`
 *
 * @internal
 *
 * @param query - query object to stringify
 * @returns string version of the query without the leading `?`
 */ function $a809ac530d32f081$export$d33b45a8f796a30(query) {
    let search = '';
    for(let key in query){
        const value = query[key];
        key = $a809ac530d32f081$var$encodeQueryKey(key);
        if (value == null) {
            // only null adds the value
            if (value !== undefined) search += (search.length ? '&' : '') + key;
            continue;
        }
        // keep null values
        const values = $a809ac530d32f081$var$isArray(value) ? value.map((v)=>v && $a809ac530d32f081$var$encodeQueryValue(v)) : [
            value && $a809ac530d32f081$var$encodeQueryValue(value)
        ];
        values.forEach((value)=>{
            // skip undefined values in arrays as if they were not present
            // smaller code than using filter
            if (value !== undefined) {
                // only append & with non-empty search
                search += (search.length ? '&' : '') + key;
                if (value != null) search += '=' + value;
            }
        });
    }
    return search;
}
/**
 * Transforms a {@link LocationQueryRaw} into a {@link LocationQuery} by casting
 * numbers into strings, removing keys with an undefined value and replacing
 * undefined with null in arrays
 *
 * @param query - query object to normalize
 * @returns a normalized query object
 */ function $a809ac530d32f081$var$normalizeQuery(query) {
    const normalizedQuery = {};
    for(const key in query){
        const value = query[key];
        if (value !== undefined) normalizedQuery[key] = $a809ac530d32f081$var$isArray(value) ? value.map((v)=>v == null ? null : '' + v) : value == null ? value : '' + value;
    }
    return normalizedQuery;
}
/**
 * RouteRecord being rendered by the closest ancestor Router View. Used for
 * `onBeforeRouteUpdate` and `onBeforeRouteLeave`. rvlm stands for Router View
 * Location Matched
 *
 * @internal
 */ const $a809ac530d32f081$export$7f4879db1558672d = Symbol('');
/**
 * Allows overriding the router view depth to control which component in
 * `matched` is rendered. rvd stands for Router View Depth
 *
 * @internal
 */ const $a809ac530d32f081$export$9b3825c34ca1427a = Symbol('');
/**
 * Allows overriding the router instance returned by `useRouter` in tests. r
 * stands for router
 *
 * @internal
 */ const $a809ac530d32f081$export$b6c0da8b9dae491f = Symbol('');
/**
 * Allows overriding the current route returned by `useRoute` in tests. rl
 * stands for route location
 *
 * @internal
 */ const $a809ac530d32f081$export$3aca783e9a3e6e9e = Symbol('');
/**
 * Allows overriding the current route used by router-view. Internally this is
 * used when the `route` prop is passed.
 *
 * @internal
 */ const $a809ac530d32f081$export$54c8124bead129f8 = Symbol('');
/**
 * Create a list of callbacks that can be reset. Used to create before and after navigation guards list
 */ function $a809ac530d32f081$var$useCallbacks() {
    let handlers = [];
    function add(handler) {
        handlers.push(handler);
        return ()=>{
            const i = handlers.indexOf(handler);
            if (i > -1) handlers.splice(i, 1);
        };
    }
    function reset() {
        handlers = [];
    }
    return {
        add: add,
        list: ()=>handlers,
        reset: reset
    };
}
function $a809ac530d32f081$var$registerGuard(record, name, guard) {
    const removeFromList = ()=>{
        record[name].delete(guard);
    };
    (0, $TusQn.onUnmounted)(removeFromList);
    (0, $TusQn.onDeactivated)(removeFromList);
    (0, $TusQn.onActivated)(()=>{
        record[name].add(guard);
    });
    record[name].add(guard);
}
/**
 * Add a navigation guard that triggers whenever the component for the current
 * location is about to be left. Similar to {@link beforeRouteLeave} but can be
 * used in any component. The guard is removed when the component is unmounted.
 *
 * @param leaveGuard - {@link NavigationGuard}
 */ function $a809ac530d32f081$export$d7fcdd004b009a9e(leaveGuard) {
    const activeRecord = (0, $TusQn.inject)($a809ac530d32f081$export$7f4879db1558672d, // to avoid warning
    {}).value;
    if (!activeRecord) return;
    $a809ac530d32f081$var$registerGuard(activeRecord, 'leaveGuards', leaveGuard);
}
/**
 * Add a navigation guard that triggers whenever the current location is about
 * to be updated. Similar to {@link beforeRouteUpdate} but can be used in any
 * component. The guard is removed when the component is unmounted.
 *
 * @param updateGuard - {@link NavigationGuard}
 */ function $a809ac530d32f081$export$46b4cb99461f4cc7(updateGuard) {
    const activeRecord = (0, $TusQn.inject)($a809ac530d32f081$export$7f4879db1558672d, // to avoid warning
    {}).value;
    if (!activeRecord) return;
    $a809ac530d32f081$var$registerGuard(activeRecord, 'updateGuards', updateGuard);
}
function $a809ac530d32f081$var$guardToPromiseFn(guard, to, from, record, name) {
    // keep a reference to the enterCallbackArray to prevent pushing callbacks if a new navigation took place
    const enterCallbackArray = record && // name is defined if record is because of the function overload
    (record.enterCallbacks[name] = record.enterCallbacks[name] || []);
    return ()=>new Promise((resolve, reject)=>{
            const next = (valid)=>{
                if (valid === false) reject($a809ac530d32f081$var$createRouterError(4 /* ErrorTypes.NAVIGATION_ABORTED */ , {
                    from: from,
                    to: to
                }));
                else if (valid instanceof Error) reject(valid);
                else if ($a809ac530d32f081$var$isRouteLocation(valid)) reject($a809ac530d32f081$var$createRouterError(2 /* ErrorTypes.NAVIGATION_GUARD_REDIRECT */ , {
                    from: to,
                    to: valid
                }));
                else {
                    if (enterCallbackArray && // since enterCallbackArray is truthy, both record and name also are
                    record.enterCallbacks[name] === enterCallbackArray && typeof valid === 'function') enterCallbackArray.push(valid);
                    resolve();
                }
            };
            // wrapping with Promise.resolve allows it to work with both async and sync guards
            const guardReturn = guard.call(record && record.instances[name], to, from, next);
            let guardCall = Promise.resolve(guardReturn);
            if (guard.length < 3) guardCall = guardCall.then(next);
            var resolvedValue;
            guardCall.catch((err)=>reject(err));
        });
}
function $a809ac530d32f081$var$canOnlyBeCalledOnce(next, to, from) {
    let called = 0;
    return function() {
        if (called++ === 1) $a809ac530d32f081$var$warn(`The "next" callback was called more than once in one navigation guard when going from "${from.fullPath}" to "${to.fullPath}". It should be called exactly one time in each navigation guard. This will fail in production.`);
        // @ts-expect-error: we put it in the original one because it's easier to check
        next._called = true;
        if (called === 1) next.apply(null, arguments);
    };
}
function $a809ac530d32f081$var$extractComponentsGuards(matched, guardType, to, from) {
    const guards = [];
    for (const record of matched)for(const name in record.components){
        let rawComponent = record.components[name];
        // skip update and leave guards if the route component is not mounted
        if (guardType !== 'beforeRouteEnter' && !record.instances[name]) continue;
        if ($a809ac530d32f081$var$isRouteComponent(rawComponent)) {
            // __vccOpts is added by vue-class-component and contain the regular options
            const options = rawComponent.__vccOpts || rawComponent;
            const guard = options[guardType];
            guard && guards.push($a809ac530d32f081$var$guardToPromiseFn(guard, to, from, record, name));
        } else {
            // start requesting the chunk already
            let componentPromise = rawComponent();
            guards.push(()=>componentPromise.then((resolved)=>{
                    if (!resolved) return Promise.reject(new Error(`Couldn't resolve component "${name}" at "${record.path}"`));
                    const resolvedComponent = $a809ac530d32f081$var$isESModule(resolved) ? resolved.default : resolved;
                    // replace the function with the resolved component
                    // cannot be null or undefined because we went into the for loop
                    record.components[name] = resolvedComponent;
                    // __vccOpts is added by vue-class-component and contain the regular options
                    const options = resolvedComponent.__vccOpts || resolvedComponent;
                    const guard = options[guardType];
                    return guard && $a809ac530d32f081$var$guardToPromiseFn(guard, to, from, record, name)();
                }));
        }
    }
    return guards;
}
/**
 * Allows differentiating lazy components from functional components and vue-class-component
 * @internal
 *
 * @param component
 */ function $a809ac530d32f081$var$isRouteComponent(component) {
    return typeof component === 'object' || 'displayName' in component || 'props' in component || '__vccOpts' in component;
}
/**
 * Ensures a route is loaded, so it can be passed as o prop to `<RouterView>`.
 *
 * @param route - resolved route to load
 */ function $a809ac530d32f081$export$d092a02cbf0deea7(route) {
    return route.matched.every((record)=>record.redirect) ? Promise.reject(new Error('Cannot load a route that redirects.')) : Promise.all(route.matched.map((record)=>record.components && Promise.all(Object.keys(record.components).reduce((promises, name)=>{
            const rawComponent = record.components[name];
            if (typeof rawComponent === 'function' && !('displayName' in rawComponent)) promises.push(rawComponent().then((resolved)=>{
                if (!resolved) return Promise.reject(new Error(`Couldn't resolve component "${name}" at "${record.path}". Ensure you passed a function that returns a promise.`));
                const resolvedComponent = $a809ac530d32f081$var$isESModule(resolved) ? resolved.default : resolved;
                // replace the function with the resolved component
                // cannot be null or undefined because we went into the for loop
                record.components[name] = resolvedComponent;
                return;
            }));
            return promises;
        }, [])))).then(()=>route);
}
// TODO: we could allow currentRoute as a prop to expose `isActive` and
// `isExactActive` behavior should go through an RFC
function $a809ac530d32f081$export$dcf14c9974fe2767(props) {
    const router = (0, $TusQn.inject)($a809ac530d32f081$export$b6c0da8b9dae491f);
    const currentRoute = (0, $TusQn.inject)($a809ac530d32f081$export$3aca783e9a3e6e9e);
    const route = (0, $01W3b.computed)(()=>router.resolve((0, $01W3b.unref)(props.to)));
    const activeRecordIndex = (0, $01W3b.computed)(()=>{
        const { matched: matched } = route.value;
        const { length: length } = matched;
        const routeMatched = matched[length - 1];
        const currentMatched = currentRoute.matched;
        if (!routeMatched || !currentMatched.length) return -1;
        const index = currentMatched.findIndex($a809ac530d32f081$var$isSameRouteRecord.bind(null, routeMatched));
        if (index > -1) return index;
        // possible parent record
        const parentRecordPath = $a809ac530d32f081$var$getOriginalPath(matched[length - 2]);
        return(// we are dealing with nested routes
        length > 1 && // if the parent and matched route have the same path, this link is
        // referring to the empty child. Or we currently are on a different
        // child of the same parent
        $a809ac530d32f081$var$getOriginalPath(routeMatched) === parentRecordPath && // avoid comparing the child with its parent
        currentMatched[currentMatched.length - 1].path !== parentRecordPath ? currentMatched.findIndex($a809ac530d32f081$var$isSameRouteRecord.bind(null, matched[length - 2])) : index);
    });
    const isActive = (0, $01W3b.computed)(()=>activeRecordIndex.value > -1 && $a809ac530d32f081$var$includesParams(currentRoute.params, route.value.params));
    const isExactActive = (0, $01W3b.computed)(()=>activeRecordIndex.value > -1 && activeRecordIndex.value === currentRoute.matched.length - 1 && $a809ac530d32f081$var$isSameRouteLocationParams(currentRoute.params, route.value.params));
    function navigate(e = {}) {
        if ($a809ac530d32f081$var$guardEvent(e)) return router[(0, $01W3b.unref)(props.replace) ? 'replace' : 'push']((0, $01W3b.unref)(props.to)).catch($a809ac530d32f081$var$noop);
        return Promise.resolve();
    }
    // devtools only
    if (__VUE_PROD_DEVTOOLS__ && $a809ac530d32f081$var$isBrowser) {
        const instance = (0, $TusQn.getCurrentInstance)();
        if (instance) {
            const linkContextDevtools = {
                route: route.value,
                isActive: isActive.value,
                isExactActive: isExactActive.value
            };
            // @ts-expect-error: this is internal
            instance.__vrl_devtools = instance.__vrl_devtools || [];
            // @ts-expect-error: this is internal
            instance.__vrl_devtools.push(linkContextDevtools);
            (0, $TusQn.watchEffect)(()=>{
                linkContextDevtools.route = route.value;
                linkContextDevtools.isActive = isActive.value;
                linkContextDevtools.isExactActive = isExactActive.value;
            }, {
                flush: 'post'
            });
        }
    }
    return {
        route: route,
        href: (0, $01W3b.computed)(()=>route.value.href),
        isActive: isActive,
        isExactActive: isExactActive,
        navigate: navigate
    };
}
const $a809ac530d32f081$var$RouterLinkImpl = /*#__PURE__*/ (0, $TusQn.defineComponent)({
    name: 'RouterLink',
    compatConfig: {
        MODE: 3
    },
    props: {
        to: {
            type: [
                String,
                Object
            ],
            required: true
        },
        replace: Boolean,
        activeClass: String,
        // inactiveClass: String,
        exactActiveClass: String,
        custom: Boolean,
        ariaCurrentValue: {
            type: String,
            default: 'page'
        }
    },
    useLink: $a809ac530d32f081$export$dcf14c9974fe2767,
    setup (props, { slots: slots }) {
        const link = (0, $01W3b.reactive)($a809ac530d32f081$export$dcf14c9974fe2767(props));
        const { options: options } = (0, $TusQn.inject)($a809ac530d32f081$export$b6c0da8b9dae491f);
        const elClass = (0, $01W3b.computed)(()=>({
                [$a809ac530d32f081$var$getLinkClass(props.activeClass, options.linkActiveClass, 'router-link-active')]: link.isActive,
                // [getLinkClass(
                //   props.inactiveClass,
                //   options.linkInactiveClass,
                //   'router-link-inactive'
                // )]: !link.isExactActive,
                [$a809ac530d32f081$var$getLinkClass(props.exactActiveClass, options.linkExactActiveClass, 'router-link-exact-active')]: link.isExactActive
            }));
        return ()=>{
            const children = slots.default && slots.default(link);
            return props.custom ? children : (0, $TusQn.h)('a', {
                'aria-current': link.isExactActive ? props.ariaCurrentValue : null,
                href: link.href,
                // this would override user added attrs but Vue will still add
                // the listener, so we end up triggering both
                onClick: link.navigate,
                class: elClass.value
            }, children);
        };
    }
});
// export the public type for h/tsx inference
// also to avoid inline import() in generated d.ts files
/**
 * Component to render a link that triggers a navigation on click.
 */ const $a809ac530d32f081$export$fce709ebdac448ed = $a809ac530d32f081$var$RouterLinkImpl;
function $a809ac530d32f081$var$guardEvent(e) {
    // don't redirect with control keys
    if (e.metaKey || e.altKey || e.ctrlKey || e.shiftKey) return;
    // don't redirect when preventDefault called
    if (e.defaultPrevented) return;
    // don't redirect on right click
    if (e.button !== undefined && e.button !== 0) return;
    // don't redirect if `target="_blank"`
    // @ts-expect-error getAttribute does exist
    if (e.currentTarget && e.currentTarget.getAttribute) {
        // @ts-expect-error getAttribute exists
        const target = e.currentTarget.getAttribute('target');
        if (/\b_blank\b/i.test(target)) return;
    }
    // this may be a Weex event which doesn't have this method
    if (e.preventDefault) e.preventDefault();
    return true;
}
function $a809ac530d32f081$var$includesParams(outer, inner) {
    for(const key in inner){
        const innerValue = inner[key];
        const outerValue = outer[key];
        if (typeof innerValue === 'string') {
            if (innerValue !== outerValue) return false;
        } else {
            if (!$a809ac530d32f081$var$isArray(outerValue) || outerValue.length !== innerValue.length || innerValue.some((value, i)=>value !== outerValue[i])) return false;
        }
    }
    return true;
}
/**
 * Get the original path value of a record by following its aliasOf
 * @param record
 */ function $a809ac530d32f081$var$getOriginalPath(record) {
    return record ? record.aliasOf ? record.aliasOf.path : record.path : '';
}
/**
 * Utility class to get the active class based on defaults.
 * @param propClass
 * @param globalClass
 * @param defaultClass
 */ const $a809ac530d32f081$var$getLinkClass = (propClass, globalClass, defaultClass)=>propClass != null ? propClass : globalClass != null ? globalClass : defaultClass;
const $a809ac530d32f081$var$RouterViewImpl = /*#__PURE__*/ (0, $TusQn.defineComponent)({
    name: 'RouterView',
    // #674 we manually inherit them
    inheritAttrs: false,
    props: {
        name: {
            type: String,
            default: 'default'
        },
        route: Object
    },
    // Better compat for @vue/compat users
    // https://github.com/vuejs/router/issues/1315
    compatConfig: {
        MODE: 3
    },
    setup (props, { attrs: attrs, slots: slots }) {
        const injectedRoute = (0, $TusQn.inject)($a809ac530d32f081$export$54c8124bead129f8);
        const routeToDisplay = (0, $01W3b.computed)(()=>props.route || injectedRoute.value);
        const injectedDepth = (0, $TusQn.inject)($a809ac530d32f081$export$9b3825c34ca1427a, 0);
        // The depth changes based on empty components option, which allows passthrough routes e.g. routes with children
        // that are used to reuse the `path` property
        const depth = (0, $01W3b.computed)(()=>{
            let initialDepth = (0, $01W3b.unref)(injectedDepth);
            const { matched: matched } = routeToDisplay.value;
            let matchedRoute;
            while((matchedRoute = matched[initialDepth]) && !matchedRoute.components)initialDepth++;
            return initialDepth;
        });
        const matchedRouteRef = (0, $01W3b.computed)(()=>routeToDisplay.value.matched[depth.value]);
        (0, $TusQn.provide)($a809ac530d32f081$export$9b3825c34ca1427a, (0, $01W3b.computed)(()=>depth.value + 1));
        (0, $TusQn.provide)($a809ac530d32f081$export$7f4879db1558672d, matchedRouteRef);
        (0, $TusQn.provide)($a809ac530d32f081$export$54c8124bead129f8, routeToDisplay);
        const viewRef = (0, $01W3b.ref)();
        // watch at the same time the component instance, the route record we are
        // rendering, and the name
        (0, $TusQn.watch)(()=>[
                viewRef.value,
                matchedRouteRef.value,
                props.name
            ], ([instance, to, name], [oldInstance, from, oldName])=>{
            // copy reused instances
            if (to) {
                // this will update the instance for new instances as well as reused
                // instances when navigating to a new route
                to.instances[name] = instance;
                // the component instance is reused for a different route or name, so
                // we copy any saved update or leave guards. With async setup, the
                // mounting component will mount before the matchedRoute changes,
                // making instance === oldInstance, so we check if guards have been
                // added before. This works because we remove guards when
                // unmounting/deactivating components
                if (from && from !== to && instance && instance === oldInstance) {
                    if (!to.leaveGuards.size) to.leaveGuards = from.leaveGuards;
                    if (!to.updateGuards.size) to.updateGuards = from.updateGuards;
                }
            }
            // trigger beforeRouteEnter next callbacks
            if (instance && to && // if there is no instance but to and from are the same this might be
            // the first visit
            (!from || !$a809ac530d32f081$var$isSameRouteRecord(to, from) || !oldInstance)) (to.enterCallbacks[name] || []).forEach((callback)=>callback(instance));
        }, {
            flush: 'post'
        });
        return ()=>{
            const route = routeToDisplay.value;
            // we need the value at the time we render because when we unmount, we
            // navigated to a different location so the value is different
            const currentName = props.name;
            const matchedRoute = matchedRouteRef.value;
            const ViewComponent = matchedRoute && matchedRoute.components[currentName];
            if (!ViewComponent) return $a809ac530d32f081$var$normalizeSlot(slots.default, {
                Component: ViewComponent,
                route: route
            });
            // props from route configuration
            const routePropsOption = matchedRoute.props[currentName];
            const routeProps = routePropsOption ? routePropsOption === true ? route.params : typeof routePropsOption === 'function' ? routePropsOption(route) : routePropsOption : null;
            const onVnodeUnmounted = (vnode)=>{
                // remove the instance reference to prevent leak
                if (vnode.component.isUnmounted) matchedRoute.instances[currentName] = null;
            };
            const component = (0, $TusQn.h)(ViewComponent, $a809ac530d32f081$var$assign({}, routeProps, attrs, {
                onVnodeUnmounted: onVnodeUnmounted,
                ref: viewRef
            }));
            if (__VUE_PROD_DEVTOOLS__ && $a809ac530d32f081$var$isBrowser && component.ref) {
                // TODO: can display if it's an alias, its props
                const info = {
                    depth: depth.value,
                    name: matchedRoute.name,
                    path: matchedRoute.path,
                    meta: matchedRoute.meta
                };
                const internalInstances = $a809ac530d32f081$var$isArray(component.ref) ? component.ref.map((r)=>r.i) : [
                    component.ref.i
                ];
                internalInstances.forEach((instance)=>{
                    // @ts-expect-error
                    instance.__vrv_devtools = info;
                });
            }
            return(// pass the vnode to the slot as a prop.
            // h and <component :is="..."> both accept vnodes
            $a809ac530d32f081$var$normalizeSlot(slots.default, {
                Component: component,
                route: route
            }) || component);
        };
    }
});
function $a809ac530d32f081$var$normalizeSlot(slot, data) {
    if (!slot) return null;
    const slotContent = slot(data);
    return slotContent.length === 1 ? slotContent[0] : slotContent;
}
// export the public type for h/tsx inference
// also to avoid inline import() in generated d.ts files
/**
 * Component to display the current route the user is at.
 */ const $a809ac530d32f081$export$d941f00e9b9a537 = $a809ac530d32f081$var$RouterViewImpl;
// warn against deprecated usage with <transition> & <keep-alive>
// due to functional component being no longer eager in Vue 3
function $a809ac530d32f081$var$warnDeprecatedUsage() {
    const instance = (0, $TusQn.getCurrentInstance)();
    const parentName = instance.parent && instance.parent.type.name;
    if (parentName && (parentName === 'KeepAlive' || parentName.includes('Transition'))) {
        const comp = parentName === 'KeepAlive' ? 'keep-alive' : 'transition';
        $a809ac530d32f081$var$warn(`<router-view> can no longer be used directly inside <transition> or <keep-alive>.\n` + `Use slot props instead:\n\n` + `<router-view v-slot="{ Component }">\n` + `  <${comp}>\n` + `    <component :is="Component" />\n` + `  </${comp}>\n` + `</router-view>`);
    }
}
/**
 * Copies a route location and removes any problematic properties that cannot be shown in devtools (e.g. Vue instances).
 *
 * @param routeLocation - routeLocation to format
 * @param tooltip - optional tooltip
 * @returns a copy of the routeLocation
 */ function $a809ac530d32f081$var$formatRouteLocation(routeLocation, tooltip) {
    const copy = $a809ac530d32f081$var$assign({}, routeLocation, {
        // remove variables that can contain vue instances
        matched: routeLocation.matched.map((matched)=>$a809ac530d32f081$var$omit(matched, [
                'instances',
                'children',
                'aliasOf'
            ]))
    });
    return {
        _custom: {
            type: null,
            readOnly: true,
            display: routeLocation.fullPath,
            tooltip: tooltip,
            value: copy
        }
    };
}
function $a809ac530d32f081$var$formatDisplay(display) {
    return {
        _custom: {
            display: display
        }
    };
}
// to support multiple router instances
let $a809ac530d32f081$var$routerId = 0;
function $a809ac530d32f081$var$addDevtools(app, router, matcher) {
    // Take over router.beforeEach and afterEach
    // make sure we are not registering the devtool twice
    if (router.__hasDevtools) return;
    router.__hasDevtools = true;
    // increment to support multiple router instances
    const id = $a809ac530d32f081$var$routerId++;
    (0, $j6G8F.setupDevtoolsPlugin)({
        id: 'org.vuejs.router' + (id ? '.' + id : ''),
        label: 'Vue Router',
        packageName: 'vue-router',
        homepage: 'https://router.vuejs.org',
        logo: 'https://router.vuejs.org/logo.png',
        componentStateTypes: [
            'Routing'
        ],
        app: app
    }, (api)=>{
        if (typeof api.now !== 'function') console.warn('[Vue Router]: You seem to be using an outdated version of Vue Devtools. Are you still using the Beta release instead of the stable one? You can find the links at https://devtools.vuejs.org/guide/installation.html.');
        // display state added by the router
        api.on.inspectComponent((payload, ctx)=>{
            if (payload.instanceData) payload.instanceData.state.push({
                type: 'Routing',
                key: '$route',
                editable: false,
                value: $a809ac530d32f081$var$formatRouteLocation(router.currentRoute.value, 'Current Route')
            });
        });
        // mark router-link as active and display tags on router views
        api.on.visitComponentTree(({ treeNode: node, componentInstance: componentInstance })=>{
            if (componentInstance.__vrv_devtools) {
                const info = componentInstance.__vrv_devtools;
                node.tags.push({
                    label: (info.name ? `${info.name.toString()}: ` : '') + info.path,
                    textColor: 0,
                    tooltip: 'This component is rendered by &lt;router-view&gt;',
                    backgroundColor: $a809ac530d32f081$var$PINK_500
                });
            }
            // if multiple useLink are used
            if ($a809ac530d32f081$var$isArray(componentInstance.__vrl_devtools)) {
                componentInstance.__devtoolsApi = api;
                componentInstance.__vrl_devtools.forEach((devtoolsData)=>{
                    let backgroundColor = $a809ac530d32f081$var$ORANGE_400;
                    let tooltip = '';
                    if (devtoolsData.isExactActive) {
                        backgroundColor = $a809ac530d32f081$var$LIME_500;
                        tooltip = 'This is exactly active';
                    } else if (devtoolsData.isActive) {
                        backgroundColor = $a809ac530d32f081$var$BLUE_600;
                        tooltip = 'This link is active';
                    }
                    node.tags.push({
                        label: devtoolsData.route.path,
                        textColor: 0,
                        tooltip: tooltip,
                        backgroundColor: backgroundColor
                    });
                });
            }
        });
        (0, $TusQn.watch)(router.currentRoute, ()=>{
            // refresh active state
            refreshRoutesView();
            api.notifyComponentUpdate();
            api.sendInspectorTree(routerInspectorId);
            api.sendInspectorState(routerInspectorId);
        });
        const navigationsLayerId = 'router:navigations:' + id;
        api.addTimelineLayer({
            id: navigationsLayerId,
            label: `Router${id ? ' ' + id : ''} Navigations`,
            color: 0x40a8c4
        });
        // const errorsLayerId = 'router:errors'
        // api.addTimelineLayer({
        //   id: errorsLayerId,
        //   label: 'Router Errors',
        //   color: 0xea5455,
        // })
        router.onError((error, to)=>{
            api.addTimelineEvent({
                layerId: navigationsLayerId,
                event: {
                    title: 'Error during Navigation',
                    subtitle: to.fullPath,
                    logType: 'error',
                    time: api.now(),
                    data: {
                        error: error
                    },
                    groupId: to.meta.__navigationId
                }
            });
        });
        // attached to `meta` and used to group events
        let navigationId = 0;
        router.beforeEach((to, from)=>{
            const data = {
                guard: $a809ac530d32f081$var$formatDisplay('beforeEach'),
                from: $a809ac530d32f081$var$formatRouteLocation(from, 'Current Location during this navigation'),
                to: $a809ac530d32f081$var$formatRouteLocation(to, 'Target location')
            };
            // Used to group navigations together, hide from devtools
            Object.defineProperty(to.meta, '__navigationId', {
                value: navigationId++
            });
            api.addTimelineEvent({
                layerId: navigationsLayerId,
                event: {
                    time: api.now(),
                    title: 'Start of navigation',
                    subtitle: to.fullPath,
                    data: data,
                    groupId: to.meta.__navigationId
                }
            });
        });
        router.afterEach((to, from, failure)=>{
            const data = {
                guard: $a809ac530d32f081$var$formatDisplay('afterEach')
            };
            if (failure) {
                data.failure = {
                    _custom: {
                        type: Error,
                        readOnly: true,
                        display: failure ? failure.message : '',
                        tooltip: 'Navigation Failure',
                        value: failure
                    }
                };
                data.status = $a809ac530d32f081$var$formatDisplay("\u274C");
            } else data.status = $a809ac530d32f081$var$formatDisplay("\u2705");
            // we set here to have the right order
            data.from = $a809ac530d32f081$var$formatRouteLocation(from, 'Current Location during this navigation');
            data.to = $a809ac530d32f081$var$formatRouteLocation(to, 'Target location');
            api.addTimelineEvent({
                layerId: navigationsLayerId,
                event: {
                    title: 'End of navigation',
                    subtitle: to.fullPath,
                    time: api.now(),
                    data: data,
                    logType: failure ? 'warning' : 'default',
                    groupId: to.meta.__navigationId
                }
            });
        });
        /**
         * Inspector of Existing routes
         */ const routerInspectorId = 'router-inspector:' + id;
        api.addInspector({
            id: routerInspectorId,
            label: 'Routes' + (id ? ' ' + id : ''),
            icon: 'book',
            treeFilterPlaceholder: 'Search routes'
        });
        function refreshRoutesView() {
            // the routes view isn't active
            if (!activeRoutesPayload) return;
            const payload = activeRoutesPayload;
            // children routes will appear as nested
            let routes = matcher.getRoutes().filter((route)=>!route.parent);
            // reset match state to false
            routes.forEach($a809ac530d32f081$var$resetMatchStateOnRouteRecord);
            // apply a match state if there is a payload
            if (payload.filter) routes = routes.filter((route)=>// save matches state based on the payload
                $a809ac530d32f081$var$isRouteMatching(route, payload.filter.toLowerCase()));
            // mark active routes
            routes.forEach((route)=>$a809ac530d32f081$var$markRouteRecordActive(route, router.currentRoute.value));
            payload.rootNodes = routes.map($a809ac530d32f081$var$formatRouteRecordForInspector);
        }
        let activeRoutesPayload;
        api.on.getInspectorTree((payload)=>{
            activeRoutesPayload = payload;
            if (payload.app === app && payload.inspectorId === routerInspectorId) refreshRoutesView();
        });
        /**
         * Display information about the currently selected route record
         */ api.on.getInspectorState((payload)=>{
            if (payload.app === app && payload.inspectorId === routerInspectorId) {
                const routes = matcher.getRoutes();
                const route = routes.find((route)=>route.record.__vd_id === payload.nodeId);
                if (route) payload.state = {
                    options: $a809ac530d32f081$var$formatRouteRecordMatcherForStateInspector(route)
                };
            }
        });
        api.sendInspectorTree(routerInspectorId);
        api.sendInspectorState(routerInspectorId);
    });
}
function $a809ac530d32f081$var$modifierForKey(key) {
    if (key.optional) return key.repeatable ? '*' : '?';
    else return key.repeatable ? '+' : '';
}
function $a809ac530d32f081$var$formatRouteRecordMatcherForStateInspector(route) {
    const { record: record } = route;
    const fields = [
        {
            editable: false,
            key: 'path',
            value: record.path
        }
    ];
    if (record.name != null) fields.push({
        editable: false,
        key: 'name',
        value: record.name
    });
    fields.push({
        editable: false,
        key: 'regexp',
        value: route.re
    });
    if (route.keys.length) fields.push({
        editable: false,
        key: 'keys',
        value: {
            _custom: {
                type: null,
                readOnly: true,
                display: route.keys.map((key)=>`${key.name}${$a809ac530d32f081$var$modifierForKey(key)}`).join(' '),
                tooltip: 'Param keys',
                value: route.keys
            }
        }
    });
    if (record.redirect != null) fields.push({
        editable: false,
        key: 'redirect',
        value: record.redirect
    });
    if (route.alias.length) fields.push({
        editable: false,
        key: 'aliases',
        value: route.alias.map((alias)=>alias.record.path)
    });
    if (Object.keys(route.record.meta).length) fields.push({
        editable: false,
        key: 'meta',
        value: route.record.meta
    });
    fields.push({
        key: 'score',
        editable: false,
        value: {
            _custom: {
                type: null,
                readOnly: true,
                display: route.score.map((score)=>score.join(', ')).join(' | '),
                tooltip: 'Score used to sort routes',
                value: route.score
            }
        }
    });
    return fields;
}
/**
 * Extracted from tailwind palette
 */ const $a809ac530d32f081$var$PINK_500 = 0xec4899;
const $a809ac530d32f081$var$BLUE_600 = 0x2563eb;
const $a809ac530d32f081$var$LIME_500 = 0x84cc16;
const $a809ac530d32f081$var$CYAN_400 = 0x22d3ee;
const $a809ac530d32f081$var$ORANGE_400 = 0xfb923c;
// const GRAY_100 = 0xf4f4f5
const $a809ac530d32f081$var$DARK = 0x666666;
function $a809ac530d32f081$var$formatRouteRecordForInspector(route) {
    const tags = [];
    const { record: record } = route;
    if (record.name != null) tags.push({
        label: String(record.name),
        textColor: 0,
        backgroundColor: $a809ac530d32f081$var$CYAN_400
    });
    if (record.aliasOf) tags.push({
        label: 'alias',
        textColor: 0,
        backgroundColor: $a809ac530d32f081$var$ORANGE_400
    });
    if (route.__vd_match) tags.push({
        label: 'matches',
        textColor: 0,
        backgroundColor: $a809ac530d32f081$var$PINK_500
    });
    if (route.__vd_exactActive) tags.push({
        label: 'exact',
        textColor: 0,
        backgroundColor: $a809ac530d32f081$var$LIME_500
    });
    if (route.__vd_active) tags.push({
        label: 'active',
        textColor: 0,
        backgroundColor: $a809ac530d32f081$var$BLUE_600
    });
    if (record.redirect) tags.push({
        label: typeof record.redirect === 'string' ? `redirect: ${record.redirect}` : 'redirects',
        textColor: 0xffffff,
        backgroundColor: $a809ac530d32f081$var$DARK
    });
    // add an id to be able to select it. Using the `path` is not possible because
    // empty path children would collide with their parents
    let id = record.__vd_id;
    if (id == null) {
        id = String($a809ac530d32f081$var$routeRecordId++);
        record.__vd_id = id;
    }
    return {
        id: id,
        label: record.path,
        tags: tags,
        children: route.children.map($a809ac530d32f081$var$formatRouteRecordForInspector)
    };
}
//  incremental id for route records and inspector state
let $a809ac530d32f081$var$routeRecordId = 0;
const $a809ac530d32f081$var$EXTRACT_REGEXP_RE = /^\/(.*)\/([a-z]*)$/;
function $a809ac530d32f081$var$markRouteRecordActive(route, currentRoute) {
    // no route will be active if matched is empty
    // reset the matching state
    const isExactActive = currentRoute.matched.length && $a809ac530d32f081$var$isSameRouteRecord(currentRoute.matched[currentRoute.matched.length - 1], route.record);
    route.__vd_exactActive = route.__vd_active = isExactActive;
    if (!isExactActive) route.__vd_active = currentRoute.matched.some((match)=>$a809ac530d32f081$var$isSameRouteRecord(match, route.record));
    route.children.forEach((childRoute)=>$a809ac530d32f081$var$markRouteRecordActive(childRoute, currentRoute));
}
function $a809ac530d32f081$var$resetMatchStateOnRouteRecord(route) {
    route.__vd_match = false;
    route.children.forEach($a809ac530d32f081$var$resetMatchStateOnRouteRecord);
}
function $a809ac530d32f081$var$isRouteMatching(route, filter) {
    const found = String(route.re).match($a809ac530d32f081$var$EXTRACT_REGEXP_RE);
    route.__vd_match = false;
    if (!found || found.length < 3) return false;
    // use a regexp without $ at the end to match nested routes better
    const nonEndingRE = new RegExp(found[1].replace(/\$$/, ''), found[2]);
    if (nonEndingRE.test(filter)) {
        // mark children as matches
        route.children.forEach((child)=>$a809ac530d32f081$var$isRouteMatching(child, filter));
        // exception case: `/`
        if (route.record.path !== '/' || filter === '/') {
            route.__vd_match = route.re.test(filter);
            return true;
        }
        // hide the / route
        return false;
    }
    const path = route.record.path.toLowerCase();
    const decodedPath = $a809ac530d32f081$var$decode(path);
    // also allow partial matching on the path
    if (!filter.startsWith('/') && (decodedPath.includes(filter) || path.includes(filter))) return true;
    if (decodedPath.startsWith(filter) || path.startsWith(filter)) return true;
    if (route.record.name && String(route.record.name).includes(filter)) return true;
    return route.children.some((child)=>$a809ac530d32f081$var$isRouteMatching(child, filter));
}
function $a809ac530d32f081$var$omit(obj, keys) {
    const ret = {};
    for(const key in obj)if (!keys.includes(key)) // @ts-expect-error
    ret[key] = obj[key];
    return ret;
}
/**
 * Creates a Router instance that can be used by a Vue app.
 *
 * @param options - {@link RouterOptions}
 */ function $a809ac530d32f081$export$baddd0131ee8c05b(options) {
    const matcher = $a809ac530d32f081$export$36302c85fdcc95a8(options.routes, options);
    const parseQuery$1 = options.parseQuery || $a809ac530d32f081$export$1e8473eaf75b0d10;
    const stringifyQuery$1 = options.stringifyQuery || $a809ac530d32f081$export$d33b45a8f796a30;
    const routerHistory = options.history;
    const beforeGuards = $a809ac530d32f081$var$useCallbacks();
    const beforeResolveGuards = $a809ac530d32f081$var$useCallbacks();
    const afterGuards = $a809ac530d32f081$var$useCallbacks();
    const currentRoute = (0, $01W3b.shallowRef)($a809ac530d32f081$export$e44be9a9779c480b);
    let pendingLocation = $a809ac530d32f081$export$e44be9a9779c480b;
    // leave the scrollRestoration if no scrollBehavior is provided
    if ($a809ac530d32f081$var$isBrowser && options.scrollBehavior && 'scrollRestoration' in history) history.scrollRestoration = 'manual';
    const normalizeParams = $a809ac530d32f081$var$applyToParams.bind(null, (paramValue)=>'' + paramValue);
    const encodeParams = $a809ac530d32f081$var$applyToParams.bind(null, $a809ac530d32f081$var$encodeParam);
    const decodeParams = // @ts-expect-error: intentionally avoid the type check
    $a809ac530d32f081$var$applyToParams.bind(null, $a809ac530d32f081$var$decode);
    function addRoute(parentOrRoute, route) {
        let parent;
        let record;
        if ($a809ac530d32f081$var$isRouteName(parentOrRoute)) {
            parent = matcher.getRecordMatcher(parentOrRoute);
            record = route;
        } else record = parentOrRoute;
        return matcher.addRoute(record, parent);
    }
    function removeRoute(name) {
        const recordMatcher = matcher.getRecordMatcher(name);
        if (recordMatcher) matcher.removeRoute(recordMatcher);
    }
    function getRoutes() {
        return matcher.getRoutes().map((routeMatcher)=>routeMatcher.record);
    }
    function hasRoute(name) {
        return !!matcher.getRecordMatcher(name);
    }
    function resolve(rawLocation, currentLocation) {
        // const objectLocation = routerLocationAsObject(rawLocation)
        // we create a copy to modify it later
        currentLocation = $a809ac530d32f081$var$assign({}, currentLocation || currentRoute.value);
        if (typeof rawLocation === 'string') {
            const locationNormalized = $a809ac530d32f081$var$parseURL(parseQuery$1, rawLocation, currentLocation.path);
            const matchedRoute = matcher.resolve({
                path: locationNormalized.path
            }, currentLocation);
            const href = routerHistory.createHref(locationNormalized.fullPath);
            // locationNormalized is always a new object
            return $a809ac530d32f081$var$assign(locationNormalized, matchedRoute, {
                params: decodeParams(matchedRoute.params),
                hash: $a809ac530d32f081$var$decode(locationNormalized.hash),
                redirectedFrom: undefined,
                href: href
            });
        }
        let matcherLocation;
        // path could be relative in object as well
        if ('path' in rawLocation) matcherLocation = $a809ac530d32f081$var$assign({}, rawLocation, {
            path: $a809ac530d32f081$var$parseURL(parseQuery$1, rawLocation.path, currentLocation.path).path
        });
        else {
            // remove any nullish param
            const targetParams = $a809ac530d32f081$var$assign({}, rawLocation.params);
            for(const key in targetParams)if (targetParams[key] == null) delete targetParams[key];
            // pass encoded values to the matcher, so it can produce encoded path and fullPath
            matcherLocation = $a809ac530d32f081$var$assign({}, rawLocation, {
                params: encodeParams(rawLocation.params)
            });
            // current location params are decoded, we need to encode them in case the
            // matcher merges the params
            currentLocation.params = encodeParams(currentLocation.params);
        }
        const matchedRoute = matcher.resolve(matcherLocation, currentLocation);
        const hash = rawLocation.hash || '';
        // the matcher might have merged current location params, so
        // we need to run the decoding again
        matchedRoute.params = normalizeParams(decodeParams(matchedRoute.params));
        const fullPath = $a809ac530d32f081$var$stringifyURL(stringifyQuery$1, $a809ac530d32f081$var$assign({}, rawLocation, {
            hash: $a809ac530d32f081$var$encodeHash(hash),
            path: matchedRoute.path
        }));
        const href = routerHistory.createHref(fullPath);
        return $a809ac530d32f081$var$assign({
            fullPath: fullPath,
            hash: // keep the hash encoded so fullPath is effectively path + encodedQuery +
            // hash
            hash,
            query: // if the user is using a custom query lib like qs, we might have
            // nested objects, so we keep the query as is, meaning it can contain
            // numbers at `$route.query`, but at the point, the user will have to
            // use their own type anyway.
            // https://github.com/vuejs/router/issues/328#issuecomment-649481567
            stringifyQuery$1 === $a809ac530d32f081$export$d33b45a8f796a30 ? $a809ac530d32f081$var$normalizeQuery(rawLocation.query) : rawLocation.query || {}
        }, matchedRoute, {
            redirectedFrom: undefined,
            href: href
        });
    }
    function locationAsObject(to) {
        return typeof to === 'string' ? $a809ac530d32f081$var$parseURL(parseQuery$1, to, currentRoute.value.path) : $a809ac530d32f081$var$assign({}, to);
    }
    function checkCanceledNavigation(to, from) {
        if (pendingLocation !== to) return $a809ac530d32f081$var$createRouterError(8 /* ErrorTypes.NAVIGATION_CANCELLED */ , {
            from: from,
            to: to
        });
    }
    function push(to) {
        return pushWithRedirect(to);
    }
    function replace(to) {
        return push($a809ac530d32f081$var$assign(locationAsObject(to), {
            replace: true
        }));
    }
    function handleRedirectRecord(to) {
        const lastMatched = to.matched[to.matched.length - 1];
        if (lastMatched && lastMatched.redirect) {
            const { redirect: redirect } = lastMatched;
            let newTargetLocation = typeof redirect === 'function' ? redirect(to) : redirect;
            if (typeof newTargetLocation === 'string') {
                newTargetLocation = newTargetLocation.includes('?') || newTargetLocation.includes('#') ? newTargetLocation = locationAsObject(newTargetLocation) : {
                    path: newTargetLocation
                };
                // @ts-expect-error: force empty params when a string is passed to let
                // the router parse them again
                newTargetLocation.params = {};
            }
            return $a809ac530d32f081$var$assign({
                query: to.query,
                hash: to.hash,
                // avoid transferring params if the redirect has a path
                params: 'path' in newTargetLocation ? {} : to.params
            }, newTargetLocation);
        }
    }
    function pushWithRedirect(to, redirectedFrom) {
        const targetLocation = pendingLocation = resolve(to);
        const from = currentRoute.value;
        const data = to.state;
        const force = to.force;
        // to could be a string where `replace` is a function
        const replace = to.replace === true;
        const shouldRedirect = handleRedirectRecord(targetLocation);
        if (shouldRedirect) return pushWithRedirect($a809ac530d32f081$var$assign(locationAsObject(shouldRedirect), {
            state: typeof shouldRedirect === 'object' ? $a809ac530d32f081$var$assign({}, data, shouldRedirect.state) : data,
            force: force,
            replace: replace
        }), // keep original redirectedFrom if it exists
        redirectedFrom || targetLocation);
        // if it was a redirect we already called `pushWithRedirect` above
        const toLocation = targetLocation;
        toLocation.redirectedFrom = redirectedFrom;
        let failure;
        if (!force && $a809ac530d32f081$var$isSameRouteLocation(stringifyQuery$1, from, targetLocation)) {
            failure = $a809ac530d32f081$var$createRouterError(16 /* ErrorTypes.NAVIGATION_DUPLICATED */ , {
                to: toLocation,
                from: from
            });
            // trigger scroll to allow scrolling to the same anchor
            handleScroll(from, from, // this is a push, the only way for it to be triggered from a
            // history.listen is with a redirect, which makes it become a push
            true, // This cannot be the first navigation because the initial location
            // cannot be manually navigated to
            false);
        }
        return (failure ? Promise.resolve(failure) : navigate(toLocation, from)).catch((error)=>$a809ac530d32f081$export$873de56207a30e5a(error) ? $a809ac530d32f081$export$873de56207a30e5a(error, 2 /* ErrorTypes.NAVIGATION_GUARD_REDIRECT */ ) ? error : markAsReady(error) // also returns the error
             : triggerError(error, toLocation, from)).then((failure)=>{
            if (failure) {
                if ($a809ac530d32f081$export$873de56207a30e5a(failure, 2 /* ErrorTypes.NAVIGATION_GUARD_REDIRECT */ )) return pushWithRedirect(// keep options
                $a809ac530d32f081$var$assign({
                    replace: // preserve an existing replacement but allow the redirect to override it
                    replace
                }, locationAsObject(failure.to), {
                    state: typeof failure.to === 'object' ? $a809ac530d32f081$var$assign({}, data, failure.to.state) : data,
                    force: force
                }), // preserve the original redirectedFrom if any
                redirectedFrom || toLocation);
            } else // if we fail we don't finalize the navigation
            failure = finalizeNavigation(toLocation, from, true, replace, data);
            triggerAfterEach(toLocation, from, failure);
            return failure;
        });
    }
    /**
     * Helper to reject and skip all navigation guards if a new navigation happened
     * @param to
     * @param from
     */ function checkCanceledNavigationAndReject(to, from) {
        const error = checkCanceledNavigation(to, from);
        return error ? Promise.reject(error) : Promise.resolve();
    }
    // TODO: refactor the whole before guards by internally using router.beforeEach
    function navigate(to, from) {
        let guards;
        const [leavingRecords, updatingRecords, enteringRecords] = $a809ac530d32f081$var$extractChangingRecords(to, from);
        // all components here have been resolved once because we are leaving
        guards = $a809ac530d32f081$var$extractComponentsGuards(leavingRecords.reverse(), 'beforeRouteLeave', to, from);
        // leavingRecords is already reversed
        for (const record of leavingRecords)record.leaveGuards.forEach((guard)=>{
            guards.push($a809ac530d32f081$var$guardToPromiseFn(guard, to, from));
        });
        const canceledNavigationCheck = checkCanceledNavigationAndReject.bind(null, to, from);
        guards.push(canceledNavigationCheck);
        // run the queue of per route beforeRouteLeave guards
        return $a809ac530d32f081$var$runGuardQueue(guards).then(()=>{
            // check global guards beforeEach
            guards = [];
            for (const guard of beforeGuards.list())guards.push($a809ac530d32f081$var$guardToPromiseFn(guard, to, from));
            guards.push(canceledNavigationCheck);
            return $a809ac530d32f081$var$runGuardQueue(guards);
        }).then(()=>{
            // check in components beforeRouteUpdate
            guards = $a809ac530d32f081$var$extractComponentsGuards(updatingRecords, 'beforeRouteUpdate', to, from);
            for (const record of updatingRecords)record.updateGuards.forEach((guard)=>{
                guards.push($a809ac530d32f081$var$guardToPromiseFn(guard, to, from));
            });
            guards.push(canceledNavigationCheck);
            // run the queue of per route beforeEnter guards
            return $a809ac530d32f081$var$runGuardQueue(guards);
        }).then(()=>{
            // check the route beforeEnter
            guards = [];
            for (const record of to.matched)// do not trigger beforeEnter on reused views
            if (record.beforeEnter && !from.matched.includes(record)) {
                if ($a809ac530d32f081$var$isArray(record.beforeEnter)) for (const beforeEnter of record.beforeEnter)guards.push($a809ac530d32f081$var$guardToPromiseFn(beforeEnter, to, from));
                else guards.push($a809ac530d32f081$var$guardToPromiseFn(record.beforeEnter, to, from));
            }
            guards.push(canceledNavigationCheck);
            // run the queue of per route beforeEnter guards
            return $a809ac530d32f081$var$runGuardQueue(guards);
        }).then(()=>{
            // NOTE: at this point to.matched is normalized and does not contain any () => Promise<Component>
            // clear existing enterCallbacks, these are added by extractComponentsGuards
            to.matched.forEach((record)=>record.enterCallbacks = {});
            // check in-component beforeRouteEnter
            guards = $a809ac530d32f081$var$extractComponentsGuards(enteringRecords, 'beforeRouteEnter', to, from);
            guards.push(canceledNavigationCheck);
            // run the queue of per route beforeEnter guards
            return $a809ac530d32f081$var$runGuardQueue(guards);
        }).then(()=>{
            // check global guards beforeResolve
            guards = [];
            for (const guard of beforeResolveGuards.list())guards.push($a809ac530d32f081$var$guardToPromiseFn(guard, to, from));
            guards.push(canceledNavigationCheck);
            return $a809ac530d32f081$var$runGuardQueue(guards);
        })// catch any navigation canceled
        .catch((err)=>$a809ac530d32f081$export$873de56207a30e5a(err, 8 /* ErrorTypes.NAVIGATION_CANCELLED */ ) ? err : Promise.reject(err));
    }
    function triggerAfterEach(to, from, failure) {
        // navigation is confirmed, call afterGuards
        // TODO: wrap with error handlers
        for (const guard of afterGuards.list())guard(to, from, failure);
    }
    /**
     * - Cleans up any navigation guards
     * - Changes the url if necessary
     * - Calls the scrollBehavior
     */ function finalizeNavigation(toLocation, from, isPush, replace, data) {
        // a more recent navigation took place
        const error = checkCanceledNavigation(toLocation, from);
        if (error) return error;
        // only consider as push if it's not the first navigation
        const isFirstNavigation = from === $a809ac530d32f081$export$e44be9a9779c480b;
        const state = !$a809ac530d32f081$var$isBrowser ? {} : history.state;
        // change URL only if the user did a push/replace and if it's not the initial navigation because
        // it's just reflecting the url
        if (isPush) {
            // on the initial navigation, we want to reuse the scroll position from
            // history state if it exists
            if (replace || isFirstNavigation) routerHistory.replace(toLocation.fullPath, $a809ac530d32f081$var$assign({
                scroll: isFirstNavigation && state && state.scroll
            }, data));
            else routerHistory.push(toLocation.fullPath, data);
        }
        // accept current navigation
        currentRoute.value = toLocation;
        handleScroll(toLocation, from, isPush, isFirstNavigation);
        markAsReady();
    }
    let removeHistoryListener;
    // attach listener to history to trigger navigations
    function setupListeners() {
        // avoid setting up listeners twice due to an invalid first navigation
        if (removeHistoryListener) return;
        removeHistoryListener = routerHistory.listen((to, _from, info)=>{
            if (!router.listening) return;
            // cannot be a redirect route because it was in history
            const toLocation = resolve(to);
            // due to dynamic routing, and to hash history with manual navigation
            // (manually changing the url or calling history.hash = '#/somewhere'),
            // there could be a redirect record in history
            const shouldRedirect = handleRedirectRecord(toLocation);
            if (shouldRedirect) {
                pushWithRedirect($a809ac530d32f081$var$assign(shouldRedirect, {
                    replace: true
                }), toLocation).catch($a809ac530d32f081$var$noop);
                return;
            }
            pendingLocation = toLocation;
            const from = currentRoute.value;
            // TODO: should be moved to web history?
            if ($a809ac530d32f081$var$isBrowser) $a809ac530d32f081$var$saveScrollPosition($a809ac530d32f081$var$getScrollKey(from.fullPath, info.delta), $a809ac530d32f081$var$computeScrollPosition());
            navigate(toLocation, from).catch((error)=>{
                if ($a809ac530d32f081$export$873de56207a30e5a(error, 12 /* ErrorTypes.NAVIGATION_CANCELLED */ )) return error;
                if ($a809ac530d32f081$export$873de56207a30e5a(error, 2 /* ErrorTypes.NAVIGATION_GUARD_REDIRECT */ )) {
                    // Here we could call if (info.delta) routerHistory.go(-info.delta,
                    // false) but this is bug prone as we have no way to wait the
                    // navigation to be finished before calling pushWithRedirect. Using
                    // a setTimeout of 16ms seems to work but there is no guarantee for
                    // it to work on every browser. So instead we do not restore the
                    // history entry and trigger a new navigation as requested by the
                    // navigation guard.
                    // the error is already handled by router.push we just want to avoid
                    // logging the error
                    pushWithRedirect(error.to, toLocation).then((failure)=>{
                        // manual change in hash history #916 ending up in the URL not
                        // changing, but it was changed by the manual url change, so we
                        // need to manually change it ourselves
                        if ($a809ac530d32f081$export$873de56207a30e5a(failure, 20 /* ErrorTypes.NAVIGATION_DUPLICATED */ ) && !info.delta && info.type === $a809ac530d32f081$var$NavigationType.pop) routerHistory.go(-1, false);
                    }).catch($a809ac530d32f081$var$noop);
                    // avoid the then branch
                    return Promise.reject();
                }
                // do not restore history on unknown direction
                if (info.delta) routerHistory.go(-info.delta, false);
                // unrecognized error, transfer to the global handler
                return triggerError(error, toLocation, from);
            }).then((failure)=>{
                failure = failure || finalizeNavigation(// after navigation, all matched components are resolved
                toLocation, from, false);
                // revert the navigation
                if (failure) {
                    if (info.delta && // a new navigation has been triggered, so we do not want to revert, that will change the current history
                    // entry while a different route is displayed
                    !$a809ac530d32f081$export$873de56207a30e5a(failure, 8 /* ErrorTypes.NAVIGATION_CANCELLED */ )) routerHistory.go(-info.delta, false);
                    else if (info.type === $a809ac530d32f081$var$NavigationType.pop && $a809ac530d32f081$export$873de56207a30e5a(failure, 20 /* ErrorTypes.NAVIGATION_DUPLICATED */ )) // manual change in hash history #916
                    // it's like a push but lacks the information of the direction
                    routerHistory.go(-1, false);
                }
                triggerAfterEach(toLocation, from, failure);
            }).catch($a809ac530d32f081$var$noop);
        });
    }
    // Initialization and Errors
    let readyHandlers = $a809ac530d32f081$var$useCallbacks();
    let errorHandlers = $a809ac530d32f081$var$useCallbacks();
    let ready;
    /**
     * Trigger errorHandlers added via onError and throws the error as well
     *
     * @param error - error to throw
     * @param to - location we were navigating to when the error happened
     * @param from - location we were navigating from when the error happened
     * @returns the error as a rejected promise
     */ function triggerError(error, to, from) {
        markAsReady(error);
        const list = errorHandlers.list();
        if (list.length) list.forEach((handler)=>handler(error, to, from));
        else console.error(error);
        return Promise.reject(error);
    }
    function isReady() {
        if (ready && currentRoute.value !== $a809ac530d32f081$export$e44be9a9779c480b) return Promise.resolve();
        return new Promise((resolve, reject)=>{
            readyHandlers.add([
                resolve,
                reject
            ]);
        });
    }
    function markAsReady(err) {
        if (!ready) {
            // still not ready if an error happened
            ready = !err;
            setupListeners();
            readyHandlers.list().forEach(([resolve, reject])=>err ? reject(err) : resolve());
            readyHandlers.reset();
        }
        return err;
    }
    // Scroll behavior
    function handleScroll(to, from, isPush, isFirstNavigation) {
        const { scrollBehavior: scrollBehavior } = options;
        if (!$a809ac530d32f081$var$isBrowser || !scrollBehavior) return Promise.resolve();
        const scrollPosition = !isPush && $a809ac530d32f081$var$getSavedScrollPosition($a809ac530d32f081$var$getScrollKey(to.fullPath, 0)) || (isFirstNavigation || !isPush) && history.state && history.state.scroll || null;
        return (0, $TusQn.nextTick)().then(()=>scrollBehavior(to, from, scrollPosition)).then((position)=>position && $a809ac530d32f081$var$scrollToPosition(position)).catch((err)=>triggerError(err, to, from));
    }
    const go = (delta)=>routerHistory.go(delta);
    let started;
    const installedApps = new Set();
    const router = {
        currentRoute: currentRoute,
        listening: true,
        addRoute: addRoute,
        removeRoute: removeRoute,
        hasRoute: hasRoute,
        getRoutes: getRoutes,
        resolve: resolve,
        options: options,
        push: push,
        replace: replace,
        go: go,
        back: ()=>go(-1),
        forward: ()=>go(1),
        beforeEach: beforeGuards.add,
        beforeResolve: beforeResolveGuards.add,
        afterEach: afterGuards.add,
        onError: errorHandlers.add,
        isReady: isReady,
        install (app) {
            const router = this;
            app.component('RouterLink', $a809ac530d32f081$export$fce709ebdac448ed);
            app.component('RouterView', $a809ac530d32f081$export$d941f00e9b9a537);
            app.config.globalProperties.$router = router;
            Object.defineProperty(app.config.globalProperties, '$route', {
                enumerable: true,
                get: ()=>(0, $01W3b.unref)(currentRoute)
            });
            // this initial navigation is only necessary on client, on server it doesn't
            // make sense because it will create an extra unnecessary navigation and could
            // lead to problems
            if ($a809ac530d32f081$var$isBrowser && // used for the initial navigation client side to avoid pushing
            // multiple times when the router is used in multiple apps
            !started && currentRoute.value === $a809ac530d32f081$export$e44be9a9779c480b) {
                // see above
                started = true;
                push(routerHistory.location).catch((err)=>{});
            }
            const reactiveRoute = {};
            for(const key in $a809ac530d32f081$export$e44be9a9779c480b)// @ts-expect-error: the key matches
            reactiveRoute[key] = (0, $01W3b.computed)(()=>currentRoute.value[key]);
            app.provide($a809ac530d32f081$export$b6c0da8b9dae491f, router);
            app.provide($a809ac530d32f081$export$3aca783e9a3e6e9e, (0, $01W3b.reactive)(reactiveRoute));
            app.provide($a809ac530d32f081$export$54c8124bead129f8, currentRoute);
            const unmountApp = app.unmount;
            installedApps.add(app);
            app.unmount = function() {
                installedApps.delete(app);
                // the router is not attached to an app anymore
                if (installedApps.size < 1) {
                    // invalidate the current navigation
                    pendingLocation = $a809ac530d32f081$export$e44be9a9779c480b;
                    removeHistoryListener && removeHistoryListener();
                    removeHistoryListener = null;
                    currentRoute.value = $a809ac530d32f081$export$e44be9a9779c480b;
                    started = false;
                    ready = false;
                }
                unmountApp();
            };
            // TODO: this probably needs to be updated so it can be used by vue-termui
            if (__VUE_PROD_DEVTOOLS__ && $a809ac530d32f081$var$isBrowser) $a809ac530d32f081$var$addDevtools(app, router, matcher);
        }
    };
    return router;
}
function $a809ac530d32f081$var$runGuardQueue(guards) {
    return guards.reduce((promise, guard)=>promise.then(()=>guard()), Promise.resolve());
}
function $a809ac530d32f081$var$extractChangingRecords(to, from) {
    const leavingRecords = [];
    const updatingRecords = [];
    const enteringRecords = [];
    const len = Math.max(from.matched.length, to.matched.length);
    for(let i = 0; i < len; i++){
        const recordFrom = from.matched[i];
        if (recordFrom) {
            if (to.matched.find((record)=>$a809ac530d32f081$var$isSameRouteRecord(record, recordFrom))) updatingRecords.push(recordFrom);
            else leavingRecords.push(recordFrom);
        }
        const recordTo = to.matched[i];
        if (recordTo) // the type doesn't matter because we are comparing per reference
        {
            if (!from.matched.find((record)=>$a809ac530d32f081$var$isSameRouteRecord(record, recordTo))) enteringRecords.push(recordTo);
        }
    }
    return [
        leavingRecords,
        updatingRecords,
        enteringRecords
    ];
}
/**
 * Returns the router instance. Equivalent to using `$router` inside
 * templates.
 */ function $a809ac530d32f081$export$9a302a45f65d0572() {
    return (0, $TusQn.inject)($a809ac530d32f081$export$b6c0da8b9dae491f);
}
/**
 * Returns the current route location. Equivalent to using `$route` inside
 * templates.
 */ function $a809ac530d32f081$export$3f79f0b98112cf57() {
    return (0, $TusQn.inject)($a809ac530d32f081$export$3aca783e9a3e6e9e);
}

});
parcelRegister("j6G8F", function(module, exports) {

$parcel$export(module.exports, "setupDevtoolsPlugin", () => $de8f43bece76d38a$export$63b9a9bba9f20f3e);

var $jiSSU = parcelRequire("jiSSU");

var $7mHjb = parcelRequire("7mHjb");

var $83xTH = parcelRequire("83xTH");



function $de8f43bece76d38a$export$63b9a9bba9f20f3e(pluginDescriptor, setupFn) {
    const descriptor = pluginDescriptor;
    const target = (0, $jiSSU.getTarget)();
    const hook = (0, $jiSSU.getDevtoolsGlobalHook)();
    const enableProxy = (0, $jiSSU.isProxyAvailable) && descriptor.enableEarlyProxy;
    if (hook && (target.__VUE_DEVTOOLS_PLUGIN_API_AVAILABLE__ || !enableProxy)) hook.emit((0, $7mHjb.HOOK_SETUP), pluginDescriptor, setupFn);
    else {
        const proxy = enableProxy ? new (0, $83xTH.ApiProxy)(descriptor, hook) : null;
        const list = target.__VUE_DEVTOOLS_PLUGINS__ = target.__VUE_DEVTOOLS_PLUGINS__ || [];
        list.push({
            pluginDescriptor: descriptor,
            setupFn: setupFn,
            proxy: proxy
        });
        if (proxy) setupFn(proxy.proxiedTarget);
    }
}

});
parcelRegister("jiSSU", function(module, exports) {

$parcel$export(module.exports, "getDevtoolsGlobalHook", () => $e0da45b668fffb6e$export$5a2d366b2d9f38f6);
$parcel$export(module.exports, "getTarget", () => $e0da45b668fffb6e$export$c22522a4dfa48e9c);
$parcel$export(module.exports, "isProxyAvailable", () => $e0da45b668fffb6e$export$bc32a04c49ed7464);
function $e0da45b668fffb6e$export$5a2d366b2d9f38f6() {
    return $e0da45b668fffb6e$export$c22522a4dfa48e9c().__VUE_DEVTOOLS_GLOBAL_HOOK__;
}
function $e0da45b668fffb6e$export$c22522a4dfa48e9c() {
    // @ts-ignore
    return typeof navigator !== 'undefined' && typeof window !== 'undefined' ? window : typeof $parcel$global !== 'undefined' ? $parcel$global : {};
}
const $e0da45b668fffb6e$export$bc32a04c49ed7464 = typeof Proxy === 'function';

});

parcelRegister("7mHjb", function(module, exports) {

$parcel$export(module.exports, "HOOK_SETUP", () => $55cc2ea2e53f2ca6$export$b1499c3bd2a3f4df);
$parcel$export(module.exports, "HOOK_PLUGIN_SETTINGS_SET", () => $55cc2ea2e53f2ca6$export$a0897f44accbe922);
const $55cc2ea2e53f2ca6$export$b1499c3bd2a3f4df = 'devtools-plugin:setup';
const $55cc2ea2e53f2ca6$export$a0897f44accbe922 = 'plugin:settings:set';

});

parcelRegister("83xTH", function(module, exports) {

$parcel$export(module.exports, "ApiProxy", () => $5dd8e5d828be8ae1$export$5728f3776e9b2ac1);

var $7mHjb = parcelRequire("7mHjb");

var $2QQ8V = parcelRequire("2QQ8V");
class $5dd8e5d828be8ae1$export$5728f3776e9b2ac1 {
    constructor(plugin, hook){
        this.target = null;
        this.targetQueue = [];
        this.onQueue = [];
        this.plugin = plugin;
        this.hook = hook;
        const defaultSettings = {};
        if (plugin.settings) for(const id in plugin.settings){
            const item = plugin.settings[id];
            defaultSettings[id] = item.defaultValue;
        }
        const localSettingsSaveId = `__vue-devtools-plugin-settings__${plugin.id}`;
        let currentSettings = Object.assign({}, defaultSettings);
        try {
            const raw = localStorage.getItem(localSettingsSaveId);
            const data = JSON.parse(raw);
            Object.assign(currentSettings, data);
        } catch (e) {
        // noop
        }
        this.fallbacks = {
            getSettings () {
                return currentSettings;
            },
            setSettings (value) {
                try {
                    localStorage.setItem(localSettingsSaveId, JSON.stringify(value));
                } catch (e) {
                // noop
                }
                currentSettings = value;
            },
            now () {
                return (0, $2QQ8V.now)();
            }
        };
        if (hook) hook.on((0, $7mHjb.HOOK_PLUGIN_SETTINGS_SET), (pluginId, value)=>{
            if (pluginId === this.plugin.id) this.fallbacks.setSettings(value);
        });
        this.proxiedOn = new Proxy({}, {
            get: (_target, prop)=>{
                if (this.target) return this.target.on[prop];
                else return (...args)=>{
                    this.onQueue.push({
                        method: prop,
                        args: args
                    });
                };
            }
        });
        this.proxiedTarget = new Proxy({}, {
            get: (_target, prop)=>{
                if (this.target) return this.target[prop];
                else if (prop === 'on') return this.proxiedOn;
                else if (Object.keys(this.fallbacks).includes(prop)) return (...args)=>{
                    this.targetQueue.push({
                        method: prop,
                        args: args,
                        resolve: ()=>{}
                    });
                    return this.fallbacks[prop](...args);
                };
                else return (...args)=>{
                    return new Promise((resolve)=>{
                        this.targetQueue.push({
                            method: prop,
                            args: args,
                            resolve: resolve
                        });
                    });
                };
            }
        });
    }
    async setRealTarget(target) {
        this.target = target;
        for (const item of this.onQueue)this.target.on[item.method](...item.args);
        for (const item of this.targetQueue)item.resolve(await this.target[item.method](...item.args));
    }
}

});
parcelRegister("2QQ8V", function(module, exports) {

$parcel$export(module.exports, "now", () => $2138e2947b5f69c4$export$461939dd4422153);
let $2138e2947b5f69c4$var$supported;
let $2138e2947b5f69c4$var$perf;
function $2138e2947b5f69c4$export$70d26280bc1ca547() {
    var _a;
    if ($2138e2947b5f69c4$var$supported !== undefined) return $2138e2947b5f69c4$var$supported;
    if (typeof window !== 'undefined' && window.performance) {
        $2138e2947b5f69c4$var$supported = true;
        $2138e2947b5f69c4$var$perf = window.performance;
    } else if (typeof $parcel$global !== 'undefined' && ((_a = $parcel$global.perf_hooks) === null || _a === void 0 ? void 0 : _a.performance)) {
        $2138e2947b5f69c4$var$supported = true;
        $2138e2947b5f69c4$var$perf = $parcel$global.perf_hooks.performance;
    } else $2138e2947b5f69c4$var$supported = false;
    return $2138e2947b5f69c4$var$supported;
}
function $2138e2947b5f69c4$export$461939dd4422153() {
    return $2138e2947b5f69c4$export$70d26280bc1ca547() ? $2138e2947b5f69c4$var$perf.now() : Date.now();
}

});




parcelRegister("1kaYI", function(module, exports) {

$parcel$export(module.exports, "default", () => $0f702cbdb726fc33$export$2e2bcd8739ae039);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
function $0f702cbdb726fc33$export$2e2bcd8739ae039(_ctx, _cache) {
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        fill: "currentColor",
        "aria-hidden": "true"
    }, [
        (0, $TusQn.createElementVNode)("path", {
            "fill-rule": "evenodd",
            d: "M5.47 5.47a.75.75 0 011.06 0L12 10.94l5.47-5.47a.75.75 0 111.06 1.06L13.06 12l5.47 5.47a.75.75 0 11-1.06 1.06L12 13.06l-5.47 5.47a.75.75 0 01-1.06-1.06L10.94 12 5.47 6.53a.75.75 0 010-1.06z",
            "clip-rule": "evenodd"
        })
    ]);
}

});

parcelRegister("gYKPF", function(module, exports) {

$parcel$export(module.exports, "MODAL_COMPONENTS", () => $c5c693e2bd23de75$export$56d17fa14a38c877);
$parcel$export(module.exports, "currentModalComponent", () => $c5c693e2bd23de75$export$f07f2c5eed748f38);
$parcel$export(module.exports, "state", () => $c5c693e2bd23de75$export$ca000e230c0caa3e);
$parcel$export(module.exports, "pushAlert", () => $c5c693e2bd23de75$export$c8e273c1dab09d1e);
$parcel$export(module.exports, "onLikeButtonClicked", () => $c5c693e2bd23de75$export$fd2b038c0654ae65);
$parcel$export(module.exports, "onMakeRequestButtonClick", () => $c5c693e2bd23de75$export$61cbffc15c376687);
$parcel$export(module.exports, "setCurrentModalComponent", () => $c5c693e2bd23de75$export$79cae6510d3a509a);
$parcel$export(module.exports, "onUpdateButtonClicked", () => $c5c693e2bd23de75$export$995021ffbe4967de);
$parcel$export(module.exports, "onDeleteButtonClicked", () => $c5c693e2bd23de75$export$3227d4137ad158d);
$parcel$export(module.exports, "onReleaseButtonClicked", () => $c5c693e2bd23de75$export$2626363779f91651);
$parcel$export(module.exports, "closeModal", () => $c5c693e2bd23de75$export$3f6fecd573f3fa48);
$parcel$export(module.exports, "isAuthenticated", () => $c5c693e2bd23de75$export$83d11f23a23d4a7c);
$parcel$export(module.exports, "isAdmin", () => $c5c693e2bd23de75$export$fc970ed23da99565);
$parcel$export(module.exports, "logUserOut", () => $c5c693e2bd23de75$export$901484478a11dbf7);
parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");

var $5ixTq = parcelRequire("5ixTq");

var $bjkdv = parcelRequire("bjkdv");

var $attCt = parcelRequire("attCt");

var $iT1d4 = parcelRequire("iT1d4");

var $6kcpF = parcelRequire("6kcpF");

var $gGcib = parcelRequire("gGcib");
const $c5c693e2bd23de75$export$56d17fa14a38c877 = {
    MAKE_REQUEST: (0, $bjkdv.default),
    UPDATE_REQUEST: (0, $attCt.default),
    DELETE_REQUEST: (0, $iT1d4.default),
    RELEASE_REQUEST: (0, $6kcpF.default)
};
const $c5c693e2bd23de75$export$f07f2c5eed748f38 = (0, $01W3b.markRaw)({
    request: null,
    callbackFunction: ()=>null,
    component: $c5c693e2bd23de75$export$56d17fa14a38c877.MAKE_REQUEST
});
const $c5c693e2bd23de75$export$ca000e230c0caa3e = (0, $01W3b.reactive)({
    isModalOpen: false,
    user: null,
    requests: null,
    searchRequestResult: null,
    requestsReleaseList: [],
    alerts: []
});
const $c5c693e2bd23de75$export$c8e273c1dab09d1e = (type, message, expiration = 3000)=>{
    const alertId = (0, $5ixTq.default)();
    $c5c693e2bd23de75$export$ca000e230c0caa3e.alerts.push({
        id: alertId,
        type: type,
        message: message
    });
    setTimeout(()=>{
        $c5c693e2bd23de75$export$ca000e230c0caa3e.alerts = $c5c693e2bd23de75$export$ca000e230c0caa3e.alerts.filter((alert)=>alert.id !== alertId);
    }, expiration);
};
const $c5c693e2bd23de75$export$fd2b038c0654ae65 = async (requests, logUserOutAndRedirectHomeFn)=>{
    try {
        const options = {
            method: 'PATCH',
            headers: {
                'Authorization': `Bearer ${(0, $gGcib.getToken)('token')}`
            }
        };
        const { _id: id } = requests[0];
        const response = await fetch(`${"https://scrapbook-concierge-requests-api-cr45w.ondigitalocean.app"}/user-requests/${id}/users/${$c5c693e2bd23de75$export$ca000e230c0caa3e.user.id}`, options);
        const result = await response.json();
        if (response.ok) requests.forEach((request)=>{
            if (!request) return;
            const isLiked = request.users.includes($c5c693e2bd23de75$export$ca000e230c0caa3e.user.id);
            if (isLiked) request.users = request.users.filter((userId)=>userId !== $c5c693e2bd23de75$export$ca000e230c0caa3e.user.id);
            else request.users.push($c5c693e2bd23de75$export$ca000e230c0caa3e.user.id);
        });
        else if (response.status === 401) {
            $c5c693e2bd23de75$export$c8e273c1dab09d1e('failure', 'You\'re not logged in');
            logUserOutAndRedirectHomeFn();
        } else if (response.status === 404) // alert( result.message );
        $c5c693e2bd23de75$export$c8e273c1dab09d1e('failure', result.message);
        else $c5c693e2bd23de75$export$c8e273c1dab09d1e('failure', result.message);
    } catch (error) {
        console.error(error);
    }
};
const $c5c693e2bd23de75$export$61cbffc15c376687 = ()=>{
    $c5c693e2bd23de75$export$79cae6510d3a509a($c5c693e2bd23de75$export$56d17fa14a38c877.MAKE_REQUEST, null);
    $c5c693e2bd23de75$export$a7f6cffb6b8ba11c();
};
const $c5c693e2bd23de75$export$995021ffbe4967de = (request)=>{
    $c5c693e2bd23de75$export$79cae6510d3a509a($c5c693e2bd23de75$export$56d17fa14a38c877.UPDATE_REQUEST, request);
    $c5c693e2bd23de75$export$a7f6cffb6b8ba11c();
};
const $c5c693e2bd23de75$export$3227d4137ad158d = (request)=>{
    $c5c693e2bd23de75$export$79cae6510d3a509a($c5c693e2bd23de75$export$56d17fa14a38c877.DELETE_REQUEST, request);
    $c5c693e2bd23de75$export$a7f6cffb6b8ba11c();
};
const $c5c693e2bd23de75$export$2626363779f91651 = ()=>{
    $c5c693e2bd23de75$export$79cae6510d3a509a($c5c693e2bd23de75$export$56d17fa14a38c877.RELEASE_REQUEST);
    $c5c693e2bd23de75$export$a7f6cffb6b8ba11c();
};
const $c5c693e2bd23de75$export$a7f6cffb6b8ba11c = ()=>{
    if (!$c5c693e2bd23de75$export$ca000e230c0caa3e.isModalOpen) $c5c693e2bd23de75$export$ca000e230c0caa3e.isModalOpen = true;
};
const $c5c693e2bd23de75$export$3f6fecd573f3fa48 = ()=>{
    if ($c5c693e2bd23de75$export$ca000e230c0caa3e.isModalOpen) $c5c693e2bd23de75$export$ca000e230c0caa3e.isModalOpen = false;
};
const $c5c693e2bd23de75$export$79cae6510d3a509a = (component, request = null, callbackFn)=>{
    $c5c693e2bd23de75$export$f07f2c5eed748f38.component = component;
    $c5c693e2bd23de75$export$f07f2c5eed748f38.request = request;
    $c5c693e2bd23de75$export$f07f2c5eed748f38.callbackFunction = callbackFn;
};
const $c5c693e2bd23de75$export$83d11f23a23d4a7c = ()=>{
    if ($c5c693e2bd23de75$export$ca000e230c0caa3e.user) return true;
    try {
        const token = (0, $gGcib.getToken)('token');
        const decodedToken = (0, $gGcib.decodeJWT)(token);
        if (!token || !decodedToken) return false;
        $c5c693e2bd23de75$export$ca000e230c0caa3e.user = decodedToken.payload;
        return true;
    } catch (error) {
        return false;
    }
};
const $c5c693e2bd23de75$export$fc970ed23da99565 = (0, $01W3b.computed)(()=>$c5c693e2bd23de75$export$ca000e230c0caa3e.user?.admin ?? false);
const $c5c693e2bd23de75$export$901484478a11dbf7 = ()=>{
    $c5c693e2bd23de75$export$ca000e230c0caa3e.user = null;
    (0, $gGcib.removeToken)('token');
};

});
parcelRegister("5ixTq", function(module, exports) {

$parcel$export(module.exports, "default", () => $3db8eca5d6d2d662$export$2e2bcd8739ae039);

var $dIA4B = parcelRequire("dIA4B");

var $8KGuT = parcelRequire("8KGuT");
function $3db8eca5d6d2d662$var$v4(options, buf, offset) {
    if (!buf && !options && crypto.randomUUID) return crypto.randomUUID();
    return $3db8eca5d6d2d662$var$_v4(options, buf, offset);
}
function $3db8eca5d6d2d662$var$_v4(options, buf, offset) {
    options = options || {};
    const rnds = options.random ?? options.rng?.() ?? (0, $dIA4B.default)();
    if (rnds.length < 16) throw new Error('Random bytes length must be >= 16');
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80;
    if (buf) {
        offset = offset || 0;
        if (offset < 0 || offset + 16 > buf.length) throw new RangeError(`UUID byte range ${offset}:${offset + 15} is out of buffer bounds`);
        for(let i = 0; i < 16; ++i)buf[offset + i] = rnds[i];
        return buf;
    }
    return (0, $8KGuT.unsafeStringify)(rnds);
}
var $3db8eca5d6d2d662$export$2e2bcd8739ae039 = $3db8eca5d6d2d662$var$v4;

});
parcelRegister("dIA4B", function(module, exports) {

$parcel$export(module.exports, "default", () => $9fcb5dcab6a2d3da$export$2e2bcd8739ae039);
const $9fcb5dcab6a2d3da$var$rnds8 = new Uint8Array(16);
function $9fcb5dcab6a2d3da$export$2e2bcd8739ae039() {
    return crypto.getRandomValues($9fcb5dcab6a2d3da$var$rnds8);
}

});

parcelRegister("8KGuT", function(module, exports) {

$parcel$export(module.exports, "unsafeStringify", () => $65f395b47d38ebfb$export$8fb373d660548968);

var $76Xhv = parcelRequire("76Xhv");
const $65f395b47d38ebfb$var$byteToHex = [];
for(let i = 0; i < 256; ++i)$65f395b47d38ebfb$var$byteToHex.push((i + 0x100).toString(16).slice(1));
function $65f395b47d38ebfb$export$8fb373d660548968(arr, offset = 0) {
    return ($65f395b47d38ebfb$var$byteToHex[arr[offset + 0]] + $65f395b47d38ebfb$var$byteToHex[arr[offset + 1]] + $65f395b47d38ebfb$var$byteToHex[arr[offset + 2]] + $65f395b47d38ebfb$var$byteToHex[arr[offset + 3]] + '-' + $65f395b47d38ebfb$var$byteToHex[arr[offset + 4]] + $65f395b47d38ebfb$var$byteToHex[arr[offset + 5]] + '-' + $65f395b47d38ebfb$var$byteToHex[arr[offset + 6]] + $65f395b47d38ebfb$var$byteToHex[arr[offset + 7]] + '-' + $65f395b47d38ebfb$var$byteToHex[arr[offset + 8]] + $65f395b47d38ebfb$var$byteToHex[arr[offset + 9]] + '-' + $65f395b47d38ebfb$var$byteToHex[arr[offset + 10]] + $65f395b47d38ebfb$var$byteToHex[arr[offset + 11]] + $65f395b47d38ebfb$var$byteToHex[arr[offset + 12]] + $65f395b47d38ebfb$var$byteToHex[arr[offset + 13]] + $65f395b47d38ebfb$var$byteToHex[arr[offset + 14]] + $65f395b47d38ebfb$var$byteToHex[arr[offset + 15]]).toLowerCase();
}
function $65f395b47d38ebfb$var$stringify(arr, offset = 0) {
    const uuid = $65f395b47d38ebfb$export$8fb373d660548968(arr, offset);
    if (!(0, $76Xhv.default)(uuid)) throw TypeError('Stringified UUID is invalid');
    return uuid;
}
var $65f395b47d38ebfb$export$2e2bcd8739ae039 = $65f395b47d38ebfb$var$stringify;

});
parcelRegister("76Xhv", function(module, exports) {

$parcel$export(module.exports, "default", () => $52d713fa7bd02880$export$2e2bcd8739ae039);

var $4FOdT = parcelRequire("4FOdT");
function $52d713fa7bd02880$var$validate(uuid) {
    return typeof uuid === 'string' && (0, $4FOdT.default).test(uuid);
}
var $52d713fa7bd02880$export$2e2bcd8739ae039 = $52d713fa7bd02880$var$validate;

});
parcelRegister("4FOdT", function(module, exports) {

$parcel$export(module.exports, "default", () => $3671f3031881591e$export$2e2bcd8739ae039);
var $3671f3031881591e$export$2e2bcd8739ae039 = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/i;

});




parcelRegister("bjkdv", function(module, exports) {

$parcel$export(module.exports, "default", () => $83c126b372f243f9$export$2e2bcd8739ae039);
let $83c126b372f243f9$var$script;



let $83c126b372f243f9$var$initialize = ()=>{
    $83c126b372f243f9$var$script = (parcelRequire("8Za8R"));
    if ($83c126b372f243f9$var$script.__esModule) $83c126b372f243f9$var$script = $83c126b372f243f9$var$script.default;
    $83c126b372f243f9$var$script.render = (parcelRequire("by8Bq")).render;
    (parcelRequire("3GK8t")).default($83c126b372f243f9$var$script);
    $83c126b372f243f9$var$script.__scopeId = 'data-v-5af3bd';
    $83c126b372f243f9$var$script.__file = "make-request.vue";
};
$83c126b372f243f9$var$initialize();
var $83c126b372f243f9$export$2e2bcd8739ae039 = $83c126b372f243f9$var$script;

});
parcelRegister("by8Bq", function(module, exports) {

$parcel$export(module.exports, "render", () => $86898afce98bd028$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
var $eeJ70 = parcelRequire("eeJ70");
const $86898afce98bd028$var$_hoisted_1 = {
    class: "mb-3"
};
const $86898afce98bd028$var$_hoisted_2 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("legend", {
    class: "mb-4 text-xl text-center font-bold"
}, "Make Request", -1);
const $86898afce98bd028$var$_hoisted_3 = {
    class: "w-full"
};
const $86898afce98bd028$var$_hoisted_4 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("label", {
    for: "request"
}, null, -1);
const $86898afce98bd028$var$_hoisted_5 = {
    class: "text-xs text-right"
};
const $86898afce98bd028$var$_hoisted_6 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("button", {
    class: "block px-4 py-2 mx-auto bg-purple-800 text-white rounded",
    type: "submit"
}, " Submit Request ", -1);
function $86898afce98bd028$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("form", {
        class: "relative w-full max-w-sm px-5 py-8 border shadow rounded bg-white",
        onSubmit: $setup.onRequestSubmit
    }, [
        (0, $TusQn.createElementVNode)("button", {
            class: "absolute top-2 right-2 p-1 rounded-full bg-red-700",
            type: "button",
            onClick: _cache[0] || (_cache[0] = (...args)=>$setup.closeModal && $setup.closeModal(...args))
        }, [
            (0, $TusQn.createVNode)($setup["XMarkIcon"], {
                class: "h-6 w-6 text-white"
            })
        ]),
        (0, $TusQn.createElementVNode)("fieldset", $86898afce98bd028$var$_hoisted_1, [
            $86898afce98bd028$var$_hoisted_2,
            (0, $TusQn.createElementVNode)("div", $86898afce98bd028$var$_hoisted_3, [
                $86898afce98bd028$var$_hoisted_4,
                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("textarea", {
                    ref: "textAreaElement",
                    class: "w-full rounded",
                    name: "request",
                    id: "request",
                    maxlength: "100",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event)=>$setup.requestValue = $event),
                    placeholder: "Enter Title",
                    required: ""
                }, "\n        \n        ", 512), [
                    [
                        (0, $eeJ70.vModelText),
                        $setup.requestValue
                    ]
                ])
            ]),
            (0, $TusQn.createElementVNode)("p", $86898afce98bd028$var$_hoisted_5, (0, $8POXm.toDisplayString)($setup.numberOfCharactersLeft) + " characters left. ", 1)
        ]),
        $86898afce98bd028$var$_hoisted_6
    ], 32);
}

});

parcelRegister("3GK8t", function(module, exports) {

$parcel$export(module.exports, "default", () => $2af914eec39e0e4d$export$2e2bcd8739ae039);
let $2af914eec39e0e4d$var$NOOP = ()=>{};
var $2af914eec39e0e4d$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRegister("attCt", function(module, exports) {

$parcel$export(module.exports, "default", () => $7a0396a37dbfd36e$export$2e2bcd8739ae039);
let $7a0396a37dbfd36e$var$script;




let $7a0396a37dbfd36e$var$initialize = ()=>{
    $7a0396a37dbfd36e$var$script = (parcelRequire("056TF"));
    if ($7a0396a37dbfd36e$var$script.__esModule) $7a0396a37dbfd36e$var$script = $7a0396a37dbfd36e$var$script.default;
    $7a0396a37dbfd36e$var$script.render = (parcelRequire("gbaf1")).render;
    $7a0396a37dbfd36e$var$script.__cssModules = {};
    (parcelRequire("lsewB")).default($7a0396a37dbfd36e$var$script);
    $7a0396a37dbfd36e$var$script.__scopeId = 'data-v-c6674d';
    $7a0396a37dbfd36e$var$script.__file = "update-request.vue";
};
$7a0396a37dbfd36e$var$initialize();
var $7a0396a37dbfd36e$export$2e2bcd8739ae039 = $7a0396a37dbfd36e$var$script;

});
parcelRegister("056TF", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $00f5d1527fb24c4b$export$2e2bcd8739ae039);
parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");
var $TusQn = parcelRequire("TusQn");

var $73mM4 = parcelRequire("73mM4");

var $gYKPF = parcelRequire("gYKPF");

var $gGcib = parcelRequire("gGcib");

var $1kaYI = parcelRequire("1kaYI");
var $00f5d1527fb24c4b$export$2e2bcd8739ae039 = {
    __name: 'update-request',
    setup (__props, { expose: expose }) {
        expose();
        const router = (0, $73mM4.useRouter)();
        const textAreaElement = (0, $01W3b.ref)(null);
        const request = (0, $gYKPF.currentModalComponent).request;
        const requestTitle = (0, $01W3b.ref)(request.title);
        const requestURL = (0, $01W3b.ref)(request.url);
        const requestReleased = (0, $01W3b.ref)(request.released ? 'true' : 'false');
        const isUrlField = (0, $01W3b.computed)(()=>requestReleased.value === 'true' && (0, $gYKPF.isAdmin));
        const numberOfCharactersLeft = (0, $01W3b.computed)(()=>{
            return requestTitle.value ? 100 - requestTitle.value.length : 100;
        });
        const onRequestUpdate = async (event)=>{
            event.preventDefault();
            try {
                const data = JSON.stringify({
                    title: requestTitle.value,
                    url: requestURL.value,
                    released: requestReleased.value
                });
                const options = {
                    method: 'PATCH',
                    body: data,
                    headers: {
                        'Authorization': `Bearer ${(0, $gGcib.getToken)('token')}`,
                        'Content-Type': 'application/json'
                    }
                };
                let response = await fetch(`${"https://scrapbook-concierge-requests-api-cr45w.ondigitalocean.app"}/requests/${(0, $gYKPF.currentModalComponent).request._id}/users/${(0, $gYKPF.state).user.id}`, options);
                let result = await response.json();
                if (response.ok) {
                    [
                        (0, $gYKPF.state).requests,
                        (0, $gYKPF.state).searchRequestResult
                    ].forEach((requestList)=>{
                        if (!requestList) return;
                        const requestIndex = requestList?.findIndex((request)=>request._id === (0, $gYKPF.currentModalComponent).request._id);
                        if (requestIndex !== -1) requestList.splice(requestIndex, 1, result.request);
                    });
                    (0, $gYKPF.pushAlert)('success', result.message);
                    (0, $gYKPF.closeModal)();
                } else if (response.status === 401) {
                    (0, $gYKPF.pushAlert)('failure', 'You\'re not logged in.');
                    (0, $gYKPF.logUserOut)();
                    router.push({
                        name: 'login'
                    });
                } else if (response.status === 404) (0, $gYKPF.pushAlert)('failure', result.message);
                else (0, $gYKPF.pushAlert)('failure', result.message);
            } catch (error) {
                console.warn(error);
                (0, $gYKPF.pushAlert)('failure', 'An Error occurred while updating the request. Try again later.');
            }
        };
        (0, $TusQn.onMounted)(()=>textAreaElement.value.focus());
        const __returned__ = {
            router: router,
            textAreaElement: textAreaElement,
            request: request,
            requestTitle: requestTitle,
            requestURL: requestURL,
            requestReleased: requestReleased,
            isUrlField: isUrlField,
            numberOfCharactersLeft: numberOfCharactersLeft,
            onRequestUpdate: onRequestUpdate,
            ref: $01W3b.ref,
            computed: $01W3b.computed,
            onMounted: $TusQn.onMounted,
            useRouter: $73mM4.useRouter,
            state: $gYKPF.state,
            isAdmin: $gYKPF.isAdmin,
            currentModalComponent: $gYKPF.currentModalComponent,
            closeModal: $gYKPF.closeModal,
            isAuthenticated: $gYKPF.isAuthenticated,
            logUserOut: $gYKPF.logUserOut,
            pushAlert: $gYKPF.pushAlert,
            getToken: $gGcib.getToken,
            XMarkIcon: $1kaYI.default
        };
        Object.defineProperty(__returned__, '__isScriptSetup', {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
};

});
parcelRegister("gGcib", function(module, exports) {

$parcel$export(module.exports, "formatDate", () => $c24a1a98a21ce8e1$export$3ae94a2503e890a1);
$parcel$export(module.exports, "getToken", () => $c24a1a98a21ce8e1$export$257b2d10b709d8ef);
$parcel$export(module.exports, "removeToken", () => $c24a1a98a21ce8e1$export$4f1f8da95a8f66ea);
$parcel$export(module.exports, "decodeJWT", () => $c24a1a98a21ce8e1$export$9a62e6c0a30e00bc);
function $c24a1a98a21ce8e1$export$3ae94a2503e890a1(dateString) {
    const options = {
        year: 'numeric',
        month: 'numeric',
        day: 'numeric'
    };
    return dateString ? new Date(dateString).toLocaleDateString('en-US', options) : null;
}
function $c24a1a98a21ce8e1$export$257b2d10b709d8ef(name = 'token') {
    return localStorage.getItem(name);
}
function $c24a1a98a21ce8e1$export$4f1f8da95a8f66ea(name = 'token') {
    localStorage.removeItem(name);
}
function $c24a1a98a21ce8e1$export$9a62e6c0a30e00bc(token) {
    const tokenParts = token.split('.');
    if (tokenParts.length !== 3) throw new Error('Invalid token format');
    const header = JSON.parse(atob(tokenParts[0]));
    const payload = JSON.parse(atob(tokenParts[1]));
    return {
        header: header,
        payload: payload
    };
}

});


parcelRegister("gbaf1", function(module, exports) {

$parcel$export(module.exports, "render", () => $030a27b62798789a$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
var $eeJ70 = parcelRequire("eeJ70");
const $030a27b62798789a$var$_withScopeId = (n)=>((0, $TusQn.pushScopeId)("data-v-c6674d"), n = n(), (0, $TusQn.popScopeId)(), n);
const $030a27b62798789a$var$_hoisted_1 = {
    class: "mb-8"
};
const $030a27b62798789a$var$_hoisted_2 = /*#__PURE__*/ $030a27b62798789a$var$_withScopeId(()=>/*#__PURE__*/ (0, $TusQn.createElementVNode)("legend", {
        class: "mb-4 text-xl text-center font-bold"
    }, " Update Request ", -1));
const $030a27b62798789a$var$_hoisted_3 = {
    key: 0,
    class: "mb-4"
};
const $030a27b62798789a$var$_hoisted_4 = /*#__PURE__*/ $030a27b62798789a$var$_withScopeId(()=>/*#__PURE__*/ (0, $TusQn.createElementVNode)("label", {
        class: "block mb-1",
        for: "url"
    }, "URL", -1));
const $030a27b62798789a$var$_hoisted_5 = [
    "required"
];
const $030a27b62798789a$var$_hoisted_6 = {
    class: "mb-4"
};
const $030a27b62798789a$var$_hoisted_7 = {
    class: "w-full"
};
const $030a27b62798789a$var$_hoisted_8 = /*#__PURE__*/ $030a27b62798789a$var$_withScopeId(()=>/*#__PURE__*/ (0, $TusQn.createElementVNode)("label", {
        class: "block mb-1",
        for: "request"
    }, "Title", -1));
const $030a27b62798789a$var$_hoisted_9 = {
    class: "text-xs text-right"
};
const $030a27b62798789a$var$_hoisted_10 = /*#__PURE__*/ $030a27b62798789a$var$_withScopeId(()=>/*#__PURE__*/ (0, $TusQn.createElementVNode)("p", {
        class: "block mb-1"
    }, "Released", -1));
const $030a27b62798789a$var$_hoisted_11 = {
    class: "flex items-center gap-x-2 mb-1"
};
const $030a27b62798789a$var$_hoisted_12 = /*#__PURE__*/ $030a27b62798789a$var$_withScopeId(()=>/*#__PURE__*/ (0, $TusQn.createElementVNode)("label", {
        for: "true"
    }, "True", -1));
const $030a27b62798789a$var$_hoisted_13 = {
    class: "flex items-center gap-x-2"
};
const $030a27b62798789a$var$_hoisted_14 = /*#__PURE__*/ $030a27b62798789a$var$_withScopeId(()=>/*#__PURE__*/ (0, $TusQn.createElementVNode)("label", {
        for: "false"
    }, "False", -1));
const $030a27b62798789a$var$_hoisted_15 = /*#__PURE__*/ $030a27b62798789a$var$_withScopeId(()=>/*#__PURE__*/ (0, $TusQn.createElementVNode)("button", {
        class: "block px-4 py-2 mx-auto bg-purple-800 text-white rounded",
        type: "submit"
    }, " Update Request ", -1));
function $030a27b62798789a$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("form", {
        class: "relative w-full max-w-sm px-5 py-8 border shadow rounded bg-white",
        onSubmit: $setup.onRequestUpdate
    }, [
        (0, $TusQn.createElementVNode)("button", {
            class: "absolute top-2 right-2 p-1 rounded-full bg-red-700",
            type: "button",
            onClick: _cache[0] || (_cache[0] = (...args)=>$setup.closeModal && $setup.closeModal(...args))
        }, [
            (0, $TusQn.createVNode)($setup["XMarkIcon"], {
                class: "h-6 w-6 text-white"
            })
        ]),
        (0, $TusQn.createElementVNode)("fieldset", $030a27b62798789a$var$_hoisted_1, [
            $030a27b62798789a$var$_hoisted_2,
            (0, $TusQn.createVNode)((0, $eeJ70.Transition), null, {
                default: (0, $TusQn.withCtx)(()=>[
                        $setup.isUrlField ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $030a27b62798789a$var$_hoisted_3, [
                            $030a27b62798789a$var$_hoisted_4,
                            (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                                class: "w-full rounded",
                                type: "text",
                                name: "url",
                                id: "url",
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event)=>$setup.requestURL = $event),
                                required: $setup.isAdmin && $setup.requestReleased
                            }, null, 8, $030a27b62798789a$var$_hoisted_5), [
                                [
                                    (0, $eeJ70.vModelText),
                                    $setup.requestURL
                                ]
                            ])
                        ])) : (0, $TusQn.createCommentVNode)("", true)
                    ]),
                _: 1
            }),
            (0, $TusQn.createElementVNode)("div", $030a27b62798789a$var$_hoisted_6, [
                (0, $TusQn.createElementVNode)("div", $030a27b62798789a$var$_hoisted_7, [
                    $030a27b62798789a$var$_hoisted_8,
                    (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("textarea", {
                        ref: "textAreaElement",
                        class: "w-full rounded font-medium",
                        name: "request",
                        id: "request",
                        maxlength: "100",
                        onFocusout: _cache[2] || (_cache[2] = (...args)=>_ctx.onTitleTextAreaFocusOut && _ctx.onTitleTextAreaFocusOut(...args)),
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event)=>$setup.requestTitle = $event),
                        required: ""
                    }, "\n          \n          ", 544), [
                        [
                            (0, $eeJ70.vModelText),
                            $setup.requestTitle
                        ]
                    ])
                ]),
                (0, $TusQn.createElementVNode)("p", $030a27b62798789a$var$_hoisted_9, (0, $8POXm.toDisplayString)($setup.numberOfCharactersLeft) + " characters left. ", 1)
            ]),
            (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("div", null, [
                $030a27b62798789a$var$_hoisted_10,
                (0, $TusQn.createElementVNode)("div", $030a27b62798789a$var$_hoisted_11, [
                    (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                        class: "text-purple-800 focus:ring-purple-800",
                        type: "radio",
                        name: "released",
                        id: "true",
                        value: "true",
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event)=>$setup.requestReleased = $event)
                    }, null, 512), [
                        [
                            (0, $eeJ70.vModelRadio),
                            $setup.requestReleased
                        ]
                    ]),
                    $030a27b62798789a$var$_hoisted_12
                ]),
                (0, $TusQn.createElementVNode)("div", $030a27b62798789a$var$_hoisted_13, [
                    (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                        class: "text-purple-800 focus:ring-purple-800",
                        type: "radio",
                        name: "released",
                        id: "false",
                        value: "false",
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event)=>$setup.requestReleased = $event)
                    }, null, 512), [
                        [
                            (0, $eeJ70.vModelRadio),
                            $setup.requestReleased
                        ]
                    ]),
                    $030a27b62798789a$var$_hoisted_14
                ])
            ], 512), [
                [
                    (0, $eeJ70.vShow),
                    $setup.isAdmin
                ]
            ])
        ]),
        $030a27b62798789a$var$_hoisted_15
    ], 32);
}

});

parcelRegister("lsewB", function(module, exports) {

$parcel$export(module.exports, "default", () => $f9e77ad3f953e9da$export$2e2bcd8739ae039);
let $f9e77ad3f953e9da$var$NOOP = ()=>{};
var $f9e77ad3f953e9da$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRegister("iT1d4", function(module, exports) {

$parcel$export(module.exports, "default", () => $dbfe4d51641a618c$export$2e2bcd8739ae039);
let $dbfe4d51641a618c$var$script;



let $dbfe4d51641a618c$var$initialize = ()=>{
    $dbfe4d51641a618c$var$script = (parcelRequire("dqI2P"));
    if ($dbfe4d51641a618c$var$script.__esModule) $dbfe4d51641a618c$var$script = $dbfe4d51641a618c$var$script.default;
    $dbfe4d51641a618c$var$script.render = (parcelRequire("ayqWe")).render;
    (parcelRequire("6IcAu")).default($dbfe4d51641a618c$var$script);
    $dbfe4d51641a618c$var$script.__scopeId = 'data-v-b19307';
    $dbfe4d51641a618c$var$script.__file = "delete-request.vue";
};
$dbfe4d51641a618c$var$initialize();
var $dbfe4d51641a618c$export$2e2bcd8739ae039 = $dbfe4d51641a618c$var$script;

});
parcelRegister("dqI2P", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $9c6fde6b933302e7$export$2e2bcd8739ae039);
parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");

var $73mM4 = parcelRequire("73mM4");

var $gYKPF = parcelRequire("gYKPF");

var $gGcib = parcelRequire("gGcib");

var $1kaYI = parcelRequire("1kaYI");
var $9c6fde6b933302e7$export$2e2bcd8739ae039 = {
    __name: 'delete-request',
    setup (__props, { expose: expose }) {
        expose();
        const router = (0, $73mM4.useRouter)();
        const request = (0, $gYKPF.currentModalComponent).request;
        const requestValue = (0, $01W3b.ref)(request.title);
        const options = {
            method: 'DELETE',
            headers: {
                'Authorization': `Bearer ${(0, $gGcib.getToken)('token')}`,
                'Content-Type': 'application/json'
            }
        };
        const onDeleteRequest = async (event)=>{
            event.preventDefault();
            // if ( ! isAuthenticated() ) return router.push( { name: 'login' } );
            try {
                let response = await fetch(`${"https://scrapbook-concierge-requests-api-cr45w.ondigitalocean.app"}/requests/${(0, $gYKPF.currentModalComponent).request._id}/users/${(0, $gYKPF.state).user.id}`, options);
                let result = await response.json();
                if (response.ok) {
                    [
                        (0, $gYKPF.state).requests,
                        (0, $gYKPF.state).searchRequestResult
                    ].forEach((requestList)=>{
                        if (!requestList) return;
                        const requestIndex = requestList.findIndex((request)=>request._id === (0, $gYKPF.currentModalComponent).request._id);
                        if (requestIndex !== -1) requestList.splice(requestIndex, 1);
                    });
                    (0, $gYKPF.pushAlert)('success', result.message);
                    // currentModalComponent.callbackFunction();
                    (0, $gYKPF.closeModal)();
                } else if (response.status === 401) {
                    (0, $gYKPF.pushAlert)('failure', 'You\'re not logged in.');
                    (0, $gYKPF.logUserOut)();
                    router.push({
                        name: 'login'
                    });
                } else if (response.status === 404) (0, $gYKPF.pushAlert)('failure', result.message);
                else (0, $gYKPF.pushAlert)('failure', result.message);
            } catch (error) {
                console.warn(error);
                (0, $gYKPF.pushAlert)('failure', 'An Error occurred while deleting the request. Try again later.');
            }
        };
        const __returned__ = {
            router: router,
            request: request,
            requestValue: requestValue,
            options: options,
            onDeleteRequest: onDeleteRequest,
            ref: $01W3b.ref,
            useRouter: $73mM4.useRouter,
            state: $gYKPF.state,
            currentModalComponent: $gYKPF.currentModalComponent,
            closeModal: $gYKPF.closeModal,
            isAuthenticated: $gYKPF.isAuthenticated,
            logUserOut: $gYKPF.logUserOut,
            pushAlert: $gYKPF.pushAlert,
            getToken: $gGcib.getToken,
            XMarkIcon: $1kaYI.default
        };
        Object.defineProperty(__returned__, '__isScriptSetup', {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
};

});

parcelRegister("ayqWe", function(module, exports) {

$parcel$export(module.exports, "render", () => $7af1f9b9fdef8381$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $eeJ70 = parcelRequire("eeJ70");
const $7af1f9b9fdef8381$var$_hoisted_1 = {
    class: "relative w-full max-w-sm px-5 py-8 border shadow rounded bg-white"
};
const $7af1f9b9fdef8381$var$_hoisted_2 = {
    class: "mb-3"
};
const $7af1f9b9fdef8381$var$_hoisted_3 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("legend", {
    class: "mb-4 text-xl text-center font-bold"
}, "Delete Request", -1);
const $7af1f9b9fdef8381$var$_hoisted_4 = {
    class: "w-full"
};
const $7af1f9b9fdef8381$var$_hoisted_5 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("label", {
    for: "request"
}, null, -1);
function $7af1f9b9fdef8381$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("form", $7af1f9b9fdef8381$var$_hoisted_1, [
        (0, $TusQn.createElementVNode)("button", {
            class: "absolute top-2 right-2 p-1 rounded-full bg-red-700",
            type: "button",
            onClick: _cache[0] || (_cache[0] = (...args)=>$setup.closeModal && $setup.closeModal(...args))
        }, [
            (0, $TusQn.createVNode)($setup["XMarkIcon"], {
                class: "h-6 w-6 text-white"
            })
        ]),
        (0, $TusQn.createElementVNode)("fieldset", $7af1f9b9fdef8381$var$_hoisted_2, [
            $7af1f9b9fdef8381$var$_hoisted_3,
            (0, $TusQn.createElementVNode)("div", $7af1f9b9fdef8381$var$_hoisted_4, [
                $7af1f9b9fdef8381$var$_hoisted_5,
                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("textarea", {
                    class: "w-full rounded",
                    name: "request",
                    id: "request",
                    maxlength: "100",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event)=>$setup.requestValue = $event),
                    disabled: ""
                }, null, 512), [
                    [
                        (0, $eeJ70.vModelText),
                        $setup.requestValue
                    ]
                ])
            ])
        ]),
        (0, $TusQn.createElementVNode)("button", {
            class: "block px-4 py-2 mx-auto bg-purple-800 text-white rounded",
            type: "submit",
            onClick: $setup.onDeleteRequest
        }, " Delete Request ")
    ]);
}

});

parcelRegister("6IcAu", function(module, exports) {

$parcel$export(module.exports, "default", () => $4e309dc374781a96$export$2e2bcd8739ae039);
let $4e309dc374781a96$var$NOOP = ()=>{};
var $4e309dc374781a96$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRegister("6kcpF", function(module, exports) {

$parcel$export(module.exports, "default", () => $49ae3d50af380703$export$2e2bcd8739ae039);
let $49ae3d50af380703$var$script;



let $49ae3d50af380703$var$initialize = ()=>{
    $49ae3d50af380703$var$script = (parcelRequire("4q9Dl"));
    if ($49ae3d50af380703$var$script.__esModule) $49ae3d50af380703$var$script = $49ae3d50af380703$var$script.default;
    $49ae3d50af380703$var$script.render = (parcelRequire("10SFm")).render;
    (parcelRequire("5YMvo")).default($49ae3d50af380703$var$script);
    $49ae3d50af380703$var$script.__scopeId = 'data-v-f3b414';
    $49ae3d50af380703$var$script.__file = "release-request.vue";
};
$49ae3d50af380703$var$initialize();
var $49ae3d50af380703$export$2e2bcd8739ae039 = $49ae3d50af380703$var$script;

});
parcelRegister("4q9Dl", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $3381102385ac4115$export$2e2bcd8739ae039);

var $73mM4 = parcelRequire("73mM4");

var $gYKPF = parcelRequire("gYKPF");

var $gGcib = parcelRequire("gGcib");

var $1DCs8 = parcelRequire("1DCs8");
var $1kaYI = parcelRequire("1kaYI");
var $3381102385ac4115$export$2e2bcd8739ae039 = {
    __name: 'release-request',
    setup (__props, { expose: expose }) {
        expose();
        const router = (0, $73mM4.useRouter)();
        function onRemoveButtonClick(id) {
            const index = (0, $gYKPF.state).requestsReleaseList.findIndex((request)=>request.id === id);
            if (index !== -1) (0, $gYKPF.state).requestsReleaseList.splice(index, 1);
        }
        const onEmailRequestersButtonClick = async ()=>{
            if (!(0, $gYKPF.isAdmin)) return router.push({
                name: 'home'
            });
            try {
                const requestIds = (0, $gYKPF.state).requestsReleaseList.map((request)=>request.id);
                const options = {
                    method: 'POST',
                    body: JSON.stringify({
                        requestIds: requestIds
                    }),
                    headers: {
                        'Authorization': `Bearer ${(0, $gGcib.getToken)('token')}`,
                        'Content-Type': 'application/json'
                    }
                };
                let response = await fetch(`${"https://scrapbook-concierge-requests-api-cr45w.ondigitalocean.app"}/notifications`, options);
                let result = await response.json();
                if (response.ok) {
                    (0, $gYKPF.pushAlert)('success', result.message);
                    (0, $gYKPF.closeModal)();
                } else if (response.status === 401) {
                    (0, $gYKPF.pushAlert)('failure', 'You\'re not logged in.');
                    (0, $gYKPF.logUserOut)();
                    router.push({
                        name: 'login'
                    });
                } else (0, $gYKPF.pushAlert)('failure', result.message);
            } catch (error) {
                console.warn(error);
                (0, $gYKPF.pushAlert)('failure', 'An Error occurred while emailing users. Try again later.');
            }
        };
        const __returned__ = {
            router: router,
            onRemoveButtonClick: onRemoveButtonClick,
            onEmailRequestersButtonClick: onEmailRequestersButtonClick,
            useRouter: $73mM4.useRouter,
            state: $gYKPF.state,
            closeModal: $gYKPF.closeModal,
            isAdmin: $gYKPF.isAdmin,
            logUserOut: $gYKPF.logUserOut,
            pushAlert: $gYKPF.pushAlert,
            getToken: $gGcib.getToken,
            XMarkIcon: $1kaYI.default,
            MinusCircleIcon: $1DCs8.default
        };
        Object.defineProperty(__returned__, '__isScriptSetup', {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
};

});
parcelRegister("1DCs8", function(module, exports) {

$parcel$export(module.exports, "default", () => $131742e6809a5b56$export$2e2bcd8739ae039);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
function $131742e6809a5b56$export$2e2bcd8739ae039(_ctx, _cache) {
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        fill: "currentColor",
        "aria-hidden": "true"
    }, [
        (0, $TusQn.createElementVNode)("path", {
            "fill-rule": "evenodd",
            d: "M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25zm3 10.5a.75.75 0 000-1.5H9a.75.75 0 000 1.5h6z",
            "clip-rule": "evenodd"
        })
    ]);
}

});


parcelRegister("10SFm", function(module, exports) {

$parcel$export(module.exports, "render", () => $0bd0321a3ee31dff$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
const $0bd0321a3ee31dff$var$_hoisted_1 = {
    class: "relative w-full max-w-sm px-5 py-8 border shadow rounded bg-white"
};
const $0bd0321a3ee31dff$var$_hoisted_2 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("h2", {
    class: "max-w-[200px] mx-auto mb-8 text-xl text-center font-bold"
}, " Requests ", -1);
const $0bd0321a3ee31dff$var$_hoisted_3 = {
    key: 0
};
const $0bd0321a3ee31dff$var$_hoisted_4 = {
    class: "mb-6 space-y-2"
};
const $0bd0321a3ee31dff$var$_hoisted_5 = [
    "onClick"
];
const $0bd0321a3ee31dff$var$_hoisted_6 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("p", {
    class: "mb-5 text-sm text-gray-500"
}, " Users that have submitted or liked the requested kits above will be notified by email of the release. ", -1);
const $0bd0321a3ee31dff$var$_hoisted_7 = {
    key: 1,
    class: "text-center"
};
function $0bd0321a3ee31dff$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $0bd0321a3ee31dff$var$_hoisted_1, [
        (0, $TusQn.createElementVNode)("button", {
            class: "absolute top-2 right-2 p-1 rounded-full bg-red-700",
            type: "button",
            onClick: _cache[0] || (_cache[0] = (...args)=>$setup.closeModal && $setup.closeModal(...args))
        }, [
            (0, $TusQn.createVNode)($setup["XMarkIcon"], {
                class: "h-6 w-6 text-white"
            })
        ]),
        (0, $TusQn.createElementVNode)("div", null, [
            $0bd0321a3ee31dff$var$_hoisted_2,
            $setup.state.requestsReleaseList.length ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $0bd0321a3ee31dff$var$_hoisted_3, [
                (0, $TusQn.createElementVNode)("ul", $0bd0321a3ee31dff$var$_hoisted_4, [
                    ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($setup.state.requestsReleaseList, ({ id: id, title: title })=>{
                        return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("li", {
                            key: id,
                            class: "flex justify-between items-center font-medium"
                        }, [
                            (0, $TusQn.createElementVNode)("span", null, (0, $8POXm.toDisplayString)(title), 1),
                            (0, $TusQn.createElementVNode)("button", {
                                onClick: ()=>$setup.onRemoveButtonClick(id),
                                type: "button",
                                "aria-label": "Remove Request from request list"
                            }, [
                                (0, $TusQn.createVNode)($setup["MinusCircleIcon"], {
                                    class: "h-7 w-7 fill-red-700"
                                })
                            ], 8, $0bd0321a3ee31dff$var$_hoisted_5)
                        ]);
                    }), 128))
                ]),
                $0bd0321a3ee31dff$var$_hoisted_6,
                (0, $TusQn.createElementVNode)("button", {
                    class: "block px-4 py-2 mx-auto bg-purple-800 text-white rounded",
                    type: "button",
                    onClick: $setup.onEmailRequestersButtonClick
                }, " Email Requesters ")
            ])) : ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("p", $0bd0321a3ee31dff$var$_hoisted_7, "Add Requests"))
        ])
    ]);
}

});

parcelRegister("5YMvo", function(module, exports) {

$parcel$export(module.exports, "default", () => $45a82e7ea783ee97$export$2e2bcd8739ae039);
let $45a82e7ea783ee97$var$NOOP = ()=>{};
var $45a82e7ea783ee97$export$2e2bcd8739ae039 = (script)=>{};

});




parcelRegister("6dIxi", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $487680e96ac0f0ab$export$2e2bcd8739ae039);

var $gYKPF = parcelRequire("gYKPF");

var $7bYVn = parcelRequire("7bYVn");

var $23Yvs = parcelRequire("23Yvs");
var $487680e96ac0f0ab$export$2e2bcd8739ae039 = {
    __name: 'app',
    setup (__props, { expose: expose }) {
        expose();
        const __returned__ = {
            state: $gYKPF.state,
            Modal: $7bYVn.default,
            Alerts: $23Yvs.default
        };
        Object.defineProperty(__returned__, '__isScriptSetup', {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
};

});
parcelRegister("7bYVn", function(module, exports) {

$parcel$export(module.exports, "default", () => $53c8d1ca304844c7$export$2e2bcd8739ae039);
let $53c8d1ca304844c7$var$script;



let $53c8d1ca304844c7$var$initialize = ()=>{
    $53c8d1ca304844c7$var$script = (parcelRequire("3wOL9"));
    if ($53c8d1ca304844c7$var$script.__esModule) $53c8d1ca304844c7$var$script = $53c8d1ca304844c7$var$script.default;
    $53c8d1ca304844c7$var$script.render = (parcelRequire("l6Ihp")).render;
    (parcelRequire("gWkPp")).default($53c8d1ca304844c7$var$script);
    $53c8d1ca304844c7$var$script.__scopeId = 'data-v-f76780';
    $53c8d1ca304844c7$var$script.__file = "modal.vue";
};
$53c8d1ca304844c7$var$initialize();
var $53c8d1ca304844c7$export$2e2bcd8739ae039 = $53c8d1ca304844c7$var$script;

});
parcelRegister("3wOL9", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $291bbc0ddf8e6024$export$2e2bcd8739ae039);

var $gYKPF = parcelRequire("gYKPF");
var $291bbc0ddf8e6024$export$2e2bcd8739ae039 = {
    __name: 'modal',
    setup (__props, { expose: expose }) {
        expose();
        const onModalBackgroundClicked = (event)=>{
            if (event.target.id === 'backdrop') (0, $gYKPF.closeModal)();
        };
        const __returned__ = {
            onModalBackgroundClicked: onModalBackgroundClicked,
            state: $gYKPF.state,
            closeModal: $gYKPF.closeModal,
            currentModalComponent: $gYKPF.currentModalComponent,
            setCurrentModalComponent: $gYKPF.setCurrentModalComponent,
            MODAL_COMPONENTS: $gYKPF.MODAL_COMPONENTS
        };
        Object.defineProperty(__returned__, '__isScriptSetup', {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
};

});

parcelRegister("l6Ihp", function(module, exports) {

$parcel$export(module.exports, "render", () => $f5dc8194ddad094e$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
function $f5dc8194ddad094e$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $TusQn.openBlock)(), (0, $TusQn.createBlock)((0, $TusQn.Teleport), {
        to: "body"
    }, [
        $setup.state.isModalOpen ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", {
            key: 0,
            role: "dialog",
            id: "backdrop",
            class: "fixed top-0 left-0 z-10 w-full h-full flex justify-center items-center bg-gradient-to-br from-[#000000b2] to-[#000000b2]",
            onClick: $setup.onModalBackgroundClicked
        }, [
            ((0, $TusQn.openBlock)(), (0, $TusQn.createBlock)((0, $TusQn.resolveDynamicComponent)($setup.currentModalComponent.component)))
        ])) : (0, $TusQn.createCommentVNode)("", true)
    ]);
}

});

parcelRegister("gWkPp", function(module, exports) {

$parcel$export(module.exports, "default", () => $c552382d8caf1c21$export$2e2bcd8739ae039);
let $c552382d8caf1c21$var$NOOP = ()=>{};
var $c552382d8caf1c21$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRegister("23Yvs", function(module, exports) {

$parcel$export(module.exports, "default", () => $180acbe206242b02$export$2e2bcd8739ae039);
let $180acbe206242b02$var$script;



let $180acbe206242b02$var$initialize = ()=>{
    $180acbe206242b02$var$script = (parcelRequire("5Ey32"));
    if ($180acbe206242b02$var$script.__esModule) $180acbe206242b02$var$script = $180acbe206242b02$var$script.default;
    $180acbe206242b02$var$script.render = (parcelRequire("c2uKC")).render;
    (parcelRequire("5Bmqu")).default($180acbe206242b02$var$script);
    $180acbe206242b02$var$script.__scopeId = 'data-v-bf1b37';
    $180acbe206242b02$var$script.__file = "alerts.vue";
};
$180acbe206242b02$var$initialize();
var $180acbe206242b02$export$2e2bcd8739ae039 = $180acbe206242b02$var$script;

});
parcelRegister("5Ey32", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $41db196757fccb09$export$2e2bcd8739ae039);

var $gYKPF = parcelRequire("gYKPF");
var // setTimeout( () => pushAlert( 'failure', '1. Failed test', 2000 ), 2000 );
// setTimeout( () => pushAlert( 'failure', '2. Failed test', 4000 ), 5000 );
// setTimeout( () => pushAlert( 'success', '3. Failed test', 6000 ), 8000 );
$41db196757fccb09$export$2e2bcd8739ae039 = {
    __name: 'alerts',
    setup (__props, { expose: expose }) {
        expose();
        const __returned__ = {
            state: $gYKPF.state,
            pushAlert: $gYKPF.pushAlert
        };
        Object.defineProperty(__returned__, '__isScriptSetup', {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
};

});

parcelRegister("c2uKC", function(module, exports) {

$parcel$export(module.exports, "render", () => $8c3d8672d21e227a$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
const $8c3d8672d21e227a$var$_hoisted_1 = {
    class: "fixed right-0 bottom-0 p-2 space-y-2"
};
function $8c3d8672d21e227a$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $TusQn.openBlock)(), (0, $TusQn.createBlock)((0, $TusQn.Teleport), {
        to: "body"
    }, [
        (0, $TusQn.createElementVNode)("div", $8c3d8672d21e227a$var$_hoisted_1, [
            ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($setup.state.alerts, (alert)=>{
                return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", {
                    key: alert.id,
                    role: "alert",
                    class: (0, $8POXm.normalizeClass)([
                        'p-2 rounded-md',
                        `${alert.type === 'success' ? 'bg-green-600 text-white' : 'bg-red-600 text-white'}`
                    ])
                }, [
                    (0, $TusQn.createElementVNode)("span", null, (0, $8POXm.toDisplayString)(alert.message), 1)
                ], 2);
            }), 128))
        ])
    ]);
}

});

parcelRegister("5Bmqu", function(module, exports) {

$parcel$export(module.exports, "default", () => $4141cddaf9c0af1a$export$2e2bcd8739ae039);
let $4141cddaf9c0af1a$var$NOOP = ()=>{};
var $4141cddaf9c0af1a$export$2e2bcd8739ae039 = (script)=>{};

});



parcelRegister("a5J4w", function(module, exports) {

$parcel$export(module.exports, "render", () => $01e56058313de704$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
const $01e56058313de704$var$_hoisted_1 = [
    "aria-hidden"
];
function $01e56058313de704$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_router_view = (0, $TusQn.resolveComponent)("router-view");
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, [
        (0, $TusQn.createElementVNode)("div", {
            "aria-hidden": !$setup.state.open
        }, [
            (0, $TusQn.createVNode)($setup["Modal"])
        ], 8, $01e56058313de704$var$_hoisted_1),
        (0, $TusQn.createVNode)($setup["Alerts"]),
        (0, $TusQn.createVNode)(_component_router_view)
    ], 64);
}

});

parcelRegister("fWmT1", function(module, exports) {

$parcel$export(module.exports, "default", () => $b9ae068fcaecdbed$export$2e2bcd8739ae039);
let $b9ae068fcaecdbed$var$NOOP = ()=>{};
var $b9ae068fcaecdbed$export$2e2bcd8739ae039 = (script)=>{};

});

parcelRegister("hmXi5", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $ca527ba9a90c52c8$export$2e2bcd8739ae039);

var $h7UQ3 = parcelRequire("h7UQ3");

var $38WoH = parcelRequire("38WoH");

var $7yIGu = parcelRequire("7yIGu");

var $2OXpE = parcelRequire("2OXpE");

var $izEgc = parcelRequire("izEgc");
var $ca527ba9a90c52c8$export$2e2bcd8739ae039 = {
    __name: 'home',
    setup (__props, { expose: expose }) {
        expose();
        const __returned__ = {
            Header: $h7UQ3.default,
            Footer: $38WoH.default,
            AllRequests: (/*@__PURE__*/$parcel$interopDefault($7yIGu)),
            MyRequests: (/*@__PURE__*/$parcel$interopDefault($2OXpE)),
            ReleasedRequests: (/*@__PURE__*/$parcel$interopDefault($izEgc))
        };
        Object.defineProperty(__returned__, '__isScriptSetup', {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
};

});
parcelRegister("h7UQ3", function(module, exports) {

$parcel$export(module.exports, "default", () => $c77f2e12f2990d0c$export$2e2bcd8739ae039);
let $c77f2e12f2990d0c$var$script;



let $c77f2e12f2990d0c$var$initialize = ()=>{
    $c77f2e12f2990d0c$var$script = (parcelRequire("lP9Fw"));
    if ($c77f2e12f2990d0c$var$script.__esModule) $c77f2e12f2990d0c$var$script = $c77f2e12f2990d0c$var$script.default;
    $c77f2e12f2990d0c$var$script.render = (parcelRequire("fmNaH")).render;
    (parcelRequire("1l3f9")).default($c77f2e12f2990d0c$var$script);
    $c77f2e12f2990d0c$var$script.__scopeId = 'data-v-b0f42f';
    $c77f2e12f2990d0c$var$script.__file = "header.vue";
};
$c77f2e12f2990d0c$var$initialize();
var $c77f2e12f2990d0c$export$2e2bcd8739ae039 = $c77f2e12f2990d0c$var$script;

});
parcelRegister("lP9Fw", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $0419a49639a187c7$export$2e2bcd8739ae039);
parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");

var $73mM4 = parcelRequire("73mM4");

var $l2e2S = parcelRequire("l2e2S");

var $gYKPF = parcelRequire("gYKPF");
var $0419a49639a187c7$export$2e2bcd8739ae039 = {
    __name: 'header',
    setup (__props, { expose: expose }) {
        expose();
        const router = (0, $73mM4.useRouter)();
        const route = (0, $73mM4.useRoute)();
        const navHTMLElement = (0, $01W3b.ref)(null);
        const isNavOpen = (0, $01W3b.ref)(false);
        const onMenuButtonClick = ()=>isNavOpen.value = !isNavOpen.value;
        const onLogoutButtonClick = ()=>{
            (0, $gYKPF.logUserOut)();
            router.push({
                name: 'home'
            });
        };
        const __returned__ = {
            router: router,
            route: route,
            navHTMLElement: navHTMLElement,
            isNavOpen: isNavOpen,
            onMenuButtonClick: onMenuButtonClick,
            onLogoutButtonClick: onLogoutButtonClick,
            ref: $01W3b.ref,
            useRoute: $73mM4.useRoute,
            useRouter: $73mM4.useRouter,
            Bars3Icon: $l2e2S.default,
            state: $gYKPF.state,
            isAdmin: $gYKPF.isAdmin,
            logUserOut: $gYKPF.logUserOut
        };
        Object.defineProperty(__returned__, '__isScriptSetup', {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
};

});
parcelRegister("l2e2S", function(module, exports) {

$parcel$export(module.exports, "default", () => $f504adfa265f1d46$export$2e2bcd8739ae039);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
function $f504adfa265f1d46$export$2e2bcd8739ae039(_ctx, _cache) {
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        fill: "currentColor",
        "aria-hidden": "true"
    }, [
        (0, $TusQn.createElementVNode)("path", {
            "fill-rule": "evenodd",
            d: "M3 6.75A.75.75 0 013.75 6h16.5a.75.75 0 010 1.5H3.75A.75.75 0 013 6.75zM3 12a.75.75 0 01.75-.75h16.5a.75.75 0 010 1.5H3.75A.75.75 0 013 12zm0 5.25a.75.75 0 01.75-.75h16.5a.75.75 0 010 1.5H3.75a.75.75 0 01-.75-.75z",
            "clip-rule": "evenodd"
        })
    ]);
}

});


parcelRegister("fmNaH", function(module, exports) {

$parcel$export(module.exports, "render", () => $b2ff0d8cd872b750$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
const $b2ff0d8cd872b750$var$_hoisted_1 = {
    class: "bg-purple-300"
};
const $b2ff0d8cd872b750$var$_hoisted_2 = {
    class: "max-w-5xl mx-auto flex justify-between items-center px-5 py-4"
};
const $b2ff0d8cd872b750$var$_hoisted_3 = {
    class: "font-bold text-xl"
};
const $b2ff0d8cd872b750$var$_hoisted_4 = /*#__PURE__*/ (0, $TusQn.createTextVNode)("SCR");
const $b2ff0d8cd872b750$var$_hoisted_5 = {
    key: 0
};
const $b2ff0d8cd872b750$var$_hoisted_6 = /*#__PURE__*/ (0, $TusQn.createTextVNode)("Requests");
const $b2ff0d8cd872b750$var$_hoisted_7 = /*#__PURE__*/ (0, $TusQn.createTextVNode)("My requests");
const $b2ff0d8cd872b750$var$_hoisted_8 = /*#__PURE__*/ (0, $TusQn.createTextVNode)("Released Requests");
const $b2ff0d8cd872b750$var$_hoisted_9 = /*#__PURE__*/ (0, $TusQn.createTextVNode)("Admin");
const $b2ff0d8cd872b750$var$_hoisted_10 = /*#__PURE__*/ (0, $TusQn.createTextVNode)(" Login ");
const $b2ff0d8cd872b750$var$_hoisted_11 = [
    "aria-expanded"
];
function $b2ff0d8cd872b750$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_router_link = (0, $TusQn.resolveComponent)("router-link");
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("header", $b2ff0d8cd872b750$var$_hoisted_1, [
        (0, $TusQn.createElementVNode)("div", $b2ff0d8cd872b750$var$_hoisted_2, [
            (0, $TusQn.createElementVNode)("div", $b2ff0d8cd872b750$var$_hoisted_3, [
                (0, $TusQn.createVNode)(_component_router_link, {
                    to: "/"
                }, {
                    default: (0, $TusQn.withCtx)(()=>[
                            $b2ff0d8cd872b750$var$_hoisted_4
                        ]),
                    _: 1
                })
            ]),
            $setup.route.name !== 'subscription' ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $b2ff0d8cd872b750$var$_hoisted_5, [
                (0, $TusQn.createElementVNode)("nav", {
                    ref: "navHTMLElement",
                    class: (0, $8POXm.normalizeClass)([
                        'absolute top-[70px] left-0 flex flex-col items-center gap-x-6 gap-y-5 w-full h-0 z-50 text-ellipsis overflow-hidden text-purple-900 bg-neutral-200 font-semibold md:relative md:top-auto md:left-auto md:flex-row md:w-auto md:h-auto md:bg-transparent transition-[height_padding] duration-300',
                        {
                            [$setup.isAdmin ? 'h-[240px] py-5' : 'h-[196px] py-5']: $setup.isNavOpen
                        }
                    ]),
                    "aria-labelledby": "menu-button"
                }, [
                    (0, $TusQn.createVNode)(_component_router_link, {
                        to: "/requests"
                    }, {
                        default: (0, $TusQn.withCtx)(()=>[
                                $b2ff0d8cd872b750$var$_hoisted_6
                            ]),
                        _: 1
                    }),
                    (0, $TusQn.createVNode)(_component_router_link, {
                        to: "/my-requests"
                    }, {
                        default: (0, $TusQn.withCtx)(()=>[
                                $b2ff0d8cd872b750$var$_hoisted_7
                            ]),
                        _: 1
                    }),
                    (0, $TusQn.createVNode)(_component_router_link, {
                        to: "/released-requests"
                    }, {
                        default: (0, $TusQn.withCtx)(()=>[
                                $b2ff0d8cd872b750$var$_hoisted_8
                            ]),
                        _: 1
                    }),
                    $setup.isAdmin ? ((0, $TusQn.openBlock)(), (0, $TusQn.createBlock)(_component_router_link, {
                        key: 0,
                        to: "/admin"
                    }, {
                        default: (0, $TusQn.withCtx)(()=>[
                                $b2ff0d8cd872b750$var$_hoisted_9
                            ]),
                        _: 1
                    })) : (0, $TusQn.createCommentVNode)("", true),
                    (0, $TusQn.createElementVNode)("div", null, [
                        !!$setup.state.user ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("button", {
                            key: 0,
                            type: "button",
                            onClick: $setup.onLogoutButtonClick
                        }, " Logout ")) : ((0, $TusQn.openBlock)(), (0, $TusQn.createBlock)(_component_router_link, {
                            key: 1,
                            to: "/login"
                        }, {
                            default: (0, $TusQn.withCtx)(()=>[
                                    $b2ff0d8cd872b750$var$_hoisted_10
                                ]),
                            _: 1
                        }))
                    ])
                ], 2),
                (0, $TusQn.createElementVNode)("button", {
                    class: "md:hidden",
                    type: "button",
                    id: "menu-button",
                    "aria-label": "Menu",
                    "aria-expanded": $setup.isNavOpen,
                    onClick: $setup.onMenuButtonClick
                }, [
                    (0, $TusQn.createVNode)($setup["Bars3Icon"], {
                        class: "h-8 w-8"
                    })
                ], 8, $b2ff0d8cd872b750$var$_hoisted_11)
            ])) : (0, $TusQn.createCommentVNode)("", true)
        ])
    ]);
}

});

parcelRegister("1l3f9", function(module, exports) {

$parcel$export(module.exports, "default", () => $0f9a44aaa25e35f5$export$2e2bcd8739ae039);
let $0f9a44aaa25e35f5$var$NOOP = ()=>{};
var $0f9a44aaa25e35f5$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRegister("38WoH", function(module, exports) {

$parcel$export(module.exports, "default", () => $249f6af4867cc274$export$2e2bcd8739ae039);
let $249f6af4867cc274$var$script;



let $249f6af4867cc274$var$initialize = ()=>{
    $249f6af4867cc274$var$script = (parcelRequire("fSnwE"));
    if ($249f6af4867cc274$var$script.__esModule) $249f6af4867cc274$var$script = $249f6af4867cc274$var$script.default;
    $249f6af4867cc274$var$script.render = (parcelRequire("1VbOx")).render;
    (parcelRequire("f0SMr")).default($249f6af4867cc274$var$script);
    $249f6af4867cc274$var$script.__scopeId = 'data-v-cd8931';
    $249f6af4867cc274$var$script.__file = "footer.vue";
};
$249f6af4867cc274$var$initialize();
var $249f6af4867cc274$export$2e2bcd8739ae039 = $249f6af4867cc274$var$script;

});
parcelRegister("fSnwE", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $b8ee25d6ead44e48$export$2e2bcd8739ae039);

var $73mM4 = parcelRequire("73mM4");

var $aHzHx = parcelRequire("aHzHx");

var $i1IVO = parcelRequire("i1IVO");

var $lDtHE = parcelRequire("lDtHE");
var $b8ee25d6ead44e48$export$2e2bcd8739ae039 = {
    __name: 'footer',
    setup (__props, { expose: expose }) {
        expose();
        const SERVER_URL = "https://scrapbook-concierge-requests-api-cr45w.ondigitalocean.app";
        const year = new Date().getFullYear();
        const __returned__ = {
            SERVER_URL: SERVER_URL,
            year: year,
            RouterLink: $73mM4.RouterLink,
            facebookIcon: (/*@__PURE__*/$parcel$interopDefault($aHzHx)),
            instagramIcon: (/*@__PURE__*/$parcel$interopDefault($i1IVO)),
            pinterestIcon: (/*@__PURE__*/$parcel$interopDefault($lDtHE))
        };
        Object.defineProperty(__returned__, '__isScriptSetup', {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
};

});
parcelRegister("aHzHx", function(module, exports) {
module.exports = import.meta.resolve("fYDvZ");

});

parcelRegister("i1IVO", function(module, exports) {
module.exports = import.meta.resolve("dLPVy");

});

parcelRegister("lDtHE", function(module, exports) {
module.exports = import.meta.resolve("23O3f");

});


parcelRegister("1VbOx", function(module, exports) {

$parcel$export(module.exports, "render", () => $16644756492792cc$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
const $16644756492792cc$var$_hoisted_1 = {
    class: "px-5 py-4 bg-purple-300 text-purple-900"
};
const $16644756492792cc$var$_hoisted_2 = {
    class: "max-w-5xl mx-auto text-center"
};
const $16644756492792cc$var$_hoisted_3 = {
    class: "mb-2 font-bold"
};
const $16644756492792cc$var$_hoisted_4 = {
    class: "flex justify-between flex-wrap gap-4 items-center"
};
const $16644756492792cc$var$_hoisted_5 = {
    class: "text-sm text-left"
};
const $16644756492792cc$var$_hoisted_6 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("a", {
    class: "hover:underline",
    href: "mailto:scrapbookconcierge@gmail.com"
}, "Contact Us", -1);
const $16644756492792cc$var$_hoisted_7 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("br", null, null, -1);
const $16644756492792cc$var$_hoisted_8 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("a", {
    class: "hover:underline",
    href: "https://www.scrapbookconciergelayouts.com/"
}, "Scrapbook Concierge", -1);
const $16644756492792cc$var$_hoisted_9 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("br", null, null, -1);
const $16644756492792cc$var$_hoisted_10 = /*#__PURE__*/ (0, $TusQn.createTextVNode)("Privacy Policy");
const $16644756492792cc$var$_hoisted_11 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("br", null, null, -1);
const $16644756492792cc$var$_hoisted_12 = /*#__PURE__*/ (0, $TusQn.createTextVNode)("Terms and conditions");
const $16644756492792cc$var$_hoisted_13 = {
    class: "flex gap-x-2"
};
const $16644756492792cc$var$_hoisted_14 = {
    class: "block w-8 h-8 rounded-md bg-[#3b5998]",
    href: "https://www.facebook.com/sharer/sharer.php?u=https://www.facebook.com/ScrapbookConcierge/",
    target: "_blank"
};
const $16644756492792cc$var$_hoisted_15 = [
    "src"
];
const $16644756492792cc$var$_hoisted_16 = {
    class: "block w-8 h-8 rounded-md",
    href: "https://www.instagram.com/scrapbookconcierge/?hl=en",
    target: "_blank"
};
const $16644756492792cc$var$_hoisted_17 = [
    "src"
];
const $16644756492792cc$var$_hoisted_18 = {
    class: "block w-8 h-8 rounded-md bg-[#bd081c]",
    href: "https://pinterest.com/pin/create/button/?url=https://www.etsy.com/shop/ScrapbookConciergeCO&media=&description="
};
const $16644756492792cc$var$_hoisted_19 = [
    "src"
];
function $16644756492792cc$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("footer", $16644756492792cc$var$_hoisted_1, [
        (0, $TusQn.createElementVNode)("div", $16644756492792cc$var$_hoisted_2, [
            (0, $TusQn.createElementVNode)("p", $16644756492792cc$var$_hoisted_3, " \xa9" + (0, $8POXm.toDisplayString)($setup.year) + " Scrapbook Concierge Requests ", 1),
            (0, $TusQn.createElementVNode)("div", $16644756492792cc$var$_hoisted_4, [
                (0, $TusQn.createElementVNode)("div", $16644756492792cc$var$_hoisted_5, [
                    $16644756492792cc$var$_hoisted_6,
                    $16644756492792cc$var$_hoisted_7,
                    $16644756492792cc$var$_hoisted_8,
                    $16644756492792cc$var$_hoisted_9,
                    (0, $TusQn.createVNode)($setup["RouterLink"], {
                        class: "hover:underline",
                        to: "/privacy-policy"
                    }, {
                        default: (0, $TusQn.withCtx)(()=>[
                                $16644756492792cc$var$_hoisted_10
                            ]),
                        _: 1
                    }),
                    $16644756492792cc$var$_hoisted_11,
                    (0, $TusQn.createVNode)($setup["RouterLink"], {
                        class: "hover:underline",
                        to: "/terms"
                    }, {
                        default: (0, $TusQn.withCtx)(()=>[
                                $16644756492792cc$var$_hoisted_12
                            ]),
                        _: 1
                    })
                ]),
                (0, $TusQn.createElementVNode)("div", $16644756492792cc$var$_hoisted_13, [
                    (0, $TusQn.createElementVNode)("a", $16644756492792cc$var$_hoisted_14, [
                        (0, $TusQn.createElementVNode)("img", {
                            src: $setup.facebookIcon,
                            alt: "facebook icon"
                        }, null, 8, $16644756492792cc$var$_hoisted_15)
                    ]),
                    (0, $TusQn.createElementVNode)("a", $16644756492792cc$var$_hoisted_16, [
                        (0, $TusQn.createElementVNode)("img", {
                            src: $setup.instagramIcon,
                            alt: "instagram icon"
                        }, null, 8, $16644756492792cc$var$_hoisted_17)
                    ]),
                    (0, $TusQn.createElementVNode)("a", $16644756492792cc$var$_hoisted_18, [
                        (0, $TusQn.createElementVNode)("img", {
                            src: $setup.pinterestIcon,
                            alt: "pinterest icon"
                        }, null, 8, $16644756492792cc$var$_hoisted_19)
                    ])
                ])
            ])
        ])
    ]);
}

});

parcelRegister("f0SMr", function(module, exports) {

$parcel$export(module.exports, "default", () => $aee159565db1c99f$export$2e2bcd8739ae039);
let $aee159565db1c99f$var$NOOP = ()=>{};
var $aee159565db1c99f$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRegister("7yIGu", function(module, exports) {
module.exports = import.meta.resolve("k2Xxl");

});

parcelRegister("2OXpE", function(module, exports) {
module.exports = import.meta.resolve("fGkDv");

});

parcelRegister("izEgc", function(module, exports) {
module.exports = import.meta.resolve("6nqCD");

});


parcelRegister("343ow", function(module, exports) {

$parcel$export(module.exports, "render", () => $23b460e62e139ae3$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
const $23b460e62e139ae3$var$_hoisted_1 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("div", {
    class: "mx-auto bg-[linear-gradient(90deg,rgba(0,0,0,0.7),rgba(0,0,0,0.8)),url('/src/assets/images/hero.jpg')] bg-center bg-cover"
}, [
    /*#__PURE__*/ (0, $TusQn.createElementVNode)("div", {
        class: "max-w-5xl mx-auto px-10 py-16 text-white text-center sm:px-24 sm:py-24 lg:py-44"
    }, [
        /*#__PURE__*/ (0, $TusQn.createElementVNode)("h1", {
            class: "mb-10 text-4xl sm:text-5xl lg:text-6xl font-bold"
        }, " Influence the Next Collection of Scrapbook Kits "),
        /*#__PURE__*/ (0, $TusQn.createElementVNode)("p", {
            class: "text-xl sm:text-2xl"
        }, " Your ideas, your votes\u2014let your voice be heard! Submit your requests and vote for the kits you'd love to see next. ")
    ])
], -1);
const $23b460e62e139ae3$var$_hoisted_2 = {
    class: "max-w-5xl mx-auto my-14 px-4 space-y-10 sm:space-y-24 md:mb-28"
};
const $23b460e62e139ae3$var$_hoisted_3 = {
    class: "flex flex-col-reverse items-center md:flex-row"
};
const $23b460e62e139ae3$var$_hoisted_4 = {
    class: "basis-3/5"
};
const $23b460e62e139ae3$var$_hoisted_5 = [
    "src"
];
const $23b460e62e139ae3$var$_hoisted_6 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("div", {
    class: "basis-2/5 text-center py-8 text-purple-900 md:px-6 md:py-10 lg:px-12"
}, [
    /*#__PURE__*/ (0, $TusQn.createElementVNode)("h2", {
        class: "mb-6 text-3xl font-bold lg:text-4xl"
    }, " Vote for Your Favorite Kit Requests "),
    /*#__PURE__*/ (0, $TusQn.createElementVNode)("p", null, " Make your mark on our next collection by voting for the kit requests you love. Simply click the black heart button next to the kit title\u2014watch it turn red as your vote is counted. Your vote helps us decide which kits to create next! ")
], -1);
const $23b460e62e139ae3$var$_hoisted_7 = {
    class: "flex flex-col-reverse items-center md:flex-row-reverse"
};
const $23b460e62e139ae3$var$_hoisted_8 = {
    class: "basis-3/5"
};
const $23b460e62e139ae3$var$_hoisted_9 = [
    "src"
];
const $23b460e62e139ae3$var$_hoisted_10 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("div", {
    class: "basis-2/5 text-center py-8 text-purple-900 md:px-6 md:py-10 lg:px-12"
}, [
    /*#__PURE__*/ (0, $TusQn.createElementVNode)("h2", {
        class: "mb-6 text-3xl font-bold lg:text-4xl"
    }, " Submit and Manage Your Requests "),
    /*#__PURE__*/ (0, $TusQn.createElementVNode)("p", null, " Have a brilliant idea for a scrapbook kit? Head over to the \"My Requests\" page. Before submitting your request, use the search bar to verify that your idea haven't been already requested, then submit your request. After submitting, you can always update or delete your request as long as it hasn't gained any likes yet. Your creativity drives our next projects! ")
], -1);
const $23b460e62e139ae3$var$_hoisted_11 = {
    class: "flex flex-col-reverse items-center md:flex-row"
};
const $23b460e62e139ae3$var$_hoisted_12 = {
    class: "basis-3/5"
};
const $23b460e62e139ae3$var$_hoisted_13 = [
    "src"
];
const $23b460e62e139ae3$var$_hoisted_14 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("div", {
    class: "basis-2/5 text-center py-8 text-purple-900 md:px-6 md:py-10 lg:px-12"
}, [
    /*#__PURE__*/ (0, $TusQn.createElementVNode)("h2", {
        class: "mb-6 text-3xl font-bold lg:text-4xl"
    }, " Explore Recently Released Kits "),
    /*#__PURE__*/ (0, $TusQn.createElementVNode)("p", null, ' Discover the latest scrapbook kits brought to life by your requests! On the "Released Requests" page, you can browse all the kits that have recently been released. See something you love? Click the "Buy Now" button to be taken directly to the product page, where you can place your order and start creating. Your ideas, our creations\u2014now available to you! ')
], -1);
function $23b460e62e139ae3$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, [
        (0, $TusQn.createVNode)($setup["Header"]),
        (0, $TusQn.createElementVNode)("main", null, [
            $23b460e62e139ae3$var$_hoisted_1,
            (0, $TusQn.createElementVNode)("div", $23b460e62e139ae3$var$_hoisted_2, [
                (0, $TusQn.createElementVNode)("div", $23b460e62e139ae3$var$_hoisted_3, [
                    (0, $TusQn.createElementVNode)("div", $23b460e62e139ae3$var$_hoisted_4, [
                        (0, $TusQn.createElementVNode)("img", {
                            src: $setup.AllRequests,
                            alt: "all requests page example"
                        }, null, 8, $23b460e62e139ae3$var$_hoisted_5)
                    ]),
                    $23b460e62e139ae3$var$_hoisted_6
                ]),
                (0, $TusQn.createElementVNode)("div", $23b460e62e139ae3$var$_hoisted_7, [
                    (0, $TusQn.createElementVNode)("div", $23b460e62e139ae3$var$_hoisted_8, [
                        (0, $TusQn.createElementVNode)("img", {
                            src: $setup.MyRequests,
                            alt: "user personal requests page example"
                        }, null, 8, $23b460e62e139ae3$var$_hoisted_9)
                    ]),
                    $23b460e62e139ae3$var$_hoisted_10
                ]),
                (0, $TusQn.createElementVNode)("div", $23b460e62e139ae3$var$_hoisted_11, [
                    (0, $TusQn.createElementVNode)("div", $23b460e62e139ae3$var$_hoisted_12, [
                        (0, $TusQn.createElementVNode)("img", {
                            src: $setup.ReleasedRequests,
                            alt: "released requests page example"
                        }, null, 8, $23b460e62e139ae3$var$_hoisted_13)
                    ]),
                    $23b460e62e139ae3$var$_hoisted_14
                ])
            ])
        ]),
        (0, $TusQn.createVNode)($setup["Footer"])
    ], 64);
}

});

parcelRegister("MIFpg", function(module, exports) {

$parcel$export(module.exports, "default", () => $092721b6e2367573$export$2e2bcd8739ae039);
let $092721b6e2367573$var$NOOP = ()=>{};
var $092721b6e2367573$export$2e2bcd8739ae039 = (script)=>{};

});

parcelRegister("lvGE2", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $fa8d929a98c358f6$export$2e2bcd8739ae039);
parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");
var $TusQn = parcelRequire("TusQn");

var $73mM4 = parcelRequire("73mM4");

var $h7UQ3 = parcelRequire("h7UQ3");

var $38WoH = parcelRequire("38WoH");

var $9amUO = parcelRequire("9amUO");

var $4ymtU = parcelRequire("4ymtU");

var $lLLhm = parcelRequire("lLLhm");

var $gGcib = parcelRequire("gGcib");

var $gYKPF = parcelRequire("gYKPF");
var $fa8d929a98c358f6$export$2e2bcd8739ae039 = {
    __name: 'requests',
    setup (__props, { expose: expose }) {
        expose();
        const REQUESTS_PER_PAGE = 100;
        const router = (0, $73mM4.useRouter)();
        const loadMoreElement = (0, $01W3b.ref)(null);
        const isLoadingRequests = (0, $01W3b.ref)(false);
        // const requests = ref( null );
        const currentPage = (0, $01W3b.ref)(0);
        const totalPages = (0, $01W3b.ref)(1);
        const isLoadingSearchRequest = (0, $01W3b.ref)(false);
        const searchRequestValue = (0, $01W3b.ref)('');
        const sortRequestValue = (0, $01W3b.ref)('usersLength-desc');
        let intersectionObserver;
        const logUserOutAndRedirectHome = ()=>{
            (0, $gYKPF.logUserOut)();
            router.push({
                name: 'login'
            });
        };
        const options = {
            method: "GET",
            headers: {
                'Authorization': `Bearer ${(0, $gGcib.getToken)('token')}`
            }
        };
        const fetchRequestsByTitle = async ()=>{
            try {
                const sortingValues = sortRequestValue.value.split('-');
                isLoadingSearchRequest.value = true;
                const response = await fetch(`${"https://scrapbook-concierge-requests-api-cr45w.ondigitalocean.app"}/requests/search?title=${searchRequestValue.value}&sort_by=${sortingValues[0]}&order_by=${sortingValues[1]}`, options);
                const data = await response.json();
                if (response.ok) (0, $gYKPF.state).searchRequestResult = data.requests;
                else if (response.status === 401) {
                    (0, $gYKPF.pushAlert)('failure', 'You\'re not logged in.');
                    logUserOutAndRedirectHome();
                } else (0, $gYKPF.pushAlert)('failure', data?.message);
            } catch (error) {
                console.error(error);
                (0, $gYKPF.pushAlert)('failure', 'An Error occurred while searching. Try again later.');
            } finally{
                isLoadingSearchRequest.value = false;
            }
        };
        const onFormSubmit = (event)=>{
            event.preventDefault();
            if (!searchRequestValue.value) return;
            fetchRequestsByTitle();
        };
        const fetchPage = async (page)=>{
            try {
                const sortingValues = sortRequestValue.value.split('-');
                // if ( page === currentPage.value ) return;
                isLoadingRequests.value = true;
                const response = await fetch(`${"https://scrapbook-concierge-requests-api-cr45w.ondigitalocean.app"}/requests?page=${page}&limit=${REQUESTS_PER_PAGE}&released=false&sort_by=${sortingValues[0]}&order_by=${sortingValues[1]}`, options);
                const data = await response.json();
                if (response.ok) {
                    if (page > 1) (0, $gYKPF.state).requests.push(...data.requests);
                    else (0, $gYKPF.state).requests = data.requests;
                    currentPage.value = data.page;
                    totalPages.value = data.total;
                } else if (response.status === 401) {
                    (0, $gYKPF.pushAlert)('failure', 'You\'re not logged in.');
                    logUserOutAndRedirectHome();
                } else (0, $gYKPF.pushAlert)('failure', data?.message);
            } catch (error) {
                console.error(error);
                (0, $gYKPF.pushAlert)('failure', 'An Error occurred while retrieving the requests. Try again later.');
            } finally{
                isLoadingRequests.value = false;
            }
        };
        const intersectionObserverCallback = (entries, observer)=>{
            entries.forEach((entry)=>{
                const nextPage = currentPage.value + 1;
                if (isLoadingRequests.value || nextPage > totalPages.value) return;
                if (entry.isIntersecting) fetchPage(nextPage);
            });
        };
        (0, $TusQn.onBeforeMount)(()=>{
            if (!!(0, $gYKPF.state).searchRequestResult) (0, $gYKPF.state).searchRequestResult = null;
        });
        (0, $TusQn.onMounted)(()=>{
            intersectionObserver = new IntersectionObserver(intersectionObserverCallback, {
                root: null,
                rootMargin: '0px',
                threshold: 0
            });
            intersectionObserver.observe(loadMoreElement.value);
        });
        (0, $TusQn.onBeforeUnmount)(()=>intersectionObserver.unobserve(loadMoreElement.value));
        (0, $TusQn.watch)(sortRequestValue, ()=>{
            currentPage.value = 0;
            (0, $gYKPF.state).requests = null;
            fetchPage();
        });
        (0, $TusQn.watch)(searchRequestValue, (newValue, oldValue)=>{
            if (!newValue) (0, $gYKPF.state).searchRequestResult = null;
        });
        const __returned__ = {
            REQUESTS_PER_PAGE: REQUESTS_PER_PAGE,
            router: router,
            loadMoreElement: loadMoreElement,
            isLoadingRequests: isLoadingRequests,
            currentPage: currentPage,
            totalPages: totalPages,
            isLoadingSearchRequest: isLoadingSearchRequest,
            searchRequestValue: searchRequestValue,
            sortRequestValue: sortRequestValue,
            intersectionObserver: intersectionObserver,
            logUserOutAndRedirectHome: logUserOutAndRedirectHome,
            options: options,
            fetchRequestsByTitle: fetchRequestsByTitle,
            onFormSubmit: onFormSubmit,
            fetchPage: fetchPage,
            intersectionObserverCallback: intersectionObserverCallback,
            ref: $01W3b.ref,
            computed: $01W3b.computed,
            onMounted: $TusQn.onMounted,
            watch: $TusQn.watch,
            onBeforeUnmount: $TusQn.onBeforeUnmount,
            onBeforeMount: $TusQn.onBeforeMount,
            useRouter: $73mM4.useRouter,
            Header: $h7UQ3.default,
            Footer: $38WoH.default,
            Spinner: $9amUO.default,
            Pagination: $4ymtU.default,
            LikeButton: $lLLhm.default,
            formatDate: $gGcib.formatDate,
            getToken: $gGcib.getToken,
            state: $gYKPF.state,
            onMakeRequestButtonClick: $gYKPF.onMakeRequestButtonClick,
            onLikeButtonClicked: $gYKPF.onLikeButtonClicked,
            logUserOut: $gYKPF.logUserOut,
            pushAlert: $gYKPF.pushAlert
        };
        Object.defineProperty(__returned__, '__isScriptSetup', {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
};

});
parcelRegister("9amUO", function(module, exports) {

$parcel$export(module.exports, "default", () => $6ac6d2bc3a0c102b$export$2e2bcd8739ae039);
let $6ac6d2bc3a0c102b$var$script;


let $6ac6d2bc3a0c102b$var$initialize = ()=>{
    $6ac6d2bc3a0c102b$var$script = {};
    $6ac6d2bc3a0c102b$var$script.render = (parcelRequire("dOwKu")).render;
    (parcelRequire("4VOXW")).default($6ac6d2bc3a0c102b$var$script);
    $6ac6d2bc3a0c102b$var$script.__scopeId = 'data-v-d83944';
    $6ac6d2bc3a0c102b$var$script.__file = "spinner.vue";
};
$6ac6d2bc3a0c102b$var$initialize();
var $6ac6d2bc3a0c102b$export$2e2bcd8739ae039 = $6ac6d2bc3a0c102b$var$script;

});
parcelRegister("dOwKu", function(module, exports) {

$parcel$export(module.exports, "render", () => $a0e9592128114df9$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
const $a0e9592128114df9$var$_hoisted_1 = {
    class: "mx-auto fill-purple-800 animate-spin",
    width: "40",
    height: "40",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512"
};
const $a0e9592128114df9$var$_hoisted_2 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("path", {
    d: "M222.7 32.1c5 16.9-4.6 34.8-21.5 39.8C121.8 95.6 64 169.1 64 256c0 106 86 192 192 192s192-86 192-192c0-86.9-57.8-160.4-137.1-184.1c-16.9-5-26.6-22.9-21.5-39.8s22.9-26.6 39.8-21.5C434.9 42.1 512 140 512 256c0 141.4-114.6 256-256 256S0 397.4 0 256C0 140 77.1 42.1 182.9 10.6c16.9-5 34.8 4.6 39.8 21.5z"
}, null, -1);
const $a0e9592128114df9$var$_hoisted_3 = [
    $a0e9592128114df9$var$_hoisted_2
];
function $a0e9592128114df9$export$b3890eb0ae9dca99(_ctx, _cache) {
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", $a0e9592128114df9$var$_hoisted_1, $a0e9592128114df9$var$_hoisted_3);
}

});

parcelRegister("4VOXW", function(module, exports) {

$parcel$export(module.exports, "default", () => $3974050c580045aa$export$2e2bcd8739ae039);
let $3974050c580045aa$var$NOOP = ()=>{};
var $3974050c580045aa$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRegister("4ymtU", function(module, exports) {

$parcel$export(module.exports, "default", () => $350bc6b906e76239$export$2e2bcd8739ae039);
let $350bc6b906e76239$var$script;



let $350bc6b906e76239$var$initialize = ()=>{
    $350bc6b906e76239$var$script = (parcelRequire("1Sdrq"));
    if ($350bc6b906e76239$var$script.__esModule) $350bc6b906e76239$var$script = $350bc6b906e76239$var$script.default;
    $350bc6b906e76239$var$script.render = (parcelRequire("gMaqT")).render;
    (parcelRequire("eIj6y")).default($350bc6b906e76239$var$script);
    $350bc6b906e76239$var$script.__scopeId = 'data-v-c37878';
    $350bc6b906e76239$var$script.__file = "pagination.vue";
};
$350bc6b906e76239$var$initialize();
var $350bc6b906e76239$export$2e2bcd8739ae039 = $350bc6b906e76239$var$script;

});
parcelRegister("1Sdrq", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $15d542c4fedaf95e$export$2e2bcd8739ae039);
parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");
var $15d542c4fedaf95e$export$2e2bcd8739ae039 = {
    __name: 'pagination',
    props: {
        current: Number,
        total: Number,
        disabled: Boolean
    },
    setup (__props, { expose: expose }) {
        expose();
        const props = __props;
        // import { ChevronRightIcon, ChevronLeftIcon } from '@heroicons/vue/24/solid';
        // const current = ref( props.current );
        const firstButton = (0, $01W3b.ref)(1);
        const secondButton = (0, $01W3b.computed)(()=>{
            return props.current <= 5 ? 2 : '&CenterDot;&CenterDot;&CenterDot;';
        });
        const thirdButton = (0, $01W3b.computed)(()=>{
            return props.current > 4 && props.total > 6 ? props.total - props.current > 3 ? props.current - 1 : props.total - 4 : 3;
        });
        const fourthButton = (0, $01W3b.computed)(()=>{
            return props.current > 4 && props.total > 6 ? props.total - props.current > 3 ? props.current : props.total - 3 : 4;
        });
        const fifthButton = (0, $01W3b.computed)(()=>{
            return props.current > 4 && props.total > 6 ? props.total - props.current > 3 ? props.current + 1 : props.total - 2 : 5;
        });
        const sixthButton = (0, $01W3b.computed)(()=>{
            return props.total - props.current < 3 ? props.total > 6 ? props.total - 1 : 6 : '&CenterDot;&CenterDot;&CenterDot;';
        });
        const seventhButton = (0, $01W3b.ref)(props.total);
        // function onPageButtonClick( event ) {
        // }
        const __returned__ = {
            props: props,
            firstButton: firstButton,
            secondButton: secondButton,
            thirdButton: thirdButton,
            fourthButton: fourthButton,
            fifthButton: fifthButton,
            sixthButton: sixthButton,
            seventhButton: seventhButton,
            computed: $01W3b.computed,
            ref: $01W3b.ref
        };
        Object.defineProperty(__returned__, '__isScriptSetup', {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
};

});

parcelRegister("gMaqT", function(module, exports) {

$parcel$export(module.exports, "render", () => $c36938c0a802c9f3$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
const $c36938c0a802c9f3$var$_hoisted_1 = {
    class: "flex gap-x-1 w-min mx-auto text-sm sm:text-base sm:gap-x-2"
};
const $c36938c0a802c9f3$var$_hoisted_2 = [
    "aria-selected",
    "hidden",
    "disabled"
];
const $c36938c0a802c9f3$var$_hoisted_3 = [
    "aria-selected",
    "disabled",
    "aria-hidden"
];
const $c36938c0a802c9f3$var$_hoisted_4 = [
    "aria-selected",
    "aria-hidden",
    "disabled"
];
const $c36938c0a802c9f3$var$_hoisted_5 = [
    "aria-selected",
    "aria-hidden",
    "disabled"
];
const $c36938c0a802c9f3$var$_hoisted_6 = [
    "aria-selected",
    "aria-hidden",
    "disabled"
];
const $c36938c0a802c9f3$var$_hoisted_7 = [
    "aria-selected",
    "disabled",
    "aria-hidden"
];
const $c36938c0a802c9f3$var$_hoisted_8 = [
    "aria-selected",
    "aria-hidden",
    "disabled"
];
function $c36938c0a802c9f3$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $c36938c0a802c9f3$var$_hoisted_1, [
        (0, $TusQn.createElementVNode)("button", {
            "aria-selected": $setup.props.current === $setup.firstButton,
            hidden: $setup.props.total < $setup.props.current,
            disabled: $setup.props.disabled || $setup.props.current === $setup.firstButton,
            class: "flex items-center px-3 py-2 rounded-md hover:bg-gray-100 transition-colors duration-200 aria-selected:border",
            type: "button",
            onClick: _cache[0] || (_cache[0] = ($event)=>_ctx.$emit('changePage', $setup.firstButton))
        }, (0, $8POXm.toDisplayString)($setup.firstButton), 9, $c36938c0a802c9f3$var$_hoisted_2),
        (0, $TusQn.createElementVNode)("button", {
            "aria-selected": $setup.props.current === $setup.secondButton,
            disabled: typeof $setup.secondButton == 'string' || $setup.props.disabled || $setup.props.current === $setup.secondButton,
            "aria-hidden": $setup.props.total < 2,
            class: "px-3 py-2 rounded-md hover:bg-gray-100 transition-colors duration-200 aria-selected:border aria-selected:bg-gray-100 aria-hidden:hidden",
            type: "button",
            onClick: _cache[1] || (_cache[1] = ($event)=>_ctx.$emit('changePage', $setup.secondButton))
        }, (0, $8POXm.toDisplayString)(typeof $setup.secondButton === 'number' ? $setup.secondButton : "\xb7\xb7\xb7"), 9, $c36938c0a802c9f3$var$_hoisted_3),
        (0, $TusQn.createElementVNode)("button", {
            "aria-selected": $setup.props.current === $setup.thirdButton,
            "aria-hidden": $setup.props.total < 3,
            disabled: $setup.props.disabled || $setup.props.current === $setup.thirdButton,
            class: "px-3 py-2 rounded-md hover:bg-gray-100 transition-colors duration-200 aria-selected:border aria-selected:bg-gray-100 aria-hidden:hidden",
            type: "button",
            onClick: _cache[2] || (_cache[2] = ($event)=>_ctx.$emit('changePage', $setup.thirdButton))
        }, (0, $8POXm.toDisplayString)($setup.thirdButton), 9, $c36938c0a802c9f3$var$_hoisted_4),
        (0, $TusQn.createElementVNode)("button", {
            "aria-selected": $setup.props.current === $setup.fourthButton,
            "aria-hidden": $setup.props.total < 4,
            disabled: $setup.props.disabled || $setup.props.current === $setup.fourthButton,
            class: "px-3 py-2 rounded-md hover:bg-gray-100 transition-colors duration-200 aria-selected:border aria-selected:bg-gray-100 aria-hidden:hidden",
            type: "button",
            onClick: _cache[3] || (_cache[3] = ($event)=>_ctx.$emit('changePage', $setup.fourthButton))
        }, (0, $8POXm.toDisplayString)($setup.fourthButton), 9, $c36938c0a802c9f3$var$_hoisted_5),
        (0, $TusQn.createElementVNode)("button", {
            "aria-selected": $setup.props.current === $setup.fifthButton,
            "aria-hidden": $setup.props.total < 5,
            disabled: $setup.props.disabled || $setup.props.current === $setup.fifthButton,
            class: "px-3 py-2 rounded-md hover:bg-gray-100 transition-colors duration-200 aria-selected:border aria-selected:bg-gray-100 aria-hidden:hidden",
            type: "button",
            onClick: _cache[4] || (_cache[4] = ($event)=>_ctx.$emit('changePage', $setup.fifthButton))
        }, (0, $8POXm.toDisplayString)($setup.fifthButton), 9, $c36938c0a802c9f3$var$_hoisted_6),
        (0, $TusQn.createElementVNode)("button", {
            "aria-selected": $setup.props.current === $setup.sixthButton,
            disabled: typeof $setup.sixthButton == 'string' || $setup.props.disabled || $setup.props.current === $setup.sixthButton,
            "aria-hidden": $setup.props.total < 6,
            class: "flex items-center px-3 py-2 rounded-md hover:bg-gray-100 transition-colors duration-200 aria-selected:border aria-hidden:hidden",
            type: "button",
            onClick: _cache[5] || (_cache[5] = ($event)=>_ctx.$emit('changePage', $setup.sixthButton))
        }, (0, $8POXm.toDisplayString)(typeof $setup.sixthButton === 'number' ? $setup.sixthButton : "\xb7\xb7\xb7"), 9, $c36938c0a802c9f3$var$_hoisted_7),
        (0, $TusQn.createElementVNode)("button", {
            "aria-selected": $setup.props.current === $setup.seventhButton,
            "aria-hidden": $setup.props.total <= 6,
            disabled: $setup.props.disabled || $setup.props.current === $setup.seventhButton,
            class: "flex items-center px-3 py-2 rounded-md hover:bg-gray-100 transition-colors duration-200 aria-selected:border aria-hidden:hidden",
            type: "button",
            onClick: _cache[6] || (_cache[6] = ($event)=>_ctx.$emit('changePage', $setup.seventhButton))
        }, (0, $8POXm.toDisplayString)($setup.seventhButton), 9, $c36938c0a802c9f3$var$_hoisted_8)
    ]);
}

});

parcelRegister("eIj6y", function(module, exports) {

$parcel$export(module.exports, "default", () => $ab63fe87479d10d0$export$2e2bcd8739ae039);
let $ab63fe87479d10d0$var$NOOP = ()=>{};
var $ab63fe87479d10d0$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRegister("lLLhm", function(module, exports) {

$parcel$export(module.exports, "default", () => $fd92a960ca92dd74$export$2e2bcd8739ae039);
let $fd92a960ca92dd74$var$script;



let $fd92a960ca92dd74$var$initialize = ()=>{
    $fd92a960ca92dd74$var$script = (parcelRequire("7Gxaz"));
    if ($fd92a960ca92dd74$var$script.__esModule) $fd92a960ca92dd74$var$script = $fd92a960ca92dd74$var$script.default;
    $fd92a960ca92dd74$var$script.render = (parcelRequire("cyU0Y")).render;
    (parcelRequire("8eFbQ")).default($fd92a960ca92dd74$var$script);
    $fd92a960ca92dd74$var$script.__scopeId = 'data-v-c8e05f';
    $fd92a960ca92dd74$var$script.__file = "likeButton.vue";
};
$fd92a960ca92dd74$var$initialize();
var $fd92a960ca92dd74$export$2e2bcd8739ae039 = $fd92a960ca92dd74$var$script;

});
parcelRegister("7Gxaz", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $59862f671155ffad$export$2e2bcd8739ae039);

var $l7C4u = parcelRequire("l7C4u");
var $59862f671155ffad$export$2e2bcd8739ae039 = {
    __name: 'likeButton',
    props: {
        isLiked: Boolean,
        isDisabled: Boolean
    },
    emits: [
        'likeButtonClicked'
    ],
    setup (__props, { expose: expose, emit: emits }) {
        expose();
        const props = __props;
        const emitLikeButtonClicked = ()=>emits('likeButtonClicked');
        const __returned__ = {
            props: props,
            emits: emits,
            emitLikeButtonClicked: emitLikeButtonClicked,
            HeartIcon: $l7C4u.default
        };
        Object.defineProperty(__returned__, '__isScriptSetup', {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
};

});
parcelRegister("l7C4u", function(module, exports) {

$parcel$export(module.exports, "default", () => $f607c89869206edd$export$2e2bcd8739ae039);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
function $f607c89869206edd$export$2e2bcd8739ae039(_ctx, _cache) {
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        fill: "currentColor",
        "aria-hidden": "true"
    }, [
        (0, $TusQn.createElementVNode)("path", {
            d: "M11.645 20.91l-.007-.003-.022-.012a15.247 15.247 0 01-.383-.218 25.18 25.18 0 01-4.244-3.17C4.688 15.36 2.25 12.174 2.25 8.25 2.25 5.322 4.714 3 7.688 3A5.5 5.5 0 0112 5.052 5.5 5.5 0 0116.313 3c2.973 0 5.437 2.322 5.437 5.25 0 3.925-2.438 7.111-4.739 9.256a25.175 25.175 0 01-4.244 3.17 15.247 15.247 0 01-.383.219l-.022.012-.007.004-.003.001a.752.752 0 01-.704 0l-.003-.001z"
        })
    ]);
}

});


parcelRegister("cyU0Y", function(module, exports) {

$parcel$export(module.exports, "render", () => $92541c5ed9fe568d$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
const $92541c5ed9fe568d$var$_hoisted_1 = [
    "disabled"
];
function $92541c5ed9fe568d$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("button", {
        class: (0, $8POXm.normalizeClass)([
            "group hover:pointer focus:scale-110",
            {
                'is-liked': $setup.props.isLiked,
                'is-disabled': $setup.props.isDisabled
            }
        ]),
        type: "button",
        "aria-label": "like request",
        onClick: $setup.emitLikeButtonClicked,
        disabled: $setup.props.isDisabled
    }, [
        (0, $TusQn.createVNode)($setup["HeartIcon"], {
            class: "h-8 w-8 stroke-neutral-500 fill-black hover:scale-110 group-[.is-liked]:fill-red-500 group-[.is-disabled]:opacity-50 group-[.is-disabled]:hover:scale-100 group-[.is-liked]:stroke-transparent transition-all duration-150"
        })
    ], 10, $92541c5ed9fe568d$var$_hoisted_1);
}

});

parcelRegister("8eFbQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $5fef94ffc6e28e4b$export$2e2bcd8739ae039);
let $5fef94ffc6e28e4b$var$NOOP = ()=>{};
var $5fef94ffc6e28e4b$export$2e2bcd8739ae039 = (script)=>{};

});



parcelRegister("k5oMG", function(module, exports) {

$parcel$export(module.exports, "render", () => $e9f77fee82524db3$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
var $eeJ70 = parcelRequire("eeJ70");
const $e9f77fee82524db3$var$_hoisted_1 = {
    class: "min-h-[calc(100vh-70px-144px)] px-5 pt-14 pb-4 sm:min-h-[calc(100vh-60px-144px)] sm:pt-28 lg:px-0"
};
const $e9f77fee82524db3$var$_hoisted_2 = {
    class: "max-w-3xl mx-auto mb-14"
};
const $e9f77fee82524db3$var$_hoisted_3 = {
    class: "sm:w-1/2"
};
const $e9f77fee82524db3$var$_hoisted_4 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("label", {
    for: "search"
}, null, -1);
const $e9f77fee82524db3$var$_hoisted_5 = [
    "disabled"
];
const $e9f77fee82524db3$var$_hoisted_6 = {
    class: "self-end"
};
const $e9f77fee82524db3$var$_hoisted_7 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("label", {
    for: "sort"
}, [
    /*#__PURE__*/ (0, $TusQn.createElementVNode)("span", {
        class: "sr-only"
    }, "Sort By")
], -1);
const $e9f77fee82524db3$var$_hoisted_8 = [
    "disabled"
];
const $e9f77fee82524db3$var$_hoisted_9 = /*#__PURE__*/ (0, $TusQn.createStaticVNode)("<option value=\"\" disabled>Sort by</option><option value=\"createdAt-asc\">Date Asc</option><option value=\"createdAt-desc\">Date Desc</option><option value=\"usersLength-asc\">Likes Asc</option><option value=\"usersLength-desc\">Likes Desc</option>", 5);
const $e9f77fee82524db3$var$_hoisted_14 = [
    $e9f77fee82524db3$var$_hoisted_9
];
const $e9f77fee82524db3$var$_hoisted_15 = {
    key: 0
};
const $e9f77fee82524db3$var$_hoisted_16 = {
    key: 0,
    class: "text-center"
};
const $e9f77fee82524db3$var$_hoisted_17 = {
    key: 1
};
const $e9f77fee82524db3$var$_hoisted_18 = {
    key: 0,
    class: "space-y-10"
};
const $e9f77fee82524db3$var$_hoisted_19 = {
    class: "absolute left-0 -top-5 px-3 py-[2px] text-xs font-medium rounded bg-green-500 empty:hidden"
};
const $e9f77fee82524db3$var$_hoisted_20 = {
    class: "text-left sm:text-right text-xs text-neutral-600"
};
const $e9f77fee82524db3$var$_hoisted_21 = {
    class: "px-5 mb-3 text-lg font-bold text-center sm:pr-20 sm:pl-0 sm:mb-0 sm:text-base sm:text-left"
};
const $e9f77fee82524db3$var$_hoisted_22 = {
    key: 0,
    class: "flex gap-x-1 items-center justify-self-end"
};
const $e9f77fee82524db3$var$_hoisted_23 = [
    "href"
];
const $e9f77fee82524db3$var$_hoisted_24 = {
    key: 1,
    class: "text-2xl text-center"
};
const $e9f77fee82524db3$var$_hoisted_25 = {
    key: 2
};
const $e9f77fee82524db3$var$_hoisted_26 = {
    key: 0,
    class: "text-center"
};
const $e9f77fee82524db3$var$_hoisted_27 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("p", {
    class: "mb-8 text-2xl"
}, " No requests made ", -1);
const $e9f77fee82524db3$var$_hoisted_28 = [
    $e9f77fee82524db3$var$_hoisted_27
];
const $e9f77fee82524db3$var$_hoisted_29 = {
    key: 1,
    class: "space-y-10"
};
const $e9f77fee82524db3$var$_hoisted_30 = {
    class: "text-left sm:text-right text-xs text-neutral-600"
};
const $e9f77fee82524db3$var$_hoisted_31 = {
    class: "px-5 mb-3 text-lg font-bold text-center sm:pr-20 sm:pl-0 sm:mb-0 sm:text-base sm:text-left"
};
const $e9f77fee82524db3$var$_hoisted_32 = {
    class: "flex gap-x-1 items-center justify-self-end"
};
const $e9f77fee82524db3$var$_hoisted_33 = {
    ref: "loadMoreElement"
};
const $e9f77fee82524db3$var$_hoisted_34 = {
    key: 0,
    class: "mt-7"
};
function $e9f77fee82524db3$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, [
        (0, $TusQn.createVNode)($setup["Header"]),
        (0, $TusQn.createElementVNode)("main", $e9f77fee82524db3$var$_hoisted_1, [
            (0, $TusQn.createElementVNode)("div", $e9f77fee82524db3$var$_hoisted_2, [
                (0, $TusQn.createElementVNode)("form", {
                    class: "flex flex-col-reverse justify-between gap-5 mb-20 sm:flex-row",
                    onSubmit: $setup.onFormSubmit
                }, [
                    (0, $TusQn.createElementVNode)("fieldset", $e9f77fee82524db3$var$_hoisted_3, [
                        $e9f77fee82524db3$var$_hoisted_4,
                        (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                            class: "w-full border-0 border-b-2 focus:border-b-purple-800 focus:ring-transparent",
                            type: "search",
                            name: "search",
                            id: "search",
                            placeholder: "search request...",
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event)=>$setup.searchRequestValue = $event),
                            disabled: $setup.isLoadingRequests
                        }, null, 8, $e9f77fee82524db3$var$_hoisted_5), [
                            [
                                (0, $eeJ70.vModelText),
                                $setup.searchRequestValue
                            ]
                        ])
                    ]),
                    (0, $TusQn.createElementVNode)("fieldset", $e9f77fee82524db3$var$_hoisted_6, [
                        $e9f77fee82524db3$var$_hoisted_7,
                        (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("select", {
                            class: "rounded focus:ring-purple-800 focus:border-purple-800",
                            name: "sort",
                            id: "sort",
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event)=>$setup.sortRequestValue = $event),
                            disabled: $setup.isLoadingRequests || !!$setup.searchRequestValue
                        }, $e9f77fee82524db3$var$_hoisted_14, 8, $e9f77fee82524db3$var$_hoisted_8), [
                            [
                                (0, $eeJ70.vModelSelect),
                                $setup.sortRequestValue
                            ]
                        ])
                    ])
                ], 32),
                $setup.currentPage > 0 ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $e9f77fee82524db3$var$_hoisted_15, [
                    $setup.isLoadingSearchRequest ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("p", $e9f77fee82524db3$var$_hoisted_16, " Searching... ")) : $setup.state.searchRequestResult ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $e9f77fee82524db3$var$_hoisted_17, [
                        !!$setup.state.searchRequestResult.length ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("ul", $e9f77fee82524db3$var$_hoisted_18, [
                            ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($setup.state.searchRequestResult, (request)=>{
                                return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("li", {
                                    class: "relative grid gap-x-3 gap-y-4 p-2 rounded shadow-[0_0_3px_rgb(0,0,0)] sm:grid-cols-[64px_1fr_auto] sm:items-center sm:bg-transparent odd:bg-purple-100 sm:shadow-[0_0_2px_rgb(0,0,0)]",
                                    key: request._id
                                }, [
                                    (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("span", $e9f77fee82524db3$var$_hoisted_19, " released ", 512), [
                                        [
                                            (0, $eeJ70.vShow),
                                            request.released && request.url
                                        ]
                                    ]),
                                    (0, $TusQn.createElementVNode)("span", $e9f77fee82524db3$var$_hoisted_20, (0, $8POXm.toDisplayString)($setup.formatDate(request.createdAt)), 1),
                                    (0, $TusQn.createElementVNode)("span", $e9f77fee82524db3$var$_hoisted_21, (0, $8POXm.toDisplayString)(request.title), 1),
                                    !request.released ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $e9f77fee82524db3$var$_hoisted_22, [
                                        (0, $TusQn.createElementVNode)("span", null, (0, $8POXm.toDisplayString)(request.users.length - 1), 1),
                                        (0, $TusQn.createVNode)($setup["LikeButton"], {
                                            id: request._id,
                                            "is-liked": request.users.includes($setup.state.user?.id),
                                            likes: request.users.length - 1,
                                            "is-disabled": request.users[0] === $setup.state.user?.id,
                                            onLikeButtonClicked: ()=>{
                                                $setup.onLikeButtonClicked([
                                                    request,
                                                    $setup.state.requests.find(({ _id: _id })=>_id === request._id)
                                                ], $setup.logUserOutAndRedirectHome);
                                            }
                                        }, null, 8, [
                                            "id",
                                            "is-liked",
                                            "likes",
                                            "is-disabled",
                                            "onLikeButtonClicked"
                                        ])
                                    ])) : ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("a", {
                                        key: 1,
                                        class: "px-2 py-1 text-sm text-center bg-green-700 text-white rounded-md hover:bg-green-800 transition-colors duration-200",
                                        target: "_blank",
                                        href: request.url
                                    }, " Buy Now ", 8, $e9f77fee82524db3$var$_hoisted_23))
                                ]);
                            }), 128))
                        ])) : ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("p", $e9f77fee82524db3$var$_hoisted_24, " No result found... "))
                    ])) : ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $e9f77fee82524db3$var$_hoisted_25, [
                        !$setup.state.requests?.length ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $e9f77fee82524db3$var$_hoisted_26, $e9f77fee82524db3$var$_hoisted_28)) : ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("ul", $e9f77fee82524db3$var$_hoisted_29, [
                            ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($setup.state.requests, (request)=>{
                                return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("li", {
                                    class: "grid gap-x-3 gap-y-4 p-2 rounded shadow-[0_0_3px_rgb(0,0,0)] sm:grid-cols-[64px_1fr_auto] sm:items-center sm:bg-transparent odd:bg-purple-100 sm:shadow-[0_0_2px_rgb(0,0,0)]",
                                    key: request._id
                                }, [
                                    (0, $TusQn.createElementVNode)("span", $e9f77fee82524db3$var$_hoisted_30, (0, $8POXm.toDisplayString)($setup.formatDate(request.createdAt)), 1),
                                    (0, $TusQn.createElementVNode)("span", $e9f77fee82524db3$var$_hoisted_31, (0, $8POXm.toDisplayString)(request.title), 1),
                                    (0, $TusQn.createElementVNode)("div", $e9f77fee82524db3$var$_hoisted_32, [
                                        (0, $TusQn.createElementVNode)("span", null, (0, $8POXm.toDisplayString)(request.users.length - 1), 1),
                                        (0, $TusQn.createVNode)($setup["LikeButton"], {
                                            id: request._id,
                                            "is-liked": request.users.includes($setup.state.user?.id),
                                            likes: request.users.length - 1,
                                            "is-disabled": request.users[0] === $setup.state.user?.id,
                                            onLikeButtonClicked: ()=>$setup.onLikeButtonClicked([
                                                    request
                                                ], ()=>$setup.fetchPage($setup.currentPage), $setup.logUserOutAndRedirectHome)
                                        }, null, 8, [
                                            "id",
                                            "is-liked",
                                            "likes",
                                            "is-disabled",
                                            "onLikeButtonClicked"
                                        ])
                                    ])
                                ]);
                            }), 128))
                        ]))
                    ]))
                ])) : (0, $TusQn.createCommentVNode)("", true),
                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("div", $e9f77fee82524db3$var$_hoisted_33, [
                    $setup.isLoadingRequests ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $e9f77fee82524db3$var$_hoisted_34, [
                        (0, $TusQn.createVNode)($setup["Spinner"])
                    ])) : ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("button", {
                        key: 1,
                        class: "block mx-auto mt-5 px-4 py-2 rounded-md bg-green-700 text-white",
                        onClick: _cache[2] || (_cache[2] = ($event)=>$setup.fetchPage($setup.currentPage + 1)),
                        type: "submit"
                    }, " Load More "))
                ], 512), [
                    [
                        (0, $eeJ70.vShow),
                        !$setup.searchRequestValue && $setup.currentPage !== $setup.totalPages && !!$setup.totalPages
                    ]
                ])
            ])
        ]),
        (0, $TusQn.createVNode)($setup["Footer"])
    ], 64);
}

});

parcelRegister("fgSYh", function(module, exports) {

$parcel$export(module.exports, "default", () => $b1e2fdc3c00c7aee$export$2e2bcd8739ae039);
let $b1e2fdc3c00c7aee$var$NOOP = ()=>{};
var $b1e2fdc3c00c7aee$export$2e2bcd8739ae039 = (script)=>{};

});

parcelRegister("2MP5Z", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $2077b2f836fd948c$export$2e2bcd8739ae039);
parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");
var $TusQn = parcelRequire("TusQn");

var $73mM4 = parcelRequire("73mM4");

var $gYKPF = parcelRequire("gYKPF");

var $gGcib = parcelRequire("gGcib");

var $ek92w = parcelRequire("ek92w");

var $aDGir = parcelRequire("aDGir");

var $1cUak = parcelRequire("1cUak");
var $2077b2f836fd948c$export$2e2bcd8739ae039 = {
    __name: 'login',
    setup (__props, { expose: expose }) {
        expose();
        const SERVER_URL = "https://scrapbook-concierge-requests-api-cr45w.ondigitalocean.app";
        const router = (0, $73mM4.useRouter)();
        const { query: query } = (0, $73mM4.useRoute)();
        const { executeRecaptcha: executeRecaptcha, recaptchaLoaded: recaptchaLoaded } = (0, $ek92w.useReCaptcha)();
        const emailValidationRegex = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
        const email = (0, $01W3b.ref)('');
        const password = (0, $01W3b.ref)('');
        const isCredentialsMessage = (0, $01W3b.ref)(false);
        const isEmailMessage = (0, $01W3b.ref)(false);
        const isPasswordMessage = (0, $01W3b.ref)(false);
        function onEmailFocusOut() {
            isEmailMessage.value = !email.value.length || !emailValidationRegex.test(email.value);
        }
        function onPasswordFocusOut() {
            isPasswordMessage.value = password.value.length < 6;
        }
        const submitForm = async (event)=>{
            event.preventDefault();
            try {
                onEmailFocusOut();
                onPasswordFocusOut();
                if (isCredentialsMessage.value) isCredentialsMessage.value = false;
                if (isEmailMessage.value || isPasswordMessage.value) return;
                const generateOptions = (body)=>({
                        method: 'POST',
                        body: JSON.stringify(body),
                        headers: {
                            'Content-Type': 'application/json',
                            'Accept': 'application/json'
                        }
                    });
                const reCAPTCHAToken = await executeRecaptcha('login');
                const verificationResponse = await fetch(`${"https://scrapbook-concierge-requests-api-cr45w.ondigitalocean.app"}/verify-recaptcha`, generateOptions({
                    token: reCAPTCHAToken
                }));
                const verificationResult = await verificationResponse.json();
                if (verificationResponse.status === 400) return router.push({
                    name: 'home'
                });
                const response = await fetch(`${"https://scrapbook-concierge-requests-api-cr45w.ondigitalocean.app"}/login`, generateOptions({
                    email: email.value,
                    password: password.value
                }));
                const result = await response.json();
                if (response.ok) {
                    localStorage.setItem('token', result.token);
                    const decodedToken = (0, $gGcib.decodeJWT)(result.token);
                    (0, $gYKPF.state).user = decodedToken.payload;
                    router.push({
                        name: 'home'
                    });
                } else if (response.status === 400) // pushAlert( 'failure', result.message );
                isCredentialsMessage.value = true;
                else if (response.status === 429) (0, $gYKPF.pushAlert)('failure', result.message);
                else (0, $gYKPF.pushAlert)('failure', result.message);
            } catch (error) {
                console.error(`An error occurred during login: ${error.message}`);
                (0, $gYKPF.pushAlert)('failure', 'An Error occurred during login. Try again later.');
            }
        };
        (0, $TusQn.onBeforeMount)(()=>{
            const token = query?.token;
            if (!token) return;
            localStorage.setItem('token', token);
            const decodedToken = (0, $gGcib.decodeJWT)(token);
            (0, $gYKPF.state).user = decodedToken.payload;
            router.push({
                name: 'home'
            });
        });
        (0, $TusQn.onMounted)(()=>{
            if (query.err) (0, $gYKPF.pushAlert)('failure', 'Wrong authentication method.');
        });
        const __returned__ = {
            SERVER_URL: SERVER_URL,
            router: router,
            query: query,
            executeRecaptcha: executeRecaptcha,
            recaptchaLoaded: recaptchaLoaded,
            emailValidationRegex: emailValidationRegex,
            email: email,
            password: password,
            isCredentialsMessage: isCredentialsMessage,
            isEmailMessage: isEmailMessage,
            isPasswordMessage: isPasswordMessage,
            onEmailFocusOut: onEmailFocusOut,
            onPasswordFocusOut: onPasswordFocusOut,
            submitForm: submitForm,
            computed: $01W3b.computed,
            ref: $01W3b.ref,
            onBeforeMount: $TusQn.onBeforeMount,
            onMounted: $TusQn.onMounted,
            useRoute: $73mM4.useRoute,
            useRouter: $73mM4.useRouter,
            state: $gYKPF.state,
            pushAlert: $gYKPF.pushAlert,
            decodeJWT: $gGcib.decodeJWT,
            useReCaptcha: $ek92w.useReCaptcha,
            SocialMediaAuthButton: $aDGir.default,
            GoogleIcon: (/*@__PURE__*/$parcel$interopDefault($1cUak))
        };
        Object.defineProperty(__returned__, '__isScriptSetup', {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
};

});
parcelRegister("ek92w", function(module, exports) {
"use strict";
var $02b0ef4228882cb4$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $02b0ef4228882cb4$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useReCaptcha = module.exports.VueReCaptcha = void 0;

var $iLYfR = parcelRequire("iLYfR");

var $5YCBU = parcelRequire("5YCBU");
var $02b0ef4228882cb4$var$VueReCaptchaInjectKey = Symbol('VueReCaptchaInjectKey');
var $02b0ef4228882cb4$var$globalConfig = {
    loadedWaiters: [],
    error: null
};
module.exports.VueReCaptcha = {
    install: function(app, options) {
        var isLoaded = $5YCBU.ref(false);
        var instance = $5YCBU.ref(undefined);
        app.config.globalProperties.$recaptchaLoaded = $02b0ef4228882cb4$var$recaptchaLoaded(isLoaded);
        $02b0ef4228882cb4$var$initializeReCaptcha(options).then(function(wrapper) {
            isLoaded.value = true;
            instance.value = wrapper;
            app.config.globalProperties.$recaptcha = $02b0ef4228882cb4$var$recaptcha(instance);
            app.config.globalProperties.$recaptchaInstance = instance;
            $02b0ef4228882cb4$var$globalConfig.loadedWaiters.forEach(function(v) {
                return v.resolve(true);
            });
        }).catch(function(error) {
            $02b0ef4228882cb4$var$globalConfig.error = error;
            $02b0ef4228882cb4$var$globalConfig.loadedWaiters.forEach(function(v) {
                return v.reject(error);
            });
        });
        app.provide($02b0ef4228882cb4$var$VueReCaptchaInjectKey, {
            instance: instance,
            isLoaded: isLoaded,
            executeRecaptcha: $02b0ef4228882cb4$var$recaptcha(instance),
            recaptchaLoaded: $02b0ef4228882cb4$var$recaptchaLoaded(isLoaded)
        });
    }
};
function $02b0ef4228882cb4$var$useReCaptcha() {
    return $5YCBU.inject($02b0ef4228882cb4$var$VueReCaptchaInjectKey);
}
module.exports.useReCaptcha = $02b0ef4228882cb4$var$useReCaptcha;
function $02b0ef4228882cb4$var$initializeReCaptcha(options) {
    return $02b0ef4228882cb4$var$__awaiter(this, void 0, void 0, function() {
        return $02b0ef4228882cb4$var$__generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    return [
                        4,
                        $iLYfR.load(options.siteKey, options.loaderOptions)
                    ];
                case 1:
                    return [
                        2,
                        _a.sent()
                    ];
            }
        });
    });
}
function $02b0ef4228882cb4$var$recaptchaLoaded(isLoaded) {
    return function() {
        return new Promise(function(resolve, reject) {
            if ($02b0ef4228882cb4$var$globalConfig.error !== null) return reject($02b0ef4228882cb4$var$globalConfig.error);
            if (isLoaded.value) return resolve(true);
            $02b0ef4228882cb4$var$globalConfig.loadedWaiters.push({
                resolve: resolve,
                reject: reject
            });
        });
    };
}
function $02b0ef4228882cb4$var$recaptcha(instance) {
    var _this = this;
    return function(action) {
        return $02b0ef4228882cb4$var$__awaiter(_this, void 0, void 0, function() {
            var _a;
            return $02b0ef4228882cb4$var$__generator(this, function(_b) {
                switch(_b.label){
                    case 0:
                        return [
                            4,
                            (_a = instance.value) === null || _a === void 0 ? void 0 : _a.execute(action)
                        ];
                    case 1:
                        return [
                            2,
                            _b.sent()
                        ];
                }
            });
        });
    };
}

});
parcelRegister("iLYfR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ReCaptchaInstance = module.exports.getInstance = module.exports.load = void 0;

var $klupM = parcelRequire("klupM");
Object.defineProperty(module.exports, "load", {
    enumerable: true,
    get: function() {
        return $klupM.load;
    }
});
Object.defineProperty(module.exports, "getInstance", {
    enumerable: true,
    get: function() {
        return $klupM.getInstance;
    }
});

var $2AxrR = parcelRequire("2AxrR");
Object.defineProperty(module.exports, "ReCaptchaInstance", {
    enumerable: true,
    get: function() {
        return $2AxrR.ReCaptchaInstance;
    }
});

});
parcelRegister("klupM", function(module, exports) {
"use strict";
var $ecfd5c929c33ae1f$var$__assign = module.exports && module.exports.__assign || function() {
    $ecfd5c929c33ae1f$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $ecfd5c929c33ae1f$var$__assign.apply(this, arguments);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getInstance = module.exports.load = void 0;

var $2AxrR = parcelRequire("2AxrR");
var $ecfd5c929c33ae1f$var$ELoadingState;
(function(ELoadingState) {
    ELoadingState[ELoadingState["NOT_LOADED"] = 0] = "NOT_LOADED";
    ELoadingState[ELoadingState["LOADING"] = 1] = "LOADING";
    ELoadingState[ELoadingState["LOADED"] = 2] = "LOADED";
})($ecfd5c929c33ae1f$var$ELoadingState || ($ecfd5c929c33ae1f$var$ELoadingState = {}));
var $ecfd5c929c33ae1f$var$ReCaptchaLoader = function() {
    function ReCaptchaLoader() {}
    ReCaptchaLoader.load = function(siteKey, options) {
        if (options === void 0) options = {};
        if (typeof document === "undefined") return Promise.reject(new Error("This is a library for the browser!"));
        if (ReCaptchaLoader.getLoadingState() === $ecfd5c929c33ae1f$var$ELoadingState.LOADED) {
            if (ReCaptchaLoader.instance.getSiteKey() === siteKey) return Promise.resolve(ReCaptchaLoader.instance);
            else return Promise.reject(new Error("reCAPTCHA already loaded with different site key!"));
        }
        if (ReCaptchaLoader.getLoadingState() === $ecfd5c929c33ae1f$var$ELoadingState.LOADING) {
            if (siteKey !== ReCaptchaLoader.instanceSiteKey) return Promise.reject(new Error("reCAPTCHA already loaded with different site key!"));
            return new Promise(function(resolve, reject) {
                ReCaptchaLoader.successfulLoadingConsumers.push(function(instance) {
                    return resolve(instance);
                });
                ReCaptchaLoader.errorLoadingRunnable.push(function(reason) {
                    return reject(reason);
                });
            });
        }
        ReCaptchaLoader.instanceSiteKey = siteKey;
        ReCaptchaLoader.setLoadingState($ecfd5c929c33ae1f$var$ELoadingState.LOADING);
        var loader = new ReCaptchaLoader();
        return new Promise(function(resolve, reject) {
            loader.loadScript(siteKey, options.useRecaptchaNet || false, options.useEnterprise || false, options.renderParameters ? options.renderParameters : {}, options.customUrl).then(function() {
                ReCaptchaLoader.setLoadingState($ecfd5c929c33ae1f$var$ELoadingState.LOADED);
                var widgetID = loader.doExplicitRender(grecaptcha, siteKey, options.explicitRenderParameters ? options.explicitRenderParameters : {}, options.useEnterprise || false);
                var instance = new $2AxrR.ReCaptchaInstance(siteKey, widgetID, grecaptcha);
                ReCaptchaLoader.successfulLoadingConsumers.forEach(function(v) {
                    return v(instance);
                });
                ReCaptchaLoader.successfulLoadingConsumers = [];
                if (options.autoHideBadge) instance.hideBadge();
                ReCaptchaLoader.instance = instance;
                resolve(instance);
            }).catch(function(error) {
                ReCaptchaLoader.errorLoadingRunnable.forEach(function(v) {
                    return v(error);
                });
                ReCaptchaLoader.errorLoadingRunnable = [];
                reject(error);
            });
        });
    };
    ReCaptchaLoader.getInstance = function() {
        return ReCaptchaLoader.instance;
    };
    ReCaptchaLoader.setLoadingState = function(state) {
        ReCaptchaLoader.loadingState = state;
    };
    ReCaptchaLoader.getLoadingState = function() {
        if (ReCaptchaLoader.loadingState === null) return $ecfd5c929c33ae1f$var$ELoadingState.NOT_LOADED;
        else return ReCaptchaLoader.loadingState;
    };
    ReCaptchaLoader.prototype.loadScript = function(siteKey, useRecaptchaNet, useEnterprise, renderParameters, customUrl) {
        var _this = this;
        if (useRecaptchaNet === void 0) useRecaptchaNet = false;
        if (useEnterprise === void 0) useEnterprise = false;
        if (renderParameters === void 0) renderParameters = {};
        if (customUrl === void 0) customUrl = "";
        var scriptElement = document.createElement("script");
        scriptElement.setAttribute("recaptcha-v3-script", "");
        scriptElement.setAttribute("async", "");
        scriptElement.setAttribute("defer", "");
        var scriptBase = "https://www.google.com/recaptcha/api.js";
        if (useRecaptchaNet) {
            if (useEnterprise) scriptBase = "https://recaptcha.net/recaptcha/enterprise.js";
            else scriptBase = "https://recaptcha.net/recaptcha/api.js";
        } else if (useEnterprise) scriptBase = "https://www.google.com/recaptcha/enterprise.js";
        if (customUrl) scriptBase = customUrl;
        if (renderParameters.render) renderParameters.render = undefined;
        var parametersQuery = this.buildQueryString(renderParameters);
        scriptElement.src = scriptBase + "?render=explicit" + parametersQuery;
        return new Promise(function(resolve, reject) {
            scriptElement.addEventListener("load", _this.waitForScriptToLoad(function() {
                resolve(scriptElement);
            }, useEnterprise), false);
            scriptElement.onerror = function(error) {
                ReCaptchaLoader.setLoadingState($ecfd5c929c33ae1f$var$ELoadingState.NOT_LOADED);
                reject(error);
            };
            document.head.appendChild(scriptElement);
        });
    };
    ReCaptchaLoader.prototype.buildQueryString = function(parameters) {
        var parameterKeys = Object.keys(parameters);
        if (parameterKeys.length < 1) return "";
        return "&" + Object.keys(parameters).filter(function(parameterKey) {
            return !!parameters[parameterKey];
        }).map(function(parameterKey) {
            return parameterKey + "=" + parameters[parameterKey];
        }).join("&");
    };
    ReCaptchaLoader.prototype.waitForScriptToLoad = function(callback, useEnterprise) {
        var _this = this;
        return function() {
            if (window.grecaptcha === undefined) setTimeout(function() {
                _this.waitForScriptToLoad(callback, useEnterprise);
            }, ReCaptchaLoader.SCRIPT_LOAD_DELAY);
            else if (useEnterprise) window.grecaptcha.enterprise.ready(function() {
                callback();
            });
            else window.grecaptcha.ready(function() {
                callback();
            });
        };
    };
    ReCaptchaLoader.prototype.doExplicitRender = function(grecaptcha1, siteKey, parameters, isEnterprise) {
        var augmentedParameters = $ecfd5c929c33ae1f$var$__assign({
            sitekey: siteKey
        }, parameters);
        if (parameters.container) {
            if (isEnterprise) return grecaptcha1.enterprise.render(parameters.container, augmentedParameters);
            else return grecaptcha1.render(parameters.container, augmentedParameters);
        } else {
            if (isEnterprise) return grecaptcha1.enterprise.render(augmentedParameters);
            else return grecaptcha1.render(augmentedParameters);
        }
    };
    ReCaptchaLoader.loadingState = null;
    ReCaptchaLoader.instance = null;
    ReCaptchaLoader.instanceSiteKey = null;
    ReCaptchaLoader.successfulLoadingConsumers = [];
    ReCaptchaLoader.errorLoadingRunnable = [];
    ReCaptchaLoader.SCRIPT_LOAD_DELAY = 25;
    return ReCaptchaLoader;
}();
module.exports.load = $ecfd5c929c33ae1f$var$ReCaptchaLoader.load;
module.exports.getInstance = $ecfd5c929c33ae1f$var$ReCaptchaLoader.getInstance;

});
parcelRegister("2AxrR", function(module, exports) {
"use strict";
var $1e28e3b827d7e7b7$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $1e28e3b827d7e7b7$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ReCaptchaInstance = void 0;
var $1e28e3b827d7e7b7$var$ReCaptchaInstance = function() {
    function ReCaptchaInstance(siteKey, recaptchaID, recaptcha) {
        this.siteKey = siteKey;
        this.recaptchaID = recaptchaID;
        this.recaptcha = recaptcha;
        this.styleContainer = null;
    }
    ReCaptchaInstance.prototype.execute = function(action) {
        return $1e28e3b827d7e7b7$var$__awaiter(this, void 0, void 0, function() {
            var _a;
            return $1e28e3b827d7e7b7$var$__generator(this, function(_b) {
                switch(_b.label){
                    case 0:
                        if (!this.recaptcha.enterprise) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            this.recaptcha.enterprise.execute(this.recaptchaID, {
                                action: action
                            })
                        ];
                    case 1:
                        _a = _b.sent();
                        return [
                            3,
                            4
                        ];
                    case 2:
                        return [
                            4,
                            this.recaptcha.execute(this.recaptchaID, {
                                action: action
                            })
                        ];
                    case 3:
                        _a = _b.sent();
                        _b.label = 4;
                    case 4:
                        return [
                            2,
                            _a
                        ];
                }
            });
        });
    };
    ReCaptchaInstance.prototype.getSiteKey = function() {
        return this.siteKey;
    };
    ReCaptchaInstance.prototype.hideBadge = function() {
        if (this.styleContainer !== null) return;
        this.styleContainer = document.createElement("style");
        this.styleContainer.innerHTML = ".grecaptcha-badge{visibility:hidden !important;}";
        document.head.appendChild(this.styleContainer);
    };
    ReCaptchaInstance.prototype.showBadge = function() {
        if (this.styleContainer === null) return;
        document.head.removeChild(this.styleContainer);
        this.styleContainer = null;
    };
    return ReCaptchaInstance;
}();
module.exports.ReCaptchaInstance = $1e28e3b827d7e7b7$var$ReCaptchaInstance;

});



parcelRegister("5YCBU", function(module, exports) {
'use strict';

module.exports = (parcelRequire("fJWfu"));

});
parcelRegister("fJWfu", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});

var $3HHJ3 = parcelRequire("3HHJ3");

var $eeJ70 = parcelRequire("eeJ70");

var $8POXm = parcelRequire("8POXm");
function $b7583dfe9c3698de$var$_interopNamespace(e) {
    if (e && e.__esModule) return e;
    var n = Object.create(null);
    if (e) Object.keys(e).forEach(function(k) {
        n[k] = e[k];
    });
    n['default'] = e;
    return Object.freeze(n);
}
var $b7583dfe9c3698de$var$runtimeDom__namespace = /*#__PURE__*/ $b7583dfe9c3698de$var$_interopNamespace($eeJ70);
// This entry is the "full-build" that includes both the runtime
const $b7583dfe9c3698de$var$compileCache = Object.create(null);
function $b7583dfe9c3698de$var$compileToFunction(template, options) {
    if (!$8POXm.isString(template)) {
        if (template.nodeType) template = template.innerHTML;
        else return $8POXm.NOOP;
    }
    const key = template;
    const cached = $b7583dfe9c3698de$var$compileCache[key];
    if (cached) return cached;
    if (template[0] === '#') {
        const el = document.querySelector(template);
        // __UNSAFE__
        // Reason: potential execution of JS expressions in in-DOM template.
        // The user must make sure the in-DOM template is trusted. If it's rendered
        // by the server, the template should not contain any user data.
        template = el ? el.innerHTML : ``;
    }
    const opts = $8POXm.extend({
        hoistStatic: true,
        onError: undefined,
        onWarn: $8POXm.NOOP
    }, options);
    if (!opts.isCustomElement && typeof customElements !== 'undefined') opts.isCustomElement = (tag)=>!!customElements.get(tag);
    const { code: code } = $3HHJ3.compile(template, opts);
    // The wildcard import results in a huge object with every export
    // with keys that cannot be mangled, and can be quite heavy size-wise.
    // In the global build we know `Vue` is available globally so we can avoid
    // the wildcard object.
    const render = new Function('Vue', code)($b7583dfe9c3698de$var$runtimeDom__namespace);
    render._rc = true;
    return $b7583dfe9c3698de$var$compileCache[key] = render;
}
$eeJ70.registerRuntimeCompiler($b7583dfe9c3698de$var$compileToFunction);
Object.keys($eeJ70).forEach(function(k) {
    if (k !== 'default') module.exports[k] = $eeJ70[k];
});
module.exports.compile = $b7583dfe9c3698de$var$compileToFunction;

});
parcelRegister("3HHJ3", function(module, exports) {

$parcel$export(module.exports, "compile", () => $2b274e48783ce38c$export$ef7acd7185315e22);

var $6rMDr = parcelRequire("6rMDr");

var $8POXm = parcelRequire("8POXm");
const $2b274e48783ce38c$export$840cf4d687fa64bf = Symbol(``);
const $2b274e48783ce38c$export$228d0b64761291c1 = Symbol(``);
const $2b274e48783ce38c$export$9f97e65b6f78b584 = Symbol(``);
const $2b274e48783ce38c$export$19eac69b46d09cfc = Symbol(``);
const $2b274e48783ce38c$export$334590174a9e57a1 = Symbol(``);
const $2b274e48783ce38c$export$5c621dc1b9e655a = Symbol(``);
const $2b274e48783ce38c$export$94febfb27c95c3cd = Symbol(``);
const $2b274e48783ce38c$export$be7d85494bd6f37b = Symbol(``);
const $2b274e48783ce38c$export$f2127cf693ff3edc = Symbol(``);
const $2b274e48783ce38c$export$bb9790ed494aa172 = Symbol(``);
(0, $6rMDr.registerRuntimeHelpers)({
    [$2b274e48783ce38c$export$840cf4d687fa64bf]: `vModelRadio`,
    [$2b274e48783ce38c$export$228d0b64761291c1]: `vModelCheckbox`,
    [$2b274e48783ce38c$export$9f97e65b6f78b584]: `vModelText`,
    [$2b274e48783ce38c$export$19eac69b46d09cfc]: `vModelSelect`,
    [$2b274e48783ce38c$export$334590174a9e57a1]: `vModelDynamic`,
    [$2b274e48783ce38c$export$5c621dc1b9e655a]: `withModifiers`,
    [$2b274e48783ce38c$export$94febfb27c95c3cd]: `withKeys`,
    [$2b274e48783ce38c$export$be7d85494bd6f37b]: `vShow`,
    [$2b274e48783ce38c$export$f2127cf693ff3edc]: `Transition`,
    [$2b274e48783ce38c$export$bb9790ed494aa172]: `TransitionGroup`
});
/* eslint-disable no-restricted-globals */ let $2b274e48783ce38c$var$decoder;
function $2b274e48783ce38c$var$decodeHtmlBrowser(raw, asAttr = false) {
    if (!$2b274e48783ce38c$var$decoder) $2b274e48783ce38c$var$decoder = document.createElement('div');
    if (asAttr) {
        $2b274e48783ce38c$var$decoder.innerHTML = `<div foo="${raw.replace(/"/g, '&quot;')}">`;
        return $2b274e48783ce38c$var$decoder.children[0].getAttribute('foo');
    } else {
        $2b274e48783ce38c$var$decoder.innerHTML = raw;
        return $2b274e48783ce38c$var$decoder.textContent;
    }
}
const $2b274e48783ce38c$var$isRawTextContainer = /*#__PURE__*/ (0, $8POXm.makeMap)('style,iframe,script,noscript', true);
const $2b274e48783ce38c$export$f3377f1c03a3aebd = {
    isVoidTag: $8POXm.isVoidTag,
    isNativeTag: (tag)=>(0, $8POXm.isHTMLTag)(tag) || (0, $8POXm.isSVGTag)(tag),
    isPreTag: (tag)=>tag === 'pre',
    decodeEntities: $2b274e48783ce38c$var$decodeHtmlBrowser,
    isBuiltInComponent: (tag)=>{
        if ((0, $6rMDr.isBuiltInType)(tag, `Transition`)) return $2b274e48783ce38c$export$f2127cf693ff3edc;
        else if ((0, $6rMDr.isBuiltInType)(tag, `TransitionGroup`)) return $2b274e48783ce38c$export$bb9790ed494aa172;
    },
    // https://html.spec.whatwg.org/multipage/parsing.html#tree-construction-dispatcher
    getNamespace (tag, parent) {
        let ns = parent ? parent.ns : 0 /* DOMNamespaces.HTML */ ;
        if (parent && ns === 2 /* DOMNamespaces.MATH_ML */ ) {
            if (parent.tag === 'annotation-xml') {
                if (tag === 'svg') return 1 /* DOMNamespaces.SVG */ ;
                if (parent.props.some((a)=>a.type === 6 /* NodeTypes.ATTRIBUTE */  && a.name === 'encoding' && a.value != null && (a.value.content === 'text/html' || a.value.content === 'application/xhtml+xml'))) ns = 0 /* DOMNamespaces.HTML */ ;
            } else if (/^m(?:[ions]|text)$/.test(parent.tag) && tag !== 'mglyph' && tag !== 'malignmark') ns = 0 /* DOMNamespaces.HTML */ ;
        } else if (parent && ns === 1 /* DOMNamespaces.SVG */ ) {
            if (parent.tag === 'foreignObject' || parent.tag === 'desc' || parent.tag === 'title') ns = 0 /* DOMNamespaces.HTML */ ;
        }
        if (ns === 0 /* DOMNamespaces.HTML */ ) {
            if (tag === 'svg') return 1 /* DOMNamespaces.SVG */ ;
            if (tag === 'math') return 2 /* DOMNamespaces.MATH_ML */ ;
        }
        return ns;
    },
    // https://html.spec.whatwg.org/multipage/parsing.html#parsing-html-fragments
    getTextMode ({ tag: tag, ns: ns }) {
        if (ns === 0 /* DOMNamespaces.HTML */ ) {
            if (tag === 'textarea' || tag === 'title') return 1 /* TextModes.RCDATA */ ;
            if ($2b274e48783ce38c$var$isRawTextContainer(tag)) return 2 /* TextModes.RAWTEXT */ ;
        }
        return 0 /* TextModes.DATA */ ;
    }
};
// Parse inline CSS strings for static style attributes into an object.
// This is a NodeTransform since it works on the static `style` attribute and
// converts it into a dynamic equivalent:
// style="color: red" -> :style='{ "color": "red" }'
// It is then processed by `transformElement` and included in the generated
// props.
const $2b274e48783ce38c$export$8dfeb887a12dd97a = (node)=>{
    if (node.type === 1 /* NodeTypes.ELEMENT */ ) node.props.forEach((p, i)=>{
        if (p.type === 6 /* NodeTypes.ATTRIBUTE */  && p.name === 'style' && p.value) // replace p with an expression node
        node.props[i] = {
            type: 7 /* NodeTypes.DIRECTIVE */ ,
            name: `bind`,
            arg: (0, $6rMDr.createSimpleExpression)(`style`, true, p.loc),
            exp: $2b274e48783ce38c$var$parseInlineCSS(p.value.content, p.loc),
            modifiers: [],
            loc: p.loc
        };
    });
};
const $2b274e48783ce38c$var$parseInlineCSS = (cssText, loc)=>{
    const normalized = (0, $8POXm.parseStringStyle)(cssText);
    return (0, $6rMDr.createSimpleExpression)(JSON.stringify(normalized), false, loc, 3 /* ConstantTypes.CAN_STRINGIFY */ );
};
function $2b274e48783ce38c$export$c2fa14fc707a7d94(code, loc) {
    return (0, $6rMDr.createCompilerError)(code, loc, undefined);
}
const $2b274e48783ce38c$var$DOMErrorMessages = {
    [50 /* DOMErrorCodes.X_V_HTML_NO_EXPRESSION */ ]: `v-html is missing expression.`,
    [51 /* DOMErrorCodes.X_V_HTML_WITH_CHILDREN */ ]: `v-html will override element children.`,
    [52 /* DOMErrorCodes.X_V_TEXT_NO_EXPRESSION */ ]: `v-text is missing expression.`,
    [53 /* DOMErrorCodes.X_V_TEXT_WITH_CHILDREN */ ]: `v-text will override element children.`,
    [54 /* DOMErrorCodes.X_V_MODEL_ON_INVALID_ELEMENT */ ]: `v-model can only be used on <input>, <textarea> and <select> elements.`,
    [55 /* DOMErrorCodes.X_V_MODEL_ARG_ON_ELEMENT */ ]: `v-model argument is not supported on plain elements.`,
    [56 /* DOMErrorCodes.X_V_MODEL_ON_FILE_INPUT_ELEMENT */ ]: `v-model cannot be used on file inputs since they are read-only. Use a v-on:change listener instead.`,
    [57 /* DOMErrorCodes.X_V_MODEL_UNNECESSARY_VALUE */ ]: `Unnecessary value binding used alongside v-model. It will interfere with v-model's behavior.`,
    [58 /* DOMErrorCodes.X_V_SHOW_NO_EXPRESSION */ ]: `v-show is missing expression.`,
    [59 /* DOMErrorCodes.X_TRANSITION_INVALID_CHILDREN */ ]: `<Transition> expects exactly one child element or component.`,
    [60 /* DOMErrorCodes.X_IGNORED_SIDE_EFFECT_TAG */ ]: `Tags with side effect (<script> and <style>) are ignored in client component templates.`
};
const $2b274e48783ce38c$var$transformVHtml = (dir, node, context)=>{
    const { exp: exp, loc: loc } = dir;
    if (!exp) context.onError($2b274e48783ce38c$export$c2fa14fc707a7d94(50 /* DOMErrorCodes.X_V_HTML_NO_EXPRESSION */ , loc));
    if (node.children.length) {
        context.onError($2b274e48783ce38c$export$c2fa14fc707a7d94(51 /* DOMErrorCodes.X_V_HTML_WITH_CHILDREN */ , loc));
        node.children.length = 0;
    }
    return {
        props: [
            (0, $6rMDr.createObjectProperty)((0, $6rMDr.createSimpleExpression)(`innerHTML`, true, loc), exp || (0, $6rMDr.createSimpleExpression)('', true))
        ]
    };
};
const $2b274e48783ce38c$var$transformVText = (dir, node, context)=>{
    const { exp: exp, loc: loc } = dir;
    if (!exp) context.onError($2b274e48783ce38c$export$c2fa14fc707a7d94(52 /* DOMErrorCodes.X_V_TEXT_NO_EXPRESSION */ , loc));
    if (node.children.length) {
        context.onError($2b274e48783ce38c$export$c2fa14fc707a7d94(53 /* DOMErrorCodes.X_V_TEXT_WITH_CHILDREN */ , loc));
        node.children.length = 0;
    }
    return {
        props: [
            (0, $6rMDr.createObjectProperty)((0, $6rMDr.createSimpleExpression)(`textContent`, true), exp ? (0, $6rMDr.getConstantType)(exp, context) > 0 ? exp : (0, $6rMDr.createCallExpression)(context.helperString((0, $6rMDr.TO_DISPLAY_STRING)), [
                exp
            ], loc) : (0, $6rMDr.createSimpleExpression)('', true))
        ]
    };
};
const $2b274e48783ce38c$var$transformModel = (dir, node, context)=>{
    const baseResult = (0, $6rMDr.transformModel)(dir, node, context);
    // base transform has errors OR component v-model (only need props)
    if (!baseResult.props.length || node.tagType === 1 /* ElementTypes.COMPONENT */ ) return baseResult;
    if (dir.arg) context.onError($2b274e48783ce38c$export$c2fa14fc707a7d94(55 /* DOMErrorCodes.X_V_MODEL_ARG_ON_ELEMENT */ , dir.arg.loc));
    function checkDuplicatedValue() {
        const value = (0, $6rMDr.findProp)(node, 'value');
        if (value) context.onError($2b274e48783ce38c$export$c2fa14fc707a7d94(57 /* DOMErrorCodes.X_V_MODEL_UNNECESSARY_VALUE */ , value.loc));
    }
    const { tag: tag } = node;
    const isCustomElement = context.isCustomElement(tag);
    if (tag === 'input' || tag === 'textarea' || tag === 'select' || isCustomElement) {
        let directiveToUse = $2b274e48783ce38c$export$9f97e65b6f78b584;
        let isInvalidType = false;
        if (tag === 'input' || isCustomElement) {
            const type = (0, $6rMDr.findProp)(node, `type`);
            if (type) {
                if (type.type === 7 /* NodeTypes.DIRECTIVE */ ) // :type="foo"
                directiveToUse = $2b274e48783ce38c$export$334590174a9e57a1;
                else if (type.value) switch(type.value.content){
                    case 'radio':
                        directiveToUse = $2b274e48783ce38c$export$840cf4d687fa64bf;
                        break;
                    case 'checkbox':
                        directiveToUse = $2b274e48783ce38c$export$228d0b64761291c1;
                        break;
                    case 'file':
                        isInvalidType = true;
                        context.onError($2b274e48783ce38c$export$c2fa14fc707a7d94(56 /* DOMErrorCodes.X_V_MODEL_ON_FILE_INPUT_ELEMENT */ , dir.loc));
                        break;
                    default:
                        break;
                }
            } else if ((0, $6rMDr.hasDynamicKeyVBind)(node)) // element has bindings with dynamic keys, which can possibly contain
            // "type".
            directiveToUse = $2b274e48783ce38c$export$334590174a9e57a1;
        } else if (tag === 'select') directiveToUse = $2b274e48783ce38c$export$19eac69b46d09cfc;
        // inject runtime directive
        // by returning the helper symbol via needRuntime
        // the import will replaced a resolveDirective call.
        if (!isInvalidType) baseResult.needRuntime = context.helper(directiveToUse);
    } else context.onError($2b274e48783ce38c$export$c2fa14fc707a7d94(54 /* DOMErrorCodes.X_V_MODEL_ON_INVALID_ELEMENT */ , dir.loc));
    // native vmodel doesn't need the `modelValue` props since they are also
    // passed to the runtime as `binding.value`. removing it reduces code size.
    baseResult.props = baseResult.props.filter((p)=>!(p.key.type === 4 /* NodeTypes.SIMPLE_EXPRESSION */  && p.key.content === 'modelValue'));
    return baseResult;
};
const $2b274e48783ce38c$var$isEventOptionModifier = /*#__PURE__*/ (0, $8POXm.makeMap)(`passive,once,capture`);
const $2b274e48783ce38c$var$isNonKeyModifier = /*#__PURE__*/ (0, $8POXm.makeMap)(// event propagation management
`stop,prevent,self,` + // system modifiers + exact
`ctrl,shift,alt,meta,exact,` + // mouse
`middle`);
// left & right could be mouse or key modifiers based on event type
const $2b274e48783ce38c$var$maybeKeyModifier = /*#__PURE__*/ (0, $8POXm.makeMap)('left,right');
const $2b274e48783ce38c$var$isKeyboardEvent = /*#__PURE__*/ (0, $8POXm.makeMap)(`onkeyup,onkeydown,onkeypress`, true);
const $2b274e48783ce38c$var$resolveModifiers = (key, modifiers, context, loc)=>{
    const keyModifiers = [];
    const nonKeyModifiers = [];
    const eventOptionModifiers = [];
    for(let i = 0; i < modifiers.length; i++){
        const modifier = modifiers[i];
        if (modifier === 'native' && (0, $6rMDr.checkCompatEnabled)("COMPILER_V_ON_NATIVE" /* CompilerDeprecationTypes.COMPILER_V_ON_NATIVE */ , context, loc)) eventOptionModifiers.push(modifier);
        else if ($2b274e48783ce38c$var$isEventOptionModifier(modifier)) // eventOptionModifiers: modifiers for addEventListener() options,
        // e.g. .passive & .capture
        eventOptionModifiers.push(modifier);
        else {
            // runtimeModifiers: modifiers that needs runtime guards
            if ($2b274e48783ce38c$var$maybeKeyModifier(modifier)) {
                if ((0, $6rMDr.isStaticExp)(key)) {
                    if ($2b274e48783ce38c$var$isKeyboardEvent(key.content)) keyModifiers.push(modifier);
                    else nonKeyModifiers.push(modifier);
                } else {
                    keyModifiers.push(modifier);
                    nonKeyModifiers.push(modifier);
                }
            } else if ($2b274e48783ce38c$var$isNonKeyModifier(modifier)) nonKeyModifiers.push(modifier);
            else keyModifiers.push(modifier);
        }
    }
    return {
        keyModifiers: keyModifiers,
        nonKeyModifiers: nonKeyModifiers,
        eventOptionModifiers: eventOptionModifiers
    };
};
const $2b274e48783ce38c$var$transformClick = (key, event)=>{
    const isStaticClick = (0, $6rMDr.isStaticExp)(key) && key.content.toLowerCase() === 'onclick';
    return isStaticClick ? (0, $6rMDr.createSimpleExpression)(event, true) : key.type !== 4 /* NodeTypes.SIMPLE_EXPRESSION */  ? (0, $6rMDr.createCompoundExpression)([
        `(`,
        key,
        `) === "onClick" ? "${event}" : (`,
        key,
        `)`
    ]) : key;
};
const $2b274e48783ce38c$var$transformOn = (dir, node, context)=>{
    return (0, $6rMDr.transformOn)(dir, node, context, (baseResult)=>{
        const { modifiers: modifiers } = dir;
        if (!modifiers.length) return baseResult;
        let { key: key, value: handlerExp } = baseResult.props[0];
        const { keyModifiers: keyModifiers, nonKeyModifiers: nonKeyModifiers, eventOptionModifiers: eventOptionModifiers } = $2b274e48783ce38c$var$resolveModifiers(key, modifiers, context, dir.loc);
        // normalize click.right and click.middle since they don't actually fire
        if (nonKeyModifiers.includes('right')) key = $2b274e48783ce38c$var$transformClick(key, `onContextmenu`);
        if (nonKeyModifiers.includes('middle')) key = $2b274e48783ce38c$var$transformClick(key, `onMouseup`);
        if (nonKeyModifiers.length) handlerExp = (0, $6rMDr.createCallExpression)(context.helper($2b274e48783ce38c$export$5c621dc1b9e655a), [
            handlerExp,
            JSON.stringify(nonKeyModifiers)
        ]);
        if (keyModifiers.length && // if event name is dynamic, always wrap with keys guard
        (!(0, $6rMDr.isStaticExp)(key) || $2b274e48783ce38c$var$isKeyboardEvent(key.content))) handlerExp = (0, $6rMDr.createCallExpression)(context.helper($2b274e48783ce38c$export$94febfb27c95c3cd), [
            handlerExp,
            JSON.stringify(keyModifiers)
        ]);
        if (eventOptionModifiers.length) {
            const modifierPostfix = eventOptionModifiers.map((0, $8POXm.capitalize)).join('');
            key = (0, $6rMDr.isStaticExp)(key) ? (0, $6rMDr.createSimpleExpression)(`${key.content}${modifierPostfix}`, true) : (0, $6rMDr.createCompoundExpression)([
                `(`,
                key,
                `) + "${modifierPostfix}"`
            ]);
        }
        return {
            props: [
                (0, $6rMDr.createObjectProperty)(key, handlerExp)
            ]
        };
    });
};
const $2b274e48783ce38c$var$transformShow = (dir, node, context)=>{
    const { exp: exp, loc: loc } = dir;
    if (!exp) context.onError($2b274e48783ce38c$export$c2fa14fc707a7d94(58 /* DOMErrorCodes.X_V_SHOW_NO_EXPRESSION */ , loc));
    return {
        props: [],
        needRuntime: context.helper($2b274e48783ce38c$export$be7d85494bd6f37b)
    };
};
const $2b274e48783ce38c$var$transformTransition = (node, context)=>{
    if (node.type === 1 /* NodeTypes.ELEMENT */  && node.tagType === 1 /* ElementTypes.COMPONENT */ ) {
        const component = context.isBuiltInComponent(node.tag);
        if (component === $2b274e48783ce38c$export$f2127cf693ff3edc) return ()=>{
            if (!node.children.length) return;
            // warn multiple transition children
            if ($2b274e48783ce38c$var$hasMultipleChildren(node)) context.onError($2b274e48783ce38c$export$c2fa14fc707a7d94(59 /* DOMErrorCodes.X_TRANSITION_INVALID_CHILDREN */ , {
                start: node.children[0].loc.start,
                end: node.children[node.children.length - 1].loc.end,
                source: ''
            }));
            // check if it's s single child w/ v-show
            // if yes, inject "persisted: true" to the transition props
            const child = node.children[0];
            if (child.type === 1 /* NodeTypes.ELEMENT */ ) {
                for (const p of child.props)if (p.type === 7 /* NodeTypes.DIRECTIVE */  && p.name === 'show') node.props.push({
                    type: 6 /* NodeTypes.ATTRIBUTE */ ,
                    name: 'persisted',
                    value: undefined,
                    loc: node.loc
                });
            }
        };
    }
};
function $2b274e48783ce38c$var$hasMultipleChildren(node) {
    // #1352 filter out potential comment nodes.
    const children = node.children = node.children.filter((c)=>c.type !== 3 /* NodeTypes.COMMENT */  && !(c.type === 2 /* NodeTypes.TEXT */  && !c.content.trim()));
    const child = children[0];
    return children.length !== 1 || child.type === 11 /* NodeTypes.FOR */  || child.type === 9 /* NodeTypes.IF */  && child.branches.some($2b274e48783ce38c$var$hasMultipleChildren);
}
const $2b274e48783ce38c$var$ignoreSideEffectTags = (node, context)=>{
    if (node.type === 1 /* NodeTypes.ELEMENT */  && node.tagType === 0 /* ElementTypes.ELEMENT */  && (node.tag === 'script' || node.tag === 'style')) {
        context.onError($2b274e48783ce38c$export$c2fa14fc707a7d94(60 /* DOMErrorCodes.X_IGNORED_SIDE_EFFECT_TAG */ , node.loc));
        context.removeNode();
    }
};
const $2b274e48783ce38c$export$e801dc6012e0c348 = [
    $2b274e48783ce38c$export$8dfeb887a12dd97a
];
const $2b274e48783ce38c$export$2257f60ebb1a11be = {
    cloak: (0, $6rMDr.noopDirectiveTransform),
    html: $2b274e48783ce38c$var$transformVHtml,
    text: $2b274e48783ce38c$var$transformVText,
    model: $2b274e48783ce38c$var$transformModel,
    on: $2b274e48783ce38c$var$transformOn,
    show: $2b274e48783ce38c$var$transformShow
};
function $2b274e48783ce38c$export$ef7acd7185315e22(template, options = {}) {
    return (0, $6rMDr.baseCompile)(template, (0, $8POXm.extend)({}, $2b274e48783ce38c$export$f3377f1c03a3aebd, options, {
        nodeTransforms: [
            // ignore <script> and <tag>
            // this is not put inside DOMNodeTransforms because that list is used
            // by compiler-ssr to generate vnode fallback branches
            $2b274e48783ce38c$var$ignoreSideEffectTags,
            ...$2b274e48783ce38c$export$e801dc6012e0c348,
            ...options.nodeTransforms || []
        ],
        directiveTransforms: (0, $8POXm.extend)({}, $2b274e48783ce38c$export$2257f60ebb1a11be, options.directiveTransforms || {}),
        transformHoist: null
    }));
}
function $2b274e48783ce38c$export$98e6a39c04603d36(template, options = {}) {
    return (0, $6rMDr.baseParse)(template, (0, $8POXm.extend)({}, $2b274e48783ce38c$export$f3377f1c03a3aebd, options));
}

});
parcelRegister("6rMDr", function(module, exports) {

$parcel$export(module.exports, "createCompilerError", () => $4b1afda415637ecc$export$57c5a5dc5aa19bdf);
$parcel$export(module.exports, "TO_DISPLAY_STRING", () => $4b1afda415637ecc$export$68f5914cce0a5680);
$parcel$export(module.exports, "registerRuntimeHelpers", () => $4b1afda415637ecc$export$8c4e724519c87f31);
$parcel$export(module.exports, "createObjectProperty", () => $4b1afda415637ecc$export$45231d90c148ea74);
$parcel$export(module.exports, "createSimpleExpression", () => $4b1afda415637ecc$export$ac2aa689b44cdd23);
$parcel$export(module.exports, "createCompoundExpression", () => $4b1afda415637ecc$export$60ad01cd5cde5e50);
$parcel$export(module.exports, "createCallExpression", () => $4b1afda415637ecc$export$2cdf8617f9d8e39d);
$parcel$export(module.exports, "isStaticExp", () => $4b1afda415637ecc$export$43d387e2d68b51dc);
$parcel$export(module.exports, "isBuiltInType", () => $4b1afda415637ecc$export$39883f63b394982);
$parcel$export(module.exports, "findProp", () => $4b1afda415637ecc$export$4ae65475e3513615);
$parcel$export(module.exports, "hasDynamicKeyVBind", () => $4b1afda415637ecc$export$4e1f112c75b8dafc);
$parcel$export(module.exports, "checkCompatEnabled", () => $4b1afda415637ecc$export$1b1c14b93fcc0fe4);
$parcel$export(module.exports, "baseParse", () => $4b1afda415637ecc$export$f5f219d5f09c81b5);
$parcel$export(module.exports, "getConstantType", () => $4b1afda415637ecc$export$7967f5197c38d72a);
$parcel$export(module.exports, "transformOn", () => $4b1afda415637ecc$export$ff060d152244ee7b);
$parcel$export(module.exports, "transformModel", () => $4b1afda415637ecc$export$567db1f69abf4dcb);
$parcel$export(module.exports, "baseCompile", () => $4b1afda415637ecc$export$3243579822c486a0);
$parcel$export(module.exports, "noopDirectiveTransform", () => $4b1afda415637ecc$export$eb34aa2b2065da17);

var $8POXm = parcelRequire("8POXm");
function $4b1afda415637ecc$var$defaultOnError(error) {
    throw error;
}
function $4b1afda415637ecc$var$defaultOnWarn(msg) {}
function $4b1afda415637ecc$export$57c5a5dc5aa19bdf(code, loc, messages, additionalMessage) {
    const msg = code;
    const error = new SyntaxError(String(msg));
    error.code = code;
    error.loc = loc;
    return error;
}
const $4b1afda415637ecc$var$errorMessages = {
    // parse errors
    [0 /* ErrorCodes.ABRUPT_CLOSING_OF_EMPTY_COMMENT */ ]: 'Illegal comment.',
    [1 /* ErrorCodes.CDATA_IN_HTML_CONTENT */ ]: 'CDATA section is allowed only in XML context.',
    [2 /* ErrorCodes.DUPLICATE_ATTRIBUTE */ ]: 'Duplicate attribute.',
    [3 /* ErrorCodes.END_TAG_WITH_ATTRIBUTES */ ]: 'End tag cannot have attributes.',
    [4 /* ErrorCodes.END_TAG_WITH_TRAILING_SOLIDUS */ ]: "Illegal '/' in tags.",
    [5 /* ErrorCodes.EOF_BEFORE_TAG_NAME */ ]: 'Unexpected EOF in tag.',
    [6 /* ErrorCodes.EOF_IN_CDATA */ ]: 'Unexpected EOF in CDATA section.',
    [7 /* ErrorCodes.EOF_IN_COMMENT */ ]: 'Unexpected EOF in comment.',
    [8 /* ErrorCodes.EOF_IN_SCRIPT_HTML_COMMENT_LIKE_TEXT */ ]: 'Unexpected EOF in script.',
    [9 /* ErrorCodes.EOF_IN_TAG */ ]: 'Unexpected EOF in tag.',
    [10 /* ErrorCodes.INCORRECTLY_CLOSED_COMMENT */ ]: 'Incorrectly closed comment.',
    [11 /* ErrorCodes.INCORRECTLY_OPENED_COMMENT */ ]: 'Incorrectly opened comment.',
    [12 /* ErrorCodes.INVALID_FIRST_CHARACTER_OF_TAG_NAME */ ]: "Illegal tag name. Use '&lt;' to print '<'.",
    [13 /* ErrorCodes.MISSING_ATTRIBUTE_VALUE */ ]: 'Attribute value was expected.',
    [14 /* ErrorCodes.MISSING_END_TAG_NAME */ ]: 'End tag name was expected.',
    [15 /* ErrorCodes.MISSING_WHITESPACE_BETWEEN_ATTRIBUTES */ ]: 'Whitespace was expected.',
    [16 /* ErrorCodes.NESTED_COMMENT */ ]: "Unexpected '<!--' in comment.",
    [17 /* ErrorCodes.UNEXPECTED_CHARACTER_IN_ATTRIBUTE_NAME */ ]: 'Attribute name cannot contain U+0022 ("), U+0027 (\'), and U+003C (<).',
    [18 /* ErrorCodes.UNEXPECTED_CHARACTER_IN_UNQUOTED_ATTRIBUTE_VALUE */ ]: 'Unquoted attribute value cannot contain U+0022 ("), U+0027 (\'), U+003C (<), U+003D (=), and U+0060 (`).',
    [19 /* ErrorCodes.UNEXPECTED_EQUALS_SIGN_BEFORE_ATTRIBUTE_NAME */ ]: "Attribute name cannot start with '='.",
    [21 /* ErrorCodes.UNEXPECTED_QUESTION_MARK_INSTEAD_OF_TAG_NAME */ ]: "'<?' is allowed only in XML context.",
    [20 /* ErrorCodes.UNEXPECTED_NULL_CHARACTER */ ]: `Unexpected null character.`,
    [22 /* ErrorCodes.UNEXPECTED_SOLIDUS_IN_TAG */ ]: "Illegal '/' in tags.",
    // Vue-specific parse errors
    [23 /* ErrorCodes.X_INVALID_END_TAG */ ]: 'Invalid end tag.',
    [24 /* ErrorCodes.X_MISSING_END_TAG */ ]: 'Element is missing end tag.',
    [25 /* ErrorCodes.X_MISSING_INTERPOLATION_END */ ]: 'Interpolation end sign was not found.',
    [27 /* ErrorCodes.X_MISSING_DYNAMIC_DIRECTIVE_ARGUMENT_END */ ]: "End bracket for dynamic directive argument was not found. Note that dynamic directive argument cannot contain spaces.",
    [26 /* ErrorCodes.X_MISSING_DIRECTIVE_NAME */ ]: 'Legal directive name was expected.',
    // transform errors
    [28 /* ErrorCodes.X_V_IF_NO_EXPRESSION */ ]: `v-if/v-else-if is missing expression.`,
    [29 /* ErrorCodes.X_V_IF_SAME_KEY */ ]: `v-if/else branches must use unique keys.`,
    [30 /* ErrorCodes.X_V_ELSE_NO_ADJACENT_IF */ ]: `v-else/v-else-if has no adjacent v-if or v-else-if.`,
    [31 /* ErrorCodes.X_V_FOR_NO_EXPRESSION */ ]: `v-for is missing expression.`,
    [32 /* ErrorCodes.X_V_FOR_MALFORMED_EXPRESSION */ ]: `v-for has invalid expression.`,
    [33 /* ErrorCodes.X_V_FOR_TEMPLATE_KEY_PLACEMENT */ ]: `<template v-for> key should be placed on the <template> tag.`,
    [34 /* ErrorCodes.X_V_BIND_NO_EXPRESSION */ ]: `v-bind is missing expression.`,
    [35 /* ErrorCodes.X_V_ON_NO_EXPRESSION */ ]: `v-on is missing expression.`,
    [36 /* ErrorCodes.X_V_SLOT_UNEXPECTED_DIRECTIVE_ON_SLOT_OUTLET */ ]: `Unexpected custom directive on <slot> outlet.`,
    [37 /* ErrorCodes.X_V_SLOT_MIXED_SLOT_USAGE */ ]: `Mixed v-slot usage on both the component and nested <template>.` + `When there are multiple named slots, all slots should use <template> ` + `syntax to avoid scope ambiguity.`,
    [38 /* ErrorCodes.X_V_SLOT_DUPLICATE_SLOT_NAMES */ ]: `Duplicate slot names found. `,
    [39 /* ErrorCodes.X_V_SLOT_EXTRANEOUS_DEFAULT_SLOT_CHILDREN */ ]: `Extraneous children found when component already has explicitly named ` + `default slot. These children will be ignored.`,
    [40 /* ErrorCodes.X_V_SLOT_MISPLACED */ ]: `v-slot can only be used on components or <template> tags.`,
    [41 /* ErrorCodes.X_V_MODEL_NO_EXPRESSION */ ]: `v-model is missing expression.`,
    [42 /* ErrorCodes.X_V_MODEL_MALFORMED_EXPRESSION */ ]: `v-model value must be a valid JavaScript member expression.`,
    [43 /* ErrorCodes.X_V_MODEL_ON_SCOPE_VARIABLE */ ]: `v-model cannot be used on v-for or v-slot scope variables because they are not writable.`,
    [44 /* ErrorCodes.X_INVALID_EXPRESSION */ ]: `Error parsing JavaScript expression: `,
    [45 /* ErrorCodes.X_KEEP_ALIVE_INVALID_CHILDREN */ ]: `<KeepAlive> expects exactly one child component.`,
    // generic errors
    [46 /* ErrorCodes.X_PREFIX_ID_NOT_SUPPORTED */ ]: `"prefixIdentifiers" option is not supported in this build of compiler.`,
    [47 /* ErrorCodes.X_MODULE_MODE_NOT_SUPPORTED */ ]: `ES module mode is not supported in this build of compiler.`,
    [48 /* ErrorCodes.X_CACHE_HANDLER_NOT_SUPPORTED */ ]: `"cacheHandlers" option is only supported when the "prefixIdentifiers" option is enabled.`,
    [49 /* ErrorCodes.X_SCOPE_ID_NOT_SUPPORTED */ ]: `"scopeId" option is only supported in module mode.`,
    // just to fulfill types
    [50 /* ErrorCodes.__EXTEND_POINT__ */ ]: ``
};
const $4b1afda415637ecc$export$4bebefc40c8513e8 = Symbol(``);
const $4b1afda415637ecc$export$e74e82bc14ac4f98 = Symbol(``);
const $4b1afda415637ecc$export$2237d737f4a10705 = Symbol(``);
const $4b1afda415637ecc$export$e9ff5bb5c39478ed = Symbol(``);
const $4b1afda415637ecc$export$b357ae9fe0a3685a = Symbol(``);
const $4b1afda415637ecc$export$59578e14f90a15eb = Symbol(``);
const $4b1afda415637ecc$export$37ddf5a12480514c = Symbol(``);
const $4b1afda415637ecc$export$f87906340c78a650 = Symbol(``);
const $4b1afda415637ecc$export$6db5bf2474139178 = Symbol(``);
const $4b1afda415637ecc$export$b22e7e78da20c982 = Symbol(``);
const $4b1afda415637ecc$export$b2aae42fb0a19db3 = Symbol(``);
const $4b1afda415637ecc$export$8890896270dfc293 = Symbol(``);
const $4b1afda415637ecc$export$1a493e4b98fdcf3 = Symbol(``);
const $4b1afda415637ecc$export$28c52e95383d270 = Symbol(``);
const $4b1afda415637ecc$export$582a2287b73d3265 = Symbol(``);
const $4b1afda415637ecc$export$7f3ccc2ef793ecce = Symbol(``);
const $4b1afda415637ecc$export$2c190751e09c3969 = Symbol(``);
const $4b1afda415637ecc$export$a5e4c1729e50ed6d = Symbol(``);
const $4b1afda415637ecc$export$3da0e5cd78c1870 = Symbol(``);
const $4b1afda415637ecc$export$a91e32c6b04aa348 = Symbol(``);
const $4b1afda415637ecc$export$6a6b6a5c860c238d = Symbol(``);
const $4b1afda415637ecc$export$68f5914cce0a5680 = Symbol(``);
const $4b1afda415637ecc$export$825e32c0f842262a = Symbol(``);
const $4b1afda415637ecc$export$6382e3ed89de4e2a = Symbol(``);
const $4b1afda415637ecc$export$b9d3780a9ab822b4 = Symbol(``);
const $4b1afda415637ecc$export$78c34c869683dd86 = Symbol(``);
const $4b1afda415637ecc$export$7046bb8d3c918928 = Symbol(``);
const $4b1afda415637ecc$export$4bdbf33367525856 = Symbol(``);
const $4b1afda415637ecc$export$3ebbf6981763e181 = Symbol(``);
const $4b1afda415637ecc$export$e3e7f5f6c22384b5 = Symbol(``);
const $4b1afda415637ecc$export$8687eaac3cd39ddd = Symbol(``);
const $4b1afda415637ecc$export$37cf1f9ab937c10d = Symbol(``);
const $4b1afda415637ecc$export$d8e039410dcfa57d = Symbol(``);
const $4b1afda415637ecc$export$4266498fbffc3354 = Symbol(``);
const $4b1afda415637ecc$export$141e17a2b5200090 = Symbol(``);
const $4b1afda415637ecc$export$e0f3ad8c273cc513 = Symbol(``);
const $4b1afda415637ecc$export$cf2c1c7bc34dc87e = Symbol(``);
const $4b1afda415637ecc$export$a0fd71f0f7cd2781 = Symbol(``);
const $4b1afda415637ecc$export$ae18cf0dc81df35a = Symbol(``);
// Name mapping for runtime helpers that need to be imported from 'vue' in
// generated code. Make sure these are correctly exported in the runtime!
// Using `any` here because TS doesn't allow symbols as index type.
const $4b1afda415637ecc$export$7dc1fc5a07bc9b35 = {
    [$4b1afda415637ecc$export$4bebefc40c8513e8]: `Fragment`,
    [$4b1afda415637ecc$export$e74e82bc14ac4f98]: `Teleport`,
    [$4b1afda415637ecc$export$2237d737f4a10705]: `Suspense`,
    [$4b1afda415637ecc$export$e9ff5bb5c39478ed]: `KeepAlive`,
    [$4b1afda415637ecc$export$b357ae9fe0a3685a]: `BaseTransition`,
    [$4b1afda415637ecc$export$59578e14f90a15eb]: `openBlock`,
    [$4b1afda415637ecc$export$37ddf5a12480514c]: `createBlock`,
    [$4b1afda415637ecc$export$f87906340c78a650]: `createElementBlock`,
    [$4b1afda415637ecc$export$6db5bf2474139178]: `createVNode`,
    [$4b1afda415637ecc$export$b22e7e78da20c982]: `createElementVNode`,
    [$4b1afda415637ecc$export$b2aae42fb0a19db3]: `createCommentVNode`,
    [$4b1afda415637ecc$export$8890896270dfc293]: `createTextVNode`,
    [$4b1afda415637ecc$export$1a493e4b98fdcf3]: `createStaticVNode`,
    [$4b1afda415637ecc$export$28c52e95383d270]: `resolveComponent`,
    [$4b1afda415637ecc$export$582a2287b73d3265]: `resolveDynamicComponent`,
    [$4b1afda415637ecc$export$7f3ccc2ef793ecce]: `resolveDirective`,
    [$4b1afda415637ecc$export$2c190751e09c3969]: `resolveFilter`,
    [$4b1afda415637ecc$export$a5e4c1729e50ed6d]: `withDirectives`,
    [$4b1afda415637ecc$export$3da0e5cd78c1870]: `renderList`,
    [$4b1afda415637ecc$export$a91e32c6b04aa348]: `renderSlot`,
    [$4b1afda415637ecc$export$6a6b6a5c860c238d]: `createSlots`,
    [$4b1afda415637ecc$export$68f5914cce0a5680]: `toDisplayString`,
    [$4b1afda415637ecc$export$825e32c0f842262a]: `mergeProps`,
    [$4b1afda415637ecc$export$6382e3ed89de4e2a]: `normalizeClass`,
    [$4b1afda415637ecc$export$b9d3780a9ab822b4]: `normalizeStyle`,
    [$4b1afda415637ecc$export$78c34c869683dd86]: `normalizeProps`,
    [$4b1afda415637ecc$export$7046bb8d3c918928]: `guardReactiveProps`,
    [$4b1afda415637ecc$export$4bdbf33367525856]: `toHandlers`,
    [$4b1afda415637ecc$export$3ebbf6981763e181]: `camelize`,
    [$4b1afda415637ecc$export$e3e7f5f6c22384b5]: `capitalize`,
    [$4b1afda415637ecc$export$8687eaac3cd39ddd]: `toHandlerKey`,
    [$4b1afda415637ecc$export$37cf1f9ab937c10d]: `setBlockTracking`,
    [$4b1afda415637ecc$export$d8e039410dcfa57d]: `pushScopeId`,
    [$4b1afda415637ecc$export$4266498fbffc3354]: `popScopeId`,
    [$4b1afda415637ecc$export$141e17a2b5200090]: `withCtx`,
    [$4b1afda415637ecc$export$e0f3ad8c273cc513]: `unref`,
    [$4b1afda415637ecc$export$cf2c1c7bc34dc87e]: `isRef`,
    [$4b1afda415637ecc$export$a0fd71f0f7cd2781]: `withMemo`,
    [$4b1afda415637ecc$export$ae18cf0dc81df35a]: `isMemoSame`
};
function $4b1afda415637ecc$export$8c4e724519c87f31(helpers) {
    Object.getOwnPropertySymbols(helpers).forEach((s)=>{
        $4b1afda415637ecc$export$7dc1fc5a07bc9b35[s] = helpers[s];
    });
}
// AST Utilities ---------------------------------------------------------------
// Some expressions, e.g. sequence and conditional expressions, are never
// associated with template nodes, so their source locations are just a stub.
// Container types like CompoundExpression also don't need a real location.
const $4b1afda415637ecc$export$6c4f24c93c3e8659 = {
    source: '',
    start: {
        line: 1,
        column: 1,
        offset: 0
    },
    end: {
        line: 1,
        column: 1,
        offset: 0
    }
};
function $4b1afda415637ecc$export$882461b6382ed46c(children, loc = $4b1afda415637ecc$export$6c4f24c93c3e8659) {
    return {
        type: 0 /* NodeTypes.ROOT */ ,
        children: children,
        helpers: [],
        components: [],
        directives: [],
        hoists: [],
        imports: [],
        cached: 0,
        temps: 0,
        codegenNode: undefined,
        loc: loc
    };
}
function $4b1afda415637ecc$export$d1cb722ac2a8b632(context, tag, props, children, patchFlag, dynamicProps, directives, isBlock = false, disableTracking = false, isComponent = false, loc = $4b1afda415637ecc$export$6c4f24c93c3e8659) {
    if (context) {
        if (isBlock) {
            context.helper($4b1afda415637ecc$export$59578e14f90a15eb);
            context.helper($4b1afda415637ecc$export$74fb204a6eba800d(context.inSSR, isComponent));
        } else context.helper($4b1afda415637ecc$export$3b9fc44425f495a6(context.inSSR, isComponent));
        if (directives) context.helper($4b1afda415637ecc$export$a5e4c1729e50ed6d);
    }
    return {
        type: 13 /* NodeTypes.VNODE_CALL */ ,
        tag: tag,
        props: props,
        children: children,
        patchFlag: patchFlag,
        dynamicProps: dynamicProps,
        directives: directives,
        isBlock: isBlock,
        disableTracking: disableTracking,
        isComponent: isComponent,
        loc: loc
    };
}
function $4b1afda415637ecc$export$c887713da9895dbb(elements, loc = $4b1afda415637ecc$export$6c4f24c93c3e8659) {
    return {
        type: 17 /* NodeTypes.JS_ARRAY_EXPRESSION */ ,
        loc: loc,
        elements: elements
    };
}
function $4b1afda415637ecc$export$ccb2e514379853a7(properties, loc = $4b1afda415637ecc$export$6c4f24c93c3e8659) {
    return {
        type: 15 /* NodeTypes.JS_OBJECT_EXPRESSION */ ,
        loc: loc,
        properties: properties
    };
}
function $4b1afda415637ecc$export$45231d90c148ea74(key, value) {
    return {
        type: 16 /* NodeTypes.JS_PROPERTY */ ,
        loc: $4b1afda415637ecc$export$6c4f24c93c3e8659,
        key: (0, $8POXm.isString)(key) ? $4b1afda415637ecc$export$ac2aa689b44cdd23(key, true) : key,
        value: value
    };
}
function $4b1afda415637ecc$export$ac2aa689b44cdd23(content, isStatic = false, loc = $4b1afda415637ecc$export$6c4f24c93c3e8659, constType = 0 /* ConstantTypes.NOT_CONSTANT */ ) {
    return {
        type: 4 /* NodeTypes.SIMPLE_EXPRESSION */ ,
        loc: loc,
        content: content,
        isStatic: isStatic,
        constType: isStatic ? 3 /* ConstantTypes.CAN_STRINGIFY */  : constType
    };
}
function $4b1afda415637ecc$export$96ca1dcf947302d0(content, loc) {
    return {
        type: 5 /* NodeTypes.INTERPOLATION */ ,
        loc: loc,
        content: (0, $8POXm.isString)(content) ? $4b1afda415637ecc$export$ac2aa689b44cdd23(content, false, loc) : content
    };
}
function $4b1afda415637ecc$export$60ad01cd5cde5e50(children, loc = $4b1afda415637ecc$export$6c4f24c93c3e8659) {
    return {
        type: 8 /* NodeTypes.COMPOUND_EXPRESSION */ ,
        loc: loc,
        children: children
    };
}
function $4b1afda415637ecc$export$2cdf8617f9d8e39d(callee, args = [], loc = $4b1afda415637ecc$export$6c4f24c93c3e8659) {
    return {
        type: 14 /* NodeTypes.JS_CALL_EXPRESSION */ ,
        loc: loc,
        callee: callee,
        arguments: args
    };
}
function $4b1afda415637ecc$export$253e05bfd5b6c4c6(params, returns, newline = false, isSlot = false, loc = $4b1afda415637ecc$export$6c4f24c93c3e8659) {
    return {
        type: 18 /* NodeTypes.JS_FUNCTION_EXPRESSION */ ,
        params: params,
        returns: returns,
        newline: newline,
        isSlot: isSlot,
        loc: loc
    };
}
function $4b1afda415637ecc$export$374e02fb5bd90a4e(test, consequent, alternate, newline = true) {
    return {
        type: 19 /* NodeTypes.JS_CONDITIONAL_EXPRESSION */ ,
        test: test,
        consequent: consequent,
        alternate: alternate,
        newline: newline,
        loc: $4b1afda415637ecc$export$6c4f24c93c3e8659
    };
}
function $4b1afda415637ecc$export$4abd162ddf919697(index, value, isVNode = false) {
    return {
        type: 20 /* NodeTypes.JS_CACHE_EXPRESSION */ ,
        index: index,
        value: value,
        isVNode: isVNode,
        loc: $4b1afda415637ecc$export$6c4f24c93c3e8659
    };
}
function $4b1afda415637ecc$export$c3ad9e28586f1d07(body) {
    return {
        type: 21 /* NodeTypes.JS_BLOCK_STATEMENT */ ,
        body: body,
        loc: $4b1afda415637ecc$export$6c4f24c93c3e8659
    };
}
function $4b1afda415637ecc$export$242433d85418a087(elements) {
    return {
        type: 22 /* NodeTypes.JS_TEMPLATE_LITERAL */ ,
        elements: elements,
        loc: $4b1afda415637ecc$export$6c4f24c93c3e8659
    };
}
function $4b1afda415637ecc$export$71ff4dcc047b6a4e(test, consequent, alternate) {
    return {
        type: 23 /* NodeTypes.JS_IF_STATEMENT */ ,
        test: test,
        consequent: consequent,
        alternate: alternate,
        loc: $4b1afda415637ecc$export$6c4f24c93c3e8659
    };
}
function $4b1afda415637ecc$export$f6cfc415b0df5d79(left, right) {
    return {
        type: 24 /* NodeTypes.JS_ASSIGNMENT_EXPRESSION */ ,
        left: left,
        right: right,
        loc: $4b1afda415637ecc$export$6c4f24c93c3e8659
    };
}
function $4b1afda415637ecc$export$42d3d4c35b19948b(expressions) {
    return {
        type: 25 /* NodeTypes.JS_SEQUENCE_EXPRESSION */ ,
        expressions: expressions,
        loc: $4b1afda415637ecc$export$6c4f24c93c3e8659
    };
}
function $4b1afda415637ecc$export$746323a443188826(returns) {
    return {
        type: 26 /* NodeTypes.JS_RETURN_STATEMENT */ ,
        returns: returns,
        loc: $4b1afda415637ecc$export$6c4f24c93c3e8659
    };
}
const $4b1afda415637ecc$export$43d387e2d68b51dc = (p)=>p.type === 4 /* NodeTypes.SIMPLE_EXPRESSION */  && p.isStatic;
const $4b1afda415637ecc$export$39883f63b394982 = (tag, expected)=>tag === expected || tag === (0, $8POXm.hyphenate)(expected);
function $4b1afda415637ecc$export$69768c9b514a01e9(tag) {
    if ($4b1afda415637ecc$export$39883f63b394982(tag, 'Teleport')) return $4b1afda415637ecc$export$e74e82bc14ac4f98;
    else if ($4b1afda415637ecc$export$39883f63b394982(tag, 'Suspense')) return $4b1afda415637ecc$export$2237d737f4a10705;
    else if ($4b1afda415637ecc$export$39883f63b394982(tag, 'KeepAlive')) return $4b1afda415637ecc$export$e9ff5bb5c39478ed;
    else if ($4b1afda415637ecc$export$39883f63b394982(tag, 'BaseTransition')) return $4b1afda415637ecc$export$b357ae9fe0a3685a;
}
const $4b1afda415637ecc$var$nonIdentifierRE = /^\d|[^\$\w]/;
const $4b1afda415637ecc$export$3cb8486ad206c65 = (name)=>!$4b1afda415637ecc$var$nonIdentifierRE.test(name);
const $4b1afda415637ecc$var$validFirstIdentCharRE = /[A-Za-z_$\xA0-\uFFFF]/;
const $4b1afda415637ecc$var$validIdentCharRE = /[\.\?\w$\xA0-\uFFFF]/;
const $4b1afda415637ecc$var$whitespaceRE = /\s+[.[]\s*|\s*[.[]\s+/g;
/**
 * Simple lexer to check if an expression is a member expression. This is
 * lax and only checks validity at the root level (i.e. does not validate exps
 * inside square brackets), but it's ok since these are only used on template
 * expressions and false positives are invalid expressions in the first place.
 */ const $4b1afda415637ecc$export$fc15bf43a5359adf = (path)=>{
    // remove whitespaces around . or [ first
    path = path.trim().replace($4b1afda415637ecc$var$whitespaceRE, (s)=>s.trim());
    let state = 0 /* MemberExpLexState.inMemberExp */ ;
    let stateStack = [];
    let currentOpenBracketCount = 0;
    let currentOpenParensCount = 0;
    let currentStringType = null;
    for(let i = 0; i < path.length; i++){
        const char = path.charAt(i);
        switch(state){
            case 0 /* MemberExpLexState.inMemberExp */ :
                if (char === '[') {
                    stateStack.push(state);
                    state = 1 /* MemberExpLexState.inBrackets */ ;
                    currentOpenBracketCount++;
                } else if (char === '(') {
                    stateStack.push(state);
                    state = 2 /* MemberExpLexState.inParens */ ;
                    currentOpenParensCount++;
                } else if (!(i === 0 ? $4b1afda415637ecc$var$validFirstIdentCharRE : $4b1afda415637ecc$var$validIdentCharRE).test(char)) return false;
                break;
            case 1 /* MemberExpLexState.inBrackets */ :
                if (char === `'` || char === `"` || char === '`') {
                    stateStack.push(state);
                    state = 3 /* MemberExpLexState.inString */ ;
                    currentStringType = char;
                } else if (char === `[`) currentOpenBracketCount++;
                else if (char === `]`) {
                    if (!--currentOpenBracketCount) state = stateStack.pop();
                }
                break;
            case 2 /* MemberExpLexState.inParens */ :
                if (char === `'` || char === `"` || char === '`') {
                    stateStack.push(state);
                    state = 3 /* MemberExpLexState.inString */ ;
                    currentStringType = char;
                } else if (char === `(`) currentOpenParensCount++;
                else if (char === `)`) {
                    // if the exp ends as a call then it should not be considered valid
                    if (i === path.length - 1) return false;
                    if (!--currentOpenParensCount) state = stateStack.pop();
                }
                break;
            case 3 /* MemberExpLexState.inString */ :
                if (char === currentStringType) {
                    state = stateStack.pop();
                    currentStringType = null;
                }
                break;
        }
    }
    return !currentOpenBracketCount && !currentOpenParensCount;
};
const $4b1afda415637ecc$export$380d727799fbcdda = (0, $8POXm.NOOP);
const $4b1afda415637ecc$export$9c8bdf9fab617ce4 = $4b1afda415637ecc$export$fc15bf43a5359adf;
function $4b1afda415637ecc$export$1b56c942e608880a(loc, offset, length) {
    const source = loc.source.slice(offset, offset + length);
    const newLoc = {
        source: source,
        start: $4b1afda415637ecc$export$1cdf554524c0924f(loc.start, loc.source, offset),
        end: loc.end
    };
    if (length != null) newLoc.end = $4b1afda415637ecc$export$1cdf554524c0924f(loc.start, loc.source, offset + length);
    return newLoc;
}
function $4b1afda415637ecc$export$1cdf554524c0924f(pos, source, numberOfCharacters = source.length) {
    return $4b1afda415637ecc$export$c57ab60b0c6308ea((0, $8POXm.extend)({}, pos), source, numberOfCharacters);
}
// advance by mutation without cloning (for performance reasons), since this
// gets called a lot in the parser
function $4b1afda415637ecc$export$c57ab60b0c6308ea(pos, source, numberOfCharacters = source.length) {
    let linesCount = 0;
    let lastNewLinePos = -1;
    for(let i = 0; i < numberOfCharacters; i++)if (source.charCodeAt(i) === 10 /* newline char code */ ) {
        linesCount++;
        lastNewLinePos = i;
    }
    pos.offset += numberOfCharacters;
    pos.line += linesCount;
    pos.column = lastNewLinePos === -1 ? pos.column + numberOfCharacters : numberOfCharacters - lastNewLinePos;
    return pos;
}
function $4b1afda415637ecc$export$a7a9523472993e97(condition, msg) {
    /* istanbul ignore if */ if (!condition) throw new Error(msg || `unexpected compiler condition`);
}
function $4b1afda415637ecc$export$1199bc2a2b648c8c(node, name, allowEmpty = false) {
    for(let i = 0; i < node.props.length; i++){
        const p = node.props[i];
        if (p.type === 7 /* NodeTypes.DIRECTIVE */  && (allowEmpty || p.exp) && ((0, $8POXm.isString)(name) ? p.name === name : name.test(p.name))) return p;
    }
}
function $4b1afda415637ecc$export$4ae65475e3513615(node, name, dynamicOnly = false, allowEmpty = false) {
    for(let i = 0; i < node.props.length; i++){
        const p = node.props[i];
        if (p.type === 6 /* NodeTypes.ATTRIBUTE */ ) {
            if (dynamicOnly) continue;
            if (p.name === name && (p.value || allowEmpty)) return p;
        } else if (p.name === 'bind' && (p.exp || allowEmpty) && $4b1afda415637ecc$export$45cac5109adb5e55(p.arg, name)) return p;
    }
}
function $4b1afda415637ecc$export$45cac5109adb5e55(arg, name) {
    return !!(arg && $4b1afda415637ecc$export$43d387e2d68b51dc(arg) && arg.content === name);
}
function $4b1afda415637ecc$export$4e1f112c75b8dafc(node) {
    return node.props.some((p)=>p.type === 7 /* NodeTypes.DIRECTIVE */  && p.name === 'bind' && (!p.arg || // v-bind="obj"
        p.arg.type !== 4 /* NodeTypes.SIMPLE_EXPRESSION */  || // v-bind:[_ctx.foo]
        !p.arg.isStatic // v-bind:[foo]
        ));
}
function $4b1afda415637ecc$export$1879817ac5c922b7(node) {
    return node.type === 5 /* NodeTypes.INTERPOLATION */  || node.type === 2 /* NodeTypes.TEXT */ ;
}
function $4b1afda415637ecc$export$eaf8991bb8af8cbb(p) {
    return p.type === 7 /* NodeTypes.DIRECTIVE */  && p.name === 'slot';
}
function $4b1afda415637ecc$export$f125a8a2b402ed89(node) {
    return node.type === 1 /* NodeTypes.ELEMENT */  && node.tagType === 3 /* ElementTypes.TEMPLATE */ ;
}
function $4b1afda415637ecc$export$45f38ad7fffc9b53(node) {
    return node.type === 1 /* NodeTypes.ELEMENT */  && node.tagType === 2 /* ElementTypes.SLOT */ ;
}
function $4b1afda415637ecc$export$3b9fc44425f495a6(ssr, isComponent) {
    return ssr || isComponent ? $4b1afda415637ecc$export$6db5bf2474139178 : $4b1afda415637ecc$export$b22e7e78da20c982;
}
function $4b1afda415637ecc$export$74fb204a6eba800d(ssr, isComponent) {
    return ssr || isComponent ? $4b1afda415637ecc$export$37ddf5a12480514c : $4b1afda415637ecc$export$f87906340c78a650;
}
const $4b1afda415637ecc$var$propsHelperSet = new Set([
    $4b1afda415637ecc$export$78c34c869683dd86,
    $4b1afda415637ecc$export$7046bb8d3c918928
]);
function $4b1afda415637ecc$var$getUnnormalizedProps(props, callPath = []) {
    if (props && !(0, $8POXm.isString)(props) && props.type === 14 /* NodeTypes.JS_CALL_EXPRESSION */ ) {
        const callee = props.callee;
        if (!(0, $8POXm.isString)(callee) && $4b1afda415637ecc$var$propsHelperSet.has(callee)) return $4b1afda415637ecc$var$getUnnormalizedProps(props.arguments[0], callPath.concat(props));
    }
    return [
        props,
        callPath
    ];
}
function $4b1afda415637ecc$export$ec34add3fb2185f8(node, prop, context) {
    let propsWithInjection;
    /**
     * 1. mergeProps(...)
     * 2. toHandlers(...)
     * 3. normalizeProps(...)
     * 4. normalizeProps(guardReactiveProps(...))
     *
     * we need to get the real props before normalization
     */ let props = node.type === 13 /* NodeTypes.VNODE_CALL */  ? node.props : node.arguments[2];
    let callPath = [];
    let parentCall;
    if (props && !(0, $8POXm.isString)(props) && props.type === 14 /* NodeTypes.JS_CALL_EXPRESSION */ ) {
        const ret = $4b1afda415637ecc$var$getUnnormalizedProps(props);
        props = ret[0];
        callPath = ret[1];
        parentCall = callPath[callPath.length - 1];
    }
    if (props == null || (0, $8POXm.isString)(props)) propsWithInjection = $4b1afda415637ecc$export$ccb2e514379853a7([
        prop
    ]);
    else if (props.type === 14 /* NodeTypes.JS_CALL_EXPRESSION */ ) {
        // merged props... add ours
        // only inject key to object literal if it's the first argument so that
        // if doesn't override user provided keys
        const first = props.arguments[0];
        if (!(0, $8POXm.isString)(first) && first.type === 15 /* NodeTypes.JS_OBJECT_EXPRESSION */ ) first.properties.unshift(prop);
        else if (props.callee === $4b1afda415637ecc$export$4bdbf33367525856) // #2366
        propsWithInjection = $4b1afda415637ecc$export$2cdf8617f9d8e39d(context.helper($4b1afda415637ecc$export$825e32c0f842262a), [
            $4b1afda415637ecc$export$ccb2e514379853a7([
                prop
            ]),
            props
        ]);
        else props.arguments.unshift($4b1afda415637ecc$export$ccb2e514379853a7([
            prop
        ]));
        !propsWithInjection && (propsWithInjection = props);
    } else if (props.type === 15 /* NodeTypes.JS_OBJECT_EXPRESSION */ ) {
        let alreadyExists = false;
        // check existing key to avoid overriding user provided keys
        if (prop.key.type === 4 /* NodeTypes.SIMPLE_EXPRESSION */ ) {
            const propKeyName = prop.key.content;
            alreadyExists = props.properties.some((p)=>p.key.type === 4 /* NodeTypes.SIMPLE_EXPRESSION */  && p.key.content === propKeyName);
        }
        if (!alreadyExists) props.properties.unshift(prop);
        propsWithInjection = props;
    } else {
        // single v-bind with expression, return a merged replacement
        propsWithInjection = $4b1afda415637ecc$export$2cdf8617f9d8e39d(context.helper($4b1afda415637ecc$export$825e32c0f842262a), [
            $4b1afda415637ecc$export$ccb2e514379853a7([
                prop
            ]),
            props
        ]);
        // in the case of nested helper call, e.g. `normalizeProps(guardReactiveProps(props))`,
        // it will be rewritten as `normalizeProps(mergeProps({ key: 0 }, props))`,
        // the `guardReactiveProps` will no longer be needed
        if (parentCall && parentCall.callee === $4b1afda415637ecc$export$7046bb8d3c918928) parentCall = callPath[callPath.length - 2];
    }
    if (node.type === 13 /* NodeTypes.VNODE_CALL */ ) {
        if (parentCall) parentCall.arguments[0] = propsWithInjection;
        else node.props = propsWithInjection;
    } else if (parentCall) parentCall.arguments[0] = propsWithInjection;
    else node.arguments[2] = propsWithInjection;
}
function $4b1afda415637ecc$export$80505c1072df544f(name, type) {
    // see issue#4422, we need adding identifier on validAssetId if variable `name` has specific character
    return `_${type}_${name.replace(/[^\w]/g, (searchValue, replaceValue)=>{
        return searchValue === '-' ? '_' : name.charCodeAt(replaceValue).toString();
    })}`;
}
// Check if a node contains expressions that reference current context scope ids
function $4b1afda415637ecc$export$587b5ad66ebfa843(node, ids) {
    if (!node || Object.keys(ids).length === 0) return false;
    switch(node.type){
        case 1 /* NodeTypes.ELEMENT */ :
            for(let i = 0; i < node.props.length; i++){
                const p = node.props[i];
                if (p.type === 7 /* NodeTypes.DIRECTIVE */  && ($4b1afda415637ecc$export$587b5ad66ebfa843(p.arg, ids) || $4b1afda415637ecc$export$587b5ad66ebfa843(p.exp, ids))) return true;
            }
            return node.children.some((c)=>$4b1afda415637ecc$export$587b5ad66ebfa843(c, ids));
        case 11 /* NodeTypes.FOR */ :
            if ($4b1afda415637ecc$export$587b5ad66ebfa843(node.source, ids)) return true;
            return node.children.some((c)=>$4b1afda415637ecc$export$587b5ad66ebfa843(c, ids));
        case 9 /* NodeTypes.IF */ :
            return node.branches.some((b)=>$4b1afda415637ecc$export$587b5ad66ebfa843(b, ids));
        case 10 /* NodeTypes.IF_BRANCH */ :
            if ($4b1afda415637ecc$export$587b5ad66ebfa843(node.condition, ids)) return true;
            return node.children.some((c)=>$4b1afda415637ecc$export$587b5ad66ebfa843(c, ids));
        case 4 /* NodeTypes.SIMPLE_EXPRESSION */ :
            return !node.isStatic && $4b1afda415637ecc$export$3cb8486ad206c65(node.content) && !!ids[node.content];
        case 8 /* NodeTypes.COMPOUND_EXPRESSION */ :
            return node.children.some((c)=>(0, $8POXm.isObject)(c) && $4b1afda415637ecc$export$587b5ad66ebfa843(c, ids));
        case 5 /* NodeTypes.INTERPOLATION */ :
        case 12 /* NodeTypes.TEXT_CALL */ :
            return $4b1afda415637ecc$export$587b5ad66ebfa843(node.content, ids);
        case 2 /* NodeTypes.TEXT */ :
        case 3 /* NodeTypes.COMMENT */ :
            return false;
        default:
            return false;
    }
}
function $4b1afda415637ecc$export$39e241985cd3e673(node) {
    if (node.type === 14 /* NodeTypes.JS_CALL_EXPRESSION */  && node.callee === $4b1afda415637ecc$export$a0fd71f0f7cd2781) return node.arguments[1].returns;
    else return node;
}
function $4b1afda415637ecc$export$8fa6719e405ab23c(node, { helper: helper, removeHelper: removeHelper, inSSR: inSSR }) {
    if (!node.isBlock) {
        node.isBlock = true;
        removeHelper($4b1afda415637ecc$export$3b9fc44425f495a6(inSSR, node.isComponent));
        helper($4b1afda415637ecc$export$59578e14f90a15eb);
        helper($4b1afda415637ecc$export$74fb204a6eba800d(inSSR, node.isComponent));
    }
}
const $4b1afda415637ecc$var$deprecationData = {
    ["COMPILER_IS_ON_ELEMENT" /* CompilerDeprecationTypes.COMPILER_IS_ON_ELEMENT */ ]: {
        message: `Platform-native elements with "is" prop will no longer be ` + `treated as components in Vue 3 unless the "is" value is explicitly ` + `prefixed with "vue:".`,
        link: `https://v3-migration.vuejs.org/breaking-changes/custom-elements-interop.html`
    },
    ["COMPILER_V_BIND_SYNC" /* CompilerDeprecationTypes.COMPILER_V_BIND_SYNC */ ]: {
        message: (key)=>`.sync modifier for v-bind has been removed. Use v-model with ` + `argument instead. \`v-bind:${key}.sync\` should be changed to ` + `\`v-model:${key}\`.`,
        link: `https://v3-migration.vuejs.org/breaking-changes/v-model.html`
    },
    ["COMPILER_V_BIND_PROP" /* CompilerDeprecationTypes.COMPILER_V_BIND_PROP */ ]: {
        message: `.prop modifier for v-bind has been removed and no longer necessary. ` + `Vue 3 will automatically set a binding as DOM property when appropriate.`
    },
    ["COMPILER_V_BIND_OBJECT_ORDER" /* CompilerDeprecationTypes.COMPILER_V_BIND_OBJECT_ORDER */ ]: {
        message: `v-bind="obj" usage is now order sensitive and behaves like JavaScript ` + `object spread: it will now overwrite an existing non-mergeable attribute ` + `that appears before v-bind in the case of conflict. ` + `To retain 2.x behavior, move v-bind to make it the first attribute. ` + `You can also suppress this warning if the usage is intended.`,
        link: `https://v3-migration.vuejs.org/breaking-changes/v-bind.html`
    },
    ["COMPILER_V_ON_NATIVE" /* CompilerDeprecationTypes.COMPILER_V_ON_NATIVE */ ]: {
        message: `.native modifier for v-on has been removed as is no longer necessary.`,
        link: `https://v3-migration.vuejs.org/breaking-changes/v-on-native-modifier-removed.html`
    },
    ["COMPILER_V_IF_V_FOR_PRECEDENCE" /* CompilerDeprecationTypes.COMPILER_V_IF_V_FOR_PRECEDENCE */ ]: {
        message: `v-if / v-for precedence when used on the same element has changed ` + `in Vue 3: v-if now takes higher precedence and will no longer have ` + `access to v-for scope variables. It is best to avoid the ambiguity ` + `with <template> tags or use a computed property that filters v-for ` + `data source.`,
        link: `https://v3-migration.vuejs.org/breaking-changes/v-if-v-for.html`
    },
    ["COMPILER_NATIVE_TEMPLATE" /* CompilerDeprecationTypes.COMPILER_NATIVE_TEMPLATE */ ]: {
        message: `<template> with no special directives will render as a native template ` + `element instead of its inner content in Vue 3.`
    },
    ["COMPILER_INLINE_TEMPLATE" /* CompilerDeprecationTypes.COMPILER_INLINE_TEMPLATE */ ]: {
        message: `"inline-template" has been removed in Vue 3.`,
        link: `https://v3-migration.vuejs.org/breaking-changes/inline-template-attribute.html`
    },
    ["COMPILER_FILTER" /* CompilerDeprecationTypes.COMPILER_FILTERS */ ]: {
        message: `filters have been removed in Vue 3. ` + `The "|" symbol will be treated as native JavaScript bitwise OR operator. ` + `Use method calls or computed properties instead.`,
        link: `https://v3-migration.vuejs.org/breaking-changes/filters.html`
    }
};
function $4b1afda415637ecc$var$getCompatValue(key, context) {
    const config = context.options ? context.options.compatConfig : context.compatConfig;
    const value = config && config[key];
    if (key === 'MODE') return value || 3; // compiler defaults to v3 behavior
    else return value;
}
function $4b1afda415637ecc$var$isCompatEnabled(key, context) {
    const mode = $4b1afda415637ecc$var$getCompatValue('MODE', context);
    const value = $4b1afda415637ecc$var$getCompatValue(key, context);
    // in v3 mode, only enable if explicitly set to true
    // otherwise enable for any non-false value
    return mode === 3 ? value === true : value !== false;
}
function $4b1afda415637ecc$export$1b1c14b93fcc0fe4(key, context, loc, ...args) {
    const enabled = $4b1afda415637ecc$var$isCompatEnabled(key, context);
    return enabled;
}
function $4b1afda415637ecc$export$1c4d39b152e0f791(key, context, loc, ...args) {
    const val = $4b1afda415637ecc$var$getCompatValue(key, context);
    if (val === 'suppress-warning') return;
    const { message: message, link: link } = $4b1afda415637ecc$var$deprecationData[key];
    const msg = `(deprecation ${key}) ${typeof message === 'function' ? message(...args) : message}${link ? `\n  Details: ${link}` : ``}`;
    const err = new SyntaxError(msg);
    err.code = key;
    if (loc) err.loc = loc;
    context.onWarn(err);
}
// The default decoder only provides escapes for characters reserved as part of
// the template syntax, and is only used if the custom renderer did not provide
// a platform-specific decoder.
const $4b1afda415637ecc$var$decodeRE = /&(gt|lt|amp|apos|quot);/g;
const $4b1afda415637ecc$var$decodeMap = {
    gt: '>',
    lt: '<',
    amp: '&',
    apos: "'",
    quot: '"'
};
const $4b1afda415637ecc$var$defaultParserOptions = {
    delimiters: [
        `{{`,
        `}}`
    ],
    getNamespace: ()=>0 /* Namespaces.HTML */ ,
    getTextMode: ()=>0 /* TextModes.DATA */ ,
    isVoidTag: (0, $8POXm.NO),
    isPreTag: (0, $8POXm.NO),
    isCustomElement: (0, $8POXm.NO),
    decodeEntities: (rawText)=>rawText.replace($4b1afda415637ecc$var$decodeRE, (_, p1)=>$4b1afda415637ecc$var$decodeMap[p1]),
    onError: $4b1afda415637ecc$var$defaultOnError,
    onWarn: $4b1afda415637ecc$var$defaultOnWarn,
    comments: false
};
function $4b1afda415637ecc$export$f5f219d5f09c81b5(content, options = {}) {
    const context = $4b1afda415637ecc$var$createParserContext(content, options);
    const start = $4b1afda415637ecc$var$getCursor(context);
    return $4b1afda415637ecc$export$882461b6382ed46c($4b1afda415637ecc$var$parseChildren(context, 0 /* TextModes.DATA */ , []), $4b1afda415637ecc$var$getSelection(context, start));
}
function $4b1afda415637ecc$var$createParserContext(content, rawOptions) {
    const options = (0, $8POXm.extend)({}, $4b1afda415637ecc$var$defaultParserOptions);
    let key;
    for(key in rawOptions)// @ts-ignore
    options[key] = rawOptions[key] === undefined ? $4b1afda415637ecc$var$defaultParserOptions[key] : rawOptions[key];
    return {
        options: options,
        column: 1,
        line: 1,
        offset: 0,
        originalSource: content,
        source: content,
        inPre: false,
        inVPre: false,
        onWarn: options.onWarn
    };
}
function $4b1afda415637ecc$var$parseChildren(context, mode, ancestors) {
    const parent = $4b1afda415637ecc$var$last(ancestors);
    const ns = parent ? parent.ns : 0 /* Namespaces.HTML */ ;
    const nodes = [];
    while(!$4b1afda415637ecc$var$isEnd(context, mode, ancestors)){
        const s = context.source;
        let node = undefined;
        if (mode === 0 /* TextModes.DATA */  || mode === 1 /* TextModes.RCDATA */ ) {
            if (!context.inVPre && $4b1afda415637ecc$var$startsWith(s, context.options.delimiters[0])) // '{{'
            node = $4b1afda415637ecc$var$parseInterpolation(context, mode);
            else if (mode === 0 /* TextModes.DATA */  && s[0] === '<') {
                // https://html.spec.whatwg.org/multipage/parsing.html#tag-open-state
                if (s.length === 1) $4b1afda415637ecc$var$emitError(context, 5 /* ErrorCodes.EOF_BEFORE_TAG_NAME */ , 1);
                else if (s[1] === '!') {
                    // https://html.spec.whatwg.org/multipage/parsing.html#markup-declaration-open-state
                    if ($4b1afda415637ecc$var$startsWith(s, '<!--')) node = $4b1afda415637ecc$var$parseComment(context);
                    else if ($4b1afda415637ecc$var$startsWith(s, '<!DOCTYPE')) // Ignore DOCTYPE by a limitation.
                    node = $4b1afda415637ecc$var$parseBogusComment(context);
                    else if ($4b1afda415637ecc$var$startsWith(s, '<![CDATA[')) {
                        if (ns !== 0 /* Namespaces.HTML */ ) node = $4b1afda415637ecc$var$parseCDATA(context, ancestors);
                        else {
                            $4b1afda415637ecc$var$emitError(context, 1 /* ErrorCodes.CDATA_IN_HTML_CONTENT */ );
                            node = $4b1afda415637ecc$var$parseBogusComment(context);
                        }
                    } else {
                        $4b1afda415637ecc$var$emitError(context, 11 /* ErrorCodes.INCORRECTLY_OPENED_COMMENT */ );
                        node = $4b1afda415637ecc$var$parseBogusComment(context);
                    }
                } else if (s[1] === '/') {
                    // https://html.spec.whatwg.org/multipage/parsing.html#end-tag-open-state
                    if (s.length === 2) $4b1afda415637ecc$var$emitError(context, 5 /* ErrorCodes.EOF_BEFORE_TAG_NAME */ , 2);
                    else if (s[2] === '>') {
                        $4b1afda415637ecc$var$emitError(context, 14 /* ErrorCodes.MISSING_END_TAG_NAME */ , 2);
                        $4b1afda415637ecc$var$advanceBy(context, 3);
                        continue;
                    } else if (/[a-z]/i.test(s[2])) {
                        $4b1afda415637ecc$var$emitError(context, 23 /* ErrorCodes.X_INVALID_END_TAG */ );
                        $4b1afda415637ecc$var$parseTag(context, 1 /* TagType.End */ , parent);
                        continue;
                    } else {
                        $4b1afda415637ecc$var$emitError(context, 12 /* ErrorCodes.INVALID_FIRST_CHARACTER_OF_TAG_NAME */ , 2);
                        node = $4b1afda415637ecc$var$parseBogusComment(context);
                    }
                } else if (/[a-z]/i.test(s[1])) {
                    node = $4b1afda415637ecc$var$parseElement(context, ancestors);
                    // 2.x <template> with no directive compat
                    if ($4b1afda415637ecc$var$isCompatEnabled("COMPILER_NATIVE_TEMPLATE" /* CompilerDeprecationTypes.COMPILER_NATIVE_TEMPLATE */ , context) && node && node.tag === 'template' && !node.props.some((p)=>p.type === 7 /* NodeTypes.DIRECTIVE */  && $4b1afda415637ecc$var$isSpecialTemplateDirective(p.name))) node = node.children;
                } else if (s[1] === '?') {
                    $4b1afda415637ecc$var$emitError(context, 21 /* ErrorCodes.UNEXPECTED_QUESTION_MARK_INSTEAD_OF_TAG_NAME */ , 1);
                    node = $4b1afda415637ecc$var$parseBogusComment(context);
                } else $4b1afda415637ecc$var$emitError(context, 12 /* ErrorCodes.INVALID_FIRST_CHARACTER_OF_TAG_NAME */ , 1);
            }
        }
        if (!node) node = $4b1afda415637ecc$var$parseText(context, mode);
        if ((0, $8POXm.isArray)(node)) for(let i = 0; i < node.length; i++)$4b1afda415637ecc$var$pushNode(nodes, node[i]);
        else $4b1afda415637ecc$var$pushNode(nodes, node);
    }
    // Whitespace handling strategy like v2
    let removedWhitespace = false;
    if (mode !== 2 /* TextModes.RAWTEXT */  && mode !== 1 /* TextModes.RCDATA */ ) {
        const shouldCondense = context.options.whitespace !== 'preserve';
        for(let i = 0; i < nodes.length; i++){
            const node = nodes[i];
            if (!context.inPre && node.type === 2 /* NodeTypes.TEXT */ ) {
                if (!/[^\t\r\n\f ]/.test(node.content)) {
                    const prev = nodes[i - 1];
                    const next = nodes[i + 1];
                    // Remove if:
                    // - the whitespace is the first or last node, or:
                    // - (condense mode) the whitespace is adjacent to a comment, or:
                    // - (condense mode) the whitespace is between two elements AND contains newline
                    if (!prev || !next || shouldCondense && (prev.type === 3 /* NodeTypes.COMMENT */  || next.type === 3 /* NodeTypes.COMMENT */  || prev.type === 1 /* NodeTypes.ELEMENT */  && next.type === 1 /* NodeTypes.ELEMENT */  && /[\r\n]/.test(node.content))) {
                        removedWhitespace = true;
                        nodes[i] = null;
                    } else // Otherwise, the whitespace is condensed into a single space
                    node.content = ' ';
                } else if (shouldCondense) // in condense mode, consecutive whitespaces in text are condensed
                // down to a single space.
                node.content = node.content.replace(/[\t\r\n\f ]+/g, ' ');
            } else if (node.type === 3 /* NodeTypes.COMMENT */  && !context.options.comments) {
                removedWhitespace = true;
                nodes[i] = null;
            }
        }
        if (context.inPre && parent && context.options.isPreTag(parent.tag)) {
            // remove leading newline per html spec
            // https://html.spec.whatwg.org/multipage/grouping-content.html#the-pre-element
            const first = nodes[0];
            if (first && first.type === 2 /* NodeTypes.TEXT */ ) first.content = first.content.replace(/^\r?\n/, '');
        }
    }
    return removedWhitespace ? nodes.filter(Boolean) : nodes;
}
function $4b1afda415637ecc$var$pushNode(nodes, node) {
    if (node.type === 2 /* NodeTypes.TEXT */ ) {
        const prev = $4b1afda415637ecc$var$last(nodes);
        // Merge if both this and the previous node are text and those are
        // consecutive. This happens for cases like "a < b".
        if (prev && prev.type === 2 /* NodeTypes.TEXT */  && prev.loc.end.offset === node.loc.start.offset) {
            prev.content += node.content;
            prev.loc.end = node.loc.end;
            prev.loc.source += node.loc.source;
            return;
        }
    }
    nodes.push(node);
}
function $4b1afda415637ecc$var$parseCDATA(context, ancestors) {
    $4b1afda415637ecc$var$advanceBy(context, 9);
    const nodes = $4b1afda415637ecc$var$parseChildren(context, 3 /* TextModes.CDATA */ , ancestors);
    if (context.source.length === 0) $4b1afda415637ecc$var$emitError(context, 6 /* ErrorCodes.EOF_IN_CDATA */ );
    else $4b1afda415637ecc$var$advanceBy(context, 3);
    return nodes;
}
function $4b1afda415637ecc$var$parseComment(context) {
    const start = $4b1afda415637ecc$var$getCursor(context);
    let content;
    // Regular comment.
    const match = /--(\!)?>/.exec(context.source);
    if (!match) {
        content = context.source.slice(4);
        $4b1afda415637ecc$var$advanceBy(context, context.source.length);
        $4b1afda415637ecc$var$emitError(context, 7 /* ErrorCodes.EOF_IN_COMMENT */ );
    } else {
        if (match.index <= 3) $4b1afda415637ecc$var$emitError(context, 0 /* ErrorCodes.ABRUPT_CLOSING_OF_EMPTY_COMMENT */ );
        if (match[1]) $4b1afda415637ecc$var$emitError(context, 10 /* ErrorCodes.INCORRECTLY_CLOSED_COMMENT */ );
        content = context.source.slice(4, match.index);
        // Advancing with reporting nested comments.
        const s = context.source.slice(0, match.index);
        let prevIndex = 1, nestedIndex = 0;
        while((nestedIndex = s.indexOf('<!--', prevIndex)) !== -1){
            $4b1afda415637ecc$var$advanceBy(context, nestedIndex - prevIndex + 1);
            if (nestedIndex + 4 < s.length) $4b1afda415637ecc$var$emitError(context, 16 /* ErrorCodes.NESTED_COMMENT */ );
            prevIndex = nestedIndex + 1;
        }
        $4b1afda415637ecc$var$advanceBy(context, match.index + match[0].length - prevIndex + 1);
    }
    return {
        type: 3 /* NodeTypes.COMMENT */ ,
        content: content,
        loc: $4b1afda415637ecc$var$getSelection(context, start)
    };
}
function $4b1afda415637ecc$var$parseBogusComment(context) {
    const start = $4b1afda415637ecc$var$getCursor(context);
    const contentStart = context.source[1] === '?' ? 1 : 2;
    let content;
    const closeIndex = context.source.indexOf('>');
    if (closeIndex === -1) {
        content = context.source.slice(contentStart);
        $4b1afda415637ecc$var$advanceBy(context, context.source.length);
    } else {
        content = context.source.slice(contentStart, closeIndex);
        $4b1afda415637ecc$var$advanceBy(context, closeIndex + 1);
    }
    return {
        type: 3 /* NodeTypes.COMMENT */ ,
        content: content,
        loc: $4b1afda415637ecc$var$getSelection(context, start)
    };
}
function $4b1afda415637ecc$var$parseElement(context, ancestors) {
    // Start tag.
    const wasInPre = context.inPre;
    const wasInVPre = context.inVPre;
    const parent = $4b1afda415637ecc$var$last(ancestors);
    const element = $4b1afda415637ecc$var$parseTag(context, 0 /* TagType.Start */ , parent);
    const isPreBoundary = context.inPre && !wasInPre;
    const isVPreBoundary = context.inVPre && !wasInVPre;
    if (element.isSelfClosing || context.options.isVoidTag(element.tag)) {
        // #4030 self-closing <pre> tag
        if (isPreBoundary) context.inPre = false;
        if (isVPreBoundary) context.inVPre = false;
        return element;
    }
    // Children.
    ancestors.push(element);
    const mode = context.options.getTextMode(element, parent);
    const children = $4b1afda415637ecc$var$parseChildren(context, mode, ancestors);
    ancestors.pop();
    // 2.x inline-template compat
    {
        const inlineTemplateProp = element.props.find((p)=>p.type === 6 /* NodeTypes.ATTRIBUTE */  && p.name === 'inline-template');
        if (inlineTemplateProp && $4b1afda415637ecc$export$1b1c14b93fcc0fe4("COMPILER_INLINE_TEMPLATE" /* CompilerDeprecationTypes.COMPILER_INLINE_TEMPLATE */ , context, inlineTemplateProp.loc)) {
            const loc = $4b1afda415637ecc$var$getSelection(context, element.loc.end);
            inlineTemplateProp.value = {
                type: 2 /* NodeTypes.TEXT */ ,
                content: loc.source,
                loc: loc
            };
        }
    }
    element.children = children;
    // End tag.
    if ($4b1afda415637ecc$var$startsWithEndTagOpen(context.source, element.tag)) $4b1afda415637ecc$var$parseTag(context, 1 /* TagType.End */ , parent);
    else {
        $4b1afda415637ecc$var$emitError(context, 24 /* ErrorCodes.X_MISSING_END_TAG */ , 0, element.loc.start);
        if (context.source.length === 0 && element.tag.toLowerCase() === 'script') {
            const first = children[0];
            if (first && $4b1afda415637ecc$var$startsWith(first.loc.source, '<!--')) $4b1afda415637ecc$var$emitError(context, 8 /* ErrorCodes.EOF_IN_SCRIPT_HTML_COMMENT_LIKE_TEXT */ );
        }
    }
    element.loc = $4b1afda415637ecc$var$getSelection(context, element.loc.start);
    if (isPreBoundary) context.inPre = false;
    if (isVPreBoundary) context.inVPre = false;
    return element;
}
const $4b1afda415637ecc$var$isSpecialTemplateDirective = /*#__PURE__*/ (0, $8POXm.makeMap)(`if,else,else-if,for,slot`);
function $4b1afda415637ecc$var$parseTag(context, type, parent) {
    // Tag open.
    const start = $4b1afda415637ecc$var$getCursor(context);
    const match = /^<\/?([a-z][^\t\r\n\f />]*)/i.exec(context.source);
    const tag = match[1];
    const ns = context.options.getNamespace(tag, parent);
    $4b1afda415637ecc$var$advanceBy(context, match[0].length);
    $4b1afda415637ecc$var$advanceSpaces(context);
    // save current state in case we need to re-parse attributes with v-pre
    const cursor = $4b1afda415637ecc$var$getCursor(context);
    const currentSource = context.source;
    // check <pre> tag
    if (context.options.isPreTag(tag)) context.inPre = true;
    // Attributes.
    let props = $4b1afda415637ecc$var$parseAttributes(context, type);
    // check v-pre
    if (type === 0 /* TagType.Start */  && !context.inVPre && props.some((p)=>p.type === 7 /* NodeTypes.DIRECTIVE */  && p.name === 'pre')) {
        context.inVPre = true;
        // reset context
        (0, $8POXm.extend)(context, cursor);
        context.source = currentSource;
        // re-parse attrs and filter out v-pre itself
        props = $4b1afda415637ecc$var$parseAttributes(context, type).filter((p)=>p.name !== 'v-pre');
    }
    // Tag close.
    let isSelfClosing = false;
    if (context.source.length === 0) $4b1afda415637ecc$var$emitError(context, 9 /* ErrorCodes.EOF_IN_TAG */ );
    else {
        isSelfClosing = $4b1afda415637ecc$var$startsWith(context.source, '/>');
        if (type === 1 /* TagType.End */  && isSelfClosing) $4b1afda415637ecc$var$emitError(context, 4 /* ErrorCodes.END_TAG_WITH_TRAILING_SOLIDUS */ );
        $4b1afda415637ecc$var$advanceBy(context, isSelfClosing ? 2 : 1);
    }
    if (type === 1 /* TagType.End */ ) return;
    let tagType = 0 /* ElementTypes.ELEMENT */ ;
    if (!context.inVPre) {
        if (tag === 'slot') tagType = 2 /* ElementTypes.SLOT */ ;
        else if (tag === 'template') {
            if (props.some((p)=>p.type === 7 /* NodeTypes.DIRECTIVE */  && $4b1afda415637ecc$var$isSpecialTemplateDirective(p.name))) tagType = 3 /* ElementTypes.TEMPLATE */ ;
        } else if ($4b1afda415637ecc$var$isComponent(tag, props, context)) tagType = 1 /* ElementTypes.COMPONENT */ ;
    }
    return {
        type: 1 /* NodeTypes.ELEMENT */ ,
        ns: ns,
        tag: tag,
        tagType: tagType,
        props: props,
        isSelfClosing: isSelfClosing,
        children: [],
        loc: $4b1afda415637ecc$var$getSelection(context, start),
        codegenNode: undefined // to be created during transform phase
    };
}
function $4b1afda415637ecc$var$isComponent(tag, props, context) {
    const options = context.options;
    if (options.isCustomElement(tag)) return false;
    if (tag === 'component' || /^[A-Z]/.test(tag) || $4b1afda415637ecc$export$69768c9b514a01e9(tag) || options.isBuiltInComponent && options.isBuiltInComponent(tag) || options.isNativeTag && !options.isNativeTag(tag)) return true;
    // at this point the tag should be a native tag, but check for potential "is"
    // casting
    for(let i = 0; i < props.length; i++){
        const p = props[i];
        if (p.type === 6 /* NodeTypes.ATTRIBUTE */ ) {
            if (p.name === 'is' && p.value) {
                if (p.value.content.startsWith('vue:')) return true;
                else if ($4b1afda415637ecc$export$1b1c14b93fcc0fe4("COMPILER_IS_ON_ELEMENT" /* CompilerDeprecationTypes.COMPILER_IS_ON_ELEMENT */ , context, p.loc)) return true;
            }
        } else {
            // directive
            // v-is (TODO Deprecate)
            if (p.name === 'is') return true;
            else if (// :is on plain element - only treat as component in compat mode
            p.name === 'bind' && $4b1afda415637ecc$export$45cac5109adb5e55(p.arg, 'is') && true && $4b1afda415637ecc$export$1b1c14b93fcc0fe4("COMPILER_IS_ON_ELEMENT" /* CompilerDeprecationTypes.COMPILER_IS_ON_ELEMENT */ , context, p.loc)) return true;
        }
    }
}
function $4b1afda415637ecc$var$parseAttributes(context, type) {
    const props = [];
    const attributeNames = new Set();
    while(context.source.length > 0 && !$4b1afda415637ecc$var$startsWith(context.source, '>') && !$4b1afda415637ecc$var$startsWith(context.source, '/>')){
        if ($4b1afda415637ecc$var$startsWith(context.source, '/')) {
            $4b1afda415637ecc$var$emitError(context, 22 /* ErrorCodes.UNEXPECTED_SOLIDUS_IN_TAG */ );
            $4b1afda415637ecc$var$advanceBy(context, 1);
            $4b1afda415637ecc$var$advanceSpaces(context);
            continue;
        }
        if (type === 1 /* TagType.End */ ) $4b1afda415637ecc$var$emitError(context, 3 /* ErrorCodes.END_TAG_WITH_ATTRIBUTES */ );
        const attr = $4b1afda415637ecc$var$parseAttribute(context, attributeNames);
        // Trim whitespace between class
        // https://github.com/vuejs/core/issues/4251
        if (attr.type === 6 /* NodeTypes.ATTRIBUTE */  && attr.value && attr.name === 'class') attr.value.content = attr.value.content.replace(/\s+/g, ' ').trim();
        if (type === 0 /* TagType.Start */ ) props.push(attr);
        if (/^[^\t\r\n\f />]/.test(context.source)) $4b1afda415637ecc$var$emitError(context, 15 /* ErrorCodes.MISSING_WHITESPACE_BETWEEN_ATTRIBUTES */ );
        $4b1afda415637ecc$var$advanceSpaces(context);
    }
    return props;
}
function $4b1afda415637ecc$var$parseAttribute(context, nameSet) {
    // Name.
    const start = $4b1afda415637ecc$var$getCursor(context);
    const match = /^[^\t\r\n\f />][^\t\r\n\f />=]*/.exec(context.source);
    const name = match[0];
    if (nameSet.has(name)) $4b1afda415637ecc$var$emitError(context, 2 /* ErrorCodes.DUPLICATE_ATTRIBUTE */ );
    nameSet.add(name);
    if (name[0] === '=') $4b1afda415637ecc$var$emitError(context, 19 /* ErrorCodes.UNEXPECTED_EQUALS_SIGN_BEFORE_ATTRIBUTE_NAME */ );
    {
        const pattern = /["'<]/g;
        let m;
        while(m = pattern.exec(name))$4b1afda415637ecc$var$emitError(context, 17 /* ErrorCodes.UNEXPECTED_CHARACTER_IN_ATTRIBUTE_NAME */ , m.index);
    }
    $4b1afda415637ecc$var$advanceBy(context, name.length);
    // Value
    let value = undefined;
    if (/^[\t\r\n\f ]*=/.test(context.source)) {
        $4b1afda415637ecc$var$advanceSpaces(context);
        $4b1afda415637ecc$var$advanceBy(context, 1);
        $4b1afda415637ecc$var$advanceSpaces(context);
        value = $4b1afda415637ecc$var$parseAttributeValue(context);
        if (!value) $4b1afda415637ecc$var$emitError(context, 13 /* ErrorCodes.MISSING_ATTRIBUTE_VALUE */ );
    }
    const loc = $4b1afda415637ecc$var$getSelection(context, start);
    if (!context.inVPre && /^(v-[A-Za-z0-9-]|:|\.|@|#)/.test(name)) {
        const match = /(?:^v-([a-z0-9-]+))?(?:(?::|^\.|^@|^#)(\[[^\]]+\]|[^\.]+))?(.+)?$/i.exec(name);
        let isPropShorthand = $4b1afda415637ecc$var$startsWith(name, '.');
        let dirName = match[1] || (isPropShorthand || $4b1afda415637ecc$var$startsWith(name, ':') ? 'bind' : $4b1afda415637ecc$var$startsWith(name, '@') ? 'on' : 'slot');
        let arg;
        if (match[2]) {
            const isSlot = dirName === 'slot';
            const startOffset = name.lastIndexOf(match[2]);
            const loc = $4b1afda415637ecc$var$getSelection(context, $4b1afda415637ecc$var$getNewPosition(context, start, startOffset), $4b1afda415637ecc$var$getNewPosition(context, start, startOffset + match[2].length + (isSlot && match[3] || '').length));
            let content = match[2];
            let isStatic = true;
            if (content.startsWith('[')) {
                isStatic = false;
                if (!content.endsWith(']')) {
                    $4b1afda415637ecc$var$emitError(context, 27 /* ErrorCodes.X_MISSING_DYNAMIC_DIRECTIVE_ARGUMENT_END */ );
                    content = content.slice(1);
                } else content = content.slice(1, content.length - 1);
            } else if (isSlot) // #1241 special case for v-slot: vuetify relies extensively on slot
            // names containing dots. v-slot doesn't have any modifiers and Vue 2.x
            // supports such usage so we are keeping it consistent with 2.x.
            content += match[3] || '';
            arg = {
                type: 4 /* NodeTypes.SIMPLE_EXPRESSION */ ,
                content: content,
                isStatic: isStatic,
                constType: isStatic ? 3 /* ConstantTypes.CAN_STRINGIFY */  : 0 /* ConstantTypes.NOT_CONSTANT */ ,
                loc: loc
            };
        }
        if (value && value.isQuoted) {
            const valueLoc = value.loc;
            valueLoc.start.offset++;
            valueLoc.start.column++;
            valueLoc.end = $4b1afda415637ecc$export$1cdf554524c0924f(valueLoc.start, value.content);
            valueLoc.source = valueLoc.source.slice(1, -1);
        }
        const modifiers = match[3] ? match[3].slice(1).split('.') : [];
        if (isPropShorthand) modifiers.push('prop');
        // 2.x compat v-bind:foo.sync -> v-model:foo
        if (dirName === 'bind' && arg) {
            if (modifiers.includes('sync') && $4b1afda415637ecc$export$1b1c14b93fcc0fe4("COMPILER_V_BIND_SYNC" /* CompilerDeprecationTypes.COMPILER_V_BIND_SYNC */ , context, loc, arg.loc.source)) {
                dirName = 'model';
                modifiers.splice(modifiers.indexOf('sync'), 1);
            }
        }
        return {
            type: 7 /* NodeTypes.DIRECTIVE */ ,
            name: dirName,
            exp: value && {
                type: 4 /* NodeTypes.SIMPLE_EXPRESSION */ ,
                content: value.content,
                isStatic: false,
                // Treat as non-constant by default. This can be potentially set to
                // other values by `transformExpression` to make it eligible for hoisting.
                constType: 0 /* ConstantTypes.NOT_CONSTANT */ ,
                loc: value.loc
            },
            arg: arg,
            modifiers: modifiers,
            loc: loc
        };
    }
    // missing directive name or illegal directive name
    if (!context.inVPre && $4b1afda415637ecc$var$startsWith(name, 'v-')) $4b1afda415637ecc$var$emitError(context, 26 /* ErrorCodes.X_MISSING_DIRECTIVE_NAME */ );
    return {
        type: 6 /* NodeTypes.ATTRIBUTE */ ,
        name: name,
        value: value && {
            type: 2 /* NodeTypes.TEXT */ ,
            content: value.content,
            loc: value.loc
        },
        loc: loc
    };
}
function $4b1afda415637ecc$var$parseAttributeValue(context) {
    const start = $4b1afda415637ecc$var$getCursor(context);
    let content;
    const quote = context.source[0];
    const isQuoted = quote === `"` || quote === `'`;
    if (isQuoted) {
        // Quoted value.
        $4b1afda415637ecc$var$advanceBy(context, 1);
        const endIndex = context.source.indexOf(quote);
        if (endIndex === -1) content = $4b1afda415637ecc$var$parseTextData(context, context.source.length, 4 /* TextModes.ATTRIBUTE_VALUE */ );
        else {
            content = $4b1afda415637ecc$var$parseTextData(context, endIndex, 4 /* TextModes.ATTRIBUTE_VALUE */ );
            $4b1afda415637ecc$var$advanceBy(context, 1);
        }
    } else {
        // Unquoted
        const match = /^[^\t\r\n\f >]+/.exec(context.source);
        if (!match) return undefined;
        const unexpectedChars = /["'<=`]/g;
        let m;
        while(m = unexpectedChars.exec(match[0]))$4b1afda415637ecc$var$emitError(context, 18 /* ErrorCodes.UNEXPECTED_CHARACTER_IN_UNQUOTED_ATTRIBUTE_VALUE */ , m.index);
        content = $4b1afda415637ecc$var$parseTextData(context, match[0].length, 4 /* TextModes.ATTRIBUTE_VALUE */ );
    }
    return {
        content: content,
        isQuoted: isQuoted,
        loc: $4b1afda415637ecc$var$getSelection(context, start)
    };
}
function $4b1afda415637ecc$var$parseInterpolation(context, mode) {
    const [open, close] = context.options.delimiters;
    const closeIndex = context.source.indexOf(close, open.length);
    if (closeIndex === -1) {
        $4b1afda415637ecc$var$emitError(context, 25 /* ErrorCodes.X_MISSING_INTERPOLATION_END */ );
        return undefined;
    }
    const start = $4b1afda415637ecc$var$getCursor(context);
    $4b1afda415637ecc$var$advanceBy(context, open.length);
    const innerStart = $4b1afda415637ecc$var$getCursor(context);
    const innerEnd = $4b1afda415637ecc$var$getCursor(context);
    const rawContentLength = closeIndex - open.length;
    const rawContent = context.source.slice(0, rawContentLength);
    const preTrimContent = $4b1afda415637ecc$var$parseTextData(context, rawContentLength, mode);
    const content = preTrimContent.trim();
    const startOffset = preTrimContent.indexOf(content);
    if (startOffset > 0) $4b1afda415637ecc$export$c57ab60b0c6308ea(innerStart, rawContent, startOffset);
    const endOffset = rawContentLength - (preTrimContent.length - content.length - startOffset);
    $4b1afda415637ecc$export$c57ab60b0c6308ea(innerEnd, rawContent, endOffset);
    $4b1afda415637ecc$var$advanceBy(context, close.length);
    return {
        type: 5 /* NodeTypes.INTERPOLATION */ ,
        content: {
            type: 4 /* NodeTypes.SIMPLE_EXPRESSION */ ,
            isStatic: false,
            // Set `isConstant` to false by default and will decide in transformExpression
            constType: 0 /* ConstantTypes.NOT_CONSTANT */ ,
            content: content,
            loc: $4b1afda415637ecc$var$getSelection(context, innerStart, innerEnd)
        },
        loc: $4b1afda415637ecc$var$getSelection(context, start)
    };
}
function $4b1afda415637ecc$var$parseText(context, mode) {
    const endTokens = mode === 3 /* TextModes.CDATA */  ? [
        ']]>'
    ] : [
        '<',
        context.options.delimiters[0]
    ];
    let endIndex = context.source.length;
    for(let i = 0; i < endTokens.length; i++){
        const index = context.source.indexOf(endTokens[i], 1);
        if (index !== -1 && endIndex > index) endIndex = index;
    }
    const start = $4b1afda415637ecc$var$getCursor(context);
    const content = $4b1afda415637ecc$var$parseTextData(context, endIndex, mode);
    return {
        type: 2 /* NodeTypes.TEXT */ ,
        content: content,
        loc: $4b1afda415637ecc$var$getSelection(context, start)
    };
}
/**
 * Get text data with a given length from the current location.
 * This translates HTML entities in the text data.
 */ function $4b1afda415637ecc$var$parseTextData(context, length, mode) {
    const rawText = context.source.slice(0, length);
    $4b1afda415637ecc$var$advanceBy(context, length);
    if (mode === 2 /* TextModes.RAWTEXT */  || mode === 3 /* TextModes.CDATA */  || !rawText.includes('&')) return rawText;
    else // DATA or RCDATA containing "&"". Entity decoding required.
    return context.options.decodeEntities(rawText, mode === 4 /* TextModes.ATTRIBUTE_VALUE */ );
}
function $4b1afda415637ecc$var$getCursor(context) {
    const { column: column, line: line, offset: offset } = context;
    return {
        column: column,
        line: line,
        offset: offset
    };
}
function $4b1afda415637ecc$var$getSelection(context, start, end) {
    end = end || $4b1afda415637ecc$var$getCursor(context);
    return {
        start: start,
        end: end,
        source: context.originalSource.slice(start.offset, end.offset)
    };
}
function $4b1afda415637ecc$var$last(xs) {
    return xs[xs.length - 1];
}
function $4b1afda415637ecc$var$startsWith(source, searchString) {
    return source.startsWith(searchString);
}
function $4b1afda415637ecc$var$advanceBy(context, numberOfCharacters) {
    const { source: source } = context;
    $4b1afda415637ecc$export$c57ab60b0c6308ea(context, source, numberOfCharacters);
    context.source = source.slice(numberOfCharacters);
}
function $4b1afda415637ecc$var$advanceSpaces(context) {
    const match = /^[\t\r\n\f ]+/.exec(context.source);
    if (match) $4b1afda415637ecc$var$advanceBy(context, match[0].length);
}
function $4b1afda415637ecc$var$getNewPosition(context, start, numberOfCharacters) {
    return $4b1afda415637ecc$export$1cdf554524c0924f(start, context.originalSource.slice(start.offset, numberOfCharacters), numberOfCharacters);
}
function $4b1afda415637ecc$var$emitError(context, code, offset, loc = $4b1afda415637ecc$var$getCursor(context)) {
    if (offset) {
        loc.offset += offset;
        loc.column += offset;
    }
    context.options.onError($4b1afda415637ecc$export$57c5a5dc5aa19bdf(code, {
        start: loc,
        end: loc,
        source: ''
    }));
}
function $4b1afda415637ecc$var$isEnd(context, mode, ancestors) {
    const s = context.source;
    switch(mode){
        case 0 /* TextModes.DATA */ :
            if ($4b1afda415637ecc$var$startsWith(s, '</')) // TODO: probably bad performance
            for(let i = ancestors.length - 1; i >= 0; --i){
                if ($4b1afda415637ecc$var$startsWithEndTagOpen(s, ancestors[i].tag)) return true;
            }
            break;
        case 1 /* TextModes.RCDATA */ :
        case 2 /* TextModes.RAWTEXT */ :
            {
                const parent = $4b1afda415637ecc$var$last(ancestors);
                if (parent && $4b1afda415637ecc$var$startsWithEndTagOpen(s, parent.tag)) return true;
                break;
            }
        case 3 /* TextModes.CDATA */ :
            if ($4b1afda415637ecc$var$startsWith(s, ']]>')) return true;
            break;
    }
    return !s;
}
function $4b1afda415637ecc$var$startsWithEndTagOpen(source, tag) {
    return $4b1afda415637ecc$var$startsWith(source, '</') && source.slice(2, 2 + tag.length).toLowerCase() === tag.toLowerCase() && /[\t\r\n\f />]/.test(source[2 + tag.length] || '>');
}
function $4b1afda415637ecc$var$hoistStatic(root, context) {
    $4b1afda415637ecc$var$walk(root, context, // Root node is unfortunately non-hoistable due to potential parent
    // fallthrough attributes.
    $4b1afda415637ecc$var$isSingleElementRoot(root, root.children[0]));
}
function $4b1afda415637ecc$var$isSingleElementRoot(root, child) {
    const { children: children } = root;
    return children.length === 1 && child.type === 1 /* NodeTypes.ELEMENT */  && !$4b1afda415637ecc$export$45f38ad7fffc9b53(child);
}
function $4b1afda415637ecc$var$walk(node, context, doNotHoistNode = false) {
    const { children: children } = node;
    const originalCount = children.length;
    let hoistedCount = 0;
    for(let i = 0; i < children.length; i++){
        const child = children[i];
        // only plain elements & text calls are eligible for hoisting.
        if (child.type === 1 /* NodeTypes.ELEMENT */  && child.tagType === 0 /* ElementTypes.ELEMENT */ ) {
            const constantType = doNotHoistNode ? 0 /* ConstantTypes.NOT_CONSTANT */  : $4b1afda415637ecc$export$7967f5197c38d72a(child, context);
            if (constantType > 0 /* ConstantTypes.NOT_CONSTANT */ ) {
                if (constantType >= 2 /* ConstantTypes.CAN_HOIST */ ) {
                    child.codegenNode.patchFlag = -1 /* PatchFlags.HOISTED */  + ``;
                    child.codegenNode = context.hoist(child.codegenNode);
                    hoistedCount++;
                    continue;
                }
            } else {
                // node may contain dynamic children, but its props may be eligible for
                // hoisting.
                const codegenNode = child.codegenNode;
                if (codegenNode.type === 13 /* NodeTypes.VNODE_CALL */ ) {
                    const flag = $4b1afda415637ecc$var$getPatchFlag(codegenNode);
                    if ((!flag || flag === 512 /* PatchFlags.NEED_PATCH */  || flag === 1 /* PatchFlags.TEXT */ ) && $4b1afda415637ecc$var$getGeneratedPropsConstantType(child, context) >= 2 /* ConstantTypes.CAN_HOIST */ ) {
                        const props = $4b1afda415637ecc$var$getNodeProps(child);
                        if (props) codegenNode.props = context.hoist(props);
                    }
                    if (codegenNode.dynamicProps) codegenNode.dynamicProps = context.hoist(codegenNode.dynamicProps);
                }
            }
        } else if (child.type === 12 /* NodeTypes.TEXT_CALL */  && $4b1afda415637ecc$export$7967f5197c38d72a(child.content, context) >= 2 /* ConstantTypes.CAN_HOIST */ ) {
            child.codegenNode = context.hoist(child.codegenNode);
            hoistedCount++;
        }
        // walk further
        if (child.type === 1 /* NodeTypes.ELEMENT */ ) {
            const isComponent = child.tagType === 1 /* ElementTypes.COMPONENT */ ;
            if (isComponent) context.scopes.vSlot++;
            $4b1afda415637ecc$var$walk(child, context);
            if (isComponent) context.scopes.vSlot--;
        } else if (child.type === 11 /* NodeTypes.FOR */ ) // Do not hoist v-for single child because it has to be a block
        $4b1afda415637ecc$var$walk(child, context, child.children.length === 1);
        else if (child.type === 9 /* NodeTypes.IF */ ) for(let i = 0; i < child.branches.length; i++)// Do not hoist v-if single child because it has to be a block
        $4b1afda415637ecc$var$walk(child.branches[i], context, child.branches[i].children.length === 1);
    }
    if (hoistedCount && context.transformHoist) context.transformHoist(children, context, node);
    // all children were hoisted - the entire children array is hoistable.
    if (hoistedCount && hoistedCount === originalCount && node.type === 1 /* NodeTypes.ELEMENT */  && node.tagType === 0 /* ElementTypes.ELEMENT */  && node.codegenNode && node.codegenNode.type === 13 /* NodeTypes.VNODE_CALL */  && (0, $8POXm.isArray)(node.codegenNode.children)) node.codegenNode.children = context.hoist($4b1afda415637ecc$export$c887713da9895dbb(node.codegenNode.children));
}
function $4b1afda415637ecc$export$7967f5197c38d72a(node, context) {
    const { constantCache: constantCache } = context;
    switch(node.type){
        case 1 /* NodeTypes.ELEMENT */ :
            if (node.tagType !== 0 /* ElementTypes.ELEMENT */ ) return 0 /* ConstantTypes.NOT_CONSTANT */ ;
            const cached = constantCache.get(node);
            if (cached !== undefined) return cached;
            const codegenNode = node.codegenNode;
            if (codegenNode.type !== 13 /* NodeTypes.VNODE_CALL */ ) return 0 /* ConstantTypes.NOT_CONSTANT */ ;
            if (codegenNode.isBlock && node.tag !== 'svg' && node.tag !== 'foreignObject') return 0 /* ConstantTypes.NOT_CONSTANT */ ;
            const flag = $4b1afda415637ecc$var$getPatchFlag(codegenNode);
            if (!flag) {
                let returnType = 3 /* ConstantTypes.CAN_STRINGIFY */ ;
                // Element itself has no patch flag. However we still need to check:
                // 1. Even for a node with no patch flag, it is possible for it to contain
                // non-hoistable expressions that refers to scope variables, e.g. compiler
                // injected keys or cached event handlers. Therefore we need to always
                // check the codegenNode's props to be sure.
                const generatedPropsType = $4b1afda415637ecc$var$getGeneratedPropsConstantType(node, context);
                if (generatedPropsType === 0 /* ConstantTypes.NOT_CONSTANT */ ) {
                    constantCache.set(node, 0 /* ConstantTypes.NOT_CONSTANT */ );
                    return 0 /* ConstantTypes.NOT_CONSTANT */ ;
                }
                if (generatedPropsType < returnType) returnType = generatedPropsType;
                // 2. its children.
                for(let i = 0; i < node.children.length; i++){
                    const childType = $4b1afda415637ecc$export$7967f5197c38d72a(node.children[i], context);
                    if (childType === 0 /* ConstantTypes.NOT_CONSTANT */ ) {
                        constantCache.set(node, 0 /* ConstantTypes.NOT_CONSTANT */ );
                        return 0 /* ConstantTypes.NOT_CONSTANT */ ;
                    }
                    if (childType < returnType) returnType = childType;
                }
                // 3. if the type is not already CAN_SKIP_PATCH which is the lowest non-0
                // type, check if any of the props can cause the type to be lowered
                // we can skip can_patch because it's guaranteed by the absence of a
                // patchFlag.
                if (returnType > 1 /* ConstantTypes.CAN_SKIP_PATCH */ ) for(let i = 0; i < node.props.length; i++){
                    const p = node.props[i];
                    if (p.type === 7 /* NodeTypes.DIRECTIVE */  && p.name === 'bind' && p.exp) {
                        const expType = $4b1afda415637ecc$export$7967f5197c38d72a(p.exp, context);
                        if (expType === 0 /* ConstantTypes.NOT_CONSTANT */ ) {
                            constantCache.set(node, 0 /* ConstantTypes.NOT_CONSTANT */ );
                            return 0 /* ConstantTypes.NOT_CONSTANT */ ;
                        }
                        if (expType < returnType) returnType = expType;
                    }
                }
                // only svg/foreignObject could be block here, however if they are
                // static then they don't need to be blocks since there will be no
                // nested updates.
                if (codegenNode.isBlock) {
                    // except set custom directives.
                    for(let i = 0; i < node.props.length; i++){
                        const p = node.props[i];
                        if (p.type === 7 /* NodeTypes.DIRECTIVE */ ) {
                            constantCache.set(node, 0 /* ConstantTypes.NOT_CONSTANT */ );
                            return 0 /* ConstantTypes.NOT_CONSTANT */ ;
                        }
                    }
                    context.removeHelper($4b1afda415637ecc$export$59578e14f90a15eb);
                    context.removeHelper($4b1afda415637ecc$export$74fb204a6eba800d(context.inSSR, codegenNode.isComponent));
                    codegenNode.isBlock = false;
                    context.helper($4b1afda415637ecc$export$3b9fc44425f495a6(context.inSSR, codegenNode.isComponent));
                }
                constantCache.set(node, returnType);
                return returnType;
            } else {
                constantCache.set(node, 0 /* ConstantTypes.NOT_CONSTANT */ );
                return 0 /* ConstantTypes.NOT_CONSTANT */ ;
            }
        case 2 /* NodeTypes.TEXT */ :
        case 3 /* NodeTypes.COMMENT */ :
            return 3 /* ConstantTypes.CAN_STRINGIFY */ ;
        case 9 /* NodeTypes.IF */ :
        case 11 /* NodeTypes.FOR */ :
        case 10 /* NodeTypes.IF_BRANCH */ :
            return 0 /* ConstantTypes.NOT_CONSTANT */ ;
        case 5 /* NodeTypes.INTERPOLATION */ :
        case 12 /* NodeTypes.TEXT_CALL */ :
            return $4b1afda415637ecc$export$7967f5197c38d72a(node.content, context);
        case 4 /* NodeTypes.SIMPLE_EXPRESSION */ :
            return node.constType;
        case 8 /* NodeTypes.COMPOUND_EXPRESSION */ :
            let returnType = 3 /* ConstantTypes.CAN_STRINGIFY */ ;
            for(let i = 0; i < node.children.length; i++){
                const child = node.children[i];
                if ((0, $8POXm.isString)(child) || (0, $8POXm.isSymbol)(child)) continue;
                const childType = $4b1afda415637ecc$export$7967f5197c38d72a(child, context);
                if (childType === 0 /* ConstantTypes.NOT_CONSTANT */ ) return 0 /* ConstantTypes.NOT_CONSTANT */ ;
                else if (childType < returnType) returnType = childType;
            }
            return returnType;
        default:
            return 0 /* ConstantTypes.NOT_CONSTANT */ ;
    }
}
const $4b1afda415637ecc$var$allowHoistedHelperSet = new Set([
    $4b1afda415637ecc$export$6382e3ed89de4e2a,
    $4b1afda415637ecc$export$b9d3780a9ab822b4,
    $4b1afda415637ecc$export$78c34c869683dd86,
    $4b1afda415637ecc$export$7046bb8d3c918928
]);
function $4b1afda415637ecc$var$getConstantTypeOfHelperCall(value, context) {
    if (value.type === 14 /* NodeTypes.JS_CALL_EXPRESSION */  && !(0, $8POXm.isString)(value.callee) && $4b1afda415637ecc$var$allowHoistedHelperSet.has(value.callee)) {
        const arg = value.arguments[0];
        if (arg.type === 4 /* NodeTypes.SIMPLE_EXPRESSION */ ) return $4b1afda415637ecc$export$7967f5197c38d72a(arg, context);
        else if (arg.type === 14 /* NodeTypes.JS_CALL_EXPRESSION */ ) // in the case of nested helper call, e.g. `normalizeProps(guardReactiveProps(exp))`
        return $4b1afda415637ecc$var$getConstantTypeOfHelperCall(arg, context);
    }
    return 0 /* ConstantTypes.NOT_CONSTANT */ ;
}
function $4b1afda415637ecc$var$getGeneratedPropsConstantType(node, context) {
    let returnType = 3 /* ConstantTypes.CAN_STRINGIFY */ ;
    const props = $4b1afda415637ecc$var$getNodeProps(node);
    if (props && props.type === 15 /* NodeTypes.JS_OBJECT_EXPRESSION */ ) {
        const { properties: properties } = props;
        for(let i = 0; i < properties.length; i++){
            const { key: key, value: value } = properties[i];
            const keyType = $4b1afda415637ecc$export$7967f5197c38d72a(key, context);
            if (keyType === 0 /* ConstantTypes.NOT_CONSTANT */ ) return keyType;
            if (keyType < returnType) returnType = keyType;
            let valueType;
            if (value.type === 4 /* NodeTypes.SIMPLE_EXPRESSION */ ) valueType = $4b1afda415637ecc$export$7967f5197c38d72a(value, context);
            else if (value.type === 14 /* NodeTypes.JS_CALL_EXPRESSION */ ) // some helper calls can be hoisted,
            // such as the `normalizeProps` generated by the compiler for pre-normalize class,
            // in this case we need to respect the ConstantType of the helper's arguments
            valueType = $4b1afda415637ecc$var$getConstantTypeOfHelperCall(value, context);
            else valueType = 0 /* ConstantTypes.NOT_CONSTANT */ ;
            if (valueType === 0 /* ConstantTypes.NOT_CONSTANT */ ) return valueType;
            if (valueType < returnType) returnType = valueType;
        }
    }
    return returnType;
}
function $4b1afda415637ecc$var$getNodeProps(node) {
    const codegenNode = node.codegenNode;
    if (codegenNode.type === 13 /* NodeTypes.VNODE_CALL */ ) return codegenNode.props;
}
function $4b1afda415637ecc$var$getPatchFlag(node) {
    const flag = node.patchFlag;
    return flag ? parseInt(flag, 10) : undefined;
}
function $4b1afda415637ecc$export$7438cb739e972616(root, { filename: filename = '', prefixIdentifiers: prefixIdentifiers = false, hoistStatic: hoistStatic = false, cacheHandlers: cacheHandlers = false, nodeTransforms: nodeTransforms = [], directiveTransforms: directiveTransforms = {}, transformHoist: transformHoist = null, isBuiltInComponent: isBuiltInComponent = (0, $8POXm.NOOP), isCustomElement: isCustomElement = (0, $8POXm.NOOP), expressionPlugins: expressionPlugins = [], scopeId: scopeId = null, slotted: slotted = true, ssr: ssr = false, inSSR: inSSR = false, ssrCssVars: ssrCssVars = ``, bindingMetadata: bindingMetadata = (0, $8POXm.EMPTY_OBJ), inline: inline = false, isTS: isTS = false, onError: onError = $4b1afda415637ecc$var$defaultOnError, onWarn: onWarn = $4b1afda415637ecc$var$defaultOnWarn, compatConfig: compatConfig }) {
    const nameMatch = filename.replace(/\?.*$/, '').match(/([^/\\]+)\.\w+$/);
    const context = {
        // options
        selfName: nameMatch && (0, $8POXm.capitalize)((0, $8POXm.camelize)(nameMatch[1])),
        prefixIdentifiers: prefixIdentifiers,
        hoistStatic: hoistStatic,
        cacheHandlers: cacheHandlers,
        nodeTransforms: nodeTransforms,
        directiveTransforms: directiveTransforms,
        transformHoist: transformHoist,
        isBuiltInComponent: isBuiltInComponent,
        isCustomElement: isCustomElement,
        expressionPlugins: expressionPlugins,
        scopeId: scopeId,
        slotted: slotted,
        ssr: ssr,
        inSSR: inSSR,
        ssrCssVars: ssrCssVars,
        bindingMetadata: bindingMetadata,
        inline: inline,
        isTS: isTS,
        onError: onError,
        onWarn: onWarn,
        compatConfig: compatConfig,
        root: // state
        root,
        helpers: new Map(),
        components: new Set(),
        directives: new Set(),
        hoists: [],
        imports: [],
        constantCache: new Map(),
        temps: 0,
        cached: 0,
        identifiers: Object.create(null),
        scopes: {
            vFor: 0,
            vSlot: 0,
            vPre: 0,
            vOnce: 0
        },
        parent: null,
        currentNode: root,
        childIndex: 0,
        inVOnce: false,
        // methods
        helper (name) {
            const count = context.helpers.get(name) || 0;
            context.helpers.set(name, count + 1);
            return name;
        },
        removeHelper (name) {
            const count = context.helpers.get(name);
            if (count) {
                const currentCount = count - 1;
                if (!currentCount) context.helpers.delete(name);
                else context.helpers.set(name, currentCount);
            }
        },
        helperString (name) {
            return `_${$4b1afda415637ecc$export$7dc1fc5a07bc9b35[context.helper(name)]}`;
        },
        replaceNode (node) {
            context.parent.children[context.childIndex] = context.currentNode = node;
        },
        removeNode (node) {
            const list = context.parent.children;
            const removalIndex = node ? list.indexOf(node) : context.currentNode ? context.childIndex : -1;
            if (!node || node === context.currentNode) {
                // current node removed
                context.currentNode = null;
                context.onNodeRemoved();
            } else // sibling node removed
            if (context.childIndex > removalIndex) {
                context.childIndex--;
                context.onNodeRemoved();
            }
            context.parent.children.splice(removalIndex, 1);
        },
        onNodeRemoved: ()=>{},
        addIdentifiers (exp) {},
        removeIdentifiers (exp) {},
        hoist (exp) {
            if ((0, $8POXm.isString)(exp)) exp = $4b1afda415637ecc$export$ac2aa689b44cdd23(exp);
            context.hoists.push(exp);
            const identifier = $4b1afda415637ecc$export$ac2aa689b44cdd23(`_hoisted_${context.hoists.length}`, false, exp.loc, 2 /* ConstantTypes.CAN_HOIST */ );
            identifier.hoisted = exp;
            return identifier;
        },
        cache (exp, isVNode = false) {
            return $4b1afda415637ecc$export$4abd162ddf919697(context.cached++, exp, isVNode);
        }
    };
    context.filters = new Set();
    return context;
}
function $4b1afda415637ecc$export$51186ad6e864892a(root, options) {
    const context = $4b1afda415637ecc$export$7438cb739e972616(root, options);
    $4b1afda415637ecc$export$c9d429747c1011af(root, context);
    if (options.hoistStatic) $4b1afda415637ecc$var$hoistStatic(root, context);
    if (!options.ssr) $4b1afda415637ecc$var$createRootCodegen(root, context);
    // finalize meta information
    root.helpers = [
        ...context.helpers.keys()
    ];
    root.components = [
        ...context.components
    ];
    root.directives = [
        ...context.directives
    ];
    root.imports = context.imports;
    root.hoists = context.hoists;
    root.temps = context.temps;
    root.cached = context.cached;
    root.filters = [
        ...context.filters
    ];
}
function $4b1afda415637ecc$var$createRootCodegen(root, context) {
    const { helper: helper } = context;
    const { children: children } = root;
    if (children.length === 1) {
        const child = children[0];
        // if the single child is an element, turn it into a block.
        if ($4b1afda415637ecc$var$isSingleElementRoot(root, child) && child.codegenNode) {
            // single element root is never hoisted so codegenNode will never be
            // SimpleExpressionNode
            const codegenNode = child.codegenNode;
            if (codegenNode.type === 13 /* NodeTypes.VNODE_CALL */ ) $4b1afda415637ecc$export$8fa6719e405ab23c(codegenNode, context);
            root.codegenNode = codegenNode;
        } else // - single <slot/>, IfNode, ForNode: already blocks.
        // - single text node: always patched.
        // root codegen falls through via genNode()
        root.codegenNode = child;
    } else if (children.length > 1) {
        // root has multiple nodes - return a fragment block.
        let patchFlag = 64 /* PatchFlags.STABLE_FRAGMENT */ ;
        let patchFlagText = (0, $8POXm.PatchFlagNames)[64 /* PatchFlags.STABLE_FRAGMENT */ ];
        root.codegenNode = $4b1afda415637ecc$export$d1cb722ac2a8b632(context, helper($4b1afda415637ecc$export$4bebefc40c8513e8), undefined, root.children, patchFlag + ``, undefined, undefined, true, undefined, false);
    }
}
function $4b1afda415637ecc$var$traverseChildren(parent, context) {
    let i = 0;
    const nodeRemoved = ()=>{
        i--;
    };
    for(; i < parent.children.length; i++){
        const child = parent.children[i];
        if ((0, $8POXm.isString)(child)) continue;
        context.parent = parent;
        context.childIndex = i;
        context.onNodeRemoved = nodeRemoved;
        $4b1afda415637ecc$export$c9d429747c1011af(child, context);
    }
}
function $4b1afda415637ecc$export$c9d429747c1011af(node, context) {
    context.currentNode = node;
    // apply transform plugins
    const { nodeTransforms: nodeTransforms } = context;
    const exitFns = [];
    for(let i = 0; i < nodeTransforms.length; i++){
        const onExit = nodeTransforms[i](node, context);
        if (onExit) {
            if ((0, $8POXm.isArray)(onExit)) exitFns.push(...onExit);
            else exitFns.push(onExit);
        }
        if (!context.currentNode) // node was removed
        return;
        else // node may have been replaced
        node = context.currentNode;
    }
    switch(node.type){
        case 3 /* NodeTypes.COMMENT */ :
            if (!context.ssr) // inject import for the Comment symbol, which is needed for creating
            // comment nodes with `createVNode`
            context.helper($4b1afda415637ecc$export$b2aae42fb0a19db3);
            break;
        case 5 /* NodeTypes.INTERPOLATION */ :
            // no need to traverse, but we need to inject toString helper
            if (!context.ssr) context.helper($4b1afda415637ecc$export$68f5914cce0a5680);
            break;
        // for container types, further traverse downwards
        case 9 /* NodeTypes.IF */ :
            for(let i = 0; i < node.branches.length; i++)$4b1afda415637ecc$export$c9d429747c1011af(node.branches[i], context);
            break;
        case 10 /* NodeTypes.IF_BRANCH */ :
        case 11 /* NodeTypes.FOR */ :
        case 1 /* NodeTypes.ELEMENT */ :
        case 0 /* NodeTypes.ROOT */ :
            $4b1afda415637ecc$var$traverseChildren(node, context);
            break;
    }
    // exit transforms
    context.currentNode = node;
    let i = exitFns.length;
    while(i--)exitFns[i]();
}
function $4b1afda415637ecc$export$aee0887cf96094d7(name, fn) {
    const matches = (0, $8POXm.isString)(name) ? (n)=>n === name : (n)=>name.test(n);
    return (node, context)=>{
        if (node.type === 1 /* NodeTypes.ELEMENT */ ) {
            const { props: props } = node;
            // structural directive transforms are not concerned with slots
            // as they are handled separately in vSlot.ts
            if (node.tagType === 3 /* ElementTypes.TEMPLATE */  && props.some($4b1afda415637ecc$export$eaf8991bb8af8cbb)) return;
            const exitFns = [];
            for(let i = 0; i < props.length; i++){
                const prop = props[i];
                if (prop.type === 7 /* NodeTypes.DIRECTIVE */  && matches(prop.name)) {
                    // structural directives are removed to avoid infinite recursion
                    // also we remove them *before* applying so that it can further
                    // traverse itself in case it moves the node around
                    props.splice(i, 1);
                    i--;
                    const onExit = fn(node, prop, context);
                    if (onExit) exitFns.push(onExit);
                }
            }
            return exitFns;
        }
    };
}
const $4b1afda415637ecc$var$PURE_ANNOTATION = `/*#__PURE__*/`;
const $4b1afda415637ecc$var$aliasHelper = (s)=>`${$4b1afda415637ecc$export$7dc1fc5a07bc9b35[s]}: _${$4b1afda415637ecc$export$7dc1fc5a07bc9b35[s]}`;
function $4b1afda415637ecc$var$createCodegenContext(ast, { mode: mode = 'function', prefixIdentifiers: prefixIdentifiers = mode === 'module', sourceMap: sourceMap = false, filename: filename = `template.vue.html`, scopeId: scopeId = null, optimizeImports: optimizeImports = false, runtimeGlobalName: runtimeGlobalName = `Vue`, runtimeModuleName: runtimeModuleName = `vue`, ssrRuntimeModuleName: ssrRuntimeModuleName = 'vue/server-renderer', ssr: ssr = false, isTS: isTS = false, inSSR: inSSR = false }) {
    const context = {
        mode: mode,
        prefixIdentifiers: prefixIdentifiers,
        sourceMap: sourceMap,
        filename: filename,
        scopeId: scopeId,
        optimizeImports: optimizeImports,
        runtimeGlobalName: runtimeGlobalName,
        runtimeModuleName: runtimeModuleName,
        ssrRuntimeModuleName: ssrRuntimeModuleName,
        ssr: ssr,
        isTS: isTS,
        inSSR: inSSR,
        source: ast.loc.source,
        code: ``,
        column: 1,
        line: 1,
        offset: 0,
        indentLevel: 0,
        pure: false,
        map: undefined,
        helper (key) {
            return `_${$4b1afda415637ecc$export$7dc1fc5a07bc9b35[key]}`;
        },
        push (code, node) {
            context.code += code;
        },
        indent () {
            newline(++context.indentLevel);
        },
        deindent (withoutNewLine = false) {
            if (withoutNewLine) --context.indentLevel;
            else newline(--context.indentLevel);
        },
        newline () {
            newline(context.indentLevel);
        }
    };
    function newline(n) {
        context.push('\n' + `  `.repeat(n));
    }
    return context;
}
function $4b1afda415637ecc$export$80d376111cc09ad7(ast, options = {}) {
    const context = $4b1afda415637ecc$var$createCodegenContext(ast, options);
    if (options.onContextCreated) options.onContextCreated(context);
    const { mode: mode, push: push, prefixIdentifiers: prefixIdentifiers, indent: indent, deindent: deindent, newline: newline, scopeId: scopeId, ssr: ssr } = context;
    const hasHelpers = ast.helpers.length > 0;
    const useWithBlock = !prefixIdentifiers && mode !== 'module';
    // preambles
    // in setup() inline mode, the preamble is generated in a sub context
    // and returned separately.
    const preambleContext = context;
    $4b1afda415637ecc$var$genFunctionPreamble(ast, preambleContext);
    // enter render function
    const functionName = ssr ? `ssrRender` : `render`;
    const args = ssr ? [
        '_ctx',
        '_push',
        '_parent',
        '_attrs'
    ] : [
        '_ctx',
        '_cache'
    ];
    const signature = args.join(', ');
    push(`function ${functionName}(${signature}) {`);
    indent();
    if (useWithBlock) {
        push(`with (_ctx) {`);
        indent();
        // function mode const declarations should be inside with block
        // also they should be renamed to avoid collision with user properties
        if (hasHelpers) {
            push(`const { ${ast.helpers.map($4b1afda415637ecc$var$aliasHelper).join(', ')} } = _Vue`);
            push(`\n`);
            newline();
        }
    }
    // generate asset resolution statements
    if (ast.components.length) {
        $4b1afda415637ecc$var$genAssets(ast.components, 'component', context);
        if (ast.directives.length || ast.temps > 0) newline();
    }
    if (ast.directives.length) {
        $4b1afda415637ecc$var$genAssets(ast.directives, 'directive', context);
        if (ast.temps > 0) newline();
    }
    if (ast.filters && ast.filters.length) {
        newline();
        $4b1afda415637ecc$var$genAssets(ast.filters, 'filter', context);
        newline();
    }
    if (ast.temps > 0) {
        push(`let `);
        for(let i = 0; i < ast.temps; i++)push(`${i > 0 ? `, ` : ``}_temp${i}`);
    }
    if (ast.components.length || ast.directives.length || ast.temps) {
        push(`\n`);
        newline();
    }
    // generate the VNode tree expression
    if (!ssr) push(`return `);
    if (ast.codegenNode) $4b1afda415637ecc$var$genNode(ast.codegenNode, context);
    else push(`null`);
    if (useWithBlock) {
        deindent();
        push(`}`);
    }
    deindent();
    push(`}`);
    return {
        ast: ast,
        code: context.code,
        preamble: ``,
        // SourceMapGenerator does have toJSON() method but it's not in the types
        map: context.map ? context.map.toJSON() : undefined
    };
}
function $4b1afda415637ecc$var$genFunctionPreamble(ast, context) {
    const { ssr: ssr, prefixIdentifiers: prefixIdentifiers, push: push, newline: newline, runtimeModuleName: runtimeModuleName, runtimeGlobalName: runtimeGlobalName, ssrRuntimeModuleName: ssrRuntimeModuleName } = context;
    const VueBinding = runtimeGlobalName;
    // Generate const declaration for helpers
    // In prefix mode, we place the const declaration at top so it's done
    // only once; But if we not prefixing, we place the declaration inside the
    // with block so it doesn't incur the `in` check cost for every helper access.
    if (ast.helpers.length > 0) {
        // "with" mode.
        // save Vue in a separate variable to avoid collision
        push(`const _Vue = ${VueBinding}\n`);
        // in "with" mode, helpers are declared inside the with block to avoid
        // has check cost, but hoists are lifted out of the function - we need
        // to provide the helper here.
        if (ast.hoists.length) {
            const staticHelpers = [
                $4b1afda415637ecc$export$6db5bf2474139178,
                $4b1afda415637ecc$export$b22e7e78da20c982,
                $4b1afda415637ecc$export$b2aae42fb0a19db3,
                $4b1afda415637ecc$export$8890896270dfc293,
                $4b1afda415637ecc$export$1a493e4b98fdcf3
            ].filter((helper)=>ast.helpers.includes(helper)).map($4b1afda415637ecc$var$aliasHelper).join(', ');
            push(`const { ${staticHelpers} } = _Vue\n`);
        }
    }
    $4b1afda415637ecc$var$genHoists(ast.hoists, context);
    newline();
    push(`return `);
}
function $4b1afda415637ecc$var$genAssets(assets, type, { helper: helper, push: push, newline: newline, isTS: isTS }) {
    const resolver = helper(type === 'filter' ? $4b1afda415637ecc$export$2c190751e09c3969 : type === 'component' ? $4b1afda415637ecc$export$28c52e95383d270 : $4b1afda415637ecc$export$7f3ccc2ef793ecce);
    for(let i = 0; i < assets.length; i++){
        let id = assets[i];
        // potential component implicit self-reference inferred from SFC filename
        const maybeSelfReference = id.endsWith('__self');
        if (maybeSelfReference) id = id.slice(0, -6);
        push(`const ${$4b1afda415637ecc$export$80505c1072df544f(id, type)} = ${resolver}(${JSON.stringify(id)}${maybeSelfReference ? `, true` : ``})${isTS ? `!` : ``}`);
        if (i < assets.length - 1) newline();
    }
}
function $4b1afda415637ecc$var$genHoists(hoists, context) {
    if (!hoists.length) return;
    context.pure = true;
    const { push: push, newline: newline, helper: helper, scopeId: scopeId, mode: mode } = context;
    newline();
    for(let i = 0; i < hoists.length; i++){
        const exp = hoists[i];
        if (exp) {
            push(`const _hoisted_${i + 1} = ${``}`);
            $4b1afda415637ecc$var$genNode(exp, context);
            newline();
        }
    }
    context.pure = false;
}
function $4b1afda415637ecc$var$isText$1(n) {
    return (0, $8POXm.isString)(n) || n.type === 4 /* NodeTypes.SIMPLE_EXPRESSION */  || n.type === 2 /* NodeTypes.TEXT */  || n.type === 5 /* NodeTypes.INTERPOLATION */  || n.type === 8 /* NodeTypes.COMPOUND_EXPRESSION */ ;
}
function $4b1afda415637ecc$var$genNodeListAsArray(nodes, context) {
    const multilines = nodes.length > 3 || false;
    context.push(`[`);
    multilines && context.indent();
    $4b1afda415637ecc$var$genNodeList(nodes, context, multilines);
    multilines && context.deindent();
    context.push(`]`);
}
function $4b1afda415637ecc$var$genNodeList(nodes, context, multilines = false, comma = true) {
    const { push: push, newline: newline } = context;
    for(let i = 0; i < nodes.length; i++){
        const node = nodes[i];
        if ((0, $8POXm.isString)(node)) push(node);
        else if ((0, $8POXm.isArray)(node)) $4b1afda415637ecc$var$genNodeListAsArray(node, context);
        else $4b1afda415637ecc$var$genNode(node, context);
        if (i < nodes.length - 1) {
            if (multilines) {
                comma && push(',');
                newline();
            } else comma && push(', ');
        }
    }
}
function $4b1afda415637ecc$var$genNode(node, context) {
    if ((0, $8POXm.isString)(node)) {
        context.push(node);
        return;
    }
    if ((0, $8POXm.isSymbol)(node)) {
        context.push(context.helper(node));
        return;
    }
    switch(node.type){
        case 1 /* NodeTypes.ELEMENT */ :
        case 9 /* NodeTypes.IF */ :
        case 11 /* NodeTypes.FOR */ :
            $4b1afda415637ecc$var$genNode(node.codegenNode, context);
            break;
        case 2 /* NodeTypes.TEXT */ :
            $4b1afda415637ecc$var$genText(node, context);
            break;
        case 4 /* NodeTypes.SIMPLE_EXPRESSION */ :
            $4b1afda415637ecc$var$genExpression(node, context);
            break;
        case 5 /* NodeTypes.INTERPOLATION */ :
            $4b1afda415637ecc$var$genInterpolation(node, context);
            break;
        case 12 /* NodeTypes.TEXT_CALL */ :
            $4b1afda415637ecc$var$genNode(node.codegenNode, context);
            break;
        case 8 /* NodeTypes.COMPOUND_EXPRESSION */ :
            $4b1afda415637ecc$var$genCompoundExpression(node, context);
            break;
        case 3 /* NodeTypes.COMMENT */ :
            $4b1afda415637ecc$var$genComment(node, context);
            break;
        case 13 /* NodeTypes.VNODE_CALL */ :
            $4b1afda415637ecc$var$genVNodeCall(node, context);
            break;
        case 14 /* NodeTypes.JS_CALL_EXPRESSION */ :
            $4b1afda415637ecc$var$genCallExpression(node, context);
            break;
        case 15 /* NodeTypes.JS_OBJECT_EXPRESSION */ :
            $4b1afda415637ecc$var$genObjectExpression(node, context);
            break;
        case 17 /* NodeTypes.JS_ARRAY_EXPRESSION */ :
            $4b1afda415637ecc$var$genArrayExpression(node, context);
            break;
        case 18 /* NodeTypes.JS_FUNCTION_EXPRESSION */ :
            $4b1afda415637ecc$var$genFunctionExpression(node, context);
            break;
        case 19 /* NodeTypes.JS_CONDITIONAL_EXPRESSION */ :
            $4b1afda415637ecc$var$genConditionalExpression(node, context);
            break;
        case 20 /* NodeTypes.JS_CACHE_EXPRESSION */ :
            $4b1afda415637ecc$var$genCacheExpression(node, context);
            break;
        case 21 /* NodeTypes.JS_BLOCK_STATEMENT */ :
            $4b1afda415637ecc$var$genNodeList(node.body, context, true, false);
            break;
        // SSR only types
        case 22 /* NodeTypes.JS_TEMPLATE_LITERAL */ :
            break;
        case 23 /* NodeTypes.JS_IF_STATEMENT */ :
            break;
        case 24 /* NodeTypes.JS_ASSIGNMENT_EXPRESSION */ :
            break;
        case 25 /* NodeTypes.JS_SEQUENCE_EXPRESSION */ :
            break;
        case 26 /* NodeTypes.JS_RETURN_STATEMENT */ :
            break;
        /* istanbul ignore next */ case 10 /* NodeTypes.IF_BRANCH */ :
            break;
        default:
    }
}
function $4b1afda415637ecc$var$genText(node, context) {
    context.push(JSON.stringify(node.content), node);
}
function $4b1afda415637ecc$var$genExpression(node, context) {
    const { content: content, isStatic: isStatic } = node;
    context.push(isStatic ? JSON.stringify(content) : content, node);
}
function $4b1afda415637ecc$var$genInterpolation(node, context) {
    const { push: push, helper: helper, pure: pure } = context;
    if (pure) push($4b1afda415637ecc$var$PURE_ANNOTATION);
    push(`${helper($4b1afda415637ecc$export$68f5914cce0a5680)}(`);
    $4b1afda415637ecc$var$genNode(node.content, context);
    push(`)`);
}
function $4b1afda415637ecc$var$genCompoundExpression(node, context) {
    for(let i = 0; i < node.children.length; i++){
        const child = node.children[i];
        if ((0, $8POXm.isString)(child)) context.push(child);
        else $4b1afda415637ecc$var$genNode(child, context);
    }
}
function $4b1afda415637ecc$var$genExpressionAsPropertyKey(node, context) {
    const { push: push } = context;
    if (node.type === 8 /* NodeTypes.COMPOUND_EXPRESSION */ ) {
        push(`[`);
        $4b1afda415637ecc$var$genCompoundExpression(node, context);
        push(`]`);
    } else if (node.isStatic) {
        // only quote keys if necessary
        const text = $4b1afda415637ecc$export$3cb8486ad206c65(node.content) ? node.content : JSON.stringify(node.content);
        push(text, node);
    } else push(`[${node.content}]`, node);
}
function $4b1afda415637ecc$var$genComment(node, context) {
    const { push: push, helper: helper, pure: pure } = context;
    if (pure) push($4b1afda415637ecc$var$PURE_ANNOTATION);
    push(`${helper($4b1afda415637ecc$export$b2aae42fb0a19db3)}(${JSON.stringify(node.content)})`, node);
}
function $4b1afda415637ecc$var$genVNodeCall(node, context) {
    const { push: push, helper: helper, pure: pure } = context;
    const { tag: tag, props: props, children: children, patchFlag: patchFlag, dynamicProps: dynamicProps, directives: directives, isBlock: isBlock, disableTracking: disableTracking, isComponent: isComponent } = node;
    if (directives) push(helper($4b1afda415637ecc$export$a5e4c1729e50ed6d) + `(`);
    if (isBlock) push(`(${helper($4b1afda415637ecc$export$59578e14f90a15eb)}(${disableTracking ? `true` : ``}), `);
    if (pure) push($4b1afda415637ecc$var$PURE_ANNOTATION);
    const callHelper = isBlock ? $4b1afda415637ecc$export$74fb204a6eba800d(context.inSSR, isComponent) : $4b1afda415637ecc$export$3b9fc44425f495a6(context.inSSR, isComponent);
    push(helper(callHelper) + `(`, node);
    $4b1afda415637ecc$var$genNodeList($4b1afda415637ecc$var$genNullableArgs([
        tag,
        props,
        children,
        patchFlag,
        dynamicProps
    ]), context);
    push(`)`);
    if (isBlock) push(`)`);
    if (directives) {
        push(`, `);
        $4b1afda415637ecc$var$genNode(directives, context);
        push(`)`);
    }
}
function $4b1afda415637ecc$var$genNullableArgs(args) {
    let i = args.length;
    while(i--){
        if (args[i] != null) break;
    }
    return args.slice(0, i + 1).map((arg)=>arg || `null`);
}
// JavaScript
function $4b1afda415637ecc$var$genCallExpression(node, context) {
    const { push: push, helper: helper, pure: pure } = context;
    const callee = (0, $8POXm.isString)(node.callee) ? node.callee : helper(node.callee);
    if (pure) push($4b1afda415637ecc$var$PURE_ANNOTATION);
    push(callee + `(`, node);
    $4b1afda415637ecc$var$genNodeList(node.arguments, context);
    push(`)`);
}
function $4b1afda415637ecc$var$genObjectExpression(node, context) {
    const { push: push, indent: indent, deindent: deindent, newline: newline } = context;
    const { properties: properties } = node;
    if (!properties.length) {
        push(`{}`, node);
        return;
    }
    const multilines = properties.length > 1 || false;
    push(multilines ? `{` : `{ `);
    multilines && indent();
    for(let i = 0; i < properties.length; i++){
        const { key: key, value: value } = properties[i];
        // key
        $4b1afda415637ecc$var$genExpressionAsPropertyKey(key, context);
        push(`: `);
        // value
        $4b1afda415637ecc$var$genNode(value, context);
        if (i < properties.length - 1) {
            // will only reach this if it's multilines
            push(`,`);
            newline();
        }
    }
    multilines && deindent();
    push(multilines ? `}` : ` }`);
}
function $4b1afda415637ecc$var$genArrayExpression(node, context) {
    $4b1afda415637ecc$var$genNodeListAsArray(node.elements, context);
}
function $4b1afda415637ecc$var$genFunctionExpression(node, context) {
    const { push: push, indent: indent, deindent: deindent } = context;
    const { params: params, returns: returns, body: body, newline: newline, isSlot: isSlot } = node;
    if (isSlot) // wrap slot functions with owner context
    push(`_${$4b1afda415637ecc$export$7dc1fc5a07bc9b35[$4b1afda415637ecc$export$141e17a2b5200090]}(`);
    push(`(`, node);
    if ((0, $8POXm.isArray)(params)) $4b1afda415637ecc$var$genNodeList(params, context);
    else if (params) $4b1afda415637ecc$var$genNode(params, context);
    push(`) => `);
    if (newline || body) {
        push(`{`);
        indent();
    }
    if (returns) {
        if (newline) push(`return `);
        if ((0, $8POXm.isArray)(returns)) $4b1afda415637ecc$var$genNodeListAsArray(returns, context);
        else $4b1afda415637ecc$var$genNode(returns, context);
    } else if (body) $4b1afda415637ecc$var$genNode(body, context);
    if (newline || body) {
        deindent();
        push(`}`);
    }
    if (isSlot) {
        if (node.isNonScopedSlot) push(`, undefined, true`);
        push(`)`);
    }
}
function $4b1afda415637ecc$var$genConditionalExpression(node, context) {
    const { test: test, consequent: consequent, alternate: alternate, newline: needNewline } = node;
    const { push: push, indent: indent, deindent: deindent, newline: newline } = context;
    if (test.type === 4 /* NodeTypes.SIMPLE_EXPRESSION */ ) {
        const needsParens = !$4b1afda415637ecc$export$3cb8486ad206c65(test.content);
        needsParens && push(`(`);
        $4b1afda415637ecc$var$genExpression(test, context);
        needsParens && push(`)`);
    } else {
        push(`(`);
        $4b1afda415637ecc$var$genNode(test, context);
        push(`)`);
    }
    needNewline && indent();
    context.indentLevel++;
    needNewline || push(` `);
    push(`? `);
    $4b1afda415637ecc$var$genNode(consequent, context);
    context.indentLevel--;
    needNewline && newline();
    needNewline || push(` `);
    push(`: `);
    const isNested = alternate.type === 19 /* NodeTypes.JS_CONDITIONAL_EXPRESSION */ ;
    if (!isNested) context.indentLevel++;
    $4b1afda415637ecc$var$genNode(alternate, context);
    if (!isNested) context.indentLevel--;
    needNewline && deindent(true);
}
function $4b1afda415637ecc$var$genCacheExpression(node, context) {
    const { push: push, helper: helper, indent: indent, deindent: deindent, newline: newline } = context;
    push(`_cache[${node.index}] || (`);
    if (node.isVNode) {
        indent();
        push(`${helper($4b1afda415637ecc$export$37cf1f9ab937c10d)}(-1),`);
        newline();
    }
    push(`_cache[${node.index}] = `);
    $4b1afda415637ecc$var$genNode(node.value, context);
    if (node.isVNode) {
        push(`,`);
        newline();
        push(`${helper($4b1afda415637ecc$export$37cf1f9ab937c10d)}(1),`);
        newline();
        push(`_cache[${node.index}]`);
        deindent();
    }
    push(`)`);
}
function $4b1afda415637ecc$export$1f18e145724205f0(root, onIdentifier, includeAll = false, parentStack = [], knownIds = Object.create(null)) {
    return;
}
function $4b1afda415637ecc$export$a351a8c8c66104d7(id, parent, parentStack) {
    return false;
}
function $4b1afda415637ecc$export$b1c677096ee1f9ce(parent, parentStack) {
    if (parent && (parent.type === 'ObjectProperty' || parent.type === 'ArrayPattern')) {
        let i = parentStack.length;
        while(i--){
            const p = parentStack[i];
            if (p.type === 'AssignmentExpression') return true;
            else if (p.type !== 'ObjectProperty' && !p.type.endsWith('Pattern')) break;
        }
    }
    return false;
}
function $4b1afda415637ecc$export$d41514e9f2f5bb4d(node, onIdent) {
    for (const p of node.params)for (const id of $4b1afda415637ecc$export$31e5048ec55fc20d(p))onIdent(id);
}
function $4b1afda415637ecc$export$3e47780ecfa08385(block, onIdent) {
    for (const stmt of block.body){
        if (stmt.type === 'VariableDeclaration') {
            if (stmt.declare) continue;
            for (const decl of stmt.declarations)for (const id of $4b1afda415637ecc$export$31e5048ec55fc20d(decl.id))onIdent(id);
        } else if (stmt.type === 'FunctionDeclaration' || stmt.type === 'ClassDeclaration') {
            if (stmt.declare || !stmt.id) continue;
            onIdent(stmt.id);
        }
    }
}
function $4b1afda415637ecc$export$31e5048ec55fc20d(param, nodes = []) {
    switch(param.type){
        case 'Identifier':
            nodes.push(param);
            break;
        case 'MemberExpression':
            let object = param;
            while(object.type === 'MemberExpression')object = object.object;
            nodes.push(object);
            break;
        case 'ObjectPattern':
            for (const prop of param.properties)if (prop.type === 'RestElement') $4b1afda415637ecc$export$31e5048ec55fc20d(prop.argument, nodes);
            else $4b1afda415637ecc$export$31e5048ec55fc20d(prop.value, nodes);
            break;
        case 'ArrayPattern':
            param.elements.forEach((element)=>{
                if (element) $4b1afda415637ecc$export$31e5048ec55fc20d(element, nodes);
            });
            break;
        case 'RestElement':
            $4b1afda415637ecc$export$31e5048ec55fc20d(param.argument, nodes);
            break;
        case 'AssignmentPattern':
            $4b1afda415637ecc$export$31e5048ec55fc20d(param.left, nodes);
            break;
    }
    return nodes;
}
const $4b1afda415637ecc$export$8af909612acebc9b = (node)=>{
    return /Function(?:Expression|Declaration)$|Method$/.test(node.type);
};
const $4b1afda415637ecc$export$f6ddf7e7b08e8e00 = (node)=>node && (node.type === 'ObjectProperty' || node.type === 'ObjectMethod') && !node.computed;
const $4b1afda415637ecc$export$644dbfd5b3d2f87f = (node, parent)=>$4b1afda415637ecc$export$f6ddf7e7b08e8e00(parent) && parent.key === node;
// these keywords should not appear inside expressions, but operators like
// typeof, instanceof and in are allowed
const $4b1afda415637ecc$var$prohibitedKeywordRE = new RegExp('\\b' + "do,if,for,let,new,try,var,case,else,with,await,break,catch,class,const,super,throw,while,yield,delete,export,import,return,switch,default,extends,finally,continue,debugger,function,arguments,typeof,void".split(',').join('\\b|\\b') + '\\b');
// strip strings in expressions
const $4b1afda415637ecc$var$stripStringRE = /'(?:[^'\\]|\\.)*'|"(?:[^"\\]|\\.)*"|`(?:[^`\\]|\\.)*\$\{|\}(?:[^`\\]|\\.)*`|`(?:[^`\\]|\\.)*`/g;
/**
 * Validate a non-prefixed expression.
 * This is only called when using the in-browser runtime compiler since it
 * doesn't prefix expressions.
 */ function $4b1afda415637ecc$var$validateBrowserExpression(node, context, asParams = false, asRawStatements = false) {
    const exp = node.content;
    // empty expressions are validated per-directive since some directives
    // do allow empty expressions.
    if (!exp.trim()) return;
    try {
        new Function(asRawStatements ? ` ${exp} ` : `return ${asParams ? `(${exp}) => {}` : `(${exp})`}`);
    } catch (e) {
        let message = e.message;
        const keywordMatch = exp.replace($4b1afda415637ecc$var$stripStringRE, '').match($4b1afda415637ecc$var$prohibitedKeywordRE);
        if (keywordMatch) message = `avoid using JavaScript keyword as property name: "${keywordMatch[0]}"`;
        context.onError($4b1afda415637ecc$export$57c5a5dc5aa19bdf(44 /* ErrorCodes.X_INVALID_EXPRESSION */ , node.loc, undefined, message));
    }
}
const $4b1afda415637ecc$export$7e9f01d2df839553 = (node, context)=>{
    if (node.type === 5 /* NodeTypes.INTERPOLATION */ ) node.content = $4b1afda415637ecc$export$997045dce990ec35(node.content, context);
    else if (node.type === 1 /* NodeTypes.ELEMENT */ ) // handle directives on element
    for(let i = 0; i < node.props.length; i++){
        const dir = node.props[i];
        // do not process for v-on & v-for since they are special handled
        if (dir.type === 7 /* NodeTypes.DIRECTIVE */  && dir.name !== 'for') {
            const exp = dir.exp;
            const arg = dir.arg;
            // do not process exp if this is v-on:arg - we need special handling
            // for wrapping inline statements.
            if (exp && exp.type === 4 /* NodeTypes.SIMPLE_EXPRESSION */  && !(dir.name === 'on' && arg)) dir.exp = $4b1afda415637ecc$export$997045dce990ec35(exp, context, // slot args must be processed as function params
            dir.name === 'slot');
            if (arg && arg.type === 4 /* NodeTypes.SIMPLE_EXPRESSION */  && !arg.isStatic) dir.arg = $4b1afda415637ecc$export$997045dce990ec35(arg, context);
        }
    }
};
// Important: since this function uses Node.js only dependencies, it should
// always be used with a leading !true check so that it can be
// tree-shaken from the browser build.
function $4b1afda415637ecc$export$997045dce990ec35(node, context, // some expressions like v-slot props & v-for aliases should be parsed as
// function params
asParams = false, // v-on handler values may contain multiple statements
asRawStatements = false, localVars = Object.create(context.identifiers)) {
    return node;
}
const $4b1afda415637ecc$var$transformIf = $4b1afda415637ecc$export$aee0887cf96094d7(/^(if|else|else-if)$/, (node, dir, context)=>{
    return $4b1afda415637ecc$export$a01e2bc7b2f1a6e5(node, dir, context, (ifNode, branch, isRoot)=>{
        // #1587: We need to dynamically increment the key based on the current
        // node's sibling nodes, since chained v-if/else branches are
        // rendered at the same depth
        const siblings = context.parent.children;
        let i = siblings.indexOf(ifNode);
        let key = 0;
        while(i-- >= 0){
            const sibling = siblings[i];
            if (sibling && sibling.type === 9 /* NodeTypes.IF */ ) key += sibling.branches.length;
        }
        // Exit callback. Complete the codegenNode when all children have been
        // transformed.
        return ()=>{
            if (isRoot) ifNode.codegenNode = $4b1afda415637ecc$var$createCodegenNodeForBranch(branch, key, context);
            else {
                // attach this branch's codegen node to the v-if root.
                const parentCondition = $4b1afda415637ecc$var$getParentCondition(ifNode.codegenNode);
                parentCondition.alternate = $4b1afda415637ecc$var$createCodegenNodeForBranch(branch, key + ifNode.branches.length - 1, context);
            }
        };
    });
});
// target-agnostic transform used for both Client and SSR
function $4b1afda415637ecc$export$a01e2bc7b2f1a6e5(node, dir, context, processCodegen) {
    if (dir.name !== 'else' && (!dir.exp || !dir.exp.content.trim())) {
        const loc = dir.exp ? dir.exp.loc : node.loc;
        context.onError($4b1afda415637ecc$export$57c5a5dc5aa19bdf(28 /* ErrorCodes.X_V_IF_NO_EXPRESSION */ , dir.loc));
        dir.exp = $4b1afda415637ecc$export$ac2aa689b44cdd23(`true`, false, loc);
    }
    if (dir.name === 'if') {
        const branch = $4b1afda415637ecc$var$createIfBranch(node, dir);
        const ifNode = {
            type: 9 /* NodeTypes.IF */ ,
            loc: node.loc,
            branches: [
                branch
            ]
        };
        context.replaceNode(ifNode);
        if (processCodegen) return processCodegen(ifNode, branch, true);
    } else {
        // locate the adjacent v-if
        const siblings = context.parent.children;
        const comments = [];
        let i = siblings.indexOf(node);
        while(i-- >= -1){
            const sibling = siblings[i];
            if (sibling && sibling.type === 2 /* NodeTypes.TEXT */  && !sibling.content.trim().length) {
                context.removeNode(sibling);
                continue;
            }
            if (sibling && sibling.type === 9 /* NodeTypes.IF */ ) {
                // Check if v-else was followed by v-else-if
                if (dir.name === 'else-if' && sibling.branches[sibling.branches.length - 1].condition === undefined) context.onError($4b1afda415637ecc$export$57c5a5dc5aa19bdf(30 /* ErrorCodes.X_V_ELSE_NO_ADJACENT_IF */ , node.loc));
                // move the node to the if node's branches
                context.removeNode();
                const branch = $4b1afda415637ecc$var$createIfBranch(node, dir);
                var userKey;
                sibling.branches.push(branch);
                const onExit = processCodegen && processCodegen(sibling, branch, false);
                // since the branch was removed, it will not be traversed.
                // make sure to traverse here.
                $4b1afda415637ecc$export$c9d429747c1011af(branch, context);
                // call on exit
                if (onExit) onExit();
                // make sure to reset currentNode after traversal to indicate this
                // node has been removed.
                context.currentNode = null;
            } else context.onError($4b1afda415637ecc$export$57c5a5dc5aa19bdf(30 /* ErrorCodes.X_V_ELSE_NO_ADJACENT_IF */ , node.loc));
            break;
        }
    }
}
function $4b1afda415637ecc$var$createIfBranch(node, dir) {
    const isTemplateIf = node.tagType === 3 /* ElementTypes.TEMPLATE */ ;
    return {
        type: 10 /* NodeTypes.IF_BRANCH */ ,
        loc: node.loc,
        condition: dir.name === 'else' ? undefined : dir.exp,
        children: isTemplateIf && !$4b1afda415637ecc$export$1199bc2a2b648c8c(node, 'for') ? node.children : [
            node
        ],
        userKey: $4b1afda415637ecc$export$4ae65475e3513615(node, `key`),
        isTemplateIf: isTemplateIf
    };
}
function $4b1afda415637ecc$var$createCodegenNodeForBranch(branch, keyIndex, context) {
    if (branch.condition) return $4b1afda415637ecc$export$374e02fb5bd90a4e(branch.condition, $4b1afda415637ecc$var$createChildrenCodegenNode(branch, keyIndex, context), // make sure to pass in asBlock: true so that the comment node call
    // closes the current block.
    $4b1afda415637ecc$export$2cdf8617f9d8e39d(context.helper($4b1afda415637ecc$export$b2aae42fb0a19db3), [
        '""',
        'true'
    ]));
    else return $4b1afda415637ecc$var$createChildrenCodegenNode(branch, keyIndex, context);
}
function $4b1afda415637ecc$var$createChildrenCodegenNode(branch, keyIndex, context) {
    const { helper: helper } = context;
    const keyProperty = $4b1afda415637ecc$export$45231d90c148ea74(`key`, $4b1afda415637ecc$export$ac2aa689b44cdd23(`${keyIndex}`, false, $4b1afda415637ecc$export$6c4f24c93c3e8659, 2 /* ConstantTypes.CAN_HOIST */ ));
    const { children: children } = branch;
    const firstChild = children[0];
    const needFragmentWrapper = children.length !== 1 || firstChild.type !== 1 /* NodeTypes.ELEMENT */ ;
    if (needFragmentWrapper) {
        if (children.length === 1 && firstChild.type === 11 /* NodeTypes.FOR */ ) {
            // optimize away nested fragments when child is a ForNode
            const vnodeCall = firstChild.codegenNode;
            $4b1afda415637ecc$export$ec34add3fb2185f8(vnodeCall, keyProperty, context);
            return vnodeCall;
        } else {
            let patchFlag = 64 /* PatchFlags.STABLE_FRAGMENT */ ;
            let patchFlagText = (0, $8POXm.PatchFlagNames)[64 /* PatchFlags.STABLE_FRAGMENT */ ];
            return $4b1afda415637ecc$export$d1cb722ac2a8b632(context, helper($4b1afda415637ecc$export$4bebefc40c8513e8), $4b1afda415637ecc$export$ccb2e514379853a7([
                keyProperty
            ]), children, patchFlag + ``, undefined, undefined, true, false, false, branch.loc);
        }
    } else {
        const ret = firstChild.codegenNode;
        const vnodeCall = $4b1afda415637ecc$export$39e241985cd3e673(ret);
        // Change createVNode to createBlock.
        if (vnodeCall.type === 13 /* NodeTypes.VNODE_CALL */ ) $4b1afda415637ecc$export$8fa6719e405ab23c(vnodeCall, context);
        // inject branch key
        $4b1afda415637ecc$export$ec34add3fb2185f8(vnodeCall, keyProperty, context);
        return ret;
    }
}
function $4b1afda415637ecc$var$isSameKey(a, b) {
    if (!a || a.type !== b.type) return false;
    if (a.type === 6 /* NodeTypes.ATTRIBUTE */ ) {
        if (a.value.content !== b.value.content) return false;
    } else {
        // directive
        const exp = a.exp;
        const branchExp = b.exp;
        if (exp.type !== branchExp.type) return false;
        if (exp.type !== 4 /* NodeTypes.SIMPLE_EXPRESSION */  || exp.isStatic !== branchExp.isStatic || exp.content !== branchExp.content) return false;
    }
    return true;
}
function $4b1afda415637ecc$var$getParentCondition(node) {
    while(true){
        if (node.type === 19 /* NodeTypes.JS_CONDITIONAL_EXPRESSION */ ) {
            if (node.alternate.type === 19 /* NodeTypes.JS_CONDITIONAL_EXPRESSION */ ) node = node.alternate;
            else return node;
        } else if (node.type === 20 /* NodeTypes.JS_CACHE_EXPRESSION */ ) node = node.value;
    }
}
const $4b1afda415637ecc$var$transformFor = $4b1afda415637ecc$export$aee0887cf96094d7('for', (node, dir, context)=>{
    const { helper: helper, removeHelper: removeHelper } = context;
    return $4b1afda415637ecc$export$bb06c920f370c8cb(node, dir, context, (forNode)=>{
        // create the loop render function expression now, and add the
        // iterator on exit after all children have been traversed
        const renderExp = $4b1afda415637ecc$export$2cdf8617f9d8e39d(helper($4b1afda415637ecc$export$3da0e5cd78c1870), [
            forNode.source
        ]);
        const isTemplate = $4b1afda415637ecc$export$f125a8a2b402ed89(node);
        const memo = $4b1afda415637ecc$export$1199bc2a2b648c8c(node, 'memo');
        const keyProp = $4b1afda415637ecc$export$4ae65475e3513615(node, `key`);
        const keyExp = keyProp && (keyProp.type === 6 /* NodeTypes.ATTRIBUTE */  ? $4b1afda415637ecc$export$ac2aa689b44cdd23(keyProp.value.content, true) : keyProp.exp);
        const keyProperty = keyProp ? $4b1afda415637ecc$export$45231d90c148ea74(`key`, keyExp) : null;
        const isStableFragment = forNode.source.type === 4 /* NodeTypes.SIMPLE_EXPRESSION */  && forNode.source.constType > 0 /* ConstantTypes.NOT_CONSTANT */ ;
        const fragmentFlag = isStableFragment ? 64 /* PatchFlags.STABLE_FRAGMENT */  : keyProp ? 128 /* PatchFlags.KEYED_FRAGMENT */  : 256 /* PatchFlags.UNKEYED_FRAGMENT */ ;
        forNode.codegenNode = $4b1afda415637ecc$export$d1cb722ac2a8b632(context, helper($4b1afda415637ecc$export$4bebefc40c8513e8), undefined, renderExp, fragmentFlag + ``, undefined, undefined, true, !isStableFragment /* disableTracking */ , false, node.loc);
        return ()=>{
            // finish the codegen now that all children have been traversed
            let childBlock;
            const { children: children } = forNode;
            var c;
            const needFragmentWrapper = children.length !== 1 || children[0].type !== 1 /* NodeTypes.ELEMENT */ ;
            const slotOutlet = $4b1afda415637ecc$export$45f38ad7fffc9b53(node) ? node : isTemplate && node.children.length === 1 && $4b1afda415637ecc$export$45f38ad7fffc9b53(node.children[0]) ? node.children[0] // api-extractor somehow fails to infer this
             : null;
            if (slotOutlet) {
                // <slot v-for="..."> or <template v-for="..."><slot/></template>
                childBlock = slotOutlet.codegenNode;
                if (isTemplate && keyProperty) // <template v-for="..." :key="..."><slot/></template>
                // we need to inject the key to the renderSlot() call.
                // the props for renderSlot is passed as the 3rd argument.
                $4b1afda415637ecc$export$ec34add3fb2185f8(childBlock, keyProperty, context);
            } else if (needFragmentWrapper) // <template v-for="..."> with text or multi-elements
            // should generate a fragment block for each loop
            childBlock = $4b1afda415637ecc$export$d1cb722ac2a8b632(context, helper($4b1afda415637ecc$export$4bebefc40c8513e8), keyProperty ? $4b1afda415637ecc$export$ccb2e514379853a7([
                keyProperty
            ]) : undefined, node.children, 64 /* PatchFlags.STABLE_FRAGMENT */  + ``, undefined, undefined, true, undefined, false);
            else {
                // Normal element v-for. Directly use the child's codegenNode
                // but mark it as a block.
                childBlock = children[0].codegenNode;
                if (isTemplate && keyProperty) $4b1afda415637ecc$export$ec34add3fb2185f8(childBlock, keyProperty, context);
                if (childBlock.isBlock !== !isStableFragment) {
                    if (childBlock.isBlock) {
                        // switch from block to vnode
                        removeHelper($4b1afda415637ecc$export$59578e14f90a15eb);
                        removeHelper($4b1afda415637ecc$export$74fb204a6eba800d(context.inSSR, childBlock.isComponent));
                    } else // switch from vnode to block
                    removeHelper($4b1afda415637ecc$export$3b9fc44425f495a6(context.inSSR, childBlock.isComponent));
                }
                childBlock.isBlock = !isStableFragment;
                if (childBlock.isBlock) {
                    helper($4b1afda415637ecc$export$59578e14f90a15eb);
                    helper($4b1afda415637ecc$export$74fb204a6eba800d(context.inSSR, childBlock.isComponent));
                } else helper($4b1afda415637ecc$export$3b9fc44425f495a6(context.inSSR, childBlock.isComponent));
            }
            if (memo) {
                const loop = $4b1afda415637ecc$export$253e05bfd5b6c4c6($4b1afda415637ecc$export$5796ae82f3e98f88(forNode.parseResult, [
                    $4b1afda415637ecc$export$ac2aa689b44cdd23(`_cached`)
                ]));
                loop.body = $4b1afda415637ecc$export$c3ad9e28586f1d07([
                    $4b1afda415637ecc$export$60ad01cd5cde5e50([
                        `const _memo = (`,
                        memo.exp,
                        `)`
                    ]),
                    $4b1afda415637ecc$export$60ad01cd5cde5e50([
                        `if (_cached`,
                        ...keyExp ? [
                            ` && _cached.key === `,
                            keyExp
                        ] : [],
                        ` && ${context.helperString($4b1afda415637ecc$export$ae18cf0dc81df35a)}(_cached, _memo)) return _cached`
                    ]),
                    $4b1afda415637ecc$export$60ad01cd5cde5e50([
                        `const _item = `,
                        childBlock
                    ]),
                    $4b1afda415637ecc$export$ac2aa689b44cdd23(`_item.memo = _memo`),
                    $4b1afda415637ecc$export$ac2aa689b44cdd23(`return _item`)
                ]);
                renderExp.arguments.push(loop, $4b1afda415637ecc$export$ac2aa689b44cdd23(`_cache`), $4b1afda415637ecc$export$ac2aa689b44cdd23(String(context.cached++)));
            } else renderExp.arguments.push($4b1afda415637ecc$export$253e05bfd5b6c4c6($4b1afda415637ecc$export$5796ae82f3e98f88(forNode.parseResult), childBlock, true));
        };
    });
});
// target-agnostic transform used for both Client and SSR
function $4b1afda415637ecc$export$bb06c920f370c8cb(node, dir, context, processCodegen) {
    if (!dir.exp) {
        context.onError($4b1afda415637ecc$export$57c5a5dc5aa19bdf(31 /* ErrorCodes.X_V_FOR_NO_EXPRESSION */ , dir.loc));
        return;
    }
    const parseResult = $4b1afda415637ecc$var$parseForExpression(// can only be simple expression because vFor transform is applied
    // before expression transform.
    dir.exp, context);
    if (!parseResult) {
        context.onError($4b1afda415637ecc$export$57c5a5dc5aa19bdf(32 /* ErrorCodes.X_V_FOR_MALFORMED_EXPRESSION */ , dir.loc));
        return;
    }
    const { addIdentifiers: addIdentifiers, removeIdentifiers: removeIdentifiers, scopes: scopes } = context;
    const { source: source, value: value, key: key, index: index } = parseResult;
    const forNode = {
        type: 11 /* NodeTypes.FOR */ ,
        loc: dir.loc,
        source: source,
        valueAlias: value,
        keyAlias: key,
        objectIndexAlias: index,
        parseResult: parseResult,
        children: $4b1afda415637ecc$export$f125a8a2b402ed89(node) ? node.children : [
            node
        ]
    };
    context.replaceNode(forNode);
    // bookkeeping
    scopes.vFor++;
    const onExit = processCodegen && processCodegen(forNode);
    return ()=>{
        scopes.vFor--;
        if (onExit) onExit();
    };
}
const $4b1afda415637ecc$var$forAliasRE = /([\s\S]*?)\s+(?:in|of)\s+([\s\S]*)/;
// This regex doesn't cover the case if key or index aliases have destructuring,
// but those do not make sense in the first place, so this works in practice.
const $4b1afda415637ecc$var$forIteratorRE = /,([^,\}\]]*)(?:,([^,\}\]]*))?$/;
const $4b1afda415637ecc$var$stripParensRE = /^\(|\)$/g;
function $4b1afda415637ecc$var$parseForExpression(input, context) {
    const loc = input.loc;
    const exp = input.content;
    const inMatch = exp.match($4b1afda415637ecc$var$forAliasRE);
    if (!inMatch) return;
    const [, LHS, RHS] = inMatch;
    const result = {
        source: $4b1afda415637ecc$var$createAliasExpression(loc, RHS.trim(), exp.indexOf(RHS, LHS.length)),
        value: undefined,
        key: undefined,
        index: undefined
    };
    let valueContent = LHS.trim().replace($4b1afda415637ecc$var$stripParensRE, '').trim();
    const trimmedOffset = LHS.indexOf(valueContent);
    const iteratorMatch = valueContent.match($4b1afda415637ecc$var$forIteratorRE);
    if (iteratorMatch) {
        valueContent = valueContent.replace($4b1afda415637ecc$var$forIteratorRE, '').trim();
        const keyContent = iteratorMatch[1].trim();
        let keyOffset;
        if (keyContent) {
            keyOffset = exp.indexOf(keyContent, trimmedOffset + valueContent.length);
            result.key = $4b1afda415637ecc$var$createAliasExpression(loc, keyContent, keyOffset);
        }
        if (iteratorMatch[2]) {
            const indexContent = iteratorMatch[2].trim();
            if (indexContent) result.index = $4b1afda415637ecc$var$createAliasExpression(loc, indexContent, exp.indexOf(indexContent, result.key ? keyOffset + keyContent.length : trimmedOffset + valueContent.length));
        }
    }
    if (valueContent) result.value = $4b1afda415637ecc$var$createAliasExpression(loc, valueContent, trimmedOffset);
    return result;
}
function $4b1afda415637ecc$var$createAliasExpression(range, content, offset) {
    return $4b1afda415637ecc$export$ac2aa689b44cdd23(content, false, $4b1afda415637ecc$export$1b56c942e608880a(range, offset, content.length));
}
function $4b1afda415637ecc$export$5796ae82f3e98f88({ value: value, key: key, index: index }, memoArgs = []) {
    return $4b1afda415637ecc$var$createParamsList([
        value,
        key,
        index,
        ...memoArgs
    ]);
}
function $4b1afda415637ecc$var$createParamsList(args) {
    let i = args.length;
    while(i--){
        if (args[i]) break;
    }
    return args.slice(0, i + 1).map((arg, i)=>arg || $4b1afda415637ecc$export$ac2aa689b44cdd23(`_`.repeat(i + 1), false));
}
const $4b1afda415637ecc$var$defaultFallback = $4b1afda415637ecc$export$ac2aa689b44cdd23(`undefined`, false);
// A NodeTransform that:
// 1. Tracks scope identifiers for scoped slots so that they don't get prefixed
//    by transformExpression. This is only applied in non-browser builds with
//    { prefixIdentifiers: true }.
// 2. Track v-slot depths so that we know a slot is inside another slot.
//    Note the exit callback is executed before buildSlots() on the same node,
//    so only nested slots see positive numbers.
const $4b1afda415637ecc$export$f0a2c7894e526c50 = (node, context)=>{
    if (node.type === 1 /* NodeTypes.ELEMENT */  && (node.tagType === 1 /* ElementTypes.COMPONENT */  || node.tagType === 3 /* ElementTypes.TEMPLATE */ )) {
        // We are only checking non-empty v-slot here
        // since we only care about slots that introduce scope variables.
        const vSlot = $4b1afda415637ecc$export$1199bc2a2b648c8c(node, 'slot');
        if (vSlot) {
            vSlot.exp;
            context.scopes.vSlot++;
            return ()=>{
                context.scopes.vSlot--;
            };
        }
    }
};
// A NodeTransform that tracks scope identifiers for scoped slots with v-for.
// This transform is only applied in non-browser builds with { prefixIdentifiers: true }
const $4b1afda415637ecc$export$38b9212074cad7c2 = (node, context)=>{
    let vFor;
    if ($4b1afda415637ecc$export$f125a8a2b402ed89(node) && node.props.some($4b1afda415637ecc$export$eaf8991bb8af8cbb) && (vFor = $4b1afda415637ecc$export$1199bc2a2b648c8c(node, 'for'))) {
        const result = vFor.parseResult = $4b1afda415637ecc$var$parseForExpression(vFor.exp, context);
        if (result) {
            const { value: value, key: key, index: index } = result;
            const { addIdentifiers: addIdentifiers, removeIdentifiers: removeIdentifiers } = context;
            value && addIdentifiers(value);
            key && addIdentifiers(key);
            index && addIdentifiers(index);
            return ()=>{
                value && removeIdentifiers(value);
                key && removeIdentifiers(key);
                index && removeIdentifiers(index);
            };
        }
    }
};
const $4b1afda415637ecc$var$buildClientSlotFn = (props, children, loc)=>$4b1afda415637ecc$export$253e05bfd5b6c4c6(props, children, false, true, children.length ? children[0].loc : loc);
// Instead of being a DirectiveTransform, v-slot processing is called during
// transformElement to build the slots object for a component.
function $4b1afda415637ecc$export$8083554712300565(node, context, buildSlotFn = $4b1afda415637ecc$var$buildClientSlotFn) {
    context.helper($4b1afda415637ecc$export$141e17a2b5200090);
    const { children: children, loc: loc } = node;
    const slotsProperties = [];
    const dynamicSlots = [];
    // If the slot is inside a v-for or another v-slot, force it to be dynamic
    // since it likely uses a scope variable.
    let hasDynamicSlots = context.scopes.vSlot > 0 || context.scopes.vFor > 0;
    // 1. Check for slot with slotProps on component itself.
    //    <Comp v-slot="{ prop }"/>
    const onComponentSlot = $4b1afda415637ecc$export$1199bc2a2b648c8c(node, 'slot', true);
    if (onComponentSlot) {
        const { arg: arg, exp: exp } = onComponentSlot;
        if (arg && !$4b1afda415637ecc$export$43d387e2d68b51dc(arg)) hasDynamicSlots = true;
        slotsProperties.push($4b1afda415637ecc$export$45231d90c148ea74(arg || $4b1afda415637ecc$export$ac2aa689b44cdd23('default', true), buildSlotFn(exp, children, loc)));
    }
    // 2. Iterate through children and check for template slots
    //    <template v-slot:foo="{ prop }">
    let hasTemplateSlots = false;
    let hasNamedDefaultSlot = false;
    const implicitDefaultChildren = [];
    const seenSlotNames = new Set();
    let conditionalBranchIndex = 0;
    for(let i = 0; i < children.length; i++){
        const slotElement = children[i];
        let slotDir;
        if (!$4b1afda415637ecc$export$f125a8a2b402ed89(slotElement) || !(slotDir = $4b1afda415637ecc$export$1199bc2a2b648c8c(slotElement, 'slot', true))) {
            // not a <template v-slot>, skip.
            if (slotElement.type !== 3 /* NodeTypes.COMMENT */ ) implicitDefaultChildren.push(slotElement);
            continue;
        }
        if (onComponentSlot) {
            // already has on-component slot - this is incorrect usage.
            context.onError($4b1afda415637ecc$export$57c5a5dc5aa19bdf(37 /* ErrorCodes.X_V_SLOT_MIXED_SLOT_USAGE */ , slotDir.loc));
            break;
        }
        hasTemplateSlots = true;
        const { children: slotChildren, loc: slotLoc } = slotElement;
        const { arg: slotName = $4b1afda415637ecc$export$ac2aa689b44cdd23(`default`, true), exp: slotProps, loc: dirLoc } = slotDir;
        // check if name is dynamic.
        let staticSlotName;
        if ($4b1afda415637ecc$export$43d387e2d68b51dc(slotName)) staticSlotName = slotName ? slotName.content : `default`;
        else hasDynamicSlots = true;
        const slotFunction = buildSlotFn(slotProps, slotChildren, slotLoc);
        // check if this slot is conditional (v-if/v-for)
        let vIf;
        let vElse;
        let vFor;
        if (vIf = $4b1afda415637ecc$export$1199bc2a2b648c8c(slotElement, 'if')) {
            hasDynamicSlots = true;
            dynamicSlots.push($4b1afda415637ecc$export$374e02fb5bd90a4e(vIf.exp, $4b1afda415637ecc$var$buildDynamicSlot(slotName, slotFunction, conditionalBranchIndex++), $4b1afda415637ecc$var$defaultFallback));
        } else if (vElse = $4b1afda415637ecc$export$1199bc2a2b648c8c(slotElement, /^else(-if)?$/, true)) {
            // find adjacent v-if
            let j = i;
            let prev;
            while(j--){
                prev = children[j];
                if (prev.type !== 3 /* NodeTypes.COMMENT */ ) break;
            }
            if (prev && $4b1afda415637ecc$export$f125a8a2b402ed89(prev) && $4b1afda415637ecc$export$1199bc2a2b648c8c(prev, 'if')) {
                // remove node
                children.splice(i, 1);
                i--;
                // attach this slot to previous conditional
                let conditional = dynamicSlots[dynamicSlots.length - 1];
                while(conditional.alternate.type === 19 /* NodeTypes.JS_CONDITIONAL_EXPRESSION */ )conditional = conditional.alternate;
                conditional.alternate = vElse.exp ? $4b1afda415637ecc$export$374e02fb5bd90a4e(vElse.exp, $4b1afda415637ecc$var$buildDynamicSlot(slotName, slotFunction, conditionalBranchIndex++), $4b1afda415637ecc$var$defaultFallback) : $4b1afda415637ecc$var$buildDynamicSlot(slotName, slotFunction, conditionalBranchIndex++);
            } else context.onError($4b1afda415637ecc$export$57c5a5dc5aa19bdf(30 /* ErrorCodes.X_V_ELSE_NO_ADJACENT_IF */ , vElse.loc));
        } else if (vFor = $4b1afda415637ecc$export$1199bc2a2b648c8c(slotElement, 'for')) {
            hasDynamicSlots = true;
            const parseResult = vFor.parseResult || $4b1afda415637ecc$var$parseForExpression(vFor.exp, context);
            if (parseResult) // Render the dynamic slots as an array and add it to the createSlot()
            // args. The runtime knows how to handle it appropriately.
            dynamicSlots.push($4b1afda415637ecc$export$2cdf8617f9d8e39d(context.helper($4b1afda415637ecc$export$3da0e5cd78c1870), [
                parseResult.source,
                $4b1afda415637ecc$export$253e05bfd5b6c4c6($4b1afda415637ecc$export$5796ae82f3e98f88(parseResult), $4b1afda415637ecc$var$buildDynamicSlot(slotName, slotFunction), true)
            ]));
            else context.onError($4b1afda415637ecc$export$57c5a5dc5aa19bdf(32 /* ErrorCodes.X_V_FOR_MALFORMED_EXPRESSION */ , vFor.loc));
        } else {
            // check duplicate static names
            if (staticSlotName) {
                if (seenSlotNames.has(staticSlotName)) {
                    context.onError($4b1afda415637ecc$export$57c5a5dc5aa19bdf(38 /* ErrorCodes.X_V_SLOT_DUPLICATE_SLOT_NAMES */ , dirLoc));
                    continue;
                }
                seenSlotNames.add(staticSlotName);
                if (staticSlotName === 'default') hasNamedDefaultSlot = true;
            }
            slotsProperties.push($4b1afda415637ecc$export$45231d90c148ea74(slotName, slotFunction));
        }
    }
    if (!onComponentSlot) {
        const buildDefaultSlotProperty = (props, children)=>{
            const fn = buildSlotFn(props, children, loc);
            if (context.compatConfig) fn.isNonScopedSlot = true;
            return $4b1afda415637ecc$export$45231d90c148ea74(`default`, fn);
        };
        if (!hasTemplateSlots) // implicit default slot (on component)
        slotsProperties.push(buildDefaultSlotProperty(undefined, children));
        else if (implicitDefaultChildren.length && // #3766
        // with whitespace: 'preserve', whitespaces between slots will end up in
        // implicitDefaultChildren. Ignore if all implicit children are whitespaces.
        implicitDefaultChildren.some((node)=>$4b1afda415637ecc$var$isNonWhitespaceContent(node))) {
            // implicit default slot (mixed with named slots)
            if (hasNamedDefaultSlot) context.onError($4b1afda415637ecc$export$57c5a5dc5aa19bdf(39 /* ErrorCodes.X_V_SLOT_EXTRANEOUS_DEFAULT_SLOT_CHILDREN */ , implicitDefaultChildren[0].loc));
            else slotsProperties.push(buildDefaultSlotProperty(undefined, implicitDefaultChildren));
        }
    }
    const slotFlag = hasDynamicSlots ? 2 /* SlotFlags.DYNAMIC */  : $4b1afda415637ecc$var$hasForwardedSlots(node.children) ? 3 /* SlotFlags.FORWARDED */  : 1 /* SlotFlags.STABLE */ ;
    let slots = $4b1afda415637ecc$export$ccb2e514379853a7(slotsProperties.concat($4b1afda415637ecc$export$45231d90c148ea74(`_`, // 2 = compiled but dynamic = can skip normalization, but must run diff
    // 1 = compiled and static = can skip normalization AND diff as optimized
    $4b1afda415637ecc$export$ac2aa689b44cdd23(slotFlag + ``, false))), loc);
    if (dynamicSlots.length) slots = $4b1afda415637ecc$export$2cdf8617f9d8e39d(context.helper($4b1afda415637ecc$export$6a6b6a5c860c238d), [
        slots,
        $4b1afda415637ecc$export$c887713da9895dbb(dynamicSlots)
    ]);
    return {
        slots: slots,
        hasDynamicSlots: hasDynamicSlots
    };
}
function $4b1afda415637ecc$var$buildDynamicSlot(name, fn, index) {
    const props = [
        $4b1afda415637ecc$export$45231d90c148ea74(`name`, name),
        $4b1afda415637ecc$export$45231d90c148ea74(`fn`, fn)
    ];
    if (index != null) props.push($4b1afda415637ecc$export$45231d90c148ea74(`key`, $4b1afda415637ecc$export$ac2aa689b44cdd23(String(index), true)));
    return $4b1afda415637ecc$export$ccb2e514379853a7(props);
}
function $4b1afda415637ecc$var$hasForwardedSlots(children) {
    for(let i = 0; i < children.length; i++){
        const child = children[i];
        switch(child.type){
            case 1 /* NodeTypes.ELEMENT */ :
                if (child.tagType === 2 /* ElementTypes.SLOT */  || $4b1afda415637ecc$var$hasForwardedSlots(child.children)) return true;
                break;
            case 9 /* NodeTypes.IF */ :
                if ($4b1afda415637ecc$var$hasForwardedSlots(child.branches)) return true;
                break;
            case 10 /* NodeTypes.IF_BRANCH */ :
            case 11 /* NodeTypes.FOR */ :
                if ($4b1afda415637ecc$var$hasForwardedSlots(child.children)) return true;
                break;
        }
    }
    return false;
}
function $4b1afda415637ecc$var$isNonWhitespaceContent(node) {
    if (node.type !== 2 /* NodeTypes.TEXT */  && node.type !== 12 /* NodeTypes.TEXT_CALL */ ) return true;
    return node.type === 2 /* NodeTypes.TEXT */  ? !!node.content.trim() : $4b1afda415637ecc$var$isNonWhitespaceContent(node.content);
}
// some directive transforms (e.g. v-model) may return a symbol for runtime
// import, which should be used instead of a resolveDirective call.
const $4b1afda415637ecc$var$directiveImportMap = new WeakMap();
// generate a JavaScript AST for this element's codegen
const $4b1afda415637ecc$export$5d90dc62c1c9e431 = (node, context)=>{
    // perform the work on exit, after all child expressions have been
    // processed and merged.
    return function postTransformElement() {
        node = context.currentNode;
        if (!(node.type === 1 /* NodeTypes.ELEMENT */  && (node.tagType === 0 /* ElementTypes.ELEMENT */  || node.tagType === 1 /* ElementTypes.COMPONENT */ ))) return;
        const { tag: tag, props: props } = node;
        const isComponent = node.tagType === 1 /* ElementTypes.COMPONENT */ ;
        // The goal of the transform is to create a codegenNode implementing the
        // VNodeCall interface.
        let vnodeTag = isComponent ? $4b1afda415637ecc$export$9871d2aaf4643d1d(node, context) : `"${tag}"`;
        const isDynamicComponent = (0, $8POXm.isObject)(vnodeTag) && vnodeTag.callee === $4b1afda415637ecc$export$582a2287b73d3265;
        let vnodeProps;
        let vnodeChildren;
        let vnodePatchFlag;
        let patchFlag = 0;
        let vnodeDynamicProps;
        let dynamicPropNames;
        let vnodeDirectives;
        let shouldUseBlock = // dynamic component may resolve to plain elements
        isDynamicComponent || vnodeTag === $4b1afda415637ecc$export$e74e82bc14ac4f98 || vnodeTag === $4b1afda415637ecc$export$2237d737f4a10705 || !isComponent && // <svg> and <foreignObject> must be forced into blocks so that block
        // updates inside get proper isSVG flag at runtime. (#639, #643)
        // This is technically web-specific, but splitting the logic out of core
        // leads to too much unnecessary complexity.
        (tag === 'svg' || tag === 'foreignObject');
        // props
        if (props.length > 0) {
            const propsBuildResult = $4b1afda415637ecc$export$bc4cd0273bb05e1b(node, context, undefined, isComponent, isDynamicComponent);
            vnodeProps = propsBuildResult.props;
            patchFlag = propsBuildResult.patchFlag;
            dynamicPropNames = propsBuildResult.dynamicPropNames;
            const directives = propsBuildResult.directives;
            vnodeDirectives = directives && directives.length ? $4b1afda415637ecc$export$c887713da9895dbb(directives.map((dir)=>$4b1afda415637ecc$export$6ff1db2f107c16cd(dir, context))) : undefined;
            if (propsBuildResult.shouldUseBlock) shouldUseBlock = true;
        }
        // children
        if (node.children.length > 0) {
            if (vnodeTag === $4b1afda415637ecc$export$e9ff5bb5c39478ed) {
                // Although a built-in component, we compile KeepAlive with raw children
                // instead of slot functions so that it can be used inside Transition
                // or other Transition-wrapping HOCs.
                // To ensure correct updates with block optimizations, we need to:
                // 1. Force keep-alive into a block. This avoids its children being
                //    collected by a parent block.
                shouldUseBlock = true;
                // 2. Force keep-alive to always be updated, since it uses raw children.
                patchFlag |= 1024 /* PatchFlags.DYNAMIC_SLOTS */ ;
            }
            const shouldBuildAsSlots = isComponent && // Teleport is not a real component and has dedicated runtime handling
            vnodeTag !== $4b1afda415637ecc$export$e74e82bc14ac4f98 && // explained above.
            vnodeTag !== $4b1afda415637ecc$export$e9ff5bb5c39478ed;
            if (shouldBuildAsSlots) {
                const { slots: slots, hasDynamicSlots: hasDynamicSlots } = $4b1afda415637ecc$export$8083554712300565(node, context);
                vnodeChildren = slots;
                if (hasDynamicSlots) patchFlag |= 1024 /* PatchFlags.DYNAMIC_SLOTS */ ;
            } else if (node.children.length === 1 && vnodeTag !== $4b1afda415637ecc$export$e74e82bc14ac4f98) {
                const child = node.children[0];
                const type = child.type;
                // check for dynamic text children
                const hasDynamicTextChild = type === 5 /* NodeTypes.INTERPOLATION */  || type === 8 /* NodeTypes.COMPOUND_EXPRESSION */ ;
                if (hasDynamicTextChild && $4b1afda415637ecc$export$7967f5197c38d72a(child, context) === 0 /* ConstantTypes.NOT_CONSTANT */ ) patchFlag |= 1 /* PatchFlags.TEXT */ ;
                // pass directly if the only child is a text node
                // (plain / interpolation / expression)
                if (hasDynamicTextChild || type === 2 /* NodeTypes.TEXT */ ) vnodeChildren = child;
                else vnodeChildren = node.children;
            } else vnodeChildren = node.children;
        }
        // patchFlag & dynamicPropNames
        if (patchFlag !== 0) {
            vnodePatchFlag = String(patchFlag);
            if (dynamicPropNames && dynamicPropNames.length) vnodeDynamicProps = $4b1afda415637ecc$var$stringifyDynamicPropNames(dynamicPropNames);
        }
        node.codegenNode = $4b1afda415637ecc$export$d1cb722ac2a8b632(context, vnodeTag, vnodeProps, vnodeChildren, vnodePatchFlag, vnodeDynamicProps, vnodeDirectives, !!shouldUseBlock, false, isComponent, node.loc);
    };
};
function $4b1afda415637ecc$export$9871d2aaf4643d1d(node, context, ssr = false) {
    let { tag: tag } = node;
    // 1. dynamic component
    const isExplicitDynamic = $4b1afda415637ecc$var$isComponentTag(tag);
    const isProp = $4b1afda415637ecc$export$4ae65475e3513615(node, 'is');
    if (isProp) {
        if (isExplicitDynamic || $4b1afda415637ecc$var$isCompatEnabled("COMPILER_IS_ON_ELEMENT" /* CompilerDeprecationTypes.COMPILER_IS_ON_ELEMENT */ , context)) {
            const exp = isProp.type === 6 /* NodeTypes.ATTRIBUTE */  ? isProp.value && $4b1afda415637ecc$export$ac2aa689b44cdd23(isProp.value.content, true) : isProp.exp;
            if (exp) return $4b1afda415637ecc$export$2cdf8617f9d8e39d(context.helper($4b1afda415637ecc$export$582a2287b73d3265), [
                exp
            ]);
        } else if (isProp.type === 6 /* NodeTypes.ATTRIBUTE */  && isProp.value.content.startsWith('vue:')) // <button is="vue:xxx">
        // if not <component>, only is value that starts with "vue:" will be
        // treated as component by the parse phase and reach here, unless it's
        // compat mode where all is values are considered components
        tag = isProp.value.content.slice(4);
    }
    // 1.5 v-is (TODO: Deprecate)
    const isDir = !isExplicitDynamic && $4b1afda415637ecc$export$1199bc2a2b648c8c(node, 'is');
    if (isDir && isDir.exp) return $4b1afda415637ecc$export$2cdf8617f9d8e39d(context.helper($4b1afda415637ecc$export$582a2287b73d3265), [
        isDir.exp
    ]);
    // 2. built-in components (Teleport, Transition, KeepAlive, Suspense...)
    const builtIn = $4b1afda415637ecc$export$69768c9b514a01e9(tag) || context.isBuiltInComponent(tag);
    if (builtIn) {
        // built-ins are simply fallthroughs / have special handling during ssr
        // so we don't need to import their runtime equivalents
        if (!ssr) context.helper(builtIn);
        return builtIn;
    }
    // 5. user component (resolve)
    context.helper($4b1afda415637ecc$export$28c52e95383d270);
    context.components.add(tag);
    return $4b1afda415637ecc$export$80505c1072df544f(tag, `component`);
}
function $4b1afda415637ecc$export$bc4cd0273bb05e1b(node, context, props = node.props, isComponent, isDynamicComponent, ssr = false) {
    const { tag: tag, loc: elementLoc, children: children } = node;
    let properties = [];
    const mergeArgs = [];
    const runtimeDirectives = [];
    const hasChildren = children.length > 0;
    let shouldUseBlock = false;
    // patchFlag analysis
    let patchFlag = 0;
    let hasRef = false;
    let hasClassBinding = false;
    let hasStyleBinding = false;
    let hasHydrationEventBinding = false;
    let hasDynamicKeys = false;
    let hasVnodeHook = false;
    const dynamicPropNames = [];
    const analyzePatchFlag = ({ key: key, value: value })=>{
        if ($4b1afda415637ecc$export$43d387e2d68b51dc(key)) {
            const name = key.content;
            const isEventHandler = (0, $8POXm.isOn)(name);
            if (isEventHandler && (!isComponent || isDynamicComponent) && // omit the flag for click handlers because hydration gives click
            // dedicated fast path.
            name.toLowerCase() !== 'onclick' && // omit v-model handlers
            name !== 'onUpdate:modelValue' && // omit onVnodeXXX hooks
            !(0, $8POXm.isReservedProp)(name)) hasHydrationEventBinding = true;
            if (isEventHandler && (0, $8POXm.isReservedProp)(name)) hasVnodeHook = true;
            if (value.type === 20 /* NodeTypes.JS_CACHE_EXPRESSION */  || (value.type === 4 /* NodeTypes.SIMPLE_EXPRESSION */  || value.type === 8 /* NodeTypes.COMPOUND_EXPRESSION */ ) && $4b1afda415637ecc$export$7967f5197c38d72a(value, context) > 0) // skip if the prop is a cached handler or has constant value
            return;
            if (name === 'ref') hasRef = true;
            else if (name === 'class') hasClassBinding = true;
            else if (name === 'style') hasStyleBinding = true;
            else if (name !== 'key' && !dynamicPropNames.includes(name)) dynamicPropNames.push(name);
            // treat the dynamic class and style binding of the component as dynamic props
            if (isComponent && (name === 'class' || name === 'style') && !dynamicPropNames.includes(name)) dynamicPropNames.push(name);
        } else hasDynamicKeys = true;
    };
    for(let i = 0; i < props.length; i++){
        // static attribute
        const prop = props[i];
        if (prop.type === 6 /* NodeTypes.ATTRIBUTE */ ) {
            const { loc: loc, name: name, value: value } = prop;
            let isStatic = true;
            if (name === 'ref') {
                hasRef = true;
                if (context.scopes.vFor > 0) properties.push($4b1afda415637ecc$export$45231d90c148ea74($4b1afda415637ecc$export$ac2aa689b44cdd23('ref_for', true), $4b1afda415637ecc$export$ac2aa689b44cdd23('true')));
            }
            // skip is on <component>, or is="vue:xxx"
            if (name === 'is' && ($4b1afda415637ecc$var$isComponentTag(tag) || value && value.content.startsWith('vue:') || $4b1afda415637ecc$var$isCompatEnabled("COMPILER_IS_ON_ELEMENT" /* CompilerDeprecationTypes.COMPILER_IS_ON_ELEMENT */ , context))) continue;
            properties.push($4b1afda415637ecc$export$45231d90c148ea74($4b1afda415637ecc$export$ac2aa689b44cdd23(name, true, $4b1afda415637ecc$export$1b56c942e608880a(loc, 0, name.length)), $4b1afda415637ecc$export$ac2aa689b44cdd23(value ? value.content : '', isStatic, value ? value.loc : loc)));
        } else {
            // directives
            const { name: name, arg: arg, exp: exp, loc: loc } = prop;
            const isVBind = name === 'bind';
            const isVOn = name === 'on';
            // skip v-slot - it is handled by its dedicated transform.
            if (name === 'slot') {
                if (!isComponent) context.onError($4b1afda415637ecc$export$57c5a5dc5aa19bdf(40 /* ErrorCodes.X_V_SLOT_MISPLACED */ , loc));
                continue;
            }
            // skip v-once/v-memo - they are handled by dedicated transforms.
            if (name === 'once' || name === 'memo') continue;
            // skip v-is and :is on <component>
            if (name === 'is' || isVBind && $4b1afda415637ecc$export$45cac5109adb5e55(arg, 'is') && ($4b1afda415637ecc$var$isComponentTag(tag) || $4b1afda415637ecc$var$isCompatEnabled("COMPILER_IS_ON_ELEMENT" /* CompilerDeprecationTypes.COMPILER_IS_ON_ELEMENT */ , context))) continue;
            // skip v-on in SSR compilation
            if (isVOn && ssr) continue;
            if (// #938: elements with dynamic keys should be forced into blocks
            isVBind && $4b1afda415637ecc$export$45cac5109adb5e55(arg, 'key') || // inline before-update hooks need to force block so that it is invoked
            // before children
            isVOn && hasChildren && $4b1afda415637ecc$export$45cac5109adb5e55(arg, 'vue:before-update')) shouldUseBlock = true;
            if (isVBind && $4b1afda415637ecc$export$45cac5109adb5e55(arg, 'ref') && context.scopes.vFor > 0) properties.push($4b1afda415637ecc$export$45231d90c148ea74($4b1afda415637ecc$export$ac2aa689b44cdd23('ref_for', true), $4b1afda415637ecc$export$ac2aa689b44cdd23('true')));
            // special case for v-bind and v-on with no argument
            if (!arg && (isVBind || isVOn)) {
                hasDynamicKeys = true;
                if (exp) {
                    if (properties.length) {
                        mergeArgs.push($4b1afda415637ecc$export$ccb2e514379853a7($4b1afda415637ecc$var$dedupeProperties(properties), elementLoc));
                        properties = [];
                    }
                    if (isVBind) {
                        if ($4b1afda415637ecc$var$isCompatEnabled("COMPILER_V_BIND_OBJECT_ORDER" /* CompilerDeprecationTypes.COMPILER_V_BIND_OBJECT_ORDER */ , context)) {
                            mergeArgs.unshift(exp);
                            continue;
                        }
                        mergeArgs.push(exp);
                    } else // v-on="obj" -> toHandlers(obj)
                    mergeArgs.push({
                        type: 14 /* NodeTypes.JS_CALL_EXPRESSION */ ,
                        loc: loc,
                        callee: context.helper($4b1afda415637ecc$export$4bdbf33367525856),
                        arguments: isComponent ? [
                            exp
                        ] : [
                            exp,
                            `true`
                        ]
                    });
                } else context.onError($4b1afda415637ecc$export$57c5a5dc5aa19bdf(isVBind ? 34 /* ErrorCodes.X_V_BIND_NO_EXPRESSION */  : 35 /* ErrorCodes.X_V_ON_NO_EXPRESSION */ , loc));
                continue;
            }
            const directiveTransform = context.directiveTransforms[name];
            if (directiveTransform) {
                // has built-in directive transform.
                const { props: props, needRuntime: needRuntime } = directiveTransform(prop, node, context);
                !ssr && props.forEach(analyzePatchFlag);
                properties.push(...props);
                if (needRuntime) {
                    runtimeDirectives.push(prop);
                    if ((0, $8POXm.isSymbol)(needRuntime)) $4b1afda415637ecc$var$directiveImportMap.set(prop, needRuntime);
                }
            } else if (!(0, $8POXm.isBuiltInDirective)(name)) {
                // no built-in transform, this is a user custom directive.
                runtimeDirectives.push(prop);
                // custom dirs may use beforeUpdate so they need to force blocks
                // to ensure before-update gets called before children update
                if (hasChildren) shouldUseBlock = true;
            }
        }
    }
    let propsExpression = undefined;
    // has v-bind="object" or v-on="object", wrap with mergeProps
    if (mergeArgs.length) {
        if (properties.length) mergeArgs.push($4b1afda415637ecc$export$ccb2e514379853a7($4b1afda415637ecc$var$dedupeProperties(properties), elementLoc));
        if (mergeArgs.length > 1) propsExpression = $4b1afda415637ecc$export$2cdf8617f9d8e39d(context.helper($4b1afda415637ecc$export$825e32c0f842262a), mergeArgs, elementLoc);
        else // single v-bind with nothing else - no need for a mergeProps call
        propsExpression = mergeArgs[0];
    } else if (properties.length) propsExpression = $4b1afda415637ecc$export$ccb2e514379853a7($4b1afda415637ecc$var$dedupeProperties(properties), elementLoc);
    // patchFlag analysis
    if (hasDynamicKeys) patchFlag |= 16 /* PatchFlags.FULL_PROPS */ ;
    else {
        if (hasClassBinding && !isComponent) patchFlag |= 2 /* PatchFlags.CLASS */ ;
        if (hasStyleBinding && !isComponent) patchFlag |= 4 /* PatchFlags.STYLE */ ;
        if (dynamicPropNames.length) patchFlag |= 8 /* PatchFlags.PROPS */ ;
        if (hasHydrationEventBinding) patchFlag |= 32 /* PatchFlags.HYDRATE_EVENTS */ ;
    }
    if (!shouldUseBlock && (patchFlag === 0 || patchFlag === 32 /* PatchFlags.HYDRATE_EVENTS */ ) && (hasRef || hasVnodeHook || runtimeDirectives.length > 0)) patchFlag |= 512 /* PatchFlags.NEED_PATCH */ ;
    // pre-normalize props, SSR is skipped for now
    if (!context.inSSR && propsExpression) switch(propsExpression.type){
        case 15 /* NodeTypes.JS_OBJECT_EXPRESSION */ :
            // means that there is no v-bind,
            // but still need to deal with dynamic key binding
            let classKeyIndex = -1;
            let styleKeyIndex = -1;
            let hasDynamicKey = false;
            for(let i = 0; i < propsExpression.properties.length; i++){
                const key = propsExpression.properties[i].key;
                if ($4b1afda415637ecc$export$43d387e2d68b51dc(key)) {
                    if (key.content === 'class') classKeyIndex = i;
                    else if (key.content === 'style') styleKeyIndex = i;
                } else if (!key.isHandlerKey) hasDynamicKey = true;
            }
            const classProp = propsExpression.properties[classKeyIndex];
            const styleProp = propsExpression.properties[styleKeyIndex];
            // no dynamic key
            if (!hasDynamicKey) {
                if (classProp && !$4b1afda415637ecc$export$43d387e2d68b51dc(classProp.value)) classProp.value = $4b1afda415637ecc$export$2cdf8617f9d8e39d(context.helper($4b1afda415637ecc$export$6382e3ed89de4e2a), [
                    classProp.value
                ]);
                if (styleProp && // the static style is compiled into an object,
                // so use `hasStyleBinding` to ensure that it is a dynamic style binding
                (hasStyleBinding || styleProp.value.type === 4 /* NodeTypes.SIMPLE_EXPRESSION */  && styleProp.value.content.trim()[0] === `[` || // v-bind:style and style both exist,
                // v-bind:style with static literal object
                styleProp.value.type === 17 /* NodeTypes.JS_ARRAY_EXPRESSION */ )) styleProp.value = $4b1afda415637ecc$export$2cdf8617f9d8e39d(context.helper($4b1afda415637ecc$export$b9d3780a9ab822b4), [
                    styleProp.value
                ]);
            } else // dynamic key binding, wrap with `normalizeProps`
            propsExpression = $4b1afda415637ecc$export$2cdf8617f9d8e39d(context.helper($4b1afda415637ecc$export$78c34c869683dd86), [
                propsExpression
            ]);
            break;
        case 14 /* NodeTypes.JS_CALL_EXPRESSION */ :
            break;
        default:
            // single v-bind
            propsExpression = $4b1afda415637ecc$export$2cdf8617f9d8e39d(context.helper($4b1afda415637ecc$export$78c34c869683dd86), [
                $4b1afda415637ecc$export$2cdf8617f9d8e39d(context.helper($4b1afda415637ecc$export$7046bb8d3c918928), [
                    propsExpression
                ])
            ]);
            break;
    }
    return {
        props: propsExpression,
        directives: runtimeDirectives,
        patchFlag: patchFlag,
        dynamicPropNames: dynamicPropNames,
        shouldUseBlock: shouldUseBlock
    };
}
// Dedupe props in an object literal.
// Literal duplicated attributes would have been warned during the parse phase,
// however, it's possible to encounter duplicated `onXXX` handlers with different
// modifiers. We also need to merge static and dynamic class / style attributes.
// - onXXX handlers / style: merge into array
// - class: merge into single expression with concatenation
function $4b1afda415637ecc$var$dedupeProperties(properties) {
    const knownProps = new Map();
    const deduped = [];
    for(let i = 0; i < properties.length; i++){
        const prop = properties[i];
        // dynamic keys are always allowed
        if (prop.key.type === 8 /* NodeTypes.COMPOUND_EXPRESSION */  || !prop.key.isStatic) {
            deduped.push(prop);
            continue;
        }
        const name = prop.key.content;
        const existing = knownProps.get(name);
        if (existing) {
            if (name === 'style' || name === 'class' || (0, $8POXm.isOn)(name)) $4b1afda415637ecc$var$mergeAsArray(existing, prop);
        } else {
            knownProps.set(name, prop);
            deduped.push(prop);
        }
    }
    return deduped;
}
function $4b1afda415637ecc$var$mergeAsArray(existing, incoming) {
    if (existing.value.type === 17 /* NodeTypes.JS_ARRAY_EXPRESSION */ ) existing.value.elements.push(incoming.value);
    else existing.value = $4b1afda415637ecc$export$c887713da9895dbb([
        existing.value,
        incoming.value
    ], existing.loc);
}
function $4b1afda415637ecc$export$6ff1db2f107c16cd(dir, context) {
    const dirArgs = [];
    const runtime = $4b1afda415637ecc$var$directiveImportMap.get(dir);
    if (runtime) // built-in directive with runtime
    dirArgs.push(context.helperString(runtime));
    else {
        // inject statement for resolving directive
        context.helper($4b1afda415637ecc$export$7f3ccc2ef793ecce);
        context.directives.add(dir.name);
        dirArgs.push($4b1afda415637ecc$export$80505c1072df544f(dir.name, `directive`));
    }
    const { loc: loc } = dir;
    if (dir.exp) dirArgs.push(dir.exp);
    if (dir.arg) {
        if (!dir.exp) dirArgs.push(`void 0`);
        dirArgs.push(dir.arg);
    }
    if (Object.keys(dir.modifiers).length) {
        if (!dir.arg) {
            if (!dir.exp) dirArgs.push(`void 0`);
            dirArgs.push(`void 0`);
        }
        const trueExpression = $4b1afda415637ecc$export$ac2aa689b44cdd23(`true`, false, loc);
        dirArgs.push($4b1afda415637ecc$export$ccb2e514379853a7(dir.modifiers.map((modifier)=>$4b1afda415637ecc$export$45231d90c148ea74(modifier, trueExpression)), loc));
    }
    return $4b1afda415637ecc$export$c887713da9895dbb(dirArgs, dir.loc);
}
function $4b1afda415637ecc$var$stringifyDynamicPropNames(props) {
    let propsNamesString = `[`;
    for(let i = 0, l = props.length; i < l; i++){
        propsNamesString += JSON.stringify(props[i]);
        if (i < l - 1) propsNamesString += ', ';
    }
    return propsNamesString + `]`;
}
function $4b1afda415637ecc$var$isComponentTag(tag) {
    return tag === 'component' || tag === 'Component';
}
const $4b1afda415637ecc$var$cacheStringFunction = (fn)=>{
    const cache = Object.create(null);
    return (str)=>{
        const hit = cache[str];
        return hit || (cache[str] = fn(str));
    };
};
const $4b1afda415637ecc$var$camelizeRE = /-(\w)/g;
/**
 * @private
 */ const $4b1afda415637ecc$var$camelize = $4b1afda415637ecc$var$cacheStringFunction((str)=>{
    return str.replace($4b1afda415637ecc$var$camelizeRE, (_, c)=>c ? c.toUpperCase() : '');
});
const $4b1afda415637ecc$var$transformSlotOutlet = (node, context)=>{
    if ($4b1afda415637ecc$export$45f38ad7fffc9b53(node)) {
        const { children: children, loc: loc } = node;
        const { slotName: slotName, slotProps: slotProps } = $4b1afda415637ecc$export$cab34cff437fc757(node, context);
        const slotArgs = [
            context.prefixIdentifiers ? `_ctx.$slots` : `$slots`,
            slotName,
            '{}',
            'undefined',
            'true'
        ];
        let expectedLen = 2;
        if (slotProps) {
            slotArgs[2] = slotProps;
            expectedLen = 3;
        }
        if (children.length) {
            slotArgs[3] = $4b1afda415637ecc$export$253e05bfd5b6c4c6([], children, false, false, loc);
            expectedLen = 4;
        }
        if (context.scopeId && !context.slotted) expectedLen = 5;
        slotArgs.splice(expectedLen); // remove unused arguments
        node.codegenNode = $4b1afda415637ecc$export$2cdf8617f9d8e39d(context.helper($4b1afda415637ecc$export$a91e32c6b04aa348), slotArgs, loc);
    }
};
function $4b1afda415637ecc$export$cab34cff437fc757(node, context) {
    let slotName = `"default"`;
    let slotProps = undefined;
    const nonNameProps = [];
    for(let i = 0; i < node.props.length; i++){
        const p = node.props[i];
        if (p.type === 6 /* NodeTypes.ATTRIBUTE */ ) {
            if (p.value) {
                if (p.name === 'name') slotName = JSON.stringify(p.value.content);
                else {
                    p.name = $4b1afda415637ecc$var$camelize(p.name);
                    nonNameProps.push(p);
                }
            }
        } else {
            if (p.name === 'bind' && $4b1afda415637ecc$export$45cac5109adb5e55(p.arg, 'name')) {
                if (p.exp) slotName = p.exp;
            } else {
                if (p.name === 'bind' && p.arg && $4b1afda415637ecc$export$43d387e2d68b51dc(p.arg)) p.arg.content = $4b1afda415637ecc$var$camelize(p.arg.content);
                nonNameProps.push(p);
            }
        }
    }
    if (nonNameProps.length > 0) {
        const { props: props, directives: directives } = $4b1afda415637ecc$export$bc4cd0273bb05e1b(node, context, nonNameProps, false, false);
        slotProps = props;
        if (directives.length) context.onError($4b1afda415637ecc$export$57c5a5dc5aa19bdf(36 /* ErrorCodes.X_V_SLOT_UNEXPECTED_DIRECTIVE_ON_SLOT_OUTLET */ , directives[0].loc));
    }
    return {
        slotName: slotName,
        slotProps: slotProps
    };
}
const $4b1afda415637ecc$var$fnExpRE = /^\s*([\w$_]+|(async\s*)?\([^)]*?\))\s*=>|^\s*(async\s+)?function(?:\s+[\w$]+)?\s*\(/;
const $4b1afda415637ecc$export$ff060d152244ee7b = (dir, node, context, augmentor)=>{
    const { loc: loc, modifiers: modifiers, arg: arg } = dir;
    if (!dir.exp && !modifiers.length) context.onError($4b1afda415637ecc$export$57c5a5dc5aa19bdf(35 /* ErrorCodes.X_V_ON_NO_EXPRESSION */ , loc));
    let eventName;
    if (arg.type === 4 /* NodeTypes.SIMPLE_EXPRESSION */ ) {
        if (arg.isStatic) {
            let rawName = arg.content;
            // TODO deprecate @vnodeXXX usage
            if (rawName.startsWith('vue:')) rawName = `vnode-${rawName.slice(4)}`;
            const eventString = node.tagType === 1 /* ElementTypes.COMPONENT */  || rawName.startsWith('vnode') || !/[A-Z]/.test(rawName) ? // it to camelCase. See issue #2249
            (0, $8POXm.toHandlerKey)((0, $8POXm.camelize)(rawName)) : `on:${rawName}`;
            eventName = $4b1afda415637ecc$export$ac2aa689b44cdd23(eventString, true, arg.loc);
        } else // #2388
        eventName = $4b1afda415637ecc$export$60ad01cd5cde5e50([
            `${context.helperString($4b1afda415637ecc$export$8687eaac3cd39ddd)}(`,
            arg,
            `)`
        ]);
    } else {
        // already a compound expression.
        eventName = arg;
        eventName.children.unshift(`${context.helperString($4b1afda415637ecc$export$8687eaac3cd39ddd)}(`);
        eventName.children.push(`)`);
    }
    // handler processing
    let exp = dir.exp;
    if (exp && !exp.content.trim()) exp = undefined;
    let shouldCache = context.cacheHandlers && !exp && !context.inVOnce;
    if (exp) {
        const isMemberExp = $4b1afda415637ecc$export$9c8bdf9fab617ce4(exp.content);
        const isInlineStatement = !(isMemberExp || $4b1afda415637ecc$var$fnExpRE.test(exp.content));
        const hasMultipleStatements = exp.content.includes(`;`);
        if (isInlineStatement || shouldCache && isMemberExp) // wrap inline statement in a function expression
        exp = $4b1afda415637ecc$export$60ad01cd5cde5e50([
            `${isInlineStatement ? `$event` : `${``}(...args)`} => ${hasMultipleStatements ? `{` : `(`}`,
            exp,
            hasMultipleStatements ? `}` : `)`
        ]);
    }
    let ret = {
        props: [
            $4b1afda415637ecc$export$45231d90c148ea74(eventName, exp || $4b1afda415637ecc$export$ac2aa689b44cdd23(`() => {}`, false, loc))
        ]
    };
    // apply extended compiler augmentor
    if (augmentor) ret = augmentor(ret);
    if (shouldCache) // cache handlers so that it's always the same handler being passed down.
    // this avoids unnecessary re-renders when users use inline handlers on
    // components.
    ret.props[0].value = context.cache(ret.props[0].value);
    // mark the key as handler for props normalization check
    ret.props.forEach((p)=>p.key.isHandlerKey = true);
    return ret;
};
// v-bind without arg is handled directly in ./transformElements.ts due to it affecting
// codegen for the entire props object. This transform here is only for v-bind
// *with* args.
const $4b1afda415637ecc$export$2fa367e7c04d4515 = (dir, _node, context)=>{
    const { exp: exp, modifiers: modifiers, loc: loc } = dir;
    const arg = dir.arg;
    if (arg.type !== 4 /* NodeTypes.SIMPLE_EXPRESSION */ ) {
        arg.children.unshift(`(`);
        arg.children.push(`) || ""`);
    } else if (!arg.isStatic) arg.content = `${arg.content} || ""`;
    // .sync is replaced by v-model:arg
    if (modifiers.includes('camel')) {
        if (arg.type === 4 /* NodeTypes.SIMPLE_EXPRESSION */ ) {
            if (arg.isStatic) arg.content = (0, $8POXm.camelize)(arg.content);
            else arg.content = `${context.helperString($4b1afda415637ecc$export$3ebbf6981763e181)}(${arg.content})`;
        } else {
            arg.children.unshift(`${context.helperString($4b1afda415637ecc$export$3ebbf6981763e181)}(`);
            arg.children.push(`)`);
        }
    }
    if (!context.inSSR) {
        if (modifiers.includes('prop')) $4b1afda415637ecc$var$injectPrefix(arg, '.');
        if (modifiers.includes('attr')) $4b1afda415637ecc$var$injectPrefix(arg, '^');
    }
    if (!exp || exp.type === 4 /* NodeTypes.SIMPLE_EXPRESSION */  && !exp.content.trim()) {
        context.onError($4b1afda415637ecc$export$57c5a5dc5aa19bdf(34 /* ErrorCodes.X_V_BIND_NO_EXPRESSION */ , loc));
        return {
            props: [
                $4b1afda415637ecc$export$45231d90c148ea74(arg, $4b1afda415637ecc$export$ac2aa689b44cdd23('', true, loc))
            ]
        };
    }
    return {
        props: [
            $4b1afda415637ecc$export$45231d90c148ea74(arg, exp)
        ]
    };
};
const $4b1afda415637ecc$var$injectPrefix = (arg, prefix)=>{
    if (arg.type === 4 /* NodeTypes.SIMPLE_EXPRESSION */ ) {
        if (arg.isStatic) arg.content = prefix + arg.content;
        else arg.content = `\`${prefix}\${${arg.content}}\``;
    } else {
        arg.children.unshift(`'${prefix}' + (`);
        arg.children.push(`)`);
    }
};
// Merge adjacent text nodes and expressions into a single expression
// e.g. <div>abc {{ d }} {{ e }}</div> should have a single expression node as child.
const $4b1afda415637ecc$var$transformText = (node, context)=>{
    if (node.type === 0 /* NodeTypes.ROOT */  || node.type === 1 /* NodeTypes.ELEMENT */  || node.type === 11 /* NodeTypes.FOR */  || node.type === 10 /* NodeTypes.IF_BRANCH */ ) // perform the transform on node exit so that all expressions have already
    // been processed.
    return ()=>{
        const children = node.children;
        let currentContainer = undefined;
        let hasText = false;
        for(let i = 0; i < children.length; i++){
            const child = children[i];
            if ($4b1afda415637ecc$export$1879817ac5c922b7(child)) {
                hasText = true;
                for(let j = i + 1; j < children.length; j++){
                    const next = children[j];
                    if ($4b1afda415637ecc$export$1879817ac5c922b7(next)) {
                        if (!currentContainer) currentContainer = children[i] = $4b1afda415637ecc$export$60ad01cd5cde5e50([
                            child
                        ], child.loc);
                        // merge adjacent text node into current
                        currentContainer.children.push(` + `, next);
                        children.splice(j, 1);
                        j--;
                    } else {
                        currentContainer = undefined;
                        break;
                    }
                }
            }
        }
        if (!hasText || // if this is a plain element with a single text child, leave it
        // as-is since the runtime has dedicated fast path for this by directly
        // setting textContent of the element.
        // for component root it's always normalized anyway.
        children.length === 1 && (node.type === 0 /* NodeTypes.ROOT */  || node.type === 1 /* NodeTypes.ELEMENT */  && node.tagType === 0 /* ElementTypes.ELEMENT */  && // #3756
        // custom directives can potentially add DOM elements arbitrarily,
        // we need to avoid setting textContent of the element at runtime
        // to avoid accidentally overwriting the DOM elements added
        // by the user through custom directives.
        !node.props.find((p)=>p.type === 7 /* NodeTypes.DIRECTIVE */  && !context.directiveTransforms[p.name]) && // in compat mode, <template> tags with no special directives
        // will be rendered as a fragment so its children must be
        // converted into vnodes.
        !(node.tag === 'template'))) return;
        // pre-convert text nodes into createTextVNode(text) calls to avoid
        // runtime normalization.
        for(let i = 0; i < children.length; i++){
            const child = children[i];
            if ($4b1afda415637ecc$export$1879817ac5c922b7(child) || child.type === 8 /* NodeTypes.COMPOUND_EXPRESSION */ ) {
                const callArgs = [];
                // createTextVNode defaults to single whitespace, so if it is a
                // single space the code could be an empty call to save bytes.
                if (child.type !== 2 /* NodeTypes.TEXT */  || child.content !== ' ') callArgs.push(child);
                // mark dynamic text with flag so it gets patched inside a block
                if (!context.ssr && $4b1afda415637ecc$export$7967f5197c38d72a(child, context) === 0 /* ConstantTypes.NOT_CONSTANT */ ) callArgs.push(1 /* PatchFlags.TEXT */  + ``);
                children[i] = {
                    type: 12 /* NodeTypes.TEXT_CALL */ ,
                    content: child,
                    loc: child.loc,
                    codegenNode: $4b1afda415637ecc$export$2cdf8617f9d8e39d(context.helper($4b1afda415637ecc$export$8890896270dfc293), callArgs)
                };
            }
        }
    };
};
const $4b1afda415637ecc$var$seen = new WeakSet();
const $4b1afda415637ecc$var$transformOnce = (node, context)=>{
    if (node.type === 1 /* NodeTypes.ELEMENT */  && $4b1afda415637ecc$export$1199bc2a2b648c8c(node, 'once', true)) {
        if ($4b1afda415637ecc$var$seen.has(node) || context.inVOnce) return;
        $4b1afda415637ecc$var$seen.add(node);
        context.inVOnce = true;
        context.helper($4b1afda415637ecc$export$37cf1f9ab937c10d);
        return ()=>{
            context.inVOnce = false;
            const cur = context.currentNode;
            if (cur.codegenNode) cur.codegenNode = context.cache(cur.codegenNode, true);
        };
    }
};
const $4b1afda415637ecc$export$567db1f69abf4dcb = (dir, node, context)=>{
    const { exp: exp, arg: arg } = dir;
    if (!exp) {
        context.onError($4b1afda415637ecc$export$57c5a5dc5aa19bdf(41 /* ErrorCodes.X_V_MODEL_NO_EXPRESSION */ , dir.loc));
        return $4b1afda415637ecc$var$createTransformProps();
    }
    const rawExp = exp.loc.source;
    const expString = exp.type === 4 /* NodeTypes.SIMPLE_EXPRESSION */  ? exp.content : rawExp;
    // im SFC <script setup> inline mode, the exp may have been transformed into
    // _unref(exp)
    context.bindingMetadata[rawExp];
    const maybeRef = false /* BindingTypes.SETUP_CONST */ ;
    if (!expString.trim() || !$4b1afda415637ecc$export$9c8bdf9fab617ce4(expString) && !maybeRef) {
        context.onError($4b1afda415637ecc$export$57c5a5dc5aa19bdf(42 /* ErrorCodes.X_V_MODEL_MALFORMED_EXPRESSION */ , exp.loc));
        return $4b1afda415637ecc$var$createTransformProps();
    }
    const propName = arg ? arg : $4b1afda415637ecc$export$ac2aa689b44cdd23('modelValue', true);
    const eventName = arg ? $4b1afda415637ecc$export$43d387e2d68b51dc(arg) ? `onUpdate:${arg.content}` : $4b1afda415637ecc$export$60ad01cd5cde5e50([
        '"onUpdate:" + ',
        arg
    ]) : `onUpdate:modelValue`;
    let assignmentExp;
    const eventArg = context.isTS ? `($event: any)` : `$event`;
    assignmentExp = $4b1afda415637ecc$export$60ad01cd5cde5e50([
        `${eventArg} => ((`,
        exp,
        `) = $event)`
    ]);
    const props = [
        // modelValue: foo
        $4b1afda415637ecc$export$45231d90c148ea74(propName, dir.exp),
        // "onUpdate:modelValue": $event => (foo = $event)
        $4b1afda415637ecc$export$45231d90c148ea74(eventName, assignmentExp)
    ];
    // modelModifiers: { foo: true, "bar-baz": true }
    if (dir.modifiers.length && node.tagType === 1 /* ElementTypes.COMPONENT */ ) {
        const modifiers = dir.modifiers.map((m)=>($4b1afda415637ecc$export$3cb8486ad206c65(m) ? m : JSON.stringify(m)) + `: true`).join(`, `);
        const modifiersKey = arg ? $4b1afda415637ecc$export$43d387e2d68b51dc(arg) ? `${arg.content}Modifiers` : $4b1afda415637ecc$export$60ad01cd5cde5e50([
            arg,
            ' + "Modifiers"'
        ]) : `modelModifiers`;
        props.push($4b1afda415637ecc$export$45231d90c148ea74(modifiersKey, $4b1afda415637ecc$export$ac2aa689b44cdd23(`{ ${modifiers} }`, false, dir.loc, 2 /* ConstantTypes.CAN_HOIST */ )));
    }
    return $4b1afda415637ecc$var$createTransformProps(props);
};
function $4b1afda415637ecc$var$createTransformProps(props = []) {
    return {
        props: props
    };
}
const $4b1afda415637ecc$var$validDivisionCharRE = /[\w).+\-_$\]]/;
const $4b1afda415637ecc$var$transformFilter = (node, context)=>{
    if (!$4b1afda415637ecc$var$isCompatEnabled("COMPILER_FILTER" /* CompilerDeprecationTypes.COMPILER_FILTERS */ , context)) return;
    if (node.type === 5 /* NodeTypes.INTERPOLATION */ ) // filter rewrite is applied before expression transform so only
    // simple expressions are possible at this stage
    $4b1afda415637ecc$var$rewriteFilter(node.content, context);
    if (node.type === 1 /* NodeTypes.ELEMENT */ ) node.props.forEach((prop)=>{
        if (prop.type === 7 /* NodeTypes.DIRECTIVE */  && prop.name !== 'for' && prop.exp) $4b1afda415637ecc$var$rewriteFilter(prop.exp, context);
    });
};
function $4b1afda415637ecc$var$rewriteFilter(node, context) {
    if (node.type === 4 /* NodeTypes.SIMPLE_EXPRESSION */ ) $4b1afda415637ecc$var$parseFilter(node, context);
    else for(let i = 0; i < node.children.length; i++){
        const child = node.children[i];
        if (typeof child !== 'object') continue;
        if (child.type === 4 /* NodeTypes.SIMPLE_EXPRESSION */ ) $4b1afda415637ecc$var$parseFilter(child, context);
        else if (child.type === 8 /* NodeTypes.COMPOUND_EXPRESSION */ ) $4b1afda415637ecc$var$rewriteFilter(node, context);
        else if (child.type === 5 /* NodeTypes.INTERPOLATION */ ) $4b1afda415637ecc$var$rewriteFilter(child.content, context);
    }
}
function $4b1afda415637ecc$var$parseFilter(node, context) {
    const exp = node.content;
    let inSingle = false;
    let inDouble = false;
    let inTemplateString = false;
    let inRegex = false;
    let curly = 0;
    let square = 0;
    let paren = 0;
    let lastFilterIndex = 0;
    let c, prev, i, expression, filters = [];
    for(i = 0; i < exp.length; i++){
        prev = c;
        c = exp.charCodeAt(i);
        if (inSingle) {
            if (c === 0x27 && prev !== 0x5c) inSingle = false;
        } else if (inDouble) {
            if (c === 0x22 && prev !== 0x5c) inDouble = false;
        } else if (inTemplateString) {
            if (c === 0x60 && prev !== 0x5c) inTemplateString = false;
        } else if (inRegex) {
            if (c === 0x2f && prev !== 0x5c) inRegex = false;
        } else if (c === 0x7c && // pipe
        exp.charCodeAt(i + 1) !== 0x7c && exp.charCodeAt(i - 1) !== 0x7c && !curly && !square && !paren) {
            if (expression === undefined) {
                // first filter, end of expression
                lastFilterIndex = i + 1;
                expression = exp.slice(0, i).trim();
            } else pushFilter();
        } else {
            switch(c){
                case 0x22:
                    inDouble = true;
                    break; // "
                case 0x27:
                    inSingle = true;
                    break; // '
                case 0x60:
                    inTemplateString = true;
                    break; // `
                case 0x28:
                    paren++;
                    break; // (
                case 0x29:
                    paren--;
                    break; // )
                case 0x5b:
                    square++;
                    break; // [
                case 0x5d:
                    square--;
                    break; // ]
                case 0x7b:
                    curly++;
                    break; // {
                case 0x7d:
                    curly--;
                    break; // }
            }
            if (c === 0x2f) {
                // /
                let j = i - 1;
                let p;
                // find first non-whitespace prev char
                for(; j >= 0; j--){
                    p = exp.charAt(j);
                    if (p !== ' ') break;
                }
                if (!p || !$4b1afda415637ecc$var$validDivisionCharRE.test(p)) inRegex = true;
            }
        }
    }
    if (expression === undefined) expression = exp.slice(0, i).trim();
    else if (lastFilterIndex !== 0) pushFilter();
    function pushFilter() {
        filters.push(exp.slice(lastFilterIndex, i).trim());
        lastFilterIndex = i + 1;
    }
    if (filters.length) {
        for(i = 0; i < filters.length; i++)expression = $4b1afda415637ecc$var$wrapFilter(expression, filters[i], context);
        node.content = expression;
    }
}
function $4b1afda415637ecc$var$wrapFilter(exp, filter, context) {
    context.helper($4b1afda415637ecc$export$2c190751e09c3969);
    const i = filter.indexOf('(');
    if (i < 0) {
        context.filters.add(filter);
        return `${$4b1afda415637ecc$export$80505c1072df544f(filter, 'filter')}(${exp})`;
    } else {
        const name = filter.slice(0, i);
        const args = filter.slice(i + 1);
        context.filters.add(name);
        return `${$4b1afda415637ecc$export$80505c1072df544f(name, 'filter')}(${exp}${args !== ')' ? ',' + args : args}`;
    }
}
const $4b1afda415637ecc$var$seen$1 = new WeakSet();
const $4b1afda415637ecc$var$transformMemo = (node, context)=>{
    if (node.type === 1 /* NodeTypes.ELEMENT */ ) {
        const dir = $4b1afda415637ecc$export$1199bc2a2b648c8c(node, 'memo');
        if (!dir || $4b1afda415637ecc$var$seen$1.has(node)) return;
        $4b1afda415637ecc$var$seen$1.add(node);
        return ()=>{
            const codegenNode = node.codegenNode || context.currentNode.codegenNode;
            if (codegenNode && codegenNode.type === 13 /* NodeTypes.VNODE_CALL */ ) {
                // non-component sub tree should be turned into a block
                if (node.tagType !== 1 /* ElementTypes.COMPONENT */ ) $4b1afda415637ecc$export$8fa6719e405ab23c(codegenNode, context);
                node.codegenNode = $4b1afda415637ecc$export$2cdf8617f9d8e39d(context.helper($4b1afda415637ecc$export$a0fd71f0f7cd2781), [
                    dir.exp,
                    $4b1afda415637ecc$export$253e05bfd5b6c4c6(undefined, codegenNode),
                    `_cache`,
                    String(context.cached++)
                ]);
            }
        };
    }
};
function $4b1afda415637ecc$export$20c96dae9bab51d8(prefixIdentifiers) {
    return [
        [
            $4b1afda415637ecc$var$transformOnce,
            $4b1afda415637ecc$var$transformIf,
            $4b1afda415637ecc$var$transformMemo,
            $4b1afda415637ecc$var$transformFor,
            $4b1afda415637ecc$var$transformFilter,
            $4b1afda415637ecc$var$transformSlotOutlet,
            $4b1afda415637ecc$export$5d90dc62c1c9e431,
            $4b1afda415637ecc$export$f0a2c7894e526c50,
            $4b1afda415637ecc$var$transformText
        ],
        {
            on: $4b1afda415637ecc$export$ff060d152244ee7b,
            bind: $4b1afda415637ecc$export$2fa367e7c04d4515,
            model: $4b1afda415637ecc$export$567db1f69abf4dcb
        }
    ];
}
// we name it `baseCompile` so that higher order compilers like
// @vue/compiler-dom can export `compile` while re-exporting everything else.
function $4b1afda415637ecc$export$3243579822c486a0(template, options = {}) {
    const onError = options.onError || $4b1afda415637ecc$var$defaultOnError;
    const isModuleMode = options.mode === 'module';
    if (options.prefixIdentifiers === true) onError($4b1afda415637ecc$export$57c5a5dc5aa19bdf(46 /* ErrorCodes.X_PREFIX_ID_NOT_SUPPORTED */ ));
    else if (isModuleMode) onError($4b1afda415637ecc$export$57c5a5dc5aa19bdf(47 /* ErrorCodes.X_MODULE_MODE_NOT_SUPPORTED */ ));
    const prefixIdentifiers = false;
    if (options.cacheHandlers) onError($4b1afda415637ecc$export$57c5a5dc5aa19bdf(48 /* ErrorCodes.X_CACHE_HANDLER_NOT_SUPPORTED */ ));
    if (options.scopeId && !isModuleMode) onError($4b1afda415637ecc$export$57c5a5dc5aa19bdf(49 /* ErrorCodes.X_SCOPE_ID_NOT_SUPPORTED */ ));
    const ast = (0, $8POXm.isString)(template) ? $4b1afda415637ecc$export$f5f219d5f09c81b5(template, options) : template;
    const [nodeTransforms, directiveTransforms] = $4b1afda415637ecc$export$20c96dae9bab51d8();
    $4b1afda415637ecc$export$51186ad6e864892a(ast, (0, $8POXm.extend)({}, options, {
        prefixIdentifiers: prefixIdentifiers,
        nodeTransforms: [
            ...nodeTransforms,
            ...options.nodeTransforms || [] // user transforms
        ],
        directiveTransforms: (0, $8POXm.extend)({}, directiveTransforms, options.directiveTransforms || {} // user transforms
        )
    }));
    return $4b1afda415637ecc$export$80d376111cc09ad7(ast, (0, $8POXm.extend)({}, options, {
        prefixIdentifiers: prefixIdentifiers
    }));
}
const $4b1afda415637ecc$export$eb34aa2b2065da17 = ()=>({
        props: []
    });

});





parcelRegister("aDGir", function(module, exports) {

$parcel$export(module.exports, "default", () => $7bee5b16e716f49a$export$2e2bcd8739ae039);
let $7bee5b16e716f49a$var$script;



let $7bee5b16e716f49a$var$initialize = ()=>{
    $7bee5b16e716f49a$var$script = (parcelRequire("fWW7y"));
    if ($7bee5b16e716f49a$var$script.__esModule) $7bee5b16e716f49a$var$script = $7bee5b16e716f49a$var$script.default;
    $7bee5b16e716f49a$var$script.render = (parcelRequire("oxltZ")).render;
    (parcelRequire("h6wbi")).default($7bee5b16e716f49a$var$script);
    $7bee5b16e716f49a$var$script.__scopeId = 'data-v-a3808f';
    $7bee5b16e716f49a$var$script.__file = "socialMediaAuthButton.vue";
};
$7bee5b16e716f49a$var$initialize();
var $7bee5b16e716f49a$export$2e2bcd8739ae039 = $7bee5b16e716f49a$var$script;

});
parcelRegister("fWW7y", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $b9c95b6108312c96$export$2e2bcd8739ae039);
var $b9c95b6108312c96$export$2e2bcd8739ae039 = {
    __name: 'socialMediaAuthButton',
    props: {
        callToAction: String,
        ariaLabel: String
    },
    setup (__props, { expose: expose }) {
        expose();
        const props = __props;
        const __returned__ = {
            props: props
        };
        Object.defineProperty(__returned__, '__isScriptSetup', {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
};

});

parcelRegister("oxltZ", function(module, exports) {

$parcel$export(module.exports, "render", () => $049c1bb9e11732b8$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
const $049c1bb9e11732b8$var$_hoisted_1 = [
    "aria-label",
    "title"
];
function $049c1bb9e11732b8$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("button", {
        type: "submit",
        class: "flex justify-center items-center gap-x-2 w-full border border-neutral-300 px-4 py-2 rounded",
        "aria-label": $setup.props.ariaLabel,
        title: $setup.props.ariaLabel
    }, [
        (0, $TusQn.renderSlot)(_ctx.$slots, "default"),
        (0, $TusQn.createTextVNode)(" " + (0, $8POXm.toDisplayString)($props.callToAction), 1)
    ], 8, $049c1bb9e11732b8$var$_hoisted_1);
}

});

parcelRegister("h6wbi", function(module, exports) {

$parcel$export(module.exports, "default", () => $c73bf5b94a0a9ea0$export$2e2bcd8739ae039);
let $c73bf5b94a0a9ea0$var$NOOP = ()=>{};
var $c73bf5b94a0a9ea0$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRegister("1cUak", function(module, exports) {
module.exports = import.meta.resolve("87HZH");

});


parcelRegister("7pQz3", function(module, exports) {

$parcel$export(module.exports, "render", () => $5663a4628b47e1fd$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $eeJ70 = parcelRequire("eeJ70");
const $5663a4628b47e1fd$var$_hoisted_1 = {
    class: "w-screen h-screen flex justify-center items-center px-4"
};
const $5663a4628b47e1fd$var$_hoisted_2 = {
    class: "w-96 px-4 py-8 border rounded"
};
const $5663a4628b47e1fd$var$_hoisted_3 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("h1", {
    class: "text-3xl font-semibold mb-8 text-center"
}, "Login", -1);
const $5663a4628b47e1fd$var$_hoisted_4 = {
    class: "flex flex-col gap-3"
};
const $5663a4628b47e1fd$var$_hoisted_5 = [
    "action"
];
const $5663a4628b47e1fd$var$_hoisted_6 = [
    "src"
];
const $5663a4628b47e1fd$var$_hoisted_7 = {
    key: 0,
    class: "mt-4 py-4 text-center border border-red-600 bg-red-200"
};
const $5663a4628b47e1fd$var$_hoisted_8 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("div", {
    class: "text-sm font-bold mb-1"
}, "Wrong Credentials", -1);
const $5663a4628b47e1fd$var$_hoisted_9 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("div", {
    class: "text-xs"
}, "Invalid username or password", -1);
const $5663a4628b47e1fd$var$_hoisted_10 = [
    $5663a4628b47e1fd$var$_hoisted_8,
    $5663a4628b47e1fd$var$_hoisted_9
];
const $5663a4628b47e1fd$var$_hoisted_11 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("div", {
    class: "grid grid-cols-[1fr_auto_1fr] items-center gap-x-2 my-5"
}, [
    /*#__PURE__*/ (0, $TusQn.createElementVNode)("hr"),
    /*#__PURE__*/ (0, $TusQn.createElementVNode)("span", {
        class: "text-neutral-500 text-sm"
    }, "or login with email"),
    /*#__PURE__*/ (0, $TusQn.createElementVNode)("hr")
], -1);
const $5663a4628b47e1fd$var$_hoisted_12 = {
    class: "mb-4"
};
const $5663a4628b47e1fd$var$_hoisted_13 = {
    class: "flex flex-col mb-4"
};
const $5663a4628b47e1fd$var$_hoisted_14 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("label", {
    class: "font-medium mb-1",
    for: "email"
}, "Email", -1);
const $5663a4628b47e1fd$var$_hoisted_15 = [
    "aria-hidden"
];
const $5663a4628b47e1fd$var$_hoisted_16 = {
    class: "flex flex-col mb-6"
};
const $5663a4628b47e1fd$var$_hoisted_17 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("label", {
    class: "font-medium mb-1",
    for: "password"
}, "Password", -1);
const $5663a4628b47e1fd$var$_hoisted_18 = [
    "aria-hidden"
];
const $5663a4628b47e1fd$var$_hoisted_19 = {
    class: "mb-1 text-center text-sm"
};
const $5663a4628b47e1fd$var$_hoisted_20 = /*#__PURE__*/ (0, $TusQn.createTextVNode)("Don't have an account? ");
const $5663a4628b47e1fd$var$_hoisted_21 = /*#__PURE__*/ (0, $TusQn.createTextVNode)("Sign up");
const $5663a4628b47e1fd$var$_hoisted_22 = {
    class: "text-center text-sm"
};
const $5663a4628b47e1fd$var$_hoisted_23 = /*#__PURE__*/ (0, $TusQn.createTextVNode)("Forgot Password?");
function $5663a4628b47e1fd$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_router_link = (0, $TusQn.resolveComponent)("router-link");
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("main", $5663a4628b47e1fd$var$_hoisted_1, [
        (0, $TusQn.createElementVNode)("div", $5663a4628b47e1fd$var$_hoisted_2, [
            $5663a4628b47e1fd$var$_hoisted_3,
            (0, $TusQn.createElementVNode)("div", $5663a4628b47e1fd$var$_hoisted_4, [
                (0, $TusQn.createElementVNode)("form", {
                    action: `${$setup.SERVER_URL}/auth/google`,
                    method: "GET"
                }, [
                    (0, $TusQn.createVNode)($setup["SocialMediaAuthButton"], {
                        callToAction: "Continue With Google",
                        "aria-label": "Login with Google"
                    }, {
                        default: (0, $TusQn.withCtx)(()=>[
                                (0, $TusQn.createElementVNode)("img", {
                                    class: "w-5 h-5",
                                    src: $setup.GoogleIcon,
                                    alt: "Google icon"
                                }, null, 8, $5663a4628b47e1fd$var$_hoisted_6)
                            ]),
                        _: 1
                    })
                ], 8, $5663a4628b47e1fd$var$_hoisted_5)
            ]),
            $setup.isCredentialsMessage ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $5663a4628b47e1fd$var$_hoisted_7, $5663a4628b47e1fd$var$_hoisted_10)) : (0, $TusQn.createCommentVNode)("", true),
            $5663a4628b47e1fd$var$_hoisted_11,
            (0, $TusQn.createElementVNode)("div", null, [
                (0, $TusQn.createElementVNode)("form", $5663a4628b47e1fd$var$_hoisted_12, [
                    (0, $TusQn.createElementVNode)("fieldset", $5663a4628b47e1fd$var$_hoisted_13, [
                        $5663a4628b47e1fd$var$_hoisted_14,
                        (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                            class: "rounded ring-transparent focus:border-transparent focus:ring-2 focus:ring-purple-800",
                            type: "email",
                            name: "email",
                            id: "email",
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event)=>$setup.email = $event),
                            onFocusout: $setup.onEmailFocusOut
                        }, null, 544), [
                            [
                                (0, $eeJ70.vModelText),
                                $setup.email
                            ]
                        ]),
                        (0, $TusQn.createElementVNode)("span", {
                            class: "pt-[2px] text-red-500 text-xs opacity-100 aria-hidden:opacity-0 transition-opacity duration-300",
                            "aria-hidden": !$setup.isEmailMessage
                        }, "Please enter a valid email", 8, $5663a4628b47e1fd$var$_hoisted_15)
                    ]),
                    (0, $TusQn.createElementVNode)("fieldset", $5663a4628b47e1fd$var$_hoisted_16, [
                        $5663a4628b47e1fd$var$_hoisted_17,
                        (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                            class: "rounded ring-transparent focus:border-transparent focus:ring-2 focus:ring-purple-800",
                            type: "password",
                            name: "password",
                            id: "password",
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event)=>$setup.password = $event),
                            onFocusout: $setup.onPasswordFocusOut
                        }, null, 544), [
                            [
                                (0, $eeJ70.vModelText),
                                $setup.password
                            ]
                        ]),
                        (0, $TusQn.createElementVNode)("span", {
                            class: "pt-[2px] text-red-500 text-xs opacity-100 aria-hidden:opacity-0 transition-opacity duration-300",
                            "aria-hidden": !$setup.isPasswordMessage
                        }, "Password should be at least 6 Characters long.", 8, $5663a4628b47e1fd$var$_hoisted_18)
                    ]),
                    (0, $TusQn.createElementVNode)("button", {
                        class: "px-5 py-2 bg-purple-800 text-white w-full text-bold rounded",
                        type: "submit",
                        onClick: $setup.submitForm
                    }, "Login")
                ]),
                (0, $TusQn.createElementVNode)("p", $5663a4628b47e1fd$var$_hoisted_19, [
                    $5663a4628b47e1fd$var$_hoisted_20,
                    (0, $TusQn.createVNode)(_component_router_link, {
                        class: "underline",
                        to: "/signup"
                    }, {
                        default: (0, $TusQn.withCtx)(()=>[
                                $5663a4628b47e1fd$var$_hoisted_21
                            ]),
                        _: 1
                    })
                ]),
                (0, $TusQn.createElementVNode)("div", $5663a4628b47e1fd$var$_hoisted_22, [
                    (0, $TusQn.createVNode)(_component_router_link, {
                        class: "underline",
                        to: "/password-forgot"
                    }, {
                        default: (0, $TusQn.withCtx)(()=>[
                                $5663a4628b47e1fd$var$_hoisted_23
                            ]),
                        _: 1
                    })
                ])
            ])
        ])
    ]);
}

});

parcelRegister("8fD1c", function(module, exports) {

$parcel$export(module.exports, "default", () => $601dfdac67a552fd$export$2e2bcd8739ae039);
let $601dfdac67a552fd$var$NOOP = ()=>{};
var $601dfdac67a552fd$export$2e2bcd8739ae039 = (script)=>{};

});

parcelRegister("1hJ3X", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $0efa55868db85034$export$2e2bcd8739ae039);
parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");

var $73mM4 = parcelRequire("73mM4");

var $ek92w = parcelRequire("ek92w");

var $aDGir = parcelRequire("aDGir");

var $gYKPF = parcelRequire("gYKPF");

var $1cUak = parcelRequire("1cUak");
var $0efa55868db85034$export$2e2bcd8739ae039 = {
    __name: 'signup',
    setup (__props, { expose: expose }) {
        expose();
        const SERVER_URL = "https://scrapbook-concierge-requests-api-cr45w.ondigitalocean.app";
        const emailValidationRegex = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
        const router = (0, $73mM4.useRouter)();
        const { executeRecaptcha: executeRecaptcha, recaptchaLoaded: recaptchaLoaded } = (0, $ek92w.useReCaptcha)();
        const username = (0, $01W3b.ref)('');
        const email = (0, $01W3b.ref)('');
        const password = (0, $01W3b.ref)('');
        const isUsernameMessage = (0, $01W3b.ref)(false);
        const isEmailMessage = (0, $01W3b.ref)(false);
        const isPasswordMessage = (0, $01W3b.ref)(false);
        function onUsernameFocusout() {
            isUsernameMessage.value = !username.value.length;
        }
        function onEmailFocusout() {
            isEmailMessage.value = !email.value.length || !emailValidationRegex.test(email.value);
        }
        function onPasswordFocusout() {
            isPasswordMessage.value = password.value.length < 6;
        }
        const submitForm = async (event)=>{
            event.preventDefault();
            try {
                onUsernameFocusout();
                onEmailFocusout();
                onPasswordFocusout();
                if (isUsernameMessage.value || isEmailMessage.value || isPasswordMessage.value) return;
                const generateOptions = (body)=>({
                        method: 'POST',
                        body: JSON.stringify(body),
                        headers: {
                            'Content-Type': 'application/json'
                        }
                    });
                const reCAPTCHAToken = await executeRecaptcha('signup');
                const verificationResponse = await fetch(`${"https://scrapbook-concierge-requests-api-cr45w.ondigitalocean.app"}/verify-recaptcha`, generateOptions({
                    token: reCAPTCHAToken
                }));
                const verificationResult = await verificationResponse.json();
                if (verificationResponse.status === 400) return router.push({
                    name: 'home'
                });
                const response = await fetch(`${"https://scrapbook-concierge-requests-api-cr45w.ondigitalocean.app"}/signup/password`, generateOptions({
                    username: username.value,
                    email: email.value,
                    password: password.value
                }));
                const result = await response.json();
                if (response.ok) {
                    (0, $gYKPF.pushAlert)('success', result.message);
                    router.push({
                        name: 'login'
                    });
                } else if (response.status === 429) (0, $gYKPF.pushAlert)('failure', result.message);
                else (0, $gYKPF.pushAlert)('failure', result.message);
            } catch (error) {
                console.warn(error);
                // pushAlert( 'failure', result.message );
                (0, $gYKPF.pushAlert)('failure', 'An Error occurred while Signing up. Try again later.');
            }
        };
        const __returned__ = {
            SERVER_URL: SERVER_URL,
            emailValidationRegex: emailValidationRegex,
            router: router,
            executeRecaptcha: executeRecaptcha,
            recaptchaLoaded: recaptchaLoaded,
            username: username,
            email: email,
            password: password,
            isUsernameMessage: isUsernameMessage,
            isEmailMessage: isEmailMessage,
            isPasswordMessage: isPasswordMessage,
            onUsernameFocusout: onUsernameFocusout,
            onEmailFocusout: onEmailFocusout,
            onPasswordFocusout: onPasswordFocusout,
            submitForm: submitForm,
            ref: $01W3b.ref,
            useRouter: $73mM4.useRouter,
            useReCaptcha: $ek92w.useReCaptcha,
            SocialMediaAuthButton: $aDGir.default,
            pushAlert: $gYKPF.pushAlert,
            GoogleIcon: (/*@__PURE__*/$parcel$interopDefault($1cUak))
        };
        Object.defineProperty(__returned__, '__isScriptSetup', {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
};

});

parcelRegister("2FKaU", function(module, exports) {

$parcel$export(module.exports, "render", () => $1f233a78696c4615$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $eeJ70 = parcelRequire("eeJ70");
const $1f233a78696c4615$var$_hoisted_1 = {
    class: "w-screen h-screen flex justify-center items-center px-4"
};
const $1f233a78696c4615$var$_hoisted_2 = {
    class: "w-96 px-4 py-8 border rounded"
};
const $1f233a78696c4615$var$_hoisted_3 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("h1", {
    class: "text-3xl font-semibold mb-8 text-center"
}, "Sign up", -1);
const $1f233a78696c4615$var$_hoisted_4 = {
    class: "flex flex-col gap-3"
};
const $1f233a78696c4615$var$_hoisted_5 = [
    "action"
];
const $1f233a78696c4615$var$_hoisted_6 = [
    "src"
];
const $1f233a78696c4615$var$_hoisted_7 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("div", {
    class: "grid grid-cols-[1fr_auto_1fr] items-center gap-x-2 my-5"
}, [
    /*#__PURE__*/ (0, $TusQn.createElementVNode)("hr"),
    /*#__PURE__*/ (0, $TusQn.createElementVNode)("span", {
        class: "text-neutral-500 text-sm"
    }, "or sign up with email"),
    /*#__PURE__*/ (0, $TusQn.createElementVNode)("hr")
], -1);
const $1f233a78696c4615$var$_hoisted_8 = {
    class: "mb-4",
    action: "",
    method: "post"
};
const $1f233a78696c4615$var$_hoisted_9 = {
    class: "flex flex-col mb-4"
};
const $1f233a78696c4615$var$_hoisted_10 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("label", {
    class: "font-medium mb-1",
    for: "username"
}, "Username", -1);
const $1f233a78696c4615$var$_hoisted_11 = [
    "aria-hidden"
];
const $1f233a78696c4615$var$_hoisted_12 = {
    class: "flex flex-col mb-4"
};
const $1f233a78696c4615$var$_hoisted_13 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("label", {
    class: "font-medium mb-1",
    for: "email"
}, "Email", -1);
const $1f233a78696c4615$var$_hoisted_14 = [
    "aria-hidden"
];
const $1f233a78696c4615$var$_hoisted_15 = {
    class: "flex flex-col mb-6"
};
const $1f233a78696c4615$var$_hoisted_16 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("label", {
    class: "font-medium mb-1",
    for: "password"
}, "Password", -1);
const $1f233a78696c4615$var$_hoisted_17 = [
    "aria-hidden"
];
const $1f233a78696c4615$var$_hoisted_18 = {
    class: "text-center text-sm"
};
const $1f233a78696c4615$var$_hoisted_19 = /*#__PURE__*/ (0, $TusQn.createTextVNode)("Already have an account? ");
const $1f233a78696c4615$var$_hoisted_20 = /*#__PURE__*/ (0, $TusQn.createTextVNode)("Login");
function $1f233a78696c4615$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_router_link = (0, $TusQn.resolveComponent)("router-link");
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("main", $1f233a78696c4615$var$_hoisted_1, [
        (0, $TusQn.createElementVNode)("div", $1f233a78696c4615$var$_hoisted_2, [
            $1f233a78696c4615$var$_hoisted_3,
            (0, $TusQn.createElementVNode)("div", $1f233a78696c4615$var$_hoisted_4, [
                (0, $TusQn.createElementVNode)("form", {
                    action: `${$setup.SERVER_URL}/auth/google`,
                    method: "GET"
                }, [
                    (0, $TusQn.createVNode)($setup["SocialMediaAuthButton"], {
                        callToAction: "Continue With Google",
                        "aria-label": "Signup with Google"
                    }, {
                        default: (0, $TusQn.withCtx)(()=>[
                                (0, $TusQn.createElementVNode)("img", {
                                    class: "w-5 h-5",
                                    src: $setup.GoogleIcon,
                                    alt: "Google icon"
                                }, null, 8, $1f233a78696c4615$var$_hoisted_6)
                            ]),
                        _: 1
                    })
                ], 8, $1f233a78696c4615$var$_hoisted_5)
            ]),
            $1f233a78696c4615$var$_hoisted_7,
            (0, $TusQn.createElementVNode)("div", null, [
                (0, $TusQn.createElementVNode)("form", $1f233a78696c4615$var$_hoisted_8, [
                    (0, $TusQn.createElementVNode)("fieldset", $1f233a78696c4615$var$_hoisted_9, [
                        $1f233a78696c4615$var$_hoisted_10,
                        (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                            class: "rounded ring-transparent focus:border-transparent focus:ring-2 focus:ring-purple-800",
                            type: "text",
                            name: "username",
                            id: "username",
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event)=>$setup.username = $event),
                            onFocusout: $setup.onUsernameFocusout
                        }, null, 544), [
                            [
                                (0, $eeJ70.vModelText),
                                $setup.username
                            ]
                        ]),
                        (0, $TusQn.createElementVNode)("span", {
                            class: "pt-[2px] text-red-500 text-xs opacity-100 aria-hidden:opacity-0 transition-opacity duration-300",
                            "aria-hidden": !$setup.isUsernameMessage
                        }, "Please enter a username", 8, $1f233a78696c4615$var$_hoisted_11)
                    ]),
                    (0, $TusQn.createElementVNode)("fieldset", $1f233a78696c4615$var$_hoisted_12, [
                        $1f233a78696c4615$var$_hoisted_13,
                        (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                            class: "rounded ring-transparent focus:border-transparent focus:ring-2 focus:ring-purple-800",
                            type: "email",
                            name: "email",
                            id: "email",
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event)=>$setup.email = $event),
                            onFocusout: $setup.onEmailFocusout
                        }, null, 544), [
                            [
                                (0, $eeJ70.vModelText),
                                $setup.email
                            ]
                        ]),
                        (0, $TusQn.createElementVNode)("span", {
                            class: "pt-[2px] text-red-500 text-xs opacity-100 aria-hidden:opacity-0 transition-opacity duration-300",
                            "aria-hidden": !$setup.isEmailMessage,
                            onFocusout: $setup.onEmailFocusout
                        }, "Please enter a valid email", 40, $1f233a78696c4615$var$_hoisted_14)
                    ]),
                    (0, $TusQn.createElementVNode)("fieldset", $1f233a78696c4615$var$_hoisted_15, [
                        $1f233a78696c4615$var$_hoisted_16,
                        (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                            class: "rounded ring-transparent focus:border-transparent focus:ring-2 focus:ring-purple-800",
                            type: "password",
                            name: "password",
                            id: "password",
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event)=>$setup.password = $event),
                            onFocusout: $setup.onPasswordFocusout
                        }, null, 544), [
                            [
                                (0, $eeJ70.vModelText),
                                $setup.password
                            ]
                        ]),
                        (0, $TusQn.createElementVNode)("span", {
                            class: "pt-[2px] text-red-500 text-xs opacity-100 aria-hidden:opacity-0 transition-opacity duration-300",
                            "aria-hidden": !$setup.isPasswordMessage
                        }, "Your password must be at least 6 characters long.", 8, $1f233a78696c4615$var$_hoisted_17)
                    ]),
                    (0, $TusQn.createElementVNode)("button", {
                        class: "px-5 py-2 bg-purple-800 text-white w-full text-bold rounded",
                        type: "submit",
                        onClick: $setup.submitForm
                    }, "Create Account")
                ]),
                (0, $TusQn.createElementVNode)("p", $1f233a78696c4615$var$_hoisted_18, [
                    $1f233a78696c4615$var$_hoisted_19,
                    (0, $TusQn.createVNode)(_component_router_link, {
                        class: "underline",
                        to: "/login"
                    }, {
                        default: (0, $TusQn.withCtx)(()=>[
                                $1f233a78696c4615$var$_hoisted_20
                            ]),
                        _: 1
                    })
                ])
            ])
        ])
    ]);
}

});

parcelRegister("8RufY", function(module, exports) {

$parcel$export(module.exports, "default", () => $673abe4852b9bf6c$export$2e2bcd8739ae039);
let $673abe4852b9bf6c$var$NOOP = ()=>{};
var $673abe4852b9bf6c$export$2e2bcd8739ae039 = (script)=>{};

});

parcelRegister("8TOKj", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $67aad2dda2da97cb$export$2e2bcd8739ae039);
parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");
var $TusQn = parcelRequire("TusQn");

var $73mM4 = parcelRequire("73mM4");

var $h7UQ3 = parcelRequire("h7UQ3");

var $9amUO = parcelRequire("9amUO");

var $lLLhm = parcelRequire("lLLhm");

var $7xcgR = parcelRequire("7xcgR");

var $8icFV = parcelRequire("8icFV");

var $38WoH = parcelRequire("38WoH");

var $gGcib = parcelRequire("gGcib");

var $gYKPF = parcelRequire("gYKPF");
var $67aad2dda2da97cb$export$2e2bcd8739ae039 = {
    __name: 'my-requests',
    setup (__props, { expose: expose }) {
        expose();
        const REQUESTS_PER_PAGE = 100;
        const router = (0, $73mM4.useRouter)();
        const loadMoreElement = (0, $01W3b.ref)(null);
        const isLoadingUserRequests = (0, $01W3b.ref)(false);
        const currentPage = (0, $01W3b.ref)(0);
        const totalPages = (0, $01W3b.ref)(1);
        const isLoadingSearchRequest = (0, $01W3b.ref)(false);
        const searchRequestValue = (0, $01W3b.ref)('');
        const sortRequestValue = (0, $01W3b.ref)('createdAt-asc');
        let intersectionObserver;
        const options = {
            method: "GET",
            headers: {
                'Authorization': `Bearer ${(0, $gGcib.getToken)('token')}`
            }
        };
        const fetchRequestsByTitle = async ()=>{
            try {
                const sortingValues = sortRequestValue.value.split('-');
                isLoadingSearchRequest.value = true;
                const response = await fetch(`${"https://scrapbook-concierge-requests-api-cr45w.ondigitalocean.app"}/requests/search?title=${searchRequestValue.value}&sort_by=${sortingValues[0]}&order_by=${sortingValues[1]}`, options);
                const data = await response.json();
                if (response.ok) (0, $gYKPF.state).searchRequestResult = data.requests;
                else if (response.status === 401) {
                    (0, $gYKPF.pushAlert)('failure', 'You\'re not logged in.');
                    logUserOutAndRedirectHome();
                } else (0, $gYKPF.pushAlert)('failure', data?.message);
            } catch (error) {
                console.error(error);
                (0, $gYKPF.pushAlert)('failure', 'An Error occurred while searching. Try again later.');
            } finally{
                isLoadingSearchRequest.value = false;
            }
        };
        const onFormSubmit = (event)=>{
            event.preventDefault();
            if (!searchRequestValue.value) return;
            fetchRequestsByTitle();
        };
        const fetchPage = async (page)=>{
            try {
                const sortingValues = sortRequestValue.value.split('-');
                isLoadingUserRequests.value = true;
                const response = await fetch(`${"https://scrapbook-concierge-requests-api-cr45w.ondigitalocean.app"}/requests?id=${(0, $gYKPF.state).user.id}&page=${page}&limit=${REQUESTS_PER_PAGE}&sort_by=${sortingValues[0]}&order_by=${sortingValues[1]}`, options);
                const data = await response.json();
                if (response.ok) {
                    if (page > 1) (0, $gYKPF.state).requests.push(...data.requests);
                    else (0, $gYKPF.state).requests = data.requests;
                    currentPage.value = data.page;
                    totalPages.value = data.total;
                } else if (response.status === 401) {
                    (0, $gYKPF.pushAlert)('failure', 'You\'re not logged in.');
                    (0, $gYKPF.logUserOut)();
                    router.push({
                        name: 'login'
                    });
                } else (0, $gYKPF.pushAlert)('failure', data.message);
            } catch (error) {
                console.error(error);
                (0, $gYKPF.pushAlert)('failure', 'An Error occurred while retrieving the requests. Try again later.');
            } finally{
                isLoadingUserRequests.value = false;
            }
        };
        const intersectionObserverCallback = (entries, observer)=>{
            entries.forEach((entry)=>{
                const nextPage = currentPage.value + 1;
                if (isLoadingUserRequests.value || nextPage > totalPages.value) return;
                if (entry.isIntersecting) fetchPage(nextPage);
            });
        };
        (0, $TusQn.onBeforeMount)(()=>{
            if (!!(0, $gYKPF.state).searchRequestResult) (0, $gYKPF.state).searchRequestResult = null;
        });
        (0, $TusQn.onMounted)(()=>{
            intersectionObserver = new IntersectionObserver(intersectionObserverCallback, {
                root: null,
                rootMargin: '0px',
                threshold: 0
            });
            intersectionObserver.observe(loadMoreElement.value);
        });
        (0, $TusQn.onBeforeUnmount)(()=>intersectionObserver.unobserve(loadMoreElement.value));
        (0, $TusQn.watch)(sortRequestValue, ()=>{
            currentPage.value = 0;
            (0, $gYKPF.state).requests = null;
            fetchPage();
        });
        (0, $TusQn.watch)(searchRequestValue, (newValue, oldValue)=>{
            if (!newValue) (0, $gYKPF.state).searchRequestResult = null;
        });
        const __returned__ = {
            REQUESTS_PER_PAGE: REQUESTS_PER_PAGE,
            router: router,
            loadMoreElement: loadMoreElement,
            isLoadingUserRequests: isLoadingUserRequests,
            currentPage: currentPage,
            totalPages: totalPages,
            isLoadingSearchRequest: isLoadingSearchRequest,
            searchRequestValue: searchRequestValue,
            sortRequestValue: sortRequestValue,
            intersectionObserver: intersectionObserver,
            options: options,
            fetchRequestsByTitle: fetchRequestsByTitle,
            onFormSubmit: onFormSubmit,
            fetchPage: fetchPage,
            intersectionObserverCallback: intersectionObserverCallback,
            ref: $01W3b.ref,
            computed: $01W3b.computed,
            onMounted: $TusQn.onMounted,
            onBeforeMount: $TusQn.onBeforeMount,
            onBeforeUnmount: $TusQn.onBeforeUnmount,
            watch: $TusQn.watch,
            useRouter: $73mM4.useRouter,
            Header: $h7UQ3.default,
            Spinner: $9amUO.default,
            LikeButton: $lLLhm.default,
            UpdateButton: $7xcgR.default,
            DeleteButton: $8icFV.default,
            Footer: $38WoH.default,
            formatDate: $gGcib.formatDate,
            getToken: $gGcib.getToken,
            state: $gYKPF.state,
            onMakeRequestButtonClick: $gYKPF.onMakeRequestButtonClick,
            onLikeButtonClicked: $gYKPF.onLikeButtonClicked,
            onUpdateButtonClicked: $gYKPF.onUpdateButtonClicked,
            onDeleteButtonClicked: $gYKPF.onDeleteButtonClicked,
            logUserOut: $gYKPF.logUserOut,
            pushAlert: $gYKPF.pushAlert
        };
        Object.defineProperty(__returned__, '__isScriptSetup', {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
};

});
parcelRegister("7xcgR", function(module, exports) {

$parcel$export(module.exports, "default", () => $57c52240363a3be6$export$2e2bcd8739ae039);
let $57c52240363a3be6$var$script;



let $57c52240363a3be6$var$initialize = ()=>{
    $57c52240363a3be6$var$script = (parcelRequire("dbmyI"));
    if ($57c52240363a3be6$var$script.__esModule) $57c52240363a3be6$var$script = $57c52240363a3be6$var$script.default;
    $57c52240363a3be6$var$script.render = (parcelRequire("h3OB0")).render;
    (parcelRequire("Nzd3i")).default($57c52240363a3be6$var$script);
    $57c52240363a3be6$var$script.__scopeId = 'data-v-b6c849';
    $57c52240363a3be6$var$script.__file = "updateButton.vue";
};
$57c52240363a3be6$var$initialize();
var $57c52240363a3be6$export$2e2bcd8739ae039 = $57c52240363a3be6$var$script;

});
parcelRegister("dbmyI", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $998dcd3198790541$export$2e2bcd8739ae039);

var $k173e = parcelRequire("k173e");
var $998dcd3198790541$export$2e2bcd8739ae039 = {
    __name: 'updateButton',
    props: {
        isDisabled: Boolean
    },
    emits: [
        'updateButtonClicked'
    ],
    setup (__props, { expose: expose, emit: emits }) {
        expose();
        const props = __props;
        const emitUpdateButtonClicked = ()=>emits('updateButtonClicked');
        const __returned__ = {
            props: props,
            emits: emits,
            emitUpdateButtonClicked: emitUpdateButtonClicked,
            PencilIcon: $k173e.default
        };
        Object.defineProperty(__returned__, '__isScriptSetup', {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
};

});
parcelRegister("k173e", function(module, exports) {

$parcel$export(module.exports, "default", () => $e9295edbf820fc26$export$2e2bcd8739ae039);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
function $e9295edbf820fc26$export$2e2bcd8739ae039(_ctx, _cache) {
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        fill: "currentColor",
        "aria-hidden": "true"
    }, [
        (0, $TusQn.createElementVNode)("path", {
            d: "M21.731 2.269a2.625 2.625 0 00-3.712 0l-1.157 1.157 3.712 3.712 1.157-1.157a2.625 2.625 0 000-3.712zM19.513 8.199l-3.712-3.712-12.15 12.15a5.25 5.25 0 00-1.32 2.214l-.8 2.685a.75.75 0 00.933.933l2.685-.8a5.25 5.25 0 002.214-1.32L19.513 8.2z"
        })
    ]);
}

});


parcelRegister("h3OB0", function(module, exports) {

$parcel$export(module.exports, "render", () => $c6b9f6c9f685f3b0$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
const $c6b9f6c9f685f3b0$var$_hoisted_1 = [
    "disabled"
];
function $c6b9f6c9f685f3b0$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("button", {
        class: "group px-[2px] py-[2px] hover:pointer hover:scale-110 focus:scale-110 transition-transform duration-150 border border-green-800 rounded disabled:opacity-50 disabled:scale-100",
        type: "button",
        "aria-label": "update request",
        disabled: $props.isDisabled,
        onClick: $setup.emitUpdateButtonClicked
    }, [
        (0, $TusQn.createVNode)($setup["PencilIcon"], {
            class: "h-8 w-8 fill-green-800"
        })
    ], 8, $c6b9f6c9f685f3b0$var$_hoisted_1);
}

});

parcelRegister("Nzd3i", function(module, exports) {

$parcel$export(module.exports, "default", () => $094fe398541ad659$export$2e2bcd8739ae039);
let $094fe398541ad659$var$NOOP = ()=>{};
var $094fe398541ad659$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRegister("8icFV", function(module, exports) {

$parcel$export(module.exports, "default", () => $6099d6385a35cd3f$export$2e2bcd8739ae039);
let $6099d6385a35cd3f$var$script;



let $6099d6385a35cd3f$var$initialize = ()=>{
    $6099d6385a35cd3f$var$script = (parcelRequire("9lnqJ"));
    if ($6099d6385a35cd3f$var$script.__esModule) $6099d6385a35cd3f$var$script = $6099d6385a35cd3f$var$script.default;
    $6099d6385a35cd3f$var$script.render = (parcelRequire("19Ees")).render;
    (parcelRequire("6F8GV")).default($6099d6385a35cd3f$var$script);
    $6099d6385a35cd3f$var$script.__scopeId = 'data-v-40ca98';
    $6099d6385a35cd3f$var$script.__file = "deleteButton.vue";
};
$6099d6385a35cd3f$var$initialize();
var $6099d6385a35cd3f$export$2e2bcd8739ae039 = $6099d6385a35cd3f$var$script;

});
parcelRegister("9lnqJ", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $6cd83ff26c13e2d7$export$2e2bcd8739ae039);

var $jpzkj = parcelRequire("jpzkj");
var $6cd83ff26c13e2d7$export$2e2bcd8739ae039 = {
    __name: 'deleteButton',
    props: {
        isDisabled: Boolean
    },
    emits: [
        'deleteButtonClicked'
    ],
    setup (__props, { expose: expose, emit: emits }) {
        expose();
        const props = __props;
        const emitDeleteButtonClicked = ()=>emits('deleteButtonClicked');
        const __returned__ = {
            props: props,
            emits: emits,
            emitDeleteButtonClicked: emitDeleteButtonClicked,
            TrashIcon: $jpzkj.default
        };
        Object.defineProperty(__returned__, '__isScriptSetup', {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
};

});
parcelRegister("jpzkj", function(module, exports) {

$parcel$export(module.exports, "default", () => $e21bc13a9b8ecafb$export$2e2bcd8739ae039);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
function $e21bc13a9b8ecafb$export$2e2bcd8739ae039(_ctx, _cache) {
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        fill: "currentColor",
        "aria-hidden": "true"
    }, [
        (0, $TusQn.createElementVNode)("path", {
            "fill-rule": "evenodd",
            d: "M16.5 4.478v.227a48.816 48.816 0 013.878.512.75.75 0 11-.256 1.478l-.209-.035-1.005 13.07a3 3 0 01-2.991 2.77H8.084a3 3 0 01-2.991-2.77L4.087 6.66l-.209.035a.75.75 0 01-.256-1.478A48.567 48.567 0 017.5 4.705v-.227c0-1.564 1.213-2.9 2.816-2.951a52.662 52.662 0 013.369 0c1.603.051 2.815 1.387 2.815 2.951zm-6.136-1.452a51.196 51.196 0 013.273 0C14.39 3.05 15 3.684 15 4.478v.113a49.488 49.488 0 00-6 0v-.113c0-.794.609-1.428 1.364-1.452zm-.355 5.945a.75.75 0 10-1.5.058l.347 9a.75.75 0 101.499-.058l-.346-9zm5.48.058a.75.75 0 10-1.498-.058l-.347 9a.75.75 0 001.5.058l.345-9z",
            "clip-rule": "evenodd"
        })
    ]);
}

});


parcelRegister("19Ees", function(module, exports) {

$parcel$export(module.exports, "render", () => $0d75d6fb4066de04$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
const $0d75d6fb4066de04$var$_hoisted_1 = [
    "disabled"
];
function $0d75d6fb4066de04$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("button", {
        class: "px-[2px] py-[2px] hover:pointer hover:scale-110 focus:scale-110 transition-transform duration-150 border border-red-800 rounded disabled:opacity-50 disabled:scale-100",
        "aria-label": "delete request",
        disabled: $setup.props.isDisabled,
        type: "button",
        onClick: $setup.emitDeleteButtonClicked
    }, [
        (0, $TusQn.createVNode)($setup["TrashIcon"], {
            class: "h-8 w-8 fill-red-800"
        })
    ], 8, $0d75d6fb4066de04$var$_hoisted_1);
}

});

parcelRegister("6F8GV", function(module, exports) {

$parcel$export(module.exports, "default", () => $4d9d5054ef9cf399$export$2e2bcd8739ae039);
let $4d9d5054ef9cf399$var$NOOP = ()=>{};
var $4d9d5054ef9cf399$export$2e2bcd8739ae039 = (script)=>{};

});



parcelRegister("9amum", function(module, exports) {

$parcel$export(module.exports, "render", () => $6ac67e09ced8bfc6$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
var $eeJ70 = parcelRequire("eeJ70");
const $6ac67e09ced8bfc6$var$_hoisted_1 = {
    class: "min-h-[calc(100vh-70px-144px)] px-5 pt-14 pb-4 sm:min-h-[calc(100vh-60px-144px)] sm:pt-28 lg:px-0"
};
const $6ac67e09ced8bfc6$var$_hoisted_2 = {
    class: "max-w-3xl mx-auto mb-14"
};
const $6ac67e09ced8bfc6$var$_hoisted_3 = {
    class: "mb-5 text-right"
};
const $6ac67e09ced8bfc6$var$_hoisted_4 = {
    class: "sm:w-1/2"
};
const $6ac67e09ced8bfc6$var$_hoisted_5 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("label", {
    for: "search"
}, null, -1);
const $6ac67e09ced8bfc6$var$_hoisted_6 = [
    "disabled"
];
const $6ac67e09ced8bfc6$var$_hoisted_7 = {
    class: "self-end"
};
const $6ac67e09ced8bfc6$var$_hoisted_8 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("label", {
    for: "sort"
}, [
    /*#__PURE__*/ (0, $TusQn.createElementVNode)("span", {
        class: "sr-only"
    }, "Sort By")
], -1);
const $6ac67e09ced8bfc6$var$_hoisted_9 = [
    "disabled"
];
const $6ac67e09ced8bfc6$var$_hoisted_10 = /*#__PURE__*/ (0, $TusQn.createStaticVNode)("<option value=\"\" disabled>Sort by</option><option value=\"createdAt-asc\">Date Asc</option><option value=\"createdAt-desc\">Date Desc</option><option value=\"usersLength-asc\">Likes Asc</option><option value=\"usersLength-desc\">Likes Desc</option>", 5);
const $6ac67e09ced8bfc6$var$_hoisted_15 = [
    $6ac67e09ced8bfc6$var$_hoisted_10
];
const $6ac67e09ced8bfc6$var$_hoisted_16 = {
    key: 0
};
const $6ac67e09ced8bfc6$var$_hoisted_17 = {
    key: 0,
    class: "text-center"
};
const $6ac67e09ced8bfc6$var$_hoisted_18 = {
    key: 1
};
const $6ac67e09ced8bfc6$var$_hoisted_19 = {
    key: 0,
    class: "space-y-10"
};
const $6ac67e09ced8bfc6$var$_hoisted_20 = {
    class: "absolute left-0 -top-5 px-3 py-[2px] text-xs font-medium rounded bg-green-500 empty:hidden"
};
const $6ac67e09ced8bfc6$var$_hoisted_21 = {
    class: "text-left sm:text-right text-xs text-neutral-600"
};
const $6ac67e09ced8bfc6$var$_hoisted_22 = {
    class: "px-5 mb-3 text-lg font-bold text-center sm:pr-20 sm:pl-0 sm:mb-0 sm:text-base sm:text-left"
};
const $6ac67e09ced8bfc6$var$_hoisted_23 = {
    key: 0,
    class: "flex gap-x-1 items-center justify-self-end"
};
const $6ac67e09ced8bfc6$var$_hoisted_24 = [
    "href"
];
const $6ac67e09ced8bfc6$var$_hoisted_25 = {
    key: 1,
    class: "text-2xl text-center"
};
const $6ac67e09ced8bfc6$var$_hoisted_26 = {
    key: 2
};
const $6ac67e09ced8bfc6$var$_hoisted_27 = {
    key: 0,
    class: "text-center"
};
const $6ac67e09ced8bfc6$var$_hoisted_28 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("p", {
    class: "mb-8 text-2xl"
}, " You have no requests yet. ", -1);
const $6ac67e09ced8bfc6$var$_hoisted_29 = [
    $6ac67e09ced8bfc6$var$_hoisted_28
];
const $6ac67e09ced8bfc6$var$_hoisted_30 = {
    class: "space-y-10"
};
const $6ac67e09ced8bfc6$var$_hoisted_31 = {
    class: "absolute left-0 -top-5 px-3 py-[2px] text-xs font-medium rounded bg-green-500 empty:hidden"
};
const $6ac67e09ced8bfc6$var$_hoisted_32 = {
    class: "text-left sm:text-right text-xs text-neutral-600"
};
const $6ac67e09ced8bfc6$var$_hoisted_33 = {
    class: "px-5 text-lg font-bold text-center sm:pr-20 sm:pl-0 sm:text-base sm:text-left"
};
const $6ac67e09ced8bfc6$var$_hoisted_34 = {
    key: 0,
    class: "justify-end flex gap-x-1 items-center"
};
const $6ac67e09ced8bfc6$var$_hoisted_35 = {
    class: "px-3"
};
const $6ac67e09ced8bfc6$var$_hoisted_36 = [
    "href"
];
const $6ac67e09ced8bfc6$var$_hoisted_37 = {
    ref: "loadMoreElement"
};
const $6ac67e09ced8bfc6$var$_hoisted_38 = {
    key: 0,
    class: "mt-7"
};
function $6ac67e09ced8bfc6$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, [
        (0, $TusQn.createVNode)($setup["Header"]),
        (0, $TusQn.createElementVNode)("main", $6ac67e09ced8bfc6$var$_hoisted_1, [
            (0, $TusQn.createElementVNode)("div", $6ac67e09ced8bfc6$var$_hoisted_2, [
                (0, $TusQn.createElementVNode)("div", null, [
                    (0, $TusQn.createElementVNode)("div", $6ac67e09ced8bfc6$var$_hoisted_3, [
                        (0, $TusQn.createElementVNode)("button", {
                            type: "button",
                            class: "px-4 py-2 rounded font-semibold bg-purple-900 text-white",
                            onClick: _cache[0] || (_cache[0] = ()=>$setup.onMakeRequestButtonClick())
                        }, " Make A Request ")
                    ]),
                    (0, $TusQn.createElementVNode)("form", {
                        class: "flex flex-col-reverse justify-between gap-5 mb-20 sm:flex-row",
                        onSubmit: $setup.onFormSubmit
                    }, [
                        (0, $TusQn.createElementVNode)("fieldset", $6ac67e09ced8bfc6$var$_hoisted_4, [
                            $6ac67e09ced8bfc6$var$_hoisted_5,
                            (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                                class: "w-full border-0 border-b-2 focus:border-b-purple-800 focus:ring-transparent",
                                type: "search",
                                name: "search",
                                id: "search",
                                placeholder: "search request...",
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event)=>$setup.searchRequestValue = $event),
                                disabled: $setup.isLoadingUserRequests
                            }, null, 8, $6ac67e09ced8bfc6$var$_hoisted_6), [
                                [
                                    (0, $eeJ70.vModelText),
                                    $setup.searchRequestValue
                                ]
                            ])
                        ]),
                        (0, $TusQn.createElementVNode)("fieldset", $6ac67e09ced8bfc6$var$_hoisted_7, [
                            $6ac67e09ced8bfc6$var$_hoisted_8,
                            (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("select", {
                                class: "rounded focus:ring-purple-800 focus:border-purple-800",
                                name: "sort",
                                id: "sort",
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event)=>$setup.sortRequestValue = $event),
                                disabled: $setup.isLoadingUserRequests || !!$setup.searchRequestValue
                            }, $6ac67e09ced8bfc6$var$_hoisted_15, 8, $6ac67e09ced8bfc6$var$_hoisted_9), [
                                [
                                    (0, $eeJ70.vModelSelect),
                                    $setup.sortRequestValue
                                ]
                            ])
                        ])
                    ], 32)
                ]),
                $setup.currentPage > 0 ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $6ac67e09ced8bfc6$var$_hoisted_16, [
                    $setup.isLoadingSearchRequest ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("p", $6ac67e09ced8bfc6$var$_hoisted_17, " Searching... ")) : $setup.state.searchRequestResult ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $6ac67e09ced8bfc6$var$_hoisted_18, [
                        !!$setup.state.searchRequestResult.length ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("ul", $6ac67e09ced8bfc6$var$_hoisted_19, [
                            ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($setup.state.searchRequestResult, (request)=>{
                                return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("li", {
                                    class: "relative grid gap-x-3 gap-y-4 p-2 rounded shadow-[0_0_3px_rgb(0,0,0)] sm:grid-cols-[64px_1fr_auto] sm:items-center sm:bg-transparent odd:bg-purple-100 sm:shadow-[0_0_2px_rgb(0,0,0)]",
                                    key: request._id
                                }, [
                                    (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("span", $6ac67e09ced8bfc6$var$_hoisted_20, " released ", 512), [
                                        [
                                            (0, $eeJ70.vShow),
                                            request.released && request.url
                                        ]
                                    ]),
                                    (0, $TusQn.createElementVNode)("span", $6ac67e09ced8bfc6$var$_hoisted_21, (0, $8POXm.toDisplayString)($setup.formatDate(request.createdAt)), 1),
                                    (0, $TusQn.createElementVNode)("span", $6ac67e09ced8bfc6$var$_hoisted_22, (0, $8POXm.toDisplayString)(request.title), 1),
                                    !request.released ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $6ac67e09ced8bfc6$var$_hoisted_23, [
                                        (0, $TusQn.createElementVNode)("span", null, (0, $8POXm.toDisplayString)(request.users.length - 1), 1),
                                        (0, $TusQn.createVNode)($setup["LikeButton"], {
                                            id: request._id,
                                            "is-liked": request.users.includes($setup.state.user?.id),
                                            likes: request.users.length - 1,
                                            "is-disabled": request.users[0] === $setup.state.user?.id,
                                            onLikeButtonClicked: ()=>{
                                                $setup.onLikeButtonClicked([
                                                    request,
                                                    $setup.state.requests.find(({ _id: _id })=>_id === request._id)
                                                ], _ctx.logUserOutAndRedirectHome);
                                            }
                                        }, null, 8, [
                                            "id",
                                            "is-liked",
                                            "likes",
                                            "is-disabled",
                                            "onLikeButtonClicked"
                                        ])
                                    ])) : ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("a", {
                                        key: 1,
                                        class: "px-2 py-1 text-sm text-center bg-green-700 text-white rounded-md hover:bg-green-800 transition-colors duration-200",
                                        target: "_blank",
                                        href: request.url
                                    }, " Buy Now ", 8, $6ac67e09ced8bfc6$var$_hoisted_24))
                                ]);
                            }), 128))
                        ])) : ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("p", $6ac67e09ced8bfc6$var$_hoisted_25, " No result found... "))
                    ])) : ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $6ac67e09ced8bfc6$var$_hoisted_26, [
                        !$setup.state.requests?.length ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $6ac67e09ced8bfc6$var$_hoisted_27, $6ac67e09ced8bfc6$var$_hoisted_29)) : (0, $TusQn.createCommentVNode)("", true),
                        (0, $TusQn.createElementVNode)("ul", $6ac67e09ced8bfc6$var$_hoisted_30, [
                            ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($setup.state.requests, (request)=>{
                                return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("li", {
                                    class: "relative grid gap-x-3 gap-y-4 p-2 rounded shadow-[0_0_3px_rgb(0,0,0)] sm:grid-cols-[64px_1fr_auto] sm:items-center sm:bg-transparent odd:bg-purple-100 sm:shadow-[0_0_2px_rgb(0,0,0)]",
                                    key: request._id
                                }, [
                                    (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("span", $6ac67e09ced8bfc6$var$_hoisted_31, " released ", 512), [
                                        [
                                            (0, $eeJ70.vShow),
                                            request.released && request.url
                                        ]
                                    ]),
                                    (0, $TusQn.createElementVNode)("span", $6ac67e09ced8bfc6$var$_hoisted_32, (0, $8POXm.toDisplayString)($setup.formatDate(request.createdAt)), 1),
                                    (0, $TusQn.createElementVNode)("span", $6ac67e09ced8bfc6$var$_hoisted_33, (0, $8POXm.toDisplayString)(request.title), 1),
                                    !request.released ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $6ac67e09ced8bfc6$var$_hoisted_34, [
                                        (0, $TusQn.createElementVNode)("span", $6ac67e09ced8bfc6$var$_hoisted_35, (0, $8POXm.toDisplayString)(request.users.length - 1), 1),
                                        (0, $TusQn.createVNode)($setup["UpdateButton"], {
                                            "is-disabled": !$setup.state.user.admin && request.users.length > 1,
                                            onUpdateButtonClicked: ()=>$setup.onUpdateButtonClicked(request)
                                        }, null, 8, [
                                            "is-disabled",
                                            "onUpdateButtonClicked"
                                        ]),
                                        (0, $TusQn.createVNode)($setup["DeleteButton"], {
                                            "is-disabled": !$setup.state.user.admin && request.users.length > 1,
                                            onDeleteButtonClicked: ()=>$setup.onDeleteButtonClicked(request)
                                        }, null, 8, [
                                            "is-disabled",
                                            "onDeleteButtonClicked"
                                        ])
                                    ])) : ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("a", {
                                        key: 1,
                                        class: "px-2 py-1 text-sm text-center bg-green-700 text-white rounded-md hover:bg-green-800 transition-colors duration-200",
                                        target: "_blank",
                                        href: request.url
                                    }, " Buy Now ", 8, $6ac67e09ced8bfc6$var$_hoisted_36))
                                ]);
                            }), 128))
                        ])
                    ]))
                ])) : (0, $TusQn.createCommentVNode)("", true),
                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("div", $6ac67e09ced8bfc6$var$_hoisted_37, [
                    $setup.isLoadingUserRequests ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $6ac67e09ced8bfc6$var$_hoisted_38, [
                        (0, $TusQn.createVNode)($setup["Spinner"])
                    ])) : ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("button", {
                        key: 1,
                        class: "block mx-auto mt-5 px-4 py-2 rounded-md bg-green-700 text-white",
                        onClick: _cache[3] || (_cache[3] = ($event)=>$setup.fetchPage($setup.currentPage + 1)),
                        type: "submit"
                    }, " Load More "))
                ], 512), [
                    [
                        (0, $eeJ70.vShow),
                        !$setup.searchRequestValue && $setup.currentPage !== $setup.totalPages && !!$setup.totalPages
                    ]
                ])
            ])
        ]),
        (0, $TusQn.createVNode)($setup["Footer"])
    ], 64);
}

});

parcelRegister("9vR2y", function(module, exports) {

$parcel$export(module.exports, "default", () => $6ed026f6857c28d9$export$2e2bcd8739ae039);
let $6ed026f6857c28d9$var$NOOP = ()=>{};
var $6ed026f6857c28d9$export$2e2bcd8739ae039 = (script)=>{};

});

parcelRegister("eT4HI", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $ad69d9e0dd883613$export$2e2bcd8739ae039);
parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");
var $TusQn = parcelRequire("TusQn");

var $73mM4 = parcelRequire("73mM4");

var $h7UQ3 = parcelRequire("h7UQ3");

var $4ymtU = parcelRequire("4ymtU");

var $lLLhm = parcelRequire("lLLhm");

var $9amUO = parcelRequire("9amUO");

var $38WoH = parcelRequire("38WoH");

var $gGcib = parcelRequire("gGcib");

var $gYKPF = parcelRequire("gYKPF");
var $ad69d9e0dd883613$export$2e2bcd8739ae039 = {
    __name: 'released-requests',
    setup (__props, { expose: expose }) {
        expose();
        const REQUESTS_PER_PAGE = 100;
        const router = (0, $73mM4.useRouter)();
        const loadMoreElement = (0, $01W3b.ref)(null);
        const isLoadingReleasedRequests = (0, $01W3b.ref)(false);
        const currentPage = (0, $01W3b.ref)(0);
        const totalPages = (0, $01W3b.ref)(1);
        const isLoadingSearchRequest = (0, $01W3b.ref)(false);
        const searchRequestValue = (0, $01W3b.ref)('');
        const sortRequestValue = (0, $01W3b.ref)('releaseDate-asc');
        let intersectionObserver;
        const options = {
            method: "GET",
            headers: {
                'Authorization': `Bearer ${(0, $gGcib.getToken)('token')}`
            }
        };
        const fetchRequestsByTitle = async ()=>{
            try {
                const sortingValues = sortRequestValue.value.split('-');
                isLoadingSearchRequest.value = true;
                const response = await fetch(`${"https://scrapbook-concierge-requests-api-cr45w.ondigitalocean.app"}/requests/search?title=${searchRequestValue.value}&sort_by=${sortingValues[0]}&order_by=${sortingValues[1]}`, options);
                const data = await response.json();
                if (response.ok) (0, $gYKPF.state).searchRequestResult = data.requests;
                else if (response.status === 401) {
                    (0, $gYKPF.pushAlert)('failure', 'You\'re not logged in.');
                    logUserOutAndRedirectHome();
                } else (0, $gYKPF.pushAlert)('failure', data?.message);
            } catch (error) {
                console.error(error);
                (0, $gYKPF.pushAlert)('failure', 'An Error occurred while searching. Try again later.');
            } finally{
                isLoadingSearchRequest.value = false;
            }
        };
        const onFormSubmit = (event)=>{
            event.preventDefault();
            if (!searchRequestValue.value) return;
            fetchRequestsByTitle();
        };
        const fetchPage = async (page)=>{
            try {
                const sortingValues = sortRequestValue.value.split('-');
                // if ( page === currentPage.value ) return;
                isLoadingReleasedRequests.value = true;
                const response = await fetch(`${"https://scrapbook-concierge-requests-api-cr45w.ondigitalocean.app"}/requests?page=${page}&limit=${REQUESTS_PER_PAGE}&released=true&sort_by=${sortingValues[0]}&order_by=${sortingValues[1]}`, options);
                const data = await response.json();
                if (response.ok) {
                    if (page > 1) (0, $gYKPF.state).requests.push(...data.requests);
                    else (0, $gYKPF.state).requests = data.requests;
                    currentPage.value = data.page;
                    totalPages.value = data.total;
                } else if (response.status === 401) {
                    (0, $gYKPF.pushAlert)('failure', 'You\'re not logged in.');
                    (0, $gYKPF.logUserOut)();
                    router.push({
                        name: 'login'
                    });
                } else (0, $gYKPF.pushAlert)('failure', result.message);
            } catch (error) {
                console.warn(error);
                (0, $gYKPF.pushAlert)('failure', 'An Error occurred while retrieving the requests. Try again later.');
            } finally{
                isLoadingReleasedRequests.value = false;
            }
        };
        const intersectionObserverCallback = (entries, observer)=>{
            entries.forEach((entry)=>{
                const nextPage = currentPage.value + 1;
                if (isLoadingReleasedRequests.value || nextPage > totalPages.value) return;
                if (entry.isIntersecting) fetchPage(nextPage);
            });
        };
        // onBeforeMount( () => fetchPage( 1 ) );
        (0, $TusQn.onBeforeMount)(()=>{
            if (!!(0, $gYKPF.state).searchRequestResult) (0, $gYKPF.state).searchRequestResult = null;
        });
        (0, $TusQn.onMounted)(()=>{
            intersectionObserver = new IntersectionObserver(intersectionObserverCallback, {
                root: null,
                rootMargin: '0px',
                threshold: 0
            });
            intersectionObserver.observe(loadMoreElement.value);
        });
        (0, $TusQn.onBeforeUnmount)(()=>intersectionObserver.unobserve(loadMoreElement.value));
        (0, $TusQn.watch)(sortRequestValue, ()=>{
            currentPage.value = 0;
            (0, $gYKPF.state).requests = null;
            fetchPage();
        });
        (0, $TusQn.watch)(searchRequestValue, (newValue, oldValue)=>{
            if (!newValue) (0, $gYKPF.state).searchRequestResult = null;
        });
        const __returned__ = {
            REQUESTS_PER_PAGE: REQUESTS_PER_PAGE,
            router: router,
            loadMoreElement: loadMoreElement,
            isLoadingReleasedRequests: isLoadingReleasedRequests,
            currentPage: currentPage,
            totalPages: totalPages,
            isLoadingSearchRequest: isLoadingSearchRequest,
            searchRequestValue: searchRequestValue,
            sortRequestValue: sortRequestValue,
            intersectionObserver: intersectionObserver,
            options: options,
            fetchRequestsByTitle: fetchRequestsByTitle,
            onFormSubmit: onFormSubmit,
            fetchPage: fetchPage,
            intersectionObserverCallback: intersectionObserverCallback,
            ref: $01W3b.ref,
            computed: $01W3b.computed,
            onMounted: $TusQn.onMounted,
            onBeforeMount: $TusQn.onBeforeMount,
            onBeforeUnmount: $TusQn.onBeforeUnmount,
            watch: $TusQn.watch,
            useRouter: $73mM4.useRouter,
            Header: $h7UQ3.default,
            Pagination: $4ymtU.default,
            LikeButton: $lLLhm.default,
            Spinner: $9amUO.default,
            Footer: $38WoH.default,
            formatDate: $gGcib.formatDate,
            getToken: $gGcib.getToken,
            state: $gYKPF.state,
            onLikeButtonClicked: $gYKPF.onLikeButtonClicked,
            logUserOut: $gYKPF.logUserOut,
            pushAlert: $gYKPF.pushAlert
        };
        Object.defineProperty(__returned__, '__isScriptSetup', {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
};

});

parcelRegister("g2b7l", function(module, exports) {

$parcel$export(module.exports, "render", () => $bac574ea9cfb9078$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
var $eeJ70 = parcelRequire("eeJ70");
const $bac574ea9cfb9078$var$_hoisted_1 = {
    class: "min-h-[calc(100vh-70px-144px)] pt-14 pb-4 px-5 sm:min-h-[calc(100vh-60px-144px)] sm:pt-28 lg:px-0"
};
const $bac574ea9cfb9078$var$_hoisted_2 = {
    class: "max-w-3xl mx-auto mb-14"
};
const $bac574ea9cfb9078$var$_hoisted_3 = {
    class: "sm:w-1/2"
};
const $bac574ea9cfb9078$var$_hoisted_4 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("label", {
    for: "search"
}, null, -1);
const $bac574ea9cfb9078$var$_hoisted_5 = [
    "disabled"
];
const $bac574ea9cfb9078$var$_hoisted_6 = {
    class: "self-end"
};
const $bac574ea9cfb9078$var$_hoisted_7 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("label", {
    for: "sort"
}, [
    /*#__PURE__*/ (0, $TusQn.createElementVNode)("span", {
        class: "sr-only"
    }, "Sort By")
], -1);
const $bac574ea9cfb9078$var$_hoisted_8 = [
    "disabled"
];
const $bac574ea9cfb9078$var$_hoisted_9 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("option", {
    value: "",
    disabled: ""
}, "Sort by", -1);
const $bac574ea9cfb9078$var$_hoisted_10 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("option", {
    value: "releaseDate-asc"
}, "Released Date Asc", -1);
const $bac574ea9cfb9078$var$_hoisted_11 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("option", {
    value: "releaseDate-desc"
}, "Released Date Desc", -1);
const $bac574ea9cfb9078$var$_hoisted_12 = [
    $bac574ea9cfb9078$var$_hoisted_9,
    $bac574ea9cfb9078$var$_hoisted_10,
    $bac574ea9cfb9078$var$_hoisted_11
];
const $bac574ea9cfb9078$var$_hoisted_13 = {
    key: 0
};
const $bac574ea9cfb9078$var$_hoisted_14 = {
    key: 0,
    class: "text-center"
};
const $bac574ea9cfb9078$var$_hoisted_15 = {
    key: 1
};
const $bac574ea9cfb9078$var$_hoisted_16 = {
    key: 0,
    class: "space-y-10"
};
const $bac574ea9cfb9078$var$_hoisted_17 = {
    class: "absolute left-0 -top-5 px-3 py-[2px] text-xs font-medium rounded bg-green-500 empty:hidden"
};
const $bac574ea9cfb9078$var$_hoisted_18 = {
    class: "text-left sm:text-right text-xs text-neutral-600"
};
const $bac574ea9cfb9078$var$_hoisted_19 = {
    class: "px-5 mb-3 text-lg font-bold text-center sm:pr-20 sm:pl-0 sm:mb-0 sm:text-base sm:text-left"
};
const $bac574ea9cfb9078$var$_hoisted_20 = {
    key: 0,
    class: "flex gap-x-1 items-center justify-self-end"
};
const $bac574ea9cfb9078$var$_hoisted_21 = [
    "href"
];
const $bac574ea9cfb9078$var$_hoisted_22 = {
    key: 1,
    class: "text-2xl text-center"
};
const $bac574ea9cfb9078$var$_hoisted_23 = {
    key: 2
};
const $bac574ea9cfb9078$var$_hoisted_24 = {
    key: 0,
    class: "text-center"
};
const $bac574ea9cfb9078$var$_hoisted_25 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("p", {
    class: "mb-8 text-2xl"
}, " No requests have been released yet. ", -1);
const $bac574ea9cfb9078$var$_hoisted_26 = [
    $bac574ea9cfb9078$var$_hoisted_25
];
const $bac574ea9cfb9078$var$_hoisted_27 = {
    key: 1,
    class: "space-y-10"
};
const $bac574ea9cfb9078$var$_hoisted_28 = {
    class: "text-left sm:text-right text-xs text-neutral-600"
};
const $bac574ea9cfb9078$var$_hoisted_29 = {
    class: "px-5 text-lg font-bold text-center sm:pr-20 sm:pl-0 sm:text-base sm:text-left"
};
const $bac574ea9cfb9078$var$_hoisted_30 = [
    "href"
];
const $bac574ea9cfb9078$var$_hoisted_31 = {
    ref: "loadMoreElement"
};
const $bac574ea9cfb9078$var$_hoisted_32 = {
    key: 0,
    class: "mt-7"
};
function $bac574ea9cfb9078$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, [
        (0, $TusQn.createVNode)($setup["Header"]),
        (0, $TusQn.createElementVNode)("main", $bac574ea9cfb9078$var$_hoisted_1, [
            (0, $TusQn.createElementVNode)("div", $bac574ea9cfb9078$var$_hoisted_2, [
                (0, $TusQn.createElementVNode)("form", {
                    class: "flex flex-col-reverse justify-between gap-5 mb-20 sm:flex-row",
                    onSubmit: $setup.onFormSubmit
                }, [
                    (0, $TusQn.createElementVNode)("fieldset", $bac574ea9cfb9078$var$_hoisted_3, [
                        $bac574ea9cfb9078$var$_hoisted_4,
                        (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                            class: "w-full border-0 border-b-2 focus:border-b-purple-800 focus:ring-transparent",
                            type: "search",
                            name: "search",
                            id: "search",
                            placeholder: "search request...",
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event)=>$setup.searchRequestValue = $event),
                            disabled: $setup.isLoadingReleasedRequests
                        }, null, 8, $bac574ea9cfb9078$var$_hoisted_5), [
                            [
                                (0, $eeJ70.vModelText),
                                $setup.searchRequestValue
                            ]
                        ])
                    ]),
                    (0, $TusQn.createElementVNode)("fieldset", $bac574ea9cfb9078$var$_hoisted_6, [
                        $bac574ea9cfb9078$var$_hoisted_7,
                        (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("select", {
                            class: "rounded focus:ring-purple-800 focus:border-purple-800",
                            name: "sort",
                            id: "sort",
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event)=>$setup.sortRequestValue = $event),
                            disabled: $setup.isLoadingReleasedRequests || !!$setup.searchRequestValue
                        }, $bac574ea9cfb9078$var$_hoisted_12, 8, $bac574ea9cfb9078$var$_hoisted_8), [
                            [
                                (0, $eeJ70.vModelSelect),
                                $setup.sortRequestValue
                            ]
                        ])
                    ])
                ], 32),
                $setup.currentPage > 0 ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $bac574ea9cfb9078$var$_hoisted_13, [
                    $setup.isLoadingSearchRequest ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("p", $bac574ea9cfb9078$var$_hoisted_14, " Searching... ")) : $setup.state.searchRequestResult ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $bac574ea9cfb9078$var$_hoisted_15, [
                        !!$setup.state.searchRequestResult.length ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("ul", $bac574ea9cfb9078$var$_hoisted_16, [
                            ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($setup.state.searchRequestResult, (request)=>{
                                return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("li", {
                                    class: "relative grid gap-x-3 gap-y-4 p-2 rounded shadow-[0_0_3px_rgb(0,0,0)] sm:grid-cols-[64px_1fr_auto] sm:items-center sm:bg-transparent odd:bg-purple-100 sm:shadow-[0_0_2px_rgb(0,0,0)]",
                                    key: request._id
                                }, [
                                    (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("span", $bac574ea9cfb9078$var$_hoisted_17, " released ", 512), [
                                        [
                                            (0, $eeJ70.vShow),
                                            request.released && request.url
                                        ]
                                    ]),
                                    (0, $TusQn.createElementVNode)("span", $bac574ea9cfb9078$var$_hoisted_18, (0, $8POXm.toDisplayString)($setup.formatDate(request.createdAt)), 1),
                                    (0, $TusQn.createElementVNode)("span", $bac574ea9cfb9078$var$_hoisted_19, (0, $8POXm.toDisplayString)(request.title), 1),
                                    !request.released ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $bac574ea9cfb9078$var$_hoisted_20, [
                                        (0, $TusQn.createElementVNode)("span", null, (0, $8POXm.toDisplayString)(request.users.length - 1), 1),
                                        (0, $TusQn.createVNode)($setup["LikeButton"], {
                                            id: request._id,
                                            "is-liked": request.users.includes($setup.state.user?.id),
                                            likes: request.users.length - 1,
                                            "is-disabled": request.users[0] === $setup.state.user?.id,
                                            onLikeButtonClicked: ()=>{
                                                $setup.onLikeButtonClicked([
                                                    request,
                                                    $setup.state.requests.find(({ _id: _id })=>_id === request._id)
                                                ], _ctx.logUserOutAndRedirectHome);
                                            }
                                        }, null, 8, [
                                            "id",
                                            "is-liked",
                                            "likes",
                                            "is-disabled",
                                            "onLikeButtonClicked"
                                        ])
                                    ])) : ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("a", {
                                        key: 1,
                                        class: "px-2 py-1 text-sm text-center bg-green-700 text-white rounded-md hover:bg-green-800 transition-colors duration-200",
                                        target: "_blank",
                                        href: request.url
                                    }, " Buy Now ", 8, $bac574ea9cfb9078$var$_hoisted_21))
                                ]);
                            }), 128))
                        ])) : ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("p", $bac574ea9cfb9078$var$_hoisted_22, " No result found... "))
                    ])) : ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $bac574ea9cfb9078$var$_hoisted_23, [
                        !$setup.state.requests?.length ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $bac574ea9cfb9078$var$_hoisted_24, $bac574ea9cfb9078$var$_hoisted_26)) : ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("ul", $bac574ea9cfb9078$var$_hoisted_27, [
                            ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($setup.state.requests, (request)=>{
                                return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("li", {
                                    class: "grid gap-x-3 gap-y-4 p-2 rounded shadow-[0_0_3px_rgb(0,0,0)] sm:grid-cols-[64px_1fr_auto] sm:items-center sm:bg-transparent odd:bg-purple-100 sm:shadow-[0_0_2px_rgb(0,0,0)]",
                                    key: request._id
                                }, [
                                    (0, $TusQn.createElementVNode)("span", $bac574ea9cfb9078$var$_hoisted_28, (0, $8POXm.toDisplayString)($setup.formatDate(request.releaseDate)), 1),
                                    (0, $TusQn.createElementVNode)("span", $bac574ea9cfb9078$var$_hoisted_29, (0, $8POXm.toDisplayString)(request.title), 1),
                                    (0, $TusQn.createElementVNode)("a", {
                                        class: "justify-self-center px-2 py-1 text-sm text-center bg-green-700 text-white rounded-md hover:scale-105 transition-all",
                                        target: "_blank",
                                        href: request.url
                                    }, " Buy Now ", 8, $bac574ea9cfb9078$var$_hoisted_30)
                                ]);
                            }), 128))
                        ]))
                    ]))
                ])) : (0, $TusQn.createCommentVNode)("", true),
                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("div", $bac574ea9cfb9078$var$_hoisted_31, [
                    $setup.isLoadingReleasedRequests ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $bac574ea9cfb9078$var$_hoisted_32, [
                        (0, $TusQn.createVNode)($setup["Spinner"])
                    ])) : ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("button", {
                        key: 1,
                        class: "block mx-auto mt-5 px-4 py-2 rounded-md bg-green-700 text-white",
                        onClick: _cache[2] || (_cache[2] = ($event)=>$setup.fetchPage($setup.currentPage + 1)),
                        type: "submit"
                    }, " Load More "))
                ], 512), [
                    [
                        (0, $eeJ70.vShow),
                        !$setup.searchRequestValue && $setup.currentPage !== $setup.totalPages && !!$setup.totalPages
                    ]
                ])
            ])
        ]),
        (0, $TusQn.createVNode)($setup["Footer"])
    ], 64);
}

});

parcelRegister("2eAj8", function(module, exports) {

$parcel$export(module.exports, "default", () => $1a090d81df670ddf$export$2e2bcd8739ae039);
let $1a090d81df670ddf$var$NOOP = ()=>{};
var $1a090d81df670ddf$export$2e2bcd8739ae039 = (script)=>{};

});

parcelRegister("ap8dr", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $79329ca52dee4bcd$export$2e2bcd8739ae039);
parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");
var $TusQn = parcelRequire("TusQn");

var $73mM4 = parcelRequire("73mM4");

var $h7UQ3 = parcelRequire("h7UQ3");

var $lLLhm = parcelRequire("lLLhm");

var $7xcgR = parcelRequire("7xcgR");

var $8icFV = parcelRequire("8icFV");

var $b9ZaU = parcelRequire("b9ZaU");

var $3LZFF = parcelRequire("3LZFF");
var $llL2y = parcelRequire("llL2y");

var $38WoH = parcelRequire("38WoH");

var $9amUO = parcelRequire("9amUO");

var $4ymtU = parcelRequire("4ymtU");

var $gYKPF = parcelRequire("gYKPF");

var $gGcib = parcelRequire("gGcib");
var $79329ca52dee4bcd$export$2e2bcd8739ae039 = {
    __name: 'admin',
    setup (__props, { expose: expose }) {
        expose();
        const REQUESTS_PER_PAGE = 100;
        const router = (0, $73mM4.useRouter)();
        const showReleased = (0, $01W3b.ref)(false);
        const loadMoreElement = (0, $01W3b.ref)(null);
        const isLoadingRequests = (0, $01W3b.ref)(false);
        const currentPage = (0, $01W3b.ref)(0);
        const totalPages = (0, $01W3b.ref)(1);
        const isLoadingSearchRequest = (0, $01W3b.ref)(false);
        const searchRequestValue = (0, $01W3b.ref)('');
        const sortRequestValue = (0, $01W3b.ref)('usersLength-desc');
        let intersectionObserver;
        const requestsReleaseListIds = (0, $01W3b.computed)(()=>(0, $gYKPF.state).requestsReleaseList.map((request)=>request.id));
        function toggleIdFromRequestList(id, title) {
            const index = (0, $gYKPF.state).requestsReleaseList.findIndex((request)=>request.id === id);
            if (index != -1) (0, $gYKPF.state).requestsReleaseList.splice(index, 1);
            else (0, $gYKPF.state).requestsReleaseList.push({
                id: id,
                title: title
            });
        }
        const options = {
            method: "GET",
            headers: {
                'Authorization': `Bearer ${(0, $gGcib.getToken)('token')}`
            }
        };
        const fetchRequestsByTitle = async ()=>{
            try {
                const sortingValues = sortRequestValue.value.split('-');
                isLoadingSearchRequest.value = true;
                const response = await fetch(`${"https://scrapbook-concierge-requests-api-cr45w.ondigitalocean.app"}/requests/search?title=${searchRequestValue.value}&sort_by=${sortingValues[0]}&order_by=${sortingValues[1]}`, options);
                const data = await response.json();
                if (response.ok) (0, $gYKPF.state).searchRequestResult = data.requests;
                else if (response.status === 401) {
                    (0, $gYKPF.pushAlert)('failure', 'You\'re not logged in.');
                    logUserOutAndRedirectHome();
                } else (0, $gYKPF.pushAlert)('failure', data?.message);
            } catch (error) {
                console.error(error);
                (0, $gYKPF.pushAlert)('failure', 'An Error occurred while searching. Try again later.');
            } finally{
                isLoadingSearchRequest.value = false;
            }
        };
        const onFormSubmit = (event)=>{
            event.preventDefault();
            if (!searchRequestValue.value) return;
            fetchRequestsByTitle();
        };
        const fetchPage = async (page)=>{
            try {
                const sortingValues = sortRequestValue.value.split('-');
                isLoadingRequests.value = true;
                const response = await fetch(`${"https://scrapbook-concierge-requests-api-cr45w.ondigitalocean.app"}/requests?page=${page}&limit=${REQUESTS_PER_PAGE}&released=${showReleased.value}&sort_by=${sortingValues[0]}&order_by=${sortingValues[1]}`, options);
                const data = await response.json();
                if (response.ok) {
                    if (page > 1) (0, $gYKPF.state).requests.push(...data.requests);
                    else (0, $gYKPF.state).requests = data.requests;
                    currentPage.value = data.page;
                    totalPages.value = data.total;
                } else if (response.status === 401) {
                    (0, $gYKPF.pushAlert)('failure', 'You\'re not logged in.');
                    (0, $gYKPF.logUserOut)();
                    router.push({
                        name: 'login'
                    });
                } else (0, $gYKPF.pushAlert)('failure', data?.message);
            } catch (error) {
                console.error(error);
                (0, $gYKPF.pushAlert)('failure', 'An Error occurred while retrieving the requests. Try again later.');
            } finally{
                isLoadingRequests.value = false;
            }
        };
        const intersectionObserverCallback = (entries, observer)=>{
            entries.forEach((entry)=>{
                const nextPage = currentPage.value + 1;
                if (isLoadingRequests.value || nextPage > totalPages.value) return;
                if (entry.isIntersecting) fetchPage(nextPage);
            });
        };
        (0, $TusQn.onBeforeMount)(()=>{
            if (!!(0, $gYKPF.state).searchRequestResult) (0, $gYKPF.state).searchRequestResult = null;
        });
        (0, $TusQn.onMounted)(()=>{
            intersectionObserver = new IntersectionObserver(intersectionObserverCallback, {
                root: null,
                rootMargin: '0px',
                threshold: 0
            });
            intersectionObserver.observe(loadMoreElement.value);
        });
        (0, $TusQn.onBeforeUnmount)(()=>intersectionObserver.unobserve(loadMoreElement.value));
        (0, $TusQn.watch)(sortRequestValue, ()=>{
            currentPage.value = 0;
            (0, $gYKPF.state).requests = null;
            fetchPage();
        });
        (0, $TusQn.watch)(showReleased, ()=>{
            currentPage.value = 0;
            (0, $gYKPF.state).requests = null;
            fetchPage();
        });
        (0, $TusQn.watch)(searchRequestValue, (newValue, oldValue)=>{
            if (!newValue) (0, $gYKPF.state).searchRequestResult = null;
        });
        const __returned__ = {
            REQUESTS_PER_PAGE: REQUESTS_PER_PAGE,
            router: router,
            showReleased: showReleased,
            loadMoreElement: loadMoreElement,
            isLoadingRequests: isLoadingRequests,
            currentPage: currentPage,
            totalPages: totalPages,
            isLoadingSearchRequest: isLoadingSearchRequest,
            searchRequestValue: searchRequestValue,
            sortRequestValue: sortRequestValue,
            intersectionObserver: intersectionObserver,
            requestsReleaseListIds: requestsReleaseListIds,
            toggleIdFromRequestList: toggleIdFromRequestList,
            options: options,
            fetchRequestsByTitle: fetchRequestsByTitle,
            onFormSubmit: onFormSubmit,
            fetchPage: fetchPage,
            intersectionObserverCallback: intersectionObserverCallback,
            ref: $01W3b.ref,
            computed: $01W3b.computed,
            onMounted: $TusQn.onMounted,
            onBeforeMount: $TusQn.onBeforeMount,
            onBeforeUnmount: $TusQn.onBeforeUnmount,
            watch: $TusQn.watch,
            useRouter: $73mM4.useRouter,
            Header: $h7UQ3.default,
            LikeButton: $lLLhm.default,
            UpdateButton: $7xcgR.default,
            DeleteButton: $8icFV.default,
            NotifyButton: $b9ZaU.default,
            ArrowLongUpIcon: $llL2y.default,
            ArrowLongDownIcon: $3LZFF.default,
            Footer: $38WoH.default,
            Spinner: $9amUO.default,
            Pagination: $4ymtU.default,
            state: $gYKPF.state,
            onUpdateButtonClicked: $gYKPF.onUpdateButtonClicked,
            onDeleteButtonClicked: $gYKPF.onDeleteButtonClicked,
            onReleaseButtonClicked: $gYKPF.onReleaseButtonClicked,
            pushAlert: $gYKPF.pushAlert,
            logUserOut: $gYKPF.logUserOut,
            formatDate: $gGcib.formatDate,
            getToken: $gGcib.getToken
        };
        Object.defineProperty(__returned__, '__isScriptSetup', {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
};

});
parcelRegister("b9ZaU", function(module, exports) {

$parcel$export(module.exports, "default", () => $81fffd08a5b6ef33$export$2e2bcd8739ae039);
let $81fffd08a5b6ef33$var$script;



let $81fffd08a5b6ef33$var$initialize = ()=>{
    $81fffd08a5b6ef33$var$script = (parcelRequire("ljFKc"));
    if ($81fffd08a5b6ef33$var$script.__esModule) $81fffd08a5b6ef33$var$script = $81fffd08a5b6ef33$var$script.default;
    $81fffd08a5b6ef33$var$script.render = (parcelRequire("aS1jF")).render;
    (parcelRequire("71b6i")).default($81fffd08a5b6ef33$var$script);
    $81fffd08a5b6ef33$var$script.__scopeId = 'data-v-8202f8';
    $81fffd08a5b6ef33$var$script.__file = "notifyButton.vue";
};
$81fffd08a5b6ef33$var$initialize();
var $81fffd08a5b6ef33$export$2e2bcd8739ae039 = $81fffd08a5b6ef33$var$script;

});
parcelRegister("ljFKc", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $f84bc0d6591a4902$export$2e2bcd8739ae039);

var $1DCs8 = parcelRequire("1DCs8");
var $fnsWf = parcelRequire("fnsWf");
var $7qZPh = parcelRequire("7qZPh");
var $f84bc0d6591a4902$export$2e2bcd8739ae039 = {
    __name: 'notifyButton',
    props: {
        released: Boolean,
        disable: Boolean
    },
    emits: [
        'notifyButtonClicked'
    ],
    setup (__props, { expose: expose, emit: emits }) {
        expose();
        const props = __props;
        const emitNotifyButtonClicked = ()=>emits('notifyButtonClicked');
        const __returned__ = {
            props: props,
            emits: emits,
            emitNotifyButtonClicked: emitNotifyButtonClicked,
            PaperAirplaneIcon: $fnsWf.default,
            PlusCircleIcon: $7qZPh.default,
            MinusCircleIcon: $1DCs8.default
        };
        Object.defineProperty(__returned__, '__isScriptSetup', {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
};

});
parcelRegister("fnsWf", function(module, exports) {

$parcel$export(module.exports, "default", () => $b31f73974c1a75a6$export$2e2bcd8739ae039);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
function $b31f73974c1a75a6$export$2e2bcd8739ae039(_ctx, _cache) {
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        fill: "currentColor",
        "aria-hidden": "true"
    }, [
        (0, $TusQn.createElementVNode)("path", {
            d: "M3.478 2.405a.75.75 0 00-.926.94l2.432 7.905H13.5a.75.75 0 010 1.5H4.984l-2.432 7.905a.75.75 0 00.926.94 60.519 60.519 0 0018.445-8.986.75.75 0 000-1.218A60.517 60.517 0 003.478 2.405z"
        })
    ]);
}

});

parcelRegister("7qZPh", function(module, exports) {

$parcel$export(module.exports, "default", () => $569aeb82e50735e4$export$2e2bcd8739ae039);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
function $569aeb82e50735e4$export$2e2bcd8739ae039(_ctx, _cache) {
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        fill: "currentColor",
        "aria-hidden": "true"
    }, [
        (0, $TusQn.createElementVNode)("path", {
            "fill-rule": "evenodd",
            d: "M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25zM12.75 9a.75.75 0 00-1.5 0v2.25H9a.75.75 0 000 1.5h2.25V15a.75.75 0 001.5 0v-2.25H15a.75.75 0 000-1.5h-2.25V9z",
            "clip-rule": "evenodd"
        })
    ]);
}

});


parcelRegister("aS1jF", function(module, exports) {

$parcel$export(module.exports, "render", () => $7e9ff7e422761909$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
const $7e9ff7e422761909$var$_hoisted_1 = [
    "disabled"
];
function $7e9ff7e422761909$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("button", {
        class: "hover:pointer hover:scale-110 focus:scale-110 transition-transform duration-150 disabled:hover:scale-100 disabled:opacity-70",
        type: "button",
        "aria-label": "Toggle request from requests list",
        onClick: $setup.emitNotifyButtonClicked,
        disabled: $props.disable
    }, [
        $props.released ? ((0, $TusQn.openBlock)(), (0, $TusQn.createBlock)($setup["MinusCircleIcon"], {
            key: 0,
            class: "h-8 w-8 fill-red-700"
        })) : ((0, $TusQn.openBlock)(), (0, $TusQn.createBlock)($setup["PlusCircleIcon"], {
            key: 1,
            class: "h-8 w-8 fill-green-700"
        }))
    ], 8, $7e9ff7e422761909$var$_hoisted_1);
}

});

parcelRegister("71b6i", function(module, exports) {

$parcel$export(module.exports, "default", () => $51c13cbc7dab5b14$export$2e2bcd8739ae039);
let $51c13cbc7dab5b14$var$NOOP = ()=>{};
var $51c13cbc7dab5b14$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRegister("3LZFF", function(module, exports) {

$parcel$export(module.exports, "default", () => $2bf59975d24901e0$export$2e2bcd8739ae039);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
function $2bf59975d24901e0$export$2e2bcd8739ae039(_ctx, _cache) {
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        fill: "currentColor",
        "aria-hidden": "true"
    }, [
        (0, $TusQn.createElementVNode)("path", {
            "fill-rule": "evenodd",
            d: "M12 2.25a.75.75 0 01.75.75v16.19l2.47-2.47a.75.75 0 111.06 1.06l-3.75 3.75a.75.75 0 01-1.06 0l-3.75-3.75a.75.75 0 111.06-1.06l2.47 2.47V3a.75.75 0 01.75-.75z",
            "clip-rule": "evenodd"
        })
    ]);
}

});

parcelRegister("llL2y", function(module, exports) {

$parcel$export(module.exports, "default", () => $f8b00c539b857dd6$export$2e2bcd8739ae039);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
function $f8b00c539b857dd6$export$2e2bcd8739ae039(_ctx, _cache) {
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        fill: "currentColor",
        "aria-hidden": "true"
    }, [
        (0, $TusQn.createElementVNode)("path", {
            "fill-rule": "evenodd",
            d: "M11.47 2.47a.75.75 0 011.06 0l3.75 3.75a.75.75 0 01-1.06 1.06l-2.47-2.47V21a.75.75 0 01-1.5 0V4.81L8.78 7.28a.75.75 0 01-1.06-1.06l3.75-3.75z",
            "clip-rule": "evenodd"
        })
    ]);
}

});


parcelRegister("6Mqjr", function(module, exports) {

$parcel$export(module.exports, "render", () => $4efba2eb734c0244$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
var $eeJ70 = parcelRequire("eeJ70");
const $4efba2eb734c0244$var$_hoisted_1 = {
    class: "relative min-h-[calc(100vh-70px-144px)] px-5 pt-14 pb-4 sm:min-h-[calc(100vh-60px-144px)] sm:pt-28 lg:px-0"
};
const $4efba2eb734c0244$var$_hoisted_2 = {
    class: "max-w-4xl mx-auto mb-14"
};
const $4efba2eb734c0244$var$_hoisted_3 = {
    class: "sticky top-10 z-10 mb-5 text-right"
};
const $4efba2eb734c0244$var$_hoisted_4 = {
    class: "sm:self-end sm:w-1/2"
};
const $4efba2eb734c0244$var$_hoisted_5 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("label", {
    for: "search"
}, null, -1);
const $4efba2eb734c0244$var$_hoisted_6 = [
    "disabled"
];
const $4efba2eb734c0244$var$_hoisted_7 = {
    class: "self-end"
};
const $4efba2eb734c0244$var$_hoisted_8 = {
    class: "mb-5 flex justify-between"
};
const $4efba2eb734c0244$var$_hoisted_9 = {
    for: "released",
    class: "select-none hover:cursor-pointer"
};
const $4efba2eb734c0244$var$_hoisted_10 = /*#__PURE__*/ (0, $TusQn.createTextVNode)(" released");
const $4efba2eb734c0244$var$_hoisted_11 = {
    class: "relative grid grid-cols-1 w-16 p-1 bg-gray-300 rounded-full has-[:checked]:bg-purple-900 transition-colors"
};
const $4efba2eb734c0244$var$_hoisted_12 = [
    "disabled"
];
const $4efba2eb734c0244$var$_hoisted_13 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("span", {
    class: "pointer-events-none row-start-1 col-start-1 w-5 h-5 rounded-full bg-white peer-checked:translate-x-9 transition-transform"
}, null, -1);
const $4efba2eb734c0244$var$_hoisted_14 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("label", {
    for: "sort"
}, [
    /*#__PURE__*/ (0, $TusQn.createElementVNode)("span", {
        class: "sr-only"
    }, "Sort By")
], -1);
const $4efba2eb734c0244$var$_hoisted_15 = [
    "disabled"
];
const $4efba2eb734c0244$var$_hoisted_16 = /*#__PURE__*/ (0, $TusQn.createStaticVNode)("<option value=\"\" disabled>Sort by</option><option value=\"usersLength-asc\"> Likes Asc </option><option value=\"usersLength-desc\">Likes Desc</option><option value=\"releaseDate-asc\">Released Date Asc</option><option value=\"releaseDate-desc\">Released Date Desc</option>", 5);
const $4efba2eb734c0244$var$_hoisted_21 = [
    $4efba2eb734c0244$var$_hoisted_16
];
const $4efba2eb734c0244$var$_hoisted_22 = {
    key: 0
};
const $4efba2eb734c0244$var$_hoisted_23 = {
    key: 0,
    class: "text-center"
};
const $4efba2eb734c0244$var$_hoisted_24 = {
    key: 1
};
const $4efba2eb734c0244$var$_hoisted_25 = {
    key: 0,
    class: "space-y-10"
};
const $4efba2eb734c0244$var$_hoisted_26 = {
    class: "absolute left-0 -top-5 px-3 py-[2px] text-xs font-medium rounded bg-green-500 empty:hidden"
};
const $4efba2eb734c0244$var$_hoisted_27 = {
    class: "text-left sm:text-right text-xs text-neutral-600"
};
const $4efba2eb734c0244$var$_hoisted_28 = {
    class: "px-5 mb-3 text-lg font-bold text-center sm:pr-20 sm:pl-0 sm:mb-0 sm:text-base sm:text-left"
};
const $4efba2eb734c0244$var$_hoisted_29 = {
    class: "flex gap-x-2 justify-self-end"
};
const $4efba2eb734c0244$var$_hoisted_30 = {
    key: 1,
    class: "text-2xl text-center"
};
const $4efba2eb734c0244$var$_hoisted_31 = {
    key: 2
};
const $4efba2eb734c0244$var$_hoisted_32 = {
    key: 0,
    class: "text-center"
};
const $4efba2eb734c0244$var$_hoisted_33 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("p", {
    class: "mb-8 text-2xl"
}, " No requests made ", -1);
const $4efba2eb734c0244$var$_hoisted_34 = [
    $4efba2eb734c0244$var$_hoisted_33
];
const $4efba2eb734c0244$var$_hoisted_35 = {
    key: 1,
    class: "space-y-10"
};
const $4efba2eb734c0244$var$_hoisted_36 = {
    class: "absolute left-0 -top-5 px-3 py-[2px] text-xs font-medium rounded bg-green-500 empty:hidden"
};
const $4efba2eb734c0244$var$_hoisted_37 = {
    class: "text-left text-xs text-neutral-600 sm:text-center"
};
const $4efba2eb734c0244$var$_hoisted_38 = {
    class: "px-5 text-lg font-bold text-center sm:pr-20 sm:pl-0 sm:text-base sm:text-left"
};
const $4efba2eb734c0244$var$_hoisted_39 = {
    class: "text-right"
};
const $4efba2eb734c0244$var$_hoisted_40 = {
    class: "text-sm"
};
const $4efba2eb734c0244$var$_hoisted_41 = {
    class: "flex gap-x-2 justify-self-end"
};
const $4efba2eb734c0244$var$_hoisted_42 = {
    ref: "loadMoreElement"
};
const $4efba2eb734c0244$var$_hoisted_43 = {
    key: 0,
    class: "mt-7"
};
function $4efba2eb734c0244$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, [
        (0, $TusQn.createVNode)($setup["Header"]),
        (0, $TusQn.createElementVNode)("main", $4efba2eb734c0244$var$_hoisted_1, [
            (0, $TusQn.createElementVNode)("div", $4efba2eb734c0244$var$_hoisted_2, [
                (0, $TusQn.createElementVNode)("div", $4efba2eb734c0244$var$_hoisted_3, [
                    (0, $TusQn.createElementVNode)("button", {
                        class: "px-4 py-2 rounded-md bg-purple-900 text-white",
                        type: "button",
                        onClick: _cache[0] || (_cache[0] = (...args)=>$setup.onReleaseButtonClicked && $setup.onReleaseButtonClicked(...args))
                    }, " Email Requesters ")
                ]),
                (0, $TusQn.createElementVNode)("form", {
                    class: "flex flex-col-reverse justify-between gap-5 mb-20 sm:flex-row",
                    onSubmit: $setup.onFormSubmit
                }, [
                    (0, $TusQn.createElementVNode)("fieldset", $4efba2eb734c0244$var$_hoisted_4, [
                        $4efba2eb734c0244$var$_hoisted_5,
                        (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                            class: "w-full border-0 border-b-2 focus:border-b-purple-800 focus:ring-transparent",
                            type: "search",
                            name: "search",
                            id: "search",
                            placeholder: "search request...",
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event)=>$setup.searchRequestValue = $event),
                            disabled: $setup.isLoadingRequests
                        }, null, 8, $4efba2eb734c0244$var$_hoisted_6), [
                            [
                                (0, $eeJ70.vModelText),
                                $setup.searchRequestValue
                            ]
                        ])
                    ]),
                    (0, $TusQn.createElementVNode)("div", $4efba2eb734c0244$var$_hoisted_7, [
                        (0, $TusQn.createElementVNode)("fieldset", $4efba2eb734c0244$var$_hoisted_8, [
                            (0, $TusQn.createElementVNode)("label", $4efba2eb734c0244$var$_hoisted_9, [
                                (0, $TusQn.createElementVNode)("strong", null, (0, $8POXm.toDisplayString)($setup.showReleased ? 'Hide' : 'Show'), 1),
                                $4efba2eb734c0244$var$_hoisted_10
                            ]),
                            (0, $TusQn.createElementVNode)("div", $4efba2eb734c0244$var$_hoisted_11, [
                                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                                    id: "released",
                                    class: "w-full peer row-start-1 col-start-1 ring-0 border-0 opacity-0 focus:ring-0",
                                    type: "checkbox",
                                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event)=>$setup.showReleased = $event),
                                    disabled: !!$setup.searchRequestValue
                                }, null, 8, $4efba2eb734c0244$var$_hoisted_12), [
                                    [
                                        (0, $eeJ70.vModelCheckbox),
                                        $setup.showReleased
                                    ]
                                ]),
                                $4efba2eb734c0244$var$_hoisted_13
                            ])
                        ]),
                        (0, $TusQn.createElementVNode)("fieldset", null, [
                            $4efba2eb734c0244$var$_hoisted_14,
                            (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("select", {
                                class: "rounded focus:ring-purple-800 focus:border-purple-800",
                                name: "sort",
                                id: "sort",
                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event)=>$setup.sortRequestValue = $event),
                                disabled: $setup.isLoadingRequests || !!$setup.searchRequestValue
                            }, $4efba2eb734c0244$var$_hoisted_21, 8, $4efba2eb734c0244$var$_hoisted_15), [
                                [
                                    (0, $eeJ70.vModelSelect),
                                    $setup.sortRequestValue
                                ]
                            ])
                        ])
                    ])
                ], 32),
                $setup.currentPage > 0 ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $4efba2eb734c0244$var$_hoisted_22, [
                    $setup.isLoadingSearchRequest ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("p", $4efba2eb734c0244$var$_hoisted_23, " Searching... ")) : $setup.state.searchRequestResult ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $4efba2eb734c0244$var$_hoisted_24, [
                        !!$setup.state.searchRequestResult.length ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("ul", $4efba2eb734c0244$var$_hoisted_25, [
                            ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($setup.state.searchRequestResult, (request)=>{
                                return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("li", {
                                    class: "relative grid gap-x-3 gap-y-4 p-2 rounded shadow-[0_0_3px_rgb(0,0,0)] sm:grid-cols-[64px_1fr_auto] sm:items-center sm:bg-transparent odd:bg-purple-100 sm:shadow-[0_0_2px_rgb(0,0,0)]",
                                    key: request._id
                                }, [
                                    (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("span", $4efba2eb734c0244$var$_hoisted_26, " released ", 512), [
                                        [
                                            (0, $eeJ70.vShow),
                                            request.released && request.url
                                        ]
                                    ]),
                                    (0, $TusQn.createElementVNode)("span", $4efba2eb734c0244$var$_hoisted_27, (0, $8POXm.toDisplayString)($setup.formatDate(request.createdAt)), 1),
                                    (0, $TusQn.createElementVNode)("span", $4efba2eb734c0244$var$_hoisted_28, (0, $8POXm.toDisplayString)(request.title), 1),
                                    (0, $TusQn.createElementVNode)("div", $4efba2eb734c0244$var$_hoisted_29, [
                                        (0, $TusQn.createVNode)($setup["UpdateButton"], {
                                            "is-disabled": !$setup.state.user?.admin,
                                            onUpdateButtonClicked: ()=>$setup.onUpdateButtonClicked(request)
                                        }, null, 8, [
                                            "is-disabled",
                                            "onUpdateButtonClicked"
                                        ]),
                                        (0, $TusQn.createVNode)($setup["DeleteButton"], {
                                            "is-disabled": !$setup.state.user?.admin,
                                            onDeleteButtonClicked: ()=>$setup.onDeleteButtonClicked(request)
                                        }, null, 8, [
                                            "is-disabled",
                                            "onDeleteButtonClicked"
                                        ])
                                    ])
                                ]);
                            }), 128))
                        ])) : ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("p", $4efba2eb734c0244$var$_hoisted_30, " No result found... "))
                    ])) : ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $4efba2eb734c0244$var$_hoisted_31, [
                        !$setup.state.requests?.length ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $4efba2eb734c0244$var$_hoisted_32, $4efba2eb734c0244$var$_hoisted_34)) : ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("ul", $4efba2eb734c0244$var$_hoisted_35, [
                            ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($setup.state.requests, (request)=>{
                                return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("li", {
                                    class: "relative grid grid-rows-3 grid-cols-1 justify-between items-center gap-y-2 p-2 rounded odd:bg-purple-100 sm:grid-rows-1 sm:grid-cols-[64px_1fr_auto_auto] sm:gap-x-5 shadow-[0_0_3px_rgb(0,0,0)] sm:shadow-[0_0_2px_rgb(0,0,0)]",
                                    key: request._id
                                }, [
                                    (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("span", $4efba2eb734c0244$var$_hoisted_36, " Released ", 512), [
                                        [
                                            (0, $eeJ70.vShow),
                                            request.released
                                        ]
                                    ]),
                                    (0, $TusQn.createElementVNode)("span", $4efba2eb734c0244$var$_hoisted_37, (0, $8POXm.toDisplayString)($setup.formatDate(request.releaseDate) ?? 'NA'), 1),
                                    (0, $TusQn.createElementVNode)("span", $4efba2eb734c0244$var$_hoisted_38, (0, $8POXm.toDisplayString)(request.title), 1),
                                    (0, $TusQn.createElementVNode)("div", $4efba2eb734c0244$var$_hoisted_39, [
                                        (0, $TusQn.createElementVNode)("span", $4efba2eb734c0244$var$_hoisted_40, (0, $8POXm.toDisplayString)(request.users.length - 1), 1)
                                    ]),
                                    (0, $TusQn.createElementVNode)("div", $4efba2eb734c0244$var$_hoisted_41, [
                                        (0, $TusQn.createVNode)($setup["UpdateButton"], {
                                            "is-disabled": !$setup.state.user?.admin,
                                            onUpdateButtonClicked: ()=>$setup.onUpdateButtonClicked(request)
                                        }, null, 8, [
                                            "is-disabled",
                                            "onUpdateButtonClicked"
                                        ]),
                                        (0, $TusQn.createVNode)($setup["DeleteButton"], {
                                            "is-disabled": !$setup.state.user?.admin,
                                            onDeleteButtonClicked: ()=>$setup.onDeleteButtonClicked(request)
                                        }, null, 8, [
                                            "is-disabled",
                                            "onDeleteButtonClicked"
                                        ]),
                                        (0, $TusQn.createVNode)($setup["NotifyButton"], {
                                            released: $setup.requestsReleaseListIds.includes(request._id),
                                            onNotifyButtonClicked: ()=>$setup.toggleIdFromRequestList(request._id, request.title)
                                        }, null, 8, [
                                            "released",
                                            "onNotifyButtonClicked"
                                        ])
                                    ])
                                ]);
                            }), 128))
                        ]))
                    ]))
                ])) : (0, $TusQn.createCommentVNode)("", true),
                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("div", $4efba2eb734c0244$var$_hoisted_42, [
                    $setup.isLoadingRequests ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $4efba2eb734c0244$var$_hoisted_43, [
                        (0, $TusQn.createVNode)($setup["Spinner"])
                    ])) : ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("button", {
                        key: 1,
                        class: "block mx-auto mt-5 px-4 py-2 rounded-md bg-green-700 text-white",
                        onClick: _cache[4] || (_cache[4] = ($event)=>$setup.fetchPage($setup.currentPage + 1)),
                        type: "submit"
                    }, " Load More "))
                ], 512), [
                    [
                        (0, $eeJ70.vShow),
                        !$setup.searchRequestValue && $setup.currentPage !== $setup.totalPages && !!$setup.totalPages
                    ]
                ])
            ])
        ]),
        (0, $TusQn.createVNode)($setup["Footer"])
    ], 64);
}

});

parcelRegister("9cP39", function(module, exports) {

$parcel$export(module.exports, "default", () => $6b3cd575c32418eb$export$2e2bcd8739ae039);
let $6b3cd575c32418eb$var$NOOP = ()=>{};
var $6b3cd575c32418eb$export$2e2bcd8739ae039 = (script)=>{};

});

parcelRegister("e5lSE", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $a41281577e7bfb8e$export$2e2bcd8739ae039);
parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");

var $73mM4 = parcelRequire("73mM4");

var $gYKPF = parcelRequire("gYKPF");

var $gGcib = parcelRequire("gGcib");

var $h7UQ3 = parcelRequire("h7UQ3");
var $a41281577e7bfb8e$export$2e2bcd8739ae039 = {
    __name: 'subscription',
    setup (__props, { expose: expose }) {
        expose();
        const route = (0, $73mM4.useRoute)();
        const emailOptInValue = (0, $01W3b.ref)(route.query.emailOptIn);
        async function onFormSubmit(event) {
            event.preventDefault();
            try {
                const options = {
                    method: "PATCH",
                    body: JSON.stringify({
                        email: route.query.email,
                        emailOptIn: emailOptInValue.value
                    }),
                    headers: {
                        'Content-Type': 'application/json'
                    }
                };
                const response = await fetch(`${"https://scrapbook-concierge-requests-api-cr45w.ondigitalocean.app"}/notifications/subscriptions`, options);
                const result = await response.json();
                if (response.ok) {
                    // console.log( result );
                    if (result.emailOptIn === 'true') (0, $gYKPF.pushAlert)('success', 'Successfully opt in email notifications.');
                    else (0, $gYKPF.pushAlert)('success', 'Successfully opt out of email notifications.');
                } else if (response.status === 429) (0, $gYKPF.pushAlert)('failure', result.message);
                else (0, $gYKPF.pushAlert)('failure', result.message);
            } catch (error) {
                console.warn(error);
                (0, $gYKPF.pushAlert)('failure', 'An Error occurred while changing email subscription status. Try again later.');
            }
        }
        const __returned__ = {
            route: route,
            emailOptInValue: emailOptInValue,
            onFormSubmit: onFormSubmit,
            ref: $01W3b.ref,
            useRoute: $73mM4.useRoute,
            pushAlert: $gYKPF.pushAlert,
            getToken: $gGcib.getToken,
            Header: $h7UQ3.default
        };
        Object.defineProperty(__returned__, '__isScriptSetup', {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
};

});

parcelRegister("hFbZ9", function(module, exports) {

$parcel$export(module.exports, "render", () => $cdbf900c8f624207$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $eeJ70 = parcelRequire("eeJ70");
const $cdbf900c8f624207$var$_hoisted_1 = {
    class: "min-h-[calc(100vh-70px)] px-5 py-14 sm:min-h-[calc(100vh-60px)] sm:py-20 lg:px-0"
};
const $cdbf900c8f624207$var$_hoisted_2 = {
    class: "max-w-3xl mx-auto mb-14"
};
const $cdbf900c8f624207$var$_hoisted_3 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("h2", {
    class: "mb-5 text-xl font-bold sm:text-2xl"
}, "I want to receive:", -1);
const $cdbf900c8f624207$var$_hoisted_4 = {
    class: "p-4 mb-5 flex border border-purple-800 sm:mb-8"
};
const $cdbf900c8f624207$var$_hoisted_5 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("label", {
    for: "emailOptIn"
}, [
    /*#__PURE__*/ (0, $TusQn.createElementVNode)("span", {
        class: "block mb-1 text-lg font-semibold"
    }, " Email me when requests I'm interested in are released. "),
    /*#__PURE__*/ (0, $TusQn.createElementVNode)("span", null, " If this box is checked, please note that you'll continue to receive emails containing the list of the scrapbook kits that you either requested or liked whenever they are released. ")
], -1);
const $cdbf900c8f624207$var$_hoisted_6 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("button", {
    class: "px-5 py-2 bg-purple-800 text-white font-bold rounded",
    type: "submit"
}, " Save ", -1);
function $cdbf900c8f624207$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, [
        (0, $TusQn.createVNode)($setup["Header"]),
        (0, $TusQn.createElementVNode)("main", $cdbf900c8f624207$var$_hoisted_1, [
            (0, $TusQn.createElementVNode)("div", $cdbf900c8f624207$var$_hoisted_2, [
                (0, $TusQn.createElementVNode)("form", {
                    onSubmit: $setup.onFormSubmit
                }, [
                    $cdbf900c8f624207$var$_hoisted_3,
                    (0, $TusQn.createElementVNode)("fieldset", $cdbf900c8f624207$var$_hoisted_4, [
                        (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                            class: "w-5 h-5 mr-3 text-purple-800 ring-purple-800 active:ring-purple-800 focus:ring-purple-800",
                            type: "checkbox",
                            id: "emailOptIn",
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event)=>$setup.emailOptInValue = $event)
                        }, null, 512), [
                            [
                                (0, $eeJ70.vModelCheckbox),
                                $setup.emailOptInValue
                            ]
                        ]),
                        $cdbf900c8f624207$var$_hoisted_5
                    ]),
                    $cdbf900c8f624207$var$_hoisted_6
                ], 32)
            ])
        ])
    ], 64);
}

});

parcelRegister("aPfiU", function(module, exports) {

$parcel$export(module.exports, "default", () => $7e1a89d5eb7af6be$export$2e2bcd8739ae039);
let $7e1a89d5eb7af6be$var$NOOP = ()=>{};
var $7e1a89d5eb7af6be$export$2e2bcd8739ae039 = (script)=>{};

});

parcelRegister("bMVAb", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $8950d81f6c568d7e$export$2e2bcd8739ae039);

var $73mM4 = parcelRequire("73mM4");

var $h7UQ3 = parcelRequire("h7UQ3");

var $38WoH = parcelRequire("38WoH");
var $8950d81f6c568d7e$export$2e2bcd8739ae039 = {
    __name: 'privacy-policy',
    setup (__props, { expose: expose }) {
        expose();
        const router = (0, $73mM4.useRouter)();
        const __returned__ = {
            router: router,
            useRouter: $73mM4.useRouter,
            Header: $h7UQ3.default,
            Footer: $38WoH.default
        };
        Object.defineProperty(__returned__, '__isScriptSetup', {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
};

});

parcelRegister("iHUIm", function(module, exports) {

$parcel$export(module.exports, "render", () => $d9e83c7ab17dfff8$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
const $d9e83c7ab17dfff8$var$_hoisted_1 = /*#__PURE__*/ (0, $TusQn.createStaticVNode)('<main class="max-w-5xl mx-auto px-4 py-14"><h1 class="mb-5 text-2xl font-bold sm:mb-8 sm:text-3xl lg:text-4xl">Privacy Policy</h1><p>Last updated: September 02, 2024</p><p>This Privacy Policy describes Our policies and procedures on the collection, use and disclosure of Your information when You use the Service and tells You about Your privacy rights and how the law protects You.</p><p>We use Your Personal data to provide and improve the Service. By using the Service, You agree to the collection and use of information in accordance with this Privacy Policy. This Privacy Policy has been created with the help of the <a href="https://www.freeprivacypolicy.com/free-privacy-policy-generator/" target="_blank">Free Privacy Policy Generator</a>.</p><div><h2 class="my-2 text-xl font-bold sm:my-4 sm:text-2xl lg:text-3xl">Interpretation and Definitions</h2><h3 class="my-1 text-lg font-bold sm:my-2 sm:text-xl lg:text-2xl">Interpretation</h3><p>The words of which the initial letter is capitalized have meanings defined under the following conditions. The following definitions shall have the same meaning regardless of whether they appear in singular or in plural.</p><h3 class="my-1 text-lg font-bold sm:my-2 sm:text-xl lg:text-2xl">Definitions</h3><p>For the purposes of this Privacy Policy:</p><ul class="ml-8 list-disc space-y-1"><li><p><strong>Account</strong> means a unique account created for You to access our Service or parts of our Service.</p></li><li><p><strong>Affiliate</strong> means an entity that controls, is controlled by or is under common control with a party, where &quot;control&quot; means ownership of 50% or more of the shares, equity interest or other securities entitled to vote for election of directors or other managing authority.</p></li><li><p><strong>Application</strong> refers to Scrapbook Concierge Requests, the software program provided by the Company.</p></li><li><p><strong>Company</strong> (referred to as either &quot;the Company&quot;, &quot;We&quot;, &quot;Us&quot; or &quot;Our&quot; in this Agreement) refers to Scrapbook Concierge Requests.</p></li><li><p><strong>Country</strong> refers to: Maryland, United States</p></li><li><p><strong>Device</strong> means any device that can access the Service such as a computer, a cellphone or a digital tablet.</p></li><li><p><strong>Personal Data</strong> is any information that relates to an identified or identifiable individual.</p></li><li><p><strong>Service</strong> refers to the Application.</p></li><li><p><strong>Service Provider</strong> means any natural or legal person who processes the data on behalf of the Company. It refers to third-party companies or individuals employed by the Company to facilitate the Service, to provide the Service on behalf of the Company, to perform services related to the Service or to assist the Company in analyzing how the Service is used.</p></li><li><p><strong>Third-party Social Media Service</strong> refers to any website or any social network website through which a User can log in or create an account to use the Service.</p></li><li><p><strong>Usage Data</strong> refers to data collected automatically, either generated by the use of the Service or from the Service infrastructure itself (for example, the duration of a page visit).</p></li><li><p><strong>You</strong> means the individual accessing or using the Service, or the company, or other legal entity on behalf of which such individual is accessing or using the Service, as applicable.</p></li></ul></div><div><h2 class="my-2 text-xl font-bold sm:my-4 sm:text-2xl lg:text-3xl">Collecting and Using Your Personal Data</h2><h3 class="my-1 text-lg font-bold sm:my-2 sm:text-xl lg:text-2xl">Types of Data Collected</h3><h4>Personal Data</h4><p>While using Our Service, We may ask You to provide Us with certain personally identifiable information that can be used to contact or identify You. Personally identifiable information may include, but is not limited to:</p><ul class="ml-8 list-disc space-y-1"><li><p>Email address</p></li><li><p>First name and last name</p></li><li><p>Usage Data</p></li></ul><h4>Usage Data</h4><p>Usage Data is collected automatically when using the Service.</p><p>Usage Data may include information such as Your Device&#39;s Internet Protocol address (e.g. IP address), browser type, browser version, the pages of our Service that You visit, the time and date of Your visit, the time spent on those pages, unique device identifiers and other diagnostic data.</p><p>When You access the Service by or through a mobile device, We may collect certain information automatically, including, but not limited to, the type of mobile device You use, Your mobile device unique ID, the IP address of Your mobile device, Your mobile operating system, the type of mobile Internet browser You use, unique device identifiers and other diagnostic data.</p><p>We may also collect information that Your browser sends whenever You visit our Service or when You access the Service by or through a mobile device.</p><h4>Information from Third-Party Social Media Services</h4><p>The Company allows You to create an account and log in to use the Service through the following Third-party Social Media Services:</p><ul class="ml-8 list-disc space-y-1"><li>Google</li><li>Facebook</li><li>Instagram</li><li>Twitter</li><li>LinkedIn</li></ul><p>If You decide to register through or otherwise grant us access to a Third-Party Social Media Service, We may collect Personal data that is already associated with Your Third-Party Social Media Service&#39;s account, such as Your name, Your email address, Your activities or Your contact list associated with that account.</p><p>You may also have the option of sharing additional information with the Company through Your Third-Party Social Media Service&#39;s account. If You choose to provide such information and Personal Data, during registration or otherwise, You are giving the Company permission to use, share, and store it in a manner consistent with this Privacy Policy.</p><h3 class="my-1 text-lg font-bold sm:my-2 sm:text-xl lg:text-2xl">Use of Your Personal Data</h3><p>The Company may use Personal Data for the following purposes:</p><ul class="ml-8 list-disc space-y-1"><li><p><strong>To provide and maintain our Service</strong>, including to monitor the usage of our Service.</p></li><li><p><strong>To manage Your Account:</strong> to manage Your registration as a user of the Service. The Personal Data You provide can give You access to different functionalities of the Service that are available to You as a registered user.</p></li><li><p><strong>For the performance of a contract:</strong> the development, compliance and undertaking of the purchase contract for the products, items or services You have purchased or of any other contract with Us through the Service.</p></li><li><p><strong>To contact You:</strong> To contact You by email, telephone calls, SMS, or other equivalent forms of electronic communication, such as a mobile application&#39;s push notifications regarding updates or informative communications related to the functionalities, products or contracted services, including the security updates, when necessary or reasonable for their implementation.</p></li><li><p><strong>To provide You</strong> with news, special offers and general information about other goods, services and events which we offer that are similar to those that you have already purchased or enquired about unless You have opted not to receive such information.</p></li><li><p><strong>To manage Your requests:</strong> To attend and manage Your requests to Us.</p></li><li><p><strong>For business transfers:</strong> We may use Your information to evaluate or conduct a merger, divestiture, restructuring, reorganization, dissolution, or other sale or transfer of some or all of Our assets, whether as a going concern or as part of bankruptcy, liquidation, or similar proceeding, in which Personal Data held by Us about our Service users is among the assets transferred.</p></li><li><p><strong>For other purposes</strong>: We may use Your information for other purposes, such as data analysis, identifying usage trends, determining the effectiveness of our promotional campaigns and to evaluate and improve our Service, products, services, marketing and your experience.</p></li></ul><p>We may share Your personal information in the following situations:</p><ul class="ml-8 list-disc space-y-1"><li><strong>With Service Providers:</strong> We may share Your personal information with Service Providers to monitor and analyze the use of our Service, to contact You. </li><li><strong>For business transfers:</strong> We may share or transfer Your personal information in connection with, or during negotiations of, any merger, sale of Company assets, financing, or acquisition of all or a portion of Our business to another company. </li><li><strong>With Affiliates:</strong> We may share Your information with Our affiliates, in which case we will require those affiliates to honor this Privacy Policy. Affiliates include Our parent company and any other subsidiaries, joint venture partners or other companies that We control or that are under common control with Us. </li><li><strong>With business partners:</strong> We may share Your information with Our business partners to offer You certain products, services or promotions. </li><li><strong>With other users:</strong> when You share personal information or otherwise interact in the public areas with other users, such information may be viewed by all users and may be publicly distributed outside. If You interact with other users or register through a Third-Party Social Media Service, Your contacts on the Third-Party Social Media Service may see Your name, profile, pictures and description of Your activity. Similarly, other users will be able to view descriptions of Your activity, communicate with You and view Your profile. </li><li><strong>With Your consent</strong>: We may disclose Your personal information for any other purpose with Your consent. </li></ul><h3 class="my-1 text-lg font-bold sm:my-2 sm:text-xl lg:text-2xl">Retention of Your Personal Data</h3><p>The Company will retain Your Personal Data only for as long as is necessary for the purposes set out in this Privacy Policy. We will retain and use Your Personal Data to the extent necessary to comply with our legal obligations (for example, if we are required to retain your data to comply with applicable laws), resolve disputes, and enforce our legal agreements and policies.</p><p>The Company will also retain Usage Data for internal analysis purposes. Usage Data is generally retained for a shorter period of time, except when this data is used to strengthen the security or to improve the functionality of Our Service, or We are legally obligated to retain this data for longer time periods.</p><h3 class="my-1 text-lg font-bold sm:my-2 sm:text-xl lg:text-2xl">Transfer of Your Personal Data</h3><p>Your information, including Personal Data, is processed at the Company&#39;s operating offices and in any other places where the parties involved in the processing are located. It means that this information may be transferred to \u2014 and maintained on \u2014 computers located outside of Your state, province, country or other governmental jurisdiction where the data protection laws may differ than those from Your jurisdiction.</p><p>Your consent to this Privacy Policy followed by Your submission of such information represents Your agreement to that transfer.</p><p>The Company will take all steps reasonably necessary to ensure that Your data is treated securely and in accordance with this Privacy Policy and no transfer of Your Personal Data will take place to an organization or a country unless there are adequate controls in place including the security of Your data and other personal information.</p><h3 class="my-1 text-lg font-bold sm:my-2 sm:text-xl lg:text-2xl">Delete Your Personal Data</h3><p>You have the right to delete or request that We assist in deleting the Personal Data that We have collected about You.</p><p>Our Service may give You the ability to delete certain information about You from within the Service.</p><p>You may update, amend, or delete Your information at any time by signing in to Your Account, if you have one, and visiting the account settings section that allows you to manage Your personal information. You may also contact Us to request access to, correct, or delete any personal information that You have provided to Us.</p><p>Please note, however, that We may need to retain certain information when we have a legal obligation or lawful basis to do so.</p><h3 class="my-1 text-lg font-bold sm:my-2 sm:text-xl lg:text-2xl">Disclosure of Your Personal Data</h3><h4>Business Transactions</h4><p>If the Company is involved in a merger, acquisition or asset sale, Your Personal Data may be transferred. We will provide notice before Your Personal Data is transferred and becomes subject to a different Privacy Policy.</p><h4>Law enforcement</h4><p>Under certain circumstances, the Company may be required to disclose Your Personal Data if required to do so by law or in response to valid requests by public authorities (e.g. a court or a government agency).</p><h4>Other legal requirements</h4><p>The Company may disclose Your Personal Data in the good faith belief that such action is necessary to:</p><ul class="ml-8 list-disc space-y-1"><li>Comply with a legal obligation</li><li>Protect and defend the rights or property of the Company</li><li>Prevent or investigate possible wrongdoing in connection with the Service</li><li>Protect the personal safety of Users of the Service or the public</li><li>Protect against legal liability</li></ul><h3 class="my-1 text-lg font-bold sm:my-2 sm:text-xl lg:text-2xl">Security of Your Personal Data</h3><p>The security of Your Personal Data is important to Us, but remember that no method of transmission over the Internet, or method of electronic storage is 100% secure. While We strive to use commercially acceptable means to protect Your Personal Data, We cannot guarantee its absolute security.</p></div><div><h2 class="my-2 text-xl font-bold sm:my-4 sm:text-2xl lg:text-3xl">Children&#39;s Privacy</h2><p>Our Service does not address anyone under the age of 13. We do not knowingly collect personally identifiable information from anyone under the age of 13. If You are a parent or guardian and You are aware that Your child has provided Us with Personal Data, please contact Us. If We become aware that We have collected Personal Data from anyone under the age of 13 without verification of parental consent, We take steps to remove that information from Our servers.</p><p>If We need to rely on consent as a legal basis for processing Your information and Your country requires consent from a parent, We may require Your parent&#39;s consent before We collect and use that information.</p></div><div><h2 class="my-2 text-xl font-bold sm:my-4 sm:text-2xl lg:text-3xl">Links to Other Websites</h2><p>Our Service may contain links to other websites that are not operated by Us. If You click on a third party link, You will be directed to that third party&#39;s site. We strongly advise You to review the Privacy Policy of every site You visit.</p><p>We have no control over and assume no responsibility for the content, privacy policies or practices of any third party sites or services.</p><h2 class="my-2 text-xl font-bold sm:my-4 sm:text-2xl lg:text-3xl">Changes to this Privacy Policy</h2><p>We may update Our Privacy Policy from time to time. We will notify You of any changes by posting the new Privacy Policy on this page.</p><p>We will let You know via email and/or a prominent notice on Our Service, prior to the change becoming effective and update the &quot;Last updated&quot; date at the top of this Privacy Policy.</p><p>You are advised to review this Privacy Policy periodically for any changes. Changes to this Privacy Policy are effective when they are posted on this page.</p></div><div><h2 class="my-2 text-xl font-bold sm:my-4 sm:text-2xl lg:text-3xl">Contact Us</h2><p>If you have any questions about this Privacy Policy, You can contact us:</p><ul class="ml-8 list-disc space-y-1"><li><a class="break-words" href="mailto:support@scrapbookconciergerequests.com">support@scrapbookconciergerequests.com</a></li><li><p>By visiting this page on our website: <a class="break-words" href="https://www.scrapbookconciergerequests.com/" rel="external nofollow noopener" target="_blank">https://www.scrapbookconciergerequests.com/</a></p></li></ul></div></main>', 1);
function $d9e83c7ab17dfff8$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, [
        (0, $TusQn.createVNode)($setup["Header"]),
        $d9e83c7ab17dfff8$var$_hoisted_1,
        (0, $TusQn.createVNode)($setup["Footer"])
    ], 64);
}

});

parcelRegister("b3z1z", function(module, exports) {

$parcel$export(module.exports, "default", () => $80cb24a47abb4135$export$2e2bcd8739ae039);
let $80cb24a47abb4135$var$NOOP = ()=>{};
var $80cb24a47abb4135$export$2e2bcd8739ae039 = (script)=>{};

});

parcelRegister("k0zMP", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $e90f9131a52eeb1d$export$2e2bcd8739ae039);
parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");
var $TusQn = parcelRequire("TusQn");

var $73mM4 = parcelRequire("73mM4");

var $h7UQ3 = parcelRequire("h7UQ3");

var $38WoH = parcelRequire("38WoH");

var $gGcib = parcelRequire("gGcib");

var $gYKPF = parcelRequire("gYKPF");
var $e90f9131a52eeb1d$export$2e2bcd8739ae039 = {
    __name: 'terms',
    setup (__props, { expose: expose }) {
        expose();
        const router = (0, $73mM4.useRouter)();
        const __returned__ = {
            router: router,
            ref: $01W3b.ref,
            computed: $01W3b.computed,
            onMounted: $TusQn.onMounted,
            watch: $TusQn.watch,
            onBeforeUnmount: $TusQn.onBeforeUnmount,
            onBeforeMount: $TusQn.onBeforeMount,
            useRouter: $73mM4.useRouter,
            Header: $h7UQ3.default,
            Footer: $38WoH.default,
            formatDate: $gGcib.formatDate,
            getToken: $gGcib.getToken,
            state: $gYKPF.state,
            onMakeRequestButtonClick: $gYKPF.onMakeRequestButtonClick,
            onLikeButtonClicked: $gYKPF.onLikeButtonClicked,
            logUserOut: $gYKPF.logUserOut,
            pushAlert: $gYKPF.pushAlert
        };
        Object.defineProperty(__returned__, '__isScriptSetup', {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
};

});

parcelRegister("ePn5k", function(module, exports) {

$parcel$export(module.exports, "render", () => $acb7bc4e6d48ff3f$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
const $acb7bc4e6d48ff3f$var$_hoisted_1 = {
    class: "max-w-5xl mx-auto px-4 py-14"
};
const $acb7bc4e6d48ff3f$var$_hoisted_2 = /*#__PURE__*/ (0, $TusQn.createStaticVNode)('<h1 class="mb-5 text-2xl font-bold sm:mb-8 sm:text-3xl lg:text-4xl">Terms and conditions</h1><p>These terms and conditions (\u201CAgreement\u201D) set forth the general terms and conditions of your use of the <a href="https://www.scrapbookconciergerequests.com">scrapbookconciergerequests.com</a> website (\u201CWebsite\u201D or \u201CService\u201D) and any of its related products and services (collectively, \u201CServices\u201D). This Agreement is legally binding between you (\u201CUser\u201D, \u201Cyou\u201D or \u201Cyour\u201D) and this Website operator (\u201COperator\u201D, \u201Cwe\u201D, \u201Cus\u201D or \u201Cour\u201D). If you are entering into this Agreement on behalf of a business or other legal entity, you represent that you have the authority to bind such entity to this Agreement, in which case the terms \u201CUser\u201D, \u201Cyou\u201D or \u201Cyour\u201D shall refer to such entity. If you do not have such authority, or if you do not agree with the terms of this Agreement, you must not accept this Agreement and may not access and use the Website and Services. By accessing and using the Website and Services, you acknowledge that you have read, understood, and agree to be bound by the terms of this Agreement. You acknowledge that this Agreement is a contract between you and the Operator, even though it is electronic and is not physically signed by you, and it governs your use of the Website and Services.</p><div class="toc"><h3 class="my-1 text-lg font-bold sm:my-2 sm:text-xl lg:text-2xl">Table of contents</h3><ol class="ml-8 list-disc"><li><a href="#accounts-and-membership">Accounts and membership</a></li><li><a href="#user-content">User content</a></li><li><a href="#backups">Backups</a></li><li><a href="#links-to-other-resources">Links to other resources</a></li><li><a href="#changes-and-amendments">Changes and amendments</a></li><li><a href="#acceptance-of-these-terms">Acceptance of these terms</a></li><li><a href="#contacting-us">Contacting us</a></li></ol></div><div><h2 class="my-1 text-lg font-bold sm:my-2 sm:text-xl lg:text-2xl" id="accounts-and-membership">Accounts and membership</h2><p>You must be at least 13 years of age to use the Website and Services. By using the Website and Services and by agreeing to this Agreement you warrant and represent that you are at least 13 years of age. If you create an account on the Website, you are responsible for maintaining the security of your account and you are fully responsible for all activities that occur under the account and any other actions taken in connection with it. We may monitor and review new accounts before you may sign in and start using the Services. Providing false contact information of any kind may result in the termination of your account. You must immediately notify us of any unauthorized uses of your account or any other breaches of security. We will not be liable for any acts or omissions by you, including any damages of any kind incurred as a result of such acts or omissions. We may suspend, disable, or delete your account (or any part thereof) if we determine that you have violated any provision of this Agreement or that your conduct or content would tend to damage our reputation and goodwill. If we delete your account for the foregoing reasons, you may not re-register for our Services. We may block your email address and Internet protocol address to prevent further registration.</p></div><div><h2 class="my-1 text-lg font-bold sm:my-2 sm:text-xl lg:text-2xl" id="user-content">User content</h2><p>We do not own any data, information or material (collectively, \u201CContent\u201D) that you submit on the Website in the course of using the Service. You shall have sole responsibility for the accuracy, quality, integrity, legality, reliability, appropriateness, and intellectual property ownership or right to use of all submitted Content. We may, but have no obligation to, monitor and review the Content on the Website submitted or created using our Services by you. You grant us permission to access, copy, distribute, store, transmit, reformat, display and perform the Content of your user account solely as required for the purpose of providing the Services to you. Without limiting any of those representations or warranties, we have the right, though not the obligation, to, in our own sole discretion, refuse or remove any Content that, in our reasonable opinion, violates any of our policies or is in any way harmful or objectionable. You also grant us the license to use, reproduce, adapt, modify, publish or distribute the Content created by you or stored in your user account for commercial, marketing or any similar purpose.</p></div><div><h2 class="my-1 text-lg font-bold sm:my-2 sm:text-xl lg:text-2xl" id="backups">Backups</h2><p>We are not responsible for the Content residing on the Website. In no event shall we be held liable for any loss of any Content. It is your sole responsibility to maintain appropriate backup of your Content. Notwithstanding the foregoing, on some occasions and in certain circumstances, with absolutely no obligation, we may be able to restore some or all of your data that has been deleted as of a certain date and time when we may have backed up data for our own purposes. We make no guarantee that the data you need will be available.</p></div><div><h2 class="my-1 text-lg font-bold sm:my-2 sm:text-xl lg:text-2xl" id="links-to-other-resources">Links to other resources</h2><p>Although the Website and Services may link to other resources (such as websites, mobile applications, etc.), we are not, directly or indirectly, implying any approval, association, sponsorship, endorsement, or affiliation with any linked resource, unless specifically stated herein. We are not responsible for examining or evaluating, and we do not warrant the offerings of, any businesses or individuals or the content of their resources. We do not assume any responsibility or liability for the actions, products, services, and content of any other third parties. You should carefully review the legal statements and other conditions of use of any resource which you access through a link on the Website. Your linking to any other off-site resources is at your own risk.</p></div><div><h2 class="my-1 text-lg font-bold sm:my-2 sm:text-xl lg:text-2xl" id="changes-and-amendments">Changes and amendments</h2><p>We reserve the right to modify this Agreement or its terms related to the Website and Services at any time at our discretion. When we do, we will send you an email to notify you. We may also provide notice to you in other ways at our discretion, such as through the contact information you have provided.</p><p>An updated version of this Agreement will be effective immediately upon the posting of the revised Agreement unless otherwise specified. Your continued use of the Website and Services after the effective date of the revised Agreement (or such other act specified at that time) will constitute your consent to those changes.</p></div><div><h2 class="my-1 text-lg font-bold sm:my-2 sm:text-xl lg:text-2xl" id="acceptance-of-these-terms">Acceptance of these terms</h2><p>You acknowledge that you have read this Agreement and agree to all its terms and conditions. By accessing and using the Website and Services you agree to be bound by this Agreement. If you do not agree to abide by the terms of this Agreement, you are not authorized to access or use the Website and Services. This policy has been created with the help of the <a href="https://www.websitepolicies.com/terms-and-conditions-generator">terms and conditions generator</a>.</p></div>', 9);
const $acb7bc4e6d48ff3f$var$_hoisted_11 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("h2", {
    class: "my-1 text-lg font-bold sm:my-2 sm:text-xl lg:text-2xl",
    id: "contacting-us"
}, "Contacting us", -1);
const $acb7bc4e6d48ff3f$var$_hoisted_12 = /*#__PURE__*/ (0, $TusQn.createTextVNode)("If you have any questions, concerns, or complaints regarding this Agreement, we encourage you to contact us using the details below: ");
const $acb7bc4e6d48ff3f$var$_hoisted_13 = {
    class: "break-words",
    ref: "mailto:support@scrapbookconciergerequests.com"
};
const $acb7bc4e6d48ff3f$var$_hoisted_14 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("p", null, "This document was last updated on September 6, 2024.", -1);
const $acb7bc4e6d48ff3f$var$_hoisted_15 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("p", {
    class: "madewith"
}, [
    /*#__PURE__*/ (0, $TusQn.createElementVNode)("a", {
        href: "https://www.websitepolicies.com/terms-and-conditions-generator?via=madewithbadge"
    }, [
        /*#__PURE__*/ (0, $TusQn.createElementVNode)("img", {
            width: "150",
            height: "18",
            alt: "Made with WebsitePolicies terms and conditions generator",
            src: "https://cdn.websitepolicies.io/img/badge.png",
            srcset: "https://cdn.websitepolicies.io/img/badge_2x.png 2x"
        })
    ])
], -1);
function $acb7bc4e6d48ff3f$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, [
        (0, $TusQn.createVNode)($setup["Header"]),
        (0, $TusQn.createElementVNode)("main", $acb7bc4e6d48ff3f$var$_hoisted_1, [
            $acb7bc4e6d48ff3f$var$_hoisted_2,
            (0, $TusQn.createElementVNode)("div", null, [
                $acb7bc4e6d48ff3f$var$_hoisted_11,
                (0, $TusQn.createElementVNode)("p", null, [
                    $acb7bc4e6d48ff3f$var$_hoisted_12,
                    (0, $TusQn.createElementVNode)("a", $acb7bc4e6d48ff3f$var$_hoisted_13, "support@scrapbookconciergerequests.com", 512)
                ]),
                $acb7bc4e6d48ff3f$var$_hoisted_14,
                $acb7bc4e6d48ff3f$var$_hoisted_15
            ])
        ]),
        (0, $TusQn.createVNode)($setup["Footer"])
    ], 64);
}

});

parcelRegister("a5RoW", function(module, exports) {

$parcel$export(module.exports, "default", () => $7593cb6ae96d760f$export$2e2bcd8739ae039);
let $7593cb6ae96d760f$var$NOOP = ()=>{};
var $7593cb6ae96d760f$export$2e2bcd8739ae039 = (script)=>{};

});

parcelRegister("j9gST", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $df0bf47bdfc62f57$export$2e2bcd8739ae039);
parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");

var $73mM4 = parcelRequire("73mM4");

var $gYKPF = parcelRequire("gYKPF");

var $ek92w = parcelRequire("ek92w");
var $df0bf47bdfc62f57$export$2e2bcd8739ae039 = {
    __name: 'password-forgot',
    setup (__props, { expose: expose }) {
        expose();
        const { executeRecaptcha: executeRecaptcha, recaptchaLoaded: recaptchaLoaded } = (0, $ek92w.useReCaptcha)();
        const router = (0, $73mM4.useRouter)();
        const email = (0, $01W3b.ref)('');
        const isEmailMessage = (0, $01W3b.ref)(false);
        async function onFormSubmit(event) {
            event.preventDefault();
            try {
                const generateOptions = (body)=>({
                        method: 'POST',
                        body: JSON.stringify(body),
                        headers: {
                            'Content-Type': 'application/json'
                        }
                    });
                const reCAPTCHAToken = await executeRecaptcha('password-forgot');
                const verificationResponse = await fetch(`${"https://scrapbook-concierge-requests-api-cr45w.ondigitalocean.app"}/verify-recaptcha`, generateOptions({
                    token: reCAPTCHAToken
                }));
                const verificationResult = await verificationResponse.json();
                if (verificationResponse.status === 400) return router.push({
                    name: 'home'
                });
                const response = await fetch(`${"https://scrapbook-concierge-requests-api-cr45w.ondigitalocean.app"}/password-reset`, generateOptions({
                    email: email.value
                }));
                const result = await response.json();
                if (response.ok) (0, $gYKPF.pushAlert)('success', result.message);
                else if (response.status === 400) (0, $gYKPF.pushAlert)('failure', result.message);
                else if (response.status === 429) (0, $gYKPF.pushAlert)('failure', result.message);
                else (0, $gYKPF.pushAlert)('failure', result.message);
            } catch (error) {
                console.error(error);
                (0, $gYKPF.pushAlert)('failure', 'An Error occurred while sending recovery email. Try again later.');
            }
        }
        const __returned__ = {
            executeRecaptcha: executeRecaptcha,
            recaptchaLoaded: recaptchaLoaded,
            router: router,
            email: email,
            isEmailMessage: isEmailMessage,
            onFormSubmit: onFormSubmit,
            ref: $01W3b.ref,
            useRouter: $73mM4.useRouter,
            pushAlert: $gYKPF.pushAlert,
            useReCaptcha: $ek92w.useReCaptcha
        };
        Object.defineProperty(__returned__, '__isScriptSetup', {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
};

});

parcelRegister("ldWyM", function(module, exports) {

$parcel$export(module.exports, "render", () => $f7383cab77301351$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $eeJ70 = parcelRequire("eeJ70");
const $f7383cab77301351$var$_hoisted_1 = {
    class: "w-screen h-screen flex justify-center items-center"
};
const $f7383cab77301351$var$_hoisted_2 = {
    class: "w-96 px-4 py-8 border rounded"
};
const $f7383cab77301351$var$_hoisted_3 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("h1", {
    class: "text-3xl font-semibold text-center"
}, "Reset your password", -1);
const $f7383cab77301351$var$_hoisted_4 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("hr", {
    class: "my-8"
}, null, -1);
const $f7383cab77301351$var$_hoisted_5 = {
    class: "mb-4"
};
const $f7383cab77301351$var$_hoisted_6 = {
    class: "flex flex-col mb-4"
};
const $f7383cab77301351$var$_hoisted_7 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("label", {
    class: "font-medium mb-1",
    for: "email"
}, "Email", -1);
const $f7383cab77301351$var$_hoisted_8 = [
    "aria-hidden"
];
function $f7383cab77301351$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("main", $f7383cab77301351$var$_hoisted_1, [
        (0, $TusQn.createElementVNode)("div", $f7383cab77301351$var$_hoisted_2, [
            $f7383cab77301351$var$_hoisted_3,
            $f7383cab77301351$var$_hoisted_4,
            (0, $TusQn.createElementVNode)("div", null, [
                (0, $TusQn.createElementVNode)("form", $f7383cab77301351$var$_hoisted_5, [
                    (0, $TusQn.createElementVNode)("fieldset", $f7383cab77301351$var$_hoisted_6, [
                        $f7383cab77301351$var$_hoisted_7,
                        (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                            class: "rounded ring-transparent focus:border-transparent focus:ring-2 focus:ring-purple-800",
                            type: "email",
                            name: "email",
                            id: "email",
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event)=>$setup.email = $event),
                            required: ""
                        }, null, 512), [
                            [
                                (0, $eeJ70.vModelText),
                                $setup.email
                            ]
                        ]),
                        (0, $TusQn.createElementVNode)("span", {
                            class: "pt-[2px] text-red-500 text-xs opacity-100 aria-hidden:opacity-0 transition-opacity duration-300",
                            "aria-hidden": !$setup.isEmailMessage
                        }, "Please enter your email", 8, $f7383cab77301351$var$_hoisted_8)
                    ]),
                    (0, $TusQn.createElementVNode)("button", {
                        class: "px-5 py-2 bg-purple-800 text-white w-full text-bold rounded",
                        type: "submit",
                        onClick: $setup.onFormSubmit
                    }, "Submit")
                ])
            ])
        ])
    ]);
}

});

parcelRegister("1hzjh", function(module, exports) {

$parcel$export(module.exports, "default", () => $0ef2c4d29350ea6a$export$2e2bcd8739ae039);
let $0ef2c4d29350ea6a$var$NOOP = ()=>{};
var $0ef2c4d29350ea6a$export$2e2bcd8739ae039 = (script)=>{};

});

parcelRegister("9lSvv", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $6cf05b3bdb8448bf$export$2e2bcd8739ae039);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $01W3b = parcelRequire("01W3b");

var $73mM4 = parcelRequire("73mM4");

var $ek92w = parcelRequire("ek92w");

var $gYKPF = parcelRequire("gYKPF");
var $6cf05b3bdb8448bf$export$2e2bcd8739ae039 = {
    __name: 'password-reset',
    setup (__props, { expose: expose }) {
        expose();
        const route = (0, $73mM4.useRoute)();
        const router = (0, $73mM4.useRouter)();
        const { executeRecaptcha: executeRecaptcha, recaptchaLoaded: recaptchaLoaded } = (0, $ek92w.useReCaptcha)();
        const { token: token, id: id } = route.query;
        const newPassword = (0, $01W3b.ref)('');
        const confirmPassword = (0, $01W3b.ref)('');
        const isNewPasswordMessage = (0, $01W3b.ref)(false);
        const isConfirmPasswordMessage = (0, $01W3b.ref)(false);
        const isPasswordMatch = (0, $01W3b.ref)(true);
        function onNewPasswordFocusOut() {
            isNewPasswordMessage.value = newPassword.value.length < 6;
        }
        function onConfirmPasswordFocusOut() {
            isConfirmPasswordMessage.value = confirmPassword.value.length < 6;
        }
        async function onFormSubmit(event) {
            event.preventDefault();
            try {
                if (!newPassword.value) return isNewPasswordMessage.value = true;
                if (!confirmPassword.value) return isConfirmPasswordMessage.value = true;
                if (newPassword.value !== confirmPassword.value) return isPasswordMatch.value = false;
                const generateOptions = (method, body)=>({
                        method: method,
                        body: JSON.stringify(body),
                        headers: {
                            'Content-Type': 'application/json'
                        }
                    });
                const reCAPTCHAToken = await executeRecaptcha('password-reset');
                const verificationResponse = await fetch(`${"https://scrapbook-concierge-requests-api-cr45w.ondigitalocean.app"}/verify-recaptcha`, generateOptions('POST', {
                    token: reCAPTCHAToken
                }));
                const verificationResult = await verificationResponse.json();
                if (verificationResponse.status === 400) return router.push({
                    name: 'home'
                });
                const response = await fetch(`${"https://scrapbook-concierge-requests-api-cr45w.ondigitalocean.app"}/password-reset`, generateOptions('PATCH', {
                    userId: id,
                    resetToken: token,
                    newPassword: newPassword.value
                }));
                let result = await response.json();
                if (response.ok) {
                    (0, $gYKPF.pushAlert)('success', result.message);
                    router.push({
                        name: 'login'
                    });
                } else if (response.status === 400) {
                    (0, $gYKPF.pushAlert)('failure', result.message);
                    router.push({
                        name: 'password-forgot'
                    });
                } else (0, $gYKPF.pushAlert)('failure', result.message);
            } catch (error) {
                console.error(error);
                (0, $gYKPF.pushAlert)('failure', 'An Error occurred while resetting the password. Try again later.');
            }
        }
        (0, $TusQn.onBeforeMount)(()=>{
            if (!token || !id) router.push({
                name: 'login'
            });
        });
        const __returned__ = {
            route: route,
            router: router,
            executeRecaptcha: executeRecaptcha,
            recaptchaLoaded: recaptchaLoaded,
            token: token,
            id: id,
            newPassword: newPassword,
            confirmPassword: confirmPassword,
            isNewPasswordMessage: isNewPasswordMessage,
            isConfirmPasswordMessage: isConfirmPasswordMessage,
            isPasswordMatch: isPasswordMatch,
            onNewPasswordFocusOut: onNewPasswordFocusOut,
            onConfirmPasswordFocusOut: onConfirmPasswordFocusOut,
            onFormSubmit: onFormSubmit,
            ref: $01W3b.ref,
            onBeforeMount: $TusQn.onBeforeMount,
            useRoute: $73mM4.useRoute,
            useRouter: $73mM4.useRouter,
            useReCaptcha: $ek92w.useReCaptcha,
            pushAlert: $gYKPF.pushAlert
        };
        Object.defineProperty(__returned__, '__isScriptSetup', {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
};

});

parcelRegister("dCej1", function(module, exports) {

$parcel$export(module.exports, "render", () => $9e99ebc98d12e0da$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $eeJ70 = parcelRequire("eeJ70");
const $9e99ebc98d12e0da$var$_hoisted_1 = {
    class: "w-screen h-screen flex justify-center items-center"
};
const $9e99ebc98d12e0da$var$_hoisted_2 = {
    class: "w-96 px-4 py-8 border rounded"
};
const $9e99ebc98d12e0da$var$_hoisted_3 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("h1", {
    class: "text-3xl font-semibold text-center"
}, "Reset Password", -1);
const $9e99ebc98d12e0da$var$_hoisted_4 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("hr", {
    class: "my-8"
}, null, -1);
const $9e99ebc98d12e0da$var$_hoisted_5 = {
    key: 0,
    class: "mb-8 py-4 text-center border border-red-600 bg-red-200"
};
const $9e99ebc98d12e0da$var$_hoisted_6 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("div", {
    class: "text-xs"
}, "New Password and Confirm Password don't match.", -1);
const $9e99ebc98d12e0da$var$_hoisted_7 = [
    $9e99ebc98d12e0da$var$_hoisted_6
];
const $9e99ebc98d12e0da$var$_hoisted_8 = {
    class: "mb-4"
};
const $9e99ebc98d12e0da$var$_hoisted_9 = {
    class: "flex flex-col mb-6"
};
const $9e99ebc98d12e0da$var$_hoisted_10 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("label", {
    class: "font-medium mb-1",
    for: "new-password"
}, "New Password", -1);
const $9e99ebc98d12e0da$var$_hoisted_11 = [
    "aria-hidden"
];
const $9e99ebc98d12e0da$var$_hoisted_12 = {
    class: "flex flex-col mb-8"
};
const $9e99ebc98d12e0da$var$_hoisted_13 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("label", {
    class: "font-medium mb-1",
    for: "confirm-password"
}, "Confirm Password", -1);
const $9e99ebc98d12e0da$var$_hoisted_14 = [
    "aria-hidden"
];
function $9e99ebc98d12e0da$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("main", $9e99ebc98d12e0da$var$_hoisted_1, [
        (0, $TusQn.createElementVNode)("div", $9e99ebc98d12e0da$var$_hoisted_2, [
            $9e99ebc98d12e0da$var$_hoisted_3,
            $9e99ebc98d12e0da$var$_hoisted_4,
            !$setup.isPasswordMatch ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $9e99ebc98d12e0da$var$_hoisted_5, $9e99ebc98d12e0da$var$_hoisted_7)) : (0, $TusQn.createCommentVNode)("", true),
            (0, $TusQn.createElementVNode)("div", null, [
                (0, $TusQn.createElementVNode)("form", $9e99ebc98d12e0da$var$_hoisted_8, [
                    (0, $TusQn.createElementVNode)("fieldset", $9e99ebc98d12e0da$var$_hoisted_9, [
                        $9e99ebc98d12e0da$var$_hoisted_10,
                        (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                            class: "rounded ring-transparent focus:border-transparent focus:ring-2 focus:ring-purple-800",
                            type: "password",
                            name: "new-password",
                            id: "new-password",
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event)=>$setup.newPassword = $event),
                            onFocusout: $setup.onNewPasswordFocusOut
                        }, null, 544), [
                            [
                                (0, $eeJ70.vModelText),
                                $setup.newPassword
                            ]
                        ]),
                        (0, $TusQn.createElementVNode)("span", {
                            class: "pt-[2px] text-red-500 text-xs opacity-100 aria-hidden:opacity-0 transition-opacity duration-300",
                            "aria-hidden": !$setup.isNewPasswordMessage
                        }, " Password should be at least 6 Characters long. ", 8, $9e99ebc98d12e0da$var$_hoisted_11)
                    ]),
                    (0, $TusQn.createElementVNode)("fieldset", $9e99ebc98d12e0da$var$_hoisted_12, [
                        $9e99ebc98d12e0da$var$_hoisted_13,
                        (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                            class: "rounded ring-transparent focus:border-transparent focus:ring-2 focus:ring-purple-800",
                            type: "password",
                            name: "confirm-password",
                            id: "confirm-password",
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event)=>$setup.confirmPassword = $event),
                            onFocusout: $setup.onConfirmPasswordFocusOut
                        }, null, 544), [
                            [
                                (0, $eeJ70.vModelText),
                                $setup.confirmPassword
                            ]
                        ]),
                        (0, $TusQn.createElementVNode)("span", {
                            class: "pt-[2px] text-red-500 text-xs opacity-100 aria-hidden:opacity-0 transition-opacity duration-300",
                            "aria-hidden": !$setup.isConfirmPasswordMessage
                        }, " Password should be at least 6 Characters long. ", 8, $9e99ebc98d12e0da$var$_hoisted_14)
                    ]),
                    (0, $TusQn.createElementVNode)("button", {
                        class: "px-5 py-2 bg-purple-800 text-white w-full text-bold rounded",
                        type: "submit",
                        onClick: $setup.onFormSubmit
                    }, "Submit")
                ])
            ])
        ])
    ]);
}

});

parcelRegister("kwDEI", function(module, exports) {

$parcel$export(module.exports, "default", () => $ef158e9b19c0f9f0$export$2e2bcd8739ae039);
let $ef158e9b19c0f9f0$var$NOOP = ()=>{};
var $ef158e9b19c0f9f0$export$2e2bcd8739ae039 = (script)=>{};

});

parcelRequire("ecd4d");
var $eeJ70 = parcelRequire("eeJ70");

var $73mM4 = parcelRequire("73mM4");

var $gYKPF = parcelRequire("gYKPF");
let $9eeee3aab604adc6$var$script;



let $9eeee3aab604adc6$var$initialize = ()=>{
    $9eeee3aab604adc6$var$script = (parcelRequire("6dIxi"));
    if ($9eeee3aab604adc6$var$script.__esModule) $9eeee3aab604adc6$var$script = $9eeee3aab604adc6$var$script.default;
    $9eeee3aab604adc6$var$script.render = (parcelRequire("a5J4w")).render;
    (parcelRequire("fWmT1")).default($9eeee3aab604adc6$var$script);
    $9eeee3aab604adc6$var$script.__scopeId = 'data-v-608b83';
    $9eeee3aab604adc6$var$script.__file = "app.vue";
};
$9eeee3aab604adc6$var$initialize();
var $9eeee3aab604adc6$export$2e2bcd8739ae039 = $9eeee3aab604adc6$var$script;


let $a4d3fbeb3c9ffe13$var$script;



let $a4d3fbeb3c9ffe13$var$initialize = ()=>{
    $a4d3fbeb3c9ffe13$var$script = (parcelRequire("hmXi5"));
    if ($a4d3fbeb3c9ffe13$var$script.__esModule) $a4d3fbeb3c9ffe13$var$script = $a4d3fbeb3c9ffe13$var$script.default;
    $a4d3fbeb3c9ffe13$var$script.render = (parcelRequire("343ow")).render;
    (parcelRequire("MIFpg")).default($a4d3fbeb3c9ffe13$var$script);
    $a4d3fbeb3c9ffe13$var$script.__scopeId = 'data-v-aea204';
    $a4d3fbeb3c9ffe13$var$script.__file = "home.vue";
};
$a4d3fbeb3c9ffe13$var$initialize();
var $a4d3fbeb3c9ffe13$export$2e2bcd8739ae039 = $a4d3fbeb3c9ffe13$var$script;


let $5f5a7066eafcf8fe$var$script;



let $5f5a7066eafcf8fe$var$initialize = ()=>{
    $5f5a7066eafcf8fe$var$script = (parcelRequire("lvGE2"));
    if ($5f5a7066eafcf8fe$var$script.__esModule) $5f5a7066eafcf8fe$var$script = $5f5a7066eafcf8fe$var$script.default;
    $5f5a7066eafcf8fe$var$script.render = (parcelRequire("k5oMG")).render;
    (parcelRequire("fgSYh")).default($5f5a7066eafcf8fe$var$script);
    $5f5a7066eafcf8fe$var$script.__scopeId = 'data-v-7cdc3e';
    $5f5a7066eafcf8fe$var$script.__file = "requests.vue";
};
$5f5a7066eafcf8fe$var$initialize();
var $5f5a7066eafcf8fe$export$2e2bcd8739ae039 = $5f5a7066eafcf8fe$var$script;


let $714b0e6770779f0b$var$script;



let $714b0e6770779f0b$var$initialize = ()=>{
    $714b0e6770779f0b$var$script = (parcelRequire("2MP5Z"));
    if ($714b0e6770779f0b$var$script.__esModule) $714b0e6770779f0b$var$script = $714b0e6770779f0b$var$script.default;
    $714b0e6770779f0b$var$script.render = (parcelRequire("7pQz3")).render;
    (parcelRequire("8fD1c")).default($714b0e6770779f0b$var$script);
    $714b0e6770779f0b$var$script.__scopeId = 'data-v-02aefe';
    $714b0e6770779f0b$var$script.__file = "login.vue";
};
$714b0e6770779f0b$var$initialize();
var $714b0e6770779f0b$export$2e2bcd8739ae039 = $714b0e6770779f0b$var$script;


let $370128e570e5bf0d$var$script;



let $370128e570e5bf0d$var$initialize = ()=>{
    $370128e570e5bf0d$var$script = (parcelRequire("1hJ3X"));
    if ($370128e570e5bf0d$var$script.__esModule) $370128e570e5bf0d$var$script = $370128e570e5bf0d$var$script.default;
    $370128e570e5bf0d$var$script.render = (parcelRequire("2FKaU")).render;
    (parcelRequire("8RufY")).default($370128e570e5bf0d$var$script);
    $370128e570e5bf0d$var$script.__scopeId = 'data-v-9491a1';
    $370128e570e5bf0d$var$script.__file = "signup.vue";
};
$370128e570e5bf0d$var$initialize();
var $370128e570e5bf0d$export$2e2bcd8739ae039 = $370128e570e5bf0d$var$script;


let $b604d8960cd69e8b$var$script;



let $b604d8960cd69e8b$var$initialize = ()=>{
    $b604d8960cd69e8b$var$script = (parcelRequire("8TOKj"));
    if ($b604d8960cd69e8b$var$script.__esModule) $b604d8960cd69e8b$var$script = $b604d8960cd69e8b$var$script.default;
    $b604d8960cd69e8b$var$script.render = (parcelRequire("9amum")).render;
    (parcelRequire("9vR2y")).default($b604d8960cd69e8b$var$script);
    $b604d8960cd69e8b$var$script.__scopeId = 'data-v-ac02e6';
    $b604d8960cd69e8b$var$script.__file = "my-requests.vue";
};
$b604d8960cd69e8b$var$initialize();
var $b604d8960cd69e8b$export$2e2bcd8739ae039 = $b604d8960cd69e8b$var$script;


let $60d0a9d22f5a5b37$var$script;



let $60d0a9d22f5a5b37$var$initialize = ()=>{
    $60d0a9d22f5a5b37$var$script = (parcelRequire("eT4HI"));
    if ($60d0a9d22f5a5b37$var$script.__esModule) $60d0a9d22f5a5b37$var$script = $60d0a9d22f5a5b37$var$script.default;
    $60d0a9d22f5a5b37$var$script.render = (parcelRequire("g2b7l")).render;
    (parcelRequire("2eAj8")).default($60d0a9d22f5a5b37$var$script);
    $60d0a9d22f5a5b37$var$script.__scopeId = 'data-v-1b9d85';
    $60d0a9d22f5a5b37$var$script.__file = "released-requests.vue";
};
$60d0a9d22f5a5b37$var$initialize();
var $60d0a9d22f5a5b37$export$2e2bcd8739ae039 = $60d0a9d22f5a5b37$var$script;


let $3d7daeabfc708c6e$var$script;



let $3d7daeabfc708c6e$var$initialize = ()=>{
    $3d7daeabfc708c6e$var$script = (parcelRequire("ap8dr"));
    if ($3d7daeabfc708c6e$var$script.__esModule) $3d7daeabfc708c6e$var$script = $3d7daeabfc708c6e$var$script.default;
    $3d7daeabfc708c6e$var$script.render = (parcelRequire("6Mqjr")).render;
    (parcelRequire("9cP39")).default($3d7daeabfc708c6e$var$script);
    $3d7daeabfc708c6e$var$script.__scopeId = 'data-v-3d5e48';
    $3d7daeabfc708c6e$var$script.__file = "admin.vue";
};
$3d7daeabfc708c6e$var$initialize();
var $3d7daeabfc708c6e$export$2e2bcd8739ae039 = $3d7daeabfc708c6e$var$script;


let $744d304a2e748825$var$script;



let $744d304a2e748825$var$initialize = ()=>{
    $744d304a2e748825$var$script = (parcelRequire("e5lSE"));
    if ($744d304a2e748825$var$script.__esModule) $744d304a2e748825$var$script = $744d304a2e748825$var$script.default;
    $744d304a2e748825$var$script.render = (parcelRequire("hFbZ9")).render;
    (parcelRequire("aPfiU")).default($744d304a2e748825$var$script);
    $744d304a2e748825$var$script.__scopeId = 'data-v-874d62';
    $744d304a2e748825$var$script.__file = "subscription.vue";
};
$744d304a2e748825$var$initialize();
var $744d304a2e748825$export$2e2bcd8739ae039 = $744d304a2e748825$var$script;


let $13d4fb7d90e2f157$var$script;



let $13d4fb7d90e2f157$var$initialize = ()=>{
    $13d4fb7d90e2f157$var$script = (parcelRequire("bMVAb"));
    if ($13d4fb7d90e2f157$var$script.__esModule) $13d4fb7d90e2f157$var$script = $13d4fb7d90e2f157$var$script.default;
    $13d4fb7d90e2f157$var$script.render = (parcelRequire("iHUIm")).render;
    (parcelRequire("b3z1z")).default($13d4fb7d90e2f157$var$script);
    $13d4fb7d90e2f157$var$script.__scopeId = 'data-v-a33f71';
    $13d4fb7d90e2f157$var$script.__file = "privacy-policy.vue";
};
$13d4fb7d90e2f157$var$initialize();
var $13d4fb7d90e2f157$export$2e2bcd8739ae039 = $13d4fb7d90e2f157$var$script;


let $4dd294d5445beaa9$var$script;



let $4dd294d5445beaa9$var$initialize = ()=>{
    $4dd294d5445beaa9$var$script = (parcelRequire("k0zMP"));
    if ($4dd294d5445beaa9$var$script.__esModule) $4dd294d5445beaa9$var$script = $4dd294d5445beaa9$var$script.default;
    $4dd294d5445beaa9$var$script.render = (parcelRequire("ePn5k")).render;
    (parcelRequire("a5RoW")).default($4dd294d5445beaa9$var$script);
    $4dd294d5445beaa9$var$script.__scopeId = 'data-v-354c0e';
    $4dd294d5445beaa9$var$script.__file = "terms.vue";
};
$4dd294d5445beaa9$var$initialize();
var $4dd294d5445beaa9$export$2e2bcd8739ae039 = $4dd294d5445beaa9$var$script;


let $98f370b7fece08fd$var$script;



let $98f370b7fece08fd$var$initialize = ()=>{
    $98f370b7fece08fd$var$script = (parcelRequire("j9gST"));
    if ($98f370b7fece08fd$var$script.__esModule) $98f370b7fece08fd$var$script = $98f370b7fece08fd$var$script.default;
    $98f370b7fece08fd$var$script.render = (parcelRequire("ldWyM")).render;
    (parcelRequire("1hzjh")).default($98f370b7fece08fd$var$script);
    $98f370b7fece08fd$var$script.__scopeId = 'data-v-df1995';
    $98f370b7fece08fd$var$script.__file = "password-forgot.vue";
};
$98f370b7fece08fd$var$initialize();
var $98f370b7fece08fd$export$2e2bcd8739ae039 = $98f370b7fece08fd$var$script;


let $674312e60c4423e2$var$script;



let $674312e60c4423e2$var$initialize = ()=>{
    $674312e60c4423e2$var$script = (parcelRequire("9lSvv"));
    if ($674312e60c4423e2$var$script.__esModule) $674312e60c4423e2$var$script = $674312e60c4423e2$var$script.default;
    $674312e60c4423e2$var$script.render = (parcelRequire("dCej1")).render;
    (parcelRequire("kwDEI")).default($674312e60c4423e2$var$script);
    $674312e60c4423e2$var$script.__scopeId = 'data-v-bd39d4';
    $674312e60c4423e2$var$script.__file = "password-reset.vue";
};
$674312e60c4423e2$var$initialize();
var $674312e60c4423e2$export$2e2bcd8739ae039 = $674312e60c4423e2$var$script;



var $8POXm = parcelRequire("8POXm");
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
function $94cd11ffbd2c28e8$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $94cd11ffbd2c28e8$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $94cd11ffbd2c28e8$var$_objectSpread2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $94cd11ffbd2c28e8$var$ownKeys(Object(source), true).forEach(function(key) {
            $94cd11ffbd2c28e8$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $94cd11ffbd2c28e8$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $94cd11ffbd2c28e8$var$load = function load(url) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return new Promise(function(resolve, reject) {
        if (typeof document === "undefined") return;
        var head = document.head || document.getElementsByTagName("head")[0];
        var script = document.createElement("script");
        script.async = true;
        script.src = url;
        script.defer = options.defer;
        if (options.preconnectOrigin) {
            var link = document.createElement("link");
            link.href = options.preconnectOrigin;
            link.rel = "preconnect";
            head.appendChild(link);
        }
        head.appendChild(script);
        script.onload = resolve;
        script.onerror = reject;
    });
};
var $94cd11ffbd2c28e8$var$mergeDeep = function mergeDeep(target) {
    for(var _len = arguments.length, sources = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)sources[_key - 1] = arguments[_key];
    if (!sources.length) return target;
    var source = sources.shift();
    if (!(0, $8POXm.isPlainObject)(target) || !(0, $8POXm.isPlainObject)(source)) return;
    for(var key in source)if ((0, $8POXm.isPlainObject)(source[key])) {
        if (!target[key]) Object.assign(target, $94cd11ffbd2c28e8$var$_defineProperty({}, key, {}));
        mergeDeep(target[key], source[key]);
    } else Object.assign(target, $94cd11ffbd2c28e8$var$_defineProperty({}, key, source[key]));
    return mergeDeep.apply(void 0, [
        target
    ].concat(sources));
};
var $94cd11ffbd2c28e8$var$isBrowser = function isBrowser() {
    if (typeof window === "undefined" || typeof document === "undefined") return false;
    return true;
};
var $94cd11ffbd2c28e8$var$warn = function warn(text) {
    var shouldLog = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    $94cd11ffbd2c28e8$var$isBrowser();
    return;
    if (!shouldLog) return;
    console.warn("[vue-gtag] ".concat(text));
};
var $94cd11ffbd2c28e8$var$validateScreenviewShape = function validateScreenviewShape() {
    var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    $94cd11ffbd2c28e8$var$warn("Missing \"appName\" property inside the plugin options.", obj.app_name == null);
    $94cd11ffbd2c28e8$var$warn("Missing \"name\" property in the route.", obj.screen_name == null);
    return obj;
};
function $94cd11ffbd2c28e8$var$getPathWithBase() {
    var path = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
    var base = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
    var pathAsArray = path.split("/");
    var baseAsArray = base.split("/");
    if (pathAsArray[0] === "" && base[base.length - 1] === "/") pathAsArray.shift();
    return baseAsArray.join("/") + pathAsArray.join("/");
}
var $94cd11ffbd2c28e8$var$getDefaultParams = function getDefaultParams() {
    return {
        bootstrap: true,
        onReady: null,
        onError: null,
        onBeforeTrack: null,
        onAfterTrack: null,
        pageTrackerTemplate: null,
        customResourceURL: "https://www.googletagmanager.com/gtag/js",
        customPreconnectOrigin: "https://www.googletagmanager.com",
        deferScriptLoad: false,
        pageTrackerExcludedRoutes: [],
        pageTrackerEnabled: true,
        enabled: true,
        disableScriptLoad: false,
        pageTrackerScreenviewEnabled: false,
        appName: null,
        pageTrackerUseFullPath: false,
        pageTrackerPrependBase: true,
        pageTrackerSkipSamePath: true,
        globalDataLayerName: "dataLayer",
        globalObjectName: "gtag",
        defaultGroupName: "default",
        includes: null,
        config: {
            id: null,
            params: {
                send_page_view: false
            }
        }
    };
};
var $94cd11ffbd2c28e8$var$params = {};
var $94cd11ffbd2c28e8$export$add91eafeaeab287 = function setOptions() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var defaultParams = $94cd11ffbd2c28e8$var$getDefaultParams();
    $94cd11ffbd2c28e8$var$params = $94cd11ffbd2c28e8$var$mergeDeep(defaultParams, options);
};
var $94cd11ffbd2c28e8$var$getOptions = function getOptions() {
    return $94cd11ffbd2c28e8$var$params;
};
var $94cd11ffbd2c28e8$export$2fa187e846a241c4 = function() {
    var _window;
    var _getOptions = $94cd11ffbd2c28e8$var$getOptions(), globalObjectName = _getOptions.globalObjectName;
    if (!$94cd11ffbd2c28e8$var$isBrowser() || typeof window[globalObjectName] === "undefined") return;
    (_window = window)[globalObjectName].apply(_window, arguments);
};
var $94cd11ffbd2c28e8$export$e506a1d27d1eaa20 = function() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    var _getOptions = $94cd11ffbd2c28e8$var$getOptions(), config = _getOptions.config, includes = _getOptions.includes;
    $94cd11ffbd2c28e8$export$2fa187e846a241c4.apply(void 0, [
        "config",
        config.id
    ].concat(args));
    if (Array.isArray(includes)) includes.forEach(function(domain) {
        $94cd11ffbd2c28e8$export$2fa187e846a241c4.apply(void 0, [
            "config",
            domain.id
        ].concat(args));
    });
};
var $94cd11ffbd2c28e8$var$assignGlobalProperty = function assignGlobalProperty(id, value) {
    if (!$94cd11ffbd2c28e8$var$isBrowser()) return;
    window["ga-disable-".concat(id)] = value;
};
var $94cd11ffbd2c28e8$var$disable = function() {
    var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    var _getOptions = $94cd11ffbd2c28e8$var$getOptions(), config = _getOptions.config, includes = _getOptions.includes;
    $94cd11ffbd2c28e8$var$assignGlobalProperty(config.id, value);
    if (Array.isArray(includes)) includes.forEach(function(domain) {
        return $94cd11ffbd2c28e8$var$assignGlobalProperty(domain.id, value);
    });
};
var $94cd11ffbd2c28e8$export$7c7d338baab9289b = function() {
    $94cd11ffbd2c28e8$var$disable(true);
};
var $94cd11ffbd2c28e8$export$4a65a988b6cd1e7e = function() {
    $94cd11ffbd2c28e8$var$disable(false);
};
var $94cd11ffbd2c28e8$var$router;
var $94cd11ffbd2c28e8$export$6142de96feec4847 = function setRouter(instance) {
    $94cd11ffbd2c28e8$var$router = instance;
};
var $94cd11ffbd2c28e8$var$getRouter = function getRouter() {
    return $94cd11ffbd2c28e8$var$router;
};
var $94cd11ffbd2c28e8$export$6cd530ed55e06764 = function(name) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var _getOptions = $94cd11ffbd2c28e8$var$getOptions(), includes = _getOptions.includes, defaultGroupName = _getOptions.defaultGroupName;
    if (params.send_to == null && Array.isArray(includes) && includes.length) params.send_to = includes.map(function(domain) {
        return domain.id;
    }).concat(defaultGroupName);
    $94cd11ffbd2c28e8$export$2fa187e846a241c4("event", name, params);
};
var $94cd11ffbd2c28e8$export$b81f1580747d8b3a = function(param) {
    if (!$94cd11ffbd2c28e8$var$isBrowser()) return;
    var template;
    if (typeof param === "string") template = {
        page_path: param
    };
    else if (param.path || param.fullPath) {
        var _getOptions = $94cd11ffbd2c28e8$var$getOptions(), useFullPath = _getOptions.pageTrackerUseFullPath, useBase = _getOptions.pageTrackerPrependBase;
        var router = $94cd11ffbd2c28e8$var$getRouter();
        var base = router && router.options.base;
        var path = useFullPath ? param.fullPath : param.path;
        template = $94cd11ffbd2c28e8$var$_objectSpread2($94cd11ffbd2c28e8$var$_objectSpread2({}, param.name && {
            page_title: param.name
        }), {}, {
            page_path: useBase ? $94cd11ffbd2c28e8$var$getPathWithBase(path, base) : path
        });
    } else template = param;
    if (template.page_location == null) template.page_location = window.location.href;
    if (template.send_page_view == null) template.send_page_view = true;
    $94cd11ffbd2c28e8$export$6cd530ed55e06764("page_view", template);
};
var $94cd11ffbd2c28e8$export$79f0686b606b0362 = function(param) {
    var _getOptions = $94cd11ffbd2c28e8$var$getOptions(), appName = _getOptions.appName;
    if (!param) return;
    var template;
    if (typeof param === "string") template = {
        screen_name: param
    };
    else template = param;
    template.app_name = template.app_name || appName;
    $94cd11ffbd2c28e8$export$6cd530ed55e06764("screen_view", template);
};
var $94cd11ffbd2c28e8$export$788a307bb494601 = function() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    $94cd11ffbd2c28e8$export$6cd530ed55e06764.apply(void 0, [
        "exception"
    ].concat(args));
};
var $94cd11ffbd2c28e8$export$326ac747d4674966 = function(params) {
    $94cd11ffbd2c28e8$export$e506a1d27d1eaa20("linker", params);
};
var $94cd11ffbd2c28e8$export$2da9be4cfdb689b1 = function(params) {
    $94cd11ffbd2c28e8$export$6cd530ed55e06764("timing_complete", params);
};
var $94cd11ffbd2c28e8$export$adaa4cf7ef1b65be = function() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    $94cd11ffbd2c28e8$export$2fa187e846a241c4.apply(void 0, [
        "set"
    ].concat(args));
};
var $94cd11ffbd2c28e8$export$af0183d50be14be2 = function() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    $94cd11ffbd2c28e8$export$6cd530ed55e06764.apply(void 0, [
        "refund"
    ].concat(args));
};
var $94cd11ffbd2c28e8$export$dc50efc0e10fcd69 = function(params) {
    $94cd11ffbd2c28e8$export$6cd530ed55e06764("purchase", params);
};
var $94cd11ffbd2c28e8$export$cf953570a894f353 = function(map) {
    $94cd11ffbd2c28e8$export$e506a1d27d1eaa20({
        custom_map: map
    });
};
var $94cd11ffbd2c28e8$var$api = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    query: $94cd11ffbd2c28e8$export$2fa187e846a241c4,
    config: $94cd11ffbd2c28e8$export$e506a1d27d1eaa20,
    optOut: $94cd11ffbd2c28e8$export$7c7d338baab9289b,
    optIn: $94cd11ffbd2c28e8$export$4a65a988b6cd1e7e,
    pageview: $94cd11ffbd2c28e8$export$b81f1580747d8b3a,
    screenview: $94cd11ffbd2c28e8$export$79f0686b606b0362,
    exception: $94cd11ffbd2c28e8$export$788a307bb494601,
    linker: $94cd11ffbd2c28e8$export$326ac747d4674966,
    time: $94cd11ffbd2c28e8$export$2da9be4cfdb689b1,
    set: $94cd11ffbd2c28e8$export$adaa4cf7ef1b65be,
    refund: $94cd11ffbd2c28e8$export$af0183d50be14be2,
    purchase: $94cd11ffbd2c28e8$export$dc50efc0e10fcd69,
    customMap: $94cd11ffbd2c28e8$export$cf953570a894f353,
    event: $94cd11ffbd2c28e8$export$6cd530ed55e06764
});
var $94cd11ffbd2c28e8$var$attachApi = function attachApi(app) {
    app.config.globalProperties.$gtag = $94cd11ffbd2c28e8$var$api;
};
var $94cd11ffbd2c28e8$var$registerGlobals = function() {
    if (!$94cd11ffbd2c28e8$var$isBrowser()) return;
    var _getOptions = $94cd11ffbd2c28e8$var$getOptions(), enabled = _getOptions.enabled, globalObjectName = _getOptions.globalObjectName, globalDataLayerName = _getOptions.globalDataLayerName;
    if (window[globalObjectName] == null) {
        window[globalDataLayerName] = window[globalDataLayerName] || [];
        window[globalObjectName] = function() {
            window[globalDataLayerName].push(arguments);
        };
    }
    window[globalObjectName]("js", new Date());
    if (!enabled) $94cd11ffbd2c28e8$export$7c7d338baab9289b();
    return window[globalObjectName];
};
var $94cd11ffbd2c28e8$var$mergeDefaultParams = function mergeDefaultParams(params) {
    return $94cd11ffbd2c28e8$var$_objectSpread2({
        send_page_view: false
    }, params);
};
var $94cd11ffbd2c28e8$var$addConfiguration = function() {
    var _getOptions = $94cd11ffbd2c28e8$var$getOptions(), config = _getOptions.config, includes = _getOptions.includes;
    $94cd11ffbd2c28e8$export$2fa187e846a241c4("config", config.id, $94cd11ffbd2c28e8$var$mergeDefaultParams(config.params));
    if (Array.isArray(includes)) includes.forEach(function(domain) {
        $94cd11ffbd2c28e8$export$2fa187e846a241c4("config", domain.id, $94cd11ffbd2c28e8$var$mergeDefaultParams(domain.params));
    });
};
var $94cd11ffbd2c28e8$var$track = function() {
    var to = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var from = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var _getOptions = $94cd11ffbd2c28e8$var$getOptions(), appName = _getOptions.appName, proxy = _getOptions.pageTrackerTemplate, useScreenview = _getOptions.pageTrackerScreenviewEnabled, skipSamePath = _getOptions.pageTrackerSkipSamePath;
    if (skipSamePath && to.path === from.path) return;
    var template = to;
    if ((0, $8POXm.isFunction)(proxy)) template = proxy(to, from);
    else if (useScreenview) template = $94cd11ffbd2c28e8$var$validateScreenviewShape({
        app_name: appName,
        screen_name: to.name
    });
    if (useScreenview) {
        $94cd11ffbd2c28e8$export$79f0686b606b0362(template);
        return;
    }
    $94cd11ffbd2c28e8$export$b81f1580747d8b3a(template);
};
var $94cd11ffbd2c28e8$var$isRouteExcluded = function isRouteExcluded(route) {
    var _getOptions = $94cd11ffbd2c28e8$var$getOptions(), routes = _getOptions.pageTrackerExcludedRoutes;
    return routes.includes(route.path) || routes.includes(route.name);
};
var $94cd11ffbd2c28e8$export$4401e98431a0f976 = function() {
    var _getOptions2 = $94cd11ffbd2c28e8$var$getOptions(), onBeforeTrack = _getOptions2.onBeforeTrack, onAfterTrack = _getOptions2.onAfterTrack;
    var router = $94cd11ffbd2c28e8$var$getRouter();
    router.isReady().then(function() {
        (0, $TusQn.nextTick)().then(function() {
            var currentRoute = router.currentRoute;
            $94cd11ffbd2c28e8$var$addConfiguration();
            if ($94cd11ffbd2c28e8$var$isRouteExcluded(currentRoute.value)) return;
            $94cd11ffbd2c28e8$var$track(currentRoute.value);
        });
        router.afterEach(function(to, from) {
            (0, $TusQn.nextTick)().then(function() {
                if ($94cd11ffbd2c28e8$var$isRouteExcluded(to)) return;
                if ((0, $8POXm.isFunction)(onBeforeTrack)) onBeforeTrack(to, from);
                $94cd11ffbd2c28e8$var$track(to, from);
                if ((0, $8POXm.isFunction)(onAfterTrack)) onAfterTrack(to, from);
            });
        });
    });
};
var $94cd11ffbd2c28e8$export$36aff1fbb4f5dfc6 = function() {
    var _getOptions = $94cd11ffbd2c28e8$var$getOptions(), onReady = _getOptions.onReady, onError = _getOptions.onError, globalObjectName = _getOptions.globalObjectName, globalDataLayerName = _getOptions.globalDataLayerName, config = _getOptions.config, customResourceURL = _getOptions.customResourceURL, customPreconnectOrigin = _getOptions.customPreconnectOrigin, deferScriptLoad = _getOptions.deferScriptLoad, pageTrackerEnabled = _getOptions.pageTrackerEnabled, disableScriptLoad = _getOptions.disableScriptLoad;
    var isPageTrackerEnabled = Boolean(pageTrackerEnabled && $94cd11ffbd2c28e8$var$getRouter());
    $94cd11ffbd2c28e8$var$registerGlobals();
    if (isPageTrackerEnabled) $94cd11ffbd2c28e8$export$4401e98431a0f976();
    else $94cd11ffbd2c28e8$var$addConfiguration();
    if (disableScriptLoad) return;
    return $94cd11ffbd2c28e8$var$load("".concat(customResourceURL, "?id=").concat(config.id, "&l=").concat(globalDataLayerName), {
        preconnectOrigin: customPreconnectOrigin,
        defer: deferScriptLoad
    }).then(function() {
        if (onReady) onReady(window[globalObjectName]);
    })["catch"](function(error) {
        if (onError) onError(error);
        return error;
    });
};
var $94cd11ffbd2c28e8$export$4b3e715f166fdd78 = function install(app) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var router = arguments.length > 2 ? arguments[2] : undefined;
    $94cd11ffbd2c28e8$var$attachApi(app);
    $94cd11ffbd2c28e8$export$add91eafeaeab287(options);
    $94cd11ffbd2c28e8$export$6142de96feec4847(router);
    if ($94cd11ffbd2c28e8$var$getOptions().bootstrap) $94cd11ffbd2c28e8$export$36aff1fbb4f5dfc6();
};
var $94cd11ffbd2c28e8$export$2e2bcd8739ae039 = $94cd11ffbd2c28e8$export$4b3e715f166fdd78;



var $ek92w = parcelRequire("ek92w");
window.__VUE_OPTIONS_API__ = false;
window.__VUE_PROD_DEVTOOLS__ = true;
const $35da740d59af89ba$var$routes = [
    {
        path: '/',
        name: 'home',
        component: (0, $a4d3fbeb3c9ffe13$export$2e2bcd8739ae039),
        meta: {
            title: 'Home'
        },
        beforeEnter: (to, from, next)=>{
            if (!(0, $gYKPF.state).user) (0, $gYKPF.isAuthenticated)();
            next();
        }
    },
    {
        path: '/requests',
        name: 'requests',
        component: (0, $5f5a7066eafcf8fe$export$2e2bcd8739ae039),
        meta: {
            title: 'All Requests'
        },
        beforeEnter: (to, from, next)=>{
            if (!(0, $gYKPF.isAuthenticated)()) next({
                name: 'login'
            });
            else next();
        }
    },
    {
        path: '/login',
        name: 'login',
        component: (0, $714b0e6770779f0b$export$2e2bcd8739ae039),
        meta: {
            title: 'Login'
        }
    },
    {
        path: '/signup',
        name: 'signup',
        component: (0, $370128e570e5bf0d$export$2e2bcd8739ae039),
        meta: {
            title: 'Signup'
        }
    },
    {
        path: '/password-forgot',
        name: 'password-forgot',
        component: (0, $98f370b7fece08fd$export$2e2bcd8739ae039),
        meta: {
            title: 'Forgot Password'
        }
    },
    {
        path: '/password-reset',
        name: 'password-reset',
        component: (0, $674312e60c4423e2$export$2e2bcd8739ae039),
        meta: {
            title: 'Password Reset'
        }
    },
    {
        path: '/my-requests',
        name: 'my-requests',
        component: (0, $b604d8960cd69e8b$export$2e2bcd8739ae039),
        meta: {
            title: 'My Requests'
        },
        beforeEnter: (to, from, next)=>{
            if (!(0, $gYKPF.isAuthenticated)()) next({
                name: 'login'
            });
            else next();
        }
    },
    {
        path: '/released-requests',
        name: 'released-requests',
        component: (0, $60d0a9d22f5a5b37$export$2e2bcd8739ae039),
        meta: {
            title: 'Released Requests'
        },
        beforeEnter: (to, from, next)=>{
            if (!(0, $gYKPF.isAuthenticated)()) next({
                name: 'login'
            });
            else next();
        }
    },
    {
        path: '/admin',
        name: 'admin',
        component: (0, $3d7daeabfc708c6e$export$2e2bcd8739ae039),
        meta: {
            title: 'Admin'
        },
        beforeEnter: (to, from, next)=>{
            if (!(0, $gYKPF.isAuthenticated)()) return next({
                name: 'login'
            });
            if (!(0, $gYKPF.isAdmin).value) return next({
                name: 'home'
            });
            next();
        }
    },
    {
        path: '/subscription',
        name: 'subscription',
        component: (0, $744d304a2e748825$export$2e2bcd8739ae039),
        meta: {
            title: 'Subscription'
        }
    },
    {
        path: '/privacy-policy',
        name: 'privacy-policy',
        component: (0, $13d4fb7d90e2f157$export$2e2bcd8739ae039),
        meta: {
            title: 'Privacy Policy'
        }
    },
    {
        path: '/terms',
        name: 'terms',
        component: (0, $4dd294d5445beaa9$export$2e2bcd8739ae039),
        meta: {
            title: 'Terms and Conditions'
        }
    }
];
const $35da740d59af89ba$var$router = (0, $73mM4.createRouter)({
    // linkExactActiveClass: 'border-b-[1px] border-purple-900',
    history: (0, $73mM4.createWebHistory)(),
    routes: $35da740d59af89ba$var$routes
});
$35da740d59af89ba$var$router.beforeEach((to, from)=>{
    document.title = `${to.meta.title} | Scrapbook Concierge Requests App`;
});
const $35da740d59af89ba$var$app = (0, $eeJ70.createApp)((0, $9eeee3aab604adc6$export$2e2bcd8739ae039));
$35da740d59af89ba$var$app.use($35da740d59af89ba$var$router);
$35da740d59af89ba$var$app.use((0, $94cd11ffbd2c28e8$export$2e2bcd8739ae039), {
    appName: 'Scrapbook Concierge Requests App',
    pageTrackerScreenviewEnabled: true,
    config: {
        id: "G-2N7XV7V1N5"
    }
}, $35da740d59af89ba$var$router);
$35da740d59af89ba$var$app.use((0, $ek92w.VueReCaptcha), {
    siteKey: "6Le4YJwtAAAAAIIhqiugOUQ-IjAcioFq_tfyfmlR"
});
$35da740d59af89ba$var$app.mount('#app');


//# sourceMappingURL=project.3a4da2af.js.map
